import * as Lr from "react";
import g, { forwardRef as ge, useState as ie, memo as wr, useMemo as me, useCallback as te, useRef as Nt, useEffect as It, createRef as IS, createContext as qo, useContext as Pi, useLayoutEffect as _m, useDebugValue as Bm, useImperativeHandle as MS, createElement as At, isValidElement as RS, useReducer as OS } from "react";
import { rem as m, useProps as he, Accordion as ul, useMantineColorScheme as DS, Box as oe, Text as As, Avatar as Vm, Indicator as AS, Group as X, createPolymorphicComponent as lc, Badge as LS, Button as ra, Title as $S, getDefaultZIndex as Rn, Card as Ih, Stack as Ee, Input as vi, Checkbox as PS, Tooltip as Xs, CopyButton as _S, useMantineTheme as _i, UnstyledButton as Qs, Divider as Qu, extractStyleProps as el, Popover as Hn, Modal as ef, NavLink as BS, Flex as gr, ScrollArea as Fr, createTheme as VS, DirectionProvider as FS, MantineProvider as NS, Drawer as zS, Menu as Ls, Collapse as jd, SimpleGrid as Wd, Container as Fm, Grid as Nm, PinInput as HS, Switch as jS, NumberInput as WS, PasswordInput as GS, InputBase as zm, useCombobox as Hm, Combobox as kt, TextInput as jm, Anchor as US, List as Wm, HoverCard as Vc, AppShell as co, Center as qS, CloseButton as JS, PillsInput as KS, useDirection as YS, Stepper as tf, Radio as oa, createSafeContext as ZS, factory as Bi, TypographyStylesProvider as XS, useResolvedStylesApi as QS, ColorSwatch as Gd, ColorPicker as eC, ActionIcon as Ji, useStyles as tC, Paper as Gm, Tabs as ac, Textarea as nC, Progress as rC, createUseExternalEvents as oC } from "@mantine/core";
import { AppShell as Az, BackgroundImage as Lz, Box as $z, Burger as Pz, Center as _z, Collapse as Bz, Container as Vz, CopyButton as Fz, Flex as Nz, Group as zz, HoverCard as Hz, Image as jz, Input as Wz, Menu as Gz, Overlay as Uz, Paper as qz, Popover as Jz, ScrollArea as Kz, SimpleGrid as Yz, Space as Zz, Stack as Xz, Transition as Qz, UnstyledButton as eH, createSafeContext as tH, em as nH, getDefaultZIndex as rH, getSortedBreakpoints as oH, px as iH, rem as sH, rgba as lH, useMantineTheme as aH, useProps as cH } from "@mantine/core";
import { ChevronDown13 as Sr, LoaderCircle as iC, User0113 as sC, Loader13 as lC, LinkExternal0213 as aC, Minus13 as cC, Check13 as Um, CheckCircleBroken13 as qm, AlertTriangle13 as Jm, CheckCircle13 as dC, ArrowNarrowRight13 as uC, Copy0313 as fC, Crop0213 as hC, ArrowLeft13 as xi, ArrowRight13 as $s, HelpCircle12 as Nr, Close13 as nf, Calendar13 as pC, UploadCloud0213 as Mh, XCircle13 as Km, Star0113 as gC, XClose13 as cc, Image0113 as mC, Moon01 as yC, Sun as bC, AlertCircle13 as Ei, Eye13 as wC, EyeOff13 as SC, SearchMd13 as Ym, LogOut0113 as CC, ChevronLeftDouble13 as vC, Menu01 as xC, CloseCircle13 as EC, ChevronLeft13 as kC, DotsHorizontal0213 as Zm, Polygon1 as TC, Type0116 as IC, Code as MC, Heading0113 as RC, Bold as OC, Italic as DC, Underline as AC, Strikethrough01 as LC, ClearFormatting as $C, PencilLine as PC, AlignLeft01 as _C, AlignCenter01 as BC, AlignJustify01 as VC, AlignRight01 as FC, Blockquote as NC, Link0312 as zC, Divider as HC, List as jC, ListNumbers as WC, Table as GC, DotsVertical0112 as UC, Table13 as qC, FilterLinesDown13 as JC, FilterLinesUp13 as KC, File0413 as YC, FileQuestion0313 as ZC, FileQuestion0113 as XC, Trash0113 as QC, RefreshCw0513 as ev } from "@affstore-ds/icons";
import { createStyles as O, keyframes as tv, emotionTransform as nv, MantineEmotionProvider as rv, Global as ov, getStylesRef as Rh } from "@mantine/emotion";
import { createStyles as uH } from "@mantine/emotion";
import { getAvatarStatusImagePath as Fc, getContentImagePath as iv, getSocialImagePath as Kn, getIdentityImagePath as sv } from "@affstore-ds/images";
import { useDidUpdate as lv, upperFirst as oo, useMediaQuery as mr, useUncontrolled as an, useClickOutside as av, useId as Xm, useMergedRef as dc, useToggle as Qm, usePrevious as cv, useLocalStorage as ey, useDebouncedState as dv, usePagination as uv, useInputState as fv, useDisclosure as ty, useWindowEvent as hv, useElementSize as pv, randomId as mi } from "@mantine/hooks";
import { useIntersection as hH, useInterval as pH, useMediaQuery as gH } from "@mantine/hooks";
import { getFlagsPath as ny } from "@affstore-ds/flags";
import { Dropzone as fl } from "@mantine/dropzone";
import { isNumber as gv, formatMoney as mv } from "@affstore-ds/helpers";
import { Notifications as yv, notifications as Ud, hideNotification as bv, cleanNotificationsQueue as wv, cleanNotifications as Sv } from "@mantine/notifications";
import Cv from "react-dom";
import { createFormContext as yH, hasLength as bH, isEmail as wH, isInRange as SH, isNotEmpty as CH, joiResolver as vH, matches as xH, superstructResolver as EH, useForm as kH, yupResolver as TH, zodResolver as IH } from "@mantine/form";
import vv from "react-image-crop";
const Ot = (t, e) => {
  switch (t) {
    case "info":
      return e[3];
    case "success":
      return e[2];
    case "warning":
      return e[1];
    case "default":
      return e[0];
    case "filter":
      return e[4];
    default:
      return e[0];
  }
}, ry = O(() => ({
  centered: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  }
})), xv = "label", oy = "mantine-Accordion-control", iy = "mantine-Accordion-icon", Ev = "mantine-Accordion-panel", No = "mantine-Button-section", qd = (t) => `.${No}[data-position="${t}"]`, kv = "mantine-Checkbox-root", Jd = "mantine-Checkbox-input", Nl = "mantine-Checkbox-icon", sy = "mantine-Checkbox-description", ia = "mantine-Radio-root", ly = "mantine-Radio-root", ay = "mantine-Radio-description", cy = "mantine-RadioIndicator-indicator", dy = "mantine-Menu-dropdown", sa = "favouriteIcon", uy = "multiselectTextValue", fy = "selectTextValue", hy = "mantine-NavLink-root", py = "mantine-NavLink-section", gy = "mantine-NavLink-rightSection", my = "mantine-NavLink-label", Ps = "mantine-InputWrapper-required", yy = "mantine-Input-section", by = "mantine-ActionIcon-root", wy = "mantine-ActionIcon-icon", ys = "mantine-Select-section", Dr = "tableBodyTd", rf = "tableCellActionButton", Sy = "tableRowColor", Cy = "mantine-Tabs-tabLabel", zl = "mantine-Switch-track", of = "copyButton", X5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACCORDION_CONTROL: oy,
  ACCORDION_ICON: iy,
  ACCORDION_PANEL: Ev,
  BUTTON_SECTION: No,
  CHECKBOX_DESCRIPTION: sy,
  CHECKBOX_ICON: Nl,
  CHECKBOX_INPUT: Jd,
  CHECKBOX_ROOT: kv,
  COPY_BUTTON: of,
  DROPDOWN: dy,
  FAVOURITE_ICON: sa,
  INPUT_ACTION_ICON: wy,
  INPUT_ACTION_ICON_ROOT: by,
  INPUT_REQUIRED: Ps,
  INPUT_SECTION: yy,
  MULTISELECT_TEXT_VALUE: uy,
  NAVLINK_LABEL: my,
  NAVLINK_LEFT_SECTION: py,
  NAVLINK_RIGHT_ICON: gy,
  NAVLINK_ROOT: hy,
  RADIO_BUTTON_ROOT: ia,
  RADIO_DESCRIPTION: ay,
  RADIO_INDICATOR: cy,
  RADIO_ROOT: ly,
  SELECT_LABEL: xv,
  SELECT_RIGHT_SECTION: ys,
  SELECT_TEXT_VALUE: fy,
  TABLE_BODY_TD: Dr,
  TABLE_CELL_ACTION_BUTTON: rf,
  TABLE_ROW_COLOR: Sy,
  TAB_LABEL: Cy,
  TOGGLE_TRACK: zl,
  getButtonSectionSelector: qd
}, Symbol.toStringTag, { value: "Module" })), Tv = {
  2: m(2),
  4: m(4),
  8: m(8),
  12: m(12),
  16: m(16),
  20: m(20),
  40: m(40)
}, Iv = ["#000000"], Mv = [
  "#fafbff",
  "#f8f9ff",
  "#f4f5ff",
  "#eef0ff",
  "#e4e8ff",
  "#d9deff",
  "#c7d0ff",
  "#bcc6ff",
  "#aebbff",
  "#99abff",
  "#829afe",
  "#6386fe",
  "#4575fe",
  "#1466fe",
  "#0059e5",
  "#004cc7",
  "#0043b1",
  "#003796",
  "#002e81",
  "#00256b",
  "#001a52",
  "#000723"
], Rv = [
  "#fbfcfd",
  "#f8f8fc",
  "#f4f6fc",
  "#edf0fa",
  "#e5e8f8",
  "#d9def5",
  "#cbd1f0",
  "#c0c7ea",
  "#b6bde3",
  "#a6aed8",
  "#969ec8",
  "#848bb4",
  "#767da3",
  "#6a7094",
  "#5d6282",
  "#4f5571",
  "#464a64",
  "#3a3e55",
  "#313448",
  "#272a3a",
  "#1c1e2c",
  "#07090f"
], Ov = [
  "#f6ffeb",
  "#eeffd6",
  "#e6ffbe",
  "#d4ff7f",
  "#c4fd00",
  "#bcf200",
  "#b1e400",
  "#a8d900",
  "#a0cf00",
  "#93bf00",
  "#86ad00",
  "#769900",
  "#6a8a00",
  "#5f7c00",
  "#536d00",
  "#475e00",
  "#3e5300",
  "#344500",
  "#2b3a00",
  "#222f00",
  "#182200",
  "#060a00"
], Dv = [
  "#fbfcfb",
  "#f8f9f7",
  "#f5f6f3",
  "#eef1ec",
  "#e7eae2",
  "#dbe0d5",
  "#ced5c6",
  "#c4cbba",
  "#bac2af",
  "#aab39e",
  "#9aa38e",
  "#88907c",
  "#7a826f",
  "#6d7563",
  "#606656",
  "#52584a",
  "#484e41",
  "#3c4135",
  "#32372d",
  "#282c24",
  "#1d2019",
  "#080907"
], Av = [
  "#f8fdf9",
  "#f1fcf3",
  "#e2fbe8",
  "#d6fadf",
  "#bef7cd",
  "#9df1b6",
  "#7ae99f",
  "#61e18f",
  "#48d882",
  "#1fc96f",
  "#00b860",
  "#00a350",
  "#009246",
  "#00843d",
  "#007434",
  "#00642b",
  "#005825",
  "#004a1d",
  "#003e18",
  "#003212",
  "#00250b",
  "#000c02"
], Lv = [
  "#fbfbfb",
  "#f9f9f9",
  "#f6f6f6",
  "#f0f0f0",
  "#eae9e9",
  "#e0dfdf",
  "#d4d2d3",
  "#cbc8cb",
  "#c1bec2",
  "#b1afb4",
  "#a19fa7",
  "#8c8c96",
  "#7e7e89",
  "#71717d",
  "#64636f",
  "#58555e",
  "#4e4a51",
  "#413e43",
  "#373437",
  "#2d2a2c",
  "#201e1f",
  "#090909"
], $v = [
  "#fcfcfc",
  "#f9f9f9",
  "#f6f6f6",
  "#f0f0f0",
  "#e9e9e9",
  "#dfdfdf",
  "#d2d2d2",
  "#c8c8c8",
  "#bfbfbf",
  "#b0b0b0",
  "#a0a0a0",
  "#8d8d8d",
  "#7f7f7f",
  "#727272",
  "#646464",
  "#565656",
  "#4b4b4b",
  "#3f3f3f",
  "#353535",
  "#2a2a2a",
  "#1e1e1e",
  "#090909"
], Pv = [
  "#f9fcfe",
  "#f3fafd",
  "#edf8fc",
  "#e1f4fb",
  "#ceeef9",
  "#b9e6f6",
  "#9fdcf1",
  "#8ad3eb",
  "#79cae4",
  "#5fbcd8",
  "#4aacc9",
  "#3798b4",
  "#2c89a4",
  "#237b94",
  "#1b6d83",
  "#135e72",
  "#0e5264",
  "#094555",
  "#063a48",
  "#042f3b",
  "#02222c",
  "#010a0f"
], _v = [
  "#fefbf7",
  "#fff7f3",
  "#fff3ef",
  "#ffece8",
  "#ffe2df",
  "#ffd5d2",
  "#ffc5c3",
  "#ffb6b6",
  "#ffa7aa",
  "#ff8f96",
  "#ff7381",
  "#ff4864",
  "#f4254f",
  "#e11144",
  "#c90039",
  "#af002f",
  "#9c0027",
  "#84001f",
  "#710019",
  "#5d0013",
  "#47000b",
  "#1d0002"
], Bv = [
  "#fffcef",
  "#fffadb",
  "#fff8c5",
  "#fff29e",
  "#ffea7d",
  "#ffdd52",
  "#ffcd27",
  "#f6c100",
  "#ecb800",
  "#daa900",
  "#c89900",
  "#b18700",
  "#a07900",
  "#906d00",
  "#805f00",
  "#6e5200",
  "#614800",
  "#513c00",
  "#463200",
  "#392800",
  "#291d00",
  "#0f0800"
], Vv = ["#ffffff"], Fv = {
  s: `0 ${m(2)} ${m(16)} -${m(4)} rgba(45, 42, 44, 0.05), 0 ${m(4)} ${m(6)} -${m(2)} rgba(45, 42, 44, 0.03)`
}, Nv = {
  4: m(4),
  8: m(8),
  12: m(12),
  16: m(16),
  20: m(20),
  24: m(24),
  32: m(32),
  40: m(40),
  48: m(48),
  64: m(64),
  80: m(80),
  96: m(96),
  128: m(128),
  160: m(160),
  192: m(192),
  224: m(224),
  256: m(256)
}, zv = {
  desktop: {
    s: {
      xxxl: {
        header: '500 2.25rem/1.2222222222222223 "Inter", sans-serif'
        // 500 36px/44px "Inter", sans-serif,
      },
      xxl: {
        header: '500 1.75rem/1.2857142857142858 "Inter", sans-serif',
        // 500 28px/36px "Inter", sans-serif
        extraImportant: '600 1.75rem/1.2857142857142858 "Inter", sans-serif',
        // 600 28px/36px "Inter", sans-serif
        default: '400 1.75rem/1.2857142857142858 "Inter", sans-serif'
        // 400 28px/36px "Inter", sans-serif
      },
      xl: {
        header: '500 1.5rem/1.3333333333333333 "Inter", sans-serif',
        // 500 24px/32px "Inter", sans-serif
        extraImportant: '600 1.5rem/1.3333333333333333 "Inter", sans-serif',
        // 600 24px/32px "Inter", sans-serif
        important: '500 1.5rem/1.3333333333333333 "Inter", sans-serif',
        // 500 24px/32px "Inter", sans-serif
        default: '400 1.5rem/1.3333333333333333 "Inter", sans-serif'
        // 400 24px/32px "Inter", sans-serif
      },
      l: {
        header: '500 1.125rem/1.5555555555555556 "Inter", sans-serif',
        // 500 18px/28px "Inter", sans-serif
        extraImportant: '600 1.125rem/1.5555555555555556 "Inter", sans-serif',
        // 600 18px/28px "Inter", sans-serif
        default: '400 1.125rem/1.5555555555555556 "Inter", sans-serif'
        // 400 18px/28px "Inter", sans-serif
      },
      m: {
        header: '500 1rem/1.5 "Inter", sans-serif',
        // 500 16px/24px "Inter", sans-serif
        important: '500 1rem/1.5 "Inter", sans-serif',
        // 500 16px/24px "Inter", sans-serif
        default: '400 1rem/1.5 "Inter", sans-serif'
        // 400 16px/24px "Inter", sans-serif
      },
      s: {
        extraImportant: '600 0.875rem/1.4285714285714286 "Inter", sans-serif',
        // 600 14px/20px "Inter", sans-serif
        // eslint-disable-next-line sonarjs/no-duplicate-string
        header: '500 0.875rem/1.4285714285714286 "Inter", sans-serif',
        // 500 14px/20px "Inter", sans-serif
        important: '500 0.875rem/1.4285714285714286 "Inter", sans-serif',
        // 500 14px/20px "Inter", sans-serif
        buttons: '500 0.875rem/1.4285714285714286 "Inter", sans-serif',
        // 500 14px/20px "Inter", sans-serif
        label: '500 0.875rem/1.4285714285714286 "Inter", sans-serif',
        // 500 14px/20px "Inter", sans-serif
        default: '400 0.875rem/1.4285714285714286 "Inter", sans-serif',
        // 400 14px/20px "Inter", sans-serif
        code: '400 0.875rem/1.4285714285714286 "Roboto Mono", monospace'
        // 400 14px/20px "Roboto Mono", monospace
      },
      xs: {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        header: '500 0.75rem/1.5 "Inter", sans-serif',
        // 500 12px/18px "Inter", sans-serif
        extraImportant: '600 0.75rem/1.5 "Inter", sans-serif',
        // 600 12px/18px "Inter", sans-serif
        important: '500 0.75rem/1.5 "Inter", sans-serif',
        // 500 12px/18px "Inter", sans-serif
        buttons: '500 0.75rem/1.5 "Inter", sans-serif',
        // 500 12px/18px "Inter", sans-serif
        default: '400 0.75rem/1.5 "Inter", sans-serif'
        // 400 12px/18px "Inter", sans-serif
      }
    }
  }
}, Hv = 12, jv = {
  width: "100vw",
  height: "100vh",
  scrollbarSize: Hv
}, hi = {
  fontFamily: '"Inter", system-ui, sans-serif',
  fontSmoothing: !1,
  breakpoints: {
    xs: "20em",
    sm: "45em",
    md: "62em",
    lg: "80em",
    xl: "100em"
  },
  other: {
    colorScheme: "light",
    colors: {
      black: Iv,
      white: Vv,
      blue: Mv,
      blueS40: Rv,
      brand: Ov,
      brandS40: Dv,
      froggy: Av,
      greyIron: Lv,
      greyTrue: $v,
      iceberg: Pv,
      raspberry: _v,
      sunflower: Bv
    },
    borderRadius: Tv,
    spacings: Nv,
    fonts: zv,
    viewport: jv,
    shadows: Fv
  }
}, Wv = (t) => `(max-device-width: ${t})`, Gv = (t, e = !0) => `${e ? "@media " : ""}(min-width: ${t})`, ni = (t, e = !0) => `${e ? "@media " : ""}(max-width: ${t})`, Uv = (t, e) => `@media (min-device-width: ${t}) and (max-device-width: ${e})`, qv = (t) => `@media (device-width: ${t})`, Jv = (t, e) => `@media (${t}-device-width: ${e})`;
let Kt = hi.breakpoints;
if (!hi.breakpoints)
  throw new Error("You need to pass theme breakpoints");
const Ge = {
  xl: ni(Kt == null ? void 0 : Kt.xl),
  lg: ni(Kt == null ? void 0 : Kt.lg),
  md: ni(Kt.md),
  sm: ni(Kt.sm),
  xs: ni(Kt.xs),
  lessThen: (t, e) => ni(Kt[t], e),
  greaterThen: (t, e) => Gv(Kt[t], e),
  between: (t, e) => Uv(Kt[t], Kt[e]),
  just: (t) => qv(Kt[t]),
  custom: (t, e) => Jv(t, e),
  maxDeviceWidthValue: (t) => Wv(Kt[t])
}, Q5 = (t) => {
  Kt = {
    ...Kt,
    ...t
  };
}, Kv = "0.3s", Yv = "ease-in-out", Ae = (t) => t.map((e) => `${e} ${Kv} ${Yv}`).join(", "), Zv = O(
  (t, { iconSize: e, iconMargin: n, chevronSize: r, type: o }) => {
    const l = Ot(o, [
      t.other.colors.greyIron[2],
      t.other.colors.raspberry[1],
      t.other.colors.froggy[1],
      t.other.colors.greyIron[1],
      t.other.colors.white[0]
    ]);
    return {
      root: {},
      item: {
        backgroundColor: l,
        padding: 0,
        border: Ot(o, ["none", `${m(1)} solid`, `${m(1)} solid`, `${m(1)} solid`, "none"]),
        borderRadius: Ot(o, [
          t.other.borderRadius[8],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          void 0
        ]),
        borderColor: Ot(o, [
          void 0,
          t.other.colors.greyIron[4],
          t.other.colors.greyIron[4],
          t.other.colors.greyIron[4],
          void 0
        ]),
        "&[data-active]": {
          [`.${oy}`]: {
            "&:hover, &:active": {
              borderColor: "transparent"
            },
            "&:focus-visible": {
              boxShadow: "none"
            }
          }
        },
        "& + &": {
          marginTop: t.other.spacings[12]
        }
      },
      control: {
        padding: `${t.other.spacings[16]} ${t.other.spacings[16]}`,
        [Ge.greaterThen("md")]: {
          padding: Ot(o, [
            m(20),
            `${m(12)} ${m(32)}`,
            `${m(12)} ${m(32)}`,
            `${m(12)} ${m(32)}`,
            m(16)
          ])
        },
        border: Ot(o, [`${m(1)} solid transparent`, "none", "none", "none", "none"]),
        borderRadius: Ot(o, [
          t.other.borderRadius[8],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          void 0
        ]),
        backgroundColor: "inherit",
        outline: "none",
        color: t.other.colors.greyIron[18],
        transition: Ae(["border-color", "box-shadow", "padding"]),
        '&[aria-expanded="true"]': {
          paddingBottom: Ot(o, [6, void 0, void 0, void 0, void 0])
        },
        "&:hover": {
          borderColor: Ot(o, [t.other.colors.greyIron[6], void 0, void 0, void 0, void 0]),
          backgroundColor: "inherit"
        },
        "&:active": {
          borderColor: t.other.colors.greyIron[8]
        },
        "&:disabled": {
          backgroundColor: Ot(o, [t.other.colors.greyIron[2], void 0, void 0, void 0, void 0]),
          borderColor: "transparent",
          opacity: 1,
          color: Ot(o, [t.other.colors.greyIron[9], void 0, void 0, void 0, void 0]),
          [`.${iy}`]: {
            color: Ot(o, [t.other.colors.greyIron[9], void 0, void 0, void 0, void 0])
          }
        },
        "&:focus-visible": {
          borderColor: "transparent",
          outline: "none",
          boxShadow: `0 0 0 ${m(4)} ${t.other.colors.brand[3]}`
        }
      },
      openedControl: {
        cursor: "default"
      },
      label: {
        font: t.other.fonts.desktop.s.s.header,
        padding: 0
      },
      chevron: {
        margin: 0
      },
      icon: {
        width: m(e),
        height: "auto",
        marginRight: m(n || 0),
        color: t.other.colors.greyIron[11]
      },
      panel: {
        backgroundColor: Ot(o, [
          void 0,
          t.other.colors.white[0],
          t.other.colors.white[0],
          t.other.colors.white[0],
          t.other.colors.white[0]
        ]),
        borderBottomLeftRadius: Ot(o, [
          t.other.borderRadius[8],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          m(0)
        ]),
        borderBottomRightRadius: Ot(o, [
          t.other.borderRadius[8],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          void 0
        ])
      },
      content: {
        padding: `${t.other.spacings[16]} ${t.other.spacings[16]}`,
        [Ge.greaterThen("md")]: {
          padding: 0,
          paddingTop: Ot(o, [
            void 0,
            t.other.spacings[24],
            t.other.spacings[24],
            t.other.spacings[24],
            void 0
          ]),
          paddingBottom: Ot(o, [
            t.other.spacings[20],
            t.other.spacings[32],
            t.other.spacings[32],
            t.other.spacings[32],
            t.other.spacings[16]
          ]),
          paddingLeft: m(Ot(o, [21, 32, 32, 32, 16])),
          paddingRight: m(Ot(o, [r || 0, 32, 32, 32, 16]))
        },
        borderBottomLeftRadius: Ot(o, [
          t.other.borderRadius[8],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          void 0
        ]),
        borderBottomRightRadius: Ot(o, [
          t.other.borderRadius[8],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          t.other.borderRadius[16],
          void 0
        ]),
        font: t.other.fonts.desktop.s.s.default,
        color: "theme.other.colors.greyIron[16]"
      }
    };
  }
), Xv = {
  chevronSize: 20,
  iconSize: 20,
  type: "default",
  withRightIcon: !0
}, Oh = 12, Qv = (t) => {
  const { items: e, value: n, chevronSize: r, iconSize: o, transitionDuration: i, withRightIcon: s, classNames: l, unstyled: a, type: c, ...d } = he(
    "Accordion",
    Xv,
    t
  ), { classes: u, cx: f } = Zv({ iconSize: o, iconMargin: Oh, chevronSize: r, type: c || "default" });
  return /* @__PURE__ */ g.createElement(
    ul,
    {
      classNames: {
        ...u,
        control: f(u.control, { [u.openedControl]: !s }, l == null ? void 0 : l.control),
        root: f(u.root, l == null ? void 0 : l.root),
        item: f(u.item, l == null ? void 0 : l.item),
        chevron: f(u.chevron, l == null ? void 0 : l.chevron),
        label: f(u.label, l == null ? void 0 : l.label),
        icon: f(u.icon, l == null ? void 0 : l.icon),
        panel: f(u.panel, l == null ? void 0 : l.panel),
        content: f(u.content, l == null ? void 0 : l.content)
      },
      unstyled: a,
      chevronSize: r,
      transitionDuration: i || 300,
      value: s ? n : "opened",
      ...d
    },
    e.map((h) => /* @__PURE__ */ g.createElement(ul.Item, { value: s ? h.value : "opened", key: h.value }, /* @__PURE__ */ g.createElement(
      ul.Control,
      {
        chevron: s ? h.chevron || /* @__PURE__ */ g.createElement(Sr, { width: r, height: r }) : /* @__PURE__ */ g.createElement(g.Fragment, null),
        icon: h.icon,
        disabled: h.disabled,
        "data-testid": h.dataTestId
      },
      h.controlContent
    ), /* @__PURE__ */ g.createElement(ul.Panel, { pl: h.icon && o ? o + Oh : 0 }, h.panelContent)))
  );
};
Qv.displayName = "Accordion";
var ci = /* @__PURE__ */ ((t) => (t.Vacation = "Vacation", t.BusinessTrip = "BusinessTrip", t.SickLeave = "SickLeave", t.Offline = "Offline", t.Online = "Online", t))(ci || {});
const Dh = (t) => (e) => {
  if (typeof e == "number")
    return m(e);
  const n = typeof t.defaultRadius == "number" ? t.defaultRadius : t.radius[t.defaultRadius] || t.defaultRadius;
  return t.radius[e] || e || n;
}, ex = O((t, { radius: e, colorScheme: n }) => ({
  root: {},
  imageWrapper: {
    position: "relative"
  },
  figure: {
    margin: 0
  },
  image: {
    display: "block",
    width: "100%",
    height: "100%",
    border: 0,
    borderRadius: Dh(t)(e)
  },
  caption: {
    color: n === "dark" ? t.colors.dark[2] : t.colors.gray[7],
    marginTop: t.spacing.xs
  },
  placeholder: {
    position: "absolute",
    top: m(0),
    right: m(0),
    left: m(0),
    bottom: m(0),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: n === "dark" ? t.colors.dark[2] : t.colors.gray[6],
    backgroundColor: n === "dark" ? t.colors.dark[8] : t.colors.gray[0],
    borderRadius: Dh(t)(e)
  }
})), tx = (t) => {
  const { width: e, height: n, style: r, ...o } = t;
  return /* @__PURE__ */ g.createElement("svg", { viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { width: e, height: n, ...r }, ...o }, /* @__PURE__ */ g.createElement(
    "path",
    {
      d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ));
}, vy = 0, nx = {
  fit: "cover",
  width: "100%",
  height: "auto",
  radius: vy,
  withPlaceholder: !0
}, Pt = ge((t, e) => {
  const { colorScheme: n } = DS(), {
    className: r,
    alt: o,
    src: i,
    fit: s,
    width: l,
    height: a,
    radius: c,
    imageProps: d,
    withPlaceholder: u,
    placeholder: f,
    imageRef: h,
    classNames: p,
    caption: y,
    style: b,
    ...w
  } = he("Image", nx, t), { classes: S, cx: x } = ex({ radius: c || vy, colorScheme: n }), [E, v] = ie(!i), T = u && E;
  return lv(() => {
    v(!i);
  }, [i]), /* @__PURE__ */ g.createElement(oe, { className: x(S.root, p == null ? void 0 : p.root, r), style: { width: m(l), ...b }, ref: e, ...w }, /* @__PURE__ */ g.createElement("figure", { className: x(S.figure, p == null ? void 0 : p.figure) }, /* @__PURE__ */ g.createElement("div", { className: x(S.imageWrapper, p == null ? void 0 : p.imageWrapper) }, /* @__PURE__ */ g.createElement(
    "img",
    {
      src: i,
      alt: o,
      ref: h,
      ...d,
      className: x(S.image, p == null ? void 0 : p.image, d == null ? void 0 : d.className),
      onError: (I) => {
        v(!0), typeof (d == null ? void 0 : d.onError) == "function" && d.onError(I);
      },
      style: {
        objectFit: s,
        width: m(l),
        height: m(a),
        ...T && { overflow: "hidden" },
        ...d == null ? void 0 : d.style
      }
    }
  ), T && /* @__PURE__ */ g.createElement("div", { className: x(S.placeholder, p == null ? void 0 : p.placeholder), title: o }, f || /* @__PURE__ */ g.createElement("div", null, /* @__PURE__ */ g.createElement(tx, { width: m(40), height: m(40) })))), !!y && /* @__PURE__ */ g.createElement(As, { component: "figcaption", size: "sm", ta: "center", className: x(S.caption, S == null ? void 0 : S.caption) }, y)));
});
Pt.displayName = "Image";
const rx = tv({
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(360deg)"
  }
}), ox = O((t) => ({
  root: {
    width: m(52),
    height: m(52)
  },
  loaderCircle: {
    borderRadius: "50%",
    width: "100%",
    height: "100%",
    animation: `${rx} .72s linear infinite`,
    color: t.other.colors.brand[5]
  }
})), sf = wr(({ className: t, classNames: e, ...n }) => {
  const { classes: r, cx: o } = ox();
  return /* @__PURE__ */ g.createElement(oe, { className: o(r.root, e == null ? void 0 : e.root, t), ...n }, /* @__PURE__ */ g.createElement(iC, { className: o(r.loaderCircle, e == null ? void 0 : e.loaderCircle) }));
});
sf.displayName = "Loader";
const ix = (t) => t == null ? void 0 : t.trim().split(" ").map((e) => e[0]).join("").toUpperCase(), sx = O((t, { loading: e }) => ({
  placeholder: {
    backgroundColor: e ? t.other.colors.white[0] : t.other.colors.greyIron[3],
    borderColor: e ? t.other.colors.greyIron[4] : "unset",
    borderWidth: e ? "1px" : "0"
  }
})), xy = ({ alt: t, children: e, loading: n, loaderProps: r, ...o }) => {
  const i = ix(t), { classes: s } = sx({ loading: n });
  return /* @__PURE__ */ g.createElement(Vm, { "data-testid": "avatar-basic", classNames: s, ...o }, n ? /* @__PURE__ */ g.createElement(sf, { ...r }) : /* @__PURE__ */ g.createElement(g.Fragment, null, e || i || /* @__PURE__ */ g.createElement(sC, { width: 20, height: 20 })));
};
xy.displayName = "AvatarBasic";
const yo = (t, e) => {
  const [n, r] = (e == null ? void 0 : e.split(".")) || [];
  return n !== void 0 && r !== void 0 ? t[n][r] : void 0;
}, lx = O((t, { colorVariant: e, size: n }) => ({
  indicator: {
    backgroundColor: yo(t.other.colors, e),
    width: typeof n == "number" ? m(n) : n,
    height: typeof n == "number" ? m(n) : n,
    svg: {
      width: "100%",
      height: "100%"
    }
  }
})), Ey = ({
  children: t,
  colorVariant: e = "greyIron.1",
  position: n = "bottom-end",
  className: r,
  size: o,
  ...i
}) => {
  const { classes: s, cx: l } = lx({ colorVariant: e, size: o });
  return /* @__PURE__ */ g.createElement(
    AS,
    {
      "data-testid": "indicator",
      size: typeof o == "number" ? m(o) : o,
      classNames: { indicator: l(s.indicator, r) },
      position: n,
      color: e,
      ...i
    },
    t
  );
};
Ey.displayName = "Indicator";
const ax = O(() => ({
  indicator: {
    padding: m(2)
  }
})), Kd = ({
  src: t,
  alt: e,
  indicatorSize: n = 10,
  indicatorRadius: r = 5,
  avatarSize: o = 40,
  avatarRadius: i = 20,
  colorVariant: s,
  indicatorLabel: l,
  indicatorDisabled: a,
  ...c
}) => {
  const { classes: d } = ax(), u = 2, f = n + u * 2, h = r + u;
  return /* @__PURE__ */ g.createElement(X, { "data-testid": "indicator-avatar" }, /* @__PURE__ */ g.createElement(
    Ey,
    {
      size: f,
      radius: h,
      colorVariant: s,
      label: l,
      position: "bottom-end",
      withBorder: !0,
      offset: n / 2,
      className: d.indicator,
      disabled: a
    },
    /* @__PURE__ */ g.createElement(xy, { src: t, alt: e, size: o, radius: i, ...c })
  ));
};
Kd.displayName = "IndicatorAvatar";
const Jo = ({ elementVariant: t, src: e, alt: n, ...r }) => {
  const o = {
    [ci.Online]: { colorVariant: "froggy.10" },
    [ci.Offline]: { colorVariant: "greyIron.7" },
    [ci.Vacation]: {
      indicatorSize: 16,
      indicatorRadius: 8,
      indicatorLabel: /* @__PURE__ */ g.createElement(Pt, { src: Fc("AvatarStatusVacation"), height: "100%" })
    },
    [ci.BusinessTrip]: {
      indicatorSize: 16,
      indicatorRadius: 8,
      indicatorLabel: /* @__PURE__ */ g.createElement(Pt, { src: Fc("AvatarStatusBusinessTrip"), height: "100%" })
    },
    [ci.SickLeave]: {
      indicatorSize: 16,
      indicatorRadius: 8,
      indicatorLabel: /* @__PURE__ */ g.createElement(Pt, { src: Fc("AvatarStatusSickLeave"), height: "100%" })
    }
  };
  return t ? /* @__PURE__ */ g.createElement(Kd, { src: e, alt: n, ...o[t], ...r }) : /* @__PURE__ */ g.createElement(Kd, { src: e, alt: n, indicatorDisabled: !0, ...r });
};
Jo.displayName = "Avatar";
const cx = (t, e) => {
  if (e === "outline")
    switch (t) {
      case "header":
        return ["brand.15", "brand.2"];
      case "brand":
        return ["brand.14", "brand.3"];
      case "success":
        return ["froggy.14", "froggy.3"];
      case "error":
        return ["raspberry.16", "raspberry.14"];
      case "warning":
        return ["sunflower.14", "sunflower.3"];
      case "secondary":
        return ["greyIron.20", "greyIron.1"];
      default:
        return ["greyIron.14", "greyIron.4"];
    }
  switch (t) {
    case "header":
      return ["brand.15", "brand.2"];
    case "brand":
      return ["brand.14", "brand.3"];
    case "success":
      return ["froggy.14", "froggy.3"];
    case "error":
      return ["raspberry.14", "raspberry.3"];
    case "warning":
      return ["sunflower.14", "sunflower.3"];
    case "secondary":
      return ["greyIron.20", "greyIron.1"];
    default:
      return ["greyIron.14", "greyIron.3"];
  }
}, Wr = (t, e) => {
  switch (t) {
    case "s":
      return e[3];
    case "m":
      return e[2];
    case "l":
      return e[1];
    case "xl":
      return e[0];
    default:
      return e[0];
  }
}, dx = O((t, { elementSize: e, elementVariant: n, elementStyle: r, rounded: o }) => {
  const [i, s] = cx(n, r), l = yo(t.other.colors, i), a = yo(t.other.colors, s);
  return {
    root: {
      borderRadius: o ? t.other.borderRadius[20] : t.other.borderRadius[8],
      padding: `${Wr(e, [m(10), m(6), m(4), m(3)])} ${Wr(e, [
        m(12),
        m(10),
        m(10),
        m(8)
      ])}`,
      minWidth: m(24),
      minHeight: m(Wr(e, [40, 32, 28, 24])),
      color: l,
      border: r === "outline" ? `${m(1)} solid ${a}` : "none",
      backgroundColor: r === "fill" ? a : "transparent"
    },
    section: {
      '&[data-position="left"]': {
        width: m(Wr(e, [20, 20, 18, 16])),
        height: m(Wr(e, [20, 20, 18, 16])),
        marginRight: "2px"
      },
      '&[data-position="right"]': {
        width: m(Wr(e, [20, 20, 18, 16])),
        height: m(Wr(e, [20, 20, 18, 16]))
      }
    },
    rightSectionWithoutChildren: {
      '&[data-position="right"]': {
        marginLeft: 0
      }
    },
    label: {
      font: Wr(e, [
        t.other.fonts.desktop.s.s.important,
        t.other.fonts.desktop.s.s.important,
        t.other.fonts.desktop.s.s.important,
        t.other.fonts.desktop.s.xs.important
      ]),
      color: l,
      textTransform: "none",
      letterSpacing: "unset",
      display: "flex",
      alignItems: "center"
    },
    dot: {
      backgroundColor: l,
      width: m(6),
      height: m(6),
      borderRadius: "50%"
    },
    dotMr: {
      marginRight: m(6)
    }
  };
}), ux = {
  rounded: !1,
  elementVariant: "default",
  elementSize: "s",
  elementStyle: "fill"
}, ky = ge((t, e) => {
  const { elementSize: n, elementVariant: r, elementStyle: o, rounded: i, classNames: s, children: l, withDot: a, ...c } = he(
    "BadgeLocal",
    ux,
    t
  ), { classes: d, cx: u } = dx({ elementSize: n, elementVariant: r, elementStyle: o, rounded: i });
  return /* @__PURE__ */ g.createElement(
    LS,
    {
      ref: e,
      classNames: {
        root: u(d.root, s == null ? void 0 : s.root),
        section: u(d.section, s == null ? void 0 : s.section, { [d.rightSectionWithoutChildren]: !l }),
        label: u(d.label, s == null ? void 0 : s.label)
      },
      ...c
    },
    a && /* @__PURE__ */ g.createElement("div", { className: u(d.dot, s == null ? void 0 : s.dot, { [d.dotMr]: !!l, [(s == null ? void 0 : s.dotMr) || ""]: !!l }) }),
    l
  );
});
ky.displayName = "BadgeLocal";
const Ty = lc(ky);
Ty.displayName = "Badge";
var Ue = /* @__PURE__ */ ((t) => (t.XS = "XS", t.S = "S", t.M = "M", t))(Ue || {}), Q = /* @__PURE__ */ ((t) => (t.PrimaryMain = "PrimaryMain", t.SecondaryMain = "SecondaryMain", t.TertiaryMain = "TertiaryMain", t.PrimaryMainLine = "PrimaryMainLine", t.SecondaryMainLine = "SecondaryMainLine", t))(Q || {});
const uc = (t, e) => {
  switch (t) {
    case Ue.M:
      return e[0];
    case Ue.S:
      return e[1];
    case Ue.XS:
      return e[2];
    default:
      return e[0];
  }
}, Iy = O(
  (t, {
    elementSize: e,
    iconSize: n,
    isIconOnly: r,
    isRound: o,
    isLoading: i,
    loaderColor: s
  }) => {
    const l = yo(t.other.colors, s) || t.other.colors.brand[20], a = r ? m(9) : `${m(9)} ${m(17)}`, c = r ? m(7) : `${m(7)} ${m(13)}`, d = r ? m(7) : `${m(7)} ${m(13)}`;
    return {
      root: {
        overflow: "visible",
        height: "auto",
        padding: uc(e, [a, c, d]),
        borderRadius: o ? t.other.borderRadius[40] : t.other.borderRadius[8],
        font: t.other.fonts.desktop.s.s.buttons,
        color: t.other.colors.brand[20],
        backgroundColor: "transparent",
        transition: Ae(["background-color", "outline-color", "color", "transform"]),
        outline: `${m(4)} solid transparent !important`,
        outlineOffset: "0 !important",
        "span, div": {
          color: i ? "transparent !important" : ""
        },
        "&[data-loading]::before": {
          content: "none"
        }
      },
      inner: {},
      label: {},
      section: {
        svg: {
          width: typeof n == "number" ? m(n) : n,
          height: typeof n == "number" ? m(n) : n,
          stroke: i ? "transparent" : "currentcolor",
          path: {
            transition: Ae(["stroke"])
          }
        },
        "&[data-position='left']": {
          visibility: i && r ? "hidden" : void 0,
          marginRight: m(r ? 0 : 8),
          marginLeft: m(r ? 0 : -2),
          width: typeof n == "number" ? m(n) : n,
          height: typeof n == "number" ? m(n) : n
        },
        "&[data-position='right']": {
          visibility: i && r ? "hidden" : void 0,
          marginLeft: m(r ? 0 : 8),
          marginRight: m(r ? 0 : -2),
          width: typeof n == "number" ? m(n) : n,
          height: typeof n == "number" ? m(n) : n
        }
      },
      loader: {
        position: "absolute",
        top: "50%",
        left: 0,
        transform: "translate(0, -50%)",
        stroke: `${l} !important`,
        path: {
          stroke: `${l} !important`
        }
      }
    };
  }
), Ah = {
  elementSize: Ue.M,
  component: "button",
  isRound: !1,
  isIconOnly: !1,
  isLoading: !1,
  isLoaderCentered: !0
}, Vi = ge((t, e) => {
  const { component: n, href: r, elementSize: o, isRound: i, isLoading: s, isIconOnly: l, children: a, className: c, loaderColor: d, isLoaderCentered: u, classNames: f, ...h } = he("ButtonBasic", Ah, t), p = uc(o || Ah.elementSize, l ? [20, 20, 16] : [20, 18, 16]), { classes: y } = ry(), { classes: b, cx: w } = Iy({ elementSize: o, iconSize: p, isIconOnly: l, isRound: i, isLoading: s, loaderColor: d });
  return /* @__PURE__ */ g.createElement(
    ra,
    {
      component: n,
      className: w(b.root, f == null ? void 0 : f.root, c),
      classNames: {
        root: w(b.root, f == null ? void 0 : f.root),
        inner: w(b.inner, f == null ? void 0 : f.inner),
        loader: w(b.loader, f == null ? void 0 : f.loader),
        label: w(b.label, f == null ? void 0 : f.label),
        section: w(b.section, f == null ? void 0 : f.section)
      },
      href: n === "a" ? r : void 0,
      ...h,
      ref: e
    },
    l ? null : a,
    s && /* @__PURE__ */ g.createElement(
      lC,
      {
        width: p,
        height: p,
        className: w(b.section, b.loader, { [y.centered]: u })
      }
    )
  );
});
Vi.displayName = "ButtonBasic";
const fx = O((t) => {
  const e = {
    color: t.other.colors.brand[9],
    backgroundColor: t.other.colors.brand[2],
    svg: {
      color: t.other.colors.brand[9]
    }
  };
  return {
    primaryMain: {
      position: "relative",
      backgroundColor: t.other.colors.brand[5],
      color: t.other.colors.brand[20],
      "&:hover": {
        backgroundColor: t.other.colors.brand[7],
        color: t.other.colors.brand[20]
      },
      "&:focus-visible": {
        outlineColor: `${t.other.colors.brand[3]} !important`
      },
      "&:active": {
        backgroundColor: t.other.colors.brand[8]
      },
      svg: {
        color: t.other.colors.brand[18]
      },
      // This selector is needed to override default mantine styles
      // https://github.com/mantinedev/mantine/blob/6.0.21/src/mantine-core/src/Button/Button.styles.ts
      '&:not([data-loading="true"]):disabled': e,
      "&[data-disabled]": e
    },
    isDisabled: e
  };
}), My = ge(
  ({ children: t = Ue.M, isLoading: e = !1, disabled: n = !1, className: r, ...o }, i) => {
    const { classes: s, cx: l } = fx();
    return /* @__PURE__ */ g.createElement(
      Vi,
      {
        ref: i,
        className: l(s.primaryMain, { [s.isDisabled]: n }, r),
        disabled: n || e,
        isLoading: e,
        loaderColor: "brand.9",
        ...o
      },
      t
    );
  }
);
My.displayName = "ButtonPrimaryMain";
const hx = O(
  (t, { isIconOnly: e, elementSize: n }) => {
    const r = {
      backgroundColor: "transparent",
      color: `${t.other.colors.brandS40[9]}`
    };
    return {
      primaryMainLine: {
        padding: 0,
        backgroundColor: "transparent",
        color: t.other.colors.brand[13],
        font: uc(n, [
          t.other.fonts.desktop.s.s.buttons,
          t.other.fonts.desktop.s.xs.buttons,
          t.other.fonts.desktop.s.xs.buttons
        ]),
        "&:hover": {
          backgroundColor: "transparent",
          color: t.other.colors.brand[16]
        },
        "&:focus-visible": {
          outlineColor: `${t.other.colors.brand[3]} !important`
        },
        "&:active": {
          backgroundColor: "transparent",
          color: t.other.colors.brand[20]
        },
        // This selector is needed to override default mantine styles
        // https://github.com/mantinedev/mantine/blob/6.0.21/src/mantine-core/src/Button/Button.styles.ts
        '&:not([data-loading="true"]):disabled': r,
        "&[data-disabled]": r,
        "&:visited": {
          color: t.other.colors.brand[15]
        },
        [`& .${No}[data-position="left"]`]: {
          marginRight: e ? 0 : t.other.spacings[8],
          marginLeft: 0
        },
        [`& .${No}[data-position="right"]`]: {
          marginLeft: e ? 0 : t.other.spacings[8],
          marginRight: 0
        }
      },
      isDisabled: r
    };
  }
), Ry = ge(
  ({
    children: t,
    component: e = "button",
    isLoading: n = !1,
    disabled: r = !1,
    isIconOnly: o = !1,
    className: i,
    elementSize: s = Ue.M,
    ...l
  }, a) => {
    const { classes: c, cx: d } = hx({ isIconOnly: o, elementSize: s });
    return /* @__PURE__ */ g.createElement(
      Vi,
      {
        ref: a,
        className: d(c.primaryMainLine, { [c.isDisabled]: r }, i),
        component: e,
        disabled: r || n,
        isLoading: n,
        isLoaderCentered: !1,
        loaderColor: "brandS40.9",
        isIconOnly: o,
        elementSize: s,
        ...l
      },
      t
    );
  }
);
Ry.displayName = "ButtonPrimaryMainLine";
const px = O((t) => {
  const e = {
    color: t.other.colors.greyIron[9],
    backgroundColor: t.other.colors.greyIron[2],
    svg: {
      color: t.other.colors.greyIron[9]
    }
  };
  return {
    secondaryMain: {
      backgroundColor: t.other.colors.greyIron[3],
      color: t.other.colors.greyIron[18],
      "&:hover": {
        backgroundColor: t.other.colors.greyIron[5],
        color: t.other.colors.greyIron[18]
      },
      "&:focus-visible": {
        outlineColor: `${t.other.colors.greyIron[4]} !important`
      },
      "&:active": {
        backgroundColor: t.other.colors.greyIron[6]
      },
      svg: {
        color: t.other.colors.greyIron[13]
      },
      // This selector is needed to override default mantine styles
      // https://github.com/mantinedev/mantine/blob/6.0.21/src/mantine-core/src/Button/Button.styles.ts
      '&:not([data-loading="true"]):disabled': e,
      "&[data-disabled]": e
    },
    isDisabled: e
  };
}), Oy = ge(
  ({ children: t, component: e = "button", isLoading: n = !1, disabled: r = !1, className: o, ...i }, s) => {
    const { classes: l, cx: a } = px();
    return /* @__PURE__ */ g.createElement(
      Vi,
      {
        ref: s,
        className: a(l.secondaryMain, { [l.isDisabled]: r }, o),
        component: e,
        disabled: r || n,
        isLoading: n,
        loaderColor: "greyIron.9",
        ...i
      },
      t
    );
  }
);
Oy.displayName = "ButtonSecondaryMain";
const gx = O(
  (t, { isIconOnly: e, elementSize: n }) => {
    const r = {
      backgroundColor: "transparent",
      color: `${t.other.colors.greyIron[9]}`
    };
    return {
      secondaryMainLine: {
        padding: 0,
        backgroundColor: "transparent",
        color: t.other.colors.greyIron[13],
        font: uc(n, [
          t.other.fonts.desktop.s.s.buttons,
          t.other.fonts.desktop.s.xs.buttons,
          t.other.fonts.desktop.s.xs.buttons
        ]),
        "&:hover": {
          backgroundColor: "transparent",
          color: t.other.colors.greyIron[16]
        },
        "&:focus-visible": {
          outlineColor: `${t.other.colors.greyIron[4]} !important`
        },
        "&:active": {
          backgroundColor: "transparent",
          color: t.other.colors.greyIron[19]
        },
        // This selector is needed to override default mantine styles
        // https://github.com/mantinedev/mantine/blob/6.0.21/src/mantine-core/src/Button/Button.styles.ts
        '&:not([data-loading="true"]):disabled': r,
        "&[data-disabled]": r,
        "&:visited": {
          color: t.other.colors.greyIron[15]
        },
        [`& ${qd("left")}`]: {
          marginRight: e ? 0 : t.other.spacings[8],
          marginLeft: 0
        },
        [`& ${qd("right")}`]: {
          marginLeft: e ? 0 : t.other.spacings[8],
          marginRight: 0
        }
      },
      isDisabled: r
    };
  }
), Dy = ge(
  ({
    children: t,
    component: e = "button",
    isLoading: n = !1,
    disabled: r = !1,
    isIconOnly: o = !1,
    className: i,
    elementSize: s = Ue.M,
    ...l
  }, a) => {
    const { classes: c, cx: d } = gx({ isIconOnly: o, elementSize: s });
    return /* @__PURE__ */ g.createElement(
      Vi,
      {
        ref: a,
        className: d(c.secondaryMainLine, { [c.isDisabled]: r }, i),
        component: e,
        disabled: r || n,
        isLoading: n,
        isLoaderCentered: !1,
        loaderColor: "greyIron.9",
        elementSize: s,
        isIconOnly: o,
        ...l
      },
      t
    );
  }
);
Dy.displayName = "ButtonSecondaryMainLine";
const Ay = O((t) => {
  const e = {
    backgroundColor: "transparent",
    color: t.other.colors.greyIron[9],
    borderColor: "transparent",
    svg: {
      color: t.other.colors.greyIron[9]
    }
  };
  return {
    tertiaryMain: {
      backgroundColor: t.other.colors.white[0],
      border: `${m(1)} solid ${t.other.colors.greyIron[4]}`,
      color: t.other.colors.greyIron[18],
      svg: {
        color: t.other.colors.brand[13]
      },
      "&:hover": {
        backgroundColor: t.other.colors.greyIron[2],
        borderColor: t.other.colors.greyIron[2],
        color: t.other.colors.greyIron[18]
      },
      "&:focus-visible": {
        outlineColor: `${t.other.colors.greyIron[4]} !important`
      },
      "&:active": {
        backgroundColor: t.other.colors.greyIron[3],
        borderColor: t.other.colors.greyIron[3]
      },
      // This selector is needed to override default mantine styles
      // https://github.com/mantinedev/mantine/blob/6.0.21/src/mantine-core/src/Button/Button.styles.ts
      '&:not([data-loading="true"]):disabled': e,
      "&[data-disabled]": e
    },
    isDisabled: e
  };
}), Ly = ge(
  ({ children: t, component: e = "button", isLoading: n = !1, disabled: r = !1, className: o, ...i }, s) => {
    const { classes: l, cx: a } = Ay();
    return /* @__PURE__ */ g.createElement(
      Vi,
      {
        ref: s,
        className: a(l.tertiaryMain, { [l.isDisabled]: r }, o),
        component: e,
        disabled: r || n,
        isLoading: n,
        loaderColor: "greyIron.9",
        ...i
      },
      t
    );
  }
);
Ly.displayName = "ButtonTertiaryMain";
const ye = ge(
  ({ children: t, elementVariant: e = Q.PrimaryMain, ...n }, r) => ((i) => {
    switch (i) {
      case Q.PrimaryMain:
        return /* @__PURE__ */ g.createElement(My, { ref: r, ...n }, t);
      case Q.SecondaryMain:
        return /* @__PURE__ */ g.createElement(Oy, { ref: r, ...n }, t);
      case Q.TertiaryMain:
        return /* @__PURE__ */ g.createElement(Ly, { ref: r, ...n }, t);
      case Q.PrimaryMainLine:
        return /* @__PURE__ */ g.createElement(Ry, { ref: r, ...n }, t);
      case Q.SecondaryMainLine:
        return /* @__PURE__ */ g.createElement(Dy, { ref: r, ...n }, t);
      default:
        return null;
    }
  })(e)
);
ye.displayName = "Button";
const mx = O(() => ({
  main: {
    transform: "none !important"
  },
  isDisabled: {
    cursor: "not-allowed"
  }
})), ki = ge(
  ({ children: t, elementVariant: e = Q.PrimaryMainLine, disabled: n = !1, className: r, onClick: o, type: i, ...s }, l) => {
    const { classes: a, cx: c } = mx();
    return /* @__PURE__ */ g.createElement(
      ye,
      {
        ref: l,
        component: "a",
        elementVariant: e,
        className: c(a.main, { [a.isDisabled]: n }, r),
        disabled: n,
        onClick: n ? (d) => {
          d.preventDefault();
        } : o,
        type: i,
        ...s
      },
      t
    );
  }
);
ki.displayName = "Link";
const yx = O((t, { colorVariant: e, elementSize: n, elementVariant: r }) => {
  const o = yo(t.other.colors, e), i = t.other.fonts.desktop.s.xxxl, s = t.other.fonts.desktop.s.xxl, l = t.other.fonts.desktop.s.xl, a = t.other.fonts.desktop.s.l, c = t.other.fonts.desktop.s.m, d = t.other.fonts.desktop.s.s, u = t.other.fonts.desktop.s.xs;
  return {
    base: {
      wordWrap: "break-word",
      wordBreak: "break-word"
    },
    xxxl: {
      font: i[n === "xxxl" ? r : "header"],
      letterSpacing: "-0.01em"
    },
    xxl: {
      font: s[n === "xxl" ? r : "header"],
      letterSpacing: "-0.01em"
    },
    xl: {
      font: l[n === "xl" ? r : "default"]
    },
    l: {
      font: a[n === "l" ? r : "default"]
    },
    m: {
      font: c[n === "m" ? r : "default"]
    },
    s: {
      font: d[n === "s" ? r : "default"]
    },
    xs: {
      font: u[n === "xs" ? r : "default"]
    },
    textColor: {
      color: o
    },
    heavy: {
      fontWeight: 600
    }
  };
}), hl = {
  elementSize: "xl",
  elementVariant: "default",
  colorVariant: "greyIron.16"
}, $y = ge((t, e) => {
  const {
    children: n,
    className: r,
    heavy: o,
    inherit: i,
    span: s,
    elementVariant: l,
    elementSize: a,
    colorVariant: c,
    ...d
  } = he("Text", hl, t), { classes: u, cx: f } = yx({
    elementSize: a ?? hl.elementSize,
    elementVariant: l ?? hl.elementVariant,
    colorVariant: c ?? hl.colorVariant
  }), h = me(
    () => f({ [u.base]: !i }, a ? { [u[a]]: !i } : void 0, u.textColor, { [u.heavy]: o }),
    [u, f, a, o, i]
  );
  return /* @__PURE__ */ g.createElement(As, { className: f(h, r), component: s ? "span" : "div", inherit: i, ...d, ref: e }, n);
});
$y.displayName = "TextLocal";
const xe = lc($y);
xe.displayName = "Text";
const bx = O((t, { colorVariant: e }) => {
  const n = yo(t.other.colors, e);
  return {
    base: {
      wordWrap: "break-word",
      wordBreak: "break-word"
    },
    xxxl: {
      font: t.other.fonts.desktop.s.xxxl.header,
      letterSpacing: "-0.01em"
    },
    xxl: {
      font: t.other.fonts.desktop.s.xxl.header,
      letterSpacing: "-0.01em"
    },
    xl: {
      font: t.other.fonts.desktop.s.xl.header
    },
    l: {
      font: t.other.fonts.desktop.s.l.header
    },
    m: {
      font: t.other.fonts.desktop.s.m.header
    },
    s: {
      font: t.other.fonts.desktop.s.s.header
    },
    xs: {
      font: t.other.fonts.desktop.s.xs.header
    },
    textColor: {
      color: n
    },
    heavy: {
      fontWeight: 600
    }
  };
}), Ti = ({
  children: t,
  className: e,
  elementSize: n = "xxl",
  colorVariant: r = "greyIron.18",
  order: o,
  heavy: i,
  ...s
}) => {
  const { classes: l, cx: a } = bx({ colorVariant: r }), c = me(() => l[n || "xxxl"], [l, n]);
  return /* @__PURE__ */ g.createElement($S, { order: o, className: a(l.base, c, l.textColor, { [l.heavy]: i }, e), ...s }, t);
};
var Hl = /* @__PURE__ */ ((t) => (t.S = "S", t.M = "M", t.L = "L", t))(Hl || {});
const Nc = (t, e) => {
  switch (t) {
    case Hl.S:
      return e[0];
    case Hl.M:
      return e[1];
    case Hl.L:
      return e[2];
    default:
      return e[0];
  }
}, wx = O(
  (t, {
    isCardClickable: e,
    backgroundImageUrl: n,
    elementSize: r,
    imageFullWidth: o,
    enableDynamicHeight: i,
    withFluidContentHeight: s
  }) => {
    const l = i ? void 0 : m(Nc(r, [428, 350, 761])), a = Nc(r, [163, 190, 592]);
    return {
      root: {
        display: "flex",
        flexDirection: "column",
        width: m(Nc(r, [304, 468, 304])),
        minHeight: l,
        backgroundColor: t.other.colors.white[0],
        border: `${m(1)} solid`,
        borderColor: t.other.colors.greyIron[4],
        borderRadius: t.other.borderRadius[8],
        cursor: e ? "pointer" : "default",
        transition: e ? Ae(["border-color", "box-shadow"]) : "",
        "&:hover": {
          borderColor: e ? t.other.colors.brand[8] : ""
        },
        "&:focus-visible": {
          borderColor: e ? t.other.colors.brand[8] : ""
        }
      },
      rootFocusVisible: {
        borderColor: "transparent",
        boxShadow: `0 0 0 ${m(4)} ${t.other.colors.brand[3]}`,
        "&:hover": {
          borderColor: "transparent"
        }
      },
      imageSection: {
        flexGrow: s ? 0 : 1,
        padding: o ? 0 : t.other.spacings[8],
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        borderBottom: `${m(1)} solid`,
        borderColor: t.other.colors.greyIron[4]
      },
      imageContainer: {
        width: "100%",
        height: o ? "100%" : m(a),
        minHeight: m(o ? i ? a : a + 16 : 0),
        flexGrow: o ? 1 : 0,
        overflow: "hidden",
        // hide the blurred image halo
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        borderRadius: o ? "" : t.other.borderRadius[8],
        backgroundColor: n ? "" : t.other.colors.black[0]
        // backgroundColor for container with video
      },
      imageBlurredBackground: {
        height: "100%",
        backgroundImage: n ? `url('${n}')` : "none",
        backgroundSize: "cover",
        filter: `blur(${m(12)})`,
        opacity: 0.5
      },
      imageHeight: {
        height: "100%"
      },
      imageGreyScale: {
        filter: "grayscale(100%)"
      },
      logoSection: {
        position: "absolute",
        top: -2,
        left: -2,
        zIndex: Rn("app"),
        padding: t.other.spacings[8],
        borderBottomRightRadius: t.other.borderRadius[8],
        backgroundColor: t.other.colors.white[0],
        border: `${m(1)} solid ${t.other.colors.greyIron[4]}`,
        "& > div:not(:first-of-type)": {
          marginLeft: m(-4)
        }
      },
      logoIcon: {
        border: `${m(1)} solid ${t.other.colors.white[0]}`,
        backgroundColor: t.other.colors.white[0],
        borderRadius: "50%"
      }
    };
  }
), Lh = {
  elementSize: "S",
  enableDynamicHeight: !1,
  generateLinkButtonProps: {
    elementVariant: Q.SecondaryMain,
    elementSize: Ue.M,
    style: { flex: 1 },
    "data-testid": "card-button-generate-link"
  }
}, Sx = wr(({ onCardClick: t, ...e }) => {
  const {
    imageUrl: n,
    imageFullWidth: r,
    imageGreyScale: o,
    imageAlt: i,
    videoUrl: s,
    videoTitle: l,
    title: a,
    description: c,
    extraContent: d,
    externalLink: u,
    onExternalLinkClick: f,
    externalLinkIcon: h,
    badges: p,
    elementSize: y,
    generateLinkText: b,
    classNames: w,
    enableDynamicHeight: S,
    withFluidContentHeight: x,
    generateLinkButtonProps: E,
    customButtons: v,
    logoSectionList: T,
    className: I,
    ...M
  } = he("Card", Lh, e), R = typeof t == "function", { classes: A, cx: F } = wx({
    isCardClickable: R,
    backgroundImageUrl: n,
    elementSize: y,
    imageFullWidth: r,
    enableDynamicHeight: S,
    withFluidContentHeight: x
  }), { classes: V } = ry(), [P, J] = ie(!1), ne = (U) => {
    if (R && !P) {
      const re = U.target;
      !re.closest("button") && !re.closest("a") && re.getAttribute("role") !== "presentation" && J(!0);
    }
  }, G = (U) => {
    if (R && P) {
      const re = U.target;
      !re.closest("button") && !re.closest("a") && re.getAttribute("role") !== "presentation" && J(!1);
    }
  }, H = (U) => {
    const re = U.target;
    !re.closest("button") && !re.closest("a") && re.getAttribute("role") !== "presentation" && (J(!1), t == null || t(U));
  }, W = (U) => {
    if (U.key === "Enter") {
      const re = U.target;
      !re.closest("button") && !re.closest("a") && re.getAttribute("role") !== "presentation" && (t == null || t(U));
    }
  }, se = (U) => {
    U.stopPropagation(), f == null || f(U);
  };
  return /* @__PURE__ */ g.createElement(
    Ih,
    {
      className: F(A.root, w == null ? void 0 : w.root, { [A.rootFocusVisible]: P }, I),
      tabIndex: R ? 0 : -1,
      "data-testid": "card-clickable",
      onFocus: ne,
      onBlur: G,
      onClick: H,
      onKeyDown: W,
      ...M
    },
    (n || s) && /* @__PURE__ */ g.createElement(Ih.Section, { className: A.imageSection }, /* @__PURE__ */ g.createElement("div", { className: F(A.imageContainer, w == null ? void 0 : w.imageContainer) }, T && /* @__PURE__ */ g.createElement(X, { gap: 0, className: F(A.logoSection, w == null ? void 0 : w.logoSection) }, T.map((U) => /* @__PURE__ */ g.createElement(Jo, { key: U, src: U, avatarSize: 24, className: F(A.logoIcon, w == null ? void 0 : w.logoIcon) }))), n && /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement("div", { className: F(A.imageBlurredBackground, w == null ? void 0 : w.imageBlurredBackground) }), /* @__PURE__ */ g.createElement(
      Pt,
      {
        classNames: {
          root: F(V.centered, A.imageHeight, w == null ? void 0 : w.imageHeight, { [A.imageGreyScale]: o }),
          imageWrapper: F(A.imageHeight, w == null ? void 0 : w.imageHeight),
          figure: A.imageHeight
        },
        src: n,
        alt: i || "image",
        fit: r ? "cover" : "contain",
        withPlaceholder: !0,
        height: "100%"
      }
    )), s && /* @__PURE__ */ g.createElement("iframe", { className: A.imageHeight, title: l, height: "100%", src: s, frameBorder: "0", allowFullScreen: !0 }))),
    /* @__PURE__ */ g.createElement(Ee, { gap: 0 }, p && /* @__PURE__ */ g.createElement(X, { gap: 8, mt: 12, justify: "left" }, p.map((U, re) => /* @__PURE__ */ g.createElement(
      Ty,
      {
        key: re,
        elementSize: "s",
        elementVariant: (U == null ? void 0 : U.elementVariant) || "secondary",
        leftSection: U == null ? void 0 : U.leftSection,
        rightSection: (U == null ? void 0 : U.rightSection) || (U == null ? void 0 : U.icon)
      },
      U == null ? void 0 : U.text
    ))), (a || c || d) && /* @__PURE__ */ g.createElement(Ee, { mt: n || s ? 16 : 0, gap: 8 }, a && /* @__PURE__ */ g.createElement(Ti, { elementSize: "m", order: 2, colorVariant: "greyIron.18" }, a), c && /* @__PURE__ */ g.createElement(xe, { lineClamp: 3, elementSize: "xs", elementVariant: "default", colorVariant: "greyIron.18" }, c), d)),
    /* @__PURE__ */ g.createElement(X, { gap: 12, pt: 12, mt: x ? "auto" : 0, justify: "space-between", wrap: "nowrap" }, u && /* @__PURE__ */ g.createElement(
      ki,
      {
        isIconOnly: !0,
        href: u,
        elementVariant: Q.SecondaryMain,
        elementSize: Ue.M,
        leftSection: h || /* @__PURE__ */ g.createElement(aC, null),
        target: "_blank",
        rel: "noreferrer noopener",
        onClick: se
      }
    ), /* @__PURE__ */ g.createElement(ye, { ...Lh.generateLinkButtonProps, ...E }, b), v)
  );
});
Sx.displayName = "Card";
const Cx = O((t, { disabled: e, isLinkHovered: n }) => ({
  root: {
    alignItems: "self-start",
    position: "relative",
    "& *": {
      cursor: "pointer"
    },
    "&:hover": {
      [`.${Jd}`]: !n && !e ? {
        border: `${m(1)} solid ${t.other.colors.brand[13]}`
      } : {}
    }
  },
  rootDisabled: {
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      cursor: "not-allowed"
    },
    [`& .${Jd} + .${Nl}`]: {
      color: t.other.colors.greyIron[6]
    }
  },
  labelWrapper: {
    display: "flex",
    flexDirection: "column"
  },
  label: {
    font: t.other.fonts.desktop.s.s.default,
    color: t.other.colors.greyIron[17],
    paddingLeft: m(8),
    "& a": {
      textDecoration: "none",
      color: t.other.colors.brand[13],
      transition: Ae(["color"]),
      "&:hover": {
        color: t.other.colors.brand[16]
      }
    }
  },
  labelImportant: {
    font: t.other.fonts.desktop.s.s.important
  },
  description: {
    font: t.other.fonts.desktop.s.s.default,
    color: t.other.colors.greyIron[14]
  },
  labelDescriptionDisabled: {
    span: {
      color: t.other.colors.greyIron[9]
    },
    "& a": {
      color: t.other.colors.greyIron[9]
    },
    [`& .${sy}`]: {
      color: t.other.colors.greyIron[9]
    }
  },
  input: {
    backgroundColor: t.other.colors.white[0],
    borderColor: t.other.colors.greyIron[7],
    transition: Ae(["border-color", "background-color", "box-shadow"]),
    "&:focus:not(:focus-visible)": {
      outline: "none",
      boxShadow: "none"
    },
    "&:focus": {
      boxShadow: `0 0 0 ${m(4)} ${t.other.colors.brand[3]}`,
      outline: "none",
      borderColor: t.other.colors.brand[13]
    },
    "&:checked": {
      backgroundColor: t.other.colors.brand[2],
      borderColor: t.other.colors.brand[13],
      [`& + .${Nl}`]: {
        color: `${t.other.colors.brand[13]}`
      }
    },
    "&:disabled": {
      backgroundColor: t.other.colors.greyIron[2],
      borderColor: t.other.colors.greyIron[6]
    },
    "&[data-indeterminate]&:not(:checked)&:not(:disabled)": {
      backgroundColor: t.other.colors.brand[2],
      borderColor: t.other.colors.brand[13],
      [`& + .${Nl}`]: {
        color: `${t.other.colors.brand[13]}`
      }
    },
    "&[data-indeterminate]&:checked": {
      backgroundColor: t.white
    }
  },
  inputActive: {
    "&:active": {
      background: t.other.colors.brand[1],
      border: `${m(1)} solid ${t.other.colors.brand[13]}`
    },
    "&:checked": {
      "&:active": {
        background: t.other.colors.brand[3]
      }
    }
  },
  inputError: {
    border: `${m(1)} solid ${t.other.colors.raspberry[11]}`
  },
  inputErrorHover: {
    "&:hover": {
      border: `${m(1)} solid ${t.other.colors.raspberry[11]} !important`,
      backgroundColor: t.other.colors.raspberry[2]
    }
  },
  error: {
    marginTop: t.other.spacings[8],
    color: t.other.colors.raspberry[11],
    font: t.other.fonts.desktop.s.s.default
  },
  icon: {
    width: m(16),
    height: m(16)
  }
})), la = ge(
  ({ label: t, description: e, disabled: n, indeterminate: r, error: o, classNames: i, unstyled: s, ...l }, a) => {
    const [c, d] = ie(!1), { classes: u, cx: f } = Cx({ disabled: n, isLinkHovered: c }), h = te(
      (p) => {
        p.target.tagName.toLowerCase() === "a" ? d(!0) : c && d(!1);
      },
      [c]
    );
    return /* @__PURE__ */ g.createElement(vi.Wrapper, { error: o, classNames: { error: u.error } }, /* @__PURE__ */ g.createElement(
      PS,
      {
        ref: a,
        "data-testid": "checkbox-input",
        classNames: {
          ...u,
          ...i,
          icon: u.icon,
          root: f(u.root, i == null ? void 0 : i.root, { [u.rootDisabled]: n }),
          label: f(u.label, i == null ? void 0 : i.label, { [u.labelImportant]: e, [u.labelDescriptionDisabled]: n }),
          input: f(u.input, i == null ? void 0 : i.input, {
            [u.inputActive]: !n && !c,
            [u.inputError]: o,
            [u.inputErrorHover]: o && !c
          })
        },
        unstyled: s,
        label: /* @__PURE__ */ g.createElement("div", { className: u.labelWrapper, onMouseOver: h, onFocus: () => {
        } }, /* @__PURE__ */ g.createElement("span", null, t), /* @__PURE__ */ g.createElement("span", { className: u.description }, e)),
        disabled: n,
        indeterminate: r,
        icon: r ? cC : Um,
        ...l
      }
    ));
  }
);
la.displayName = "Checkbox";
var Yd = /* @__PURE__ */ ((t) => (t.Light = "Light", t.Bright = "Bright", t))(Yd || {});
const vx = O(
  (t, { colorName: e, elementVariant: n }) => {
    const r = {
      wrapper: {
        padding: m(4),
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: m(40),
        height: m(40)
      },
      icon: {
        width: m(20),
        height: m(20),
        "& > svg": {
          width: m(20),
          height: m(20)
        }
      }
    }, o = {
      wrapper: {
        ...r.wrapper,
        backgroundColor: t.other.colors[e][2],
        boxShadow: `0 0 0 ${m(4)} ${t.other.colors[e][0]}`
      },
      icon: {
        ...r.icon,
        color: t.other.colors[e][14]
      }
    }, i = {
      wrapper: {
        ...r.wrapper,
        backgroundColor: t.other.colors[e][3],
        boxShadow: `0 0 0 ${m(4)} ${t.other.colors[e][1]}`
      },
      icon: {
        ...r.icon,
        color: t.other.colors[e][12]
      }
    };
    return {
      [Yd.Light]: o,
      [Yd.Bright]: i
    }[n];
  }
), Lo = ({ Icon: t, colorName: e = "greyIron", elementVariant: n = "Light" }) => {
  const { classes: r } = vx({ colorName: e, elementVariant: n });
  return /* @__PURE__ */ g.createElement("div", { className: r.wrapper }, /* @__PURE__ */ g.createElement(t, { className: r.icon }));
}, xx = ({ Icon: t, colorName: e }) => /* @__PURE__ */ g.createElement(Lo, { Icon: t || qm, colorName: e || "froggy", elementVariant: "Bright" }), Ex = ({ Icon: t, colorName: e }) => /* @__PURE__ */ g.createElement(Lo, { Icon: t || Jm, colorName: e || "sunflower", elementVariant: "Bright" }), kx = O((t, { colorName: e }) => ({
  codeBlock: {
    position: "relative",
    font: t.other.fonts.desktop.s.s.code,
    padding: t.other.spacings[12],
    paddingLeft: 28,
    border: `${m(1)} solid ${t.other.colors[e][5]}`,
    borderRadius: t.other.borderRadius[8],
    backgroundColor: t.other.colors[e][0],
    color: t.other.colors.greyIron[16],
    wordBreak: "break-all",
    "&::before": {
      display: "block",
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: 16,
      height: "100%",
      borderRadius: `${t.other.borderRadius[8]} 0 0 ${t.other.borderRadius[8]}`,
      backgroundColor: t.other.colors[e][3]
    },
    "&::selection": {
      backgroundColor: t.other.colors[e][4]
    }
  }
})), Tx = "iceberg", Ix = ({ children: t, colorName: e = Tx }) => {
  const { classes: n } = kx({ colorName: e });
  return /* @__PURE__ */ g.createElement("div", { className: n.codeBlock }, t);
};
Ix.displayName = "CodeBlock";
var yi = /* @__PURE__ */ ((t) => (t.xs = "xs", t.s = "s", t.m = "m", t))(yi || {});
const ri = (t, e) => {
  switch (t) {
    case yi.m:
      return e[0];
    case yi.s:
      return e[1];
    case yi.xs:
      return e[2];
    default:
      return e[0];
  }
}, pl = 16, Mx = O((t, { passed: e, elementSize: n = yi.m }) => ({
  root: {
    gap: m(24),
    alignItems: "flex-start"
  },
  titleWrapper: {
    gap: m(8),
    flexWrap: "nowrap"
  },
  textWrapper: {
    gap: m(ri(n, [8, 0, 0]))
  },
  title: {
    font: ri(n, [
      t.other.fonts.desktop.s.m.header,
      t.other.fonts.desktop.s.s.default,
      t.other.fonts.desktop.s.xs.default
    ]),
    color: ri(n, [t.other.colors.greyIron[20], t.other.colors.greyIron[16], t.other.colors.greyIron[16]])
  },
  description: {
    font: ri(n, [
      t.other.fonts.desktop.s.s.default,
      t.other.fonts.desktop.s.s.default,
      t.other.fonts.desktop.s.xs.default
    ]),
    color: ri(n, [t.other.colors.greyIron[16], t.other.colors.greyIron[11], t.other.colors.greyIron[11]]),
    paddingLeft: m(ri(n, [0, pl + 8, pl + 8]))
  },
  icon: {
    width: m(pl),
    height: m(pl),
    color: e ? t.other.colors.froggy[8] : t.other.colors.greyIron[8],
    flexShrink: 0
  }
})), Rx = {
  elementSize: yi.m,
  passed: !1
}, ez = (t) => {
  const { elementSize: e, title: n, description: r, linkText: o, linkHref: i, onLinkClick: s, passed: l, className: a, classNames: c, ...d } = he(
    "Condition",
    Rx,
    t
  ), { classes: u, cx: f } = Mx({ passed: l, elementSize: e }), h = !!(o && e === "m");
  return /* @__PURE__ */ g.createElement(Ee, { className: f(u.root, c == null ? void 0 : c.root, a), ...d }, /* @__PURE__ */ g.createElement(Ee, { className: f(u.textWrapper, c == null ? void 0 : c.textWrapper) }, /* @__PURE__ */ g.createElement(X, { className: f(u.titleWrapper, c == null ? void 0 : c.titleWrapper) }, /* @__PURE__ */ g.createElement(dC, { className: f(u.icon, c == null ? void 0 : c.icon) }), /* @__PURE__ */ g.createElement(xe, { elementSize: "s", elementVariant: "default", className: f(u.title, c == null ? void 0 : c.title) }, n)), r && /* @__PURE__ */ g.createElement(xe, { elementSize: "s", elementVariant: "default", className: f(u.description, c == null ? void 0 : c.description) }, r)), h && /* @__PURE__ */ g.createElement(
    ki,
    {
      href: i,
      onClick: s,
      rightSection: /* @__PURE__ */ g.createElement(uC, null),
      elementVariant: Q.PrimaryMainLine,
      elementSize: Ue.M,
      "data-testid": "condition-link-button"
    },
    o
  ));
}, Ox = () => {
  const [t, e] = ie(!1), n = te((o) => {
    e(o);
  }, []), r = te(
    (o) => {
      o.preventDefault(), o.stopPropagation(), n(!t);
    },
    [t, n]
  );
  return {
    opened: t,
    onTooltipClick: r,
    toggleTooltipOpened: n
  };
}, Dx = O((t, { maxWidth: e }) => ({
  tooltip: {
    backgroundColor: t.other.colors.greyIron[19],
    color: t.other.colors.greyIron[0],
    font: t.other.fonts.desktop.s.xs.important,
    borderRadius: t.other.borderRadius[8],
    padding: `${t.other.spacings[4]} ${t.other.spacings[8]}`,
    maxWidth: m(e) || "none",
    wordBreak: "break-word",
    "&& a": {
      color: t.other.colors.greyIron[0]
    },
    pointerEvents: "initial"
  },
  arrow: {}
})), at = ({
  children: t,
  classNames: e,
  styles: n,
  unstyled: r,
  w: o = 220,
  label: i,
  transitionProps: s,
  openDelay: l = 150,
  events: a = { hover: !0, touch: !0, focus: !1 },
  floatingStrategy: c = "fixed",
  ...d
}) => {
  const { classes: u } = Dx(
    { maxWidth: Number.isInteger(o) ? Number(o) : void 0 },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    { classNames: e, styles: n, unstyled: r, name: "TooltipExtra" }
  ), { opened: f, onTooltipClick: h, toggleTooltipOpened: p } = Ox();
  return i ? /* @__PURE__ */ g.createElement(
    Xs,
    {
      classNames: u,
      label: i,
      zIndex: 999999999,
      multiline: !0,
      transitionProps: {
        duration: 200,
        ...s
      },
      events: a,
      openDelay: l,
      opened: f,
      onClick: h,
      onMouseEnter: () => p(!0),
      onMouseLeave: () => p(!1),
      floatingStrategy: c,
      ...d
    },
    t
  ) : /* @__PURE__ */ g.createElement(g.Fragment, null, t);
};
at.displayName = "Tooltip";
at.Floating = Xs.Floating;
at.Group = Xs.Group;
const Ax = O(() => ({
  active: {
    "&:active": {
      transform: "unset"
    }
  }
})), Lx = ({ value: t, textButtonCopied: e = "Copied", timeout: n = 1e3, tooltipPosition: r = "top" }) => {
  const { classes: o } = Ax();
  return /* @__PURE__ */ g.createElement(_S, { value: t, timeout: n }, ({ copied: i, copy: s }) => /* @__PURE__ */ g.createElement(at, { opened: !0, withinPortal: !0, label: i ? e : "", withArrow: !1, position: r }, /* @__PURE__ */ g.createElement(
    ye,
    {
      className: o.active,
      "data-testid": "copy-button",
      elementVariant: Q.PrimaryMainLine,
      leftSection: /* @__PURE__ */ g.createElement(fC, null),
      onClick: s,
      isIconOnly: !0
    }
  )));
}, $x = O((t) => ({
  root: {},
  container: {
    padding: m(3),
    borderRadius: m(8),
    border: `${m(1)} solid transparent`,
    backgroundColor: t.other.colors.brand[3],
    width: "max-content",
    minWidth: m(26)
  },
  containerDisabled: {
    backgroundColor: "transparent",
    borderColor: t.other.colors.greyIron[4]
  },
  counter: {},
  counterDisabled: {
    color: t.other.colors.greyIron[9]
  }
})), Px = ({
  value: t,
  disabled: e,
  classNames: n,
  className: r
}) => {
  const { classes: o, cx: i } = $x(void 0);
  return /* @__PURE__ */ g.createElement(
    Ee,
    {
      gap: 0,
      align: "center",
      className: i(o.container, n == null ? void 0 : n.container, r, {
        [i(o.containerDisabled, n == null ? void 0 : n.containerDisabled)]: e
      })
    },
    /* @__PURE__ */ g.createElement(
      xe,
      {
        elementSize: "s",
        elementVariant: "buttons",
        className: i(o.counter, n == null ? void 0 : n.counter, { [i(o.counterDisabled, n == null ? void 0 : n.counterDisabled)]: e })
      },
      t
    )
  );
}, _x = O((t) => ({
  root: {},
  flag: {
    backgroundColor: t.other.colors.greyTrue[2]
  },
  country: {}
})), tz = (t) => {
  const { flagName: e, country: n, classNames: r, className: o, ...i } = t, s = me(() => ny(e), [e]), { classes: l, cx: a } = _x(void 0);
  return /* @__PURE__ */ g.createElement(X, { className: a(l.root, r == null ? void 0 : r.root, o), gap: 8, wrap: "nowrap", ...i }, /* @__PURE__ */ g.createElement(Vm, { className: a(l.flag, r == null ? void 0 : r.flag), src: s, alt: e, size: 16, radius: 50 }), /* @__PURE__ */ g.createElement(xe, { className: a(l.country, r == null ? void 0 : r.country), elementVariant: "important", elementSize: "s" }, n));
}, Bx = async (t, e, n, r, o, i = 1) => {
  const s = e.getContext("2d");
  if (!s)
    throw new Error("No 2d context");
  e.width = r, e.height = o;
  const l = n.x, a = n.y, c = n.width * i, d = n.height * i;
  s.save(), s.scale(i, i), s.drawImage(t, l, a, c, d, 0, 0, r, o), s.restore();
}, Vx = O((t) => ({
  canvas: {
    borderRadius: t.other.borderRadius[4]
  },
  image: {
    borderRadius: t.other.borderRadius[4],
    objectFit: "cover"
  }
})), nz = ({ src: t, img: e, crop: n, targetWidth: r, targetHeight: o, scale: i, className: s, ...l }) => {
  const a = Nt(null), { classes: c, cx: d } = Vx(void 0);
  return It(() => {
    !(n != null && n.width) || !(n != null && n.height) || !e || !a.current || Bx(e, a.current, n, r, o, i);
  }, [e, n]), /* @__PURE__ */ g.createElement(
    oe,
    {
      component: e ? "canvas" : "img",
      ref: e ? a : void 0,
      src: e ? void 0 : t,
      alt: "crop preview",
      width: r,
      height: o,
      className: d({ [c.image]: !e, [c.canvas]: e }, s),
      ...l
    }
  );
}, Fx = O((t) => ({
  root: {
    borderRadius: t.other.borderRadius[4],
    maxHeight: m(504),
    maxWidth: m(365)
  },
  mainWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: t.other.colors.greyIron[2],
    borderRadius: t.other.borderRadius[4],
    position: "relative"
  },
  figure: {},
  imageWrapper: {},
  image: {
    maxHeight: m(504),
    maxWidth: m(365)
  },
  cropper: {
    "& .ReactCrop__child-wrapper": {
      borderRadius: t.other.borderRadius[4]
    }
  },
  enableCropButton: {
    position: "absolute",
    right: m(8),
    bottom: m(8)
  }
})), Nx = {
  width: 365,
  height: 504
}, rz = (t) => {
  const {
    src: e,
    width: n,
    height: r,
    className: o,
    classNames: i,
    onChange: s,
    initialCrop: l,
    imageRef: a,
    aspect: c,
    minWidth: d,
    minHeight: u,
    maxWidth: f,
    maxHeight: h,
    keepSelection: p,
    disabled: y,
    locked: b,
    cropperStyle: w,
    onComplete: S,
    onDragStart: x,
    onDragEnd: E,
    renderSelectionAddon: v,
    ruleOfThirds: T,
    circularCrop: I,
    imageAlt: M,
    withCropEnableButton: R,
    ...A
  } = he("ImageCrop", Nx, t), F = IS(), [V, P] = ie(0), [J, ne] = ie(l), [G, H] = ie(!R), { classes: W, cx: se } = Fx(), U = (re) => {
    var Oe;
    const { width: ke, height: Te, x: Se, y: Le } = re, Ce = V / (((Oe = F.current) == null ? void 0 : Oe.clientHeight) || 1), et = {
      x: Se * Ce,
      y: Le * Ce,
      width: ke * Ce,
      height: Te * Ce,
      unit: "px"
    };
    ne(re), s == null || s(et);
  };
  return It(() => {
    a != null && a.current && P(a.current.naturalHeight);
  }, [a == null ? void 0 : a.current]), /* @__PURE__ */ g.createElement(oe, { className: se(W.mainWrapper, i == null ? void 0 : i.mainWrapper, o), ...A, w: n, h: r }, G && /* @__PURE__ */ g.createElement(
    vv,
    {
      crop: J,
      onChange: U,
      className: W.cropper,
      aspect: c,
      minWidth: d,
      minHeight: u,
      maxWidth: f,
      maxHeight: h,
      keepSelection: p,
      disabled: y,
      locked: b,
      style: w,
      onComplete: S,
      onDragStart: x,
      onDragEnd: E,
      renderSelectionAddon: v,
      ruleOfThirds: T,
      circularCrop: I
    },
    /* @__PURE__ */ g.createElement(Pt, { src: e, classNames: { ...W, ...i }, imageRef: a, ref: F, alt: M, fit: "contain" })
  ), !G && /* @__PURE__ */ g.createElement(Pt, { imageRef: a, src: e, classNames: { ...W, ...i }, alt: M, fit: "contain" }), !G && /* @__PURE__ */ g.createElement(
    ye,
    {
      onClick: () => H(!0),
      isIconOnly: !0,
      isRound: !0,
      leftSection: /* @__PURE__ */ g.createElement(hC, null),
      elementVariant: Q.TertiaryMain,
      className: W.enableCropButton
    }
  ));
}, zx = (t, e = "monday") => {
  const n = new Date(t), r = n.getDay(), o = e === "sunday", i = 7 - (o ? r + 1 : r);
  return (o && r !== 6 || r !== 0) && n.setDate(n.getDate() + i), n;
}, Py = (t, e = "monday") => {
  const n = new Date(t), r = n.getDay() || 7, o = e === "sunday", i = o ? r : r - 1;
  return (o && r !== 0 || r !== 1) && n.setHours(-24 * i), n;
}, Hx = (t, e = "monday") => {
  const n = t.getMonth(), r = new Date(t.getFullYear(), n, 1), o = new Date(t.getFullYear(), t.getMonth() + 1, 0), i = zx(o, e), s = Py(r, e), l = [];
  for (; s <= i; ) {
    const a = [];
    for (let c = 0; c < 7; c += 1)
      a.push(new Date(s)), s.setDate(s.getDate() + 1);
    l.push(a);
  }
  return l;
};
class Ko extends Error {
}
class jx extends Ko {
  constructor(e) {
    super(`Invalid DateTime: ${e.toMessage()}`);
  }
}
class Wx extends Ko {
  constructor(e) {
    super(`Invalid Interval: ${e.toMessage()}`);
  }
}
class Gx extends Ko {
  constructor(e) {
    super(`Invalid Duration: ${e.toMessage()}`);
  }
}
class as extends Ko {
}
class _y extends Ko {
  constructor(e) {
    super(`Invalid unit ${e}`);
  }
}
class Vn extends Ko {
}
class Gr extends Ko {
  constructor() {
    super("Zone is an abstract class");
  }
}
const z = "numeric", nr = "short", Mn = "long", aa = {
  year: z,
  month: z,
  day: z
}, By = {
  year: z,
  month: nr,
  day: z
}, Ux = {
  year: z,
  month: nr,
  day: z,
  weekday: nr
}, Vy = {
  year: z,
  month: Mn,
  day: z
}, Fy = {
  year: z,
  month: Mn,
  day: z,
  weekday: Mn
}, Ny = {
  hour: z,
  minute: z
}, zy = {
  hour: z,
  minute: z,
  second: z
}, Hy = {
  hour: z,
  minute: z,
  second: z,
  timeZoneName: nr
}, jy = {
  hour: z,
  minute: z,
  second: z,
  timeZoneName: Mn
}, Wy = {
  hour: z,
  minute: z,
  hourCycle: "h23"
}, Gy = {
  hour: z,
  minute: z,
  second: z,
  hourCycle: "h23"
}, Uy = {
  hour: z,
  minute: z,
  second: z,
  hourCycle: "h23",
  timeZoneName: nr
}, qy = {
  hour: z,
  minute: z,
  second: z,
  hourCycle: "h23",
  timeZoneName: Mn
}, Jy = {
  year: z,
  month: z,
  day: z,
  hour: z,
  minute: z
}, Ky = {
  year: z,
  month: z,
  day: z,
  hour: z,
  minute: z,
  second: z
}, Yy = {
  year: z,
  month: nr,
  day: z,
  hour: z,
  minute: z
}, Zy = {
  year: z,
  month: nr,
  day: z,
  hour: z,
  minute: z,
  second: z
}, qx = {
  year: z,
  month: nr,
  day: z,
  weekday: nr,
  hour: z,
  minute: z
}, Xy = {
  year: z,
  month: Mn,
  day: z,
  hour: z,
  minute: z,
  timeZoneName: nr
}, Qy = {
  year: z,
  month: Mn,
  day: z,
  hour: z,
  minute: z,
  second: z,
  timeZoneName: nr
}, e0 = {
  year: z,
  month: Mn,
  day: z,
  weekday: Mn,
  hour: z,
  minute: z,
  timeZoneName: Mn
}, t0 = {
  year: z,
  month: Mn,
  day: z,
  weekday: Mn,
  hour: z,
  minute: z,
  second: z,
  timeZoneName: Mn
};
class tl {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new Gr();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new Gr();
  }
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new Gr();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, n) {
    throw new Gr();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    throw new Gr();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    throw new Gr();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    throw new Gr();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new Gr();
  }
}
let zc = null;
class fc extends tl {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return zc === null && (zc = new fc()), zc;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: n, locale: r }) {
    return r0(e, n, r);
  }
  /** @override **/
  formatOffset(e, n) {
    return ws(this.offset(e), n);
  }
  /** @override **/
  offset(e) {
    return -new Date(e).getTimezoneOffset();
  }
  /** @override **/
  equals(e) {
    return e.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let jl = {};
function Jx(t) {
  return jl[t] || (jl[t] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), jl[t];
}
const Kx = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function Yx(t, e) {
  const n = t.format(e).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, o, i, s, l, a, c, d] = r;
  return [s, o, i, l, a, c, d];
}
function Zx(t, e) {
  const n = t.formatToParts(e), r = [];
  for (let o = 0; o < n.length; o++) {
    const { type: i, value: s } = n[o], l = Kx[i];
    i === "era" ? r[l] = s : He(l) || (r[l] = parseInt(s, 10));
  }
  return r;
}
let gl = {};
class Br extends tl {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(e) {
    return gl[e] || (gl[e] = new Br(e)), gl[e];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    gl = {}, jl = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(e) {
    return this.isValidZone(e);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(e) {
    if (!e)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: e }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(e) {
    super(), this.zoneName = e, this.valid = Br.isValidZone(e);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: n, locale: r }) {
    return r0(e, n, r, this.name);
  }
  /** @override **/
  formatOffset(e, n) {
    return ws(this.offset(e), n);
  }
  /** @override **/
  offset(e) {
    const n = new Date(e);
    if (isNaN(n)) return NaN;
    const r = Jx(this.name);
    let [o, i, s, l, a, c, d] = r.formatToParts ? Zx(r, n) : Yx(r, n);
    l === "BC" && (o = -Math.abs(o) + 1);
    const f = cf({
      year: o,
      month: i,
      day: s,
      hour: a === 24 ? 0 : a,
      minute: c,
      second: d,
      millisecond: 0
    });
    let h = +n;
    const p = h % 1e3;
    return h -= p >= 0 ? p : 1e3 + p, (f - h) / (60 * 1e3);
  }
  /** @override **/
  equals(e) {
    return e.type === "iana" && e.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let $h = {};
function Xx(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = $h[n];
  return r || (r = new Intl.ListFormat(t, e), $h[n] = r), r;
}
let Zd = {};
function Xd(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = Zd[n];
  return r || (r = new Intl.DateTimeFormat(t, e), Zd[n] = r), r;
}
let Qd = {};
function Qx(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let r = Qd[n];
  return r || (r = new Intl.NumberFormat(t, e), Qd[n] = r), r;
}
let eu = {};
function eE(t, e = {}) {
  const { base: n, ...r } = e, o = JSON.stringify([t, r]);
  let i = eu[o];
  return i || (i = new Intl.RelativeTimeFormat(t, e), eu[o] = i), i;
}
let cs = null;
function tE() {
  return cs || (cs = new Intl.DateTimeFormat().resolvedOptions().locale, cs);
}
function nE(t) {
  const e = t.indexOf("-x-");
  e !== -1 && (t = t.substring(0, e));
  const n = t.indexOf("-u-");
  if (n === -1)
    return [t];
  {
    let r, o;
    try {
      r = Xd(t).resolvedOptions(), o = t;
    } catch {
      const a = t.substring(0, n);
      r = Xd(a).resolvedOptions(), o = a;
    }
    const { numberingSystem: i, calendar: s } = r;
    return [o, i, s];
  }
}
function rE(t, e, n) {
  return (n || e) && (t.includes("-u-") || (t += "-u"), n && (t += `-ca-${n}`), e && (t += `-nu-${e}`)), t;
}
function oE(t) {
  const e = [];
  for (let n = 1; n <= 12; n++) {
    const r = _.utc(2016, n, 1);
    e.push(t(r));
  }
  return e;
}
function iE(t) {
  const e = [];
  for (let n = 1; n <= 7; n++) {
    const r = _.utc(2016, 11, 13 + n);
    e.push(t(r));
  }
  return e;
}
function ml(t, e, n, r, o) {
  const i = t.listingMode(n);
  return i === "error" ? null : i === "en" ? r(e) : o(e);
}
function sE(t) {
  return t.numberingSystem && t.numberingSystem !== "latn" ? !1 : t.numberingSystem === "latn" || !t.locale || t.locale.startsWith("en") || new Intl.DateTimeFormat(t.intl).resolvedOptions().numberingSystem === "latn";
}
class lE {
  constructor(e, n, r) {
    this.padTo = r.padTo || 0, this.floor = r.floor || !1;
    const { padTo: o, floor: i, ...s } = r;
    if (!n || Object.keys(s).length > 0) {
      const l = { useGrouping: !1, ...r };
      r.padTo > 0 && (l.minimumIntegerDigits = r.padTo), this.inf = Qx(e, l);
    }
  }
  format(e) {
    if (this.inf) {
      const n = this.floor ? Math.floor(e) : e;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(e) : af(e, 3);
      return Bt(n, this.padTo);
    }
  }
}
class aE {
  constructor(e, n, r) {
    this.opts = r, this.originalZone = void 0;
    let o;
    if (this.opts.timeZone)
      this.dt = e;
    else if (e.zone.type === "fixed") {
      const s = -1 * (e.offset / 60), l = s >= 0 ? `Etc/GMT+${s}` : `Etc/GMT${s}`;
      e.offset !== 0 && Br.create(l).valid ? (o = l, this.dt = e) : (o = "UTC", this.dt = e.offset === 0 ? e : e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    } else e.zone.type === "system" ? this.dt = e : e.zone.type === "iana" ? (this.dt = e, o = e.zone.name) : (o = "UTC", this.dt = e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    const i = { ...this.opts };
    i.timeZone = i.timeZone || o, this.dtf = Xd(n, i);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: e }) => e).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const e = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? e.map((n) => {
      if (n.type === "timeZoneName") {
        const r = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: r
        };
      } else
        return n;
    }) : e;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class cE {
  constructor(e, n, r) {
    this.opts = { style: "long", ...r }, !n && n0() && (this.rtf = eE(e, r));
  }
  format(e, n) {
    return this.rtf ? this.rtf.format(e, n) : TE(n, e, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(e, n) {
    return this.rtf ? this.rtf.formatToParts(e, n) : [];
  }
}
class ft {
  static fromOpts(e) {
    return ft.create(e.locale, e.numberingSystem, e.outputCalendar, e.defaultToEN);
  }
  static create(e, n, r, o = !1) {
    const i = e || _t.defaultLocale, s = i || (o ? "en-US" : tE()), l = n || _t.defaultNumberingSystem, a = r || _t.defaultOutputCalendar;
    return new ft(s, l, a, i);
  }
  static resetCache() {
    cs = null, Zd = {}, Qd = {}, eu = {};
  }
  static fromObject({ locale: e, numberingSystem: n, outputCalendar: r } = {}) {
    return ft.create(e, n, r);
  }
  constructor(e, n, r, o) {
    const [i, s, l] = nE(e);
    this.locale = i, this.numberingSystem = n || s || null, this.outputCalendar = r || l || null, this.intl = rE(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = o, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = sE(this)), this.fastNumbersCached;
  }
  listingMode() {
    const e = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return e && n ? "en" : "intl";
  }
  clone(e) {
    return !e || Object.getOwnPropertyNames(e).length === 0 ? this : ft.create(
      e.locale || this.specifiedLocale,
      e.numberingSystem || this.numberingSystem,
      e.outputCalendar || this.outputCalendar,
      e.defaultToEN || !1
    );
  }
  redefaultToEN(e = {}) {
    return this.clone({ ...e, defaultToEN: !0 });
  }
  redefaultToSystem(e = {}) {
    return this.clone({ ...e, defaultToEN: !1 });
  }
  months(e, n = !1, r = !0) {
    return ml(this, e, r, s0, () => {
      const o = n ? { month: e, day: "numeric" } : { month: e }, i = n ? "format" : "standalone";
      return this.monthsCache[i][e] || (this.monthsCache[i][e] = oE((s) => this.extract(s, o, "month"))), this.monthsCache[i][e];
    });
  }
  weekdays(e, n = !1, r = !0) {
    return ml(this, e, r, c0, () => {
      const o = n ? { weekday: e, year: "numeric", month: "long", day: "numeric" } : { weekday: e }, i = n ? "format" : "standalone";
      return this.weekdaysCache[i][e] || (this.weekdaysCache[i][e] = iE(
        (s) => this.extract(s, o, "weekday")
      )), this.weekdaysCache[i][e];
    });
  }
  meridiems(e = !0) {
    return ml(
      this,
      void 0,
      e,
      () => d0,
      () => {
        if (!this.meridiemCache) {
          const n = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [_.utc(2016, 11, 13, 9), _.utc(2016, 11, 13, 19)].map(
            (r) => this.extract(r, n, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(e, n = !0) {
    return ml(this, e, n, u0, () => {
      const r = { era: e };
      return this.eraCache[e] || (this.eraCache[e] = [_.utc(-40, 1, 1), _.utc(2017, 1, 1)].map(
        (o) => this.extract(o, r, "era")
      )), this.eraCache[e];
    });
  }
  extract(e, n, r) {
    const o = this.dtFormatter(e, n), i = o.formatToParts(), s = i.find((l) => l.type.toLowerCase() === r);
    return s ? s.value : null;
  }
  numberFormatter(e = {}) {
    return new lE(this.intl, e.forceSimple || this.fastNumbers, e);
  }
  dtFormatter(e, n = {}) {
    return new aE(e, this.intl, n);
  }
  relFormatter(e = {}) {
    return new cE(this.intl, this.isEnglish(), e);
  }
  listFormatter(e = {}) {
    return Xx(this.intl, e);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  equals(e) {
    return this.locale === e.locale && this.numberingSystem === e.numberingSystem && this.outputCalendar === e.outputCalendar;
  }
}
let Hc = null;
class hn extends tl {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return Hc === null && (Hc = new hn(0)), Hc;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(e) {
    return e === 0 ? hn.utcInstance : new hn(e);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(e) {
    if (e) {
      const n = e.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new hn(pc(n[1], n[2]));
    }
    return null;
  }
  constructor(e) {
    super(), this.fixed = e;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${ws(this.fixed, "narrow")}`;
  }
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${ws(-this.fixed, "narrow")}`;
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(e, n) {
    return ws(this.fixed, n);
  }
  /** @override **/
  get isUniversal() {
    return !0;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(e) {
    return e.type === "fixed" && e.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
class dE extends tl {
  constructor(e) {
    super(), this.zoneName = e;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function eo(t, e) {
  if (He(t) || t === null)
    return e;
  if (t instanceof tl)
    return t;
  if (uE(t)) {
    const n = t.toLowerCase();
    return n === "default" ? e : n === "local" || n === "system" ? fc.instance : n === "utc" || n === "gmt" ? hn.utcInstance : hn.parseSpecifier(n) || Br.create(t);
  } else return $o(t) ? hn.instance(t) : typeof t == "object" && t.offset && typeof t.offset == "number" ? t : new dE(t);
}
let Ph = () => Date.now(), _h = "system", Bh = null, Vh = null, Fh = null, Nh = 60, zh;
class _t {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return Ph;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(e) {
    Ph = e;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(e) {
    _h = e;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return eo(_h, fc.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return Bh;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(e) {
    Bh = e;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return Vh;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(e) {
    Vh = e;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return Fh;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(e) {
    Fh = e;
  }
  /**
   * Get the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return Nh;
  }
  /**
   * Set the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // cut-off year is 0, so all 'yy' are interpretted as current century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 1949; '50' -> 2050
   * @example Settings.twoDigitCutoffYear = 1950 // interpretted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpretted as 50
   */
  static set twoDigitCutoffYear(e) {
    Nh = e % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return zh;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(e) {
    zh = e;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    ft.resetCache(), Br.resetCache();
  }
}
function He(t) {
  return typeof t > "u";
}
function $o(t) {
  return typeof t == "number";
}
function hc(t) {
  return typeof t == "number" && t % 1 === 0;
}
function uE(t) {
  return typeof t == "string";
}
function fE(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function n0() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function hE(t) {
  return Array.isArray(t) ? t : [t];
}
function Hh(t, e, n) {
  if (t.length !== 0)
    return t.reduce((r, o) => {
      const i = [e(o), o];
      return r && n(r[0], i[0]) === r[0] ? r : i;
    }, null)[1];
}
function pE(t, e) {
  return e.reduce((n, r) => (n[r] = t[r], n), {});
}
function Ii(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function Ar(t, e, n) {
  return hc(t) && t >= e && t <= n;
}
function gE(t, e) {
  return t - e * Math.floor(t / e);
}
function Bt(t, e = 2) {
  const n = t < 0;
  let r;
  return n ? r = "-" + ("" + -t).padStart(e, "0") : r = ("" + t).padStart(e, "0"), r;
}
function Kr(t) {
  if (!(He(t) || t === null || t === ""))
    return parseInt(t, 10);
}
function ko(t) {
  if (!(He(t) || t === null || t === ""))
    return parseFloat(t);
}
function lf(t) {
  if (!(He(t) || t === null || t === "")) {
    const e = parseFloat("0." + t) * 1e3;
    return Math.floor(e);
  }
}
function af(t, e, n = !1) {
  const r = 10 ** e;
  return (n ? Math.trunc : Math.round)(t * r) / r;
}
function nl(t) {
  return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
}
function bs(t) {
  return nl(t) ? 366 : 365;
}
function ca(t, e) {
  const n = gE(e - 1, 12) + 1, r = t + (e - n) / 12;
  return n === 2 ? nl(r) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function cf(t) {
  let e = Date.UTC(
    t.year,
    t.month - 1,
    t.day,
    t.hour,
    t.minute,
    t.second,
    t.millisecond
  );
  return t.year < 100 && t.year >= 0 && (e = new Date(e), e.setUTCFullYear(t.year, t.month - 1, t.day)), +e;
}
function da(t) {
  const e = (t + Math.floor(t / 4) - Math.floor(t / 100) + Math.floor(t / 400)) % 7, n = t - 1, r = (n + Math.floor(n / 4) - Math.floor(n / 100) + Math.floor(n / 400)) % 7;
  return e === 4 || r === 3 ? 53 : 52;
}
function tu(t) {
  return t > 99 ? t : t > _t.twoDigitCutoffYear ? 1900 + t : 2e3 + t;
}
function r0(t, e, n, r = null) {
  const o = new Date(t), i = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  r && (i.timeZone = r);
  const s = { timeZoneName: e, ...i }, l = new Intl.DateTimeFormat(n, s).formatToParts(o).find((a) => a.type.toLowerCase() === "timezonename");
  return l ? l.value : null;
}
function pc(t, e) {
  let n = parseInt(t, 10);
  Number.isNaN(n) && (n = 0);
  const r = parseInt(e, 10) || 0, o = n < 0 || Object.is(n, -0) ? -r : r;
  return n * 60 + o;
}
function o0(t) {
  const e = Number(t);
  if (typeof t == "boolean" || t === "" || Number.isNaN(e))
    throw new Vn(`Invalid unit value ${t}`);
  return e;
}
function ua(t, e) {
  const n = {};
  for (const r in t)
    if (Ii(t, r)) {
      const o = t[r];
      if (o == null) continue;
      n[e(r)] = o0(o);
    }
  return n;
}
function ws(t, e) {
  const n = Math.trunc(Math.abs(t / 60)), r = Math.trunc(Math.abs(t % 60)), o = t >= 0 ? "+" : "-";
  switch (e) {
    case "short":
      return `${o}${Bt(n, 2)}:${Bt(r, 2)}`;
    case "narrow":
      return `${o}${n}${r > 0 ? `:${r}` : ""}`;
    case "techie":
      return `${o}${Bt(n, 2)}${Bt(r, 2)}`;
    default:
      throw new RangeError(`Value format ${e} is out of range for property format`);
  }
}
function gc(t) {
  return pE(t, ["hour", "minute", "second", "millisecond"]);
}
const mE = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], i0 = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], yE = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function s0(t) {
  switch (t) {
    case "narrow":
      return [...yE];
    case "short":
      return [...i0];
    case "long":
      return [...mE];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const l0 = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], a0 = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], bE = ["M", "T", "W", "T", "F", "S", "S"];
function c0(t) {
  switch (t) {
    case "narrow":
      return [...bE];
    case "short":
      return [...a0];
    case "long":
      return [...l0];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const d0 = ["AM", "PM"], wE = ["Before Christ", "Anno Domini"], SE = ["BC", "AD"], CE = ["B", "A"];
function u0(t) {
  switch (t) {
    case "narrow":
      return [...CE];
    case "short":
      return [...SE];
    case "long":
      return [...wE];
    default:
      return null;
  }
}
function vE(t) {
  return d0[t.hour < 12 ? 0 : 1];
}
function xE(t, e) {
  return c0(e)[t.weekday - 1];
}
function EE(t, e) {
  return s0(e)[t.month - 1];
}
function kE(t, e) {
  return u0(e)[t.year < 0 ? 0 : 1];
}
function TE(t, e, n = "always", r = !1) {
  const o = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, i = ["hours", "minutes", "seconds"].indexOf(t) === -1;
  if (n === "auto" && i) {
    const u = t === "days";
    switch (e) {
      case 1:
        return u ? "tomorrow" : `next ${o[t][0]}`;
      case -1:
        return u ? "yesterday" : `last ${o[t][0]}`;
      case 0:
        return u ? "today" : `this ${o[t][0]}`;
    }
  }
  const s = Object.is(e, -0) || e < 0, l = Math.abs(e), a = l === 1, c = o[t], d = r ? a ? c[1] : c[2] || c[1] : a ? o[t][0] : t;
  return s ? `${l} ${d} ago` : `in ${l} ${d}`;
}
function jh(t, e) {
  let n = "";
  for (const r of t)
    r.literal ? n += r.val : n += e(r.val);
  return n;
}
const IE = {
  D: aa,
  DD: By,
  DDD: Vy,
  DDDD: Fy,
  t: Ny,
  tt: zy,
  ttt: Hy,
  tttt: jy,
  T: Wy,
  TT: Gy,
  TTT: Uy,
  TTTT: qy,
  f: Jy,
  ff: Yy,
  fff: Xy,
  ffff: e0,
  F: Ky,
  FF: Zy,
  FFF: Qy,
  FFFF: t0
};
class rn {
  static create(e, n = {}) {
    return new rn(e, n);
  }
  static parseFormat(e) {
    let n = null, r = "", o = !1;
    const i = [];
    for (let s = 0; s < e.length; s++) {
      const l = e.charAt(s);
      l === "'" ? (r.length > 0 && i.push({ literal: o || /^\s+$/.test(r), val: r }), n = null, r = "", o = !o) : o || l === n ? r += l : (r.length > 0 && i.push({ literal: /^\s+$/.test(r), val: r }), r = l, n = l);
    }
    return r.length > 0 && i.push({ literal: o || /^\s+$/.test(r), val: r }), i;
  }
  static macroTokenToFormatOpts(e) {
    return IE[e];
  }
  constructor(e, n) {
    this.opts = n, this.loc = e, this.systemLoc = null;
  }
  formatWithSystemDefault(e, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(e, { ...this.opts, ...n }).format();
  }
  formatDateTime(e, n = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...n }).format();
  }
  formatDateTimeParts(e, n = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...n }).formatToParts();
  }
  formatInterval(e, n = {}) {
    return this.loc.dtFormatter(e.start, { ...this.opts, ...n }).dtf.formatRange(e.start.toJSDate(), e.end.toJSDate());
  }
  resolvedOptions(e, n = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...n }).resolvedOptions();
  }
  num(e, n = 0) {
    if (this.opts.forceSimple)
      return Bt(e, n);
    const r = { ...this.opts };
    return n > 0 && (r.padTo = n), this.loc.numberFormatter(r).format(e);
  }
  formatDateTimeFromString(e, n) {
    const r = this.loc.listingMode() === "en", o = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", i = (h, p) => this.loc.extract(e, h, p), s = (h) => e.isOffsetFixed && e.offset === 0 && h.allowZ ? "Z" : e.isValid ? e.zone.formatOffset(e.ts, h.format) : "", l = () => r ? vE(e) : i({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), a = (h, p) => r ? EE(e, h) : i(p ? { month: h } : { month: h, day: "numeric" }, "month"), c = (h, p) => r ? xE(e, h) : i(
      p ? { weekday: h } : { weekday: h, month: "long", day: "numeric" },
      "weekday"
    ), d = (h) => {
      const p = rn.macroTokenToFormatOpts(h);
      return p ? this.formatWithSystemDefault(e, p) : h;
    }, u = (h) => r ? kE(e, h) : i({ era: h }, "era"), f = (h) => {
      switch (h) {
        // ms
        case "S":
          return this.num(e.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(e.millisecond, 3);
        // seconds
        case "s":
          return this.num(e.second);
        case "ss":
          return this.num(e.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(e.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(e.millisecond / 100));
        // minutes
        case "m":
          return this.num(e.minute);
        case "mm":
          return this.num(e.minute, 2);
        // hours
        case "h":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12);
        case "hh":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12, 2);
        case "H":
          return this.num(e.hour);
        case "HH":
          return this.num(e.hour, 2);
        // offset
        case "Z":
          return s({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return s({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return s({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return e.zone.offsetName(e.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return e.zone.offsetName(e.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return e.zoneName;
        // meridiems
        case "a":
          return l();
        // dates
        case "d":
          return o ? i({ day: "numeric" }, "day") : this.num(e.day);
        case "dd":
          return o ? i({ day: "2-digit" }, "day") : this.num(e.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(e.weekday);
        case "ccc":
          return c("short", !0);
        case "cccc":
          return c("long", !0);
        case "ccccc":
          return c("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(e.weekday);
        case "EEE":
          return c("short", !1);
        case "EEEE":
          return c("long", !1);
        case "EEEEE":
          return c("narrow", !1);
        // months - standalone
        case "L":
          return o ? i({ month: "numeric", day: "numeric" }, "month") : this.num(e.month);
        case "LL":
          return o ? i({ month: "2-digit", day: "numeric" }, "month") : this.num(e.month, 2);
        case "LLL":
          return a("short", !0);
        case "LLLL":
          return a("long", !0);
        case "LLLLL":
          return a("narrow", !0);
        // months - format
        case "M":
          return o ? i({ month: "numeric" }, "month") : this.num(e.month);
        case "MM":
          return o ? i({ month: "2-digit" }, "month") : this.num(e.month, 2);
        case "MMM":
          return a("short", !1);
        case "MMMM":
          return a("long", !1);
        case "MMMMM":
          return a("narrow", !1);
        // years
        case "y":
          return o ? i({ year: "numeric" }, "year") : this.num(e.year);
        case "yy":
          return o ? i({ year: "2-digit" }, "year") : this.num(e.year.toString().slice(-2), 2);
        case "yyyy":
          return o ? i({ year: "numeric" }, "year") : this.num(e.year, 4);
        case "yyyyyy":
          return o ? i({ year: "numeric" }, "year") : this.num(e.year, 6);
        // eras
        case "G":
          return u("short");
        case "GG":
          return u("long");
        case "GGGGG":
          return u("narrow");
        case "kk":
          return this.num(e.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(e.weekYear, 4);
        case "W":
          return this.num(e.weekNumber);
        case "WW":
          return this.num(e.weekNumber, 2);
        case "o":
          return this.num(e.ordinal);
        case "ooo":
          return this.num(e.ordinal, 3);
        case "q":
          return this.num(e.quarter);
        case "qq":
          return this.num(e.quarter, 2);
        case "X":
          return this.num(Math.floor(e.ts / 1e3));
        case "x":
          return this.num(e.ts);
        default:
          return d(h);
      }
    };
    return jh(rn.parseFormat(n), f);
  }
  formatDurationFromString(e, n) {
    const r = (a) => {
      switch (a[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, o = (a) => (c) => {
      const d = r(c);
      return d ? this.num(a.get(d), c.length) : c;
    }, i = rn.parseFormat(n), s = i.reduce(
      (a, { literal: c, val: d }) => c ? a : a.concat(d),
      []
    ), l = e.shiftTo(...s.map(r).filter((a) => a));
    return jh(i, o(l));
  }
}
class er {
  constructor(e, n) {
    this.reason = e, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const f0 = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function Fi(...t) {
  const e = t.reduce((n, r) => n + r.source, "");
  return RegExp(`^${e}$`);
}
function Ni(...t) {
  return (e) => t.reduce(
    ([n, r, o], i) => {
      const [s, l, a] = i(e, o);
      return [{ ...n, ...s }, l || r, a];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function zi(t, ...e) {
  if (t == null)
    return [null, null];
  for (const [n, r] of e) {
    const o = n.exec(t);
    if (o)
      return r(o);
  }
  return [null, null];
}
function h0(...t) {
  return (e, n) => {
    const r = {};
    let o;
    for (o = 0; o < t.length; o++)
      r[t[o]] = Kr(e[n + o]);
    return [r, null, n + o];
  };
}
const p0 = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, ME = `(?:${p0.source}?(?:\\[(${f0.source})\\])?)?`, df = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, g0 = RegExp(`${df.source}${ME}`), uf = RegExp(`(?:T${g0.source})?`), RE = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, OE = /(\d{4})-?W(\d\d)(?:-?(\d))?/, DE = /(\d{4})-?(\d{3})/, AE = h0("weekYear", "weekNumber", "weekDay"), LE = h0("year", "ordinal"), $E = /(\d{4})-(\d\d)-(\d\d)/, m0 = RegExp(
  `${df.source} ?(?:${p0.source}|(${f0.source}))?`
), PE = RegExp(`(?: ${m0.source})?`);
function bi(t, e, n) {
  const r = t[e];
  return He(r) ? n : Kr(r);
}
function _E(t, e) {
  return [{
    year: bi(t, e),
    month: bi(t, e + 1, 1),
    day: bi(t, e + 2, 1)
  }, null, e + 3];
}
function Hi(t, e) {
  return [{
    hours: bi(t, e, 0),
    minutes: bi(t, e + 1, 0),
    seconds: bi(t, e + 2, 0),
    milliseconds: lf(t[e + 3])
  }, null, e + 4];
}
function rl(t, e) {
  const n = !t[e] && !t[e + 1], r = pc(t[e + 1], t[e + 2]), o = n ? null : hn.instance(r);
  return [{}, o, e + 3];
}
function ol(t, e) {
  const n = t[e] ? Br.create(t[e]) : null;
  return [{}, n, e + 1];
}
const BE = RegExp(`^T?${df.source}$`), VE = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function FE(t) {
  const [e, n, r, o, i, s, l, a, c] = t, d = e[0] === "-", u = a && a[0] === "-", f = (h, p = !1) => h !== void 0 && (p || h && d) ? -h : h;
  return [
    {
      years: f(ko(n)),
      months: f(ko(r)),
      weeks: f(ko(o)),
      days: f(ko(i)),
      hours: f(ko(s)),
      minutes: f(ko(l)),
      seconds: f(ko(a), a === "-0"),
      milliseconds: f(lf(c), u)
    }
  ];
}
const NE = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function ff(t, e, n, r, o, i, s) {
  const l = {
    year: e.length === 2 ? tu(Kr(e)) : Kr(e),
    month: i0.indexOf(n) + 1,
    day: Kr(r),
    hour: Kr(o),
    minute: Kr(i)
  };
  return s && (l.second = Kr(s)), t && (l.weekday = t.length > 3 ? l0.indexOf(t) + 1 : a0.indexOf(t) + 1), l;
}
const zE = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function HE(t) {
  const [
    ,
    e,
    n,
    r,
    o,
    i,
    s,
    l,
    a,
    c,
    d,
    u
  ] = t, f = ff(e, o, r, n, i, s, l);
  let h;
  return a ? h = NE[a] : c ? h = 0 : h = pc(d, u), [f, new hn(h)];
}
function jE(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const WE = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, GE = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, UE = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function Wh(t) {
  const [, e, n, r, o, i, s, l] = t;
  return [ff(e, o, r, n, i, s, l), hn.utcInstance];
}
function qE(t) {
  const [, e, n, r, o, i, s, l] = t;
  return [ff(e, l, n, r, o, i, s), hn.utcInstance];
}
const JE = Fi(RE, uf), KE = Fi(OE, uf), YE = Fi(DE, uf), ZE = Fi(g0), y0 = Ni(
  _E,
  Hi,
  rl,
  ol
), XE = Ni(
  AE,
  Hi,
  rl,
  ol
), QE = Ni(
  LE,
  Hi,
  rl,
  ol
), ek = Ni(
  Hi,
  rl,
  ol
);
function tk(t) {
  return zi(
    t,
    [JE, y0],
    [KE, XE],
    [YE, QE],
    [ZE, ek]
  );
}
function nk(t) {
  return zi(jE(t), [zE, HE]);
}
function rk(t) {
  return zi(
    t,
    [WE, Wh],
    [GE, Wh],
    [UE, qE]
  );
}
function ok(t) {
  return zi(t, [VE, FE]);
}
const ik = Ni(Hi);
function sk(t) {
  return zi(t, [BE, ik]);
}
const lk = Fi($E, PE), ak = Fi(m0), ck = Ni(
  Hi,
  rl,
  ol
);
function dk(t) {
  return zi(
    t,
    [lk, y0],
    [ak, ck]
  );
}
const uk = "Invalid Duration", b0 = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, fk = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...b0
}, $n = 146097 / 400, oi = 146097 / 4800, hk = {
  years: {
    quarters: 4,
    months: 12,
    weeks: $n / 7,
    days: $n,
    hours: $n * 24,
    minutes: $n * 24 * 60,
    seconds: $n * 24 * 60 * 60,
    milliseconds: $n * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: $n / 28,
    days: $n / 4,
    hours: $n * 24 / 4,
    minutes: $n * 24 * 60 / 4,
    seconds: $n * 24 * 60 * 60 / 4,
    milliseconds: $n * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: oi / 7,
    days: oi,
    hours: oi * 24,
    minutes: oi * 24 * 60,
    seconds: oi * 24 * 60 * 60,
    milliseconds: oi * 24 * 60 * 60 * 1e3
  },
  ...b0
}, To = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], pk = To.slice(0).reverse();
function Ur(t, e, n = !1) {
  const r = {
    values: n ? e.values : { ...t.values, ...e.values || {} },
    loc: t.loc.clone(e.loc),
    conversionAccuracy: e.conversionAccuracy || t.conversionAccuracy,
    matrix: e.matrix || t.matrix
  };
  return new We(r);
}
function gk(t) {
  return t < 0 ? Math.floor(t) : Math.ceil(t);
}
function w0(t, e, n, r, o) {
  const i = t[o][n], s = e[n] / i, l = Math.sign(s) === Math.sign(r[o]), a = !l && r[o] !== 0 && Math.abs(s) <= 1 ? gk(s) : Math.trunc(s);
  r[o] += a, e[n] -= a * i;
}
function mk(t, e) {
  pk.reduce((n, r) => He(e[r]) ? n : (n && w0(t, e, n, e, r), r), null);
}
function yk(t) {
  const e = {};
  for (const [n, r] of Object.entries(t))
    r !== 0 && (e[n] = r);
  return e;
}
class We {
  /**
   * @private
   */
  constructor(e) {
    const n = e.conversionAccuracy === "longterm" || !1;
    let r = n ? hk : fk;
    e.matrix && (r = e.matrix), this.values = e.values, this.loc = e.loc || ft.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = e.invalid || null, this.matrix = r, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(e, n) {
    return We.fromObject({ milliseconds: e }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(e, n = {}) {
    if (e == null || typeof e != "object")
      throw new Vn(
        `Duration.fromObject: argument expected to be an object, got ${e === null ? "null" : typeof e}`
      );
    return new We({
      values: ua(e, We.normalizeUnit),
      loc: ft.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(e) {
    if ($o(e))
      return We.fromMillis(e);
    if (We.isDuration(e))
      return e;
    if (typeof e == "object")
      return We.fromObject(e);
    throw new Vn(
      `Unknown duration argument ${e} of type ${typeof e}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(e, n) {
    const [r] = ok(e);
    return r ? We.fromObject(r, n) : We.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(e, n) {
    const [r] = sk(e);
    return r ? We.fromObject(r, n) : We.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new Vn("need to specify a reason the Duration is invalid");
    const r = e instanceof er ? e : new er(e, n);
    if (_t.throwOnInvalid)
      throw new Gx(r);
    return new We({ invalid: r });
  }
  /**
   * @private
   */
  static normalizeUnit(e) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[e && e.toLowerCase()];
    if (!n) throw new _y(e);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(e) {
    return e && e.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(e, n = {}) {
    const r = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? rn.create(this.loc, r).formatDurationFromString(this, e) : uk;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(e = {}) {
    const n = To.map((r) => {
      const o = this.values[r];
      return He(o) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...e, unit: r.slice(0, -1) }).format(o);
    }).filter((r) => r);
    return this.loc.listFormatter({ type: "conjunction", style: e.listStyle || "narrow", ...e }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let e = "P";
    return this.years !== 0 && (e += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (e += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (e += this.weeks + "W"), this.days !== 0 && (e += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (e += "T"), this.hours !== 0 && (e += this.hours + "H"), this.minutes !== 0 && (e += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (e += af(this.seconds + this.milliseconds / 1e3, 3) + "S"), e === "P" && (e += "T0S"), e;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(e = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    if (n < 0 || n >= 864e5) return null;
    e = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...e
    };
    const r = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
    let o = e.format === "basic" ? "hhmm" : "hh:mm";
    (!e.suppressSeconds || r.seconds !== 0 || r.milliseconds !== 0) && (o += e.format === "basic" ? "ss" : ":ss", (!e.suppressMilliseconds || r.milliseconds !== 0) && (o += ".SSS"));
    let i = r.toFormat(o);
    return e.includePrefix && (i = "T" + i), i;
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.as("milliseconds");
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = We.fromDurationLike(e), r = {};
    for (const o of To)
      (Ii(n.values, o) || Ii(this.values, o)) && (r[o] = n.get(o) + this.get(o));
    return Ur(this, { values: r }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = We.fromDurationLike(e);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(e) {
    if (!this.isValid) return this;
    const n = {};
    for (const r of Object.keys(this.values))
      n[r] = o0(e(this.values[r], r));
    return Ur(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(e) {
    return this[We.normalizeUnit(e)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = { ...this.values, ...ua(e, We.normalizeUnit) };
    return Ur(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: e, numberingSystem: n, conversionAccuracy: r, matrix: o } = {}) {
    const s = { loc: this.loc.clone({ locale: e, numberingSystem: n }), matrix: o, conversionAccuracy: r };
    return Ur(this, s);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(e) {
    return this.isValid ? this.shiftTo(e).get(e) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const e = this.toObject();
    return mk(this.matrix, e), Ur(this, { values: e }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const e = yk(this.normalize().shiftToAll().toObject());
    return Ur(this, { values: e }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...e) {
    if (!this.isValid) return this;
    if (e.length === 0)
      return this;
    e = e.map((s) => We.normalizeUnit(s));
    const n = {}, r = {}, o = this.toObject();
    let i;
    for (const s of To)
      if (e.indexOf(s) >= 0) {
        i = s;
        let l = 0;
        for (const c in r)
          l += this.matrix[c][s] * r[c], r[c] = 0;
        $o(o[s]) && (l += o[s]);
        const a = Math.trunc(l);
        n[s] = a, r[s] = (l * 1e3 - a * 1e3) / 1e3;
        for (const c in o)
          To.indexOf(c) > To.indexOf(s) && w0(this.matrix, o, c, n, s);
      } else $o(o[s]) && (r[s] = o[s]);
    for (const s in r)
      r[s] !== 0 && (n[i] += s === i ? r[s] : r[s] / this.matrix[i][s]);
    return Ur(this, { values: n }, !0).normalize();
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const e = {};
    for (const n of Object.keys(this.values))
      e[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return Ur(this, { values: e }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(e) {
    if (!this.isValid || !e.isValid || !this.loc.equals(e.loc))
      return !1;
    function n(r, o) {
      return r === void 0 || r === 0 ? o === void 0 || o === 0 : r === o;
    }
    for (const r of To)
      if (!n(this.values[r], e.values[r]))
        return !1;
    return !0;
  }
}
const ii = "Invalid Interval";
function bk(t, e) {
  return !t || !t.isValid ? xt.invalid("missing or invalid start") : !e || !e.isValid ? xt.invalid("missing or invalid end") : e < t ? xt.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${t.toISO()} and end=${e.toISO()}`
  ) : null;
}
class xt {
  /**
   * @private
   */
  constructor(e) {
    this.s = e.start, this.e = e.end, this.invalid = e.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new Vn("need to specify a reason the Interval is invalid");
    const r = e instanceof er ? e : new er(e, n);
    if (_t.throwOnInvalid)
      throw new Wx(r);
    return new xt({ invalid: r });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(e, n) {
    const r = Zi(e), o = Zi(n), i = bk(r, o);
    return i ?? new xt({
      start: r,
      end: o
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(e, n) {
    const r = We.fromDurationLike(n), o = Zi(e);
    return xt.fromDateTimes(o, o.plus(r));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(e, n) {
    const r = We.fromDurationLike(n), o = Zi(e);
    return xt.fromDateTimes(o.minus(r), o);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(e, n) {
    const [r, o] = (e || "").split("/", 2);
    if (r && o) {
      let i, s;
      try {
        i = _.fromISO(r, n), s = i.isValid;
      } catch {
        s = !1;
      }
      let l, a;
      try {
        l = _.fromISO(o, n), a = l.isValid;
      } catch {
        a = !1;
      }
      if (s && a)
        return xt.fromDateTimes(i, l);
      if (s) {
        const c = We.fromISO(o, n);
        if (c.isValid)
          return xt.after(i, c);
      } else if (a) {
        const c = We.fromISO(r, n);
        if (c.isValid)
          return xt.before(l, c);
      }
    }
    return xt.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(e) {
    return e && e.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(e = "milliseconds") {
    return this.isValid ? this.toDuration(e).get(e) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  count(e = "milliseconds") {
    if (!this.isValid) return NaN;
    const n = this.start.startOf(e), r = this.end.startOf(e);
    return Math.floor(r.diff(n, e).get(e)) + (r.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(e) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, e) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(e) {
    return this.isValid ? this.s > e : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(e) {
    return this.isValid ? this.e <= e : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(e) {
    return this.isValid ? this.s <= e && this.e > e : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: e, end: n } = {}) {
    return this.isValid ? xt.fromDateTimes(e || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...e) {
    if (!this.isValid) return [];
    const n = e.map(Zi).filter((s) => this.contains(s)).sort(), r = [];
    let { s: o } = this, i = 0;
    for (; o < this.e; ) {
      const s = n[i] || this.e, l = +s > +this.e ? this.e : s;
      r.push(xt.fromDateTimes(o, l)), o = l, i += 1;
    }
    return r;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(e) {
    const n = We.fromDurationLike(e);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: r } = this, o = 1, i;
    const s = [];
    for (; r < this.e; ) {
      const l = this.start.plus(n.mapUnits((a) => a * o));
      i = +l > +this.e ? this.e : l, s.push(xt.fromDateTimes(r, i)), r = i, o += 1;
    }
    return s;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(e) {
    return this.isValid ? this.splitBy(this.length() / e).slice(0, e) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(e) {
    return this.e > e.s && this.s < e.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(e) {
    return this.isValid ? +this.e == +e.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(e) {
    return this.isValid ? +e.e == +this.s : !1;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(e) {
    return this.isValid ? this.s <= e.s && this.e >= e.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(e) {
    return !this.isValid || !e.isValid ? !1 : this.s.equals(e.s) && this.e.equals(e.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(e) {
    if (!this.isValid) return this;
    const n = this.s > e.s ? this.s : e.s, r = this.e < e.e ? this.e : e.e;
    return n >= r ? null : xt.fromDateTimes(n, r);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(e) {
    if (!this.isValid) return this;
    const n = this.s < e.s ? this.s : e.s, r = this.e > e.e ? this.e : e.e;
    return xt.fromDateTimes(n, r);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(e) {
    const [n, r] = e.sort((o, i) => o.s - i.s).reduce(
      ([o, i], s) => i ? i.overlaps(s) || i.abutsStart(s) ? [o, i.union(s)] : [o.concat([i]), s] : [o, s],
      [[], null]
    );
    return r && n.push(r), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(e) {
    let n = null, r = 0;
    const o = [], i = e.map((a) => [
      { time: a.s, type: "s" },
      { time: a.e, type: "e" }
    ]), s = Array.prototype.concat(...i), l = s.sort((a, c) => a.time - c.time);
    for (const a of l)
      r += a.type === "s" ? 1 : -1, r === 1 ? n = a.time : (n && +n != +a.time && o.push(xt.fromDateTimes(n, a.time)), n = null);
    return xt.merge(o);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...e) {
    return xt.xor([this].concat(e)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : ii;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(e = aa, n = {}) {
    return this.isValid ? rn.create(this.s.loc.clone(n), e).formatInterval(this) : ii;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(e) {
    return this.isValid ? `${this.s.toISO(e)}/${this.e.toISO(e)}` : ii;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : ii;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(e) {
    return this.isValid ? `${this.s.toISOTime(e)}/${this.e.toISOTime(e)}` : ii;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(e, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(e)}${n}${this.e.toFormat(e)}` : ii;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(e, n) {
    return this.isValid ? this.e.diff(this.s, e, n) : We.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(e) {
    return xt.fromDateTimes(e(this.s), e(this.e));
  }
}
let ds = class {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(e = _t.defaultZone) {
    const n = _.now().setZone(e).set({ month: 12 });
    return !e.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(e) {
    return Br.isValidZone(e);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(e) {
    return eo(e, _t.defaultZone);
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(e = "long", { locale: n = null, numberingSystem: r = null, locObj: o = null, outputCalendar: i = "gregory" } = {}) {
    return (o || ft.create(n, r, i)).months(e);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(e = "long", { locale: n = null, numberingSystem: r = null, locObj: o = null, outputCalendar: i = "gregory" } = {}) {
    return (o || ft.create(n, r, i)).months(e, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(e = "long", { locale: n = null, numberingSystem: r = null, locObj: o = null } = {}) {
    return (o || ft.create(n, r, null)).weekdays(e);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(e = "long", { locale: n = null, numberingSystem: r = null, locObj: o = null } = {}) {
    return (o || ft.create(n, r, null)).weekdays(e, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: e = null } = {}) {
    return ft.create(e).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(e = "short", { locale: n = null } = {}) {
    return ft.create(n, null, "gregory").eras(e);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */
  static features() {
    return { relative: n0() };
  }
};
function Gh(t, e) {
  const n = (o) => o.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), r = n(e) - n(t);
  return Math.floor(We.fromMillis(r).as("days"));
}
function wk(t, e, n) {
  const r = [
    ["years", (a, c) => c.year - a.year],
    ["quarters", (a, c) => c.quarter - a.quarter + (c.year - a.year) * 4],
    ["months", (a, c) => c.month - a.month + (c.year - a.year) * 12],
    [
      "weeks",
      (a, c) => {
        const d = Gh(a, c);
        return (d - d % 7) / 7;
      }
    ],
    ["days", Gh]
  ], o = {}, i = t;
  let s, l;
  for (const [a, c] of r)
    n.indexOf(a) >= 0 && (s = a, o[a] = c(t, e), l = i.plus(o), l > e ? (o[a]--, t = i.plus(o)) : t = l);
  return [t, o, l, s];
}
function Sk(t, e, n, r) {
  let [o, i, s, l] = wk(t, e, n);
  const a = e - o, c = n.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );
  c.length === 0 && (s < e && (s = o.plus({ [l]: 1 })), s !== o && (i[l] = (i[l] || 0) + a / (s - o)));
  const d = We.fromObject(i, r);
  return c.length > 0 ? We.fromMillis(a, r).shiftTo(...c).plus(d) : d;
}
const hf = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, Uh = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, Ck = hf.hanidec.replace(/[\[|\]]/g, "").split("");
function vk(t) {
  let e = parseInt(t, 10);
  if (isNaN(e)) {
    e = "";
    for (let n = 0; n < t.length; n++) {
      const r = t.charCodeAt(n);
      if (t[n].search(hf.hanidec) !== -1)
        e += Ck.indexOf(t[n]);
      else
        for (const o in Uh) {
          const [i, s] = Uh[o];
          r >= i && r <= s && (e += r - i);
        }
    }
    return parseInt(e, 10);
  } else
    return e;
}
function Yn({ numberingSystem: t }, e = "") {
  return new RegExp(`${hf[t || "latn"]}${e}`);
}
const xk = "missing Intl.DateTimeFormat.formatToParts support";
function Ke(t, e = (n) => n) {
  return { regex: t, deser: ([n]) => e(vk(n)) };
}
const Ek = " ", S0 = `[ ${Ek}]`, C0 = new RegExp(S0, "g");
function kk(t) {
  return t.replace(/\./g, "\\.?").replace(C0, S0);
}
function qh(t) {
  return t.replace(/\./g, "").replace(C0, " ").toLowerCase();
}
function Zn(t, e) {
  return t === null ? null : {
    regex: RegExp(t.map(kk).join("|")),
    deser: ([n]) => t.findIndex((r) => qh(n) === qh(r)) + e
  };
}
function Jh(t, e) {
  return { regex: t, deser: ([, n, r]) => pc(n, r), groups: e };
}
function yl(t) {
  return { regex: t, deser: ([e]) => e };
}
function Tk(t) {
  return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function Ik(t, e) {
  const n = Yn(e), r = Yn(e, "{2}"), o = Yn(e, "{3}"), i = Yn(e, "{4}"), s = Yn(e, "{6}"), l = Yn(e, "{1,2}"), a = Yn(e, "{1,3}"), c = Yn(e, "{1,6}"), d = Yn(e, "{1,9}"), u = Yn(e, "{2,4}"), f = Yn(e, "{4,6}"), h = (b) => ({ regex: RegExp(Tk(b.val)), deser: ([w]) => w, literal: !0 }), y = ((b) => {
    if (t.literal)
      return h(b);
    switch (b.val) {
      // era
      case "G":
        return Zn(e.eras("short", !1), 0);
      case "GG":
        return Zn(e.eras("long", !1), 0);
      // years
      case "y":
        return Ke(c);
      case "yy":
        return Ke(u, tu);
      case "yyyy":
        return Ke(i);
      case "yyyyy":
        return Ke(f);
      case "yyyyyy":
        return Ke(s);
      // months
      case "M":
        return Ke(l);
      case "MM":
        return Ke(r);
      case "MMM":
        return Zn(e.months("short", !0, !1), 1);
      case "MMMM":
        return Zn(e.months("long", !0, !1), 1);
      case "L":
        return Ke(l);
      case "LL":
        return Ke(r);
      case "LLL":
        return Zn(e.months("short", !1, !1), 1);
      case "LLLL":
        return Zn(e.months("long", !1, !1), 1);
      // dates
      case "d":
        return Ke(l);
      case "dd":
        return Ke(r);
      // ordinals
      case "o":
        return Ke(a);
      case "ooo":
        return Ke(o);
      // time
      case "HH":
        return Ke(r);
      case "H":
        return Ke(l);
      case "hh":
        return Ke(r);
      case "h":
        return Ke(l);
      case "mm":
        return Ke(r);
      case "m":
        return Ke(l);
      case "q":
        return Ke(l);
      case "qq":
        return Ke(r);
      case "s":
        return Ke(l);
      case "ss":
        return Ke(r);
      case "S":
        return Ke(a);
      case "SSS":
        return Ke(o);
      case "u":
        return yl(d);
      case "uu":
        return yl(l);
      case "uuu":
        return Ke(n);
      // meridiem
      case "a":
        return Zn(e.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return Ke(i);
      case "kk":
        return Ke(u, tu);
      // weekNumber (W)
      case "W":
        return Ke(l);
      case "WW":
        return Ke(r);
      // weekdays
      case "E":
      case "c":
        return Ke(n);
      case "EEE":
        return Zn(e.weekdays("short", !1, !1), 1);
      case "EEEE":
        return Zn(e.weekdays("long", !1, !1), 1);
      case "ccc":
        return Zn(e.weekdays("short", !0, !1), 1);
      case "cccc":
        return Zn(e.weekdays("long", !0, !1), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return Jh(new RegExp(`([+-]${l.source})(?::(${r.source}))?`), 2);
      case "ZZZ":
        return Jh(new RegExp(`([+-]${l.source})(${r.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return yl(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return yl(/[^\S\n\r]/);
      default:
        return h(b);
    }
  })(t) || {
    invalidReason: xk
  };
  return y.token = t, y;
}
const Mk = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function Rk(t, e) {
  const { type: n, value: r } = t;
  if (n === "literal") {
    const s = /^\s+$/.test(r);
    return {
      literal: !s,
      val: s ? " " : r
    };
  }
  const o = e[n];
  let i = Mk[n];
  if (typeof i == "object" && (i = i[o]), i)
    return {
      literal: !1,
      val: i
    };
}
function Ok(t) {
  return [`^${t.map((n) => n.regex).reduce((n, r) => `${n}(${r.source})`, "")}$`, t];
}
function Dk(t, e, n) {
  const r = t.match(e);
  if (r) {
    const o = {};
    let i = 1;
    for (const s in n)
      if (Ii(n, s)) {
        const l = n[s], a = l.groups ? l.groups + 1 : 1;
        !l.literal && l.token && (o[l.token.val[0]] = l.deser(r.slice(i, i + a))), i += a;
      }
    return [r, o];
  } else
    return [r, {}];
}
function Ak(t) {
  const e = (i) => {
    switch (i) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, r;
  return He(t.z) || (n = Br.create(t.z)), He(t.Z) || (n || (n = new hn(t.Z)), r = t.Z), He(t.q) || (t.M = (t.q - 1) * 3 + 1), He(t.h) || (t.h < 12 && t.a === 1 ? t.h += 12 : t.h === 12 && t.a === 0 && (t.h = 0)), t.G === 0 && t.y && (t.y = -t.y), He(t.u) || (t.S = lf(t.u)), [Object.keys(t).reduce((i, s) => {
    const l = e(s);
    return l && (i[l] = t[s]), i;
  }, {}), n, r];
}
let jc = null;
function Lk() {
  return jc || (jc = _.fromMillis(1555555555555)), jc;
}
function $k(t, e) {
  if (t.literal)
    return t;
  const n = rn.macroTokenToFormatOpts(t.val), r = E0(n, e);
  return r == null || r.includes(void 0) ? t : r;
}
function v0(t, e) {
  return Array.prototype.concat(...t.map((n) => $k(n, e)));
}
function x0(t, e, n) {
  const r = v0(rn.parseFormat(n), t), o = r.map((s) => Ik(s, t)), i = o.find((s) => s.invalidReason);
  if (i)
    return { input: e, tokens: r, invalidReason: i.invalidReason };
  {
    const [s, l] = Ok(o), a = RegExp(s, "i"), [c, d] = Dk(e, a, l), [u, f, h] = d ? Ak(d) : [null, null, void 0];
    if (Ii(d, "a") && Ii(d, "H"))
      throw new as(
        "Can't include meridiem when specifying 24-hour format"
      );
    return { input: e, tokens: r, regex: a, rawMatches: c, matches: d, result: u, zone: f, specificOffset: h };
  }
}
function Pk(t, e, n) {
  const { result: r, zone: o, specificOffset: i, invalidReason: s } = x0(t, e, n);
  return [r, o, i, s];
}
function E0(t, e) {
  return t ? rn.create(e, t).formatDateTimeParts(Lk()).map((o) => Rk(o, t)) : null;
}
const k0 = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], T0 = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function zn(t, e) {
  return new er(
    "unit out of range",
    `you specified ${e} (of type ${typeof e}) as a ${t}, which is invalid`
  );
}
function I0(t, e, n) {
  const r = new Date(Date.UTC(t, e - 1, n));
  t < 100 && t >= 0 && r.setUTCFullYear(r.getUTCFullYear() - 1900);
  const o = r.getUTCDay();
  return o === 0 ? 7 : o;
}
function M0(t, e, n) {
  return n + (nl(t) ? T0 : k0)[e - 1];
}
function R0(t, e) {
  const n = nl(t) ? T0 : k0, r = n.findIndex((i) => i < e), o = e - n[r];
  return { month: r + 1, day: o };
}
function nu(t) {
  const { year: e, month: n, day: r } = t, o = M0(e, n, r), i = I0(e, n, r);
  let s = Math.floor((o - i + 10) / 7), l;
  return s < 1 ? (l = e - 1, s = da(l)) : s > da(e) ? (l = e + 1, s = 1) : l = e, { weekYear: l, weekNumber: s, weekday: i, ...gc(t) };
}
function Kh(t) {
  const { weekYear: e, weekNumber: n, weekday: r } = t, o = I0(e, 1, 4), i = bs(e);
  let s = n * 7 + r - o - 3, l;
  s < 1 ? (l = e - 1, s += bs(l)) : s > i ? (l = e + 1, s -= bs(e)) : l = e;
  const { month: a, day: c } = R0(l, s);
  return { year: l, month: a, day: c, ...gc(t) };
}
function Wc(t) {
  const { year: e, month: n, day: r } = t, o = M0(e, n, r);
  return { year: e, ordinal: o, ...gc(t) };
}
function Yh(t) {
  const { year: e, ordinal: n } = t, { month: r, day: o } = R0(e, n);
  return { year: e, month: r, day: o, ...gc(t) };
}
function _k(t) {
  const e = hc(t.weekYear), n = Ar(t.weekNumber, 1, da(t.weekYear)), r = Ar(t.weekday, 1, 7);
  return e ? n ? r ? !1 : zn("weekday", t.weekday) : zn("week", t.week) : zn("weekYear", t.weekYear);
}
function Bk(t) {
  const e = hc(t.year), n = Ar(t.ordinal, 1, bs(t.year));
  return e ? n ? !1 : zn("ordinal", t.ordinal) : zn("year", t.year);
}
function O0(t) {
  const e = hc(t.year), n = Ar(t.month, 1, 12), r = Ar(t.day, 1, ca(t.year, t.month));
  return e ? n ? r ? !1 : zn("day", t.day) : zn("month", t.month) : zn("year", t.year);
}
function D0(t) {
  const { hour: e, minute: n, second: r, millisecond: o } = t, i = Ar(e, 0, 23) || e === 24 && n === 0 && r === 0 && o === 0, s = Ar(n, 0, 59), l = Ar(r, 0, 59), a = Ar(o, 0, 999);
  return i ? s ? l ? a ? !1 : zn("millisecond", o) : zn("second", r) : zn("minute", n) : zn("hour", e);
}
const Gc = "Invalid DateTime", Vk = 864e13;
function bl(t) {
  return new er("unsupported zone", `the zone "${t.name}" is not supported`);
}
function Uc(t) {
  return t.weekData === null && (t.weekData = nu(t.c)), t.weekData;
}
function Ki(t, e) {
  const n = {
    ts: t.ts,
    zone: t.zone,
    c: t.c,
    o: t.o,
    loc: t.loc,
    invalid: t.invalid
  };
  return new _({ ...n, ...e, old: n });
}
function A0(t, e, n) {
  let r = t - e * 60 * 1e3;
  const o = n.offset(r);
  if (e === o)
    return [r, e];
  r -= (o - e) * 60 * 1e3;
  const i = n.offset(r);
  return o === i ? [r, o] : [t - Math.min(o, i) * 60 * 1e3, Math.max(o, i)];
}
function Zh(t, e) {
  t += e * 60 * 1e3;
  const n = new Date(t);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function Wl(t, e, n) {
  return A0(cf(t), e, n);
}
function Xh(t, e) {
  const n = t.o, r = t.c.year + Math.trunc(e.years), o = t.c.month + Math.trunc(e.months) + Math.trunc(e.quarters) * 3, i = {
    ...t.c,
    year: r,
    month: o,
    day: Math.min(t.c.day, ca(r, o)) + Math.trunc(e.days) + Math.trunc(e.weeks) * 7
  }, s = We.fromObject({
    years: e.years - Math.trunc(e.years),
    quarters: e.quarters - Math.trunc(e.quarters),
    months: e.months - Math.trunc(e.months),
    weeks: e.weeks - Math.trunc(e.weeks),
    days: e.days - Math.trunc(e.days),
    hours: e.hours,
    minutes: e.minutes,
    seconds: e.seconds,
    milliseconds: e.milliseconds
  }).as("milliseconds"), l = cf(i);
  let [a, c] = A0(l, n, t.zone);
  return s !== 0 && (a += s, c = t.zone.offset(a)), { ts: a, o: c };
}
function Yi(t, e, n, r, o, i) {
  const { setZone: s, zone: l } = n;
  if (t && Object.keys(t).length !== 0 || e) {
    const a = e || l, c = _.fromObject(t, {
      ...n,
      zone: a,
      specificOffset: i
    });
    return s ? c : c.setZone(l);
  } else
    return _.invalid(
      new er("unparsable", `the input "${o}" can't be parsed as ${r}`)
    );
}
function wl(t, e, n = !0) {
  return t.isValid ? rn.create(ft.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(t, e) : null;
}
function qc(t, e) {
  const n = t.c.year > 9999 || t.c.year < 0;
  let r = "";
  return n && t.c.year >= 0 && (r += "+"), r += Bt(t.c.year, n ? 6 : 4), e ? (r += "-", r += Bt(t.c.month), r += "-", r += Bt(t.c.day)) : (r += Bt(t.c.month), r += Bt(t.c.day)), r;
}
function Qh(t, e, n, r, o, i) {
  let s = Bt(t.c.hour);
  return e ? (s += ":", s += Bt(t.c.minute), (t.c.second !== 0 || !n) && (s += ":")) : s += Bt(t.c.minute), (t.c.second !== 0 || !n) && (s += Bt(t.c.second), (t.c.millisecond !== 0 || !r) && (s += ".", s += Bt(t.c.millisecond, 3))), o && (t.isOffsetFixed && t.offset === 0 && !i ? s += "Z" : t.o < 0 ? (s += "-", s += Bt(Math.trunc(-t.o / 60)), s += ":", s += Bt(Math.trunc(-t.o % 60))) : (s += "+", s += Bt(Math.trunc(t.o / 60)), s += ":", s += Bt(Math.trunc(t.o % 60)))), i && (s += "[" + t.zone.ianaName + "]"), s;
}
const L0 = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Fk = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Nk = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, $0 = ["year", "month", "day", "hour", "minute", "second", "millisecond"], zk = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], Hk = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function ep(t) {
  const e = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[t.toLowerCase()];
  if (!e) throw new _y(t);
  return e;
}
function tp(t, e) {
  const n = eo(e.zone, _t.defaultZone), r = ft.fromObject(e), o = _t.now();
  let i, s;
  if (He(t.year))
    i = o;
  else {
    for (const c of $0)
      He(t[c]) && (t[c] = L0[c]);
    const l = O0(t) || D0(t);
    if (l)
      return _.invalid(l);
    const a = n.offset(o);
    [i, s] = Wl(t, a, n);
  }
  return new _({ ts: i, zone: n, loc: r, o: s });
}
function np(t, e, n) {
  const r = He(n.round) ? !0 : n.round, o = (s, l) => (s = af(s, r || n.calendary ? 0 : 2, !0), e.loc.clone(n).relFormatter(n).format(s, l)), i = (s) => n.calendary ? e.hasSame(t, s) ? 0 : e.startOf(s).diff(t.startOf(s), s).get(s) : e.diff(t, s).get(s);
  if (n.unit)
    return o(i(n.unit), n.unit);
  for (const s of n.units) {
    const l = i(s);
    if (Math.abs(l) >= 1)
      return o(l, s);
  }
  return o(t > e ? -0 : 0, n.units[n.units.length - 1]);
}
function rp(t) {
  let e = {}, n;
  return t.length > 0 && typeof t[t.length - 1] == "object" ? (e = t[t.length - 1], n = Array.from(t).slice(0, t.length - 1)) : n = Array.from(t), [e, n];
}
class _ {
  /**
   * @access private
   */
  constructor(e) {
    const n = e.zone || _t.defaultZone;
    let r = e.invalid || (Number.isNaN(e.ts) ? new er("invalid input") : null) || (n.isValid ? null : bl(n));
    this.ts = He(e.ts) ? _t.now() : e.ts;
    let o = null, i = null;
    if (!r)
      if (e.old && e.old.ts === this.ts && e.old.zone.equals(n))
        [o, i] = [e.old.c, e.old.o];
      else {
        const l = n.offset(this.ts);
        o = Zh(this.ts, l), r = Number.isNaN(o.year) ? new er("invalid input") : null, o = r ? null : o, i = r ? null : l;
      }
    this._zone = n, this.loc = e.loc || ft.create(), this.invalid = r, this.weekData = null, this.c = o, this.o = i, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new _({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [e, n] = rp(arguments), [r, o, i, s, l, a, c] = n;
    return tp({ year: r, month: o, day: i, hour: s, minute: l, second: a, millisecond: c }, e);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [e, n] = rp(arguments), [r, o, i, s, l, a, c] = n;
    return e.zone = hn.utcInstance, tp({ year: r, month: o, day: i, hour: s, minute: l, second: a, millisecond: c }, e);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(e, n = {}) {
    const r = fE(e) ? e.valueOf() : NaN;
    if (Number.isNaN(r))
      return _.invalid("invalid input");
    const o = eo(n.zone, _t.defaultZone);
    return o.isValid ? new _({
      ts: r,
      zone: o,
      loc: ft.fromObject(n)
    }) : _.invalid(bl(o));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(e, n = {}) {
    if ($o(e))
      return e < -864e13 || e > Vk ? _.invalid("Timestamp out of range") : new _({
        ts: e,
        zone: eo(n.zone, _t.defaultZone),
        loc: ft.fromObject(n)
      });
    throw new Vn(
      `fromMillis requires a numerical input, but received a ${typeof e} with value ${e}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(e, n = {}) {
    if ($o(e))
      return new _({
        ts: e * 1e3,
        zone: eo(n.zone, _t.defaultZone),
        loc: ft.fromObject(n)
      });
    throw new Vn("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  static fromObject(e, n = {}) {
    e = e || {};
    const r = eo(n.zone, _t.defaultZone);
    if (!r.isValid)
      return _.invalid(bl(r));
    const o = _t.now(), i = He(n.specificOffset) ? r.offset(o) : n.specificOffset, s = ua(e, ep), l = !He(s.ordinal), a = !He(s.year), c = !He(s.month) || !He(s.day), d = a || c, u = s.weekYear || s.weekNumber, f = ft.fromObject(n);
    if ((d || l) && u)
      throw new as(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (c && l)
      throw new as("Can't mix ordinal dates with month/day");
    const h = u || s.weekday && !d;
    let p, y, b = Zh(o, i);
    h ? (p = zk, y = Fk, b = nu(b)) : l ? (p = Hk, y = Nk, b = Wc(b)) : (p = $0, y = L0);
    let w = !1;
    for (const M of p) {
      const R = s[M];
      He(R) ? w ? s[M] = y[M] : s[M] = b[M] : w = !0;
    }
    const S = h ? _k(s) : l ? Bk(s) : O0(s), x = S || D0(s);
    if (x)
      return _.invalid(x);
    const E = h ? Kh(s) : l ? Yh(s) : s, [v, T] = Wl(E, i, r), I = new _({
      ts: v,
      zone: r,
      o: T,
      loc: f
    });
    return s.weekday && d && e.weekday !== I.weekday ? _.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${s.weekday} and a date of ${I.toISO()}`
    ) : I;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(e, n = {}) {
    const [r, o] = tk(e);
    return Yi(r, o, n, "ISO 8601", e);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(e, n = {}) {
    const [r, o] = nk(e);
    return Yi(r, o, n, "RFC 2822", e);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(e, n = {}) {
    const [r, o] = rk(e);
    return Yi(r, o, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(e, n, r = {}) {
    if (He(e) || He(n))
      throw new Vn("fromFormat requires an input string and a format");
    const { locale: o = null, numberingSystem: i = null } = r, s = ft.fromOpts({
      locale: o,
      numberingSystem: i,
      defaultToEN: !0
    }), [l, a, c, d] = Pk(s, e, n);
    return d ? _.invalid(d) : Yi(l, a, r, `format ${n}`, e, c);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(e, n, r = {}) {
    return _.fromFormat(e, n, r);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(e, n = {}) {
    const [r, o] = dk(e);
    return Yi(r, o, n, "SQL", e);
  }
  /**
   * Create an invalid DateTime.
   * @param {DateTime} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new Vn("need to specify a reason the DateTime is invalid");
    const r = e instanceof er ? e : new er(e, n);
    if (_t.throwOnInvalid)
      throw new jx(r);
    return new _({ invalid: r });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(e) {
    return e && e.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(e, n = {}) {
    const r = E0(e, ft.fromObject(n));
    return r ? r.map((o) => o ? o.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(e, n = {}) {
    return v0(rn.parseFormat(e), ft.fromObject(n)).map((o) => o.val).join("");
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(e) {
    return this[e];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? Uc(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? Uc(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? Uc(this).weekday : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? Wc(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? ds.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? ds.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? ds.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? ds.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return nl(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return ca(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? bs(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? da(this.weekYear) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(e = {}) {
    const { locale: n, numberingSystem: r, calendar: o } = rn.create(
      this.loc.clone(e),
      e
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: r, outputCalendar: o };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(e = 0, n = {}) {
    return this.setZone(hn.instance(e), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(_t.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(e, { keepLocalTime: n = !1, keepCalendarTime: r = !1 } = {}) {
    if (e = eo(e, _t.defaultZone), e.equals(this.zone))
      return this;
    if (e.isValid) {
      let o = this.ts;
      if (n || r) {
        const i = e.offset(this.ts), s = this.toObject();
        [o] = Wl(s, i, e);
      }
      return Ki(this, { ts: o, zone: e });
    } else
      return _.invalid(bl(e));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: e, numberingSystem: n, outputCalendar: r } = {}) {
    const o = this.loc.clone({ locale: e, numberingSystem: n, outputCalendar: r });
    return Ki(this, { loc: o });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(e) {
    return this.reconfigure({ locale: e });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = ua(e, ep), r = !He(n.weekYear) || !He(n.weekNumber) || !He(n.weekday), o = !He(n.ordinal), i = !He(n.year), s = !He(n.month) || !He(n.day), l = i || s, a = n.weekYear || n.weekNumber;
    if ((l || o) && a)
      throw new as(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (s && o)
      throw new as("Can't mix ordinal dates with month/day");
    let c;
    r ? c = Kh({ ...nu(this.c), ...n }) : He(n.ordinal) ? (c = { ...this.toObject(), ...n }, He(n.day) && (c.day = Math.min(ca(c.year, c.month), c.day))) : c = Yh({ ...Wc(this.c), ...n });
    const [d, u] = Wl(c, this.o, this.zone);
    return Ki(this, { ts: d, o: u });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = We.fromDurationLike(e);
    return Ki(this, Xh(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = We.fromDurationLike(e).negate();
    return Ki(this, Xh(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(e) {
    if (!this.isValid) return this;
    const n = {}, r = We.normalizeUnit(e);
    switch (r) {
      case "years":
        n.month = 1;
      // falls through
      case "quarters":
      case "months":
        n.day = 1;
      // falls through
      case "weeks":
      case "days":
        n.hour = 0;
      // falls through
      case "hours":
        n.minute = 0;
      // falls through
      case "minutes":
        n.second = 0;
      // falls through
      case "seconds":
        n.millisecond = 0;
        break;
    }
    if (r === "weeks" && (n.weekday = 1), r === "quarters") {
      const o = Math.ceil(this.month / 3);
      n.month = (o - 1) * 3 + 1;
    }
    return this.set(n);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(e) {
    return this.isValid ? this.plus({ [e]: 1 }).startOf(e).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(e, n = {}) {
    return this.isValid ? rn.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, e) : Gc;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(e = aa, n = {}) {
    return this.isValid ? rn.create(this.loc.clone(n), e).formatDateTime(this) : Gc;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(e = {}) {
    return this.isValid ? rn.create(this.loc.clone(e), e).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: e = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: r = !1,
    includeOffset: o = !0,
    extendedZone: i = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const s = e === "extended";
    let l = qc(this, s);
    return l += "T", l += Qh(this, s, n, r, o, i), l;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: e = "extended" } = {}) {
    return this.isValid ? qc(this, e === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return wl(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: e = !1,
    suppressSeconds: n = !1,
    includeOffset: r = !0,
    includePrefix: o = !1,
    extendedZone: i = !1,
    format: s = "extended"
  } = {}) {
    return this.isValid ? (o ? "T" : "") + Qh(
      this,
      s === "extended",
      n,
      e,
      r,
      i
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return wl(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return wl(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? qc(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: e = !0, includeZone: n = !1, includeOffsetSpace: r = !0 } = {}) {
    let o = "HH:mm:ss.SSS";
    return (n || e) && (r && (o += " "), n ? o += "z" : e && (o += "ZZ")), wl(this, o, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(e = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(e)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : Gc;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(e = {}) {
    if (!this.isValid) return {};
    const n = { ...this.c };
    return e.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(e, n = "milliseconds", r = {}) {
    if (!this.isValid || !e.isValid)
      return We.invalid("created by diffing an invalid DateTime");
    const o = { locale: this.locale, numberingSystem: this.numberingSystem, ...r }, i = hE(n).map(We.normalizeUnit), s = e.valueOf() > this.valueOf(), l = s ? this : e, a = s ? e : this, c = Sk(l, a, i, o);
    return s ? c.negate() : c;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(e = "milliseconds", n = {}) {
    return this.diff(_.now(), e, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(e) {
    return this.isValid ? xt.fromDateTimes(this, e) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(e, n) {
    if (!this.isValid) return !1;
    const r = e.valueOf(), o = this.setZone(e.zone, { keepLocalTime: !0 });
    return o.startOf(n) <= r && r <= o.endOf(n);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(e) {
    return this.isValid && e.isValid && this.valueOf() === e.valueOf() && this.zone.equals(e.zone) && this.loc.equals(e.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(e = {}) {
    if (!this.isValid) return null;
    const n = e.base || _.fromObject({}, { zone: this.zone }), r = e.padding ? this < n ? -e.padding : e.padding : 0;
    let o = ["years", "months", "days", "hours", "minutes", "seconds"], i = e.unit;
    return Array.isArray(e.unit) && (o = e.unit, i = void 0), np(n, this.plus(r), {
      ...e,
      numeric: "always",
      units: o,
      unit: i
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(e = {}) {
    return this.isValid ? np(e.base || _.fromObject({}, { zone: this.zone }), this, {
      ...e,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...e) {
    if (!e.every(_.isDateTime))
      throw new Vn("min requires all arguments be DateTimes");
    return Hh(e, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...e) {
    if (!e.every(_.isDateTime))
      throw new Vn("max requires all arguments be DateTimes");
    return Hh(e, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(e, n, r = {}) {
    const { locale: o = null, numberingSystem: i = null } = r, s = ft.fromOpts({
      locale: o,
      numberingSystem: i,
      defaultToEN: !0
    });
    return x0(s, e, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(e, n, r = {}) {
    return _.fromFormatExplain(e, n, r);
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return aa;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return By;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return Ux;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return Vy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return Fy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return Ny;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return zy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return Hy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return jy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return Wy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return Gy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return Uy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return qy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return Jy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return Ky;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return Yy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return Zy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return qx;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return Xy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return Qy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return e0;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return t0;
  }
}
function Zi(t) {
  if (_.isDateTime(t))
    return t;
  if (t && t.valueOf && $o(t.valueOf()))
    return _.fromJSDate(t);
  if (t && typeof t == "object")
    return _.fromObject(t);
  throw new Vn(
    `Unknown datetime argument: ${t}, of type ${typeof t}`
  );
}
const jk = (t, e) => {
  const n = [];
  for (let r = 0; r < 12; r += 1)
    n.push(ds.months("short", { locale: t })[r]);
  return n;
}, Wk = (t, e = "monday", n = "ccc") => {
  const r = [], o = Py(/* @__PURE__ */ new Date(), e);
  for (let i = 0; i < 7; i += 1) {
    const s = _.fromJSDate(o).setLocale(t).toFormat(n);
    r.push(s), o.setDate(o.getDate() + 1);
  }
  return r;
}, P0 = (t, e) => (t == null ? void 0 : t.getFullYear()) === (e == null ? void 0 : e.getFullYear()) && (t == null ? void 0 : t.getMonth()) === (e == null ? void 0 : e.getMonth()), pn = (t, e) => P0(t, e) && t.getDate() === (e == null ? void 0 : e.getDate()), _0 = "LLLL dd, yyyy", pf = 1, Jc = {
  xs: 32,
  sm: 40,
  md: 40,
  lg: 50,
  xl: 54
}, Gk = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 12
}, Uk = O((t, { size: e }) => ({
  calendarHeader: {
    display: "flex",
    justifyContent: "space-between",
    align: "center",
    marginBottom: Gk[e]
  },
  calendarHeaderControl: {
    width: Jc[e],
    height: Jc[e],
    "&:disabled": {
      opacity: 0,
      cursor: "default"
    }
  },
  calendarHeaderLevel: {
    transition: Ae(["background-color", "outline-color", "color"]),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    font: t.other.fonts.desktop.s.s.buttons,
    cursor: "pointer",
    height: Jc[e],
    margin: `0 ${m(16)}`,
    borderRadius: t.other.borderRadius[8],
    flex: 1,
    textAlign: "center",
    color: t.other.colors.greyIron[18],
    outline: `${m(4)} solid transparent`,
    outlineOffset: 0,
    WebkitTapHighlightColor: "transparent",
    "&:hover": {
      backgroundColor: t.other.colors.greyIron[2]
    },
    "&:focus": {
      outlineOffset: 0,
      outline: `${m(4)} solid ${t.other.colors.greyIron[4]}`
    },
    "&:focus:not(:focus-visible)": {
      outline: "none"
    },
    "&:disabled": {
      "&:hover": {
        backgroundColor: "transparent",
        cursor: "default"
      }
    }
  },
  calendarHeaderLevelIcon: {
    marginLeft: m(4)
  }
}));
function mc({
  hasNext: t,
  hasPrevious: e,
  onNext: n,
  onPrevious: r,
  onNextLevel: o,
  className: i,
  label: s,
  nextLevelDisabled: l,
  size: a = "sm",
  classNames: c,
  nextLabel: d,
  previousLabel: u,
  preventLevelFocus: f = !1,
  preventFocus: h,
  ...p
}) {
  const y = _i(), { classes: b, cx: w } = Uk({ size: a });
  return /* @__PURE__ */ g.createElement(oe, { className: w(b.calendarHeader, i, c == null ? void 0 : c.calendarHeader), ...p }, /* @__PURE__ */ g.createElement(
    ye,
    {
      isRound: !0,
      isIconOnly: !0,
      elementSize: Ue.M,
      elementVariant: Q.TertiaryMain,
      className: w(b.calendarHeaderControl, c == null ? void 0 : c.calendarHeaderControl),
      disabled: !e,
      onClick: r,
      "aria-label": u,
      onMouseDown: (S) => h && S.preventDefault(),
      rightSection: /* @__PURE__ */ g.createElement(xi, null),
      "data-testid": "calendar-arrow-left",
      "data-control": "calendar-arrow"
    }
  ), /* @__PURE__ */ g.createElement(
    Qs,
    {
      className: w(b.calendarHeaderLevel, c == null ? void 0 : c.calendarHeaderLevel),
      disabled: l,
      onClick: o,
      tabIndex: f ? -1 : 0,
      onMouseDown: (S) => h && S.preventDefault(),
      "data-testid": "calendar-arrow-down",
      "data-control": "calendar-header"
    },
    s,
    !l && /* @__PURE__ */ g.createElement(
      Sr,
      {
        width: 20,
        height: 20,
        className: w(b.calendarHeaderLevelIcon, c == null ? void 0 : c.calendarHeaderLevelIcon),
        color: y.other.colors.greyIron[12]
      }
    )
  ), /* @__PURE__ */ g.createElement(
    ye,
    {
      isRound: !0,
      isIconOnly: !0,
      elementSize: Ue.M,
      elementVariant: Q.TertiaryMain,
      className: w(b.calendarHeaderControl, c == null ? void 0 : c.calendarHeaderControl),
      disabled: !t,
      onClick: n,
      "aria-label": d,
      onMouseDown: (S) => h && S.preventDefault(),
      rightSection: /* @__PURE__ */ g.createElement($s, null),
      "data-testid": "calendar-arrow-right",
      "data-control": "calendar-arrow"
    }
  ));
}
mc.displayName = "CalendarHeader";
function us(t, e) {
  return _.fromJSDate(new Date(t, 1, 1)).toFormat(e);
}
const ru = ({ date: t, minDate: e, maxDate: n }) => {
  const r = e instanceof Date, o = n instanceof Date;
  if (!o && !r)
    return !0;
  const i = _.fromJSDate(t).endOf("month"), s = _.fromJSDate(t).startOf("month"), l = o ? s < _.fromJSDate(n) : !0, a = r ? i > _.fromJSDate(e) : !0;
  return l && a;
}, qk = {
  xs: 32,
  sm: 40,
  md: 40,
  lg: 52,
  xl: 56
}, Jk = O((t, { size: e }) => ({
  monthPicker: {
    width: "100%"
  },
  monthPickerControls: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    padding: `${m(36)} 0`,
    rowGap: m(24),
    columnGap: m(8)
  },
  monthPickerControl: {
    transition: Ae(["background-color", "outline-color", "color"]),
    font: t.other.fonts.desktop.s.m.default,
    flex: "0 0 31%",
    color: t.other.colors.greyIron[18],
    height: qk[e],
    textAlign: "center",
    borderRadius: t.other.borderRadius[8],
    outline: `${m(4)} solid transparent`,
    outlineOffset: 0,
    WebkitTapHighlightColor: "transparent",
    "&:hover": {
      backgroundColor: t.other.colors.greyIron[2]
    },
    "&:focus": {
      outlineOffset: 0,
      outline: `${m(4)} solid ${t.other.colors.greyIron[4]}`
    },
    "&:focus:not(:focus-visible)": {
      outline: "none"
    },
    "&:disabled": {
      color: t.other.colors.greyIron[6],
      cursor: "not-allowed",
      "&:hover": {
        backgroundColor: "transparent"
      }
    }
  },
  monthPickerControlActive: {
    backgroundColor: t.other.colors.brand[5],
    "&:hover": {
      backgroundColor: t.other.colors.brand[7]
    }
  }
}));
function B0({
  className: t,
  classNames: e,
  value: n,
  onChange: r,
  locale: o,
  year: i,
  onYearChange: s,
  onNextLevel: l,
  size: a = "sm",
  minDate: c,
  maxDate: d,
  __staticSelector: u = "MonthPicker",
  nextYearLabel: f,
  previousYearLabel: h,
  preventFocus: p,
  unstyled: y,
  yearLabelFormat: b = "yyyy",
  ...w
}) {
  const { classes: S, cx: x } = Jk({ size: a }), E = jk(o), v = c instanceof Date ? c.getFullYear() : void 0, T = d instanceof Date ? d.getFullYear() : void 0, I = E.map((M, R) => {
    const A = R === n.month && i === n.year;
    return /* @__PURE__ */ g.createElement(
      Qs,
      {
        key: M,
        unstyled: y,
        onClick: () => r(R),
        className: x(S.monthPickerControl, {
          [S.monthPickerControlActive]: A
        }),
        disabled: !ru({ date: new Date(i, R), minDate: c, maxDate: d }),
        onMouseDown: (F) => p && F.preventDefault(),
        "data-testid": `month-${M}`,
        "data-active": A
      },
      M
    );
  });
  return /* @__PURE__ */ g.createElement(oe, { className: x(S.monthPicker, t), "data-testid": "monthPicker", ...w }, /* @__PURE__ */ g.createElement(
    mc,
    {
      label: us(i, b),
      hasNext: typeof T == "number" ? i < T : !0,
      hasPrevious: typeof v == "number" ? i > v : !0,
      onNext: () => s(i + 1),
      onPrevious: () => s(i - 1),
      onNextLevel: l,
      size: a,
      classNames: e,
      __staticSelector: u,
      nextLabel: f,
      previousLabel: h,
      preventFocus: p
    }
  ), /* @__PURE__ */ g.createElement("div", { className: S.monthPickerControls }, I));
}
B0.displayName = "MonthPicker";
const Kk = ({ hasValue: t, selected: e, firstInMonth: n }) => t ? e ? !0 : void 0 : n ? !0 : void 0, Yk = ({ focusable: t, hasValue: e, selected: n, firstInMonth: r }) => t ? e ? n ? 0 : -1 : r ? 0 : -1 : -1, En = {
  xs: 34,
  sm: 38,
  md: 40,
  lg: 58,
  xl: 66
}, Zk = O((t, { size: e, fullWidth: n, hideOutsideDates: r, firstPosition: o, lastPosition: i }) => ({
  wrapper: {
    width: n ? "100%" : En[e],
    position: "relative"
  },
  day: {
    font: t.other.fonts.desktop.s.s.default,
    position: "relative",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    width: n ? "100%" : En[e],
    height: En[e],
    padding: 0,
    border: "none",
    cursor: "pointer",
    userSelect: "none",
    color: t.other.colors.greyIron[18],
    borderRadius: "50%",
    outline: `${m(2)} solid transparent`,
    outlineOffset: 0,
    "&:focus": {
      outlineOffset: 0,
      outline: `${m(2)} solid ${t.other.colors.greyIron[4]}`
    },
    "&:focus:not(:focus-visible)": {
      outline: "none"
    },
    "&:disabled": {
      pointerEvents: "none",
      color: t.other.colors.greyIron[6]
    },
    "&:hover": {
      backgroundColor: t.other.colors.greyIron[2]
    },
    "&[data-weekend]": {
      color: t.other.colors.greyIron[18]
      // TODO: now not support in design
    },
    "&[data-current-date]": {
      position: "relative",
      "&::before": {
        position: "absolute",
        content: '""',
        width: m(4),
        height: m(4),
        borderRadius: "50%",
        backgroundColor: t.other.colors.brand[13],
        bottom: m(5),
        left: m(En[e] / 2 - 2)
      }
    },
    "&[data-outside]": {
      display: r ? "none" : void 0,
      color: t.other.colors.greyIron[10]
    },
    "&[data-in-range]:not([data-selected])": {
      font: t.other.fonts.desktop.s.s.important,
      backgroundColor: t.other.colors.greyIron[2],
      borderRadius: "50%",
      position: "relative",
      zIndex: 1,
      "&:hover": {
        backgroundColor: t.other.colors.greyIron[3]
      }
    },
    "&[data-in-range]": {
      font: t.other.fonts.desktop.s.s.important,
      backgroundColor: t.other.colors.greyIron[2],
      borderRadius: "50%",
      position: "relative",
      zIndex: 1,
      "&:hover": {
        backgroundColor: t.other.colors.greyIron[3]
      }
    },
    "&[data-selected]": {
      backgroundColor: t.other.colors.brand[5],
      borderRadius: "50%",
      position: "relative",
      zIndex: 1
    },
    "&[data-first-in-range]:not([data-last-in-range])": {
      backgroundColor: t.other.colors.brand[5],
      borderRadius: "50%",
      position: "relative",
      zIndex: 1,
      "&:hover": {
        backgroundColor: t.other.colors.brand[7]
      }
    },
    "&[data-last-in-range]:not([data-first-in-range])": {
      backgroundColor: t.other.colors.brand[5],
      borderRadius: "50%",
      position: "relative",
      zIndex: 1,
      "&:hover": {
        backgroundColor: t.other.colors.brand[7]
      }
    }
  },
  inRangeDays: {
    "&[data-in-range]:not([data-last-in-range], [data-outside])": {
      position: "absolute",
      top: 0,
      left: 0,
      width: En[e],
      height: En[e],
      "&::before": {
        content: '""',
        backgroundColor: t.other.colors.greyIron[2],
        position: "absolute",
        right: m(-1),
        left: m(20),
        top: 0,
        bottom: 0,
        width: i ? 0 : "50%",
        height: "100%"
      }
    },
    "&[data-first-in-range]:not([data-last-in-range], [data-outside])": {
      position: "absolute",
      top: 0,
      left: 0,
      width: En[e],
      height: En[e],
      "&::before": {
        content: '""',
        backgroundColor: t.other.colors.greyIron[2],
        position: "absolute",
        right: m(-1),
        left: m(20),
        top: 0,
        bottom: 0,
        width: i ? 0 : "50%",
        height: "100%"
      }
    },
    "&[data-in-range]:not([data-first-in-range], [data-outside])": {
      position: "absolute",
      top: 0,
      right: 0,
      width: En[e],
      height: En[e],
      "&::after": {
        content: '""',
        backgroundColor: t.other.colors.greyIron[2],
        position: "absolute",
        left: m(-1),
        right: m(20),
        top: 0,
        bottom: 0,
        width: o ? 0 : "50%",
        height: "100%"
      }
    },
    "&[data-last-in-range]:not([data-first-in-range], [data-outside])": {
      position: "absolute",
      top: 0,
      right: 0,
      width: En[e],
      height: En[e],
      "&::after": {
        content: '""',
        backgroundColor: t.other.colors.greyIron[2],
        position: "absolute",
        left: m(-1),
        right: m(20),
        top: 0,
        bottom: 0,
        width: o ? 0 : "50%",
        height: "100%"
      }
    }
  }
})), V0 = ge(
  (t, e) => {
    const {
      className: n,
      value: r,
      selected: o,
      weekend: i,
      outside: s,
      onMouseEnter: l,
      classNames: a,
      hasValue: c,
      firstInRange: d,
      lastInRange: u,
      inRange: f,
      firstHovered: h,
      lastHovered: p,
      firstInRow: y,
      lastInRow: b,
      size: w,
      fullWidth: S,
      firstInMonth: x,
      focusable: E,
      hideOutsideDates: v,
      renderDay: T,
      disabled: I,
      stopPropagation: M,
      isCurrent: R,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- no need this here
      __staticSelector: A,
      ...F
    } = he("Day", {}, t), { classes: V, cx: P } = Zk({
      size: w,
      fullWidth: S,
      hideOutsideDates: !!v,
      firstPosition: y || h,
      lastPosition: b || p
    }), J = me(() => typeof T == "function" ? T(r) : r.getDate(), [T, r]);
    return /* @__PURE__ */ g.createElement(oe, { className: P(V.wrapper, a == null ? void 0 : a.wrapper) }, /* @__PURE__ */ g.createElement(
      "button",
      {
        ...F,
        type: "button",
        ref: e,
        disabled: I,
        onMouseEnter: (ne) => l(r, ne),
        tabIndex: Yk({ focusable: !!E, hasValue: c, selected: o, firstInMonth: x }),
        "data-autofocus": Kk({ hasValue: c, selected: o, firstInMonth: x }),
        "data-mantine-stop-propagation": M || void 0,
        "data-outside": s && !I || void 0,
        "data-weekend": i && !I || void 0,
        "data-selected": o && !I || void 0,
        "data-in-range": f && !I || void 0,
        "data-first-in-range": d && !I || void 0,
        "data-last-in-range": u && !I || void 0,
        "data-current-date": R && !I || void 0,
        "data-testid": `day-${J}`,
        className: P(V.day, n)
      },
      J
    ), (f || d || u) && !I && /* @__PURE__ */ g.createElement(
      "span",
      {
        className: P(V.inRangeDays, a == null ? void 0 : a.inRangeDays),
        "data-in-range": f || void 0,
        "data-first-in-range": d || void 0,
        "data-last-in-range": u || void 0,
        "data-outside": s && v && !I || void 0
      }
    ));
  }
);
V0.displayName = "Day";
const Xk = (t, e) => {
  const n = Array.isArray(e) && e.every((l) => l instanceof Date), r = n ? [_.fromJSDate(e[0]).minus({ day: 1 }), _.fromJSDate(e[1]).plus({ day: 1 })] : [], o = n && pn(t, e[0]), i = n && pn(t, e[1]), s = n && _.fromJSDate(t) > r[0] && _.fromJSDate(t) < r[1] && !pn(e[0], e[1]);
  return { firstInRange: o, lastInRange: i, inRange: s, selectedInRange: o || i };
}, Qk = ({ minDate: t, maxDate: e, excludeDate: n, disableOutsideEvents: r, date: o, outside: i }) => {
  const s = e instanceof Date && _.fromJSDate(e) < _.fromJSDate(o), l = t instanceof Date && _.fromJSDate(t) > _.fromJSDate(o), a = typeof n == "function" && n(o);
  return s || l || a || !!r && !!i;
}, eT = (t, e) => !P0(t, e), tT = (t, e = [0, 6]) => e.includes(t.getDay()), op = ({
  date: t,
  month: e,
  hasValue: n,
  minDate: r,
  maxDate: o,
  value: i,
  excludeDate: s,
  disableOutsideEvents: l,
  range: a,
  weekendDays: c
}) => {
  const d = eT(t, e), u = n && (Array.isArray(i) ? i.some((w) => pn(w, t)) : pn(t, i)), { inRange: f, lastInRange: h, firstInRange: p, selectedInRange: y } = Xk(t, a), b = pn(t, /* @__PURE__ */ new Date());
  return {
    disabled: Qk({ minDate: r, maxDate: o, excludeDate: s, disableOutsideEvents: l, date: t, outside: d }),
    weekend: tT(t, c),
    selectedInRange: y,
    selected: u,
    inRange: f,
    firstInRange: p,
    lastInRange: h,
    outside: d,
    isCurrent: b
  };
}, nT = O((t, { fullWidth: e }) => ({
  weekday: {
    font: t.other.fonts.desktop.s.s.important,
    color: t.other.colors.greyIron[18]
  },
  month: {
    font: t.other.fonts.desktop.s.s.default,
    borderCollapse: "collapse",
    width: e ? "100%" : "auto",
    tableLayout: "fixed"
  },
  cell: {
    boxSizing: "border-box",
    padding: 0,
    borderTop: `${m(4)} solid transparent`
  },
  weekdayCell: {
    boxSizing: "border-box",
    padding: 0,
    fontWeight: "normal",
    textAlign: "center",
    cursor: "default",
    userSelect: "none",
    height: m(42),
    width: m(40)
  },
  weekdayRow: {
    paddingBottom: m(2)
  }
})), si = () => !1, rT = 0, oT = 6, iT = (t) => t === rT, sT = (t) => t === oT, lT = {
  disableOutsideEvents: !1,
  hideWeekdays: !1,
  __staticSelector: "Month",
  size: "sm",
  fullWidth: !1,
  preventFocus: !1,
  focusable: !0,
  firstDayOfWeek: "monday",
  hideOutsideDates: !1,
  weekendDays: [0, 6],
  __stopPropagation: !0
}, F0 = ge((t, e) => {
  const {
    className: n,
    month: r,
    value: o,
    onChange: i,
    disableOutsideEvents: s,
    locale: l,
    dayClassName: a,
    dayStyle: c,
    classNames: d,
    minDate: u,
    maxDate: f,
    excludeDate: h,
    onDayMouseEnter: p,
    range: y,
    hideWeekdays: b,
    __staticSelector: w,
    size: S,
    fullWidth: x,
    preventFocus: E,
    focusable: v,
    firstDayOfWeek: T,
    onDayKeyDown: I,
    daysRefs: M,
    hideOutsideDates: R,
    isDateInRange: A = si,
    isDateFirstInRange: F = si,
    isDateLastInRange: V = si,
    isFirstInRangeHovered: P = si,
    isLastInRangeHovered: J = si,
    renderDay: ne,
    weekdayLabelFormat: G,
    unstyled: H,
    weekendDays: W,
    __stopPropagation: se,
    ...U
  } = he("Month", lT, t), { classes: re, cx: ke } = nT({ fullWidth: x }), Te = l || "en", Se = Hx(r, T), Le = Wk(Te, T, G).map((Ie) => /* @__PURE__ */ g.createElement("th", { className: ke(re.weekdayCell, d == null ? void 0 : d.weekdayCell), key: Ie, "data-testid": `weekday-${Ie}` }, /* @__PURE__ */ g.createElement(As, { size: S, className: ke(re.weekday, d == null ? void 0 : d.weekday) }, Ie.length >= 2 ? oo(Ie) : Ie))), Ce = Array.isArray(o) ? o.every((Ie) => Ie instanceof Date) : o instanceof Date, et = o instanceof Date && _.fromJSDate(o) > _.fromJSDate(r).startOf("month") && _.fromJSDate(o) < _.fromJSDate(r).endOf("month"), Oe = me(
    () => Se.flat().find((Ie) => {
      const ee = op({
        date: Ie,
        month: r,
        hasValue: Ce,
        minDate: u,
        maxDate: f,
        value: o,
        excludeDate: h,
        disableOutsideEvents: s,
        range: y,
        weekendDays: W
      });
      return !ee.disabled && !ee.outside;
    }) || _.fromJSDate(r).startOf("month").toJSDate(),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), $e = Se.map((Ie, ee) => {
    const de = Ie.map((ae, Y) => {
      const we = op({
        date: ae,
        month: r,
        hasValue: Ce,
        minDate: u,
        maxDate: f,
        value: o,
        excludeDate: h,
        disableOutsideEvents: s,
        range: y,
        weekendDays: W
      }), Ze = { rowIndex: ee, cellIndex: Y, date: ae }, Je = _.fromJSDate(r).startOf("month").toJSDate(), ht = _.fromJSDate(r).endOf("month").toJSDate(), Xe = pn(ae, Je), Lt = pn(ae, ht);
      return /* @__PURE__ */ g.createElement("td", { className: ke(re.cell, d == null ? void 0 : d.cell), key: Y }, /* @__PURE__ */ g.createElement(
        V0,
        {
          unstyled: H,
          ref: (Be) => {
            M && (Array.isArray(M[ee]) || (M[ee] = []), M[ee][Y] = Be);
          },
          onClick: () => typeof i == "function" && i(ae),
          onMouseDown: (Be) => E && Be.preventDefault(),
          value: ae,
          outside: we.outside,
          weekend: we.weekend,
          inRange: we.inRange || A(ae, we),
          firstInRange: we.firstInRange || F(ae, we),
          lastInRange: we.lastInRange || V(ae, we),
          firstInRow: iT(Y) || !!R && Xe,
          lastInRow: sT(Y) || !!R && Lt,
          firstHovered: P(ae),
          lastHovered: J(ae),
          firstInMonth: pn(ae, Oe),
          selected: we.selected || we.selectedInRange,
          hasValue: et,
          onKeyDown: (Be) => typeof I == "function" && I(Ze, Be),
          className: typeof a == "function" ? a(ae, we) : void 0,
          style: typeof c == "function" ? c(ae, we) : void 0,
          disabled: we.disabled,
          isCurrent: we.isCurrent,
          onMouseEnter: typeof p == "function" ? p : si,
          size: S,
          fullWidth: !!x,
          focusable: v,
          hideOutsideDates: R,
          __staticSelector: w,
          classNames: d,
          renderDay: ne,
          stopPropagation: se
        }
      ));
    });
    return /* @__PURE__ */ g.createElement("tr", { key: ee }, de);
  });
  return /* @__PURE__ */ g.createElement(oe, { component: "table", className: ke(re.month, n), ref: e, "data-testid": "month", ...U }, !b && /* @__PURE__ */ g.createElement("thead", { className: re.weekdayRow }, /* @__PURE__ */ g.createElement("tr", null, Le)), /* @__PURE__ */ g.createElement("tbody", null, $e));
});
F0.displayName = "Month";
const aT = ({ month: t, locale: e, format: n }) => oo(_.fromJSDate(t).setLocale(e).toFormat(n));
function N0(t) {
  const {
    amountOfMonths: e,
    paginateBy: n,
    month: r,
    locale: o,
    minDate: i,
    maxDate: s,
    allowLevelChange: l,
    size: a,
    daysRefs: c,
    onMonthChange: d,
    onNextLevel: u,
    onDayKeyDown: f,
    classNames: h,
    nextMonthLabel: p,
    previousMonthLabel: y,
    labelFormat: b,
    weekdayLabelFormat: w,
    preventFocus: S,
    renderDay: x,
    unstyled: E,
    __staticSelector: v,
    ...T
  } = he("MonthsList", {}, t), I = _.fromJSDate(r).plus({ months: e }).toJSDate(), M = _.fromJSDate(r).minus({ months: 1 }).toJSDate(), R = Array.from({ length: e }).fill(0).map((A, F) => {
    var P;
    const V = _.fromJSDate(r).plus({ months: F }).toJSDate();
    return /* @__PURE__ */ g.createElement("div", { key: F, "data-testid": "month-item" }, /* @__PURE__ */ g.createElement(
      mc,
      {
        hasNext: F + 1 === e && ru({ date: I, minDate: i, maxDate: s }),
        hasPrevious: F === 0 && ru({ date: M, minDate: i, maxDate: s }),
        label: aT({ month: V, locale: o, format: b || "" }),
        onNext: () => d(_.fromJSDate(r).plus({ months: n }).toJSDate()),
        onPrevious: () => d(_.fromJSDate(r).minus({ months: n }).toJSDate()),
        onNextLevel: u,
        nextLevelDisabled: !l,
        size: a,
        classNames: h,
        __staticSelector: v,
        nextLabel: p,
        previousLabel: y,
        preventLevelFocus: F > 0,
        preventFocus: S
      }
    ), /* @__PURE__ */ g.createElement(
      F0,
      {
        month: V,
        daysRefs: (P = c.current) == null ? void 0 : P[F],
        onDayKeyDown: (...J) => f(F, ...J),
        size: a,
        minDate: i,
        maxDate: s,
        classNames: h,
        __staticSelector: v,
        locale: o,
        focusable: F === 0,
        preventFocus: S,
        renderDay: x,
        weekdayLabelFormat: w,
        unstyled: E,
        ...T
      }
    ));
  });
  return /* @__PURE__ */ g.createElement(g.Fragment, null, R);
}
N0.displayName = "MonthsList";
const cT = (t) => {
  const e = t - t % 10 - 1, n = [];
  for (let r = 0; r < 12; r += 1) {
    const o = e + r;
    n.push(o);
  }
  return n;
}, dT = {
  xs: 32,
  sm: 40,
  md: 40,
  lg: 52,
  xl: 56
}, uT = O((t, { size: e }, n) => ({
  yearPicker: {
    width: "100%"
  },
  yearPickerControls: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    padding: `${m(36)} 0`,
    rowGap: m(24),
    columnGap: m(8)
  },
  yearPickerControl: {
    flex: "0 0 31%",
    transition: Ae(["background-color", "outline-color", "color"]),
    font: t.other.fonts.desktop.s.m.default,
    height: dT[e],
    textAlign: "center",
    borderRadius: t.other.borderRadius[8],
    color: t.other.colors.greyIron[18],
    outline: `${m(4)} solid transparent`,
    outlineOffset: 0,
    WebkitTapHighlightColor: "transparent",
    "&:focus": {
      outlineOffset: 0,
      outline: `${m(4)} solid ${t.other.colors.greyIron[4]}`
    },
    "&:focus:not(:focus-visible)": {
      outline: "none"
    },
    "&:hover": {
      backgroundColor: t.other.colors.greyIron[2]
    },
    "&:disabled": {
      color: n.dark ? t.colors.dark[3] : t.colors.gray[4],
      cursor: "not-allowed",
      "&:hover": {
        backgroundColor: "transparent"
      }
    }
  },
  yearPickerControlActive: {
    backgroundColor: t.other.colors.brand[5],
    "&:hover": {
      backgroundColor: t.other.colors.brand[7]
    }
  }
}));
function z0({
  className: t,
  classNames: e,
  value: n,
  onChange: r,
  size: o = "sm",
  minYear: i,
  maxYear: s,
  __staticSelector: l = "YearPicker",
  nextDecadeLabel: a,
  previousDecadeLabel: c,
  preventFocus: d,
  unstyled: u,
  yearLabelFormat: f = "yyyy",
  ...h
}) {
  const { classes: p, cx: y } = uT({ size: o }), [b, w] = ie(n), S = cT(b), x = S.map((E) => {
    const v = E === n;
    return /* @__PURE__ */ g.createElement(
      Qs,
      {
        key: E,
        unstyled: u,
        onClick: () => r(E),
        disabled: E < Number(i) || E > Number(s),
        onMouseDown: (T) => d && T.preventDefault(),
        className: y(p.yearPickerControl, {
          [p.yearPickerControlActive]: E === n
        }),
        "data-testid": `year-${us(E, f)}`,
        "data-active": v
      },
      us(E, f)
    );
  });
  return /* @__PURE__ */ g.createElement("div", { className: y(p.yearPicker, t), "data-testid": "yearPicker", ...h }, /* @__PURE__ */ g.createElement(
    mc,
    {
      label: `${us(S[0], f)} – ${us(S[S.length - 1], f)}`,
      hasPrevious: typeof i == "number" ? i < S[0] : !0,
      hasNext: typeof s == "number" ? s > S[S.length - 1] : !0,
      onNext: () => w((E) => E + 10),
      onPrevious: () => w((E) => E - 10),
      nextLevelDisabled: !0,
      size: o,
      nextLabel: a,
      previousLabel: c,
      classNames: e,
      __staticSelector: l,
      preventFocus: d
    }
  ), /* @__PURE__ */ g.createElement("div", { className: p.yearPickerControls }, x));
}
z0.displayName = "YearPicker";
const fT = O((t, { size: e, amountOfMonths: n, fullWidth: r }) => {
  const i = En[e] * 7 + 40, s = n > 1 ? i * n + (n - 1) * 16 : i;
  return {
    calendarBase: {
      boxSizing: "border-box",
      display: "flex",
      gap: t.spacing.md,
      maxWidth: r ? "100%" : m(s),
      padding: m(20),
      backgroundColor: t.other.colors.white[0]
    }
  };
}), gf = ge(
  ({
    className: t,
    classNames: e,
    month: n,
    initialMonth: r,
    onMonthChange: o,
    locale: i,
    amountOfMonths: s = 1,
    paginateBy: l = s,
    size: a = "md",
    allowLevelChange: c = !0,
    initialLevel: d = "date",
    minDate: u,
    maxDate: f,
    __staticSelector: h = "CalendarBase",
    dayClassName: p,
    dayStyle: y,
    disableOutsideEvents: b,
    excludeDate: w,
    hideWeekdays: S,
    fullWidth: x,
    preventFocus: E,
    firstDayOfWeek: v = "monday",
    value: T,
    onChange: I,
    onDayMouseEnter: M,
    range: R,
    nextDecadeLabel: A,
    nextMonthLabel: F,
    nextYearLabel: V,
    previousDecadeLabel: P,
    previousMonthLabel: J,
    previousYearLabel: ne,
    labelFormat: G = "MMMM, yyyy",
    weekdayLabelFormat: H,
    hideOutsideDates: W,
    isDateInRange: se,
    isDateFirstInRange: U,
    isDateLastInRange: re,
    renderDay: ke,
    weekendDays: Te,
    isFirstInRangeHovered: Se,
    isLastInRangeHovered: Le,
    __stopPropagation: Ce,
    yearLabelFormat: et = "yyyy",
    variant: Oe = "static",
    ...$e
  }, Ie) => {
    const ee = mr(Ge.greaterThen("md", !1)), de = Oe === "responsive" && !ee ? pf : s, [ae, Y] = ie(d), { classes: we, cx: Ze } = fT({
      size: a,
      fullWidth: !!x,
      amountOfMonths: ae === "date" ? de : 1
    }), Je = i || "en", ht = Nt(
      Array.from({ length: de }).fill(0).map(() => [])
    ), [Xe, Lt] = an({
      value: n,
      defaultValue: r,
      finalValue: /* @__PURE__ */ new Date(),
      onChange: o
    }), [Be, tt] = ie(Xe.getFullYear()), St = u instanceof Date ? u.getFullYear() : 100, Mt = f instanceof Date ? f.getFullYear() : 1e4, nt = 6, je = (L, q, ve, De = 1) => {
      const pt = ["down", "up"].includes(L), un = pt ? ve.rowIndex + (L === "down" ? De : -De) : ve.rowIndex, bn = pt ? ve.cellIndex : ve.cellIndex + (L === "right" ? De : -De), Ut = ht.current[q][un][bn];
      Ut && (Ut.disabled ? je(L, q, ve, De + 1) : Ut.focus());
    }, Qe = (L, q, ve) => {
      var De;
      switch (ve.key) {
        case "ArrowDown": {
          ve.preventDefault(), q.rowIndex + 1 < ht.current[L].length && je("down", L, q);
          break;
        }
        case "ArrowUp": {
          ve.preventDefault(), q.rowIndex > 0 && je("up", L, q);
          break;
        }
        case "ArrowRight": {
          ve.preventDefault(), q.cellIndex !== nt ? je("right", L, q) : L + 1 < de && ht.current[L + 1][q.rowIndex] && ((De = ht.current[L + 1][q.rowIndex][0]) == null || De.focus());
          break;
        }
        case "ArrowLeft":
          ve.preventDefault(), q.cellIndex !== 0 ? je("left", L, q) : L > 0 && ht.current[L - 1][q.rowIndex] && ht.current[L - 1][q.rowIndex][nt].focus();
      }
    };
    return /* @__PURE__ */ g.createElement(oe, { className: Ze(we.calendarBase, t), ref: Ie, ...$e }, ae === "year" && /* @__PURE__ */ g.createElement(
      z0,
      {
        size: a,
        value: Be,
        minYear: St,
        maxYear: Mt,
        onChange: (L) => {
          tt(L), Y("month");
        },
        classNames: e,
        __staticSelector: h,
        nextDecadeLabel: A,
        previousDecadeLabel: P,
        preventFocus: E,
        yearLabelFormat: et
      }
    ), ae === "month" && /* @__PURE__ */ g.createElement(
      B0,
      {
        size: a,
        value: { month: Xe == null ? void 0 : Xe.getMonth(), year: Xe == null ? void 0 : Xe.getFullYear() },
        year: Be,
        onYearChange: tt,
        onNextLevel: () => Y("year"),
        locale: Je,
        minDate: u,
        maxDate: f,
        onChange: (L) => {
          Lt(new Date(Be, L, 1)), Y("date");
        },
        classNames: e,
        __staticSelector: h,
        nextYearLabel: V,
        previousYearLabel: ne,
        preventFocus: E,
        yearLabelFormat: et
      }
    ), ae === "date" && /* @__PURE__ */ g.createElement(
      N0,
      {
        amountOfMonths: de,
        paginateBy: l,
        month: Xe,
        locale: Je,
        minDate: u,
        maxDate: f,
        allowLevelChange: c,
        size: a,
        daysRefs: ht,
        onMonthChange: Lt,
        onNextLevel: () => Y("month"),
        onDayKeyDown: Qe,
        classNames: e,
        __staticSelector: h,
        dayClassName: p,
        dayStyle: y,
        disableOutsideEvents: b,
        excludeDate: w,
        hideWeekdays: S,
        fullWidth: x,
        preventFocus: E,
        firstDayOfWeek: v,
        value: T,
        range: R,
        onChange: I,
        nextMonthLabel: F,
        previousMonthLabel: J,
        labelFormat: G,
        weekdayLabelFormat: H,
        onDayMouseEnter: M,
        renderDay: ke,
        hideOutsideDates: W,
        isDateInRange: se,
        isDateFirstInRange: U,
        isDateLastInRange: re,
        isFirstInRangeHovered: Se,
        isLastInRangeHovered: Le,
        weekendDays: Te,
        __stopPropagation: Ce
      }
    ));
  }
);
gf.displayName = "CalendarBase";
const hT = {
  __staticSelector: "Calendar"
};
function H0(t) {
  const { __staticSelector: e = "Calendar", multiple: n, value: r, onChange: o, ...i } = he("Calendar", hT, t), s = (l) => {
    if (!n)
      return o(l);
    const a = r.some((c) => pn(c, l));
    return o(a ? r.filter((c) => !pn(c, l)) : [...r, l]);
  };
  return /* @__PURE__ */ g.createElement(gf, { __staticSelector: e, onChange: s, value: r, ...i });
}
H0.displayName = "Calendar";
var mt = /* @__PURE__ */ ((t) => (t.S = "S", t.M = "M", t.SeparateL = "SeparateL", t.SeparateXL = "SeparateXL", t))(mt || {}), fa = /* @__PURE__ */ ((t) => (t.default = "default", t.tooltip = "tooltip", t))(fa || {});
const pT = O((t, { colorVariant: e }) => {
  const [n, r] = (e == null ? void 0 : e.split(".")) || [];
  return {
    root: {},
    label: {
      margin: "0 !important"
    },
    dividerColor: {
      borderTopColor: n !== void 0 && r !== void 0 ? t.other.colors[n][r] : void 0,
      borderLeftColor: n !== void 0 && r !== void 0 ? t.other.colors[n][r] : void 0
    }
  };
}), il = ({
  orientation: t,
  colorVariant: e = "greyIron.4",
  height: n,
  className: r,
  classNames: o,
  ...i
}) => {
  const { classes: s, cx: l } = pT({ colorVariant: e });
  return /* @__PURE__ */ g.createElement(
    Qu,
    {
      style: { height: t === "vertical" ? m(n) : void 0 },
      className: l({ [s.dividerColor]: !!e }, r),
      classNames: {
        root: l(s.root, o == null ? void 0 : o.root),
        label: l(s.label, o == null ? void 0 : o.label)
      },
      orientation: t,
      ...i
    }
  );
}, ot = (t, e) => {
  switch (t) {
    case mt.SeparateXL:
      return e[0];
    case mt.SeparateL:
      return e[1];
    case mt.M:
      return e[2];
    case mt.S:
      return e[3];
    default:
      return e[0];
  }
}, sr = O((t, { elementSize: e }) => {
  const n = ot(e, [0, 0, 20, 18]), r = ot(e, [52, 40, 40, 36]);
  return {
    root: {
      width: ot(e, [44, 36, "auto", "auto"]),
      height: ot(e, [52, 36, "auto", "auto"]),
      lineHeight: 1,
      display: "flex",
      flexDirection: "column",
      gap: m(6)
    },
    wrapper: {
      marginBottom: 0
    },
    input: {
      width: "100%",
      height: m(r),
      paddingTop: m(ot(e, [9, 7, 9, 7])),
      paddingBottom: m(ot(e, [9, 7, 9, 7])),
      borderRadius: t.other.borderRadius[8],
      borderColor: t.other.colors.greyIron[7],
      font: ot(e, [
        t.other.fonts.desktop.s.xl.important,
        t.other.fonts.desktop.s.s.buttons,
        t.other.fonts.desktop.s.s.default,
        t.other.fonts.desktop.s.s.default
      ]),
      textAlign: ot(e, ["center", "center", "left", "left"]),
      color: t.other.colors.greyIron[18],
      backgroundColor: t.other.colors.white[0],
      transition: Ae(["background-color", "border-color", "color"]),
      "&::placeholder": {
        color: t.other.colors.greyIron[10]
      },
      "&::selection": {
        backgroundColor: t.other.colors.brand[3]
      },
      "&:hover:not(&:disabled)": {
        borderColor: t.other.colors.brand[10]
      },
      "&:focus, &:focus-within": {
        borderColor: t.other.colors.brand[13],
        backgroundColor: t.other.colors.white[0]
      },
      "&:read-only": {
        color: t.other.colors.greyIron[15]
      },
      "&:disabled, &[data-disabled]": {
        opacity: 1,
        borderColor: "transparent",
        backgroundColor: t.other.colors.greyIron[2],
        color: t.other.colors.greyIron[12],
        pointerEvents: "none",
        "::placeholder": {
          color: t.other.colors.greyIron[9]
        }
      },
      "&:-internal-autofill-selected": {
        borderColor: t.other.colors.brand[13],
        boxShadow: `0 0 0 ${m(40)} ${t.other.colors.brand[0]} inset`
      },
      '&[data-error="true"]': {
        borderColor: t.other.colors.raspberry[12],
        backgroundColor: t.other.colors.white[0],
        color: t.other.colors.greyIron[18],
        "&::placeholder": {
          color: t.other.colors.raspberry[12]
        },
        "&:hover:not(&:disabled)": {
          borderColor: t.other.colors.raspberry[12],
          backgroundColor: t.other.colors.raspberry[0]
        },
        "&:hover:not(&:placeholder-shown)": {
          backgroundColor: t.other.colors.white[0]
        },
        "&:active:not(&:disabled)": {
          backgroundColor: t.other.colors.white[0]
        },
        "&:focus": {
          borderColor: t.other.colors.raspberry[12]
        },
        "&:-internal-autofill-selected": {
          borderColor: t.other.colors.raspberry[12],
          backgroundColor: t.other.colors.white[0],
          color: t.other.colors.greyIron[18]
        }
      }
    },
    inputContainer: {
      position: "relative"
    },
    required: {
      color: t.other.colors.brand[13]
    },
    labelWrapper: {
      display: "inline-flex",
      alignItems: "center"
    },
    labelWrapperWithIcon: {},
    label: {
      font: t.other.fonts.desktop.s.s.label,
      color: t.other.colors.greyIron[15],
      [`& .${Ps}`]: {
        display: "none"
      }
    },
    labelDisabled: {
      color: t.other.colors.greyIron[9]
    },
    labelIcon: {
      marginLeft: t.other.spacings[4],
      display: "flex",
      alignItems: "center",
      color: t.other.colors.greyIron[10],
      svg: {
        width: m(16),
        height: m(16)
      }
    },
    description: {
      font: t.other.fonts.desktop.s.s.default,
      color: t.other.colors.greyIron[10],
      marginTop: m(-2)
    },
    section: {
      svg: {
        width: m(n),
        height: m(n),
        color: t.other.colors.greyIron[10]
      },
      '&[data-position="right"]': {
        marginRight: 3
      },
      '&[data-position="left"]': {
        marginLeft: m(3)
      }
    },
    iconDisabled: {
      svg: {
        stroke: t.other.colors.greyIron[9]
      }
    },
    iconError: {
      '&[data-position="right"]': {
        svg: {
          color: t.other.colors.raspberry[12]
        }
      }
    },
    error: {
      marginTop: m(-2),
      font: t.other.fonts.desktop.s.s.default,
      color: t.other.colors.raspberry[12]
    },
    toggle: {
      "&&": {
        position: "absolute"
      },
      top: m(-24),
      right: 0
    },
    svgIcon: {
      svg: {
        width: m(n),
        height: m(n),
        color: t.other.colors.greyIron[10]
      }
    }
  };
});
var ln = /* @__PURE__ */ ((t) => (t.S = "S", t.M = "M", t))(ln || {});
const hr = (t, e) => {
  switch (t) {
    case ln.M:
      return e[0];
    case ln.S:
      return e[1];
    default:
      return e[0];
  }
}, gT = O((t, { elementSize: e }) => {
  const n = ot(e, [void 0, void 0, 20, 18]), r = ot(e, [40, 40, 40, 36]);
  return {
    root: {
      gap: `${m(2)} !important`
    },
    wrapper: {
      marginTop: 0,
      position: "relative",
      cursor: "pointer",
      width: "100%"
    },
    input: {
      width: "100%",
      height: m(r),
      cursor: "pointer",
      whiteSpace: "nowrap",
      paddingLeft: m(36),
      "&:not([data-free-input])::selection": {
        backgroundColor: "transparent"
      },
      "&[data-free-input]": {
        cursor: "text"
      }
    },
    labelWrapper: {
      display: "inline-flex",
      color: t.other.colors.greyIron[15],
      alignItems: "center"
    },
    description: {
      marginBottom: m(2)
    },
    leftSection: {
      '&[data-position="left"]': {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "auto",
        marginLeft: m(11),
        font: t.other.fonts.desktop.s.s.default,
        color: t.other.colors.greyIron[18]
      }
    },
    rightSectionWrapper: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      height: "100%",
      cursor: "pointer"
    },
    rightSectionWrapperDisabled: {
      cursor: "not-allowed"
    },
    rightSectionDivider: {
      margin: `auto ${m(6)} auto`
    },
    rightSection: {
      '&[data-position="right"]': {
        display: "flex",
        flexDirection: "column",
        marginRight: m(2),
        width: m(36),
        cursor: "pointer",
        pointerEvents: "none",
        svg: {
          width: m(n),
          height: m(n)
        }
      }
    },
    clearButton: {
      pointerEvents: "all",
      height: "100%",
      svg: {
        color: t.other.colors.greyIron[12],
        transition: Ae(["color"])
      },
      "&:hover": {
        svg: {
          color: t.other.colors.greyIron[13]
        }
      }
    },
    chevron: {
      width: m(hr(ln[e], [20, 14])),
      height: m(hr(ln[e], [20, 14])),
      transition: Ae(["transform"]),
      color: t.other.colors.greyIron[12]
    },
    chevronOpened: {
      transform: "rotate(-180deg)"
    },
    dropdown: {
      border: `${m(1)} solid ${t.other.colors.white[0]}`,
      borderRadius: t.other.borderRadius[8],
      padding: 0
    },
    error: {
      marginTop: `${m(2)} !important`,
      font: t.other.fonts.desktop.s.s.default,
      color: t.other.colors.raspberry[12]
    }
  };
}), mT = {
  in: { opacity: 1, transform: "translateY(0) scale(1)" },
  out: { opacity: 0, transform: `translateY(${m(-25)}) scale(0.93)` },
  common: { transformOrigin: "top left" },
  transitionProperty: "opacity, transform"
}, mf = ge(
  (t, e) => {
    const {
      classNames: n,
      className: r,
      style: o,
      wrapperProps: i,
      required: s,
      allowFreeInput: l = !1,
      label: a,
      labelIcon: c,
      labelIconTooltipText: d,
      error: u,
      id: f,
      description: h,
      placeholder: p,
      shadow: y,
      transition: b = mT,
      transitionDuration: w = 100,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      transitionTimingFunction: S,
      elementSize: x = mt.M,
      children: E,
      inputLabel: v,
      __staticSelector: T = "DatePickerBase",
      dropdownOpened: I,
      setDropdownOpened: M,
      dropdownType: R = "popover",
      dropdownPosition: A = "flip",
      clearable: F = !0,
      clearButtonLabel: V,
      onClear: P,
      positionDependencies: J = [],
      zIndex: ne,
      withinPortal: G = !1,
      onBlur: H,
      onFocus: W,
      onChange: se,
      onKeyDown: U,
      name: re = "date",
      amountOfMonths: ke = 1,
      onDropdownClose: Te,
      onDropdownOpen: Se,
      clickOutsideEvents: Le = ["mousedown", "touchstart"],
      modalZIndex: Ce,
      errorProps: et,
      labelProps: Oe,
      descriptionProps: $e,
      clearButtonTabIndex: Ie = 0,
      unstyled: ee,
      inputContainer: de,
      inputWrapperOrder: ae,
      modalProps: Y,
      withAsterisk: we,
      disabled: Ze,
      rightSection: Je,
      leftSection: ht,
      variant: Xe = "static",
      ...Lt
    } = he("DatePickerBase", t, {}), Be = mr(Ge.greaterThen("md", !1)), tt = Xe === "responsive" && !Be ? pf : ke, [St, Mt] = ie(null), [nt, je] = ie(null);
    av(() => M(!1), null, [St, nt]);
    const Qe = _i(), { classes: L, cx: q } = gT({ elementSize: x }), { classes: ve } = sr({ elementSize: mt[x] }), De = Xm(f), pt = Nt(null), un = () => {
      M(!1), Te == null || Te();
    }, bn = () => {
      M(!0), Se == null || Se();
    }, Ut = () => {
      M(!I), I ? Te == null || Te() : Se == null || Se();
    }, Dn = (Ct) => {
      Ct.key === "Escape" && (un(), window.setTimeout(() => {
        var An;
        return (An = pt.current) == null ? void 0 : An.focus();
      }, 0));
    }, qt = (Ct) => {
      typeof H == "function" && H(Ct), l && un();
    }, ct = (Ct) => {
      typeof W == "function" && W(Ct), l && bn();
    }, vn = (Ct) => {
      typeof U == "function" && U(Ct), (Ct.key === "Space" || Ct.key === "Enter") && !l && (Ct.preventDefault(), bn());
    }, { styleProps: Jt, rest: Un } = el(Lt);
    return /* @__PURE__ */ g.createElement(
      vi.Wrapper,
      {
        required: s,
        id: De,
        label: (a || c) && /* @__PURE__ */ g.createElement(
          "div",
          {
            className: q(L.labelWrapper, {
              [ve.labelWrapperWithIcon]: c,
              [ve.labelDisabled]: Ze
            })
          },
          a && /* @__PURE__ */ g.createElement("span", null, a),
          (c || d) && /* @__PURE__ */ g.createElement(at, { label: d, style: { maxWidth: m(200) }, multiline: !0 }, /* @__PURE__ */ g.createElement("span", { className: q(ve.labelIcon, { [ve.iconDisabled]: Ze }) }, c || /* @__PURE__ */ g.createElement(Nr, null)))
        ),
        error: u,
        description: h,
        className: q(r, ve.root),
        style: o,
        classNames: {
          ...L,
          root: q(L.root, n == null ? void 0 : n.root),
          label: q(ve.label, n == null ? void 0 : n.label),
          description: q(L.description, n == null ? void 0 : n.description),
          error: q(L.error, ve.error, n == null ? void 0 : n.error)
        },
        __staticSelector: T,
        errorProps: et,
        descriptionProps: $e,
        labelProps: Oe,
        inputContainer: de,
        inputWrapperOrder: ae,
        unstyled: ee,
        withAsterisk: we,
        "data-testid": "datepicker-input",
        ...Jt,
        ...i
      },
      /* @__PURE__ */ g.createElement(
        Hn,
        {
          __staticSelector: T,
          withinPortal: G,
          offset: 10,
          opened: I,
          transitionProps: {
            transition: b,
            duration: w
          },
          positionDependencies: J,
          middlewares: { flip: A === "flip", shift: !1 },
          position: A === "flip" ? "bottom-start" : A,
          shadow: y,
          onClose: un,
          trapFocus: !l,
          withRoles: !1,
          clickOutsideEvents: Le,
          zIndex: ne,
          classNames: n,
          unstyled: ee
        },
        /* @__PURE__ */ g.createElement(Hn.Target, null, /* @__PURE__ */ g.createElement("div", { className: L.wrapper, ref: je }, /* @__PURE__ */ g.createElement(
          vi,
          {
            classNames: {
              ...n,
              ...ve,
              wrapper: q(ve.wrapper, L.wrapper, n == null ? void 0 : n.wrapper),
              input: q(ve.input, L.input, n == null ? void 0 : n.input),
              section: q(ve.section, L.leftSection, L.rightSection, { [ve.iconDisabled]: Ze })
            },
            "data-free-input": l || void 0,
            "data-testid": "datepicker-data-free-input",
            onKeyDown: vn,
            id: De,
            ref: dc(e, pt),
            __staticSelector: T,
            name: re,
            placeholder: p,
            value: v,
            required: s,
            "data-invalid": !!u,
            readOnly: !l,
            leftSection: ht || /* @__PURE__ */ g.createElement(pC, { className: ve.section, color: Qe.other.colors.greyIron[13] }),
            rightSection: (
              // It is not valid to put <button> inside <button> element, so we have to use 'div' here
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
              /* @__PURE__ */ g.createElement("div", { className: q(L.rightSectionWrapper, { [L.rightSectionWrapperDisabled]: Ze }) }, F && v ? /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(
                ye,
                {
                  "aria-label": V,
                  tabIndex: Ie,
                  className: L.clearButton,
                  elementVariant: Q.SecondaryMainLine,
                  leftSection: /* @__PURE__ */ g.createElement(nf, { color: Qe.other.colors.greyIron[13] }),
                  isIconOnly: !0,
                  style: { width: m(36), height: m(36) },
                  onClick: () => P == null ? void 0 : P(),
                  "data-testid": "datepicker-clear-button"
                }
              ), !v && /* @__PURE__ */ g.createElement(il, { className: L.rightSectionDivider, orientation: "vertical", height: 20 })) : "", !v && (Je || /* @__PURE__ */ g.createElement(
                Sr,
                {
                  className: q(L.chevron, { [L.chevronOpened]: I }),
                  color: Qe.other.colors.greyIron[13]
                }
              )))
            ),
            rightSectionWidth: 36,
            onBlur: qt,
            onFocus: ct,
            onChange: se,
            autoComplete: "off",
            unstyled: ee,
            disabled: Ze,
            ...Un,
            onClick: () => l ? bn() : Ut()
          }
        ))),
        R === "popover" ? /* @__PURE__ */ g.createElement(Hn.Dropdown, { className: L.dropdown, ref: Mt }, /* @__PURE__ */ g.createElement("div", { "data-mantine-stop-propagation": I, onKeyDownCapture: Dn, "aria-hidden": l || void 0 }, E)) : /* @__PURE__ */ g.createElement(
          ef,
          {
            ...Y,
            opened: I,
            onClose: un,
            withCloseButton: !1,
            size: tt * 400,
            zIndex: Ce,
            unstyled: ee
          },
          E
        )
      )
    );
  }
);
mf.displayName = "DatePickerBase";
const yT = {
  shadow: "sm",
  transitionDuration: 200,
  closeCalendarOnChange: !0,
  labelFormat: "MMMM yyyy",
  initiallyOpened: !1,
  name: "date",
  elementSize: mt.M,
  dropdownType: "popover",
  dropdownPosition: "flip",
  clearable: !0,
  disabled: !1,
  fixOnBlur: !0,
  withinPortal: !1,
  firstDayOfWeek: "monday",
  openDropdownOnClear: !1,
  variant: "static"
}, bT = ge((t, e) => {
  const {
    value: n,
    onChange: r,
    defaultValue: o,
    classNames: i,
    shadow: s,
    locale: l,
    inputFormat: a,
    transitionDuration: c,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    transitionTimingFunction: d,
    nextMonthLabel: u,
    previousMonthLabel: f,
    closeCalendarOnChange: h,
    labelFormat: p,
    dayClassName: y,
    dayStyle: b,
    disableOutsideEvents: w,
    minDate: S,
    maxDate: x,
    excludeDate: E,
    initialMonth: v,
    initiallyOpened: T,
    name: I,
    elementSize: M,
    dropdownType: R,
    dropdownPosition: A,
    clearable: F,
    disabled: V,
    clearButtonLabel: P,
    fixOnBlur: J,
    allowFreeInput: ne,
    withinPortal: G,
    dateParser: H,
    firstDayOfWeek: W,
    onFocus: se,
    onBlur: U,
    amountOfMonths: re,
    allowLevelChange: ke,
    initialLevel: Te,
    onDropdownClose: Se,
    onDropdownOpen: Le,
    hideOutsideDates: Ce,
    hideWeekdays: et,
    renderDay: Oe,
    type: $e,
    openDropdownOnClear: Ie,
    unstyled: ee,
    weekendDays: de,
    yearLabelFormat: ae,
    nextDecadeLabel: Y,
    nextYearLabel: we,
    previousDecadeLabel: Ze,
    previousYearLabel: Je,
    error: ht,
    variant: Xe,
    ...Lt
  } = he("DatePicker", yT, t), Be = mr(Ge.greaterThen("sm", !1)), St = Xe === "responsive" && !Be ? "xs" : R === "modal" ? "lg" : "md", Mt = l || "en", nt = $e === "date" ? "yyyy-MM-dd" : a || _0, [je, Qe] = ie(T), L = Nt(null), [q, ve] = ie(o ?? null), [De, pt] = an({
    value: n,
    defaultValue: o,
    finalValue: null,
    onChange: r
  }), [un, bn] = ie(De || v || /* @__PURE__ */ new Date()), [Ut, Dn] = ie(!1), [qt, ct] = ie(
    De instanceof Date ? oo(_.fromJSDate(De).setLocale(Mt).toFormat(nt)) : ""
  ), vn = () => {
    Qe(!1), Se == null || Se();
  }, Jt = () => {
    Qe(!0), Le == null || Le();
  };
  It(() => {
    n === null && !Ut && ct(""), n instanceof Date && !Ut && ct(oo(_.fromJSDate(n).setLocale(Mt).toFormat(nt)));
  }, [n, Ut]);
  const Un = (Pe) => {
    pt(Pe), ct(oo(_.fromJSDate(Pe).setLocale(Mt).toFormat(nt))), h && vn(), window.setTimeout(() => {
      var xn;
      return (xn = L.current) == null ? void 0 : xn.focus();
    }, 0);
  }, Ct = () => {
    var Pe;
    pt(null), ve(null), ct(""), Ie && Jt(), (Pe = L.current) == null || Pe.focus();
  }, An = (Pe) => H ? H(Pe) : _.fromFormat(Pe, nt).setLocale(Mt).toJSDate(), jr = () => {
    let Pe = typeof De == "string" ? An(De) : De;
    x && Pe && _.fromJSDate(Pe) > _.fromJSDate(x) && (Pe = x), S && Pe && _.fromJSDate(Pe) < _.fromJSDate(S) && (Pe = S), Pe && _.fromJSDate(Pe).isValid ? (pt(Pe), ve(Pe), ct(oo(_.fromJSDate(Pe).setLocale(Mt).toFormat(nt))), bn(Pe)) : J && pt(q);
  }, qn = (Pe) => {
    typeof U == "function" && U(Pe), Dn(!1), ne && jr();
  }, Eo = (Pe) => {
    Pe.key === "Enter" && ne && (vn(), jr());
  }, gt = (Pe) => {
    typeof se == "function" && se(Pe), Dn(!0);
  }, Jn = (Pe) => {
    Jt();
    const xn = An(Pe.target.value);
    _.fromJSDate(xn).isValid ? (pt(xn), ve(xn), ct(Pe.target.value), bn(xn)) : ct(Pe.target.value);
  };
  return /* @__PURE__ */ g.createElement(
    mf,
    {
      allowFreeInput: ne,
      dropdownOpened: !!je,
      setDropdownOpened: Qe,
      shadow: s,
      transitionDuration: c,
      ref: dc(e, L),
      elementSize: M,
      classNames: i,
      onChange: Jn,
      onBlur: qn,
      onFocus: gt,
      onKeyDown: Eo,
      name: I,
      inputLabel: qt,
      __staticSelector: "DatePicker",
      dropdownType: R,
      dropdownPosition: A,
      clearable: $e === "date" ? !1 : F && !!De && !V,
      clearButtonLabel: P,
      onClear: Ct,
      disabled: V,
      withinPortal: G,
      amountOfMonths: re,
      onDropdownClose: Se,
      onDropdownOpen: Le,
      type: $e,
      unstyled: ee,
      error: ht,
      variant: Xe,
      ...Lt
    },
    /* @__PURE__ */ g.createElement(
      H0,
      {
        classNames: i,
        locale: Mt,
        nextMonthLabel: u,
        previousMonthLabel: f,
        month: ne ? un : void 0,
        initialMonth: v || (De instanceof Date ? De : /* @__PURE__ */ new Date()),
        onMonthChange: bn,
        value: De instanceof Date ? De : _.fromJSDate(De).toJSDate(),
        onChange: Un,
        labelFormat: p,
        dayClassName: y,
        dayStyle: b,
        disableOutsideEvents: w,
        minDate: S,
        maxDate: x,
        excludeDate: E,
        __staticSelector: "DatePicker",
        fullWidth: R === "modal",
        __stopPropagation: R !== "modal",
        size: St,
        firstDayOfWeek: W,
        preventFocus: ne,
        amountOfMonths: re,
        allowLevelChange: ke,
        initialLevel: Te,
        hideOutsideDates: Ce,
        hideWeekdays: et,
        renderDay: Oe,
        weekendDays: de,
        yearLabelFormat: ae,
        nextDecadeLabel: Y,
        nextYearLabel: we,
        previousDecadeLabel: Ze,
        previousYearLabel: Je,
        variant: Xe
      }
    )
  );
});
bT.displayName = "DatePicker";
var _e = /* @__PURE__ */ ((t) => (t[t.Today = 0] = "Today", t[t.Yesterday = 1] = "Yesterday", t[t.Last7days = 2] = "Last7days", t[t.ThisWeek = 3] = "ThisWeek", t[t.Last30Days = 4] = "Last30Days", t[t.LastMonth = 5] = "LastMonth", t[t.ThisMonth = 6] = "ThisMonth", t[t.Last3Months = 7] = "Last3Months", t[t.Last6Months = 8] = "Last6Months", t[t.ThisYear = 9] = "ThisYear", t[t.LastYear = 10] = "LastYear", t[t.AllTime = 11] = "AllTime", t))(_e || {});
const wT = [
  _e.AllTime,
  _e.Today,
  _e.Yesterday,
  _e.Last7days,
  _e.ThisWeek,
  _e.Last30Days,
  _e.ThisMonth,
  _e.LastMonth,
  _e.Last3Months,
  _e.Last6Months,
  _e.ThisYear,
  _e.LastYear
], ST = {
  [_e.Today]: "Today",
  [_e.Yesterday]: "Yesterday",
  [_e.Last7days]: "Last 7 days",
  [_e.ThisWeek]: "This week",
  [_e.Last30Days]: "Last 30 days",
  [_e.ThisMonth]: "This month",
  [_e.LastMonth]: "Last month",
  [_e.Last3Months]: "Last 3 months",
  [_e.Last6Months]: "Last 6 months",
  [_e.ThisYear]: "This year",
  [_e.LastYear]: "Last year",
  [_e.AllTime]: "All time"
}, wn = (t) => t.set({ minute: 0, hour: 0, millisecond: 0, second: 0 }), CT = (t, e) => {
  const n = wn(_.now()), r = n.minus({ day: 1 }).toJSDate(), o = n.minus({ day: 6 }).toJSDate(), i = wn(n.startOf("week")).toJSDate(), s = wn(n.endOf("week")).toJSDate(), l = n.minus({ day: 30 }).plus({ day: 1 }).toJSDate(), a = wn(n.minus({ month: 1 }).startOf("month")).toJSDate(), c = wn(n.minus({ month: 1 }).endOf("month")).toJSDate(), d = wn(n.startOf("month")).toJSDate(), u = wn(n.endOf("month")).toJSDate(), f = wn(n.minus({ month: 3 })).toJSDate(), h = wn(n.minus({ month: 6 })).toJSDate(), p = wn(n.startOf("year")).toJSDate(), y = wn(n.endOf("year")).toJSDate(), b = wn(n.minus({ year: 1 }).startOf("year")).toJSDate(), w = wn(n.minus({ year: 1 }).endOf("year")).toJSDate(), S = wn(n.set({ year: 1970, month: 1, day: 1 })).toJSDate();
  return {
    [_e.Today]: [n.toJSDate(), n.toJSDate()],
    [_e.Yesterday]: [r, r],
    [_e.Last7days]: [o, n.toJSDate()],
    [_e.ThisWeek]: [i, s],
    [_e.Last30Days]: [l, n.toJSDate()],
    [_e.ThisMonth]: [d, u],
    [_e.LastMonth]: [a, c],
    [_e.Last3Months]: [f, n.toJSDate()],
    [_e.Last6Months]: [h, n.toJSDate()],
    [_e.ThisYear]: [p, y],
    [_e.LastYear]: [b, w],
    [_e.AllTime]: [t || S, e || y]
  };
}, vT = O(
  (t, {
    leftSectionSize: e,
    leftSectionOffset: n,
    isIconOnly: r,
    rotateRightIcon: o,
    description: i
  }) => {
    const l = e || 24, a = 12, c = n || 8, d = l + a + c;
    return {
      root: {
        height: i ? "auto" : m(40),
        minHeight: m(40),
        padding: `${t.other.spacings[8]} ${t.other.spacings[a]}`,
        borderRadius: t.other.borderRadius[8],
        backgroundColor: "transparent",
        transition: Ae(["background-color", "outline-color", "color"]),
        outline: `${m(4)} solid transparent !important`,
        outlineOffset: m(-4),
        "&:hover": {
          backgroundColor: t.other.colors.greyIron[2]
        },
        '&:focus-visible:not(&[data-disabled="true"])': {
          outlineColor: `${t.other.colors.greyIron[4]} !important`,
          outlineOffset: m(-4)
        },
        "&:active": {
          backgroundColor: t.other.colors.greyIron[3],
          color: t.other.colors.greyIron[20]
        },
        "&[data-active]": {
          backgroundColor: t.other.colors.greyIron[2],
          "&:hover": {
            backgroundColor: t.other.colors.greyIron[3]
          },
          "&:active": {
            backgroundColor: t.other.colors.greyIron[4]
          }
        },
        "&[data-disabled]": {
          opacity: 1,
          [`& .${py}`]: {
            color: t.other.colors.greyIron[9]
          },
          [`& .${gy}`]: {
            color: t.other.colors.greyIron[9]
          },
          [`& .${my}`]: {
            color: t.other.colors.greyIron[9]
          }
        }
      },
      section: {
        '&[data-position="left"]': {
          width: m(l),
          height: m(l),
          marginRight: r ? 0 : m(c),
          marginLeft: 0,
          marginTop: 0,
          marginBottom: 0,
          paddingTop: 0,
          color: t.other.colors.greyIron[12],
          alignSelf: "flex-start",
          svg: {
            width: m(l),
            height: m(l)
          }
        },
        '&[data-position="right"]': {
          height: m(24),
          minWidth: m(24),
          color: t.other.colors.greyIron[12],
          transition: Ae(["transform"]),
          "&[data-rotate]": {
            transform: o ? "rotate(180deg)" : "none"
          },
          svg: {
            width: m(24),
            height: m(24)
          }
        }
      },
      chevron: {
        display: "none"
      },
      children: {
        [`& .${hy}`]: {
          paddingLeft: m(d)
        }
      },
      label: {
        font: t.other.fonts.desktop.s.s.buttons,
        color: t.other.colors.greyIron[18]
      },
      body: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      },
      description: {
        display: "flex",
        flexDirection: "column",
        font: t.other.fonts.desktop.s.s.default,
        color: t.other.colors.greyIron[12],
        lineHeight: m(20)
      }
    };
  }
), Mi = ge(
  ({
    children: t,
    component: e,
    to: n,
    leftSection: r,
    leftSectionSize: o,
    leftSectionOffset: i,
    rightSection: s,
    isIconOnly: l,
    rotateRightIcon: a = !0,
    description: c,
    className: d,
    classNames: u,
    ...f
  }, h) => {
    const { classes: p, cx: y } = vT({ leftSectionSize: o, leftSectionOffset: i, isIconOnly: l, rotateRightIcon: a, description: c }), { label: b, ...w } = f, x = !!t ? /* @__PURE__ */ g.createElement(Sr, null) : void 0;
    return /* @__PURE__ */ g.createElement(
      BS,
      {
        className: d,
        classNames: {
          ...p,
          root: y(p.root, u == null ? void 0 : u.root),
          body: y(p.body, u == null ? void 0 : u.body),
          section: y(p.section, u == null ? void 0 : u.section),
          label: y(p.label, u == null ? void 0 : u.label),
          description: y(p.description, u == null ? void 0 : u.description)
        },
        component: e,
        to: n,
        childrenOffset: 0,
        leftSection: r,
        rightSection: s || x,
        label: !l && b,
        description: c,
        ref: h,
        ...w
      },
      t
    );
  }
);
Mi.displayName = "NavLink";
const xT = {
  __staticSelector: "RangeCalendar",
  allowSingleDateInRange: !1,
  amountOfMonths: 1
}, j0 = ge(
  (t, e) => {
    const { value: n, onChange: r, dayStyle: o, onMouseLeave: i, __staticSelector: s, allowSingleDateInRange: l, amountOfMonths: a, paginateBy: c, locale: d, ...u } = he("RangeCalendar", xT, t), [f, h] = ie(null), [p, y] = ie(null), b = (I) => {
      if (p instanceof Date) {
        if (pn(I, p) && !l)
          return y(null), h(null), null;
        const M = [I, p];
        return M.sort((R, A) => R.getTime() - A.getTime()), r(M), y(null), null;
      }
      return n[0] && pn(I, n[0]) && !l ? (y(null), h(null), r([null, null]), null) : (r([I, null]), y(I), null);
    }, w = (I) => {
      typeof i == "function" && i(I), h(null);
    }, S = (I, M) => {
      if (p instanceof Date && f instanceof Date) {
        const R = [f, p];
        return R.sort((A, F) => A.getTime() - F.getTime()), !M.selected && _.fromJSDate(I).minus({ day: 1 }) < _.fromJSDate(R[1]) && _.fromJSDate(I).plus({ day: 1 }) > _.fromJSDate(R[0]);
      }
      return !1;
    }, x = (I, M) => {
      if (p instanceof Date && f instanceof Date) {
        const R = [f, p];
        return R.sort((A, F) => A.getTime() - F.getTime()), M.selected && _.fromJSDate(I) < _.fromJSDate(R[1]);
      }
      return !1;
    }, E = (I) => {
      if (p instanceof Date && f instanceof Date) {
        const M = [f, p];
        return M.sort((R, A) => R.getTime() - A.getTime()), _.fromJSDate(I) < _.fromJSDate(M[1]) && pn(I, M[0]);
      }
      return !1;
    }, v = (I) => {
      if (p instanceof Date && f instanceof Date) {
        const M = [f, p];
        return M.sort((R, A) => R.getTime() - A.getTime()), _.fromJSDate(I) > _.fromJSDate(M[0]) && pn(I, M[1]);
      }
      return !1;
    }, T = (I, M) => {
      if (p instanceof Date && f instanceof Date) {
        const R = [f, p];
        return R.sort((A, F) => A.getTime() - F.getTime()), M.selected && _.fromJSDate(I) > _.fromJSDate(R[0]);
      }
      return !1;
    };
    return /* @__PURE__ */ g.createElement(
      gf,
      {
        locale: d,
        dayStyle: o,
        onMouseLeave: w,
        onDayMouseEnter: (I) => h(I),
        onChange: b,
        value: p,
        range: n,
        ref: e,
        __staticSelector: s,
        amountOfMonths: a,
        paginateBy: c || a,
        hideOutsideDates: Number(a) > 1,
        isDateInRange: S,
        isDateFirstInRange: x,
        isDateLastInRange: T,
        isFirstInRangeHovered: E,
        isLastInRangeHovered: v,
        ...u
      }
    );
  }
);
j0.displayName = "RangeCalendar";
const ET = O((t, { variant: e }) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: `${m(6)} !important`,
    lineHeight: m(20)
  },
  fastRangePanel: {
    borderBottom: e === "responsive" ? `${m(1)} solid ${t.other.colors.greyIron[4]}` : "none",
    borderRight: e === "responsive" ? "none" : `${m(1)} solid ${t.other.colors.greyIron[4]}`,
    [Ge.greaterThen("md")]: {
      borderBottom: "none",
      borderRight: `${m(1)} solid ${t.other.colors.greyIron[4]}`
    }
  },
  fastRangePanelItem: {
    font: t.other.fonts.desktop.s.s.default
  }
})), ip = (t) => Array.isArray(t) && t.length === 2 && t.every((e) => e instanceof Date), kT = (t) => Array.isArray(t) && t.length === 2 && t[0] instanceof Date, TT = {
  shadow: "sm",
  transitionDuration: 200,
  closeCalendarOnChange: !0,
  labelFormat: "MMMM yyyy",
  initiallyOpened: !1,
  elementSize: mt.M,
  dropdownType: "popover",
  labelSeparator: "—",
  clearable: !0,
  firstDayOfWeek: "monday",
  allowSingleDateInRange: !1,
  amountOfMonths: 1,
  withinPortal: !1,
  openDropdownOnClear: !1,
  variant: "static"
}, IT = ge(
  // eslint-disable-next-line sonarjs/cognitive-complexity
  (t, e) => {
    const {
      value: n,
      onChange: r,
      defaultValue: o,
      classNames: i,
      shadow: s,
      locale: l,
      inputFormat: a,
      transitionDuration: c,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      transitionTimingFunction: d,
      nextMonthLabel: u,
      previousMonthLabel: f,
      closeCalendarOnChange: h,
      labelFormat: p,
      dayClassName: y,
      dayStyle: b,
      disableOutsideEvents: w,
      minDate: S,
      maxDate: x,
      excludeDate: E,
      initialMonth: v,
      initiallyOpened: T,
      elementSize: I,
      dropdownType: M,
      labelSeparator: R,
      clearable: A,
      clearButtonLabel: F,
      firstDayOfWeek: V,
      allowLevelChange: P,
      allowSingleDateInRange: J,
      amountOfMonths: ne,
      withinPortal: G,
      initialLevel: H,
      onDropdownClose: W,
      onDropdownOpen: se,
      hideOutsideDates: U,
      hideWeekdays: re,
      renderDay: ke,
      openDropdownOnClear: Te,
      unstyled: Se,
      weekendDays: Le,
      yearLabelFormat: Ce,
      nextDecadeLabel: et,
      nextYearLabel: Oe,
      previousDecadeLabel: $e,
      previousYearLabel: Ie,
      labelIcon: ee,
      labelIconTooltipText: de,
      onClear: ae,
      withFastPanel: Y,
      fastPanelLabels: we,
      defaultFastPanelFilterActive: Ze,
      variant: Je = "static",
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onDayMouseEnter: ht,
      ...Xe
    } = he("DateRangePicker", TT, t), Lt = mr(Ge.greaterThen("md", !1)), Be = mr(Ge.greaterThen("sm", !1)), St = Je === "responsive" && !Be ? "xs" : M === "modal" ? "lg" : "md", [Mt, nt] = ie(), [je, Qe] = ie(
      Ze || null
    ), L = Je === "responsive" && !Lt ? pf : ne, { classes: q, cx: ve } = ET({ variant: Je }), De = {
      root: ve(q.root, i == null ? void 0 : i.root),
      fastRangePanel: ve(q.fastRangePanel, i == null ? void 0 : i.fastRangePanel),
      fastRangePanelItem: ve(q.fastRangePanelItem, i == null ? void 0 : i.fastRangePanelItem)
    }, pt = l || "en", un = a || _0, [bn, Ut] = ie(T), Dn = Nt(null), [qt, ct] = an({
      value: n,
      defaultValue: o,
      finalValue: [null, null],
      onChange: r
    }), vn = (gt) => {
      ct(gt), h && ip(gt) && (Ut(!1), W == null || W(), window.setTimeout(() => {
        var Jn;
        return (Jn = Dn.current) == null ? void 0 : Jn.focus();
      }, 0));
    }, Jt = (gt) => () => {
      Qe(null), nt(gt), vn(CT(S, x)[gt]);
    }, Un = ip(qt), Ct = kT(qt), An = qt[0] ? oo(_.fromJSDate(qt[0]).setLocale(pt).toFormat(un)) : "", jr = qt[1] ? oo(_.fromJSDate(qt[1]).setLocale(pt).toFormat(un)) : "", qn = () => {
      var gt;
      Qe(Ze || null), ae ? ae() : ct([null, null]), Ut(!0), Te && (se == null || se()), (gt = Dn.current) == null || gt.focus();
    }, Eo = (gt) => {
      !gt && Ct && qt[1] === null && qn(), Ut(gt);
    };
    return /* @__PURE__ */ g.createElement(
      mf,
      {
        dropdownOpened: !!bn,
        setDropdownOpened: Eo,
        shadow: s,
        transitionDuration: c,
        ref: dc(e, Dn),
        elementSize: I,
        classNames: De,
        inputLabel: Ct ? `${An} ${R} ${jr}` : "",
        labelIcon: ee,
        labelIconTooltipText: de,
        __staticSelector: "DateRangePicker",
        dropdownType: M,
        clearable: A && Ct,
        clearButtonLabel: F,
        onClear: qn,
        withinPortal: G,
        amountOfMonths: L,
        onDropdownClose: W,
        onDropdownOpen: se,
        unstyled: Se,
        variant: Je,
        ...Xe
      },
      /* @__PURE__ */ g.createElement(gr, { direction: Je === "responsive" ? { base: "column", md: "row" } : "row", wrap: "nowrap", gap: 0, align: "stretch", w: "fit-content" }, Y && /* @__PURE__ */ g.createElement(
        Fr,
        {
          h: Je === "responsive" ? { base: 80, md: 400 } : 400,
          w: Je === "responsive" ? { base: 280, sm: 320, md: 192 } : 192,
          styles: { thumb: { opacity: "0.3!important" } },
          type: "auto",
          scrollbars: Je === "responsive" && !Lt ? "x" : "y",
          className: De.fastRangePanel
        },
        /* @__PURE__ */ g.createElement(gr, { direction: Je === "responsive" ? { base: "row", md: "column" } : "column", p: 20, gap: 4 }, wT.map((gt) => /* @__PURE__ */ g.createElement(
          Mi,
          {
            key: gt,
            component: "button",
            classNames: {
              label: ve({
                [De.fastRangePanelItem]: (je || Mt) !== gt
              })
            },
            label: (we == null ? void 0 : we[gt]) || ST[gt],
            onClick: Jt(gt),
            flex: Je === "responsive" ? "1 0" : void 0,
            miw: Je === "responsive" ? { base: "fit-content", md: void 0 } : void 0
          }
        )))
      ), /* @__PURE__ */ g.createElement(
        j0,
        {
          locale: pt,
          nextMonthLabel: u,
          previousMonthLabel: f,
          initialMonth: (Un ? qt[0] : v) || void 0,
          value: qt,
          onChange: vn,
          labelFormat: p,
          dayClassName: y,
          dayStyle: b,
          disableOutsideEvents: w,
          minDate: S,
          maxDate: x,
          excludeDate: E,
          fullWidth: M === "modal",
          firstDayOfWeek: V,
          size: St,
          allowLevelChange: P,
          allowSingleDateInRange: J,
          amountOfMonths: L,
          initialLevel: H,
          hideOutsideDates: U,
          hideWeekdays: re,
          renderDay: ke,
          weekendDays: Le,
          yearLabelFormat: Ce,
          nextDecadeLabel: et,
          nextYearLabel: Oe,
          previousDecadeLabel: $e,
          previousYearLabel: Ie
        }
      ))
    );
  }
);
IT.displayName = "DateRangePicker";
const W0 = qo({
  colorScheme: "light",
  toggleColorScheme: () => {
    throw new Error('You need to implement "toggleColorScheme"');
  }
}), iz = () => {
  const t = Pi(W0);
  if (!t)
    throw new Error("useColorScheme hook was called outside of context, make sure your app is wrapped with ColorSchemeProvider component");
  return t;
}, G0 = ({ colorScheme: t, toggleColorScheme: e, children: n }) => /* @__PURE__ */ g.createElement(W0.Provider, { value: { colorScheme: t, toggleColorScheme: e } }, n);
G0.displayName = "ColorSchemeProvider";
const sz = ({ children: t, ...e }) => /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(yv, { containerWidth: 495, position: "top-right", ...e }), t), Kc = "border-box", lz = ({
  children: t,
  colorThemes: e,
  defaultColorScheme: n = "light",
  globalHtmlStyles: r = {},
  globalBodyStyles: o = {},
  getGlobalBodyStyles: i,
  withGlobalStyles: s = !0,
  contentMaxWidth: l,
  contentMinWidth: a
}) => {
  const [c, d] = ie(n), u = te((h) => d(h), []), f = me(
    () => {
      var h;
      return VS({
        ...hi,
        other: {
          ...hi.other,
          colorScheme: c,
          colors: {
            ...(h = hi.other) == null ? void 0 : h.colors,
            ...e == null ? void 0 : e[c]
          },
          contentMaxWidth: l,
          contentMinWidth: a
        },
        components: {
          ...hi.components,
          ScrollArea: Fr.extend({
            styles: (p) => ({
              scrollbar: {
                padding: 4,
                "&, &:hover": {
                  background: "transparent"
                },
                '&[data-orientation="vertical"] .mantine-ScrollArea-thumb': {
                  backgroundColor: p.other.colors.greyIron[13],
                  opacity: "30%"
                },
                '&[data-orientation="horizontal"] .mantine-ScrollArea-thumb': {
                  backgroundColor: p.other.colors.greyIron[13],
                  opacity: "30%"
                }
              }
            })
          })
        }
      });
    },
    [c, e, l, a]
  );
  return /* @__PURE__ */ g.createElement(G0, { colorScheme: c, toggleColorScheme: u }, /* @__PURE__ */ g.createElement(FS, null, /* @__PURE__ */ g.createElement(NS, { theme: f, stylesTransform: nv }, /* @__PURE__ */ g.createElement(rv, null, s && /* @__PURE__ */ g.createElement(
    ov,
    {
      styles: (h) => ({
        html: {
          WebkitBoxSizing: Kc,
          boxSizing: Kc,
          webkitTextSizeAdjust: "100%",
          msOverflowStyle: "scrollbar",
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
          minHeight: "100%",
          "* svg path": {
            vectorEffect: "non-scaling-stroke"
          },
          ...r
        },
        body: {
          maxWidth: h.other.contentMaxWidth,
          minWidth: h.other.contentMinWidth,
          margin: "0 auto",
          overflow: "hidden",
          boxSizing: Kc,
          backgroundColor: h.other.colors.greyIron[0],
          ...i == null ? void 0 : i(h),
          ...o
        }
      })
    }
  ), t))));
}, MT = O((t) => ({
  root: {
    "--drawer-size": m(512),
    [Ge.lessThen("sm")]: {
      "--drawer-size": "100%"
    }
  },
  inner: {
    left: 0,
    right: 0
  },
  content: {},
  contentScrollArea: {
    flexGrow: 1,
    padding: `0 ${t.other.spacings[32]}`,
    [Ge.lessThen("sm")]: {
      padding: `0 ${t.other.spacings[16]}`
    }
  },
  header: {
    height: 80,
    margin: 0,
    padding: `${t.other.spacings[24]} ${t.other.spacings[32]} ${t.other.spacings[16]} ${t.other.spacings[32]}`,
    [Ge.lessThen("sm")]: {
      padding: t.other.spacings[16]
    }
  },
  overlay: {
    backgroundColor: t.other.colors.greyIron[16],
    opacity: "0.8 !important"
  },
  title: {},
  body: {
    height: `calc(100% - ${m(80)})`,
    padding: 0,
    flexGrow: 1,
    display: "flex",
    flexDirection: "column"
  },
  drawer: {
    display: "flex",
    flexDirection: "column"
  },
  close: {
    width: m(40),
    height: m(40),
    padding: 0,
    svg: {
      width: `${m(16)} !important`,
      height: `${m(16)} !important`
    }
  },
  footer: {
    borderTop: `${m(1)} solid ${t.other.colors.greyIron[4]}`,
    padding: `${t.other.spacings[16]} ${t.other.spacings[32]}`,
    [Ge.lessThen("sm")]: {
      padding: t.other.spacings[16]
    }
  }
})), RT = {
  position: "right",
  withFooter: !0
}, OT = (t) => {
  const {
    children: e,
    withFooter: n,
    footerButtonLeftProperties: r,
    footerButtonRightProperties: o,
    onClose: i,
    onFooterButtonLeftClick: s,
    onFooterButtonRightClick: l,
    classNames: a,
    className: c,
    ...d
  } = he("Drawer", RT, t), { classes: u, cx: f } = Iy({
    elementSize: Ue.M,
    iconSize: 20,
    isIconOnly: !1,
    isRound: !0,
    isLoading: !1
  }), { classes: h } = Ay(), { classes: p } = MT(), y = te(() => {
    i == null || i();
  }, [i]);
  return /* @__PURE__ */ g.createElement(
    zS,
    {
      classNames: {
        ...p,
        inner: f(p.inner, a == null ? void 0 : a.inner),
        content: f(p.content, a == null ? void 0 : a.content),
        header: f(p.header, a == null ? void 0 : a.header),
        overlay: f(p.overlay, a == null ? void 0 : a.overlay),
        title: f(p.title, a == null ? void 0 : a.title),
        body: f(p.body, a == null ? void 0 : a.body),
        close: f(u.root, h.tertiaryMain, p.close, a == null ? void 0 : a.close)
      },
      className: c,
      onClose: y,
      "data-testid": "drawer-root-container",
      ...d
    },
    /* @__PURE__ */ g.createElement(Fr, { className: p.contentScrollArea }, e),
    n && /* @__PURE__ */ g.createElement(gr, { direction: { base: "column", sm: "row" }, gap: 12, className: p.footer }, /* @__PURE__ */ g.createElement(
      ye,
      {
        onClick: s,
        elementVariant: Q.TertiaryMain,
        elementSize: Ue.M,
        fullWidth: !0,
        "data-testid": "drawer-footer-button-left",
        ...r
      },
      (r == null ? void 0 : r.children) || "Cancel"
    ), /* @__PURE__ */ g.createElement(
      ye,
      {
        onClick: l,
        elementVariant: Q.PrimaryMain,
        elementSize: Ue.M,
        fullWidth: !0,
        "data-testid": "drawer-footer-button-right",
        ...o
      },
      (o == null ? void 0 : o.children) || "Save"
    ))
  );
};
OT.displayName = "Drawer";
const yf = O((t, { elementSize: e }) => ({
  wrapper: {
    display: "flex"
  },
  targetElement: {},
  arrow: {},
  label: {},
  itemLabel: {},
  itemSection: {},
  dropdown: {
    borderColor: t.other.colors.greyIron[5],
    backgroundColor: t.other.colors.white[0],
    padding: hr(e, [t.other.spacings[12], t.other.spacings[8]]),
    borderRadius: t.other.borderRadius[8],
    boxShadow: t.other.shadows.s
  },
  item: {
    position: "relative",
    font: hr(e, [t.other.fonts.desktop.s.s.default, t.other.fonts.desktop.s.xs.default]),
    color: t.other.colors.greyIron[18],
    padding: hr(e, [`${t.other.spacings[8]} ${t.other.spacings[12]}`, t.other.spacings[8]]),
    marginBottom: m(2),
    borderRadius: t.other.borderRadius[8],
    wordBreak: "break-word",
    transition: Ae(["color", "background-color"]),
    '&[data-hovered="true"]': {
      backgroundColor: t.other.colors.greyIron[2],
      svg: {
        color: t.other.colors.brand[16]
      }
    },
    '&[data-current="true"]': {
      font: hr(e, [t.other.fonts.desktop.s.s.important, t.other.fonts.desktop.s.xs.important]),
      color: t.other.colors.brand[13],
      svg: {
        color: t.other.colors.brand[16]
      }
    },
    "&:hover": {
      backgroundColor: t.other.colors.greyIron[2],
      svg: {
        color: t.other.colors.brand[16]
      }
    },
    "&:active": {
      backgroundColor: t.other.colors.greyIron[3],
      svg: {
        color: t.other.colors.brand[16]
      }
    },
    "&:focus-visible": {
      backgroundColor: t.other.colors.greyIron[3],
      outline: "0 !important"
    },
    "&:disabled": {
      color: `${t.other.colors.greyIron[9]} !important`,
      svg: {
        color: t.other.colors.brand[9]
      }
    },
    "&:last-of-type": {
      marginBottom: 0
    },
    svg: {
      width: m(16),
      height: m(16),
      color: t.other.colors.brand[13],
      transition: Ae(["color"])
    }
  },
  divider: {
    margin: `${t.other.spacings[8]} 0`,
    borderColor: t.other.colors.greyIron[4]
  }
})), U0 = O((t, { elementSize: e }) => ({
  chevron: {
    width: m(hr(e, [20, 14])),
    height: m(hr(e, [20, 14])),
    transition: Ae(["transform"])
  },
  chevronOpened: {
    transform: "rotate(-180deg)"
  }
})), Zt = ({
  children: t,
  targetElementProps: e,
  hideTargetElementRightIcon: n,
  defaultOpened: r,
  onChange: o,
  classNames: i,
  elementSize: s = ln.M,
  position: l = "bottom-start",
  ...a
}) => {
  const [c, d] = ie(r), { classes: u, cx: f } = yf({ elementSize: s }), { classes: h } = U0({ elementSize: s }), p = te(
    (y) => {
      d(y), o == null || o(y);
    },
    [o]
  );
  return /* @__PURE__ */ g.createElement("div", { className: f(u.wrapper, i == null ? void 0 : i.wrapper) }, /* @__PURE__ */ g.createElement(
    Ls,
    {
      classNames: {
        ...u,
        dropdown: f(u.dropdown, i == null ? void 0 : i.dropdown),
        arrow: f(u.arrow, i == null ? void 0 : i.arrow),
        divider: f(u.divider, i == null ? void 0 : i.divider),
        label: f(u.label, i == null ? void 0 : i.label),
        item: f(u.item, i == null ? void 0 : i.item),
        itemLabel: f(u.itemLabel, i == null ? void 0 : i.itemLabel),
        itemSection: f(u.itemSection, i == null ? void 0 : i.itemSection)
      },
      transitionProps: {
        transition: "pop-top-left",
        duration: 300
      },
      position: l,
      ...a,
      opened: c,
      onChange: p
    },
    /* @__PURE__ */ g.createElement(Ls.Target, null, /* @__PURE__ */ g.createElement(
      ye,
      {
        className: f(u.targetElement, i == null ? void 0 : i.targetElement),
        elementSize: Ue[s],
        "data-testid": "dropdown-target",
        ...e,
        rightSection: n ? null : (e == null ? void 0 : e.rightSection) || /* @__PURE__ */ g.createElement(Sr, { className: f(h.chevron, { [h.chevronOpened]: c }) })
      }
    )),
    t
  ));
};
Zt.displayName = "Dropdown";
Zt.Item = Ls.Item;
Zt.Items = Ls.Dropdown;
Zt.Divider = Ls.Divider;
const DT = O(
  (t, { orientation: e = "horizontal", isLoading: n }) => ({
    root: {
      height: m(e === "horizontal" ? 250 : 504),
      width: m(e === "horizontal" ? 448 : 366),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: n ? t.other.colors.brand[0] : t.other.colors.white,
      cursor: n ? "not-allowed" : "pointer",
      border: `1px dashed ${t.other.colors.greyIron[7]}`,
      borderRadius: m(8),
      "&[data-accept]": {
        backgroundColor: `${t.other.colors.brand[0]} !important`,
        borderColor: t.other.colors.greyIron[7]
      },
      "&:hover": {
        backgroundColor: t.other.colors.brand[0]
      }
    },
    loader: {
      height: m(40),
      width: m(40),
      marginBottom: m(4)
    },
    disabled: {
      backgroundColor: n ? t.other.colors.brand[0] : t.other.colors.greyIron[2],
      cursor: "not-allowed",
      "&:hover": {
        backgroundColor: n ? t.other.colors.brand[0] : t.other.colors.greyIron[2]
      }
    },
    inner: {}
  })
), AT = {
  title: "or drag and drop"
}, az = (t) => {
  const {
    orientation: e,
    leftLinkText: n,
    rightLinkText: r,
    buttonText: o,
    title: i,
    description: s,
    isLoading: l,
    disabled: a,
    className: c,
    classNames: d,
    children: u,
    onDrop: f,
    ...h
  } = he("Dropzone", AT, t), { classes: p, cx: y } = DT({ orientation: e, isLoading: l }), b = !n && !r ? "Click to select files" : n, w = (S) => {
    f == null || f(S);
  };
  return /* @__PURE__ */ g.createElement(
    fl,
    {
      "data-testid": "dropzone-container",
      disabled: a || l,
      className: y(p.root, { [p.disabled]: a }, c),
      classNames: { ...p, ...d },
      onDrop: w,
      ...h
    },
    /* @__PURE__ */ g.createElement(Ee, { gap: 4, align: "center", "data-testid": "dropzone-content-wrapper" }, l && /* @__PURE__ */ g.createElement(sf, { classNames: { root: p.loader } }), !l && /* @__PURE__ */ g.createElement(X, { mb: 4 }, /* @__PURE__ */ g.createElement(fl.Accept, null, /* @__PURE__ */ g.createElement(Lo, { Icon: Mh })), /* @__PURE__ */ g.createElement(fl.Reject, null, /* @__PURE__ */ g.createElement(Lo, { Icon: Km, colorName: "raspberry" })), /* @__PURE__ */ g.createElement(fl.Idle, null, /* @__PURE__ */ g.createElement(Lo, { Icon: Mh }))), /* @__PURE__ */ g.createElement(X, { gap: 4 }, b && /* @__PURE__ */ g.createElement(ki, null, b), /* @__PURE__ */ g.createElement(xe, { elementSize: "s", elementVariant: "buttons", colorVariant: "greyIron.10" }, i), r && /* @__PURE__ */ g.createElement(ki, null, r)), /* @__PURE__ */ g.createElement(xe, { elementSize: "xs", elementVariant: "default", colorVariant: "greyIron.10" }, s), o && /* @__PURE__ */ g.createElement(ye, { mt: 12, disabled: a || l, elementVariant: Q.SecondaryMain }, o), u)
  );
}, LT = O((t) => ({
  root: {},
  wrapper: {
    gap: 0,
    alignItems: "center",
    justifyContent: "center",
    maxWidth: m(558),
    margin: "0 auto"
  },
  code: {
    backgroundColor: t.other.colors.greyIron[3],
    padding: t.other.spacings[12],
    borderRadius: t.other.borderRadius[8]
  },
  icon: {},
  title: {},
  description: {}
})), cz = (t) => {
  const { code: e, title: n, description: r, children: o, className: i, classNames: s, style: l, withIcon: a, icon: c, ...d } = he("ErrorBlock", {}, t), { classes: u, cx: f } = LT(void 0);
  return /* @__PURE__ */ g.createElement(Ee, { gap: 24, className: f(u.wrapper, s == null ? void 0 : s.wrapper, i), style: l, ...d }, e && /* @__PURE__ */ g.createElement(Ti, { elementSize: "xxxl", order: 1, className: f(u.code, s == null ? void 0 : s.code), heavy: !0 }, e), a && (c || /* @__PURE__ */ g.createElement(Pt, { className: f(u.icon, s == null ? void 0 : s.icon), src: iv("SomethingWentWrong"), width: 156 })), /* @__PURE__ */ g.createElement(
    Ti,
    {
      className: f(u.title, s == null ? void 0 : s.title),
      elementSize: "xl",
      order: 2,
      sx: { textAlign: "center" },
      colorVariant: "greyIron.18",
      mt: e ? 26 : 0
    },
    n
  ), r && /* @__PURE__ */ g.createElement(
    xe,
    {
      className: u.description,
      elementSize: "s",
      elementVariant: "default",
      align: "center",
      colorVariant: "greyIron.18",
      maw: 350,
      mt: 8,
      mb: o ? 16 : 0
    },
    r
  ), o);
}, $T = (t, e) => {
  switch (t) {
    case Q.SecondaryMainLine:
      return e[0];
    case Q.TertiaryMain:
      return e[1];
    default:
      return e[0];
  }
}, PT = O((t, { checked: e, variant: n }) => {
  const r = e ? t.other.colors.sunflower[8] : t.other.colors.greyIron[10];
  return {
    root: {},
    input: {
      height: 0,
      width: 0,
      overflow: "hidden",
      whiteSpace: "nowrap",
      padding: 0,
      WebkitClipPath: "inset(50%)",
      clipPath: "inset(50%)",
      position: "absolute",
      [`&:focus-visible + .${sa}`]: {
        outlineOffset: 0,
        outline: `${m(2)} solid ${$T(n, [t.other.colors.greyIron[4], t.other.colors.greyIron[4]])}`
      },
      [`&:focus:not(:focus-visible) + .${sa}`]: {
        outline: "none",
        boxShadow: "none"
      }
    },
    iconWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: t.other.borderRadius[8]
    },
    icon: {
      svg: {
        fill: e ? t.other.colors.sunflower[8] : "none",
        color: `${r} !important`,
        width: m(20),
        height: m(20)
      }
    }
  };
}), _T = {
  elementVariant: "default",
  isStopPropagation: !1
}, BT = ge((t, e) => {
  const { className: n, isLoading: r, classNames: o, checked: i, defaultChecked: s, elementVariant: l, onChange: a, disabled: c, id: d, isStopPropagation: u, ...f } = he(
    "Favourite",
    _T,
    t
  ), h = Xm(d), [p, y] = an({
    value: i,
    defaultValue: s,
    finalValue: !1
  }), b = l === "button" ? Q.TertiaryMain : Q.SecondaryMainLine, { classes: w, cx: S } = PT({ checked: p, variant: b }), x = (v) => (a == null || a(v), y(v.currentTarget.checked), !1), E = (v) => u && v.stopPropagation();
  return /* @__PURE__ */ g.createElement(vi.Wrapper, { id: h, className: S(w.root, o == null ? void 0 : o.root, n), onClick: E, "data-testid": "favourite-button-wrapper" }, /* @__PURE__ */ g.createElement("label", { htmlFor: h, className: S(w.iconWrapper, w.iconWrapper, sa) }, /* @__PURE__ */ g.createElement(
    "input",
    {
      ...f,
      disabled: c,
      checked: p,
      onChange: x,
      ref: e,
      id: h,
      className: S(w.input, o == null ? void 0 : o.input),
      type: "checkbox"
    }
  ), /* @__PURE__ */ g.createElement(
    ye,
    {
      component: "div",
      "data-testid": "favourite-click-button",
      classNames: { section: S(w.icon, o == null ? void 0 : o.icon) },
      elementVariant: b,
      leftSection: /* @__PURE__ */ g.createElement(gC, null),
      isIconOnly: !0,
      isLoading: r
    }
  )));
});
BT.displayName = "Favourite";
const q0 = {
  static: "static"
};
var rr = Array.isArray, VT = Object.prototype;
function bf(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || VT;
  return t === n;
}
function J0(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var FT = J0(Object.keys, Object), NT = Object.prototype, zT = NT.hasOwnProperty;
function K0(t) {
  if (!bf(t))
    return FT(t);
  var e = [];
  for (var n in Object(t))
    zT.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var Y0 = typeof global == "object" && global && global.Object === Object && global, HT = typeof self == "object" && self && self.Object === Object && self, Cr = Y0 || HT || Function("return this")(), Gn = Cr.Symbol, Z0 = Object.prototype, jT = Z0.hasOwnProperty, WT = Z0.toString, Xi = Gn ? Gn.toStringTag : void 0;
function GT(t) {
  var e = jT.call(t, Xi), n = t[Xi];
  try {
    t[Xi] = void 0;
    var r = !0;
  } catch {
  }
  var o = WT.call(t);
  return r && (e ? t[Xi] = n : delete t[Xi]), o;
}
var UT = Object.prototype, qT = UT.toString;
function JT(t) {
  return qT.call(t);
}
var KT = "[object Null]", YT = "[object Undefined]", sp = Gn ? Gn.toStringTag : void 0;
function Yo(t) {
  return t == null ? t === void 0 ? YT : KT : sp && sp in Object(t) ? GT(t) : JT(t);
}
function ji(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var ZT = "[object AsyncFunction]", XT = "[object Function]", QT = "[object GeneratorFunction]", eI = "[object Proxy]";
function X0(t) {
  if (!ji(t))
    return !1;
  var e = Yo(t);
  return e == XT || e == QT || e == ZT || e == eI;
}
var Yc = Cr["__core-js_shared__"], lp = function() {
  var t = /[^.]+$/.exec(Yc && Yc.keys && Yc.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function tI(t) {
  return !!lp && lp in t;
}
var nI = Function.prototype, rI = nI.toString;
function Zo(t) {
  if (t != null) {
    try {
      return rI.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var oI = /[\\^$.*+?()[\]{}|]/g, iI = /^\[object .+?Constructor\]$/, sI = Function.prototype, lI = Object.prototype, aI = sI.toString, cI = lI.hasOwnProperty, dI = RegExp(
  "^" + aI.call(cI).replace(oI, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function uI(t) {
  if (!ji(t) || tI(t))
    return !1;
  var e = X0(t) ? dI : iI;
  return e.test(Zo(t));
}
function fI(t, e) {
  return t == null ? void 0 : t[e];
}
function Xo(t, e) {
  var n = fI(t, e);
  return uI(n) ? n : void 0;
}
var ou = Xo(Cr, "DataView"), _s = Xo(Cr, "Map"), iu = Xo(Cr, "Promise"), su = Xo(Cr, "Set"), lu = Xo(Cr, "WeakMap"), ap = "[object Map]", hI = "[object Object]", cp = "[object Promise]", dp = "[object Set]", up = "[object WeakMap]", fp = "[object DataView]", pI = Zo(ou), gI = Zo(_s), mI = Zo(iu), yI = Zo(su), bI = Zo(lu), Fn = Yo;
(ou && Fn(new ou(new ArrayBuffer(1))) != fp || _s && Fn(new _s()) != ap || iu && Fn(iu.resolve()) != cp || su && Fn(new su()) != dp || lu && Fn(new lu()) != up) && (Fn = function(t) {
  var e = Yo(t), n = e == hI ? t.constructor : void 0, r = n ? Zo(n) : "";
  if (r)
    switch (r) {
      case pI:
        return fp;
      case gI:
        return ap;
      case mI:
        return cp;
      case yI:
        return dp;
      case bI:
        return up;
    }
  return e;
});
function Vr(t) {
  return t != null && typeof t == "object";
}
var wI = "[object Arguments]";
function hp(t) {
  return Vr(t) && Yo(t) == wI;
}
var Q0 = Object.prototype, SI = Q0.hasOwnProperty, CI = Q0.propertyIsEnumerable, wf = hp(/* @__PURE__ */ function() {
  return arguments;
}()) ? hp : function(t) {
  return Vr(t) && SI.call(t, "callee") && !CI.call(t, "callee");
}, vI = 9007199254740991;
function eb(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= vI;
}
function Sf(t) {
  return t != null && eb(t.length) && !X0(t);
}
function xI() {
  return !1;
}
var tb = typeof exports == "object" && exports && !exports.nodeType && exports, pp = tb && typeof module == "object" && module && !module.nodeType && module, EI = pp && pp.exports === tb, gp = EI ? Cr.Buffer : void 0, kI = gp ? gp.isBuffer : void 0, Bs = kI || xI, TI = "[object Arguments]", II = "[object Array]", MI = "[object Boolean]", RI = "[object Date]", OI = "[object Error]", DI = "[object Function]", AI = "[object Map]", LI = "[object Number]", $I = "[object Object]", PI = "[object RegExp]", _I = "[object Set]", BI = "[object String]", VI = "[object WeakMap]", FI = "[object ArrayBuffer]", NI = "[object DataView]", zI = "[object Float32Array]", HI = "[object Float64Array]", jI = "[object Int8Array]", WI = "[object Int16Array]", GI = "[object Int32Array]", UI = "[object Uint8Array]", qI = "[object Uint8ClampedArray]", JI = "[object Uint16Array]", KI = "[object Uint32Array]", dt = {};
dt[zI] = dt[HI] = dt[jI] = dt[WI] = dt[GI] = dt[UI] = dt[qI] = dt[JI] = dt[KI] = !0;
dt[TI] = dt[II] = dt[FI] = dt[MI] = dt[NI] = dt[RI] = dt[OI] = dt[DI] = dt[AI] = dt[LI] = dt[$I] = dt[PI] = dt[_I] = dt[BI] = dt[VI] = !1;
function YI(t) {
  return Vr(t) && eb(t.length) && !!dt[Yo(t)];
}
function Cf(t) {
  return function(e) {
    return t(e);
  };
}
var nb = typeof exports == "object" && exports && !exports.nodeType && exports, Ss = nb && typeof module == "object" && module && !module.nodeType && module, ZI = Ss && Ss.exports === nb, Zc = ZI && Y0.process, Ri = function() {
  try {
    var t = Ss && Ss.require && Ss.require("util").types;
    return t || Zc && Zc.binding && Zc.binding("util");
  } catch {
  }
}(), mp = Ri && Ri.isTypedArray, vf = mp ? Cf(mp) : YI, XI = "[object Map]", QI = "[object Set]", eM = Object.prototype, tM = eM.hasOwnProperty;
function au(t) {
  if (t == null)
    return !0;
  if (Sf(t) && (rr(t) || typeof t == "string" || typeof t.splice == "function" || Bs(t) || vf(t) || wf(t)))
    return !t.length;
  var e = Fn(t);
  if (e == XI || e == QI)
    return !t.size;
  if (bf(t))
    return !K0(t).length;
  for (var n in t)
    if (tM.call(t, n))
      return !1;
  return !0;
}
function nM() {
  this.__data__ = [], this.size = 0;
}
function xf(t, e) {
  return t === e || t !== t && e !== e;
}
function yc(t, e) {
  for (var n = t.length; n--; )
    if (xf(t[n][0], e))
      return n;
  return -1;
}
var rM = Array.prototype, oM = rM.splice;
function iM(t) {
  var e = this.__data__, n = yc(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : oM.call(e, n, 1), --this.size, !0;
}
function sM(t) {
  var e = this.__data__, n = yc(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function lM(t) {
  return yc(this.__data__, t) > -1;
}
function aM(t, e) {
  var n = this.__data__, r = yc(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
function zr(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
zr.prototype.clear = nM;
zr.prototype.delete = iM;
zr.prototype.get = sM;
zr.prototype.has = lM;
zr.prototype.set = aM;
function cM() {
  this.__data__ = new zr(), this.size = 0;
}
function dM(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
function uM(t) {
  return this.__data__.get(t);
}
function fM(t) {
  return this.__data__.has(t);
}
var Vs = Xo(Object, "create");
function hM() {
  this.__data__ = Vs ? Vs(null) : {}, this.size = 0;
}
function pM(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var gM = "__lodash_hash_undefined__", mM = Object.prototype, yM = mM.hasOwnProperty;
function bM(t) {
  var e = this.__data__;
  if (Vs) {
    var n = e[t];
    return n === gM ? void 0 : n;
  }
  return yM.call(e, t) ? e[t] : void 0;
}
var wM = Object.prototype, SM = wM.hasOwnProperty;
function CM(t) {
  var e = this.__data__;
  return Vs ? e[t] !== void 0 : SM.call(e, t);
}
var vM = "__lodash_hash_undefined__";
function xM(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = Vs && e === void 0 ? vM : e, this;
}
function zo(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
zo.prototype.clear = hM;
zo.prototype.delete = pM;
zo.prototype.get = bM;
zo.prototype.has = CM;
zo.prototype.set = xM;
function EM() {
  this.size = 0, this.__data__ = {
    hash: new zo(),
    map: new (_s || zr)(),
    string: new zo()
  };
}
function kM(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function bc(t, e) {
  var n = t.__data__;
  return kM(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function TM(t) {
  var e = bc(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function IM(t) {
  return bc(this, t).get(t);
}
function MM(t) {
  return bc(this, t).has(t);
}
function RM(t, e) {
  var n = bc(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
function Hr(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Hr.prototype.clear = EM;
Hr.prototype.delete = TM;
Hr.prototype.get = IM;
Hr.prototype.has = MM;
Hr.prototype.set = RM;
var OM = 200;
function DM(t, e) {
  var n = this.__data__;
  if (n instanceof zr) {
    var r = n.__data__;
    if (!_s || r.length < OM - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new Hr(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
function $r(t) {
  var e = this.__data__ = new zr(t);
  this.size = e.size;
}
$r.prototype.clear = cM;
$r.prototype.delete = dM;
$r.prototype.get = uM;
$r.prototype.has = fM;
$r.prototype.set = DM;
var AM = "__lodash_hash_undefined__";
function LM(t) {
  return this.__data__.set(t, AM), this;
}
function $M(t) {
  return this.__data__.has(t);
}
function ha(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new Hr(); ++e < n; )
    this.add(t[e]);
}
ha.prototype.add = ha.prototype.push = LM;
ha.prototype.has = $M;
function PM(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
function _M(t, e) {
  return t.has(e);
}
var BM = 1, VM = 2;
function rb(t, e, n, r, o, i) {
  var s = n & BM, l = t.length, a = e.length;
  if (l != a && !(s && a > l))
    return !1;
  var c = i.get(t), d = i.get(e);
  if (c && d)
    return c == e && d == t;
  var u = -1, f = !0, h = n & VM ? new ha() : void 0;
  for (i.set(t, e), i.set(e, t); ++u < l; ) {
    var p = t[u], y = e[u];
    if (r)
      var b = s ? r(y, p, u, e, t, i) : r(p, y, u, t, e, i);
    if (b !== void 0) {
      if (b)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!PM(e, function(w, S) {
        if (!_M(h, S) && (p === w || o(p, w, n, r, i)))
          return h.push(S);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === y || o(p, y, n, r, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(t), i.delete(e), f;
}
var pa = Cr.Uint8Array;
function FM(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, o) {
    n[++e] = [o, r];
  }), n;
}
function NM(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var zM = 1, HM = 2, jM = "[object Boolean]", WM = "[object Date]", GM = "[object Error]", UM = "[object Map]", qM = "[object Number]", JM = "[object RegExp]", KM = "[object Set]", YM = "[object String]", ZM = "[object Symbol]", XM = "[object ArrayBuffer]", QM = "[object DataView]", yp = Gn ? Gn.prototype : void 0, Xc = yp ? yp.valueOf : void 0;
function eR(t, e, n, r, o, i, s) {
  switch (n) {
    case QM:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case XM:
      return !(t.byteLength != e.byteLength || !i(new pa(t), new pa(e)));
    case jM:
    case WM:
    case qM:
      return xf(+t, +e);
    case GM:
      return t.name == e.name && t.message == e.message;
    case JM:
    case YM:
      return t == e + "";
    case UM:
      var l = FM;
    case KM:
      var a = r & zM;
      if (l || (l = NM), t.size != e.size && !a)
        return !1;
      var c = s.get(t);
      if (c)
        return c == e;
      r |= HM, s.set(t, e);
      var d = rb(l(t), l(e), r, o, i, s);
      return s.delete(t), d;
    case ZM:
      if (Xc)
        return Xc.call(t) == Xc.call(e);
  }
  return !1;
}
function Ef(t, e) {
  for (var n = -1, r = e.length, o = t.length; ++n < r; )
    t[o + n] = e[n];
  return t;
}
function ob(t, e, n) {
  var r = e(t);
  return rr(t) ? r : Ef(r, n(t));
}
function tR(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, o = 0, i = []; ++n < r; ) {
    var s = t[n];
    e(s, n, t) && (i[o++] = s);
  }
  return i;
}
function ib() {
  return [];
}
var nR = Object.prototype, rR = nR.propertyIsEnumerable, bp = Object.getOwnPropertySymbols, sb = bp ? function(t) {
  return t == null ? [] : (t = Object(t), tR(bp(t), function(e) {
    return rR.call(t, e);
  }));
} : ib;
function oR(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var iR = 9007199254740991, sR = /^(?:0|[1-9]\d*)$/;
function lR(t, e) {
  var n = typeof t;
  return e = e ?? iR, !!e && (n == "number" || n != "symbol" && sR.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var aR = Object.prototype, cR = aR.hasOwnProperty;
function lb(t, e) {
  var n = rr(t), r = !n && wf(t), o = !n && !r && Bs(t), i = !n && !r && !o && vf(t), s = n || r || o || i, l = s ? oR(t.length, String) : [], a = l.length;
  for (var c in t)
    (e || cR.call(t, c)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    lR(c, a))) && l.push(c);
  return l;
}
function dR(t) {
  return Sf(t) ? lb(t) : K0(t);
}
function wp(t) {
  return ob(t, dR, sb);
}
var uR = 1, fR = Object.prototype, hR = fR.hasOwnProperty;
function pR(t, e, n, r, o, i) {
  var s = n & uR, l = wp(t), a = l.length, c = wp(e), d = c.length;
  if (a != d && !s)
    return !1;
  for (var u = a; u--; ) {
    var f = l[u];
    if (!(s ? f in e : hR.call(e, f)))
      return !1;
  }
  var h = i.get(t), p = i.get(e);
  if (h && p)
    return h == e && p == t;
  var y = !0;
  i.set(t, e), i.set(e, t);
  for (var b = s; ++u < a; ) {
    f = l[u];
    var w = t[f], S = e[f];
    if (r)
      var x = s ? r(S, w, f, e, t, i) : r(w, S, f, t, e, i);
    if (!(x === void 0 ? w === S || o(w, S, n, r, i) : x)) {
      y = !1;
      break;
    }
    b || (b = f == "constructor");
  }
  if (y && !b) {
    var E = t.constructor, v = e.constructor;
    E != v && "constructor" in t && "constructor" in e && !(typeof E == "function" && E instanceof E && typeof v == "function" && v instanceof v) && (y = !1);
  }
  return i.delete(t), i.delete(e), y;
}
var gR = 1, Sp = "[object Arguments]", Cp = "[object Array]", Sl = "[object Object]", mR = Object.prototype, vp = mR.hasOwnProperty;
function yR(t, e, n, r, o, i) {
  var s = rr(t), l = rr(e), a = s ? Cp : Fn(t), c = l ? Cp : Fn(e);
  a = a == Sp ? Sl : a, c = c == Sp ? Sl : c;
  var d = a == Sl, u = c == Sl, f = a == c;
  if (f && Bs(t)) {
    if (!Bs(e))
      return !1;
    s = !0, d = !1;
  }
  if (f && !d)
    return i || (i = new $r()), s || vf(t) ? rb(t, e, n, r, o, i) : eR(t, e, a, n, r, o, i);
  if (!(n & gR)) {
    var h = d && vp.call(t, "__wrapped__"), p = u && vp.call(e, "__wrapped__");
    if (h || p) {
      var y = h ? t.value() : t, b = p ? e.value() : e;
      return i || (i = new $r()), o(y, b, n, r, i);
    }
  }
  return f ? (i || (i = new $r()), pR(t, e, n, r, o, i)) : !1;
}
function ab(t, e, n, r, o) {
  return t === e ? !0 : t == null || e == null || !Vr(t) && !Vr(e) ? t !== t && e !== e : yR(t, e, n, r, ab, o);
}
function bR(t, e) {
  return ab(t, e);
}
function cb(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, o = Array(r); ++n < r; )
    o[n] = e(t[n], n, t);
  return o;
}
function wR(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var ga = function() {
  try {
    var t = Xo(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
function db(t, e, n) {
  e == "__proto__" && ga ? ga(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
var SR = Object.prototype, CR = SR.hasOwnProperty;
function ub(t, e, n) {
  var r = t[e];
  (!(CR.call(t, e) && xf(r, n)) || n === void 0 && !(e in t)) && db(t, e, n);
}
function vR(t, e, n, r) {
  var o = !n;
  n || (n = {});
  for (var i = -1, s = e.length; ++i < s; ) {
    var l = e[i], a = void 0;
    a === void 0 && (a = t[l]), o ? db(n, l, a) : ub(n, l, a);
  }
  return n;
}
function xR(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var ER = Object.prototype, kR = ER.hasOwnProperty;
function TR(t) {
  if (!ji(t))
    return xR(t);
  var e = bf(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !kR.call(t, r)) || n.push(r);
  return n;
}
function IR(t) {
  return Sf(t) ? lb(t, !0) : TR(t);
}
var fb = typeof exports == "object" && exports && !exports.nodeType && exports, xp = fb && typeof module == "object" && module && !module.nodeType && module, MR = xp && xp.exports === fb, Ep = MR ? Cr.Buffer : void 0;
Ep && Ep.allocUnsafe;
function RR(t, e) {
  return t.slice();
}
var hb = J0(Object.getPrototypeOf, Object), OR = Object.getOwnPropertySymbols, DR = OR ? function(t) {
  for (var e = []; t; )
    Ef(e, sb(t)), t = hb(t);
  return e;
} : ib;
function pb(t) {
  return ob(t, IR, DR);
}
var AR = Object.prototype, LR = AR.hasOwnProperty;
function $R(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && LR.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
function kf(t) {
  var e = new t.constructor(t.byteLength);
  return new pa(e).set(new pa(t)), e;
}
function PR(t, e) {
  var n = kf(t.buffer);
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var _R = /\w*$/;
function BR(t) {
  var e = new t.constructor(t.source, _R.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var kp = Gn ? Gn.prototype : void 0, Tp = kp ? kp.valueOf : void 0;
function VR(t) {
  return Tp ? Object(Tp.call(t)) : {};
}
function FR(t, e) {
  var n = kf(t.buffer);
  return new t.constructor(n, t.byteOffset, t.length);
}
var NR = "[object Boolean]", zR = "[object Date]", HR = "[object Map]", jR = "[object Number]", WR = "[object RegExp]", GR = "[object Set]", UR = "[object String]", qR = "[object Symbol]", JR = "[object ArrayBuffer]", KR = "[object DataView]", YR = "[object Float32Array]", ZR = "[object Float64Array]", XR = "[object Int8Array]", QR = "[object Int16Array]", eO = "[object Int32Array]", tO = "[object Uint8Array]", nO = "[object Uint8ClampedArray]", rO = "[object Uint16Array]", oO = "[object Uint32Array]";
function iO(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case JR:
      return kf(t);
    case NR:
    case zR:
      return new r(+t);
    case KR:
      return PR(t);
    case YR:
    case ZR:
    case XR:
    case QR:
    case eO:
    case tO:
    case nO:
    case rO:
    case oO:
      return FR(t);
    case HR:
      return new r();
    case jR:
    case UR:
      return new r(t);
    case WR:
      return BR(t);
    case GR:
      return new r();
    case qR:
      return VR(t);
  }
}
var sO = "[object Map]";
function lO(t) {
  return Vr(t) && Fn(t) == sO;
}
var Ip = Ri && Ri.isMap, aO = Ip ? Cf(Ip) : lO, cO = "[object Set]";
function dO(t) {
  return Vr(t) && Fn(t) == cO;
}
var Mp = Ri && Ri.isSet, uO = Mp ? Cf(Mp) : dO, gb = "[object Arguments]", fO = "[object Array]", hO = "[object Boolean]", pO = "[object Date]", gO = "[object Error]", mb = "[object Function]", mO = "[object GeneratorFunction]", yO = "[object Map]", bO = "[object Number]", yb = "[object Object]", wO = "[object RegExp]", SO = "[object Set]", CO = "[object String]", vO = "[object Symbol]", xO = "[object WeakMap]", EO = "[object ArrayBuffer]", kO = "[object DataView]", TO = "[object Float32Array]", IO = "[object Float64Array]", MO = "[object Int8Array]", RO = "[object Int16Array]", OO = "[object Int32Array]", DO = "[object Uint8Array]", AO = "[object Uint8ClampedArray]", LO = "[object Uint16Array]", $O = "[object Uint32Array]", st = {};
st[gb] = st[fO] = st[EO] = st[kO] = st[hO] = st[pO] = st[TO] = st[IO] = st[MO] = st[RO] = st[OO] = st[yO] = st[bO] = st[yb] = st[wO] = st[SO] = st[CO] = st[vO] = st[DO] = st[AO] = st[LO] = st[$O] = !0;
st[gO] = st[mb] = st[xO] = !1;
function Gl(t, e, n, r, o, i) {
  var s;
  if (n && (s = o ? n(t, r, o, i) : n(t)), s !== void 0)
    return s;
  if (!ji(t))
    return t;
  var l = rr(t);
  if (l)
    s = $R(t);
  else {
    var a = Fn(t), c = a == mb || a == mO;
    if (Bs(t))
      return RR(t);
    if (a == yb || a == gb || c && !o)
      s = {};
    else {
      if (!st[a])
        return o ? t : {};
      s = iO(t, a);
    }
  }
  i || (i = new $r());
  var d = i.get(t);
  if (d)
    return d;
  i.set(t, s), uO(t) ? t.forEach(function(h) {
    s.add(Gl(h, e, n, h, t, i));
  }) : aO(t) && t.forEach(function(h, p) {
    s.set(p, Gl(h, e, n, p, t, i));
  });
  var u = pb, f = l ? void 0 : u(t);
  return wR(f || t, function(h, p) {
    f && (p = h, h = t[p]), ub(s, p, Gl(h, e, n, p, t, i));
  }), s;
}
var PO = "[object Symbol]";
function Tf(t) {
  return typeof t == "symbol" || Vr(t) && Yo(t) == PO;
}
var _O = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, BO = /^\w*$/;
function VO(t, e) {
  if (rr(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || Tf(t) ? !0 : BO.test(t) || !_O.test(t) || e != null && t in Object(e);
}
var FO = "Expected a function";
function If(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(FO);
  var n = function() {
    var r = arguments, o = e ? e.apply(this, r) : r[0], i = n.cache;
    if (i.has(o))
      return i.get(o);
    var s = t.apply(this, r);
    return n.cache = i.set(o, s) || i, s;
  };
  return n.cache = new (If.Cache || Hr)(), n;
}
If.Cache = Hr;
var NO = 500;
function zO(t) {
  var e = If(t, function(r) {
    return n.size === NO && n.clear(), r;
  }), n = e.cache;
  return e;
}
var HO = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, jO = /\\(\\)?/g, WO = zO(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(HO, function(n, r, o, i) {
    e.push(o ? i.replace(jO, "$1") : r || n);
  }), e;
}), Rp = Gn ? Gn.prototype : void 0, Op = Rp ? Rp.toString : void 0;
function bb(t) {
  if (typeof t == "string")
    return t;
  if (rr(t))
    return cb(t, bb) + "";
  if (Tf(t))
    return Op ? Op.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
function GO(t) {
  return t == null ? "" : bb(t);
}
function Mf(t, e) {
  return rr(t) ? t : VO(t, e) ? [t] : WO(GO(t));
}
function UO(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
function wb(t) {
  if (typeof t == "string" || Tf(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
function qO(t, e) {
  e = Mf(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[wb(e[n++])];
  return n && n == r ? t : void 0;
}
function JO(t, e, n) {
  var r = -1, o = t.length;
  e < 0 && (e = -e > o ? 0 : o + e), n = n > o ? o : n, n < 0 && (n += o), o = e > n ? 0 : n - e >>> 0, e >>>= 0;
  for (var i = Array(o); ++r < o; )
    i[r] = t[r + e];
  return i;
}
function KO(t, e) {
  return e.length < 2 ? t : qO(t, JO(e, 0, -1));
}
function YO(t, e) {
  return e = Mf(e, t), t = KO(t, e), t == null || delete t[wb(UO(e))];
}
var ZO = "[object Object]", XO = Function.prototype, QO = Object.prototype, Sb = XO.toString, eD = QO.hasOwnProperty, tD = Sb.call(Object);
function nD(t) {
  if (!Vr(t) || Yo(t) != ZO)
    return !1;
  var e = hb(t);
  if (e === null)
    return !0;
  var n = eD.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && Sb.call(n) == tD;
}
function rD(t) {
  return nD(t) ? void 0 : t;
}
var Dp = Gn ? Gn.isConcatSpreadable : void 0;
function oD(t) {
  return rr(t) || wf(t) || !!(Dp && t && t[Dp]);
}
function iD(t, e, n, r, o) {
  var i = -1, s = t.length;
  for (n || (n = oD), o || (o = []); ++i < s; ) {
    var l = t[i];
    n(l) ? Ef(o, l) : o[o.length] = l;
  }
  return o;
}
function sD(t) {
  var e = t == null ? 0 : t.length;
  return e ? iD(t) : [];
}
function lD(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
var Ap = Math.max;
function aD(t, e, n) {
  return e = Ap(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, o = -1, i = Ap(r.length - e, 0), s = Array(i); ++o < i; )
      s[o] = r[e + o];
    o = -1;
    for (var l = Array(e + 1); ++o < e; )
      l[o] = r[o];
    return l[e] = n(s), lD(t, this, l);
  };
}
function cD(t) {
  return function() {
    return t;
  };
}
function dD(t) {
  return t;
}
var uD = ga ? function(t, e) {
  return ga(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: cD(e),
    writable: !0
  });
} : dD, fD = 800, hD = 16, pD = Date.now;
function gD(t) {
  var e = 0, n = 0;
  return function() {
    var r = pD(), o = hD - (r - n);
    if (n = r, o > 0) {
      if (++e >= fD)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var mD = gD(uD);
function yD(t) {
  return mD(aD(t, void 0, sD), t + "");
}
var bD = 1, wD = 2, SD = 4, CD = yD(function(t, e) {
  var n = {};
  if (t == null)
    return n;
  var r = !1;
  e = cb(e, function(i) {
    return i = Mf(i, t), r || (r = i.length > 1), i;
  }), vR(t, pb(t), n), r && (n = Gl(n, bD | wD | SD, rD));
  for (var o = e.length; o--; )
    YO(n, e[o]);
  return n;
});
const vD = 1024 * 1024, Cb = (t) => Number((t.size / vD).toFixed(2)), xD = async (t) => {
  const e = new FileReader();
  return await new Promise((n) => {
    e.readAsDataURL(t), e.addEventListener("load", (r) => {
      const o = new Image();
      o.src = r.target.result;
      const i = new Promise(
        (s) => o.addEventListener("load", () => s({ width: o.width, height: o.height }))
      );
      n(i);
    });
  });
}, Lp = (t) => {
  if (gv(t))
    return t;
  if (!t)
    return;
  if (!ji(t))
    return t;
  const e = Object.keys(t).filter((n) => {
    const r = t[n];
    if (rr(r)) {
      const [o] = r;
      return o !== "" && !au(r);
    }
    return !!r;
  });
  if (!au(e))
    return Object.fromEntries(e.map((n) => [n, t[n]]));
}, $p = (t, e) => Object.keys(t).some((n) => {
  const r = Lp(t[n]), o = Lp(e[n]);
  return ji(r) ? !bR(r, o) : r !== o;
}), ED = ({
  formValues: t,
  onClearAll: e,
  resetFormValues: n,
  filters: r,
  omittedToCheckFormValues: o = []
}) => {
  const i = te(() => {
    e();
  }, [e]), s = me(() => CD(t, o), [t, o]), l = me(() => $p(s, n), [s, n]), a = me(() => $p(s, r), [s, r]);
  return {
    handleClearAll: i,
    isClearAllButtonDisabled: !l,
    isSubmitButtonDisabled: !a
  };
}, kD = O(() => ({
  applyButtonLeftIcon: {
    display: "none"
  }
})), TD = {
  variant: q0.static,
  wrap: "nowrap",
  justify: "right",
  gap: 12,
  px: 0,
  py: 0,
  ml: "auto"
}, dz = (t) => {
  const {
    loading: e,
    formValues: n,
    onClearAll: r,
    resetFormValues: o,
    filters: i,
    omittedToCheckFormValues: s,
    clearAllButtonProperties: l,
    applyFiltersButtonProperties: a,
    clearAllButtonText: c,
    submitButtonText: d,
    withDefaultSubmitEnabled: u,
    variant: f,
    direction: h,
    w: p,
    ...y
  } = he("FilterButtons", TD, t), {
    disabled: b,
    onClick: w,
    ...S
  } = l || {}, {
    disabled: x,
    onClick: E,
    classNames: v,
    ...T
  } = a || {}, { classes: I } = kD(), { handleClearAll: M, isSubmitButtonDisabled: R, isClearAllButtonDisabled: A } = ED({
    formValues: n,
    onClearAll: r,
    resetFormValues: o,
    filters: i,
    omittedToCheckFormValues: s
  }), F = Nt(u), V = () => {
    F.current = !1;
  }, P = f === q0.static;
  return /* @__PURE__ */ g.createElement(
    gr,
    {
      direction: h || (P ? "row" : { base: "column", md: "row" }),
      w: p || (P ? void 0 : { base: "100%", md: "auto" }),
      ...y
    },
    /* @__PURE__ */ g.createElement(
      ye,
      {
        elementVariant: Q.TertiaryMain,
        rightSection: /* @__PURE__ */ g.createElement(cc, null),
        "data-testid": "clear-all-filters",
        "aria-label": c,
        disabled: e || b || A,
        onClick: w || M,
        ...S
      },
      c
    ),
    /* @__PURE__ */ g.createElement(
      ye,
      {
        elementVariant: Q.SecondaryMain,
        "data-testid": "apply-filters",
        "aria-label": d,
        type: "submit",
        isLoading: e,
        disabled: !F.current && R || x,
        onClick: E || V,
        classNames: { section: I.applyButtonLeftIcon, ...v },
        ...T
      },
      d
    )
  );
};
var ID = /* @__PURE__ */ Lr.forwardRef(({ color: t = "currentColor", size: e = 14, ...n }, r) => /* @__PURE__ */ Lr.createElement(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: r,
    ...n
  },
  /* @__PURE__ */ Lr.createElement(
    "path",
    {
      d: "M7.354 3.896l5.5 5.5a.5.5 0 01-.708.708L7 4.957l-5.146 5.147a.5.5 0 01-.708-.708l5.5-5.5a.5.5 0 01.708 0z",
      fill: t
    }
  )
)), MD = /* @__PURE__ */ Lr.forwardRef(({ color: t = "currentColor", size: e = 14, ...n }, r) => /* @__PURE__ */ Lr.createElement(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: r,
    ...n
  },
  /* @__PURE__ */ Lr.createElement(
    "path",
    {
      d: "M1.146 4.604l5.5 5.5a.5.5 0 00.708 0l5.5-5.5a.5.5 0 00-.708-.708L7 9.043 1.854 3.896a.5.5 0 10-.708.708z",
      fill: t
    }
  )
));
const RD = O((t) => ({
  toggler: {
    border: "none",
    background: "transparent",
    color: t.other.colors.brand[13],
    paddingLeft: 0,
    paddingRight: 0,
    ":hover": {
      background: "transparent"
    }
  },
  icon: {
    color: t.other.colors.brand[13]
  },
  rotate: {
    transform: "rotate(180deg)"
  }
})), vb = wr(
  ({ onClick: t, isShow: e, showText: n = "Show filters", hideText: r = "Hide filters", disabled: o, ...i }) => {
    const { classes: s, cx: l } = RD();
    return /* @__PURE__ */ g.createElement(
      ye,
      {
        className: s.toggler,
        elementVariant: Q.TertiaryMain,
        rightSection: /* @__PURE__ */ g.createElement(Sr, { className: l({ [s.rotate]: e }) }),
        onClick: t,
        disabled: o,
        mod: {
          opened: e
        },
        ...i
      },
      e ? r : n
    );
  }
);
vb.displayName = "FilterDisplaySwitcher";
const OD = O((t, { isTitleHidden: e }) => ({
  root: {
    width: "100%",
    gap: 0,
    flexDirection: "column",
    padding: m(16),
    [Ge.greaterThen("md")]: {
      padding: m(24)
    },
    backgroundColor: t.other.colors.white[0],
    border: "1px solid",
    borderRadius: t.other.borderRadius[8],
    borderColor: t.other.colors.greyIron[4]
  },
  noBorderBottom: {
    borderBottom: "none",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  titleWrapper: {
    align: "center",
    justifyContent: "space-between",
    wrap: "nowrap",
    hidden: e,
    [Ge.greaterThen("md")]: {
      visibility: "hidden"
    }
  },
  title: {},
  titleCollapseControlButton: {},
  panelCollapseWrapper: {},
  panelCollapseContent: {
    width: "100%",
    gap: 0,
    flexDirection: "column",
    marginTop: m(16),
    [Ge.greaterThen("md")]: {
      marginTop: 0
    }
  },
  notCollapsibleSlotWrapper: {
    width: "100%",
    rowGap: m(16),
    [Ge.greaterThen("md")]: {
      rowGap: m(24)
    },
    columnGap: m(16)
  },
  panelCollapsibleSlotWrapper: {},
  collapsibleSlotWrapper: {
    width: "100%",
    paddingTop: m(16),
    rowGap: m(16),
    [Ge.greaterThen("md")]: {
      rowGap: m(24)
    },
    columnGap: m(16)
  },
  controls: {
    justifyContent: "space-between",
    paddingTop: m(16),
    [Ge.greaterThen("md")]: {
      paddingTop: m(24)
    }
  }
})), DD = {
  variant: "static",
  title: "Filters",
  collapseShowText: "Show filters",
  collapseHideText: "Hide filters",
  withBorderBottomOnPanel: !0
}, AD = (t) => {
  const {
    loading: e,
    filtersButtonsSlot: n,
    filtersNotCollapsibleSlot: r,
    filtersCollapsibleSlot: o,
    variant: i,
    title: s,
    collapseShowText: l,
    collapseHideText: a,
    classNames: c,
    withBorderBottomOnPanel: d,
    ...u
  } = he("FiltersPanel", DD, t), f = i === "static", { classes: h, cx: p } = OD({ isTitleHidden: f }), y = "md", b = mr(Ge.greaterThen("md", !1)), w = f || !!b, S = f ? { base: 3 } : { base: 1, md: 3 }, [x, E] = ie(!1), v = te(() => {
    E((R) => !R);
  }, [E]), [T, I] = ie(!1), M = te(() => {
    I((R) => !R);
  }, [I]);
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore                                                    -- Flex has incompatible polymorphic types with form types. Need to keep ts-ignore until mantine will fix it
    // eslint-disable-next-line prettier/prettier                    -- Need to keep Flex on different lines to keep ts-ignore comment above and has typecheck for props
    /* @__PURE__ */ g.createElement(
      gr,
      {
        component: "form",
        className: p(h.root, c == null ? void 0 : c.root, {
          [p(h.noBorderBottom, c == null ? void 0 : c.noBorderBottom)]: !d
        }),
        ...u
      },
      /* @__PURE__ */ g.createElement(X, { onClick: v, hiddenFrom: y, className: p(h.titleWrapper, c == null ? void 0 : c.titleWrapper) }, /* @__PURE__ */ g.createElement(xe, { elementVariant: "header", elementSize: "s", className: p(h.title, c == null ? void 0 : c.title) }, s), /* @__PURE__ */ g.createElement(
        ye,
        {
          elementSize: Ue.XS,
          isIconOnly: !0,
          leftSection: x ? /* @__PURE__ */ g.createElement(ID, null) : /* @__PURE__ */ g.createElement(MD, null),
          elementVariant: Q.SecondaryMainLine,
          className: p(h.titleCollapseControlButton, c == null ? void 0 : c.titleCollapseControlButton),
          "data-testid": "filters-panel-switch-button"
        }
      )),
      /* @__PURE__ */ g.createElement(jd, { in: x || w, className: p(h.panelCollapseWrapper, c == null ? void 0 : c.panelCollapseWrapper) }, /* @__PURE__ */ g.createElement(gr, { className: p(h.panelCollapseContent, c == null ? void 0 : c.panelCollapseContent) }, /* @__PURE__ */ g.createElement(Wd, { cols: S, className: p(h.notCollapsibleSlotWrapper, c == null ? void 0 : c.notCollapsibleSlotWrapper) }, r), o && /* @__PURE__ */ g.createElement(jd, { in: T || !w, className: p(h.panelCollapsibleSlotWrapper, c == null ? void 0 : c.panelCollapsibleSlotWrapper) }, /* @__PURE__ */ g.createElement(Wd, { cols: S, className: p(h.collapsibleSlotWrapper, c == null ? void 0 : c.collapsibleSlotWrapper) }, o)), /* @__PURE__ */ g.createElement(X, { className: p(h.controls, c == null ? void 0 : c.controls) }, o ? /* @__PURE__ */ g.createElement(
        vb,
        {
          isShow: T,
          onClick: M,
          disabled: e,
          "data-testid": "filters-collapse-button",
          visibleFrom: f ? void 0 : "md",
          showText: l,
          hideText: a
        }
      ) : /* @__PURE__ */ g.createElement(oe, null), n)))
    )
  );
};
AD.displayName = "FiltersPanel";
const LD = O((t) => ({
  scrollContainer: {
    width: t.other.viewport.width,
    height: t.other.viewport.height,
    zIndex: Rn("app")
  },
  container: {
    width: t.other.contentMaxWidth,
    minHeight: t.other.viewport.height,
    height: "auto"
  }
})), uz = ({
  children: t,
  className: e,
  containerClassName: n,
  ...r
}) => {
  const { classes: o, cx: i } = LD(), s = _i();
  return /* @__PURE__ */ g.createElement(Fr, { scrollbarSize: s.other.viewport.scrollbarSize, className: i(o.scrollContainer, e), ...r }, /* @__PURE__ */ g.createElement("div", { className: i(o.container, n) }, t));
};
function xb(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var o = t.length;
    for (e = 0; e < o; e++) t[e] && (n = xb(t[e])) && (r && (r += " "), r += n);
  } else for (n in t) t[n] && (r && (r += " "), r += n);
  return r;
}
function $D() {
  for (var t, e, n = 0, r = "", o = arguments.length; n < o; n++) (t = arguments[n]) && (e = xb(t)) && (r && (r += " "), r += e);
  return r;
}
const PD = 12, _D = { base: 16, xs: 16, sm: 16, md: 24, lg: 24, xl: 32 }, BD = { base: 16, xs: 16, sm: 16, md: 24, lg: 24, xl: 32 }, VD = 1600, Eb = ge((t, e) => {
  const { children: n, className: r, classNames: o, ...i } = he(
    "GridContainer",
    {
      w: "100%",
      maw: VD,
      px: BD
    },
    t
  );
  return /* @__PURE__ */ g.createElement(Fm, { className: $D(r, o == null ? void 0 : o.root), ref: e, ...i }, n);
});
Eb.displayName = "GridContainerComponent";
const kb = lc(Eb);
kb.displayName = "Grid.Container";
const FD = O(() => ({
  container: {},
  root: {
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0
  },
  inner: {
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0
  },
  col: {
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0
  }
})), Rf = (t) => {
  const { children: e, gutter: n, className: r, classNames: o, ...i } = he("Grid", {}, t), { classes: s, cx: l } = FD();
  return /* @__PURE__ */ g.createElement(
    Nm,
    {
      className: l(s.container, r),
      classNames: {
        container: l(s.container, o == null ? void 0 : o.container),
        root: l(s.root, o == null ? void 0 : o.root),
        inner: l(s.inner, o == null ? void 0 : o.inner),
        col: l(s.col, o == null ? void 0 : o.col)
      },
      gutter: n || _D,
      columns: PD,
      px: 0,
      ...i
    },
    e
  );
};
Rf.displayName = "Grid";
Rf.Container = kb;
Rf.Col = Nm.Col;
const ND = (t) => {
  switch (t) {
    case "wide":
      return { width: 80, height: 46 };
    case "round":
      return { width: 84, height: 84 };
    case "square":
      return { width: 50, height: 50 };
    default:
      return { width: 56, height: 40 };
  }
}, zD = O(
  (t, { elementVariant: e, disabled: n }) => ({
    root: {},
    imageWrapper: {},
    figure: {},
    image: {
      borderRadius: e === "round" ? "50%" : t.other.borderRadius[4]
    },
    placeholder: {
      backgroundColor: n ? t.other.colors.greyIron[4] : t.other.colors.greyIron[2],
      borderRadius: t.other.borderRadius[4],
      color: n ? t.other.colors.greyIron[10] : t.other.colors.greyIron[20]
    }
  })
), HD = {
  src: "",
  elementVariant: "default",
  withPlaceholder: !0
}, jD = (t) => {
  const { className: e, classNames: n, src: r, disabled: o, elementVariant: i, w: s, h: l, placeholder: a, width: c, height: d, ...u } = he(
    "ImagePreview",
    HD,
    t
  ), { classes: f, cx: h } = zD({ elementVariant: i, disabled: o }), p = {
    root: h(f.root, n == null ? void 0 : n.root),
    image: h(f.image, n == null ? void 0 : n.image),
    imageWrapper: h(f.imageWrapper, n == null ? void 0 : n.imageWrapper),
    figure: h(f.figure, n == null ? void 0 : n.figure),
    placeholder: h(f.placeholder, n == null ? void 0 : n.placeholder)
  }, { width: y, height: b } = ND(i);
  return /* @__PURE__ */ g.createElement(
    Pt,
    {
      width: typeof s == "number" ? s : c || y,
      height: typeof l == "number" ? l : d || b,
      w: s || c || y,
      h: l || d || b,
      src: r,
      className: e,
      classNames: p,
      placeholder: a || /* @__PURE__ */ g.createElement(mC, { width: 18, height: 18 }),
      ...u
    }
  );
}, WD = O(
  (t, {
    withDivider: e,
    length: n,
    inputGap: r,
    isError: o,
    isSuccess: i
  }) => {
    const s = Math.round(n / 2), l = 4;
    return {
      root: {
        gap: m(r)
      },
      pinInput: {
        width: "100%",
        height: "auto",
        ...e ? {
          [`&:nth-child(${s})`]: {
            marginRight: m(r + r + l),
            "&::after": {
              content: '""',
              position: "absolute",
              left: `calc(100% + ${m(r + l)})`,
              top: "50%",
              width: m(l),
              height: m(l),
              borderRadius: "50%",
              backgroundColor: t.other.colors.greyIron[8],
              ...i ? { backgroundColor: t.other.colors.raspberry[13] } : {},
              ...o ? { backgroundColor: t.other.colors.brand[10] } : {}
            }
          }
        } : {}
      },
      input: {},
      inputSuccess: {
        borderColor: t.other.colors.brand[10],
        backgroundColor: t.other.colors.brand[0]
      },
      inputError: {
        borderColor: t.other.colors.raspberry[13],
        "&:hover:not(&:disabled)": {
          borderColor: t.other.colors.raspberry[13]
        },
        "&:focus": {
          borderColor: t.other.colors.raspberry[13]
        },
        "&:-internal-autofill-selected": {
          borderColor: t.other.colors.raspberry[13]
        }
      }
    };
  }
), fz = ({
  length: t = 6,
  inputGap: e = 8,
  placeholder: n = "",
  onChange: r,
  isSuccess: o,
  isError: i,
  errorElement: s,
  withDivider: l = !0,
  className: a,
  classNames: c,
  ...d
}) => {
  const { cx: u, classes: f } = WD({ withDivider: l, length: t, inputGap: e, isError: i, isSuccess: o }), { classes: h } = sr({ elementSize: mt.SeparateXL });
  return /* @__PURE__ */ g.createElement(Ee, { gap: 12, className: a }, /* @__PURE__ */ g.createElement(X, { justify: "center" }, /* @__PURE__ */ g.createElement(
    HS,
    {
      autoFocus: !0,
      type: "number",
      length: t,
      onChange: r,
      placeholder: n,
      classNames: {
        root: u(f.root, c == null ? void 0 : c.root),
        pinInput: u(f.pinInput, c == null ? void 0 : c.pinInput),
        input: u(h.input, f.input, c == null ? void 0 : c.input, {
          [f.inputSuccess]: o && !i,
          [f.inputError]: i
        })
      },
      "data-success": o,
      "data-error": i,
      oneTimeCode: !0,
      "aria-label": "One time code",
      ...d
    }
  )), i && /* @__PURE__ */ g.createElement(Fm, { px: 0 }, s));
}, GD = {
  xs: { width: 28, height: 16, paddingX: 0, paddingY: 2 },
  m: { width: 44, height: 24, paddingX: 0, paddingY: 2 }
}, UD = (t) => GD[t], qD = O(
  (t, { elementSize: e, elementVariant: n }) => {
    const { width: r, height: o, paddingX: i, paddingY: s } = UD(e), l = o - s * 2, a = n === "theme" ? t.other.colors.greyIron[3] : t.other.colors.brand[5], c = n === "theme" ? t.other.colors.greyIron[3] : t.other.colors.brand[7];
    return {
      root: {
        '&[data-label-position="right"]': {
          "--label-offset-start": m(8)
        },
        '&[data-label-position="left"]': {
          "--label-offset-end": m(8)
        }
      },
      input: {
        "&:checked": {
          [`& + .${zl}`]: {
            backgroundColor: a,
            ".mantine-Switch-thumb": {
              left: `calc(100% - ${m(l)} - ${m(s)})`,
              backgroundColor: t.other.colors.white
            },
            "&:hover": {
              backgroundColor: c
            }
          }
        },
        "&:disabled": {
          "&:focus-visible": {
            boxShadow: "none"
          },
          [`& + .${zl}`]: {
            backgroundColor: t.other.colors.greyIron[4],
            cursor: "not-allowed",
            "&:hover": {
              backgroundColor: t.other.colors.greyIron[4]
            }
          }
        },
        "&:focus-visible": {
          [`& + .${zl}`]: {
            boxShadow: `0 0 0 ${m(2)} ${t.other.colors.brand[2]}`,
            outline: "none"
          }
        }
      },
      labelWrapper: {},
      body: {
        alignItems: "center"
      },
      track: {
        border: "none",
        width: m(r),
        minWidth: m(r),
        height: m(o),
        backgroundColor: t.other.colors.greyIron[3],
        cursor: "pointer",
        "&:hover": {
          backgroundColor: t.other.colors.greyIron[4]
        }
      },
      thumb: {
        border: "none",
        margin: `0 ${m(i)}`,
        height: m(l),
        width: m(l),
        boxShadow: `0 ${m(1)} ${m(2)} rgba(16, 24, 40, 0.1), 0 0 ${m(1)} rgba(16, 24, 40, 0.06)`
      },
      trackLabel: {
        margin: `0 0 0 ${m(l)}`
      },
      error: {
        marginTop: t.other.spacings[8],
        color: t.other.colors.raspberry[11],
        font: t.other.fonts.desktop.s.s.default
      },
      description: {},
      label: {
        color: t.other.colors.greyIron[12],
        font: t.other.fonts.desktop.s.xs.buttons
      }
    };
  }
), Of = ge((t, e) => {
  const {
    elementSize: n = "xs",
    elementVariant: r = "brand",
    ariaLabel: o,
    onChange: i,
    value: s,
    defaultValue: l,
    error: a,
    className: c,
    classNames: d,
    ...u
  } = he("Switch", {}, t), [f, h] = an({
    defaultValue: l,
    value: s,
    onChange: i
  }), { classes: p, cx: y } = qD({ elementSize: n, elementVariant: r }), b = te(
    (w) => {
      h(!!w.target.checked);
    },
    [h]
  );
  return /* @__PURE__ */ g.createElement("div", { className: y(p.root, c) }, /* @__PURE__ */ g.createElement(
    jS,
    {
      classNames: { ...p, ...d },
      "aria-label": o,
      checked: f,
      onChange: b,
      "data-testid": "toggle",
      onLabel: r === "theme" ? /* @__PURE__ */ g.createElement(bC, { width: 12, height: 12, color: "#FBFBFB" }) : null,
      offLabel: r === "theme" ? /* @__PURE__ */ g.createElement(yC, { width: 12, height: 12, color: "#71717D" }) : null,
      ref: e,
      ...u
    }
  ), a && /* @__PURE__ */ g.createElement("div", { className: p.error }, a));
});
Of.displayName = "Toggle";
const JD = (t) => {
  const { errorVariant: e, error: n, disabled: r, rightSection: o } = t;
  return e === fa.tooltip ? n ? /* @__PURE__ */ g.createElement(at, { disabled: r, label: n, style: { maxWidth: m(200) }, multiline: !0 }, /* @__PURE__ */ g.createElement(oe, { "data-testid": "number-input-error-in-tooltip", component: "span", display: "flex" }, /* @__PURE__ */ g.createElement(Ei, null))) : o : n ? /* @__PURE__ */ g.createElement(Ei, null) : o;
}, KD = O((t, { withIcon: e }) => ({
  root: {},
  input: {
    paddingLeft: e ? m(36) : m(12)
  },
  inputContainer: {},
  required: {},
  labelWrapper: {},
  labelWrapperWithIcon: {},
  label: {},
  labelDisabled: {},
  labelIcon: {
    color: t.other.colors.greyIron[10]
  },
  description: {
    marginTop: m(-2)
  },
  section: {
    '&[data-position="right"]': {
      "&&": {
        overflow: "unset",
        marginRight: m(2.5)
      }
    }
  },
  wrapper: {},
  iconDisabled: {},
  iconError: {},
  error: {},
  toggle: {},
  control: {
    border: "none",
    padding: 0,
    backgroundColor: "transparent",
    color: t.other.colors.greyIron[13],
    marginLeft: m(-6),
    height: m(24),
    marginTop: m(-2),
    cursor: "unset",
    svg: {
      color: t.other.colors.greyIron[10],
      transition: Ae(["color"]),
      width: m(24),
      height: m(24)
    },
    "&:hover": {
      backgroundColor: "transparent",
      color: t.other.colors.greyIron[16],
      svg: {
        color: t.other.colors.greyIron[16]
      }
    },
    "&:focus-visible": {
      outlineColor: `${t.other.colors.greyIron[4]} !important`
    },
    "&:active": {
      backgroundColor: "transparent",
      color: t.other.colors.greyIron[19]
    },
    '&[data-direction="up"]': {
      svg: {
        marginTop: 6
      }
    },
    '&[data-direction="down"]': {
      svg: {
        marginBottom: 6
      }
    }
  },
  controls: {
    background: "transparent !important",
    borderTopRightRadius: t.other.borderRadius[8]
  }
})), YD = ge(
  ({
    elementSize: t = mt.M,
    classNames: e,
    label: n,
    labelIcon: r,
    leftSection: o,
    leftSectionWidth: i = 34,
    disabled: s,
    error: l,
    rightSection: a,
    labelIconTooltipText: c,
    withToggle: d,
    isToggleChecked: u,
    onToggle: f,
    hideControls: h = !0,
    errorVariant: p = fa.default,
    required: y,
    withAsterisk: b,
    tooltipProps: w,
    ...S
  }, x) => {
    const [E, v] = Qm(u ? [!0, !1] : [!1, !0]), { classes: T, cx: I } = sr({ elementSize: t }), { classes: M } = KD({ withIcon: !!o }), R = (V) => {
      f == null || f(V), v();
    }, A = me(() => p === fa.tooltip ? !!l : l, [l, p]), F = me(
      () => /* @__PURE__ */ g.createElement(JD, { disabled: s, rightSection: a, error: l, errorVariant: p }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [s, l, p, a]
    );
    return /* @__PURE__ */ g.createElement(
      WS,
      {
        ref: x,
        classNames: {
          ...M,
          wrapper: I(T.wrapper, M.wrapper),
          error: I(T.error, M.error),
          required: I(T.required, M.required),
          input: I(T.input, M.input, e == null ? void 0 : e.input),
          root: I(T.root, M.root, e == null ? void 0 : e.root),
          label: I(T.label, M.label, e == null ? void 0 : e.label, { [M.labelDisabled]: s }),
          description: I(T == null ? void 0 : T.description, M.description, e == null ? void 0 : e.description, { [M.labelDisabled]: s }),
          section: I(T == null ? void 0 : T.section, M.section, e == null ? void 0 : e.section, {
            [I(T.iconDisabled, M.iconDisabled)]: s,
            [I(T.iconError, M.iconError)]: l
          })
        },
        disabled: d ? !E : s,
        label: (n || r) && /* @__PURE__ */ g.createElement(
          "div",
          {
            className: I(T.labelWrapper, M.labelWrapper, {
              [I(M.labelWrapperWithIcon, T.labelWrapperWithIcon)]: r
            })
          },
          n && /* @__PURE__ */ g.createElement("span", null, n, (y || b) && /* @__PURE__ */ g.createElement("span", { className: I(T.required, e == null ? void 0 : e.required), "aria-hidden": !0 }, " *")),
          (r || c) && /* @__PURE__ */ g.createElement(at, { label: c, style: { maxWidth: m(200) }, multiline: !0, ...w }, /* @__PURE__ */ g.createElement(
            "span",
            {
              className: I(T.labelIcon, M.labelIcon, { [I(M.iconDisabled, T.iconDisabled)]: s })
            },
            r || /* @__PURE__ */ g.createElement(Nr, null)
          ))
        ),
        inputContainer: d ? (V) => /* @__PURE__ */ g.createElement("div", { className: I(T.inputContainer, M.inputContainer), "data-testid": "input-container" }, V, /* @__PURE__ */ g.createElement(
          Of,
          {
            className: I(M.toggle, T.toggle),
            value: E,
            onChange: R,
            "data-testid": "input-toggle"
          }
        )) : void 0,
        leftSection: ot(t, [void 0, void 0, o, o]),
        leftSectionWidth: ot(t, [0, 0, i, i]),
        rightSectionWidth: ot(t, [0, 0, i, i]),
        rightSection: ot(t, [void 0, void 0, F, F]),
        inputWrapperOrder: ["label", "input", "description", "error"],
        error: A,
        hideControls: h,
        required: y,
        ...S
      }
    );
  }
);
YD.displayName = "NumberInput";
const Tb = (t) => (e) => {
  for (const n of t)
    typeof n == "function" ? n(e) : n != null && (n.current = e);
}, Ib = '"-internal-autofill-selected"', ZD = O(
  (t, { elementSize: e, isAutoFilled: n, withIcon: r }) => {
    const o = ot(e, [40, 40, 40, 36]);
    return {
      error: {},
      wrapper: {
        gap: m(6)
      },
      input: {
        transition: Ae(["background-color", "border-color", "color"]),
        height: m(o),
        borderColor: n ? t.other.colors.brand[13] : void 0,
        '&[data-error="true"]': {
          [`& ~ .${yy}`]: {
            [`& > .${by}`]: {
              [`& > .${wy}`]: {
                svg: {
                  color: `${t.other.colors.raspberry[12]} !important`
                }
              }
            }
          }
        }
      },
      innerInput: {
        height: m(o - 2),
        // inputHeight - border width
        transition: Ae(["background-color", "border-color", "color"]),
        border: "none",
        "&:-internal-autofill-selected": {
          border: "none",
          boxShadow: `0 0 0 ${m(40)} ${t.other.colors.brand[0]} inset`,
          content: `${Ib}`
        },
        color: t.other.colors.black[0],
        marginLeft: r ? m(2) : 0,
        '&[data-invalid="true"]': {
          "--input-placeholder-color": t.other.colors.raspberry[12]
        }
      },
      description: {
        marginTop: m(-2)
      },
      visibilityToggle: {
        marginLeft: m(1),
        backgroundColor: "transparent",
        svg: {
          transition: Ae(["stroke"])
        },
        "&:hover": {
          backgroundColor: "transparent",
          svg: {
            stroke: t.other.colors.brand[10]
          }
        }
      }
    };
  }
), XD = ge(
  ({
    elementSize: t = mt.M,
    classNames: e,
    label: n,
    labelIcon: r,
    leftSection: o,
    leftSectionWidth: i,
    disabled: s,
    error: l,
    value: a,
    required: c,
    withAsterisk: d,
    ...u
  }, f) => {
    const h = Nt(null), [p, y] = ie(!1), { classes: b, cx: w } = sr({ elementSize: t }), { classes: S } = ZD({ elementSize: t, isAutoFilled: p, withIcon: !!o });
    return It(() => {
      const x = h.current;
      getComputedStyle(x, ":-internal-autofill-selected").content === Ib ? y(!0) : y(!1);
    }, [a]), /* @__PURE__ */ g.createElement(
      GS,
      {
        ref: Tb([h, f]),
        classNames: {
          ...b,
          error: w(b.error, S.error, e == null ? void 0 : e.error),
          required: w(b.required, e == null ? void 0 : e.required),
          root: w(b.root, e == null ? void 0 : e.root),
          wrapper: w(b.wrapper, S.wrapper, e == null ? void 0 : e.wrapper),
          input: w(b.input, S.input, e == null ? void 0 : e.input),
          innerInput: w(S.innerInput, e == null ? void 0 : e.innerInput),
          label: w(b.label, e == null ? void 0 : e.label, { [b.labelDisabled]: s }),
          description: w(b.description, S.description, e == null ? void 0 : e.description, { [b.labelDisabled]: s }),
          section: w(b.section, e == null ? void 0 : e.section, { [b.iconDisabled]: s }),
          visibilityToggle: w(S.visibilityToggle, e == null ? void 0 : e.visibilityToggle)
        },
        disabled: s,
        label: /* @__PURE__ */ g.createElement("div", { className: w(b.labelWrapper, { [b.labelWrapperWithIcon]: r }) }, n && /* @__PURE__ */ g.createElement("span", null, n, (c || d) && /* @__PURE__ */ g.createElement("span", { className: w(b.required, e == null ? void 0 : e.required), "aria-hidden": !0 }, " *")), r ? /* @__PURE__ */ g.createElement("span", { className: w(b.svgIcon, b.labelIcon, { [b.iconDisabled]: s }) }, r) : null),
        leftSection: o,
        leftSectionWidth: i,
        visibilityToggleIcon: ({ reveal: x }) => x ? /* @__PURE__ */ g.createElement(wC, null) : /* @__PURE__ */ g.createElement(SC, null),
        inputWrapperOrder: ["label", "input", "description", "error"],
        error: l,
        value: a,
        ...u
      }
    );
  }
);
XD.displayName = "PasswordInput";
const QD = (t) => {
  const e = /* @__PURE__ */ new Map();
  for (const n of t)
    e.set(n.value, n.alias.toUpperCase());
  return e;
}, e2 = O((t, { elementSize: e }) => {
  const n = ot(e, [0, 0, 20, 18]);
  return {
    root: {},
    label: {
      display: "inline-block",
      font: t.other.fonts.desktop.s.s.label,
      color: t.other.colors.greyIron[15],
      wordBreak: "break-word",
      cursor: "default",
      WebkitTapHighlightColor: "transparent"
    },
    labelWrapper: {
      display: "inline-flex",
      alignItems: "center"
    },
    labelWrapperWithIcon: {
      [`& + .${Rh(Ps)}`]: {
        marginLeft: -2
      }
    },
    svgIcon: {
      svg: {
        width: n,
        height: n,
        color: t.other.colors.greyIron[10]
      }
    },
    labelIcon: {
      marginLeft: t.other.spacings[4],
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      svg: {
        width: 16,
        height: 16
      }
    },
    iconDisabled: {
      svg: {
        stroke: t.other.colors.greyIron[9]
      }
    },
    required: {
      color: t.other.colors.brand[13],
      ref: Rh(Ps)
    },
    error: {
      color: t.other.colors.raspberry[12],
      font: t.other.fonts.desktop.s.s.default
    }
  };
}), t2 = 15, n2 = O(() => ({
  input: {
    minWidth: 129,
    width: "100%"
  }
})), r2 = ({
  defaultValue: t,
  value: e,
  elementSize: n = mt.M,
  placeholder: r = "Mobile number",
  disabled: o,
  error: i,
  onChange: s,
  ...l
}) => {
  const { classes: a, cx: c } = sr({ elementSize: n }), { classes: d } = n2(), u = te(
    (f) => {
      const h = f.currentTarget.value.replace(/\D/g, "");
      s == null || s(h);
    },
    [s]
  );
  return /* @__PURE__ */ g.createElement(
    zm,
    {
      value: e,
      defaultValue: t,
      maxLength: t2,
      placeholder: r,
      onChange: u,
      "data-testid": "phone-number-input",
      classNames: {
        ...a,
        wrapper: c(a.wrapper),
        error: c(a.error),
        required: c(a.required),
        input: c(a.input, d.input),
        label: c(a.label, { [a.labelDisabled]: o }),
        description: c(a.description, { [a.labelDisabled]: o }),
        section: c(a.section, { [c(a.iconDisabled)]: o })
      },
      error: i,
      disabled: o,
      ...l
    }
  );
};
var ma = /* @__PURE__ */ ((t) => (t.default = "default", t.tooltip = "tooltip", t))(ma || {});
const o2 = ({
  value: t,
  defaultValue: e = "",
  searchValue: n,
  defaultSearchValue: r,
  initiallyOpened: o = !1,
  onChange: i,
  onDropdownOpen: s,
  onDropdownClose: l,
  onSearchChange: a,
  searchable: c
}) => {
  const [d, u] = an({
    value: t,
    defaultValue: e,
    finalValue: "",
    onChange: i
  }), [f, h] = an({
    value: n,
    defaultValue: r,
    finalValue: "",
    onChange: a
  }), p = Hm({
    defaultOpened: o,
    onDropdownClose: () => {
      p.resetSelectedOption(), h(""), l == null || l();
    },
    onDropdownOpen: () => {
      c && p.focusSearchInput(), p.updateSelectedOptionIndex("active", { scrollIntoView: !0 }), s == null || s();
    }
  }), y = te(
    (S) => {
      p.updateSelectedOptionIndex(), h(S.currentTarget.value);
    },
    [p, h]
  ), b = te(
    (S) => {
      u(S), p.closeDropdown();
    },
    [p, u]
  ), w = te(() => {
    p.toggleDropdown();
  }, [p]);
  return {
    combobox: p,
    selectedValue: d,
    search: f,
    setSearch: h,
    handleSearchChange: y,
    setSelectedValue: u,
    onOptionSubmit: b,
    handleComboboxToggle: w
  };
}, Mb = (t) => {
  switch (t) {
    case mt.M:
      return ln.M;
    case mt.S:
      return ln.S;
    default:
      return ln.M;
  }
}, i2 = (t) => {
  const { errorVariant: e, error: n, disabled: r, children: o, className: i } = t;
  return e === ma.tooltip && n ? /* @__PURE__ */ g.createElement(at, { disabled: r, label: n, maw: 220, withinPortal: !0, multiline: !0 }, /* @__PURE__ */ g.createElement(oe, { "data-testid": "select-error-in-tooltip", component: "span", display: "flex", style: { pointerEvents: "all" }, className: i }, /* @__PURE__ */ g.createElement(Ei, { width: 20, height: 20 }))) : /* @__PURE__ */ g.createElement(g.Fragment, null, o);
}, s2 = O((t, { elementSize: e }) => ({
  rightSectionWrapper: {
    width: "100%",
    position: "absolute",
    right: 1,
    top: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: `calc(100% - ${m(2)})`,
    cursor: "pointer",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: m(8),
    pointerEvents: "none"
  },
  rightSectionWrapperDisabled: {
    cursor: "not-allowed",
    background: "transparent",
    "&::before": {
      background: "transparent"
    }
  },
  clearButton: {
    pointerEvents: "all",
    height: "100%"
  },
  rightSectionDivider: {
    margin: `auto ${m(6)} auto`
  },
  error: {
    color: t.other.colors.raspberry[12]
  },
  chevron: {
    width: m(hr(e, [20, 14])),
    height: m(hr(e, [20, 14])),
    transition: Ae(["transform"]),
    color: t.other.colors.greyIron[12]
  },
  chevronOpened: {
    transform: "rotate(-180deg)"
  },
  alert: {}
})), l2 = ({
  clearable: t,
  selectedValue: e,
  disabled: n,
  rightSection: r,
  elementSize: o,
  dropdownOpened: i,
  onClearIcon: s,
  error: l,
  errorVariant: a,
  classNames: c
}) => {
  const d = Mb(o), u = !!(t && e && !n), { classes: f, cx: h } = s2({ elementSize: d });
  return /* @__PURE__ */ g.createElement(
    X,
    {
      gap: 0,
      align: "center",
      className: h(f.rightSectionWrapper, c == null ? void 0 : c.rightSectionWrapper, { [f.rightSectionWrapperDisabled]: n })
    },
    u ? /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(
      ye,
      {
        className: h(f.clearButton, c == null ? void 0 : c.clearButton),
        elementVariant: Q.SecondaryMainLine,
        leftSection: /* @__PURE__ */ g.createElement(nf, null),
        isIconOnly: !0,
        onClick: s,
        onMouseDown: (p) => p.preventDefault()
      }
    ), /* @__PURE__ */ g.createElement(il, { className: h(f.rightSectionDivider, c == null ? void 0 : c.rightSectionDivider), orientation: "vertical", height: 20 })) : null,
    /* @__PURE__ */ g.createElement(
      i2,
      {
        disabled: n,
        error: l,
        errorVariant: a,
        className: h(f.alert, { [h(f.error, c == null ? void 0 : c.error)]: !!l })
      },
      r || /* @__PURE__ */ g.createElement(g.Fragment, null, !n && /* @__PURE__ */ g.createElement(
        ye,
        {
          role: "button",
          component: "div",
          elementVariant: Q.SecondaryMainLine,
          isIconOnly: !0,
          disabled: n,
          "data-testid": "select-right-section",
          onMouseDown: (p) => p.preventDefault(),
          rightSection: /* @__PURE__ */ g.createElement(
            Sr,
            {
              className: h(f.chevron, {
                [f.chevronOpened]: i,
                [h(f.error, c == null ? void 0 : c.error)]: !!l
              })
            }
          )
        }
      ))
    )
  );
}, a2 = O(() => ({
  valueItem: {
    "&&": {
      display: "inline-block",
      margin: 0,
      marginRight: m(4),
      padding: `${m(4)} 0 ${m(4)} 0`,
      width: 0,
      float: "left",
      boxSizing: "border-box",
      minWidth: 0,
      whiteSpace: "nowrap"
    },
    "&::after": {
      content: "','"
    },
    "&:nth-last-of-type(1)::after": {
      content: "''"
    }
  }
})), c2 = ({ label: t, classNames: e, className: n, ...r }) => {
  const { classes: o, cx: i } = a2();
  return t ? /* @__PURE__ */ g.createElement(oe, { component: "span", className: i(fy, o.valueItem, n, e == null ? void 0 : e.valueItem), ...r }, t) : null;
}, d2 = O(
  (t, {
    elementSize: e
  }) => {
    const n = ot(e, [40, 40, 40, 36]);
    return {
      selectInputValue: {
        overflow: "hidden"
      },
      selectPlaceholder: {
        display: "inline-block",
        color: t.other.colors.greyIron[10],
        lineHeight: m(n)
      },
      error: {
        color: t.other.colors.raspberry[12]
      },
      disabled: {
        color: t.other.colors.greyIron[9]
      },
      valueItem: {}
    };
  }
), u2 = ({
  selectedValue: t,
  elementSize: e,
  disabled: n,
  placeholder: r,
  label: o,
  error: i,
  classNames: s,
  data: l,
  compact: a
}) => {
  const { classes: c, cx: d } = d2({ elementSize: e }), u = me(() => {
    var f;
    return a || (f = l.find(({ value: h }) => h === t)) == null ? void 0 : f.label;
  }, [a, l, t]);
  return /* @__PURE__ */ g.createElement(X, { gap: 0, "aria-label": o == null ? void 0 : o.toString(), p: 0, align: "center", className: d(c.selectInputValue, s == null ? void 0 : s.selectInputValue) }, u && /* @__PURE__ */ g.createElement(c2, { label: u, classNames: s }), !u && !a && /* @__PURE__ */ g.createElement(
    oe,
    {
      component: "span",
      className: d(c.selectPlaceholder, s == null ? void 0 : s.selectPlaceholder, {
        [d(c.error, s == null ? void 0 : s.error)]: !!i,
        [d(c.disabled)]: n
      })
    },
    r
  ));
}, f2 = O((t) => ({
  label: {},
  labelWrapper: {
    display: "inline-flex",
    alignItems: "center"
  },
  labelIcon: {
    color: t.other.colors.greyIron[10]
  },
  required: {}
})), Rb = ge((t, e) => {
  const { label: n, labelIcon: r, labelIconTooltipText: o, disabled: i, elementSize: s, classNames: l, onClick: a, required: c, tooltipProps: d } = t, { classes: u, cx: f } = f2(), { classes: h } = sr({ elementSize: s });
  return /* @__PURE__ */ g.createElement(oe, { component: "span", className: f(u.labelWrapper, l == null ? void 0 : l.labelWrapper, { [h.labelWrapperWithIcon]: r }) }, n && /* @__PURE__ */ g.createElement("span", null, /* @__PURE__ */ g.createElement(oe, { component: "span", ref: e, onClick: a }, n), c && /* @__PURE__ */ g.createElement("span", { className: f(h.required, u == null ? void 0 : u.required), "aria-hidden": !0 }, " *")), (r || o) && /* @__PURE__ */ g.createElement(at, { label: o, style: { maxWidth: m(200) }, multiline: !0, withinPortal: !0, ...d }, /* @__PURE__ */ g.createElement(
    oe,
    {
      component: "span",
      className: f(h.labelIcon, h.labelIcon, { [h.iconDisabled]: i }, u.labelIcon)
    },
    r || /* @__PURE__ */ g.createElement(Nr, null)
  )));
});
Rb.displayName = "SelectLabel";
const h2 = ({
  data: t,
  limit: e,
  search: n,
  searchableByDescription: r
}) => {
  const i = t.filter(
    ({ label: l, description: a }) => l.toLowerCase().includes(n.trim().toLowerCase()) || r && (a == null ? void 0 : a.toLowerCase().includes(n.trim().toLowerCase()))
  ).slice(0, e);
  return i.some((l) => l.group) ? i.sort((l, a) => l.group && a.group ? l.group.localeCompare(a.group) : 0) : i;
}, Ul = ge(({ label: t, description: e, ...n }, r) => /* @__PURE__ */ g.createElement(X, { wrap: "nowrap", gap: 0, ref: r, ...n }, /* @__PURE__ */ g.createElement(Ee, { gap: 4 }, /* @__PURE__ */ g.createElement(xe, { elementVariant: "default", elementSize: "s", c: "inherit", inherit: !0 }, t), e && /* @__PURE__ */ g.createElement(xe, { elementVariant: "default", elementSize: "xs", colorVariant: "greyIron.12" }, e))));
Ul.displayName = "SelectItem";
const p2 = O((t) => ({
  dropdownOptionsWrapper: {
    padding: `${m(4)} 0 ${m(4)} ${m(8)}`
  },
  dropdownScrollArea: {
    '& > [data-offset-scrollbars="xy"]': {
      padding: 0
    }
  },
  dropdownButtonGroup: {
    width: "100%",
    padding: `${m(4)} ${m(12)} ${m(8)} ${m(12)}`
  },
  dropdownItem: {
    color: t.other.colors.greyIron[20],
    minHeight: m(38),
    padding: `${m(8)} ${m(12)}`,
    wordBreak: "break-word",
    "&:hover": {
      backgroundColor: t.other.colors.greyIron[2],
      "&:where([data-combobox-disabled])": {
        backgroundColor: "transparent"
      }
    },
    "&:where([data-combobox-disabled])": {
      cursor: "not-allowed",
      opacity: 1,
      color: t.other.colors.greyIron[9],
      backgroundColor: t.other.colors.white[0]
    },
    "&:where([data-combobox-active])": {
      backgroundColor: t.other.colors.white[0],
      font: t.other.fonts.desktop.s.s.important,
      color: t.other.colors.brand[13],
      "&:hover": {
        backgroundColor: t.other.colors.greyIron[2],
        color: t.other.colors.brand[13]
      }
    },
    "&:where([data-combobox-selected])": {
      backgroundColor: t.other.colors.greyIron[2],
      "&:hover": {
        backgroundColor: t.other.colors.greyIron[2]
      }
    }
  },
  groupDivider: {
    margin: `0 ${m(8)}`,
    borderColor: t.other.colors.greyIron[3]
  },
  option: {}
})), g2 = ({
  data: t,
  selectedValue: e,
  maxDropdownHeight: n,
  search: r,
  limit: o,
  searchableByDescription: i,
  classNames: s,
  renderOption: l,
  nothingFoundMessage: a,
  dataTestId: c
}) => {
  const { classes: d, cx: u } = p2(), f = h2({ data: t, limit: o, search: r, searchableByDescription: i }), h = f.some((b) => b.group), p = [...new Set(f.map((b) => b.group))].filter(Boolean), y = f.filter((b) => !b.group);
  return /* @__PURE__ */ g.createElement(kt.Options, { className: u(d.dropdownOptionsWrapper, s == null ? void 0 : s.dropdownOptionsWrapper), "data-testid": c }, f.length > 0 ? /* @__PURE__ */ g.createElement(
    Fr.Autosize,
    {
      style: { maxHeight: n ? m(n) : "auto" },
      type: "auto",
      className: u(d.dropdownScrollArea, s == null ? void 0 : s.dropdownScrollArea)
    },
    h ? /* @__PURE__ */ g.createElement(Ee, { gap: 0 }, p.map((b) => /* @__PURE__ */ g.createElement(kt.Group, { label: b, key: b }, f.filter((w) => w.group === b).map(({ value: w, label: S, description: x, disabled: E, "data-testid": v, ...T }) => /* @__PURE__ */ g.createElement(
      kt.Option,
      {
        key: w,
        value: w,
        active: e === w,
        className: u(d.dropdownItem, s == null ? void 0 : s.dropdownItem, s == null ? void 0 : s.option),
        disabled: E,
        "data-testid": v,
        selected: e === w
      },
      typeof l == "function" ? l({ value: w, label: S, description: x, disabled: E, "data-testid": v, ...T }) : /* @__PURE__ */ g.createElement(Ul, { label: S, value: w, description: x })
    )))), y.length > 0 ? /* @__PURE__ */ g.createElement(Ee, null, /* @__PURE__ */ g.createElement(Qu, { mr: 8, className: u(d.groupDivider, s == null ? void 0 : s.groupDivider) }), y.map(({ value: b, label: w, description: S, disabled: x, "data-testid": E, ...v }) => /* @__PURE__ */ g.createElement(
      kt.Option,
      {
        value: b,
        key: b,
        active: e === b,
        className: u(d.dropdownItem, s == null ? void 0 : s.dropdownItem),
        "data-testid": E,
        selected: e === b,
        disabled: x
      },
      typeof l == "function" ? l({ value: b, label: w, description: S, disabled: x, "data-testid": E, ...v }) : /* @__PURE__ */ g.createElement(Ul, { label: w, value: b, description: S })
    ))) : null) : f.map(({ value: b, label: w, description: S, disabled: x, "data-testid": E, ...v }) => /* @__PURE__ */ g.createElement(
      kt.Option,
      {
        value: b,
        key: b,
        active: e === b,
        className: u(d.dropdownItem, s == null ? void 0 : s.dropdownItem),
        "data-testid": E,
        selected: e === b,
        disabled: x
      },
      typeof l == "function" ? l({ value: b, label: w, description: S, disabled: x, "data-testid": E, ...v }) : /* @__PURE__ */ g.createElement(Ul, { label: w, value: b, description: S })
    ))
  ) : /* @__PURE__ */ g.createElement(kt.Empty, null, /* @__PURE__ */ g.createElement(xe, { elementVariant: "default", elementSize: "s", colorVariant: "greyIron.10" }, a || "No data")));
}, Pp = "not-allowed", m2 = O(
  (t, { elementSize: e, shouldClear: n, withIcon: r, error: o }) => {
    const i = ot(e, [void 0, void 0, 20, 18]), s = ot(e, [40, 40, 40, 36]), l = n ? 71 : 36;
    return {
      root: {
        display: "flex",
        flexDirection: "column",
        gap: m(6),
        [`&:has(input:disabled) .${ys}`]: {
          display: "none"
        }
      },
      inputRoot: {
        display: "grid",
        gap: m(6)
      },
      wrapper: {
        marginBottom: 0
      },
      dropdown: {
        "&&": {
          paddingLeft: m(4),
          paddingRight: m(12),
          paddingBottom: m(8)
        }
      },
      dropdownScrollArea: {},
      dropdownButtonGroup: {},
      input: {
        paddingTop: 0,
        paddingBottom: 0,
        height: m(s),
        boxSizing: "border-box",
        paddingRight: m(l),
        paddingLeft: r ? m(36) : m(12),
        cursor: "pointer",
        "&::placeholder": {
          color: t.other.colors.greyIron[10]
        },
        ...o ? { borderColor: `${t.other.colors.raspberry[12]} !important` } : {},
        '&[data-error="true"]': {
          backgroundColor: t.other.colors.white[0],
          color: t.other.colors.greyIron[18],
          "&:hover:not(&:disabled)": {
            borderColor: t.other.colors.raspberry[12],
            backgroundColor: t.other.colors.raspberry[0]
          },
          "&:active:not(&:disabled)": {
            backgroundColor: t.other.colors.white[0]
          },
          "&:focus": {
            borderColor: t.other.colors.raspberry[12]
          },
          "&::placeholder": {
            color: t.other.colors.raspberry[12]
          },
          [`& ~ .${ys}`]: {
            svg: {
              color: t.other.colors.raspberry[12]
            }
          }
        }
      },
      selectPlaceholder: {},
      searchInput: {
        paddingTop: 0,
        paddingBottom: 0,
        position: "relative",
        boxSizing: "border-box",
        paddingRight: m(l),
        cursor: "pointer",
        "&::placeholder": {
          color: t.other.colors.greyIron[10]
        },
        font: t.other.fonts.desktop.s.s.default,
        overflow: "hidden",
        whiteSpace: "nowrap",
        height: m(36),
        minHeight: m(36),
        paddingLeft: m(32),
        margin: `0 0 0 ${m(8)}`,
        "&&": {
          borderWidth: "1px",
          width: `calc(100% - ${m(8)})`,
          maxWidth: `calc(100% - ${m(8)})`
        }
      },
      searchIcon: {
        marginLeft: m(12),
        width: m(18),
        height: m(18)
      },
      inputHovered: {
        borderColor: t.other.colors.brand[10]
      },
      label: {
        color: t.other.colors.greyIron[15]
      },
      labelWrapper: {
        display: "inline-flex",
        alignItems: "center"
      },
      itemsWrapper: {
        padding: t.other.spacings[12]
      },
      option: {
        color: t.other.colors.greyIron[18],
        wordBreak: "break-word",
        marginRight: `${m(6)} !important`,
        '&[data-hovered="true"], &:hover': {
          backgroundColor: t.other.colors.greyIron[2]
        },
        '&[data-selected="true"]': {
          backgroundColor: t.other.colors.white[0],
          font: t.other.fonts.desktop.s.s.important,
          color: t.other.colors.brand[13],
          '&[data-hovered="true"], &:hover': {
            backgroundColor: t.other.colors.greyIron[2],
            color: t.other.colors.brand[13]
          }
        }
      },
      separatorLabel: {
        font: t.other.fonts.desktop.s.xs.default,
        color: t.other.colors.greyIron[9],
        "&::after": {
          borderColor: t.other.colors.greyIron[4]
        }
      },
      separator: {
        borderColor: t.other.colors.greyIron[4],
        div: {
          borderColor: t.other.colors.greyIron[4]
        }
      },
      rightSectionWrapper: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        height: "100%",
        cursor: "pointer"
      },
      rightSectionWrapperDisabled: {
        cursor: Pp
      },
      rightSectionDivider: {
        margin: `auto ${m(6)} auto`
      },
      section: {
        '&[data-position="right"]': {
          display: "flex",
          flexDirection: "column",
          marginRight: 0,
          width: m(l),
          cursor: "pointer",
          svg: {
            width: m(i),
            height: m(i)
          }
        },
        '&[data-position="left"]': {
          display: "flex",
          flexDirection: "column",
          marginRight: 0,
          cursor: "pointer",
          svg: {
            width: m(i),
            height: m(i),
            color: t.other.colors.greyIron[12]
          }
        }
      },
      disabled: {
        [`& + .${ys}`]: {
          cursor: Pp,
          svg: {
            color: t.other.colors.greyIron[9]
          }
        }
      },
      clearButton: {
        pointerEvents: "all",
        height: "100%"
      },
      error: {
        color: t.other.colors.raspberry[12]
      },
      description: {
        color: t.other.colors.greyIron[10]
      },
      required: {}
    };
  }
), y2 = { duration: 300, transition: "pop-top-left" }, b2 = ["label", "input", "error", "description"], Ob = ge((t, e) => {
  const { styleProps: n, rest: r } = el(t), {
    data: o,
    elementSize: i = mt.M,
    clearable: s,
    disabled: l,
    classNames: a,
    label: c,
    labelIcon: d,
    labelIconTooltipText: u,
    rightSection: f,
    rightSectionPointerEvents: h,
    rightSectionWidth: p,
    rightSectionProps: y,
    onDropdownOpen: b,
    onDropdownClose: w,
    placeholder: S,
    searchable: x = !0,
    searchableByDescription: E,
    initiallyOpened: v,
    value: T,
    defaultValue: I,
    onChange: M,
    searchValue: R,
    defaultSearchValue: A,
    onSearchChange: F,
    error: V,
    required: P,
    maxDropdownHeight: J = 300,
    style: ne,
    description: G,
    position: H = "bottom-start",
    limit: W = Number.POSITIVE_INFINITY,
    errorVariant: se = ma.default,
    tooltipProps: U,
    leftSection: re,
    leftSectionWidth: ke,
    leftSectionPointerEvents: Te,
    leftSectionProps: Se,
    renderOption: Le,
    hiddenInputProps: Ce,
    nothingFoundMessage: et,
    compact: Oe,
    targetButtonProps: $e,
    "data-testid": Ie,
    ...ee
  } = he("Select", {}, r), { combobox: de, selectedValue: ae, search: Y, setSelectedValue: we, handleSearchChange: Ze, onOptionSubmit: Je, handleComboboxToggle: ht } = o2({
    value: T,
    defaultValue: I,
    searchValue: R,
    defaultSearchValue: A,
    initiallyOpened: v,
    onChange: M,
    onDropdownOpen: b,
    onDropdownClose: w,
    onSearchChange: F,
    searchable: x
  }), Xe = !!(s && ae && !l), Lt = Mb(i), { classes: Be, cx: tt } = m2({ elementSize: i, error: !!V, withIcon: !!re, shouldClear: Xe }), { classes: St } = sr({ elementSize: i }), { classes: Mt } = yf({ elementSize: Lt }), nt = (je) => Ie ? `${Ie}-${je}` : void 0;
  return /* @__PURE__ */ g.createElement(Ee, { gap: 4, className: tt(Be.root, a == null ? void 0 : a.root), style: ne, ...n }, /* @__PURE__ */ g.createElement(
    kt,
    {
      store: de,
      onOptionSubmit: Je,
      transitionProps: y2,
      position: H,
      middlewares: { shift: !1 },
      "data-testid": Ie,
      ...ee
    },
    /* @__PURE__ */ g.createElement(kt.Target, null, $e != null && $e.children ? /* @__PURE__ */ g.createElement(oe, null, /* @__PURE__ */ g.createElement(
      ye,
      {
        "data-testid": nt("button"),
        ...$e,
        onClick: l ? void 0 : ht,
        ref: e
      },
      $e.children
    ), /* @__PURE__ */ g.createElement(
      kt.HiddenInput,
      {
        value: ae,
        name: ee.name,
        disabled: l,
        "data-testid": nt("input"),
        ...Ce
      }
    )) : /* @__PURE__ */ g.createElement(
      zm,
      {
        "data-testid": nt("button"),
        component: "button",
        type: "button",
        pointer: !0,
        rightSectionPointerEvents: h || "none",
        rightSectionWidth: p,
        rightSectionProps: y,
        ref: e,
        error: se === ma.default ? V : void 0,
        label: c || d ? /* @__PURE__ */ g.createElement(
          Rb,
          {
            label: c,
            labelIcon: d,
            labelIconTooltipText: u,
            disabled: l,
            elementSize: i,
            classNames: a,
            required: P,
            tooltipProps: U
          }
        ) : void 0,
        onClick: ht,
        classNames: {
          wrapper: tt(Be.wrapper, a == null ? void 0 : a.wrapper),
          root: tt(Be.inputRoot, a == null ? void 0 : a.inputRoot),
          input: tt(St.input, Be.input, a == null ? void 0 : a.input),
          required: tt(St.required, Be.required, a == null ? void 0 : a.required),
          label: tt(St.label, Be.label, Be.label, a == null ? void 0 : a.label, {
            [St.labelDisabled]: l
          }),
          section: tt(Be.section, a == null ? void 0 : a.section),
          description: tt(Be.description, St.description, a == null ? void 0 : a.description),
          error: tt(Be.error, St.error, a == null ? void 0 : a.error)
        },
        description: G,
        required: P,
        disabled: l,
        tabIndex: 0,
        leftSection: re,
        leftSectionWidth: ke,
        leftSectionPointerEvents: Te,
        leftSectionProps: Se,
        inputWrapperOrder: b2,
        rightSection: /* @__PURE__ */ g.createElement(
          l2,
          {
            clearable: s,
            selectedValue: ae,
            disabled: l,
            rightSection: f,
            elementSize: i,
            dropdownOpened: de.dropdownOpened,
            onClearIcon: () => {
              we(null), de.closeDropdown();
            },
            classNames: a,
            error: V,
            errorVariant: se
          }
        )
      },
      /* @__PURE__ */ g.createElement(
        kt.HiddenInput,
        {
          value: ae,
          name: ee.name,
          disabled: l,
          "data-testid": nt("input"),
          ...Ce
        }
      ),
      /* @__PURE__ */ g.createElement(
        u2,
        {
          compact: Oe,
          data: o,
          selectedValue: ae,
          disabled: l,
          elementSize: i,
          classNames: a,
          error: V,
          label: ae,
          placeholder: S
        }
      )
    )),
    /* @__PURE__ */ g.createElement(kt.Dropdown, { className: tt(Mt.dropdown, Be.dropdown, a == null ? void 0 : a.dropdown), "data-testid": nt("dropdown") }, x && /* @__PURE__ */ g.createElement(
      kt.Search,
      {
        value: Y,
        leftSection: /* @__PURE__ */ g.createElement(Ym, { className: tt(Be.searchIcon, a == null ? void 0 : a.searchIcon) }),
        onChange: Ze,
        classNames: {
          input: tt(St.input, Be.searchInput, a == null ? void 0 : a.searchInput)
        },
        placeholder: S,
        "data-testid": nt("search")
      }
    ), /* @__PURE__ */ g.createElement(
      g2,
      {
        data: o,
        selectedValue: ae,
        maxDropdownHeight: J,
        search: Y,
        searchableByDescription: E,
        classNames: a,
        limit: W,
        renderOption: Le,
        nothingFoundMessage: et,
        dataTestId: nt("options")
      }
    ))
  ));
});
Ob.displayName = "Select";
const Db = (t) => {
  if (t && t !== "--")
    return ny(t);
}, w2 = (t) => t.replace(/_\+\d+/g, ""), S2 = O(() => ({
  input: {
    minWidth: m(106),
    // to fit with clearable and flag
    width: m(140),
    paddingRight: 0
  },
  dropdown: {},
  option: {
    "--mantine-font-size-md": m(14)
  }
})), C2 = (t) => {
  const { alias: e, name: n, label: r, ...o } = t, i = Db(e);
  return /* @__PURE__ */ g.createElement(X, { wrap: "nowrap", ...o }, /* @__PURE__ */ g.createElement(Jo, { src: i, alt: e, avatarSize: 20 }), /* @__PURE__ */ g.createElement(As, { style: { width: m(43), flexShrink: 0 }, c: "inherit", inherit: !0 }, r), /* @__PURE__ */ g.createElement(As, { c: "inherit", inherit: !0 }, n));
}, v2 = ({
  countries: t,
  placeholder: e = "Country",
  defaultValue: n,
  searchable: r = !0,
  onChange: o,
  prepareCountryCodeFlagPath: i,
  value: s,
  countryCodeToAliasMap: l,
  ...a
}) => {
  const { classes: c } = S2(), d = me(() => {
    if (!s)
      return null;
    let u = Db(w2(l.get(s) || "")) || "";
    return i && u && (u = i == null ? void 0 : i(u)), u ? /* @__PURE__ */ g.createElement(Jo, { avatarSize: 16, src: u }) : null;
  }, [s, l, i]);
  return /* @__PURE__ */ g.createElement(
    Ob,
    {
      data: t,
      placeholder: e,
      value: s,
      defaultValue: n,
      renderOption: C2,
      onChange: o,
      leftSection: d,
      "data-testid": "select-country-code",
      classNames: c,
      clearable: !1,
      searchable: r,
      width: 300,
      position: "bottom-start",
      ...a
    }
  );
}, hz = ({
  phoneNumberValue: t,
  phoneNumberDefaultValue: e,
  countryCodeValue: n,
  countryCodeDefaultValue: r,
  countryCodeSelectProperties: o,
  countries: i,
  inputSize: s = mt.M,
  selectSize: l,
  inputPlaceholder: a,
  selectPlaceholder: c,
  disabled: d,
  countryCodeError: u,
  phoneNumberError: f,
  onCountryCodeChange: h,
  onPhoneNumberChange: p,
  prepareCountryCodeFlagPath: y,
  labelIcon: b,
  label: w,
  labelIconTooltipText: S,
  required: x,
  classNames: E,
  className: v,
  tooltipProps: T,
  ...I
}) => {
  const { classes: M, cx: R } = e2({ elementSize: s }), A = me(() => QD(i), [i]), [F, V] = an({
    value: n,
    defaultValue: "",
    onChange: h
  }), [P, J] = an({
    value: t,
    defaultValue: "",
    onChange: p
  });
  return /* @__PURE__ */ g.createElement(Ee, { gap: 4, className: R(M.root, E == null ? void 0 : E.root, v), ...I }, /* @__PURE__ */ g.createElement(
    vi.Label,
    {
      classNames: { label: R(M.label, E == null ? void 0 : E.label), required: R(M.required, E == null ? void 0 : E.required) },
      required: x
    },
    (w || b) && /* @__PURE__ */ g.createElement(
      "div",
      {
        className: R(M.labelWrapper, E == null ? void 0 : E.labelWrapper, {
          [R(M.labelWrapperWithIcon, E == null ? void 0 : E.labelWrapperWithIcon)]: b
        })
      },
      w && /* @__PURE__ */ g.createElement("span", null, w),
      (b || S) && /* @__PURE__ */ g.createElement(at, { label: S, style: { maxWidth: m(200) }, multiline: !0, ...T }, /* @__PURE__ */ g.createElement("span", { className: R(M.svgIcon, M.labelIcon, E == null ? void 0 : E.labelIcon, { [M.iconDisabled]: d }) }, b || /* @__PURE__ */ g.createElement(Nr, null)))
    )
  ), /* @__PURE__ */ g.createElement(X, { align: "start", gap: 8, wrap: "nowrap" }, /* @__PURE__ */ g.createElement(
    v2,
    {
      onChange: V,
      countries: i,
      defaultValue: r,
      value: F,
      elementSize: l,
      placeholder: c,
      disabled: d,
      error: !!u,
      prepareCountryCodeFlagPath: y,
      countryCodeToAliasMap: A,
      clearable: !0,
      ...o
    }
  ), /* @__PURE__ */ g.createElement(
    r2,
    {
      styles: { root: { flexGrow: 1 } },
      defaultValue: e,
      value: P,
      onChange: J,
      elementSize: s,
      placeholder: a,
      disabled: d,
      error: !!f
    }
  )), (u || f) && /* @__PURE__ */ g.createElement(vi.Error, { className: M.error }, u || f));
}, x2 = O((t, { withIcon: e }) => ({
  input: {
    paddingLeft: e ? m(36) : m(12)
  }
})), Ab = ge(
  ({
    elementSize: t = mt.M,
    classNames: e,
    label: n,
    labelIcon: r,
    leftSection: o,
    leftSectionWidth: i,
    disabled: s,
    error: l,
    rightSection: a,
    labelIconTooltipText: c,
    withToggle: d,
    isToggleChecked: u,
    onToggle: f,
    required: h,
    withAsterisk: p,
    tooltipProps: y,
    ...b
  }, w) => {
    const [S, x] = Qm(u ? [!0, !1] : [!1, !0]), { classes: E, cx: v } = sr({ elementSize: t }), { classes: T } = x2({ withIcon: !!o }), I = l ? /* @__PURE__ */ g.createElement(Ei, null) : a, M = (R) => {
      f == null || f(R), x();
    };
    return /* @__PURE__ */ g.createElement(
      jm,
      {
        ref: w,
        classNames: {
          ...E,
          wrapper: v(E.wrapper, e == null ? void 0 : e.wrapper),
          input: v(E.input, T.input, e == null ? void 0 : e.input),
          root: v(E.root, e == null ? void 0 : e.root),
          required: v(E.required, e == null ? void 0 : e.required),
          error: v(E.error, e == null ? void 0 : e.error),
          label: v(E.label, { [E.labelDisabled]: s }),
          description: v(E.description, { [E.labelDisabled]: s }),
          section: v(E.section, e == null ? void 0 : e.section, { [E.iconDisabled]: s, [E.iconError]: l })
        },
        disabled: d ? !S : s,
        label: (n || r) && /* @__PURE__ */ g.createElement("div", { className: v(E.labelWrapper, { [E.labelWrapperWithIcon]: r }) }, n && /* @__PURE__ */ g.createElement("span", null, n, (h || p) && /* @__PURE__ */ g.createElement("span", { className: v(E.required, e == null ? void 0 : e.required), "aria-hidden": !0 }, " *")), (r || c) && /* @__PURE__ */ g.createElement(at, { label: c, style: { maxWidth: m(200) }, multiline: !0, ...y }, /* @__PURE__ */ g.createElement("span", { className: v(E.labelIcon, { [E.iconDisabled]: s }) }, r || /* @__PURE__ */ g.createElement(Nr, null)))),
        inputContainer: d ? (R) => /* @__PURE__ */ g.createElement("div", { className: E.inputContainer, "data-testid": "input-container" }, R, /* @__PURE__ */ g.createElement(Of, { className: E.toggle, value: S, onChange: M, "data-testid": "input-toggle" })) : void 0,
        leftSection: ot(t, [void 0, void 0, o, o]),
        leftSectionWidth: ot(t, [0, 0, i, i]),
        rightSectionWidth: ot(t, [0, 0, i, i]),
        rightSection: ot(t, [void 0, void 0, I, I]),
        inputWrapperOrder: ["label", "input", "description", "error"],
        error: l,
        required: h,
        ...b
      }
    );
  }
);
Ab.displayName = "TextInput";
const E2 = O((t) => ({
  main: {
    font: t.other.fonts.desktop.s.m.default,
    color: t.other.colors.blue[13],
    textDecoration: "underline",
    textUnderlineOffset: 4,
    textDecorationColor: t.other.colors.blue[9],
    transition: Ae(["color", "text-decoration-color"]),
    "&::selection": {
      backgroundColor: t.other.colors.blue[2]
    },
    "&:hover": {
      textDecorationColor: t.other.colors.blue[13],
      color: t.other.colors.blue[13]
    },
    "&:active": {
      color: t.other.colors.blue[15],
      textDecorationColor: t.other.colors.blue[15]
    },
    "&:visited": {
      color: t.other.colors.blue[15],
      textDecorationColor: t.other.colors.blue[9],
      "&:hover": {
        textDecorationColor: t.other.colors.blue[15]
      },
      "&:active": {
        color: t.other.colors.blue[17],
        textDecorationColor: t.other.colors.blue[17]
      }
    }
  }
})), k2 = ({ children: t, className: e, ...n }) => {
  const { classes: r, cx: o } = E2();
  return /* @__PURE__ */ g.createElement(US, { component: "a", className: o(r.main, e), ...n }, t);
};
k2.displayName = "LinkText";
const Qc = "inline-flex", T2 = (t, e, n) => {
  var i;
  const r = (i = yo(n.other.colors, e)) == null ? void 0 : i.replace(/#/g, "%23");
  return {
    m: `url("data:image/svg+xml,%3Csvg width='8' height='24' viewBox='0 0 8 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='4' cy='13' r='4' fill='${r}'/%3E%3C/svg%3E%0A")`,
    s: `url("data:image/svg+xml,%3Csvg width='8' height='20' viewBox='0 0 8 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='4' cy='10' r='3' fill='${r}'/%3E%3C/svg%3E%0A")`,
    xs: `url("data:image/svg+xml,%3Csvg width='8' height='18' viewBox='0 0 8 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='4' cy='9' r='2' fill='${r}'/%3E%3C/svg%3E%0A")`
  }[t];
}, I2 = (t) => ({
  m: m(24),
  s: m(20),
  xs: m(18)
})[t], M2 = O(
  (t, { elementSize: e = "s", markerSpacing: n, colorVariant: r }) => {
    const o = I2(e), i = T2(e, r, t);
    return {
      root: {
        paddingLeft: m(17),
        gap: m(4),
        display: "flex",
        flexDirection: "column"
      },
      item: {
        font: t.other.fonts.desktop.s[e].default,
        color: yo(t.other.colors, r),
        lineHeight: o
      },
      bulletList: {
        listStyleType: "none",
        display: Qc,
        "&:before": {
          content: '""',
          backgroundImage: i,
          display: "inline-block",
          marginRight: m(n),
          width: m(8),
          minWidth: m(8),
          height: o
        }
      },
      dashList: {
        listStyleType: "none",
        display: Qc,
        "&:before": {
          content: '"—"',
          display: "inline-block",
          marginRight: m(n)
        }
      },
      orderedList: {
        display: Qc,
        "&:before": {
          content: '""',
          display: "list-item",
          marginRight: m(n)
        }
      },
      withIcon: {},
      itemWrapper: {},
      itemIcon: {}
    };
  }
), Lb = ge((t, e) => {
  const {
    children: n,
    classNames: r,
    unstyled: o,
    type: i,
    elementSize: s = "s",
    markerType: l,
    markerSpacing: a = 16,
    colorVariant: c = "greyIron.16",
    ...d
  } = he("List", {}, t), { classes: u, cx: f } = M2({ elementSize: s, markerSpacing: a, colorVariant: c });
  return /* @__PURE__ */ g.createElement(
    Wm,
    {
      ...d,
      type: i,
      unstyled: o,
      classNames: {
        ...u,
        ...r,
        item: f(u.item, {
          [u.bulletList]: i === "unordered" && l === "bullet",
          [u.dashList]: i === "unordered" && l === "dash",
          [u.orderedList]: i === "ordered"
        })
      },
      ref: e
    },
    n
  );
});
Lb.displayName = "List";
Lb.Item = Wm.Item;
const $b = (t = 1e3, e = 200, n) => {
  const r = Nt(0), o = Nt(), i = Nt(null), s = cv(n), [l, a] = ie(!n);
  return It(() => {
    if (!l) {
      const c = () => {
        i.current && (r.current = r.current + (1 - r.current) * 0.2, i.current.style.width = r.current * 100 + "%"), o.current = setTimeout(c, t + e * Math.random());
      };
      c();
    }
    return () => {
      clearTimeout(o.current);
    };
  }, [l, t, e]), It(() => {
    i.current && s === !0 && n === !1 && (clearTimeout(o.current), i.current.style.width = "100%", setTimeout(() => {
      a(!0), r.current = 0;
    }, 500)), s === !1 && n === !0 && a(!1);
  }, [n, s]), { element: i, isFinished: l, setIsFinished: a };
}, R2 = O((t) => ({
  appLoaderWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "100%",
    height: "100%",
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    zIndex: Rn("max")
  },
  appLoaderContainer: {
    height: m(56),
    textAlign: "center"
  },
  appLoaderLogoComponent: {
    width: m(196),
    height: m(30)
  },
  appLoaderContainerLine: {
    backgroundColor: t.other.colors.greyIron[3],
    height: m(2),
    width: m(236),
    marginTop: t.other.spacings[24],
    borderRadius: t.other.borderRadius[2]
  },
  appLoaderContainerLineInner: {
    height: m(2),
    backgroundColor: t.other.colors.brand[5],
    borderRadius: t.other.borderRadius[2],
    transition: "width 0.5s",
    width: "20%"
  }
})), O2 = wr(({ id: t, className: e, style: n, logo: r, ...o }) => {
  const { element: i } = $b(1e3, 200, !0), { classes: s, cx: l } = R2();
  return /* @__PURE__ */ g.createElement("div", { className: s.appLoaderWrapper }, /* @__PURE__ */ g.createElement("div", { className: s.appLoaderContainer }, r, /* @__PURE__ */ g.createElement("div", { className: s.appLoaderContainerLine }, /* @__PURE__ */ g.createElement("div", { ref: i, id: t, className: l(s.appLoaderContainerLineInner, e), style: n, ...o }))));
});
O2.displayName = "LoaderApp";
const D2 = O((t, { isFixed: e }) => ({
  loaderWrapper: {
    position: e ? "fixed" : "absolute",
    backgroundColor: "transparent",
    height: m(2),
    width: "100%",
    top: 0,
    left: 0,
    right: 0,
    zIndex: e ? Rn("max") : 2
  },
  loaderLine: {
    height: m(2),
    backgroundColor: t.other.colors.brand[5],
    borderRadius: t.other.borderRadius[2],
    transition: "width 0.5s",
    width: "20%"
  }
})), A2 = ({ className: t, classNames: e, loading: n, isFixed: r, timeoutInterval: o, ...i }) => {
  const { element: s, isFinished: l } = $b(o || 2e3, 500, n), { classes: a, cx: c } = D2({ isFixed: r });
  return l ? null : /* @__PURE__ */ g.createElement(oe, { className: c(a.loaderWrapper, t, e == null ? void 0 : e.loaderWrapper), ...i }, /* @__PURE__ */ g.createElement("div", { ref: s, className: c(a.loaderLine, e == null ? void 0 : e.loaderLine) }));
}, L2 = () => {
  const [t, e] = ie(!1);
  return {
    isSectionWithTopShadow: t,
    onScrollPositionChange: ({ y: r }) => {
      r > 0 && !t && e(!0), r === 0 && t && e(!1);
    }
  };
}, $2 = O((t) => ({
  root: {
    border: "none !important",
    [`&:disabled .${No}`]: {
      color: "currentcolor"
    },
    padding: `${m(8)} ${m(12)}`
  },
  inner: {
    justifyContent: "space-between",
    color: t.other.colors.greyIron[18]
  },
  icon: {
    color: t.other.colors.brand[13]
  }
})), P2 = ({ onLogoutClick: t, logoutButtonText: e }) => {
  const { classes: n } = $2();
  return /* @__PURE__ */ g.createElement(
    ye,
    {
      classNames: n,
      onClick: t,
      elementVariant: Q.TertiaryMain,
      rightSection: /* @__PURE__ */ g.createElement(CC, null),
      "data-testid": "navbar-logout",
      fullWidth: !0
    },
    e
  );
}, _2 = O((t) => ({
  root: {
    border: "none !important",
    padding: `${m(8)} ${m(12)}`,
    borderRadius: 0,
    [`&:disabled .${No}`]: {
      color: "currentcolor"
    }
  },
  inner: {
    justifyContent: "center"
  },
  button: {
    svg: {
      color: t.other.colors.greyIron[12],
      transition: Ae(["transform"]),
      "&[data-rotate]": {
        transform: "rotate(180deg)"
      }
    }
  }
})), B2 = ({ collapsed: t, onCollapseClick: e }) => {
  const { classes: n } = _2();
  return /* @__PURE__ */ g.createElement(
    ye,
    {
      classNames: n,
      className: n.button,
      onClick: e,
      elementVariant: Q.TertiaryMain,
      rightSection: /* @__PURE__ */ g.createElement(vC, { width: 20, height: 20, "data-rotate": t || void 0 }),
      isIconOnly: !0,
      "data-testid": "navbar-collapse",
      fullWidth: !0
    }
  );
}, V2 = ({ linkValue: t, currentPath: e, depthCheck: n = 1 }) => {
  const r = t.split("/"), o = e == null ? void 0 : e.split("/");
  if (t === e)
    return !0;
  if (n === 0)
    return !1;
  let i = 0;
  for (const [s, l] of o.entries()) {
    if (i !== s)
      break;
    l === (r == null ? void 0 : r[s]) && i === s && (i += 1);
  }
  return i > n;
}, F2 = O((t) => ({
  tooltip: {
    padding: t.other.spacings[8],
    marginTop: m(3),
    font: t.other.fonts.desktop.s.xs.default
  },
  dropdownPopup: {
    borderRadius: 8,
    padding: t.other.spacings[8],
    border: `${m(1)} solid ${t.other.colors.greyIron[4]}`,
    boxShadow: `0 ${m(4)} ${m(6)} ${m(-2)} rgba(45, 42, 44, 0.03), 0 ${m(2)} ${m(16)} ${m(-4)} rgba(45, 42, 44, 0.05)`,
    backgroundColor: t.other.colors.white
  },
  activeLink: {
    cursor: "default"
  }
})), cu = ({ link: t, activeLink: e, externalClassName: n, onLinkClick: r, isIconOnly: o }) => {
  var h, p;
  const { classes: i, cx: s } = F2(), [l, a] = ie(!1), c = me(() => {
    var y;
    return !!((y = t.children) != null && y.length);
  }, [t.children]), d = me(
    () => V2({ linkValue: t.value, currentPath: e, depthCheck: t.depthCheck }),
    [e, t.depthCheck, t.value]
  ), u = me(() => c && (e == null ? void 0 : e.startsWith(t.value)), [e, c, t.value]), f = te(
    (y) => {
      if (!(y === "button" || t.external))
        return r == null ? void 0 : r(t.value || "");
    },
    [t.external, t.value, r]
  );
  return It(() => {
    a(u);
  }, [u]), typeof t.shouldRender == "boolean" && !t.shouldRender ? null : o ? /* @__PURE__ */ g.createElement(X, { align: "flex-start" }, /* @__PURE__ */ g.createElement(Vc, { width: 240, position: "bottom-start", classNames: { dropdown: i.dropdownPopup }, withinPortal: !0 }, /* @__PURE__ */ g.createElement(Vc.Target, null, /* @__PURE__ */ g.createElement(oe, null, /* @__PURE__ */ g.createElement(at, { offset: 8, label: t.label, position: "right-start", classNames: { tooltip: i.tooltip }, withinPortal: !0 }, /* @__PURE__ */ g.createElement(
    Mi,
    {
      active: u || d,
      component: t.component,
      className: s({ [i.activeLink]: d }),
      to: c || t.external ? void 0 : t.value,
      href: t.external ? t.value : void 0,
      target: t.external ? "_blank" : void 0,
      rel: t.external ? "noopener noreferrer" : void 0,
      label: t.label,
      leftSection: t.icon,
      disabled: t.disabled,
      onClick: f(t.component),
      isIconOnly: o,
      "data-testid": t.dataTestId
    }
  )))), c ? /* @__PURE__ */ g.createElement(Vc.Dropdown, null, /* @__PURE__ */ g.createElement(Ee, { gap: 2 }, (h = t.children) == null ? void 0 : h.map(
    (y) => typeof t.shouldRender == "boolean" && !y.shouldRender ? null : /* @__PURE__ */ g.createElement(
      cu,
      {
        key: y.label,
        link: y,
        activeLink: e,
        externalClassName: n,
        onLinkClick: r
      }
    )
  ))) : null)) : /* @__PURE__ */ g.createElement(
    Mi,
    {
      active: !c && d,
      component: t.component,
      to: c || t.external ? void 0 : t.value,
      href: t.external ? t.value : void 0,
      target: t.external ? "_blank" : void 0,
      rel: t.external ? "noopener noreferrer" : void 0,
      label: t.label,
      leftSection: t.icon,
      rightSection: t.counter ? /* @__PURE__ */ g.createElement(Px, { value: t.counter }) : void 0,
      rotateRightIcon: !t.counter,
      disabled: t.disabled,
      onClick: f(t.component),
      defaultOpened: u,
      opened: l,
      onChange: a,
      "data-testid": t.dataTestId,
      className: s({ [i.activeLink]: d })
    },
    c ? /* @__PURE__ */ g.createElement(Ee, { className: n }, (p = t.children) == null ? void 0 : p.map(
      (y) => typeof t.shouldRender == "boolean" && !y.shouldRender ? null : /* @__PURE__ */ g.createElement(
        cu,
        {
          key: y.label,
          link: y,
          activeLink: e,
          externalClassName: n,
          onLinkClick: r
        }
      )
    )) : null
  );
}, N2 = (t) => {
  switch (t) {
    case "skype":
      return /* @__PURE__ */ g.createElement(Pt, { src: Kn("Skype"), width: 24, height: 24 });
    case "telegram":
      return /* @__PURE__ */ g.createElement(Pt, { src: Kn("Telegram"), width: 20, height: 20 });
    case "facebook":
      return /* @__PURE__ */ g.createElement(Pt, { src: Kn("FB"), width: 20, height: 20 });
    case "whatsapp":
      return /* @__PURE__ */ g.createElement(Pt, { src: Kn("WA"), width: 20, height: 20 });
    case "qq":
      return /* @__PURE__ */ g.createElement(Pt, { src: Kn("QQ"), width: 20, height: 20 });
    case "viber":
      return /* @__PURE__ */ g.createElement(Pt, { src: Kn("Viber"), width: 20, height: 20 });
    case "wechat":
      return /* @__PURE__ */ g.createElement(Pt, { src: Kn("Wechat"), width: 20, height: 20 });
    case "weibo":
      return /* @__PURE__ */ g.createElement(Pt, { src: Kn("Weibo"), width: 20, height: 20 });
    case "email":
      return /* @__PURE__ */ g.createElement(Pt, { src: Kn("Gmail"), width: 20, height: 15 });
    case "msteams":
      return /* @__PURE__ */ g.createElement(Pt, { src: Kn("MSTeams"), width: 20, height: 15 });
    case "line":
      return /* @__PURE__ */ g.createElement(Pt, { src: Kn("Line"), width: 20, height: 15 });
    default:
      return null;
  }
}, z2 = O(() => ({
  contactWrapper: {
    ":hover": {
      [`& .${of}`]: {
        visibility: "visible",
        opacity: 1
      }
    }
  },
  text: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    maxWidth: m(118)
  },
  textCapitalize: {
    textTransform: "capitalize"
  },
  avatar: {
    minWidth: m(36),
    width: m(36),
    height: m(36)
  },
  copyButton: {
    visibility: "hidden",
    opacity: 0,
    transition: Ae(["opacity"]),
    [`${Ge.md}`]: {
      visibility: "visible",
      opacity: 1
    }
  }
})), H2 = ({ contactName: t, contactType: e, copyTooltipText: n, ...r }) => {
  const { classes: o, cx: i } = z2(), s = N2(e);
  return /* @__PURE__ */ g.createElement(X, { className: o.contactWrapper, gap: 8, align: "flex-start", ...r }, /* @__PURE__ */ g.createElement(Jo, { className: o.avatar }, s), /* @__PURE__ */ g.createElement(Ee, { gap: 0 }, /* @__PURE__ */ g.createElement(xe, { elementSize: "s", elementVariant: "buttons", colorVariant: "greyIron.18", className: o.text }, t), /* @__PURE__ */ g.createElement(xe, { elementSize: "s", elementVariant: "default", colorVariant: "greyIron.12", className: i(o.text, o.textCapitalize) }, e)), /* @__PURE__ */ g.createElement(oe, { className: i(o.copyButton, of), component: "div", ml: "auto" }, /* @__PURE__ */ g.createElement(Lx, { value: t, textButtonCopied: n })));
}, j2 = O((t) => ({
  navLink: {
    transition: Ae(["background-color", "outline-color", "color", "border-top-left-radius", "border-top-right-radius"])
  },
  label: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  navLinkIsOpened: {
    backgroundColor: t.other.colors.greyIron[2],
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0
  },
  dropdown: {
    boxSizing: "border-box",
    backgroundColor: t.other.colors.greyIron[2],
    border: "none",
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    boxShadow: "none",
    padding: m(12),
    paddingBottom: m(16)
  },
  divider: {
    marginTop: m(20),
    marginBottom: m(-4)
  },
  rightSection: {
    transition: Ae(["transform"])
  },
  rightSectionOpened: {
    transform: "rotate(180deg)"
  },
  dateVacation: {
    paddingRight: m(2)
  }
})), W2 = ({ manager: t }) => {
  const { classes: e, cx: n } = j2(), [r, o] = ie(!1), i = me(() => t.vacation ? /* @__PURE__ */ g.createElement(xe, { elementSize: "xs", elementVariant: "header" }, t.vacation) : t.work ? /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(xe, { elementSize: "s", elementVariant: "default", colorVariant: "greyIron.12" }, t.work.hours), /* @__PURE__ */ g.createElement(xe, { elementSize: "s", elementVariant: "default", colorVariant: "greyIron.12" }, t.work.days)) : null, [t.vacation, t.work]), s = () => t.contacts.length === 0 || !t.contacts ? null : t.contacts.map((l) => /* @__PURE__ */ g.createElement(
    H2,
    {
      key: l.type,
      contactName: l.value,
      contactType: l.type,
      copyTooltipText: t.labels.copyTooltipText,
      "data-testid": `manager-contact-${l.type}`
    }
  ));
  return /* @__PURE__ */ g.createElement(
    Hn,
    {
      width: "target",
      position: "top",
      offset: 0,
      withinPortal: !1,
      transitionProps: {
        transition: "fade",
        duration: 300
      },
      opened: r,
      onChange: o
    },
    /* @__PURE__ */ g.createElement(Hn.Target, null, /* @__PURE__ */ g.createElement("div", null, /* @__PURE__ */ g.createElement(
      Mi,
      {
        component: "button",
        onClick: () => o(!r),
        classNames: {
          root: n(e.navLink, { [e.navLinkIsOpened]: r }),
          label: e.label
        },
        leftSection: /* @__PURE__ */ g.createElement(
          Jo,
          {
            src: t.photo,
            elementVariant: t.avatarVariant,
            alt: `${t.firstName} ${t.lastName}`,
            "data-testid": "avatar-manager"
          }
        ),
        leftSectionSize: 40,
        leftSectionOffset: 12,
        label: `${t == null ? void 0 : t.firstName} ${(t == null ? void 0 : t.lastName).slice(0, 1)}.`,
        rightSection: /* @__PURE__ */ g.createElement(Sr, { className: n(e.rightSection, { [e.rightSectionOpened]: r }) }),
        description: i,
        "data-testid": "navbar-manager"
      }
    ))),
    /* @__PURE__ */ g.createElement(Hn.Dropdown, { className: e.dropdown }, /* @__PURE__ */ g.createElement(xe, { elementSize: "s", elementVariant: "default", colorVariant: "greyIron.12" }, t.labels.contactsSectionLabel), /* @__PURE__ */ g.createElement(Ee, { mt: 16, gap: 12 }, s()), t.supportTicketHref && /* @__PURE__ */ g.createElement(
      ki,
      {
        fullWidth: !0,
        elementVariant: Q.PrimaryMain,
        href: t.supportTicketHref,
        target: "_blank",
        rel: "noreferrer noopener",
        mt: 20,
        "data-testid": "manager-sendMessage"
      },
      t.labels.sendMessageLabel
    ), /* @__PURE__ */ g.createElement(il, { className: e.divider }))
  );
}, G2 = O((t, { isMobileResolution: e }) => ({
  navbar: {},
  container: {
    padding: `0 ${t.other.spacings[16]}`,
    paddingRight: 0,
    borderRight: `${m(1)} solid ${t.other.colors.greyIron[4]}`,
    boxSizing: "border-box",
    zIndex: Rn("app"),
    overflow: e ? "auto" : "hidden",
    transition: Ae(["width"])
  },
  navLinkLogo: {
    backgroundColor: "transparent !important",
    minHeight: 0,
    padding: 0,
    paddingLeft: t.other.spacings[8],
    outlineOffset: `${m(4)} !important`
  },
  bottomSectionTopShadowOnScroll: {
    position: "relative",
    "&::after": {
      content: '""',
      background: "linear-gradient(180deg, rgba(78, 74, 81, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)",
      height: m(40),
      top: m(-40),
      right: m(-16),
      left: m(-16),
      bottom: 0,
      position: "absolute",
      transform: "rotate(180deg)",
      pointerEvents: "none",
      zIndex: Rn("app")
    }
  },
  linksContainer: {
    gap: t.other.spacings[4],
    marginBottom: m(4)
  },
  collapseButtonContainer: {
    borderTop: `${m(1)} solid ${t.other.colors.greyIron[3]}`,
    marginLeft: m(-16),
    marginBottom: m(-16)
  },
  collapseSectionTopShadowOnScroll: {
    position: "relative",
    "&::after": {
      content: '""',
      background: "linear-gradient(180deg, rgba(78, 74, 81, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)",
      width: m(272),
      height: m(40),
      top: m(-40),
      right: 0,
      bottom: 0,
      position: "absolute",
      transform: "rotate(180deg)",
      pointerEvents: "none"
    }
  }
})), U2 = (t) => {
  const {
    activeLink: e,
    links: n,
    logout: r,
    managerInfo: o,
    onLinkClick: i,
    withCollapse: s = !1,
    collapsed: l = !1,
    handleCollapse: a,
    className: c,
    classNames: d,
    handleLinkClickWithLayout: u,
    ...f
  } = t, { isSectionWithTopShadow: h, onScrollPositionChange: p } = L2(), [y, b] = ie(l), w = mr(Ge.maxDeviceWidthValue("md")), { classes: S, cx: x } = G2({ isMobileResolution: w }), E = (T = "") => (I) => {
    I.preventDefault(), T !== e && (i(T), u == null || u());
  }, v = () => {
    a == null || a(!y), b(!y);
  };
  return It(() => {
    b(l);
  }, [l]), /* @__PURE__ */ g.createElement(co.Navbar, { className: x(S.container, d == null ? void 0 : d.container, c), ...f }, /* @__PURE__ */ g.createElement(
    co.Section,
    {
      flex: 1,
      mt: 0,
      grow: !w,
      component: w ? void 0 : Fr,
      onScrollPositionChange: w ? void 0 : p,
      pr: 16,
      pt: 16,
      mb: w ? 16 : 0
    },
    /* @__PURE__ */ g.createElement(Ee, { className: x(S.linksContainer, d == null ? void 0 : d.linksContainer) }, n.map((T) => /* @__PURE__ */ g.createElement(
      cu,
      {
        key: T.label,
        link: T,
        activeLink: e,
        externalClassName: x(S.linksContainer, d == null ? void 0 : d.linksContainer),
        onLinkClick: E,
        isIconOnly: y
      }
    )))
  ), /* @__PURE__ */ g.createElement(co.Section, { pb: 16 }, /* @__PURE__ */ g.createElement(Ee, { gap: 16, mr: 16, className: x({ [S.bottomSectionTopShadowOnScroll]: h && !w }) }, o && /* @__PURE__ */ g.createElement(W2, { manager: o }), r && /* @__PURE__ */ g.createElement(P2, { onLogoutClick: r.onLogoutClick, logoutButtonText: r.logoutButtonText })), s && /* @__PURE__ */ g.createElement(
    oe,
    {
      className: x(S.collapseButtonContainer, d == null ? void 0 : d.collapseButtonContainer, {
        [S.collapseSectionTopShadowOnScroll]: h
      })
    },
    /* @__PURE__ */ g.createElement(B2, { collapsed: y, onCollapseClick: v })
  )));
}, q2 = 72, Pb = 56, J2 = O(() => ({
  main: {
    "p, span, li": {
      "& > a": {
        fontSize: "inherit !important"
      }
    }
  }
})), _b = qo({ headerHeight: Pb, isNavbarOpen: !1 }), pz = () => Pi(_b), K2 = ({ children: t, ...e }) => /* @__PURE__ */ g.createElement(_b.Provider, { value: e }, t), Y2 = O((t, e, n) => ({
  header: {
    padding: `${t.other.spacings[16]} ${t.other.spacings[16]}`,
    borderBottom: `1px solid ${t.other.colors.greyIron[4]}`,
    display: "flex",
    alignItems: "center",
    [n.largerThan("sm")]: {
      padding: `${t.other.spacings[16]} ${t.other.spacings[24]}`
    }
  },
  logoRoot: {
    backgroundColor: "transparent !important",
    minHeight: 0,
    height: m(16),
    padding: 0,
    outlineOffset: `${m(4)} !important`,
    [n.largerThan("sm")]: {
      height: m(24)
    }
  },
  label: {
    display: "flex",
    alignItems: "center"
  },
  menuButton: {
    padding: 0,
    [n.largerThan("sm")]: {
      padding: m(6)
    }
  }
})), _p = { width: m(24), height: m(24) }, Z2 = ({
  children: t,
  defaultLocation: e = "/",
  logo: n = sv("LogoLightBrandEmblemWord"),
  onLogoClick: r,
  logoWrapperComponent: o = "button",
  isMenuOpen: i,
  onMenuButtonClick: s,
  ...l
}) => {
  const { classes: a } = Y2();
  return /* @__PURE__ */ g.createElement(co.Header, { className: a.header, zIndex: Rn("app"), ...l }, /* @__PURE__ */ g.createElement(X, { w: "100%" }, /* @__PURE__ */ g.createElement(gr, { direction: "row", align: "center", gap: { base: 16, xs: 16, sm: 24 } }, /* @__PURE__ */ g.createElement(co.Section, { hiddenFrom: "lg" }, /* @__PURE__ */ g.createElement(
    ye,
    {
      elementVariant: Q.PrimaryMainLine,
      elementSize: Ue.M,
      className: a.menuButton,
      onClick: s,
      "data-testid": "navbar-menu-button",
      isIconOnly: !0,
      leftSection: i ? /* @__PURE__ */ g.createElement(cc, { "data-testid": "navbar-menu-button-close", style: _p }) : /* @__PURE__ */ g.createElement(xC, { "data-testid": "navbar-menu-button-open", style: _p })
    }
  )), /* @__PURE__ */ g.createElement(co.Section, { mr: { base: 8, xs: 8, sm: 16 } }, /* @__PURE__ */ g.createElement(
    Mi,
    {
      classNames: { root: a.logoRoot, label: a.label },
      component: o,
      label: typeof n == "string" ? /* @__PURE__ */ g.createElement(oe, { component: "img", src: n, height: "auto", w: { base: 112, xs: 112, sm: 144 }, alt: "Logo" }) : n,
      to: e,
      onClick: r,
      "data-testid": "navbar-logo"
    }
  ))), /* @__PURE__ */ g.createElement(oe, { flex: 1 }, t)));
}, gz = ({
  children: t,
  localStorageNavMenuKey: e = "affstore-collapsed-menu",
  headerProps: { content: n, onLogoClick: r, logo: o, defaultLocation: i, logoWrapperComponent: s, ...l },
  navbarProps: a,
  outerContent: c,
  navbar: d = {},
  header: u = {},
  ...f
}) => {
  const [h, p] = ey({
    key: e,
    defaultValue: !1
  }), { classes: y } = J2(), b = mr(Ge.greaterThen("lg", !1)), w = mr(Ge.greaterThen("sm", !1)), S = b ? !1 : !h, x = te(() => {
    p((M) => !M);
  }, [p]), E = !1, v = w ? q2 : Pb, T = !(w ? S : !h);
  It(() => {
    document.body.style.overflow = T && !w ? "hidden" : "auto";
  }, [T, w]);
  const I = te(() => {
    w || p(!1);
  }, [p, w]);
  return /* @__PURE__ */ g.createElement(
    co,
    {
      header: { height: v, ...u },
      navbar: { width: { base: m(294) }, breakpoint: "sm", collapsed: { desktop: S, mobile: !h }, ...d },
      zIndex: Rn("app"),
      classNames: {
        main: y.main
      },
      ...f
    },
    /* @__PURE__ */ g.createElement(K2, { headerHeight: v, isNavbarOpen: T }, /* @__PURE__ */ g.createElement(
      Z2,
      {
        isMenuOpen: h,
        onMenuButtonClick: x,
        onLogoClick: r,
        logo: o,
        defaultLocation: i,
        logoWrapperComponent: s,
        ...l
      },
      n || null
    ), /* @__PURE__ */ g.createElement(co.Main, null, t), /* @__PURE__ */ g.createElement(U2, { ...a, withCollapse: E, handleLinkClickWithLayout: I }), c)
  );
}, X2 = ({ Icon: t, colorName: e }) => /* @__PURE__ */ g.createElement(Lo, { Icon: t || Km, colorName: e || "raspberry", elementVariant: "Bright" }), du = 24, uu = 16, Bp = 1, Q2 = O((t) => ({
  headerWrapper: {
    backgroundColor: t.other.colors.white[0]
  },
  headerContent: {
    "&&": {
      flexGrow: 1,
      font: t.other.fonts.desktop.s.s.default,
      color: t.other.colors.greyIron[10],
      textAlign: "center"
    }
  },
  closeIcon: {
    color: t.other.colors.brand[13]
  }
})), eA = ({
  elementVariant: t,
  Icon: e,
  iconStyleElementVariant: n,
  iconColorName: r,
  headerContent: o,
  onClose: i,
  withCloseButton: s = !0,
  "data-testid": l
}) => {
  const { classes: a } = Q2(), c = () => {
    switch (t) {
      case "success":
        return /* @__PURE__ */ g.createElement(xx, { Icon: e });
      case "warning":
        return /* @__PURE__ */ g.createElement(Ex, { Icon: e });
      case "error":
        return /* @__PURE__ */ g.createElement(X2, { Icon: e });
      default:
        return e ? /* @__PURE__ */ g.createElement(Lo, { Icon: e, elementVariant: n, colorName: r }) : null;
    }
  };
  return /* @__PURE__ */ g.createElement(
    X,
    {
      justify: "space-between",
      className: a.headerWrapper,
      pb: 8,
      pt: { base: uu + Bp, md: du + Bp },
      mb: -8
    },
    c(),
    o && /* @__PURE__ */ g.createElement("div", { className: a.headerContent }, o),
    s && /* @__PURE__ */ g.createElement("div", { className: a.closeIcon }, /* @__PURE__ */ g.createElement(
      ye,
      {
        classNames: {
          section: a.closeIcon
        },
        elementSize: Ue.M,
        elementVariant: Q.TertiaryMain,
        isIconOnly: !0,
        isRound: !0,
        leftSection: /* @__PURE__ */ g.createElement(cc, null),
        onClick: i,
        "data-testid": l
      }
    ))
  );
}, tA = O((t, { hideHeader: e, zIndex: n }) => ({
  /** Mantine modal */
  root: {},
  close: {},
  inner: {
    zIndex: n || Rn("modal"),
    left: 0
  },
  content: {
    border: `${m(1)} solid`,
    backgroundColor: t.other.colors.white[0],
    borderColor: t.other.colors.greyIron[4],
    boxShadow: t.other.shadows.s,
    borderRadius: t.other.borderRadius[12],
    "&&": {
      padding: m(uu),
      /** fix visible content on the top of the header if scrolling */
      paddingTop: e ? m(uu) : 0,
      [Ge.greaterThen("md")]: {
        padding: m(du),
        /** fix visible content on the top of the header if scrolling */
        paddingTop: e ? m(du) : 0
      }
    }
  },
  header: {
    margin: 0,
    padding: 0,
    minHeight: "fit-content"
  },
  overlay: {
    backgroundColor: t.other.colors.greyIron[16],
    opacity: "0.8 !important",
    zIndex: n || Rn("modal")
  },
  title: {
    width: "100%",
    margin: 0
  },
  body: {
    padding: 0
  },
  /** Internal modal */
  children: {
    font: t.other.fonts.desktop.s.s.default
  },
  footer: {
    font: t.other.fonts.desktop.s.s.default
  },
  contentColumns: {
    display: "flex",
    alignItems: "stretch",
    gap: t.other.spacings[24],
    flexWrap: "nowrap"
  },
  content1: {
    flex: 1,
    "&": {
      marginTop: e ? 0 : void 0
    }
  },
  contentTitle: {
    color: t.other.colors.greyIron[18]
  },
  contentDescription: {},
  center: {
    textAlign: "center"
  }
})), wc = (t) => {
  const {
    elementVariant: e,
    Icon: n,
    iconStyleElementVariant: r,
    iconColorName: o,
    classNames: i,
    unstyled: s,
    children: l,
    leftColumnContent: a,
    headerContent: c,
    centeredContent: d,
    title: u,
    titleSize: f = "l",
    description: h,
    buttonOpenProps: p,
    onClose: y,
    dataTestId: b,
    opened: w,
    hideOpenButton: S = !1,
    hideHeader: x = !1,
    withCloseButton: E = !0,
    zIndex: v,
    className: T,
    style: I,
    transitionProps: M,
    ...R
  } = t, [A, F] = an({
    value: w,
    defaultValue: !1
  }), { classes: V, cx: P } = tA({ hideHeader: x, zIndex: v }), J = te(
    (U) => {
      var re;
      U.preventDefault(), U.stopPropagation(), (re = p == null ? void 0 : p.onClick) == null || re.call(p, U), F(!0);
    },
    [p, F]
  ), ne = te(() => {
    y == null || y(), F(!1);
  }, [y, F]), { tooltip: G, tooltipWidth: H, ...W } = p || {}, se = /* @__PURE__ */ g.createElement(
    eA,
    {
      headerContent: c,
      elementVariant: e,
      Icon: n,
      iconStyleElementVariant: r,
      iconColorName: o,
      onClose: ne,
      "data-testid": b == null ? void 0 : b.closeButtonModal,
      withCloseButton: E
    }
  );
  return /* @__PURE__ */ g.createElement(g.Fragment, null, S ? null : /* @__PURE__ */ g.createElement(at, { label: G, w: H }, /* @__PURE__ */ g.createElement(ye, { "data-testid": "open-modal", ...W, onClick: J }, W.isIconOnly ? null : (p == null ? void 0 : p.children) || "Open modal")), /* @__PURE__ */ g.createElement(
    ef,
    {
      withCloseButton: !1,
      style: I,
      className: T,
      unstyled: s,
      classNames: {
        body: P(V.body, i == null ? void 0 : i.body),
        header: P(V.header, i == null ? void 0 : i.header),
        title: P(V.title, i == null ? void 0 : i.title),
        overlay: P(V.overlay, i == null ? void 0 : i.overlay),
        root: P(V.root, i == null ? void 0 : i.root),
        content: P(V.content, i == null ? void 0 : i.content),
        close: P(V.close, i == null ? void 0 : i.close),
        inner: P(V.inner, i == null ? void 0 : i.inner)
      },
      title: x || a ? null : se,
      opened: A,
      onClose: ne,
      zIndex: v,
      transitionProps: {
        duration: 200,
        transition: "pop",
        ...M
      },
      ...R
    },
    /* @__PURE__ */ g.createElement("div", { className: P(V.contentColumns, i == null ? void 0 : i.contentColumns) }, a, /* @__PURE__ */ g.createElement(Ee, { className: V.content1, gap: 8, mt: !a && (u || h) ? 16 : 0 }, a && !x ? se : null, u && /* @__PURE__ */ g.createElement(
      Ti,
      {
        className: P(V.contentTitle, i == null ? void 0 : i.contentTitle, { [P(V.center, i == null ? void 0 : i.center)]: d }),
        elementSize: f,
        order: 2
      },
      u
    ), h && /* @__PURE__ */ g.createElement(
      xe,
      {
        className: P(V.contentDescription, i == null ? void 0 : i.contentDescription),
        elementSize: "s",
        elementVariant: "default",
        colorVariant: "greyIron.16",
        align: d ? "center" : void 0
      },
      h
    ), l && /* @__PURE__ */ g.createElement(
      Ee,
      {
        className: P(V.children, i == null ? void 0 : i.children),
        align: d ? "center" : void 0,
        mt: u || h ? 16 : void 0
      },
      l
    )))
  ));
};
wc.displayName = "Modal";
const nA = O((t, { hasChildren: e }) => ({
  buttonGroup: {
    marginTop: e ? m(8) : 0,
    gap: m(12)
  }
})), rA = ({
  opened: t,
  hideOpenButton: e = !1,
  buttonCancelProperties: n,
  buttonAcceptProperties: r,
  onCancel: o,
  onAccept: i,
  buttonOpenProps: s,
  hideCancelButton: l,
  children: a,
  ...c
}) => {
  const [d, u] = an({
    value: t,
    defaultValue: !1
  }), { classes: f } = nA({ hasChildren: !!a }), h = te(async () => {
    await (i == null ? void 0 : i()), u(!1);
  }, [i, u]), p = te(
    (b) => {
      var w;
      (w = s == null ? void 0 : s.onClick) == null || w.call(s, b), u(!0);
    },
    [s, u]
  ), y = te(() => {
    o == null || o(), u(!1);
  }, [o, u]);
  return /* @__PURE__ */ g.createElement(
    wc,
    {
      buttonOpenProps: {
        ...s,
        onClick: p
      },
      hideOpenButton: e,
      onClose: y,
      opened: d,
      ...c
    },
    a,
    /* @__PURE__ */ g.createElement(gr, { direction: { base: "column", md: "row" }, justify: "space-between", w: "100%", className: f.buttonGroup }, !l && /* @__PURE__ */ g.createElement(
      ye,
      {
        onClick: y,
        elementVariant: Q.TertiaryMain,
        elementSize: Ue.M,
        fullWidth: !0,
        "data-testid": "modal-button-cancel",
        ...n
      },
      (n == null ? void 0 : n.children) || "Cancel"
    ), /* @__PURE__ */ g.createElement(
      ye,
      {
        onClick: h,
        elementVariant: Q.PrimaryMain,
        elementSize: Ue.M,
        fullWidth: !0,
        "data-testid": "modal-button-accept",
        ...r
      },
      (r == null ? void 0 : r.children) || "Accept"
    ))
  );
}, Qi = {
  next: "next",
  prev: "prev"
}, es = ",", oA = O((t, { hasChildren: e }) => ({
  buttonGroup: {
    marginTop: e ? m(8) : 0,
    gap: m(12)
  }
})), iA = ({
  steps: t,
  firstStep: e,
  stepsProperties: n,
  stepsHandlers: r,
  stepsContent: o,
  stepsFooterContent: i,
  onCancel: s,
  onFinish: l,
  buttonCancelProperties: a,
  buttonPreviousProperties: c,
  buttonFinishProperties: d,
  buttonNextProperties: u,
  buttonOpenProps: f,
  hideOpenButton: h,
  iconStyleElementVariant: p,
  iconColorName: y,
  stepsProgressText: b,
  clearError: w,
  elementVariant: S,
  ...x
}) => {
  var Ce, et, Oe, $e, Ie;
  const { classes: E } = oA({ hasChildren: !0 }), [v, T] = ie(e), [I, M] = ie(!1), R = me(() => o(T), [o]), A = me(() => i == null ? void 0 : i(T), [i]), F = /* @__PURE__ */ new Map();
  for (const [ee, de] of Object.keys(r).entries())
    F.set(de, ee + 1);
  const V = F.size, P = te(
    (ee) => {
      var de;
      (de = f == null ? void 0 : f.onClick) == null || de.call(f, ee), T(e), M(!0);
    },
    [f, e, T]
  ), J = me(() => {
    var ee, de;
    return e === v ? (a == null ? void 0 : a.children) || "Cancel" : (c == null ? void 0 : c.children) || ((de = (ee = n[v]) == null ? void 0 : ee.buttonPreviousProperties) == null ? void 0 : de.children) || "Previous";
  }, [v, a == null ? void 0 : a.children, c == null ? void 0 : c.children, e, n]), ne = me(() => {
    var ee, de;
    return t.get(`${v}${es}${Qi.next}`) === null ? (d == null ? void 0 : d.children) || "Done" : (u == null ? void 0 : u.children) || ((de = (ee = n[v]) == null ? void 0 : ee.buttonNextProperties) == null ? void 0 : de.children) || "Next";
  }, [v, d == null ? void 0 : d.children, u == null ? void 0 : u.children, t, n]), G = me(
    () => e === v ? a : c,
    [v, a, c, e]
  ), H = me(
    () => t.get(`${v}${es}${Qi.next}`) === null ? d : u,
    [v, d, u, t]
  ), W = te(() => {
    s == null || s(), T(e), M(!1);
  }, [e, s]), se = te(() => {
    var de, ae;
    (ae = (de = r[v]) == null ? void 0 : de.onPrevious) == null || ae.call(de);
    const ee = t.get(`${v}${es}${Qi.prev}`);
    T(ee || v || e), w == null || w();
  }, [r, v, t, e, w]), U = te(() => {
    var ee;
    if (e === v || (ee = n[v]) != null && ee.shouldCloseOnPrevious) {
      W();
      return;
    }
    se();
  }, [v, e, se, W, n]), re = te(async () => {
    await (l == null ? void 0 : l()), T(e), M(!1);
  }, [e, l]), ke = te(async () => {
    var de, ae, Y;
    const ee = t.get(`${v}${es}${Qi.next}`);
    (de = r[v]) != null && de.onNext ? await ((Y = (ae = r[v]) == null ? void 0 : ae.onNext) == null ? void 0 : Y.call(ae, () => {
      T(ee || v || e), w == null || w();
    })) : (T(ee || v || e), w == null || w());
  }, [v, w, e, t, r]), Te = te(async () => {
    if (t.get(`${v}${es}${Qi.next}`) === null) {
      await re();
      return;
    }
    await ke();
  }, [v, ke, re, t]), Se = () => {
    var ee, de;
    return (ee = n[v]) != null && ee.withStepsProgress ? /* @__PURE__ */ g.createElement(qS, { style: { flexGrow: 1 } }, b == null ? void 0 : b.replace("%current", (de = F.get(v)) == null ? void 0 : de.toString()).replace("%total", V == null ? void 0 : V.toString())) : null;
  }, Le = () => {
    var de, ae, Y, we, Ze;
    if (!((de = n[v]) != null && de.withButtonPreviousInHeader || (ae = n[v]) != null && ae.withStepsProgress))
      return null;
    const ee = (Y = n[v]) != null && Y.Icon ? void 0 : /* @__PURE__ */ g.createElement("div", { style: { width: m(40), height: m(40) } });
    return /* @__PURE__ */ g.createElement(X, null, (we = n[v]) != null && we.withButtonPreviousInHeader ? /* @__PURE__ */ g.createElement(
      ye,
      {
        elementSize: Ue.M,
        elementVariant: Q.TertiaryMain,
        isIconOnly: !0,
        isRound: !0,
        leftSection: /* @__PURE__ */ g.createElement(xi, null),
        onClick: U,
        "data-testid": "multistep-modal-header-button-prev"
      }
    ) : ee, (Ze = n[v]) != null && Ze.withStepsProgress ? /* @__PURE__ */ g.createElement(Se, null) : null);
  };
  return /* @__PURE__ */ g.createElement(
    wc,
    {
      headerContent: /* @__PURE__ */ g.createElement(Le, null),
      title: (Ce = n[v]) == null ? void 0 : Ce.title,
      description: (et = n[v]) == null ? void 0 : et.description,
      hideOpenButton: h,
      buttonOpenProps: {
        ...f,
        onClick: P
      },
      onClose: W,
      opened: I,
      Icon: (Oe = n[v]) == null ? void 0 : Oe.Icon,
      iconStyleElementVariant: p,
      iconColorName: y,
      elementVariant: ($e = n[v]) != null && $e.withButtonPreviousInHeader ? "default" : S,
      ...x
    },
    R[v],
    /* @__PURE__ */ g.createElement(gr, { direction: { base: "column", md: "row" }, justify: "space-between", w: "100%", className: E.buttonGroup }, !((Ie = n[v]) != null && Ie.hidePreviousButton) && /* @__PURE__ */ g.createElement(
      ye,
      {
        onClick: U,
        elementVariant: Q.TertiaryMain,
        elementSize: Ue.M,
        fullWidth: !0,
        "data-testid": "multistep-modal-button-prev",
        ...G
      },
      J
    ), /* @__PURE__ */ g.createElement(
      ye,
      {
        onClick: Te,
        elementVariant: Q.PrimaryMain,
        elementSize: Ue.M,
        fullWidth: !0,
        "data-testid": "multistep-modal-button-next",
        ...H
      },
      ne
    )),
    A && A[v]
  );
}, Df = wc;
Df.Confirm = rA;
Df.ConfirmMultiStep = iA;
const sA = O((t, e) => ({
  root: {
    whiteSpace: "nowrap",
    "&::before": {
      display: "inline",
      content: `"${e.isNegative ? "-" : e.positiveSign}${e.currency}"`
    }
  },
  thousandWrapper: {},
  thousand: {
    "&:not(:last-of-type)": {
      paddingRight: `${e.spacing}em`
    }
  },
  frac: {}
})), lA = {
  elementSettings: { elementVariant: "default", elementSize: "m" },
  colorVariant: "greyIron.18",
  value: 0,
  zeroFraction: !1,
  withFraction: !0,
  spacing: 0.25,
  currency: "$",
  positiveSign: ""
}, aA = (t) => {
  const {
    elementSettings: e,
    colorVariant: n,
    value: r,
    zeroFraction: o,
    withFraction: i,
    spacing: s,
    currency: l,
    positiveSign: a,
    classNames: c,
    className: d,
    styles: u,
    unstyled: f,
    ...h
  } = he("CustomComponent", lA, t), [p, y] = mv(r, {
    currency: "",
    zeroFraction: o,
    withNegative: !1
  }).split("."), b = Number.isNaN(Number(r)), w = r < 0, { classes: S, cx: x } = sA({
    value: r,
    zeroFraction: o,
    spacing: s || 0,
    currency: l,
    positiveSign: a,
    isNegative: w
  });
  return b ? /* @__PURE__ */ g.createElement(g.Fragment, null, r) : /* @__PURE__ */ g.createElement(
    xe,
    {
      elementVariant: e == null ? void 0 : e.elementVariant,
      elementSize: e == null ? void 0 : e.elementSize,
      colorVariant: n,
      className: x(S.root, d),
      classNames: c,
      styles: u,
      unstyled: f,
      ...h
    },
    /* @__PURE__ */ g.createElement("span", { className: x(S.thousandWrapper, c == null ? void 0 : c.thousandWrapper) }, p.split(" ").map((E, v) => /* @__PURE__ */ g.createElement("span", { className: x(S.thousand, c == null ? void 0 : c.thousand), key: v }, E))),
    i ? /* @__PURE__ */ g.createElement("span", { className: x(S.frac, c == null ? void 0 : c.frac) }, y ? `.${y}` : "") : null
  );
};
aA.displayName = "Money";
var ya = /* @__PURE__ */ ((t) => (t.default = "default", t.tooltip = "tooltip", t))(ya || {});
const cA = (t) => {
  if (!t)
    return [];
  const e = /[\n,;]/, n = t.split(e).map((r) => r.trim().toLowerCase()).filter((r) => r !== "");
  return [...new Set(n)];
}, dA = ({
  data: t = [],
  value: e,
  defaultValue: n = [],
  searchValue: r,
  defaultSearchValue: o,
  initiallyOpened: i = !1,
  onChange: s,
  onDropdownOpen: l,
  onDropdownClose: a,
  onSearchChange: c,
  onUnmatchedDataChange: d,
  withInputValues: u
}) => {
  const [f, h] = ie(i), [p, y] = an({
    value: e,
    defaultValue: n,
    finalValue: [],
    onChange: s
  }), [b, w] = an({
    value: r,
    defaultValue: o,
    finalValue: "",
    onChange: c
  }), S = Hm({
    onDropdownClose: () => {
      h(!1), S.resetSelectedOption(), w("");
    },
    onDropdownOpen: () => {
      h(!0), S.focusSearchInput(), S.updateSelectedOptionIndex("active");
    }
  }), [x, E] = ie([]), v = te(
    (G) => {
      const H = p.includes(G) ? p.filter((W) => W !== G) : [...p, G];
      y(H);
    },
    [p, y]
  ), T = te(
    (G) => {
      const H = p.filter((W) => W !== G);
      y(H);
    },
    [p, y]
  ), I = te(() => {
    S.openDropdown(), l == null || l();
  }, [S, l]), M = te(() => {
    S.closeDropdown(), a == null || a();
  }, [S, a]), R = te(() => {
    const G = t.filter((H) => !H.disabled || H.disabled && p.includes(H.value)).map((H) => H.value);
    y(G);
  }, [t, p, y]), A = te(() => {
    const G = t.filter((H) => H.disabled && p.includes(H.value)).map((H) => H.value);
    y(G), w("");
  }, [t, p, w, y]), F = te(() => {
    A();
  }, [A]), V = (G) => {
    S.updateSelectedOptionIndex(), w(G.currentTarget.value);
  }, P = te(
    (G) => {
      var Te;
      G.preventDefault();
      const H = (Te = G == null ? void 0 : G.clipboardData) == null ? void 0 : Te.getData("text"), W = cA(H), se = t.filter(
        (Se) => {
          var Le;
          return !Se.disabled && (W.includes(Se.value.toLowerCase()) || W.includes((Le = Se.label) == null ? void 0 : Le.toLowerCase()));
        }
      ), U = se.map((Se) => Se.value), re = W.filter(
        (Se) => !se.some((Le) => {
          var Ce;
          return Le.value.toLowerCase() === Se || ((Ce = Le.label) == null ? void 0 : Ce.toLowerCase()) === Se;
        })
      );
      E([.../* @__PURE__ */ new Set([...x, ...re])]);
      const ke = [.../* @__PURE__ */ new Set([...p, ...U, ...re])];
      y(ke);
    },
    [t, x, p, y]
  ), J = me(
    () => x.filter((G) => p.includes(G)),
    [p, x]
  ), ne = me(
    () => [
      ...t,
      ...J.map((G) => ({
        value: G,
        label: G
      }))
    ],
    [t, J]
  );
  return It(() => {
    d == null || d(J);
  }, [d, J]), {
    combobox: S,
    selectedValues: p,
    search: b,
    dropdownOpened: f,
    unmatchedPastedDataInSelectedValues: J,
    preparedData: ne,
    setSearch: w,
    handleSearchChange: V,
    handleValueSelect: v,
    handleValueRemove: T,
    handleDropdownOpen: I,
    handleDropdownClose: M,
    handleSelectAll: R,
    handleClearAll: A,
    handleClearIcon: F,
    handlePaste: u ? P : void 0
  };
}, Bb = (t) => {
  switch (t) {
    case mt.M:
      return ln.M;
    case mt.S:
      return ln.S;
    default:
      return ln.M;
  }
}, uA = (t) => {
  const { errorVariant: e, error: n, disabled: r, className: o, children: i } = t;
  return e === ya.tooltip && n ? /* @__PURE__ */ g.createElement(at, { disabled: r, label: n, style: { maxWidth: m(200) }, withinPortal: !0, multiline: !0 }, /* @__PURE__ */ g.createElement(oe, { "data-testid": "multi-select-error-in-tooltip", component: "span", display: "flex", style: { pointerEvents: "all" }, className: o }, /* @__PURE__ */ g.createElement(Ei, { width: 20, height: 20 }))) : /* @__PURE__ */ g.createElement(g.Fragment, null, i);
}, fA = O(
  (t, {
    withInputValues: e,
    shouldRenderClear: n
  }) => ({
    rightSectionWrapper: {
      position: "absolute",
      right: 1,
      top: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: `calc(100% - ${m(2)})`,
      paddingRight: m(10),
      cursor: "pointer",
      backgroundColor: t.other.colors.white[0],
      border: "none",
      borderRadius: m(8),
      pointerEvents: "none",
      ...e ? {} : {
        "&::before": {
          position: "absolute",
          left: 0,
          transform: "translateX(-90%)",
          pointerEvents: "none",
          width: m(60),
          height: m(27),
          content: '""',
          background: `linear-gradient(270deg, ${t.other.colors.white[0]} 4.17%, rgba(${t.other.colorScheme === "dark" ? "0, 0, 0" : "255, 255, 255"}, 0.671875) 56.68%, rgba(${t.other.colorScheme === "dark" ? "0, 0, 0" : "255, 255, 255"}, 0) 95%)`
        }
      }
    },
    rightSectionWrapperDisabled: {
      cursor: "not-allowed",
      background: "transparent",
      "&::before": {
        background: "transparent"
      }
    },
    clearButton: {
      pointerEvents: "all",
      height: "100%"
    },
    rightSectionDivider: {
      margin: `auto ${m(6)} auto`
    },
    error: {
      color: t.other.colors.raspberry[12]
    },
    chevron: {
      marginRight: m(12)
    },
    alert: {
      marginLeft: n ? 0 : m(12)
    }
  })
), hA = ({
  clearable: t,
  selectedValues: e,
  disabled: n,
  withInputValues: r,
  rightSection: o,
  elementSize: i,
  dropdownOpened: s,
  onDropdownOpen: l,
  onDropdownClose: a,
  onClearIcon: c,
  error: d,
  errorVariant: u,
  classNames: f
}) => {
  const h = Bb(i), p = !!(t && e && e.length > 0 && !n), { classes: y, cx: b } = fA({ withInputValues: r, shouldRenderClear: p }), { classes: w } = U0({ elementSize: h }), S = s ? a : l;
  return /* @__PURE__ */ g.createElement(
    X,
    {
      gap: 0,
      align: "center",
      className: b(y.rightSectionWrapper, f == null ? void 0 : f.rightSectionWrapper, { [y.rightSectionWrapperDisabled]: n })
    },
    p ? /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(
      ye,
      {
        className: b(y.clearButton, f == null ? void 0 : f.clearButton),
        elementVariant: Q.SecondaryMainLine,
        leftSection: /* @__PURE__ */ g.createElement(nf, null),
        isIconOnly: !0,
        onClick: c
      }
    ), /* @__PURE__ */ g.createElement(il, { className: b(y.rightSectionDivider, f == null ? void 0 : f.rightSectionDivider), orientation: "vertical", height: 20 })) : "",
    /* @__PURE__ */ g.createElement(
      uA,
      {
        disabled: n,
        error: d,
        errorVariant: u,
        className: b(y.alert, { [b(y.error, f == null ? void 0 : f.error)]: !!d })
      },
      o || /* @__PURE__ */ g.createElement(g.Fragment, null, !n && /* @__PURE__ */ g.createElement(
        ye,
        {
          role: "button",
          component: "div",
          onClick: n ? void 0 : S,
          elementVariant: Q.SecondaryMainLine,
          isIconOnly: !0,
          disabled: n,
          "data-testid": "multiselect-right-section",
          rightSection: /* @__PURE__ */ g.createElement(
            Sr,
            {
              className: b(w.chevron, {
                [w.chevronOpened]: s,
                [b(y.error, f == null ? void 0 : f.error)]: !!d
              })
            }
          )
        }
      ))
    )
  );
}, pA = 3, gA = (t) => t * pA, mA = O(
  (t, { disabled: e, counterWidth: n }) => ({
    valueItem: {
      display: "flex",
      alignItems: "center",
      backgroundColor: t.other.colors.greyIron[3],
      color: t.other.colors.greyIron[20],
      height: m(28),
      padding: `${m(4)} ${m(8)} ${m(4)} ${m(10)} !important`,
      margin: `${m(2)} !important`,
      borderRadius: m(8),
      cursor: e ? "not-allowed" : "pointer",
      font: t.other.fonts.desktop.s.s.buttons,
      userSelect: "none",
      maxWidth: `calc(100% - ${n ? m(n + 33) : m(20)})`
    },
    valueItemError: {
      backgroundColor: t.other.colors.raspberry[3]
    },
    valueItemRemove: {
      color: t.other.colors.brand[13],
      width: m(20),
      minWidth: m(20),
      height: m(20),
      minHeight: m(20),
      marginLeft: m(4),
      "&:hover": {
        color: t.other.colors.brand[16]
      }
    },
    valueItemLabel: {
      paddingLeft: "0 !important",
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  })
), yA = ({
  label: t,
  classNames: e,
  className: n,
  onRemove: r,
  disabled: o,
  readOnly: i,
  unstyled: s,
  error: l,
  counterWidth: a,
  ...c
}) => {
  const { classes: d, cx: u } = mA({ disabled: o, readOnly: i, counterWidth: a });
  return /* @__PURE__ */ g.createElement(at, { label: t, position: "top", withinPortal: !0, events: { hover: !0, focus: !0, touch: !0 } }, /* @__PURE__ */ g.createElement(oe, { className: u(d.valueItem, e == null ? void 0 : e.valueItem, { [d.valueItemError]: l }, n), ...c }, /* @__PURE__ */ g.createElement(oe, { className: u(d.valueItemLabel, e == null ? void 0 : e.valueItemLabel) }, t), !o && !i && /* @__PURE__ */ g.createElement(
    JS,
    {
      "aria-hidden": !0,
      onMouseDown: r,
      radius: 2,
      color: "blue",
      variant: "transparent",
      iconSize: 16,
      className: u(d.valueItemRemove, e == null ? void 0 : e.valueItemRemove),
      tabIndex: -1,
      unstyled: s
    }
  )));
}, bA = O(() => ({
  valueItem: {
    "&&": {
      display: "inline-block",
      width: "max-content",
      margin: 0,
      marginRight: m(4),
      padding: `${m(4)} 0 ${m(4)} 0`
    },
    "&::after": {
      content: "','"
    },
    "&:nth-last-of-type(1)::after": {
      content: "''"
    }
  }
})), wA = ({ label: t, classNames: e, className: n, ...r }) => {
  const { classes: o, cx: i } = bA();
  return t ? /* @__PURE__ */ g.createElement(oe, { component: "span", className: i(uy, o.valueItem, n, e == null ? void 0 : e.valueItem), ...r }, t) : null;
}, SA = O(
  (t, {
    withInputValues: e,
    elementSize: n
  }) => {
    const r = ot(n, [40, 40, 40, 36]), o = ot(n, [28, 28, 28, 24]);
    return {
      pillGroupWrapper: {
        height: e ? "auto" : `calc(${m(r)} - ${m(2)})`
      },
      pillGroup: {
        display: "flex",
        alignItems: "center",
        flexWrap: e ? "wrap" : "nowrap",
        overflow: e ? "auto" : "hidden",
        whiteSpace: "nowrap",
        maxHeight: e ? "auto" : m(r),
        margin: `${m(5)} ${m(4)} ${m(5)} ${m(-4)}`,
        position: e ? void 0 : "absolute",
        right: e ? void 0 : m(40),
        left: e ? void 0 : m(12)
      },
      counter: {
        minWidth: m(o),
        flexShrink: 0,
        height: m(o),
        marginRight: e ? m(4) : m(8),
        padding: n === mt.M ? t.other.spacings[4] : m(2),
        borderRadius: m(6),
        border: `${m(1)} solid transparent`,
        textAlign: "center",
        backgroundColor: t.other.colors.brand[3],
        font: t.other.fonts.desktop.s.s.default
      },
      counterDisabled: {
        backgroundColor: "transparent",
        borderColor: t.other.colors.greyIron[4],
        color: t.other.colors.greyIron[9]
      },
      selectPlaceholder: {
        display: "inline-block",
        color: t.other.colors.greyIron[10],
        lineHeight: m(r)
      },
      error: {
        color: t.other.colors.raspberry[12]
      },
      disabled: {
        color: t.other.colors.greyIron[9]
      }
    };
  }
), CA = ({
  preparedData: t,
  selectedValues: e,
  elementSize: n,
  disabled: r,
  withInputValues: o,
  unmatchedPastedDataInSelectedValues: i,
  counterLength: s,
  onValueRemove: l,
  placeholder: a,
  label: c,
  error: d,
  classNames: u
}) => {
  const f = gA(s), { classes: h, cx: p } = SA({ withInputValues: o, elementSize: n });
  return /* @__PURE__ */ g.createElement(X, { gap: 0, "aria-label": c == null ? void 0 : c.toString(), p: 0, align: "center", className: p(h.pillGroupWrapper, u == null ? void 0 : u.pillGroupWrapper) }, e && e.length > 0 && /* @__PURE__ */ g.createElement(X, { className: p(h.pillGroup, u == null ? void 0 : u.pillGroup), gap: 0 }, /* @__PURE__ */ g.createElement(oe, { component: "div", className: p(h.counter, u == null ? void 0 : u.counter, { [h.counterDisabled]: r }) }, e.length), e.map((y) => {
    var b, w;
    return o ? /* @__PURE__ */ g.createElement(
      yA,
      {
        key: y,
        onRemove: () => l(y),
        label: (b = t.find(({ value: S }) => S === y)) == null ? void 0 : b.label,
        counterWidth: f,
        error: i.includes(y),
        classNames: u,
        disabled: r
      }
    ) : /* @__PURE__ */ g.createElement(wA, { key: y, label: (w = t.find(({ value: S }) => S === y)) == null ? void 0 : w.label, classNames: u });
  })), (e == null ? void 0 : e.length) === 0 && /* @__PURE__ */ g.createElement(
    oe,
    {
      component: "span",
      className: p(h.selectPlaceholder, u == null ? void 0 : u.selectPlaceholder, {
        [p(h.error, u == null ? void 0 : u.error)]: !!d,
        [p(h.disabled)]: r
      })
    },
    a
  ));
}, vA = O((t) => ({
  label: {},
  labelWrapper: {
    display: "inline-flex",
    alignItems: "center"
  },
  labelIcon: {
    color: t.other.colors.greyIron[10]
  },
  required: {}
})), Vb = ge((t, e) => {
  const { label: n, labelIcon: r, labelIconTooltipText: o, disabled: i, elementSize: s, classNames: l, onClick: a, required: c, tooltipProps: d } = t, { classes: u, cx: f } = vA(), { classes: h } = sr({ elementSize: s });
  return /* @__PURE__ */ g.createElement(oe, { component: "span", className: f(u.labelWrapper, l == null ? void 0 : l.labelWrapper, { [h.labelWrapperWithIcon]: r }) }, n && /* @__PURE__ */ g.createElement("span", null, /* @__PURE__ */ g.createElement(oe, { component: "span", ref: e, onClick: a }, n), c && /* @__PURE__ */ g.createElement("span", { className: f(h.required, u == null ? void 0 : u.required), "aria-hidden": !0 }, " *")), (r || o) && /* @__PURE__ */ g.createElement(at, { label: o, style: { maxWidth: m(200) }, multiline: !0, withinPortal: !0, ...d }, /* @__PURE__ */ g.createElement(
    oe,
    {
      component: "span",
      className: f(h.labelIcon, h.labelIcon, { [h.iconDisabled]: i }, u.labelIcon)
    },
    r || /* @__PURE__ */ g.createElement(Nr, null)
  )));
});
Vb.displayName = "MultiSelectLabel";
const xA = ({
  data: t,
  limit: e,
  search: n,
  searchableByDescription: r
}) => {
  const i = t.filter(
    ({ label: l, description: a }) => l.toLowerCase().includes(n.trim().toLowerCase()) || r && (a == null ? void 0 : a.toLowerCase().includes(n.trim().toLowerCase()))
  ).slice(0, e);
  return i.some((l) => l.group) ? i.sort((l, a) => l.group && a.group ? l.group.localeCompare(a.group) : 0) : i;
}, ql = ge(
  ({ selected: t, label: e, description: n, disabled: r, ...o }, i) => /* @__PURE__ */ g.createElement(X, { wrap: "nowrap", gap: 0, ref: i, ...o }, /* @__PURE__ */ g.createElement(la, { display: "flex", checked: t, disabled: r, readOnly: !0 }), /* @__PURE__ */ g.createElement(Ee, { gap: 3 }, /* @__PURE__ */ g.createElement(xe, { elementVariant: "default", elementSize: "s" }, e), n && /* @__PURE__ */ g.createElement(xe, { elementVariant: "default", elementSize: "xs", colorVariant: "greyIron.12" }, n)))
);
ql.displayName = "MultiSelectItem";
const EA = O((t) => ({
  dropdownOptionsWrapper: {
    padding: `${m(4)} 0 ${m(4)} ${m(8)}`
  },
  dropdownScrollArea: {
    '& > [data-offset-scrollbars="xy"]': {
      padding: 0
    }
  },
  dropdownButtonGroup: {
    width: "100%",
    padding: `${m(4)} ${m(12)} ${m(8)} ${m(12)}`
  },
  dropdownItem: {
    color: t.other.colors.greyIron[20],
    minHeight: m(38),
    padding: `${m(8)} ${m(12)}`,
    "&:hover": {
      backgroundColor: t.other.colors.greyIron[2],
      "&:where([data-combobox-disabled])": {
        backgroundColor: "transparent"
      }
    },
    "&:where([data-combobox-disabled])": {
      opacity: 1
    },
    "&:where([data-combobox-selected])": {
      backgroundColor: t.other.colors.greyIron[2],
      "&:hover": {
        backgroundColor: t.other.colors.greyIron[2]
      }
    }
  },
  groupDivider: {
    margin: `0 ${m(8)}`,
    borderColor: t.other.colors.greyIron[3]
  }
})), kA = ({
  data: t,
  selectedValues: e,
  maxDropdownHeight: n,
  selectAllLabel: r,
  clearLabel: o,
  emptySearchLabel: i,
  search: s,
  limit: l,
  searchableByDescription: a,
  onSelectAll: c,
  onClearAll: d,
  classNames: u,
  dataTestId: f
}) => {
  const { classes: h, cx: p } = EA(), y = xA({ data: t, limit: l, search: s, searchableByDescription: a }), b = new Set(e), w = y.some((v) => v.group), S = [...new Set(y.map((v) => v.group))].filter(Boolean), x = y.filter((v) => !v.group), E = (v) => f ? `${f}-${v}` : void 0;
  return /* @__PURE__ */ g.createElement(kt.Options, { className: p(h.dropdownOptionsWrapper, u == null ? void 0 : u.dropdownOptionsWrapper), "data-testid": f }, y.length > 0 ? /* @__PURE__ */ g.createElement(
    Fr.Autosize,
    {
      style: { maxHeight: n ? m(n) : "auto" },
      type: "auto",
      className: p(h.dropdownScrollArea, u == null ? void 0 : u.dropdownScrollArea)
    },
    /* @__PURE__ */ g.createElement(X, { wrap: "nowrap", justify: "space-between", align: "center", className: p(h.dropdownButtonGroup, u == null ? void 0 : u.dropdownButtonGroup) }, /* @__PURE__ */ g.createElement(ye, { elementVariant: Q.PrimaryMainLine, onClick: c, "data-testid": E("select-all") }, r || "Select All"), /* @__PURE__ */ g.createElement(ye, { elementVariant: Q.SecondaryMainLine, onClick: d, "data-testid": E("clear") }, o || "Clear")),
    w ? /* @__PURE__ */ g.createElement(Ee, null, S.map((v) => /* @__PURE__ */ g.createElement(kt.Group, { label: v, key: v }, y.filter((T) => T.group === v).map(({ value: T, label: I, description: M, disabled: R, "data-testid": A }) => /* @__PURE__ */ g.createElement(
      kt.Option,
      {
        key: T,
        value: T,
        active: b.has(T),
        className: p(h.dropdownItem, u == null ? void 0 : u.dropdownItem),
        disabled: R,
        "data-testid": A
      },
      /* @__PURE__ */ g.createElement(X, { gap: "sm" }, /* @__PURE__ */ g.createElement(
        ql,
        {
          selected: b.has(T),
          label: I,
          value: T,
          disabled: R,
          description: M
        }
      ))
    )))), /* @__PURE__ */ g.createElement(Ee, null, /* @__PURE__ */ g.createElement(Qu, { mr: 8, className: p(h.groupDivider, u == null ? void 0 : u.groupDivider) }), x.map(({ value: v, label: T, description: I, disabled: M, "data-testid": R }) => /* @__PURE__ */ g.createElement(
      kt.Option,
      {
        value: v,
        key: v,
        active: b.has(v),
        className: p(h.dropdownItem, u == null ? void 0 : u.dropdownItem),
        "data-testid": R
      },
      /* @__PURE__ */ g.createElement(X, { gap: "sm" }, /* @__PURE__ */ g.createElement(
        ql,
        {
          selected: b.has(v),
          disabled: M,
          label: T,
          value: v,
          description: I
        }
      ))
    )))) : y.map(({ value: v, label: T, description: I, disabled: M, "data-testid": R }) => /* @__PURE__ */ g.createElement(
      kt.Option,
      {
        value: v,
        key: v,
        active: b.has(v),
        className: p(h.dropdownItem, u == null ? void 0 : u.dropdownItem),
        disabled: M,
        "data-testid": R
      },
      /* @__PURE__ */ g.createElement(X, { gap: "sm" }, /* @__PURE__ */ g.createElement(
        ql,
        {
          selected: b.has(v),
          label: T,
          value: v,
          disabled: M,
          description: I
        }
      ))
    ))
  ) : /* @__PURE__ */ g.createElement(kt.Empty, null, /* @__PURE__ */ g.createElement(xe, { elementVariant: "default", elementSize: "s", colorVariant: "greyIron.10" }, i || "No data")));
}, TA = O(
  (t, {
    elementSize: e,
    isCounterDisplay: n,
    error: r,
    shouldClear: o
  }) => {
    const i = ot(e, [void 0, void 0, 20, 18]), s = ot(e, [40, 40, 40, 36]), l = o ? 71 : 36;
    return {
      root: {
        lineHeight: m(20)
      },
      dropdown: {
        "&&": {
          paddingLeft: m(4),
          paddingRight: m(12),
          paddingBottom: m(8)
        }
      },
      dropdownScrollArea: {},
      dropdownButtonGroup: {},
      dropdownItem: {},
      groupDivider: {},
      label: {
        color: t.other.colors.greyIron[15]
      },
      labelWrapper: {},
      labelIcon: {},
      inputRoot: {
        display: "grid",
        gap: m(6)
      },
      wrapper: {
        marginBottom: 0
      },
      input: {
        paddingTop: 0,
        paddingBottom: 0,
        position: "relative",
        height: "auto",
        boxSizing: "border-box",
        paddingRight: m(l),
        cursor: "pointer",
        "&::placeholder": {
          color: t.other.colors.greyIron[10]
        },
        minHeight: m(s),
        font: t.other.fonts.desktop.s.s.default,
        overflow: "hidden",
        whiteSpace: "nowrap",
        ...r ? { borderColor: `${t.other.colors.raspberry[12]} !important` } : {},
        '&[data-error="true"]': {
          backgroundColor: t.other.colors.white[0],
          color: t.other.colors.greyIron[18],
          "&:hover:not(&:disabled)": {
            borderColor: t.other.colors.raspberry[12],
            backgroundColor: t.other.colors.raspberry[0]
          },
          "&:active:not(&:disabled)": {
            backgroundColor: t.other.colors.white[0]
          },
          "&:focus": {
            borderColor: t.other.colors.raspberry[12]
          },
          "&::placeholder": {
            color: t.other.colors.raspberry[12]
          },
          [`& ~ .${ys}`]: {
            svg: {
              color: t.other.colors.raspberry[12]
            }
          }
        },
        '& [type="search"]': {
          marginLeft: n ? 0 : void 0,
          font: t.other.fonts.desktop.s.s.default,
          "&::-webkit-search-cancel-button": {
            display: "none"
          }
        }
      },
      selectPlaceholder: {},
      searchInput: {
        paddingTop: 0,
        paddingBottom: 0,
        position: "relative",
        boxSizing: "border-box",
        paddingRight: m(l),
        cursor: "pointer",
        "&::placeholder": {
          color: t.other.colors.greyIron[10]
        },
        font: t.other.fonts.desktop.s.s.default,
        overflow: "hidden",
        whiteSpace: "nowrap",
        height: m(36),
        minHeight: m(36),
        paddingLeft: m(32),
        margin: `0 0 0 ${m(8)}`,
        "&&": {
          borderWidth: "1px",
          width: `calc(100% - ${m(12)})`,
          maxWidth: `calc(100% - ${m(12)})`
        }
      },
      searchIcon: {
        marginLeft: m(12),
        width: m(18),
        height: m(18)
      },
      werror: {
        color: t.other.colors.raspberry[12]
      },
      disabled: {
        "&:hover:not(&:disabled)": {
          borderColor: "transparent"
        }
      },
      values: {},
      required: {},
      counter: {},
      counterDisabled: {},
      section: {
        '&[data-position="right"]': {
          display: "flex",
          flexDirection: "column",
          marginRight: 0,
          width: m(l),
          cursor: "pointer",
          svg: {
            width: m(i),
            height: m(i),
            color: t.other.colors.greyIron[12]
          }
        }
      },
      rightSectionWrapper: {},
      rightSectionWrapperDisabled: {},
      clearButton: {},
      rightSectionDivider: {},
      pillGroupWrapper: {},
      pillGroup: {},
      description: {
        color: t.other.colors.greyIron[10]
      },
      error: {
        color: t.other.colors.raspberry[12]
      }
    };
  }
), IA = ["label", "input", "error", "description"], Fb = ge((t, e) => {
  const { styleProps: n, rest: r } = el(t), {
    data: o,
    elementSize: i = mt.M,
    withInputValues: s = !1,
    clearable: l,
    disabled: a,
    classNames: c,
    label: d,
    labelIcon: u,
    labelIconTooltipText: f,
    rightSection: h,
    onDropdownOpen: p,
    onDropdownClose: y,
    placeholder: b,
    searchable: w = !0,
    searchableByDescription: S,
    selectAllLabel: x,
    clearLabel: E,
    initiallyOpened: v,
    value: T,
    defaultValue: I,
    onChange: M,
    searchValue: R,
    defaultSearchValue: A,
    onSearchChange: F,
    error: V,
    required: P,
    emptySearchLabel: J,
    maxDropdownHeight: ne,
    style: G,
    onUnmatchedDataChange: H,
    description: W,
    targetButtonText: se,
    targetButtonProps: U,
    position: re = "bottom-start",
    limit: ke = Number.POSITIVE_INFINITY,
    errorVariant: Te = ya.default,
    tooltipProps: Se,
    "data-testid": Le,
    ...Ce
  } = he("MultiSelect", {}, r), {
    combobox: et,
    selectedValues: Oe,
    search: $e,
    dropdownOpened: Ie,
    unmatchedPastedDataInSelectedValues: ee,
    preparedData: de,
    handleValueSelect: ae,
    handleValueRemove: Y,
    handleDropdownOpen: we,
    handleDropdownClose: Ze,
    handleSelectAll: Je,
    handleClearAll: ht,
    handleClearIcon: Xe,
    handlePaste: Lt,
    handleSearchChange: Be
  } = dA({
    data: o,
    value: T,
    defaultValue: I,
    searchValue: R,
    defaultSearchValue: A,
    initiallyOpened: v,
    onChange: M,
    onDropdownOpen: p,
    onDropdownClose: y,
    onSearchChange: F,
    onUnmatchedDataChange: H,
    withInputValues: s
  }), tt = !!(Oe != null && Oe.length), St = String(Oe == null ? void 0 : Oe.length).length, Mt = !!(l && Oe && Oe.length > 0 && !a), nt = Bb(i), { classes: je, cx: Qe } = TA({ elementSize: i, isCounterDisplay: tt, error: V, shouldClear: Mt }), { classes: L } = sr({ elementSize: i }), { classes: q } = yf({ elementSize: nt }), ve = Ie ? Ze : we, De = (pt) => Le ? `${Le}-${pt}` : void 0;
  return /* @__PURE__ */ g.createElement(Ee, { gap: 4, className: Qe(je.root, c == null ? void 0 : c.root), style: G, ...n }, /* @__PURE__ */ g.createElement(
    kt,
    {
      store: et,
      onOptionSubmit: ae,
      transitionProps: { duration: 300, transition: "pop-top-left" },
      position: re,
      middlewares: { shift: !1 },
      "data-testid": Le,
      ...Ce
    },
    /* @__PURE__ */ g.createElement(kt.DropdownTarget, null, se ? /* @__PURE__ */ g.createElement(ye, { "data-testid": De("button"), ...U, onClick: a ? void 0 : ve }, se) : /* @__PURE__ */ g.createElement(
      KS,
      {
        ref: e,
        label: d || u ? /* @__PURE__ */ g.createElement(
          Vb,
          {
            label: d,
            labelIcon: u,
            labelIconTooltipText: f,
            disabled: a,
            elementSize: i,
            classNames: c,
            onClick: a ? void 0 : we,
            required: P,
            tooltipProps: Se
          }
        ) : void 0,
        onClick: a ? void 0 : ve,
        onFocus: a ? void 0 : we,
        classNames: {
          wrapper: Qe(je.wrapper, c == null ? void 0 : c.wrapper),
          root: Qe(je.inputRoot, c == null ? void 0 : c.inputRoot),
          input: Qe(L.input, je.input, c == null ? void 0 : c.input),
          required: Qe(L.required, je.required, c == null ? void 0 : c.required),
          label: Qe(L.label, je.label, c == null ? void 0 : c.label, {
            [L.labelDisabled]: a
          }),
          description: Qe(L.description, je.description, c == null ? void 0 : c.description),
          error: Qe(L.error, je == null ? void 0 : je.error, c == null ? void 0 : c.error)
        },
        required: P,
        disabled: a,
        tabIndex: 0,
        error: Te === ya.default ? V : void 0,
        description: W,
        inputWrapperOrder: IA,
        "data-testid": De("pills")
      },
      /* @__PURE__ */ g.createElement(
        CA,
        {
          preparedData: de,
          elementSize: i,
          selectedValues: Oe,
          disabled: a,
          withInputValues: s,
          classNames: c,
          unmatchedPastedDataInSelectedValues: ee,
          counterLength: St,
          onValueRemove: Y,
          placeholder: b,
          label: d,
          error: V
        }
      ),
      /* @__PURE__ */ g.createElement(
        hA,
        {
          clearable: l,
          selectedValues: Oe,
          disabled: a,
          withInputValues: s,
          rightSection: h,
          elementSize: i,
          dropdownOpened: Ie,
          onDropdownOpen: we,
          onDropdownClose: Ze,
          onClearIcon: Xe,
          classNames: c,
          error: V,
          errorVariant: Te
        }
      )
    )),
    /* @__PURE__ */ g.createElement(kt.Dropdown, { className: Qe(q.dropdown, je.dropdown, c == null ? void 0 : c.dropdown), "data-testid": De("dropdown") }, w && /* @__PURE__ */ g.createElement(
      kt.Search,
      {
        value: $e,
        leftSection: /* @__PURE__ */ g.createElement(Ym, { className: Qe(je.searchIcon, c == null ? void 0 : c.searchIcon) }),
        onChange: Be,
        onPaste: Lt,
        classNames: {
          input: Qe(L.input, je.searchInput, c == null ? void 0 : c.searchInput)
        },
        placeholder: b,
        "data-testid": De("search")
      }
    ), /* @__PURE__ */ g.createElement(
      kA,
      {
        data: o,
        selectedValues: Oe,
        maxDropdownHeight: ne,
        selectAllLabel: x,
        clearLabel: E,
        emptySearchLabel: J,
        search: $e,
        searchableByDescription: S,
        onSelectAll: Je,
        onClearAll: ht,
        classNames: c,
        limit: ke,
        dataTestId: De("options")
      }
    ))
  ));
});
Fb.displayName = "MultiSelect";
const MA = O((t) => ({
  title: {
    color: t.other.colors.greyIron[20]
  },
  message: {
    color: t.other.colors.greyIron[13]
  }
})), RA = ({ title: t, message: e, closeButtonProps: n, children: r }) => {
  const { classes: o } = MA();
  return /* @__PURE__ */ g.createElement(X, { wrap: "nowrap", justify: "space-between" }, /* @__PURE__ */ g.createElement(Ee, { align: "flex-start", gap: 0 }, t && /* @__PURE__ */ g.createElement(xe, { elementSize: "s", elementVariant: "important", className: o.title, "data-testid": "notification-title" }, t), /* @__PURE__ */ g.createElement(xe, { elementSize: "s", elementVariant: "default", className: o.message, "data-testid": "notification-message" }, e)), /* @__PURE__ */ g.createElement(ye, { elementVariant: Q.SecondaryMainLine, "data-testid": "notification-close-button", ...n }, r));
};
var In = /* @__PURE__ */ ((t) => (t.Default = "Default", t.Success = "Success", t.Warning = "Warning", t.Error = "Error", t))(In || {});
const OA = (t, e) => ({
  [In.Default]: /* @__PURE__ */ g.createElement(Ei, { width: e, height: e }),
  [In.Success]: /* @__PURE__ */ g.createElement(qm, { width: e, height: e }),
  [In.Warning]: /* @__PURE__ */ g.createElement(Jm, { width: e, height: e }),
  [In.Error]: /* @__PURE__ */ g.createElement(EC, { width: e, height: e })
})[t], DA = O((t, { elementVariant: e }) => ({
  [In.Default]: {
    root: {
      border: `${m(5)} solid ${t.other.colors.greyIron[1]}`,
      borderRadius: "50%"
    },
    placeholder: {
      backgroundColor: t.other.colors.greyIron[3],
      color: t.other.colors.greyIron[11]
    }
  },
  [In.Success]: {
    root: {
      border: `${m(5)} solid ${t.other.colors.froggy[1]}`,
      borderRadius: "50%"
    },
    placeholder: {
      backgroundColor: t.other.colors.froggy[3],
      color: t.other.colors.froggy[12]
    }
  },
  [In.Warning]: {
    root: {
      border: `${m(5)} solid ${t.other.colors.sunflower[1]}`,
      borderRadius: "50%"
    },
    placeholder: {
      backgroundColor: t.other.colors.sunflower[3],
      color: t.other.colors.sunflower[12]
    }
  },
  [In.Error]: {
    root: {
      border: `${m(5)} solid ${t.other.colors.raspberry[1]}`,
      borderRadius: "50%"
    },
    placeholder: {
      backgroundColor: t.other.colors.raspberry[3],
      color: t.other.colors.raspberry[12]
    }
  }
})[e]), AA = ({ iconContainerSize: t, iconSize: e, elementVariant: n }) => {
  const { classes: r } = DA({ elementVariant: n });
  return /* @__PURE__ */ g.createElement(Jo, { classNames: r, avatarSize: t }, OA(n, e));
}, LA = (t, e) => ({
  [In.Default]: {
    root: {
      borderColor: t.other.colors.greyIron[6],
      backgroundColor: t.other.colors.white[0]
    }
  },
  [In.Success]: {
    root: {
      borderColor: t.other.colors.froggy[6],
      backgroundColor: t.other.colors.froggy[0]
    }
  },
  [In.Warning]: {
    root: {
      borderColor: t.other.colors.sunflower[6],
      backgroundColor: t.other.colors.sunflower[0]
    }
  },
  [In.Error]: {
    root: {
      borderColor: t.other.colors.raspberry[6],
      backgroundColor: t.other.colors.raspberry[0]
    }
  }
})[e], $A = (t) => ({
  root: {
    padding: `${m(6)} ${m(10)}`,
    border: `${m(1)} solid transparent`,
    borderRadius: m(8),
    minHeight: m(64),
    boxShadow: "none"
  },
  icon: {
    width: t,
    height: t,
    backgroundColor: "transparent !important",
    marginRight: m(11)
  },
  body: {
    marginRight: m(5)
  }
}), PA = ({
  title: t,
  message: e,
  elementVariant: n,
  buttonText: r,
  closeButtonProps: o,
  iconContainerSize: i = 50,
  iconSize: s = 20,
  position: l = "top-right",
  withCloseButton: a = !1,
  ...c
}) => {
  Ud.show({
    icon: /* @__PURE__ */ g.createElement(AA, { elementVariant: n, iconContainerSize: i, iconSize: s }),
    message: /* @__PURE__ */ g.createElement(RA, { message: e, title: t, closeButtonProps: o }, r),
    withCloseButton: a,
    position: l,
    styles: (d) => {
      const u = $A(i), f = LA(d, n);
      return {
        root: {
          ...u.root,
          ...f.root
        },
        icon: u.icon,
        body: u.body
      };
    },
    ...c
  });
}, mz = () => ({
  showNotification: PA,
  cleanNotifications: Sv,
  cleanNotificationsQueue: wv,
  hideNotification: bv,
  notifications: Ud,
  /* @deprecated Use `notifications` instead */
  useNotifications: Ud
}), _A = O(() => ({
  root: {},
  titleWrapper: {},
  backButton: {},
  backButtonTooltip: {},
  logoIconWrapper: {
    width: m(56),
    height: m(56)
  },
  title: {},
  subtitle: {}
})), BA = (t) => {
  const {
    elementSize: e = "m",
    withLogo: n = !1,
    withBackButton: r = !1,
    title: o,
    subtitle: i,
    logoIcon: s,
    backButtonTooltip: l,
    onBackButtonClick: a,
    classNames: c,
    className: d,
    ...u
  } = t, { classes: f, cx: h } = _A(), p = e === "m", y = !!i;
  return /* @__PURE__ */ g.createElement(Ee, { gap: 4, className: h(f.root, c == null ? void 0 : c.root, d), ...u }, /* @__PURE__ */ g.createElement(X, { align: "stretch", w: "auto", gap: 4, wrap: "nowrap", className: h(f.titleWrapper, c == null ? void 0 : c.titleWrapper) }, r && p && /* @__PURE__ */ g.createElement(at, { label: l, className: h(f.backButtonTooltip, c == null ? void 0 : c.backButtonTooltip) }, /* @__PURE__ */ g.createElement(
    ye,
    {
      isIconOnly: !0,
      isRound: !0,
      elementVariant: Q.PrimaryMainLine,
      leftSection: /* @__PURE__ */ g.createElement(kC, null),
      className: h(f.backButton, c == null ? void 0 : c.backButton),
      onClick: a,
      "data-testid": "page-heading-back-button"
    }
  )), n && p && /* @__PURE__ */ g.createElement(oe, { className: h(f.logoIconWrapper, c == null ? void 0 : c.logoIconWrapper) }, s), o && /* @__PURE__ */ g.createElement(
    Ti,
    {
      order: p ? 1 : 2,
      elementSize: p ? "xl" : "m",
      colorVariant: "greyIron.18",
      className: h(f.title, c == null ? void 0 : c.title),
      ml: n && p ? 4 : void 0
    },
    o
  )), y && /* @__PURE__ */ g.createElement(
    xe,
    {
      elementSize: p ? "m" : "s",
      elementVariant: "default",
      colorVariant: "greyIron.16",
      className: h(f.subtitle, c == null ? void 0 : c.subtitle)
    },
    i
  ));
}, VA = () => {
  const t = Nt(!1);
  return It(() => {
    t.current = !0;
  }, []), t.current;
}, FA = {
  dots: Zm,
  next: $s,
  prev: xi,
  last: $s,
  first: xi
}, NA = {
  dots: Zm,
  next: $s,
  prev: xi,
  last: $s,
  first: xi
}, zA = 5, HA = 84, Jl = ({ page: t, onClick: e, controlsText: n, pageNode: r, ...o }) => {
  const i = _i(), { dir: s } = YS(), l = (s === "rtl" ? NA : FA)[t], a = () => {
    switch (t) {
      case "prev":
        return n == null ? void 0 : n[0];
      case "next":
        return n == null ? void 0 : n[1];
      case "dots":
        return null;
      case "last":
      case "first":
        return /* @__PURE__ */ g.createElement(l, null);
      default:
        return t;
    }
  }, c = () => t === "prev" ? /* @__PURE__ */ g.createElement(l, { color: i.other.colors.brand[13] }) : t === "dots" ? /* @__PURE__ */ g.createElement(l, { style: { color: i.other.colors.greyIron[20] }, width: 20, height: 20 }) : null, d = a(), u = ["next", "prev"].includes(t) && !d || t === "dots", f = ["next", "prev"].includes(t) && !d, h = d && d.toString().length > zA, p = !u && !h && !n, y = r || /* @__PURE__ */ g.createElement(
    ye,
    {
      elementVariant: Q.TertiaryMain,
      elementSize: Ue.S,
      type: "button",
      onClick: e,
      leftSection: c(),
      rightSection: t === "next" && /* @__PURE__ */ g.createElement(l, { color: i.other.colors.brand[13] }),
      isIconOnly: u,
      isRound: f,
      "data-testid": `pagination-item-${t}`,
      style: { maxWidth: p ? HA : void 0 },
      ...o
    },
    u ? void 0 : d
  );
  return h ? /* @__PURE__ */ g.createElement(at, { label: d }, y) : y;
};
Jl.displayName = "Item";
const Cl = "break-word", jA = O((t) => ({
  item: {
    cursor: "pointer",
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: m(74),
    "&[data-dots]": {
      cursor: "default",
      borderColor: "transparent",
      backgroundColor: "transparent",
      pointerEvents: "none"
    },
    "&[data-active]": {
      borderColor: t.other.colors.greyIron[2],
      backgroundColor: t.other.colors.greyIron[2],
      "&:hover": {
        backgroundColor: t.other.colors.greyIron[3]
      },
      "&:active": {
        backgroundColor: t.other.colors.greyIron[4]
      }
    },
    "&[data-disabled]": {
      cursor: "not-allowed"
    },
    "& > div": {
      overflow: "hidden",
      wordWrap: Cl,
      "& > span": {
        display: "inline-block",
        wordBreak: Cl,
        textOverflow: "ellipsis"
      }
    }
  },
  withPerPageWrapper: {
    color: t.other.colors.greyIron[11],
    "& > div": {
      position: "relative"
    },
    [`& .${dy}`]: {
      width: "100%"
    },
    order: 999999,
    [Ge.greaterThen("md")]: {
      order: "unset"
    }
  },
  perPageButton: {
    padding: `${m(7)} ${m(15)}`
  },
  withGoToPageWrapper: {
    color: t.other.colors.greyIron[11],
    order: 999999,
    [Ge.greaterThen("md")]: {
      order: "unset"
    }
  },
  goToPageInput: {
    textAlign: "center",
    overflow: "hidden",
    wordBreak: Cl,
    wordWrap: Cl,
    textOverflow: "ellipsis"
  },
  goToPageInputWrapper: {
    minWidth: m(36),
    maxWidth: m(74)
  },
  arrowButtonWithText: {
    maxWidth: "100%"
  }
})), WA = 36, GA = 400, UA = {
  initialPage: 1,
  siblings: 1,
  boundaries: 1,
  withControls: !0,
  pageSizeOptions: ["10", "20", "30", "40", "50", "60", "70", "80", "90", "100"],
  defaultPageSize: 10
}, Nb = ge((t, e) => {
  const {
    classNames: n,
    page: r,
    initialPage: o,
    total: i,
    siblings: s,
    boundaries: l,
    onChange: a,
    getItemAriaLabel: c,
    withControls: d,
    unstyled: u,
    pageSize: f,
    pageSizeOptions: h,
    hideOnSinglePage: p,
    defaultPageSize: y,
    withPerPage: b,
    pageSizeShowText: w,
    goToPageText: S,
    withGoToPage: x,
    controlsText: E,
    visiblePageNodes: v,
    pageNodes: T,
    ...I
  } = he("Pagination", UA, t), [M, R] = ie(WA), [A, F] = ie(""), [V, P] = dv(A, GA), J = Nt(null), [ne, G] = an({
    defaultValue: y,
    value: f
  }), { classes: H, cx: W } = jA(), se = me(() => Math.ceil(i / ne), [ne, i]), U = me(() => !!(se === 1 && p), [p, se]), re = (Y) => {
    a == null || a(Y, ne);
  }, { range: ke, setPage: Te, next: Se, previous: Le, active: Ce } = uv({
    page: r,
    siblings: s,
    total: se,
    initialPage: o,
    boundaries: l,
    onChange: re
  }), et = (Y) => () => {
    G(Number(Y)), a == null || a(Ce, Number(Y));
  }, Oe = ({ target: { value: Y } }) => {
    F(Y), P(Y);
  }, $e = v ?? ke.length, Ie = ke.length > $e ? ke.slice(
    Math.max(0, Math.min(ke.length - $e, ke.indexOf(Ce) - Math.floor($e / 2))),
    Math.max($e, Math.min(ke.length, ke.indexOf(Ce) + Math.ceil($e / 2)))
  ) : ke, ee = $e === 1, de = Ie.map((Y, we) => /* @__PURE__ */ g.createElement(
    Jl,
    {
      key: we,
      page: Y,
      pageNode: Y === "dots" || T == null ? void 0 : T[Y],
      "aria-current": Y === Ce ? "page" : void 0,
      "aria-label": typeof c == "function" ? c(Y) : "",
      tabIndex: Y === "dots" ? -1 : 0,
      "data-dots": Y === "dots" || void 0,
      "data-active": Y === Ce || void 0,
      className: W(H.item, n == null ? void 0 : n.item),
      onClick: Y === "dots" ? void 0 : () => Te(Y)
    }
  )), ae = VA();
  return It(() => {
    ae && Te(1);
  }, [ne]), _m(() => {
    J.current && R(J.current.offsetWidth);
  }, [A]), It(() => {
    const Y = Number(V);
    Y && Y <= se && Te(Y);
  }, [V]), U ? null : /* @__PURE__ */ g.createElement(
    gr,
    {
      role: "navigation",
      wrap: ee ? "nowrap" : "wrap",
      justify: { base: ee ? "center" : "start", md: "center" },
      align: "center",
      gap: 8,
      ref: e,
      unstyled: u,
      ...I
    },
    d && /* @__PURE__ */ g.createElement(
      Jl,
      {
        page: "prev",
        onClick: Le,
        "aria-label": c ? c("prev") : void 0,
        "aria-disabled": Ce === 1,
        className: W(H.item, n == null ? void 0 : n.item, {
          [W(H.arrowButtonWithText, n == null ? void 0 : n.arrowButtonWithText)]: !!E
        }),
        disabled: Ce === 1 || se <= 1,
        controlsText: E,
        mr: { base: ee ? "auto" : "unset", md: "auto" }
      }
    ),
    de,
    b && /* @__PURE__ */ g.createElement(X, { gap: 12, className: W(H.withPerPageWrapper, n == null ? void 0 : n.withPerPageWrapper) }, w || "Show", /* @__PURE__ */ g.createElement(
      Zt,
      {
        targetElementProps: {
          elementVariant: Q.TertiaryMain,
          children: ne
        },
        elementSize: ln.M,
        classNames: { targetElement: W(H.perPageButton, n == null ? void 0 : n.perPageButton) },
        "data-testid": "pagination-item-dropdown",
        "aria-label": c ? c("pageSize") : void 0
      },
      /* @__PURE__ */ g.createElement(Zt.Items, null, h == null ? void 0 : h.map((Y) => /* @__PURE__ */ g.createElement(
        Zt.Item,
        {
          "data-testid": `pagination-item-dropdown-${Y}`,
          key: Y,
          onClick: et(Y),
          "data-current": Number(Y) === ne
        },
        Y
      )))
    )),
    x && /* @__PURE__ */ g.createElement(X, { gap: 12, align: "center", className: W(H.withGoToPageWrapper, n == null ? void 0 : n.withGoToPageWrapper) }, (S == null ? void 0 : S[0]) || "Go to", /* @__PURE__ */ g.createElement(
      Ab,
      {
        style: { width: M },
        placeholder: "2",
        classNames: {
          root: W(H.goToPageInputWrapper, n == null ? void 0 : n.goToPageInputWrapper),
          input: W(H.goToPageInput, n == null ? void 0 : n.goToPageInput)
        },
        elementSize: mt.S,
        onChange: Oe,
        "data-testid": "pagination-item-input",
        "aria-label": c ? c("goToPage") : void 0,
        maxLength: se.toString().length
      }
    ), /* @__PURE__ */ g.createElement("span", { style: { visibility: "hidden", padding: `0 ${m(13)}`, position: "absolute" }, ref: J }, A), (S == null ? void 0 : S[1]) || "page"),
    d && /* @__PURE__ */ g.createElement(
      Jl,
      {
        page: "next",
        onClick: Se,
        "aria-label": c ? c("next") : void 0,
        "aria-disabled": Ce === se,
        className: W(H.item, n == null ? void 0 : n.item, { [H.arrowButtonWithText]: !!E }),
        disabled: Ce === se || se <= 1,
        controlsText: E,
        ml: { base: ee ? "auto" : "unset", md: "auto" }
      }
    )
  );
});
Nb.displayName = "Pagination";
const qA = O((t) => ({
  root: {
    width: "100%",
    alignItems: "flex-start"
  },
  progressRoot: {
    flex: 1
  },
  progressIndicatorWrapper: {
    minWidth: m(6)
  },
  progressIndicatorPolygon: {},
  progressIndicatorValue: {
    wordBreak: "keep-all",
    "&[data-left]": {
      left: m(10)
    },
    "&[data-right]": {
      right: `calc(100% + ${m(4)})`
    }
  },
  progressWrapper: {
    height: m(8),
    position: "relative",
    backgroundColor: t.other.colors.greyIron[2],
    borderRadius: t.other.borderRadius[8],
    overflow: "hidden"
  },
  progress: {
    minWidth: m(3),
    height: m(8),
    borderRadius: t.other.borderRadius[8],
    background: "linear-gradient(90deg, #B1E400 0%, #86AD00 105.9%)"
  },
  pointsValueWrapper: {},
  pointValue: {
    whiteSpace: "nowrap",
    alignItems: "flex-end"
  }
})), Vp = 100, ed = 100, JA = 50, td = 0, KA = {
  withPoints: !0,
  withCurrentValue: !0
}, YA = wr((t) => {
  const { className: e, classNames: n, withPoints: r, withCurrentValue: o, points: i, currentValue: s, ...l } = he(
    "ProgressBar",
    KA,
    t
  ), { classes: a, cx: c } = qA(), [d, u] = i, f = s < d ? d : s, h = me(() => {
    if (d === s && u === Number.POSITIVE_INFINITY)
      return td;
    if (d !== s && u === Number.POSITIVE_INFINITY)
      return ed;
    let b = f / u * Vp;
    return d !== td && (b = (f - d) / (u - d) * Vp), b > ed ? ed : b;
  }, [d, s, u, f]), p = me(() => h === td, [h]), y = me(() => h > JA, [h]);
  return /* @__PURE__ */ g.createElement(X, { wrap: "nowrap", gap: 16, className: c(a.root, n == null ? void 0 : n.root, e), ...l }, /* @__PURE__ */ g.createElement(Ee, { p: 0, m: 0, className: c(a.progressRoot, n == null ? void 0 : n.progressRoot), gap: 0 }, o && /* @__PURE__ */ g.createElement(
    X,
    {
      className: c(a.progressIndicatorWrapper, n == null ? void 0 : n.progressIndicatorWrapper),
      w: `${h}%`,
      justify: p ? void 0 : "right"
    },
    /* @__PURE__ */ g.createElement(oe, { pos: "relative", w: 6 }, /* @__PURE__ */ g.createElement(
      xe,
      {
        elementVariant: "important",
        elementSize: "xs",
        colorVariant: "brand.14",
        className: c(a.progressIndicatorValue, n == null ? void 0 : n.progressIndicatorValue),
        pos: "absolute",
        mod: {
          left: !y,
          right: y
        }
      },
      f
    ), /* @__PURE__ */ g.createElement(
      xe,
      {
        elementVariant: "important",
        elementSize: "xs",
        colorVariant: "brand.14",
        className: c(a.progressIndicatorPolygon, n == null ? void 0 : n.progressIndicatorPolygon)
      },
      /* @__PURE__ */ g.createElement(TC, null)
    ))
  ), /* @__PURE__ */ g.createElement(oe, { className: c(a.progressWrapper, n == null ? void 0 : n.progressWrapper), mt: 4 }, /* @__PURE__ */ g.createElement(oe, { className: c(a.progress, n == null ? void 0 : n.progress), w: `${h}%` })), r && /* @__PURE__ */ g.createElement(X, { className: c(a.pointsValueWrapper, n == null ? void 0 : n.pointsValueWrapper), gap: 0, mt: 8, justify: "space-between", align: "stretch" }, /* @__PURE__ */ g.createElement(xe, { elementVariant: "default", elementSize: "xs", align: "right", className: c(a.pointValue, n == null ? void 0 : n.pointValue) }, d), /* @__PURE__ */ g.createElement(xe, { elementVariant: "default", elementSize: "xs", align: "right", className: c(a.pointValue, n == null ? void 0 : n.pointValue) }, u === Number.POSITIVE_INFINITY ? "∞" : u))));
});
YA.displayName = "ProgressBar";
const Fp = m(32), nd = m(40), Np = m(12), ZA = O((t, { orientation: e }) => ({
  root: {},
  separator: {
    width: "100%",
    height: m(1),
    backgroundColor: t.other.colors.brand[6]
  },
  steps: {
    padding: `${t.other.spacings[12]} ${t.other.spacings[16]}`,
    backgroundColor: t.other.colors.greyIron[2],
    borderRadius: t.other.borderRadius[8],
    justifyContent: "space-between"
  },
  content: {
    padding: `${t.other.spacings[32]} 0`,
    paddingBottom: 0,
    font: t.other.fonts.desktop.s.s.default
  },
  step: e === "vertical" ? {
    "&:first-of-type": {
      marginTop: 0
    },
    marginTop: t.other.spacings[12],
    minHeight: `calc(${nd} + ${Fp} + ${Np})`
  } : {},
  stepLoader: {},
  verticalSeparator: {
    top: `calc(${nd} + ${Np})`,
    maxHeight: Fp,
    borderLeft: `${m(1)} solid ${t.other.colors.brand[6]}`
  },
  stepWrapper: {
    marginBottom: 0
  },
  stepIcon: {
    color: t.other.colors.greyIron[18],
    borderColor: t.other.colors.greyIron[6],
    font: t.other.fonts.desktop.s.m.important,
    backgroundColor: "transparent",
    '&[data-progress="true"]': {
      borderColor: t.other.colors.brand[6]
    },
    '&[data-completed="true"]': {
      backgroundColor: t.other.colors.brand[6],
      borderColor: t.other.colors.brand[6]
    }
  },
  stepCompletedIcon: {
    "& > svg": {
      color: t.other.colors.greyIron[18]
    }
  },
  stepBody: {
    margin: `0 0 0 ${t.other.spacings[12]}`,
    height: nd,
    justifyContent: "center"
  },
  stepLabel: {
    font: t.other.fonts.desktop.s.m.important,
    color: t.other.colors.greyIron[18]
  },
  stepDescription: {
    margin: `${t.other.spacings[4]} 0 0 0`,
    font: t.other.fonts.desktop.s.s.default,
    color: t.other.colors.greyIron[16]
  }
})), XA = "ProgressSteps.Step", sl = ge((t, e) => {
  const { styleProps: n, rest: r } = el(t), { children: o, classNames: i, className: s, iconSize: l, orientation: a, ...c } = he("ProgressSteps", {}, r), { classes: d, cx: u } = ZA({ orientation: a });
  return /* @__PURE__ */ g.createElement(
    tf,
    {
      ref: e,
      className: u(d.root, s),
      classNames: {
        separator: u(d.separator, i == null ? void 0 : i.separator),
        steps: u(d.steps, i == null ? void 0 : i.steps),
        content: u(d.content, i == null ? void 0 : i.content),
        step: u(d.step, i == null ? void 0 : i.step),
        stepLoader: u(d.stepLoader, i == null ? void 0 : i.stepLoader),
        verticalSeparator: u(d.verticalSeparator, i == null ? void 0 : i.verticalSeparator),
        stepWrapper: u(d.stepWrapper, i == null ? void 0 : i.stepWrapper),
        stepIcon: u(d.stepIcon, i == null ? void 0 : i.stepIcon),
        stepCompletedIcon: u(d.stepCompletedIcon, i == null ? void 0 : i.stepCompletedIcon),
        stepBody: u(d.stepBody, i == null ? void 0 : i.stepBody),
        stepLabel: u(d.stepLabel, i == null ? void 0 : i.stepLabel),
        stepDescription: u(d.stepDescription, i == null ? void 0 : i.stepDescription)
      },
      completedIcon: /* @__PURE__ */ g.createElement(oe, { component: Um, w: 24, h: 24 }),
      iconSize: l ?? 40,
      orientation: a,
      ...n,
      ...c
    },
    o
  );
});
sl.displayName = "ProgressSteps";
sl.Step = tf.Step;
sl.Step.displayName = XA;
sl.Completed = tf.Completed;
sl.Completed.displayName = "ProgressSteps.Completed";
const QA = '"focus-visible"', eL = O((t, { disabled: e }) => ({
  root: {
    alignItems: "self-start",
    position: "relative",
    "& *": {
      cursor: "pointer"
    },
    "&:hover": {
      [`.${ly}`]: e ? {} : {
        border: `${m(1)} solid ${t.other.colors.brand[13]}`
      }
    }
  },
  rootDisabled: {
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      cursor: "not-allowed"
    }
  },
  labelWrapper: {
    display: "flex",
    flexDirection: "column"
  },
  label: {
    width: "100%",
    font: t.other.fonts.desktop.s.s.important,
    color: t.other.colors.greyIron[20]
  },
  labelExtraImportant: {
    font: t.other.fonts.desktop.s.s.extraImportant
  },
  description: {
    font: t.other.fonts.desktop.s.s.default,
    color: t.other.colors.greyIron[14]
  },
  labelDescriptionDisabled: {
    color: t.other.colors.greyIron[9],
    "& a": {
      color: t.other.colors.greyIron[9]
    },
    [`& .${ay}`]: {
      color: t.other.colors.greyIron[9]
    }
  },
  radio: {
    position: "relative",
    display: "block",
    backgroundColor: t.other.colors.white[0],
    borderColor: t.other.colors.greyIron[7],
    transition: Ae(["border-color", "background-color"]),
    "&:focus:not(:focus-visible)": {
      outline: "none",
      boxShadow: "none"
    },
    "&:focus": {
      boxShadow: `0 0 0 ${m(4)} ${t.other.colors.brand[3]}`,
      outline: "none",
      borderColor: t.other.colors.brand[13]
    },
    "&:focus-visible": {
      content: `${QA}`
    },
    "&:checked": {
      backgroundColor: t.other.colors.brand[2],
      borderColor: t.other.colors.brand[13]
    },
    "&:disabled": {
      backgroundColor: t.other.colors.greyIron[2],
      borderColor: t.other.colors.greyIron[6]
    }
  },
  radioActive: {
    "&:active": {
      background: t.other.colors.brand[1],
      border: `${m(1)} solid ${t.other.colors.brand[13]}`
    },
    "&:checked": {
      "&:active": {
        background: t.other.colors.brand[3]
      }
    }
  },
  icon: {
    width: m(8),
    height: m(8),
    top: m(6),
    left: m(6),
    color: t.other.colors.brand[13]
  },
  body: void 0,
  bodyDisabled: {
    color: t.other.colors.greyIron[6]
  },
  inner: {},
  error: {}
})), zb = ge((t, e) => {
  const { label: n, description: r, disabled: o, classNames: i, unstyled: s, className: l, ...a } = t, { classes: c, cx: d } = eL({ disabled: o });
  return /* @__PURE__ */ g.createElement(
    oa,
    {
      ref: e,
      className: l,
      unstyled: s,
      classNames: {
        ...c,
        root: d(c.root, i == null ? void 0 : i.root, {
          [d(c.rootDisabled, i == null ? void 0 : i.rootDisabled)]: o
        }),
        label: d(c.label, i == null ? void 0 : i.label, {
          [c.labelExtraImportant]: !r,
          [c.labelDescriptionDisabled]: o
        }),
        radio: d(c.radio, i == null ? void 0 : i.radio, {
          [c.radioActive]: !o
        }),
        body: d(c.body, i == null ? void 0 : i.body, { [c.bodyDisabled]: o }),
        inner: d(c.inner, i == null ? void 0 : i.inner),
        labelWrapper: d(c.labelWrapper, i == null ? void 0 : i.labelWrapper),
        description: d(c.description, i == null ? void 0 : i.description),
        error: d(c.error, i == null ? void 0 : i.error),
        icon: d(c.icon, i == null ? void 0 : i.icon)
      },
      label: /* @__PURE__ */ g.createElement("div", { "data-testid": "radio-label", className: d(c.labelWrapper, i == null ? void 0 : i.labelWrapper), onFocus: () => {
      } }, /* @__PURE__ */ g.createElement("span", null, n), /* @__PURE__ */ g.createElement("span", { className: d(c.description, i == null ? void 0 : i.description) }, r)),
      disabled: o,
      ...a
    }
  );
});
zb.displayName = "Radio";
const Hb = qo({
  currentValue: "",
  onValueChange: () => {
    throw new Error("Not implemented onChange method");
  }
}), tL = Hb.Provider, nL = () => Pi(Hb), jb = '"focus-visible"', rL = O((t, { disabled: e }) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `${m(1)} solid ${t.other.colors.greyIron[4]}`,
    backgroundColor: t.other.colors.white[0],
    color: t.other.colors.greyIron[18],
    font: t.other.fonts.desktop.s.s.buttons,
    cursor: "pointer",
    transition: Ae(["border-color", "background-color"]),
    ...!e && {
      "&:hover": {
        backgroundColor: t.other.colors.greyIron[2],
        borderColor: t.other.colors.greyIron[2]
      },
      "&:active": {
        backgroundColor: t.other.colors.brand[8],
        borderColor: t.other.colors.brand[8]
      }
    },
    ...e && {
      backgroundColor: "transparent",
      color: t.other.colors.greyIron[9],
      cursor: "default"
    }
  },
  rootChecked: {
    backgroundColor: t.other.colors.brand[5],
    color: t.other.colors.brand[20],
    "&:hover": {
      backgroundColor: t.other.colors.brand[5],
      borderColor: t.other.colors.greyIron[4],
      cursor: "default"
    },
    "&:active": {
      backgroundColor: t.other.colors.brand[8]
    }
  },
  labelChecked: {
    "&:hover": {
      cursor: "default"
    }
  },
  focusVisible: {
    boxShadow: `0 0 0 ${m(4)} ${t.other.colors.greyIron[4]}`
  },
  focusVisibleActive: {
    boxShadow: `0 0 0 ${m(4)} ${t.other.colors.brand[3]}`
  },
  label: {
    width: "max-content",
    padding: `${m(9)} ${m(15)}`,
    cursor: "pointer",
    ...e && {
      cursor: "default"
    }
  },
  radio: {
    width: 0,
    height: 0,
    opacity: 0,
    "&:focus-visible": {
      content: `${jb}`
    }
  }
})), Wb = ge(
  ({ disabled: t, label: e, classNames: n, className: r, ...o }, i) => {
    const s = Nt(null), [l, a] = ie(!1), { classes: c, cx: d } = rL({ disabled: t }), u = nL(), f = u ? {
      checked: u.currentValue === o.value,
      onChange: u.onValueChange
    } : {};
    return It(() => {
      if (!s.current)
        return;
      const h = s.current, p = () => {
        getComputedStyle(h, ":focus-visible").content === jb ? a(!0) : a(!1);
      }, y = () => {
        a(!1);
      };
      return h == null || h.addEventListener("focus", p), h == null || h.addEventListener("blur", y), () => {
        h == null || h.removeEventListener("focus", p), h == null || h.removeEventListener("blur", y);
      };
    }, [s]), /* @__PURE__ */ g.createElement(
      oe,
      {
        className: d(
          c.root,
          n == null ? void 0 : n.root,
          ia,
          {
            [d(c.focusVisible, n == null ? void 0 : n.focusVisible)]: l,
            [d(c.rootChecked, n == null ? void 0 : n.rootChecked)]: f.checked,
            [d(c.focusVisibleActive, n == null ? void 0 : n.focusVisibleActive)]: f.checked && l
          },
          r
        ),
        "data-checked": f.checked || void 0
      },
      /* @__PURE__ */ g.createElement(
        "label",
        {
          className: d(c.label, n == null ? void 0 : n.label, { [c.labelChecked]: f.checked }),
          "data-disabled": t || void 0
        },
        e,
        /* @__PURE__ */ g.createElement(
          oe,
          {
            component: "input",
            ref: Tb([s, i]),
            className: d(c.radio, n == null ? void 0 : n.radio),
            type: "radio",
            disabled: t,
            ...o,
            ...f
          }
        )
      )
    );
  }
);
Wb.displayName = "RadioButton";
const oL = O((t, { disabled: e }) => ({
  root: {
    position: "relative",
    padding: `${t.other.spacings[20]} ${t.other.spacings[24]}`,
    backgroundColor: t.other.colors.white[0],
    border: `${m(1)} solid ${t.other.colors.greyIron[7]}`,
    borderRadius: t.other.borderRadius[8],
    transition: Ae(["border-color", "background-color"]),
    "&:focus-visible": {
      boxShadow: `0 0 0 ${m(4)} ${t.other.colors.brand[3]}`,
      borderColor: t.other.colors.brand[13],
      outline: "none",
      [`& div.${cy}`]: {
        boxShadow: `0 0 0 ${m(4)} ${t.other.colors.brand[3]}`,
        borderColor: t.other.colors.brand[13]
      }
    },
    ...e ? {} : {
      "&:hover": {
        borderColor: t.other.colors.brand[8]
      },
      "&:active": {
        backgroundColor: t.other.colors.brand[0],
        borderColor: t.other.colors.brand[8]
      }
    }
  },
  rootDisabled: {
    borderColor: t.other.colors.greyIron[7],
    cursor: "not-allowed"
  },
  rootChecked: {
    backgroundColor: t.other.colors.brand[0],
    borderColor: t.other.colors.brand[10],
    "&:hover": {
      backgroundColor: t.other.colors.brand[1]
    },
    "&:active": {
      backgroundColor: t.other.colors.brand[2]
    }
  },
  label: {},
  description: {},
  labelDescriptionDisabled: {
    color: t.other.colors.greyIron[9]
  },
  indicator: {
    position: "relative",
    backgroundColor: t.other.colors.white[0],
    borderColor: t.other.colors.greyIron[7],
    transition: Ae(["border-color", "background-color"]),
    cursor: "pointer",
    "&[data-checked], &[data-indeterminate]": {
      backgroundColor: t.other.colors.brand[2],
      borderColor: t.other.colors.brand[13],
      "& > svg": {
        color: `${t.other.colors.brand[13]} !important`
      }
    }
  },
  indicatorDisabled: {
    backgroundColor: t.other.colors.greyIron[2],
    borderColor: t.other.colors.greyIron[6],
    cursor: "not-allowed",
    "&[data-checked], &[data-indeterminate]": {
      backgroundColor: t.other.colors.greyIron[2],
      borderColor: t.other.colors.greyIron[6],
      "& > svg": {
        color: `${t.other.colors.greyIron[6]} !important`
      }
    }
  }
})), iL = {
  showIndicator: !0
}, Gb = ge((t, e) => {
  const { disabled: n, classNames: r, selectedValue: o, value: i, label: s, description: l, children: a, showIndicator: c, ...d } = he(
    "RadioGreen",
    iL,
    t
  ), { classes: u, cx: f } = oL({ disabled: n }), h = {
    root: f(u.root, r == null ? void 0 : r.root),
    rootDisabled: f(u.rootDisabled, r == null ? void 0 : r.rootDisabled)
  };
  return /* @__PURE__ */ g.createElement(
    oa.Card,
    {
      value: i,
      classNames: {
        card: f(h.root, {
          [h.rootDisabled || ""]: n,
          [u.rootChecked]: o === i && !n
        })
      },
      ref: e,
      disabled: n,
      ...d
    },
    /* @__PURE__ */ g.createElement(Ee, { gap: 12 }, /* @__PURE__ */ g.createElement(X, { wrap: "nowrap", align: "flex-start", gap: 12 }, c && /* @__PURE__ */ g.createElement(
      oa.Indicator,
      {
        mt: 2,
        classNames: {
          indicator: f(u.indicator, r == null ? void 0 : r.indicator, { [f(u.indicatorDisabled, r == null ? void 0 : r.indicatorDisabled)]: n })
        }
      }
    ), /* @__PURE__ */ g.createElement(Ee, { gap: 4 }, s && /* @__PURE__ */ g.createElement(
      xe,
      {
        elementSize: "m",
        elementVariant: "header",
        colorVariant: "greyIron.18",
        className: f(u.label, r == null ? void 0 : r.label, {
          [f(u.labelDescriptionDisabled, r == null ? void 0 : r.labelDescriptionDisabled)]: n
        })
      },
      s
    ), l && /* @__PURE__ */ g.createElement(
      xe,
      {
        elementSize: "s",
        elementVariant: "default",
        colorVariant: "greyIron.16",
        className: f(u.description, r == null ? void 0 : r.description, {
          [f(u.labelDescriptionDisabled, r == null ? void 0 : r.labelDescriptionDisabled)]: n
        })
      },
      l
    ))), a)
  );
});
Gb.displayName = "RadioGreenLocal";
const Ub = lc(Gb);
Ub.displayName = "RadioGreen";
const sL = O(
  (t, { orientation: e, groupType: n }) => ({
    root: {
      '&>div[role="radiogroup"]': {
        gap: n === "buttons" ? 0 : m(16),
        display: "flex",
        flexDirection: e === "vertical" ? "column" : "row",
        "& > div": {
          alignItems: "flex-start",
          ...n === "buttons" ? { gap: 0 } : {},
          ...e === "vertical" && n === "buttons" ? {
            flexDirection: "column",
            flexGrow: 0
          } : {}
        },
        ...e === "vertical" && n === "buttons" && {
          [`& .${ia}`]: {
            width: "100%",
            "&:not(:first-of-type)": {
              borderTopWidth: m(0.5)
            },
            "&:not(:last-of-type)": {
              borderBottomWidth: m(0.5)
            },
            "&:first-of-type": {
              borderTopLeftRadius: t.other.borderRadius[8],
              borderTopRightRadius: t.other.borderRadius[8]
            },
            "&:last-of-type": {
              borderBottomRightRadius: t.other.borderRadius[8],
              borderBottomLeftRadius: t.other.borderRadius[8]
            }
          }
        },
        ...e === "horizontal" && n === "buttons" && {
          [`& .${ia}`]: {
            "&:not(:first-of-type)": {
              borderLeftWidth: m(0.5)
            },
            "&:not(:last-of-type)": {
              borderRightWidth: m(0.5)
            },
            "&:first-of-type": {
              borderTopLeftRadius: t.other.borderRadius[8],
              borderBottomLeftRadius: t.other.borderRadius[8]
            },
            "&:last-of-type": {
              borderTopRightRadius: t.other.borderRadius[8],
              borderBottomRightRadius: t.other.borderRadius[8]
            }
          }
        }
      }
    },
    label: {
      marginBottom: m(20),
      font: t.other.fonts.desktop.s.s.label
    },
    error: {
      marginTop: t.other.spacings[8],
      color: t.other.colors.raspberry[11],
      font: t.other.fonts.desktop.s.s.default
    },
    required: {}
  })
), lL = {
  orientation: "vertical"
}, qb = ge((t, e) => {
  const { children: n, classNames: r, value: o, defaultValue: i, orientation: s, groupType: l, onChange: a, errorProps: c, ...d } = he(
    "RadioGroup",
    lL,
    t
  ), { classes: u, cx: f } = sL({ orientation: s, groupType: l }), {
    classes: { required: h }
  } = sr({ elementSize: mt.M }), [p, y] = an({
    value: o,
    defaultValue: i,
    finalValue: "",
    onChange: a
  }), b = (w) => y(w.currentTarget.value);
  return /* @__PURE__ */ g.createElement(tL, { value: { currentValue: p, onValueChange: b } }, /* @__PURE__ */ g.createElement(
    oa.Group,
    {
      ref: e,
      classNames: {
        ...u,
        ...r,
        root: f(u.root, r == null ? void 0 : r.root),
        required: f(h, r == null ? void 0 : r.required)
      },
      errorProps: {
        ...c,
        "data-testid": "radio-field-error"
      },
      onChange: a,
      value: o,
      defaultValue: i,
      ...d
    },
    n
  ));
});
qb.displayName = "RadioGroup";
const Af = zb;
Af.Group = qb;
Af.Green = Ub;
Af.Button = Wb;
function Yt(t) {
  this.content = t;
}
Yt.prototype = {
  constructor: Yt,
  find: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === t) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(t) {
    var e = this.find(t);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(t, e, n) {
    var r = n && n != t ? this.remove(n) : this, o = r.find(t), i = r.content.slice();
    return o == -1 ? i.push(n || t, e) : (i[o + 1] = e, n && (i[o] = n)), new Yt(i);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(t) {
    var e = this.find(t);
    if (e == -1) return this;
    var n = this.content.slice();
    return n.splice(e, 2), new Yt(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(t, e) {
    return new Yt([t, e].concat(this.remove(t).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(t, e) {
    var n = this.remove(t).content.slice();
    return n.push(t, e), new Yt(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(t, e, n) {
    var r = this.remove(e), o = r.content.slice(), i = r.find(t);
    return o.splice(i == -1 ? o.length : i, 0, e, n), new Yt(o);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      t(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(t) {
    return t = Yt.from(t), t.size ? new Yt(t.content.concat(this.subtract(t).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(t) {
    return t = Yt.from(t), t.size ? new Yt(this.subtract(t).content.concat(t.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(t) {
    var e = this;
    t = Yt.from(t);
    for (var n = 0; n < t.content.length; n += 2)
      e = e.remove(t.content[n]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var t = {};
    return this.forEach(function(e, n) {
      t[e] = n;
    }), t;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Yt.from = function(t) {
  if (t instanceof Yt) return t;
  var e = [];
  if (t) for (var n in t) e.push(n, t[n]);
  return new Yt(e);
};
function Jb(t, e, n) {
  for (let r = 0; ; r++) {
    if (r == t.childCount || r == e.childCount)
      return t.childCount == e.childCount ? null : n;
    let o = t.child(r), i = e.child(r);
    if (o == i) {
      n += o.nodeSize;
      continue;
    }
    if (!o.sameMarkup(i))
      return n;
    if (o.isText && o.text != i.text) {
      for (let s = 0; o.text[s] == i.text[s]; s++)
        n++;
      return n;
    }
    if (o.content.size || i.content.size) {
      let s = Jb(o.content, i.content, n + 1);
      if (s != null)
        return s;
    }
    n += o.nodeSize;
  }
}
function Kb(t, e, n, r) {
  for (let o = t.childCount, i = e.childCount; ; ) {
    if (o == 0 || i == 0)
      return o == i ? null : { a: n, b: r };
    let s = t.child(--o), l = e.child(--i), a = s.nodeSize;
    if (s == l) {
      n -= a, r -= a;
      continue;
    }
    if (!s.sameMarkup(l))
      return { a: n, b: r };
    if (s.isText && s.text != l.text) {
      let c = 0, d = Math.min(s.text.length, l.text.length);
      for (; c < d && s.text[s.text.length - c - 1] == l.text[l.text.length - c - 1]; )
        c++, n--, r--;
      return { a: n, b: r };
    }
    if (s.content.size || l.content.size) {
      let c = Kb(s.content, l.content, n - 1, r - 1);
      if (c)
        return c;
    }
    n -= a, r -= a;
  }
}
class D {
  /**
  @internal
  */
  constructor(e, n) {
    if (this.content = e, this.size = n || 0, n == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, n, r, o = 0, i) {
    for (let s = 0, l = 0; l < n; s++) {
      let a = this.content[s], c = l + a.nodeSize;
      if (c > e && r(a, o + l, i || null, s) !== !1 && a.content.size) {
        let d = l + 1;
        a.nodesBetween(Math.max(0, e - d), Math.min(a.content.size, n - d), r, o + d);
      }
      l = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, n, r, o) {
    let i = "", s = !0;
    return this.nodesBetween(e, n, (l, a) => {
      let c = l.isText ? l.text.slice(Math.max(e, a) - a, n - a) : l.isLeaf ? o ? typeof o == "function" ? o(l) : o : l.type.spec.leafText ? l.type.spec.leafText(l) : "" : "";
      l.isBlock && (l.isLeaf && c || l.isTextblock) && r && (s ? s = !1 : i += r), i += c;
    }, 0), i;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let n = this.lastChild, r = e.firstChild, o = this.content.slice(), i = 0;
    for (n.isText && n.sameMarkup(r) && (o[o.length - 1] = n.withText(n.text + r.text), i = 1); i < e.content.length; i++)
      o.push(e.content[i]);
    return new D(o, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, n = this.size) {
    if (e == 0 && n == this.size)
      return this;
    let r = [], o = 0;
    if (n > e)
      for (let i = 0, s = 0; s < n; i++) {
        let l = this.content[i], a = s + l.nodeSize;
        a > e && ((s < e || a > n) && (l.isText ? l = l.cut(Math.max(0, e - s), Math.min(l.text.length, n - s)) : l = l.cut(Math.max(0, e - s - 1), Math.min(l.content.size, n - s - 1))), r.push(l), o += l.nodeSize), s = a;
      }
    return new D(r, o);
  }
  /**
  @internal
  */
  cutByIndex(e, n) {
    return e == n ? D.empty : e == 0 && n == this.content.length ? this : new D(this.content.slice(e, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, n) {
    let r = this.content[e];
    if (r == n)
      return this;
    let o = this.content.slice(), i = this.size + n.nodeSize - r.nodeSize;
    return o[e] = n, new D(o, i);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new D([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new D(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(e.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let n = this.content[e];
    if (!n)
      throw new RangeError("Index " + e + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let o = this.content[n];
      e(o, r, n), r += o.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, n = 0) {
    return Jb(this, e, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, n = this.size, r = e.size) {
    return Kb(this, e, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, n = -1) {
    if (e == 0)
      return vl(0, e);
    if (e == this.size)
      return vl(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let r = 0, o = 0; ; r++) {
      let i = this.child(r), s = o + i.nodeSize;
      if (s >= e)
        return s == e || n > 0 ? vl(r + 1, s) : vl(r, o);
      o = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return D.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new D(n.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return D.empty;
    let n, r = 0;
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      r += i.nodeSize, o && i.isText && e[o - 1].sameMarkup(i) ? (n || (n = e.slice(0, o)), n[n.length - 1] = i.withText(n[n.length - 1].text + i.text)) : n && n.push(i);
    }
    return new D(n || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return D.empty;
    if (e instanceof D)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new D([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
D.empty = new D([], 0);
const rd = { index: 0, offset: 0 };
function vl(t, e) {
  return rd.index = t, rd.offset = e, rd;
}
function ba(t, e) {
  if (t === e)
    return !0;
  if (!(t && typeof t == "object") || !(e && typeof e == "object"))
    return !1;
  let n = Array.isArray(t);
  if (Array.isArray(e) != n)
    return !1;
  if (n) {
    if (t.length != e.length)
      return !1;
    for (let r = 0; r < t.length; r++)
      if (!ba(t[r], e[r]))
        return !1;
  } else {
    for (let r in t)
      if (!(r in e) || !ba(t[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in t))
        return !1;
  }
  return !0;
}
let it = class fu {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let n, r = !1;
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      if (this.eq(i))
        return e;
      if (this.type.excludes(i.type))
        n || (n = e.slice(0, o));
      else {
        if (i.type.excludes(this.type))
          return e;
        !r && i.type.rank > this.type.rank && (n || (n = e.slice(0, o)), n.push(this), r = !0), n && n.push(i);
      }
    }
    return n || (n = e.slice()), r || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return e.slice(0, n).concat(e.slice(n + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && ba(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[n.type];
    if (!r)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    let o = r.create(n.attrs);
    return r.checkAttrs(o.attrs), o;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, n) {
    if (e == n)
      return !0;
    if (e.length != n.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(n[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return fu.none;
    if (e instanceof fu)
      return [e];
    let n = e.slice();
    return n.sort((r, o) => r.type.rank - o.type.rank), n;
  }
};
it.none = [];
class wa extends Error {
}
class N {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, n, r) {
    this.content = e, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, n) {
    let r = Zb(this.content, e + this.openStart, n);
    return r && new N(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, n) {
    return new N(Yb(this.content, e + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return N.empty;
    let r = n.openStart || 0, o = n.openEnd || 0;
    if (typeof r != "number" || typeof o != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new N(D.fromJSON(e, n.content), r, o);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, n = !0) {
    let r = 0, o = 0;
    for (let i = e.firstChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.firstChild)
      r++;
    for (let i = e.lastChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.lastChild)
      o++;
    return new N(e, r, o);
  }
}
N.empty = new N(D.empty, 0, 0);
function Yb(t, e, n) {
  let { index: r, offset: o } = t.findIndex(e), i = t.maybeChild(r), { index: s, offset: l } = t.findIndex(n);
  if (o == e || i.isText) {
    if (l != n && !t.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return t.cut(0, e).append(t.cut(n));
  }
  if (r != s)
    throw new RangeError("Removing non-flat range");
  return t.replaceChild(r, i.copy(Yb(i.content, e - o - 1, n - o - 1)));
}
function Zb(t, e, n, r) {
  let { index: o, offset: i } = t.findIndex(e), s = t.maybeChild(o);
  if (i == e || s.isText)
    return t.cut(0, e).append(n).append(t.cut(e));
  let l = Zb(s.content, e - i - 1, n);
  return l && t.replaceChild(o, s.copy(l));
}
function aL(t, e, n) {
  if (n.openStart > t.depth)
    throw new wa("Inserted content deeper than insertion position");
  if (t.depth - n.openStart != e.depth - n.openEnd)
    throw new wa("Inconsistent open depths");
  return Xb(t, e, n, 0);
}
function Xb(t, e, n, r) {
  let o = t.index(r), i = t.node(r);
  if (o == e.index(r) && r < t.depth - n.openStart) {
    let s = Xb(t, e, n, r + 1);
    return i.copy(i.content.replaceChild(o, s));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && t.depth == r && e.depth == r) {
      let s = t.parent, l = s.content;
      return _o(s, l.cut(0, t.parentOffset).append(n.content).append(l.cut(e.parentOffset)));
    } else {
      let { start: s, end: l } = cL(n, t);
      return _o(i, e1(t, s, l, e, r));
    }
  else return _o(i, Sa(t, e, r));
}
function Qb(t, e) {
  if (!e.type.compatibleContent(t.type))
    throw new wa("Cannot join " + e.type.name + " onto " + t.type.name);
}
function hu(t, e, n) {
  let r = t.node(n);
  return Qb(r, e.node(n)), r;
}
function Po(t, e) {
  let n = e.length - 1;
  n >= 0 && t.isText && t.sameMarkup(e[n]) ? e[n] = t.withText(e[n].text + t.text) : e.push(t);
}
function Cs(t, e, n, r) {
  let o = (e || t).node(n), i = 0, s = e ? e.index(n) : o.childCount;
  t && (i = t.index(n), t.depth > n ? i++ : t.textOffset && (Po(t.nodeAfter, r), i++));
  for (let l = i; l < s; l++)
    Po(o.child(l), r);
  e && e.depth == n && e.textOffset && Po(e.nodeBefore, r);
}
function _o(t, e) {
  return t.type.checkContent(e), t.copy(e);
}
function e1(t, e, n, r, o) {
  let i = t.depth > o && hu(t, e, o + 1), s = r.depth > o && hu(n, r, o + 1), l = [];
  return Cs(null, t, o, l), i && s && e.index(o) == n.index(o) ? (Qb(i, s), Po(_o(i, e1(t, e, n, r, o + 1)), l)) : (i && Po(_o(i, Sa(t, e, o + 1)), l), Cs(e, n, o, l), s && Po(_o(s, Sa(n, r, o + 1)), l)), Cs(r, null, o, l), new D(l);
}
function Sa(t, e, n) {
  let r = [];
  if (Cs(null, t, n, r), t.depth > n) {
    let o = hu(t, e, n + 1);
    Po(_o(o, Sa(t, e, n + 1)), r);
  }
  return Cs(e, null, n, r), new D(r);
}
function cL(t, e) {
  let n = e.depth - t.openStart, o = e.node(n).copy(t.content);
  for (let i = n - 1; i >= 0; i--)
    o = e.node(i).copy(D.from(o));
  return {
    start: o.resolveNoCache(t.openStart + n),
    end: o.resolveNoCache(o.content.size - t.openEnd - n)
  };
}
class Fs {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.path = n, this.parentOffset = r, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, n = this.index(this.depth);
    if (n == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], o = e.child(n);
    return r ? e.child(n).cut(r) : o;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(e).cut(0, n) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, n) {
    n = this.resolveDepth(n);
    let r = this.path[n * 3], o = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let i = 0; i < e; i++)
      o += r.child(i).nodeSize;
    return o;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, n = this.index();
    if (e.content.size == 0)
      return it.none;
    if (this.textOffset)
      return e.child(n).marks;
    let r = e.maybeChild(n - 1), o = e.maybeChild(n);
    if (!r) {
      let l = r;
      r = o, o = l;
    }
    let i = r.marks;
    for (var s = 0; s < i.length; s++)
      i[s].type.spec.inclusive === !1 && (!o || !i[s].isInSet(o.marks)) && (i = i[s--].removeFromSet(i));
    return i;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let r = n.marks, o = e.parent.maybeChild(e.index());
    for (var i = 0; i < r.length; i++)
      r[i].type.spec.inclusive === !1 && (!o || !r[i].isInSet(o.marks)) && (r = r[i--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= e && this.end(n) >= e)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, n) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!n || n(this.node(r))))
        return new Ca(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 1; n <= this.depth; n++)
      e += (e ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, n) {
    if (!(n >= 0 && n <= e.content.size))
      throw new RangeError("Position " + n + " out of range");
    let r = [], o = 0, i = n;
    for (let s = e; ; ) {
      let { index: l, offset: a } = s.content.findIndex(i), c = i - a;
      if (r.push(s, l, o + a), !c || (s = s.child(l), s.isText))
        break;
      i = c - 1, o += a + 1;
    }
    return new Fs(n, r, i);
  }
  /**
  @internal
  */
  static resolveCached(e, n) {
    let r = zp.get(e);
    if (r)
      for (let i = 0; i < r.elts.length; i++) {
        let s = r.elts[i];
        if (s.pos == n)
          return s;
      }
    else
      zp.set(e, r = new dL());
    let o = r.elts[r.i] = Fs.resolve(e, n);
    return r.i = (r.i + 1) % uL, o;
  }
}
class dL {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const uL = 12, zp = /* @__PURE__ */ new WeakMap();
class Ca {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const fL = /* @__PURE__ */ Object.create(null);
let uo = class pu {
  /**
  @internal
  */
  constructor(e, n, r, o = it.none) {
    this.type = e, this.attrs = n, this.marks = o, this.content = r || D.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, n, r, o = 0) {
    this.content.nodesBetween(e, n, r, o, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, n, r, o) {
    return this.content.textBetween(e, n, r, o);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, n, r) {
    return this.type == e && ba(this.attrs, n || e.defaultAttrs || fL) && it.sameSet(this.marks, r || it.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new pu(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new pu(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, n = this.content.size) {
    return e == 0 && n == this.content.size ? this : this.copy(this.content.cut(e, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, n = this.content.size, r = !1) {
    if (e == n)
      return N.empty;
    let o = this.resolve(e), i = this.resolve(n), s = r ? 0 : o.sharedDepth(n), l = o.start(s), c = o.node(s).content.cut(o.pos - l, i.pos - l);
    return new N(c, o.depth - s, i.depth - s);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, n, r) {
    return aL(this.resolve(e), this.resolve(n), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let n = this; ; ) {
      let { index: r, offset: o } = n.content.findIndex(e);
      if (n = n.maybeChild(r), !n)
        return null;
      if (o == e || n.isText)
        return n;
      e -= o + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: n, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(n), index: n, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(n), index: n, offset: r };
    let o = this.content.child(n - 1);
    return { node: o, index: n - 1, offset: r - o.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return Fs.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return Fs.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, n, r) {
    let o = !1;
    return n > e && this.nodesBetween(e, n, (i) => (r.isInSet(i.marks) && (o = !0), !o)), o;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), t1(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, n, r = D.empty, o = 0, i = r.childCount) {
    let s = this.contentMatchAt(e).matchFragment(r, o, i), l = s && s.matchFragment(this.content, n);
    if (!l || !l.validEnd)
      return !1;
    for (let a = o; a < i; a++)
      if (!this.type.allowsMarks(r.child(a).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, n, r, o) {
    if (o && !this.type.allowsMarks(o))
      return !1;
    let i = this.contentMatchAt(e).matchType(r), s = i && i.matchFragment(this.content, n);
    return s ? s.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = it.none;
    for (let n = 0; n < this.marks.length; n++) {
      let r = this.marks[n];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!it.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((n) => n.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = n.marks.map(e.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(n.text, r);
    }
    let o = D.fromJSON(e, n.content), i = e.nodeType(n.type).create(n.attrs, o, r);
    return i.type.checkAttrs(i.attrs), i;
  }
};
uo.prototype.text = void 0;
class va extends uo {
  /**
  @internal
  */
  constructor(e, n, r, o) {
    if (super(e, n, null, o), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : t1(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, n) {
    return this.text.slice(e, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new va(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new va(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, n = this.text.length) {
    return e == 0 && n == this.text.length ? this : this.withText(this.text.slice(e, n));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function t1(t, e) {
  for (let n = t.length - 1; n >= 0; n--)
    e = t[n].type.name + "(" + e + ")";
  return e;
}
class Ho {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, n) {
    let r = new hL(e, n);
    if (r.next == null)
      return Ho.empty;
    let o = n1(r);
    r.next && r.err("Unexpected trailing text");
    let i = SL(wL(o));
    return CL(i, r), i;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == e)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, n = 0, r = e.childCount) {
    let o = this;
    for (let i = n; o && i < r; i++)
      o = o.matchType(e.child(i).type);
    return o;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: n } = this.next[e];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let n = 0; n < this.next.length; n++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[n].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, n = !1, r = 0) {
    let o = [this];
    function i(s, l) {
      let a = s.matchFragment(e, r);
      if (a && (!n || a.validEnd))
        return D.from(l.map((c) => c.createAndFill()));
      for (let c = 0; c < s.next.length; c++) {
        let { type: d, next: u } = s.next[c];
        if (!(d.isText || d.hasRequiredAttrs()) && o.indexOf(u) == -1) {
          o.push(u);
          let f = i(u, l.concat(d));
          if (f)
            return f;
        }
      }
      return null;
    }
    return i(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let n = this.computeWrapping(e);
    return this.wrapCache.push(e, n), n;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let o = r.shift(), i = o.match;
      if (i.matchType(e)) {
        let s = [];
        for (let l = o; l.type; l = l.via)
          s.push(l.type);
        return s.reverse();
      }
      for (let s = 0; s < i.next.length; s++) {
        let { type: l, next: a } = i.next[s];
        !l.isLeaf && !l.hasRequiredAttrs() && !(l.name in n) && (!o.type || a.validEnd) && (r.push({ match: l.contentMatch, type: l, via: o }), n[l.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function n(r) {
      e.push(r);
      for (let o = 0; o < r.next.length; o++)
        e.indexOf(r.next[o].next) == -1 && n(r.next[o].next);
    }
    return n(this), e.map((r, o) => {
      let i = o + (r.validEnd ? "*" : " ") + " ";
      for (let s = 0; s < r.next.length; s++)
        i += (s ? ", " : "") + r.next[s].type.name + "->" + e.indexOf(r.next[s].next);
      return i;
    }).join(`
`);
  }
}
Ho.empty = new Ho(!0);
class hL {
  constructor(e, n) {
    this.string = e, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function n1(t) {
  let e = [];
  do
    e.push(pL(t));
  while (t.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function pL(t) {
  let e = [];
  do
    e.push(gL(t));
  while (t.next && t.next != ")" && t.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function gL(t) {
  let e = bL(t);
  for (; ; )
    if (t.eat("+"))
      e = { type: "plus", expr: e };
    else if (t.eat("*"))
      e = { type: "star", expr: e };
    else if (t.eat("?"))
      e = { type: "opt", expr: e };
    else if (t.eat("{"))
      e = mL(t, e);
    else
      break;
  return e;
}
function Hp(t) {
  /\D/.test(t.next) && t.err("Expected number, got '" + t.next + "'");
  let e = Number(t.next);
  return t.pos++, e;
}
function mL(t, e) {
  let n = Hp(t), r = n;
  return t.eat(",") && (t.next != "}" ? r = Hp(t) : r = -1), t.eat("}") || t.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: e };
}
function yL(t, e) {
  let n = t.nodeTypes, r = n[e];
  if (r)
    return [r];
  let o = [];
  for (let i in n) {
    let s = n[i];
    s.isInGroup(e) && o.push(s);
  }
  return o.length == 0 && t.err("No node type or group '" + e + "' found"), o;
}
function bL(t) {
  if (t.eat("(")) {
    let e = n1(t);
    return t.eat(")") || t.err("Missing closing paren"), e;
  } else if (/\W/.test(t.next))
    t.err("Unexpected token '" + t.next + "'");
  else {
    let e = yL(t, t.next).map((n) => (t.inline == null ? t.inline = n.isInline : t.inline != n.isInline && t.err("Mixing inline and block content"), { type: "name", value: n }));
    return t.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function wL(t) {
  let e = [[]];
  return o(i(t, 0), n()), e;
  function n() {
    return e.push([]) - 1;
  }
  function r(s, l, a) {
    let c = { term: a, to: l };
    return e[s].push(c), c;
  }
  function o(s, l) {
    s.forEach((a) => a.to = l);
  }
  function i(s, l) {
    if (s.type == "choice")
      return s.exprs.reduce((a, c) => a.concat(i(c, l)), []);
    if (s.type == "seq")
      for (let a = 0; ; a++) {
        let c = i(s.exprs[a], l);
        if (a == s.exprs.length - 1)
          return c;
        o(c, l = n());
      }
    else if (s.type == "star") {
      let a = n();
      return r(l, a), o(i(s.expr, a), a), [r(a)];
    } else if (s.type == "plus") {
      let a = n();
      return o(i(s.expr, l), a), o(i(s.expr, a), a), [r(a)];
    } else {
      if (s.type == "opt")
        return [r(l)].concat(i(s.expr, l));
      if (s.type == "range") {
        let a = l;
        for (let c = 0; c < s.min; c++) {
          let d = n();
          o(i(s.expr, a), d), a = d;
        }
        if (s.max == -1)
          o(i(s.expr, a), a);
        else
          for (let c = s.min; c < s.max; c++) {
            let d = n();
            r(a, d), o(i(s.expr, a), d), a = d;
          }
        return [r(a)];
      } else {
        if (s.type == "name")
          return [r(l, void 0, s.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function r1(t, e) {
  return e - t;
}
function jp(t, e) {
  let n = [];
  return r(e), n.sort(r1);
  function r(o) {
    let i = t[o];
    if (i.length == 1 && !i[0].term)
      return r(i[0].to);
    n.push(o);
    for (let s = 0; s < i.length; s++) {
      let { term: l, to: a } = i[s];
      !l && n.indexOf(a) == -1 && r(a);
    }
  }
}
function SL(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return n(jp(t, 0));
  function n(r) {
    let o = [];
    r.forEach((s) => {
      t[s].forEach(({ term: l, to: a }) => {
        if (!l)
          return;
        let c;
        for (let d = 0; d < o.length; d++)
          o[d][0] == l && (c = o[d][1]);
        jp(t, a).forEach((d) => {
          c || o.push([l, c = []]), c.indexOf(d) == -1 && c.push(d);
        });
      });
    });
    let i = e[r.join(",")] = new Ho(r.indexOf(t.length - 1) > -1);
    for (let s = 0; s < o.length; s++) {
      let l = o[s][1].sort(r1);
      i.next.push({ type: o[s][0], next: e[l.join(",")] || n(l) });
    }
    return i;
  }
}
function CL(t, e) {
  for (let n = 0, r = [t]; n < r.length; n++) {
    let o = r[n], i = !o.validEnd, s = [];
    for (let l = 0; l < o.next.length; l++) {
      let { type: a, next: c } = o.next[l];
      s.push(a.name), i && !(a.isText || a.hasRequiredAttrs()) && (i = !1), r.indexOf(c) == -1 && r.push(c);
    }
    i && e.err("Only non-generatable nodes (" + s.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function o1(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let r = t[n];
    if (!r.hasDefault)
      return null;
    e[n] = r.default;
  }
  return e;
}
function i1(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in t) {
    let o = e && e[r];
    if (o === void 0) {
      let i = t[r];
      if (i.hasDefault)
        o = i.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = o;
  }
  return n;
}
function s1(t, e, n, r) {
  for (let o in e)
    if (!(o in t))
      throw new RangeError(`Unsupported attribute ${o} for ${n} of type ${o}`);
  for (let o in t) {
    let i = t[o];
    i.validate && i.validate(e[o]);
  }
}
function l1(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      n[r] = new xL(t, r, e[r]);
  return n;
}
let Wp = class a1 {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.name = e, this.schema = n, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = l1(e, r.attrs), this.defaultAttrs = o1(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Ho.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : i1(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, n, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new uo(this, this.computeAttrs(e), D.from(n), it.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, n, r) {
    return n = D.from(n), this.checkContent(n), new uo(this, this.computeAttrs(e), n, it.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, n, r) {
    if (e = this.computeAttrs(e), n = D.from(n), n.size) {
      let s = this.contentMatch.fillBefore(n);
      if (!s)
        return null;
      n = s.append(n);
    }
    let o = this.contentMatch.matchFragment(n), i = o && o.fillBefore(D.empty, !0);
    return i ? new uo(this, e, n.append(i), it.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let n = this.contentMatch.matchFragment(e);
    if (!n || !n.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    s1(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < e.length; n++)
      if (!this.allowsMarkType(e[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let n;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? n && n.push(e[r]) : n || (n = e.slice(0, r));
    return n ? n.length ? n : it.none : e;
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((i, s) => r[i] = new a1(i, n, s));
    let o = n.spec.topNode || "doc";
    if (!r[o])
      throw new RangeError("Schema is missing its top node type ('" + o + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let i in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function vL(t, e, n) {
  let r = n.split("|");
  return (o) => {
    let i = o === null ? "null" : typeof o;
    if (r.indexOf(i) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${t}, got ${i}`);
  };
}
class xL {
  constructor(e, n, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? vL(e, n, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Sc {
  /**
  @internal
  */
  constructor(e, n, r, o) {
    this.name = e, this.rank = n, this.schema = r, this.spec = o, this.attrs = l1(e, o.attrs), this.excluded = null;
    let i = o1(this.attrs);
    this.instance = i ? new it(this, i) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new it(this, i1(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null), o = 0;
    return e.forEach((i, s) => r[i] = new Sc(i, o++, n, s)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var n = 0; n < e.length; n++)
      e[n].type == this && (e = e.slice(0, n).concat(e.slice(n + 1)), n--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (e[n].type == this)
        return e[n];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    s1(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class c1 {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let o in e)
      n[o] = e[o];
    n.nodes = Yt.from(e.nodes), n.marks = Yt.from(e.marks || {}), this.nodes = Wp.compile(this.spec.nodes, this), this.marks = Sc.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let o in this.nodes) {
      if (o in this.marks)
        throw new RangeError(o + " can not be both a node and a mark");
      let i = this.nodes[o], s = i.spec.content || "", l = i.spec.marks;
      if (i.contentMatch = r[s] || (r[s] = Ho.parse(s, this.nodes)), i.inlineContent = i.contentMatch.inlineContent, i.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!i.isInline || !i.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = i;
      }
      i.markSet = l == "_" ? null : l ? Gp(this, l.split(" ")) : l == "" || !i.inlineContent ? [] : null;
    }
    for (let o in this.marks) {
      let i = this.marks[o], s = i.spec.excludes;
      i.excluded = s == null ? [i] : s == "" ? [] : Gp(this, s.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, n = null, r, o) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof Wp) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(n, r, o);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, n) {
    let r = this.nodes.text;
    return new va(r, r.defaultAttrs, e, it.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, n) {
    return typeof e == "string" && (e = this.marks[e]), e.create(n);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return uo.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return it.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let n = this.nodes[e];
    if (!n)
      throw new RangeError("Unknown node type: " + e);
    return n;
  }
}
function Gp(t, e) {
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let o = e[r], i = t.marks[o], s = i;
    if (i)
      n.push(i);
    else
      for (let l in t.marks) {
        let a = t.marks[l];
        (o == "_" || a.spec.group && a.spec.group.split(" ").indexOf(o) > -1) && n.push(s = a);
      }
    if (!s)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return n;
}
function EL(t) {
  return t.tag != null;
}
function kL(t) {
  return t.style != null;
}
class fo {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, n) {
    this.schema = e, this.rules = n, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    n.forEach((o) => {
      if (EL(o))
        this.tags.push(o);
      else if (kL(o)) {
        let i = /[^=]*/.exec(o.style)[0];
        r.indexOf(i) < 0 && r.push(i), this.styles.push(o);
      }
    }), this.normalizeLists = !this.tags.some((o) => {
      if (!/^(ul|ol)\b/.test(o.tag) || !o.node)
        return !1;
      let i = e.nodes[o.node];
      return i.contentMatch.matchType(i);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, n = {}) {
    let r = new qp(this, n, !1);
    return r.addAll(e, it.none, n.from, n.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, n = {}) {
    let r = new qp(this, n, !0);
    return r.addAll(e, it.none, n.from, n.to), N.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, n, r) {
    for (let o = r ? this.tags.indexOf(r) + 1 : 0; o < this.tags.length; o++) {
      let i = this.tags[o];
      if (ML(e, i.tag) && (i.namespace === void 0 || e.namespaceURI == i.namespace) && (!i.context || n.matchesContext(i.context))) {
        if (i.getAttrs) {
          let s = i.getAttrs(e);
          if (s === !1)
            continue;
          i.attrs = s || void 0;
        }
        return i;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, n, r, o) {
    for (let i = o ? this.styles.indexOf(o) + 1 : 0; i < this.styles.length; i++) {
      let s = this.styles[i], l = s.style;
      if (!(l.indexOf(e) != 0 || s.context && !r.matchesContext(s.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      l.length > e.length && (l.charCodeAt(e.length) != 61 || l.slice(e.length + 1) != n))) {
        if (s.getAttrs) {
          let a = s.getAttrs(n);
          if (a === !1)
            continue;
          s.attrs = a || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let n = [];
    function r(o) {
      let i = o.priority == null ? 50 : o.priority, s = 0;
      for (; s < n.length; s++) {
        let l = n[s];
        if ((l.priority == null ? 50 : l.priority) < i)
          break;
      }
      n.splice(s, 0, o);
    }
    for (let o in e.marks) {
      let i = e.marks[o].spec.parseDOM;
      i && i.forEach((s) => {
        r(s = Jp(s)), s.mark || s.ignore || s.clearMark || (s.mark = o);
      });
    }
    for (let o in e.nodes) {
      let i = e.nodes[o].spec.parseDOM;
      i && i.forEach((s) => {
        r(s = Jp(s)), s.node || s.ignore || s.mark || (s.node = o);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new fo(e, fo.schemaRules(e)));
  }
}
const d1 = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, TL = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, u1 = { ol: !0, ul: !0 }, xa = 1, Ea = 2, Kl = 4;
function Up(t, e, n) {
  return e != null ? (e ? xa : 0) | (e === "full" ? Ea : 0) : t && t.whitespace == "pre" ? xa | Ea : n & -5;
}
class xl {
  constructor(e, n, r, o, i, s) {
    this.type = e, this.attrs = n, this.marks = r, this.solid = o, this.options = s, this.content = [], this.activeMarks = it.none, this.match = i || (s & Kl ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(D.from(e));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let r = this.type.contentMatch, o;
        return (o = r.findWrapping(e.type)) ? (this.match = r, o) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & xa)) {
      let r = this.content[this.content.length - 1], o;
      if (r && r.isText && (o = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let i = r;
        r.text.length == o[0].length ? this.content.pop() : this.content[this.content.length - 1] = i.withText(i.text.slice(0, i.text.length - o[0].length));
      }
    }
    let n = D.from(this.content);
    return !e && this.match && (n = n.append(this.match.fillBefore(D.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !d1.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class qp {
  constructor(e, n, r) {
    this.parser = e, this.options = n, this.isOpen = r, this.open = 0;
    let o = n.topNode, i, s = Up(null, n.preserveWhitespace, 0) | (r ? Kl : 0);
    o ? i = new xl(o.type, o.attrs, it.none, !0, n.topMatch || o.type.contentMatch, s) : r ? i = new xl(null, null, it.none, !0, null, s) : i = new xl(e.schema.topNodeType, null, it.none, !0, null, s), this.nodes = [i], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, n) {
    e.nodeType == 3 ? this.addTextNode(e, n) : e.nodeType == 1 && this.addElement(e, n);
  }
  addTextNode(e, n) {
    let r = e.nodeValue, o = this.top;
    if (o.options & Ea || o.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (o.options & xa)
        o.options & Ea ? r = r.replace(/\r\n?/g, `
`) : r = r.replace(/\r?\n|\r/g, " ");
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let i = o.content[o.content.length - 1], s = e.previousSibling;
        (!i || s && s.nodeName == "BR" || i.isText && /[ \t\r\n\u000c]$/.test(i.text)) && (r = r.slice(1));
      }
      r && this.insertNode(this.parser.schema.text(r), n), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, n, r) {
    let o = e.nodeName.toLowerCase(), i;
    u1.hasOwnProperty(o) && this.parser.normalizeLists && IL(e);
    let s = this.options.ruleFromNode && this.options.ruleFromNode(e) || (i = this.parser.matchTag(e, this, r));
    if (s ? s.ignore : TL.hasOwnProperty(o))
      this.findInside(e), this.ignoreFallback(e, n);
    else if (!s || s.skip || s.closeParent) {
      s && s.closeParent ? this.open = Math.max(0, this.open - 1) : s && s.skip.nodeType && (e = s.skip);
      let l, a = this.top, c = this.needsBlock;
      if (d1.hasOwnProperty(o))
        a.content.length && a.content[0].isInline && this.open && (this.open--, a = this.top), l = !0, a.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, n);
        return;
      }
      let d = s && s.skip ? n : this.readStyles(e, n);
      d && this.addAll(e, d), l && this.sync(a), this.needsBlock = c;
    } else {
      let l = this.readStyles(e, n);
      l && this.addElementByRule(e, s, l, s.consuming === !1 ? i : void 0);
    }
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, n) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), n);
  }
  // Called for ignored nodes
  ignoreFallback(e, n) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), n);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, n) {
    let r = e.style;
    if (r && r.length)
      for (let o = 0; o < this.parser.matchedStyles.length; o++) {
        let i = this.parser.matchedStyles[o], s = r.getPropertyValue(i);
        if (s)
          for (let l = void 0; ; ) {
            let a = this.parser.matchStyle(i, s, this, l);
            if (!a)
              break;
            if (a.ignore)
              return null;
            if (a.clearMark ? n = n.filter((c) => !a.clearMark(c)) : n = n.concat(this.parser.schema.marks[a.mark].create(a.attrs)), a.consuming === !1)
              l = a;
            else
              break;
          }
      }
    return n;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, n, r, o) {
    let i, s;
    if (n.node)
      if (s = this.parser.schema.nodes[n.node], s.isLeaf)
        this.insertNode(s.create(n.attrs), r) || this.leafFallback(e, r);
      else {
        let a = this.enter(s, n.attrs || null, r, n.preserveWhitespace);
        a && (i = !0, r = a);
      }
    else {
      let a = this.parser.schema.marks[n.mark];
      r = r.concat(a.create(n.attrs));
    }
    let l = this.top;
    if (s && s.isLeaf)
      this.findInside(e);
    else if (o)
      this.addElement(e, r, o);
    else if (n.getContent)
      this.findInside(e), n.getContent(e, this.parser.schema).forEach((a) => this.insertNode(a, r));
    else {
      let a = e;
      typeof n.contentElement == "string" ? a = e.querySelector(n.contentElement) : typeof n.contentElement == "function" ? a = n.contentElement(e) : n.contentElement && (a = n.contentElement), this.findAround(e, a, !0), this.addAll(a, r), this.findAround(e, a, !1);
    }
    i && this.sync(l) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, n, r, o) {
    let i = r || 0;
    for (let s = r ? e.childNodes[r] : e.firstChild, l = o == null ? null : e.childNodes[o]; s != l; s = s.nextSibling, ++i)
      this.findAtPoint(e, i), this.addDOM(s, n);
    this.findAtPoint(e, i);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, n) {
    let r, o;
    for (let i = this.open; i >= 0; i--) {
      let s = this.nodes[i], l = s.findWrapping(e);
      if (l && (!r || r.length > l.length) && (r = l, o = s, !l.length) || s.solid)
        break;
    }
    if (!r)
      return null;
    this.sync(o);
    for (let i = 0; i < r.length; i++)
      n = this.enterInner(r[i], null, n, !1);
    return n;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, n) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let o = this.textblockFromContext();
      o && (n = this.enterInner(o, null, n));
    }
    let r = this.findPlace(e, n);
    if (r) {
      this.closeExtra();
      let o = this.top;
      o.match && (o.match = o.match.matchType(e.type));
      let i = it.none;
      for (let s of r.concat(e.marks))
        (o.type ? o.type.allowsMarkType(s.type) : Kp(s.type, e.type)) && (i = s.addToSet(i));
      return o.content.push(e.mark(i)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, n, r, o) {
    let i = this.findPlace(e.create(n), r);
    return i && (i = this.enterInner(e, n, r, !0, o)), i;
  }
  // Open a node of the given type
  enterInner(e, n, r, o = !1, i) {
    this.closeExtra();
    let s = this.top;
    s.match = s.match && s.match.matchType(e);
    let l = Up(e, i, s.options);
    s.options & Kl && s.content.length == 0 && (l |= Kl);
    let a = it.none;
    return r = r.filter((c) => (s.type ? s.type.allowsMarkType(c.type) : Kp(c.type, e)) ? (a = c.addToSet(a), !1) : !0), this.nodes.push(new xl(e, n, a, o, null, l)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(e) {
    for (let n = this.open; n >= 0; n--)
      if (this.nodes[n] == e)
        return this.open = n, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n].content;
      for (let o = r.length - 1; o >= 0; o--)
        e += r[o].nodeSize;
      n && e++;
    }
    return e;
  }
  findAtPoint(e, n) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && e.nodeType == 1 && e.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(e, n, r) {
    if (e != n && this.find)
      for (let o = 0; o < this.find.length; o++)
        this.find[o].pos == null && e.nodeType == 1 && e.contains(this.find[o].node) && n.compareDocumentPosition(this.find[o].node) & (r ? 2 : 4) && (this.find[o].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == e && (this.find[n].pos = this.currentPos - (e.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = e.split("/"), r = this.options.context, o = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), i = -(r ? r.depth + 1 : 0) + (o ? 0 : 1), s = (l, a) => {
      for (; l >= 0; l--) {
        let c = n[l];
        if (c == "") {
          if (l == n.length - 1 || l == 0)
            continue;
          for (; a >= i; a--)
            if (s(l - 1, a))
              return !0;
          return !1;
        } else {
          let d = a > 0 || a == 0 && o ? this.nodes[a].type : r && a >= i ? r.node(a - i).type : null;
          if (!d || d.name != c && !d.isInGroup(c))
            return !1;
          a--;
        }
      }
      return !0;
    };
    return s(n.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let n = e.depth; n >= 0; n--) {
        let r = e.node(n).contentMatchAt(e.indexAfter(n)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let n in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[n];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function IL(t) {
  for (let e = t.firstChild, n = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && u1.hasOwnProperty(r) && n ? (n.appendChild(e), e = n) : r == "li" ? n = e : r && (n = null);
  }
}
function ML(t, e) {
  return (t.matches || t.msMatchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector).call(t, e);
}
function Jp(t) {
  let e = {};
  for (let n in t)
    e[n] = t[n];
  return e;
}
function Kp(t, e) {
  let n = e.schema.nodes;
  for (let r in n) {
    let o = n[r];
    if (!o.allowsMarkType(t))
      continue;
    let i = [], s = (l) => {
      i.push(l);
      for (let a = 0; a < l.edgeCount; a++) {
        let { type: c, next: d } = l.edge(a);
        if (c == e || i.indexOf(d) < 0 && s(d))
          return !0;
      }
    };
    if (s(o.contentMatch))
      return !0;
  }
}
class Qo {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, n) {
    this.nodes = e, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, n = {}, r) {
    r || (r = od(n).createDocumentFragment());
    let o = r, i = [];
    return e.forEach((s) => {
      if (i.length || s.marks.length) {
        let l = 0, a = 0;
        for (; l < i.length && a < s.marks.length; ) {
          let c = s.marks[a];
          if (!this.marks[c.type.name]) {
            a++;
            continue;
          }
          if (!c.eq(i[l][0]) || c.type.spec.spanning === !1)
            break;
          l++, a++;
        }
        for (; l < i.length; )
          o = i.pop()[1];
        for (; a < s.marks.length; ) {
          let c = s.marks[a++], d = this.serializeMark(c, s.isInline, n);
          d && (i.push([c, o]), o.appendChild(d.dom), o = d.contentDOM || d.dom);
        }
      }
      o.appendChild(this.serializeNodeInner(s, n));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, n) {
    let { dom: r, contentDOM: o } = Yl(od(n), this.nodes[e.type.name](e), null, e.attrs);
    if (o) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, n, o);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, n = {}) {
    let r = this.serializeNodeInner(e, n);
    for (let o = e.marks.length - 1; o >= 0; o--) {
      let i = this.serializeMark(e.marks[o], e.isInline, n);
      i && ((i.contentDOM || i.dom).appendChild(r), r = i.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, n, r = {}) {
    let o = this.marks[e.type.name];
    return o && Yl(od(r), o(e, n), null, e.attrs);
  }
  static renderSpec(e, n, r = null, o) {
    return Yl(e, n, r, o);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new Qo(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let n = Yp(e.nodes);
    return n.text || (n.text = (r) => r.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return Yp(e.marks);
  }
}
function Yp(t) {
  let e = {};
  for (let n in t) {
    let r = t[n].spec.toDOM;
    r && (e[n] = r);
  }
  return e;
}
function od(t) {
  return t.document || window.document;
}
const Zp = /* @__PURE__ */ new WeakMap();
function RL(t) {
  let e = Zp.get(t);
  return e === void 0 && Zp.set(t, e = OL(t)), e;
}
function OL(t) {
  let e = null;
  function n(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let o = 0; o < r.length; o++)
            n(r[o]);
      else
        for (let o in r)
          n(r[o]);
  }
  return n(t), e;
}
function Yl(t, e, n, r) {
  if (typeof e == "string")
    return { dom: t.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let o = e[0], i;
  if (typeof o != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (i = RL(r)) && i.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let s = o.indexOf(" ");
  s > 0 && (n = o.slice(0, s), o = o.slice(s + 1));
  let l, a = n ? t.createElementNS(n, o) : t.createElement(o), c = e[1], d = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    d = 2;
    for (let u in c)
      if (c[u] != null) {
        let f = u.indexOf(" ");
        f > 0 ? a.setAttributeNS(u.slice(0, f), u.slice(f + 1), c[u]) : a.setAttribute(u, c[u]);
      }
  }
  for (let u = d; u < e.length; u++) {
    let f = e[u];
    if (f === 0) {
      if (u < e.length - 1 || u > d)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: a, contentDOM: a };
    } else {
      let { dom: h, contentDOM: p } = Yl(t, f, n, r);
      if (a.appendChild(h), p) {
        if (l)
          throw new RangeError("Multiple content holes");
        l = p;
      }
    }
  }
  return { dom: a, contentDOM: l };
}
const f1 = 65535, h1 = Math.pow(2, 16);
function DL(t, e) {
  return t + e * h1;
}
function Xp(t) {
  return t & f1;
}
function AL(t) {
  return (t - (t & f1)) / h1;
}
const p1 = 1, g1 = 2, Zl = 4, m1 = 8;
class gu {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & m1) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (p1 | Zl)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (g1 | Zl)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Zl) > 0;
  }
}
class kn {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, n = !1) {
    if (this.ranges = e, this.inverted = n, !e.length && kn.empty)
      return kn.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let n = 0, r = Xp(e);
    if (!this.inverted)
      for (let o = 0; o < r; o++)
        n += this.ranges[o * 3 + 2] - this.ranges[o * 3 + 1];
    return this.ranges[r * 3] + n + AL(e);
  }
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  map(e, n = 1) {
    return this._map(e, n, !0);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let o = 0, i = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let a = this.ranges[l] - (this.inverted ? o : 0);
      if (a > e)
        break;
      let c = this.ranges[l + i], d = this.ranges[l + s], u = a + c;
      if (e <= u) {
        let f = c ? e == a ? -1 : e == u ? 1 : n : n, h = a + o + (f < 0 ? 0 : d);
        if (r)
          return h;
        let p = e == (n < 0 ? a : u) ? null : DL(l / 3, e - a), y = e == a ? g1 : e == u ? p1 : Zl;
        return (n < 0 ? e != a : e != u) && (y |= m1), new gu(h, y, p);
      }
      o += d - c;
    }
    return r ? e + o : new gu(e + o, 0, null);
  }
  /**
  @internal
  */
  touches(e, n) {
    let r = 0, o = Xp(n), i = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let a = this.ranges[l] - (this.inverted ? r : 0);
      if (a > e)
        break;
      let c = this.ranges[l + i], d = a + c;
      if (e <= d && l == o * 3)
        return !0;
      r += this.ranges[l + s] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let o = 0, i = 0; o < this.ranges.length; o += 3) {
      let s = this.ranges[o], l = s - (this.inverted ? i : 0), a = s + (this.inverted ? 0 : i), c = this.ranges[o + n], d = this.ranges[o + r];
      e(l, l + c, a, a + d), i += d - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new kn(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? kn.empty : new kn(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
kn.empty = new kn([]);
class wi {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e = [], n, r = 0, o = e.length) {
    this.maps = e, this.mirror = n, this.from = r, this.to = o;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, n = this.maps.length) {
    return new wi(this.maps, this.mirror, e, n);
  }
  /**
  @internal
  */
  copy() {
    return new wi(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, n) {
    this.to = this.maps.push(e), n != null && this.setMirror(this.maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let n = 0, r = this.maps.length; n < e.maps.length; n++) {
      let o = e.getMirror(n);
      this.appendMap(e.maps[n], o != null && o < n ? r + o : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == e)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, n) {
    this.mirror || (this.mirror = []), this.mirror.push(e, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let n = e.maps.length - 1, r = this.maps.length + e.maps.length; n >= 0; n--) {
      let o = e.getMirror(n);
      this.appendMap(e.maps[n].invert(), o != null && o > n ? r - o - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new wi();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, n = 1) {
    if (this.mirror)
      return this._map(e, n, !0);
    for (let r = this.from; r < this.to; r++)
      e = this.maps[r].map(e, n);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let o = 0;
    for (let i = this.from; i < this.to; i++) {
      let s = this.maps[i], l = s.mapResult(e, n);
      if (l.recover != null) {
        let a = this.getMirror(i);
        if (a != null && a > i && a < this.to) {
          i = a, e = this.maps[a].recover(l.recover);
          continue;
        }
      }
      o |= l.delInfo, e = l.pos;
    }
    return r ? e : new gu(e, o, null);
  }
}
const id = /* @__PURE__ */ Object.create(null);
class dn {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return kn.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = id[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, n) {
    if (e in id)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return id[e] = n, n.prototype.jsonID = e, n;
  }
}
class Vt {
  /**
  @internal
  */
  constructor(e, n) {
    this.doc = e, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new Vt(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new Vt(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, n, r, o) {
    try {
      return Vt.ok(e.replace(n, r, o));
    } catch (i) {
      if (i instanceof wa)
        return Vt.fail(i.message);
      throw i;
    }
  }
}
function Lf(t, e, n) {
  let r = [];
  for (let o = 0; o < t.childCount; o++) {
    let i = t.child(o);
    i.content.size && (i = i.copy(Lf(i.content, e, i))), i.isInline && (i = e(i, n, o)), r.push(i);
  }
  return D.fromArray(r);
}
class io extends dn {
  /**
  Create a mark step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = e.resolve(this.from), o = r.node(r.sharedDepth(this.to)), i = new N(Lf(n.content, (s, l) => !s.isAtom || !l.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), o), n.openStart, n.openEnd);
    return Vt.fromReplace(e, this.from, this.to, i);
  }
  invert() {
    return new pr(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new io(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof io && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new io(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new io(n.from, n.to, e.markFromJSON(n.mark));
  }
}
dn.jsonID("addMark", io);
class pr extends dn {
  /**
  Create a mark-removing step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = new N(Lf(n.content, (o) => o.mark(this.mark.removeFromSet(o.marks)), e), n.openStart, n.openEnd);
    return Vt.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new io(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new pr(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof pr && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new pr(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new pr(n.from, n.to, e.markFromJSON(n.mark));
  }
}
dn.jsonID("removeMark", pr);
class so extends dn {
  /**
  Create a node mark step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return Vt.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return Vt.fromReplace(e, this.pos, this.pos + 1, new N(D.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let o = 0; o < n.marks.length; o++)
          if (!n.marks[o].isInSet(r))
            return new so(this.pos, n.marks[o]);
        return new so(this.pos, this.mark);
      }
    }
    return new Oi(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new so(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new so(n.pos, e.markFromJSON(n.mark));
  }
}
dn.jsonID("addNodeMark", so);
class Oi extends dn {
  /**
  Create a mark-removing step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return Vt.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return Vt.fromReplace(e, this.pos, this.pos + 1, new N(D.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new so(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Oi(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Oi(n.pos, e.markFromJSON(n.mark));
  }
}
dn.jsonID("removeNodeMark", Oi);
class zt extends dn {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, n, r, o = !1) {
    super(), this.from = e, this.to = n, this.slice = r, this.structure = o;
  }
  apply(e) {
    return this.structure && mu(e, this.from, this.to) ? Vt.fail("Structure replace would overwrite content") : Vt.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new kn([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new zt(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deletedAcross && r.deletedAcross ? null : new zt(n.pos, Math.max(n.pos, r.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof zt) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let n = this.slice.size + e.slice.size == 0 ? N.empty : new N(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new zt(this.from, this.to + (e.to - e.from), n, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let n = this.slice.size + e.slice.size == 0 ? N.empty : new N(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new zt(e.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new zt(n.from, n.to, N.fromJSON(e, n.slice), !!n.structure);
  }
}
dn.jsonID("replace", zt);
class Ht extends dn {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, n, r, o, i, s, l = !1) {
    super(), this.from = e, this.to = n, this.gapFrom = r, this.gapTo = o, this.slice = i, this.insert = s, this.structure = l;
  }
  apply(e) {
    if (this.structure && (mu(e, this.from, this.gapFrom) || mu(e, this.gapTo, this.to)))
      return Vt.fail("Structure gap-replace would overwrite content");
    let n = e.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return Vt.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? Vt.fromReplace(e, this.from, this.to, r) : Vt.fail("Content does not fit in gap");
  }
  getMap() {
    return new kn([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let n = this.gapTo - this.gapFrom;
    return new Ht(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), o = this.from == this.gapFrom ? n.pos : e.map(this.gapFrom, -1), i = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || o < n.pos || i > r.pos ? null : new Ht(n.pos, r.pos, o, i, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Ht(n.from, n.to, n.gapFrom, n.gapTo, N.fromJSON(e, n.slice), n.insert, !!n.structure);
  }
}
dn.jsonID("replaceAround", Ht);
function mu(t, e, n) {
  let r = t.resolve(e), o = n - e, i = r.depth;
  for (; o > 0 && i > 0 && r.indexAfter(i) == r.node(i).childCount; )
    i--, o--;
  if (o > 0) {
    let s = r.node(i).maybeChild(r.indexAfter(i));
    for (; o > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, o--;
    }
  }
  return !1;
}
function LL(t, e, n, r) {
  let o = [], i = [], s, l;
  t.doc.nodesBetween(e, n, (a, c, d) => {
    if (!a.isInline)
      return;
    let u = a.marks;
    if (!r.isInSet(u) && d.type.allowsMarkType(r.type)) {
      let f = Math.max(c, e), h = Math.min(c + a.nodeSize, n), p = r.addToSet(u);
      for (let y = 0; y < u.length; y++)
        u[y].isInSet(p) || (s && s.to == f && s.mark.eq(u[y]) ? s.to = h : o.push(s = new pr(f, h, u[y])));
      l && l.to == f ? l.to = h : i.push(l = new io(f, h, r));
    }
  }), o.forEach((a) => t.step(a)), i.forEach((a) => t.step(a));
}
function $L(t, e, n, r) {
  let o = [], i = 0;
  t.doc.nodesBetween(e, n, (s, l) => {
    if (!s.isInline)
      return;
    i++;
    let a = null;
    if (r instanceof Sc) {
      let c = s.marks, d;
      for (; d = r.isInSet(c); )
        (a || (a = [])).push(d), c = d.removeFromSet(c);
    } else r ? r.isInSet(s.marks) && (a = [r]) : a = s.marks;
    if (a && a.length) {
      let c = Math.min(l + s.nodeSize, n);
      for (let d = 0; d < a.length; d++) {
        let u = a[d], f;
        for (let h = 0; h < o.length; h++) {
          let p = o[h];
          p.step == i - 1 && u.eq(o[h].style) && (f = p);
        }
        f ? (f.to = c, f.step = i) : o.push({ style: u, from: Math.max(l, e), to: c, step: i });
      }
    }
  }), o.forEach((s) => t.step(new pr(s.from, s.to, s.style)));
}
function $f(t, e, n, r = n.contentMatch, o = !0) {
  let i = t.doc.nodeAt(e), s = [], l = e + 1;
  for (let a = 0; a < i.childCount; a++) {
    let c = i.child(a), d = l + c.nodeSize, u = r.matchType(c.type);
    if (!u)
      s.push(new zt(l, d, N.empty));
    else {
      r = u;
      for (let f = 0; f < c.marks.length; f++)
        n.allowsMarkType(c.marks[f].type) || t.step(new pr(l, d, c.marks[f]));
      if (o && c.isText && n.whitespace != "pre") {
        let f, h = /\r?\n|\r/g, p;
        for (; f = h.exec(c.text); )
          p || (p = new N(D.from(n.schema.text(" ", n.allowedMarks(c.marks))), 0, 0)), s.push(new zt(l + f.index, l + f.index + f[0].length, p));
      }
    }
    l = d;
  }
  if (!r.validEnd) {
    let a = r.fillBefore(D.empty, !0);
    t.replace(l, l, new N(a, 0, 0));
  }
  for (let a = s.length - 1; a >= 0; a--)
    t.step(s[a]);
}
function PL(t, e, n) {
  return (e == 0 || t.canReplace(e, t.childCount)) && (n == t.childCount || t.canReplace(0, n));
}
function Wi(t) {
  let n = t.parent.content.cutByIndex(t.startIndex, t.endIndex);
  for (let r = t.depth; ; --r) {
    let o = t.$from.node(r), i = t.$from.index(r), s = t.$to.indexAfter(r);
    if (r < t.depth && o.canReplace(i, s, n))
      return r;
    if (r == 0 || o.type.spec.isolating || !PL(o, i, s))
      break;
  }
  return null;
}
function _L(t, e, n) {
  let { $from: r, $to: o, depth: i } = e, s = r.before(i + 1), l = o.after(i + 1), a = s, c = l, d = D.empty, u = 0;
  for (let p = i, y = !1; p > n; p--)
    y || r.index(p) > 0 ? (y = !0, d = D.from(r.node(p).copy(d)), u++) : a--;
  let f = D.empty, h = 0;
  for (let p = i, y = !1; p > n; p--)
    y || o.after(p + 1) < o.end(p) ? (y = !0, f = D.from(o.node(p).copy(f)), h++) : c++;
  t.step(new Ht(a, c, s, l, new N(d.append(f), u, h), d.size - u, !0));
}
function Pf(t, e, n = null, r = t) {
  let o = BL(t, e), i = o && VL(r, e);
  return i ? o.map(Qp).concat({ type: e, attrs: n }).concat(i.map(Qp)) : null;
}
function Qp(t) {
  return { type: t, attrs: null };
}
function BL(t, e) {
  let { parent: n, startIndex: r, endIndex: o } = t, i = n.contentMatchAt(r).findWrapping(e);
  if (!i)
    return null;
  let s = i.length ? i[0] : e;
  return n.canReplaceWith(r, o, s) ? i : null;
}
function VL(t, e) {
  let { parent: n, startIndex: r, endIndex: o } = t, i = n.child(r), s = e.contentMatch.findWrapping(i.type);
  if (!s)
    return null;
  let a = (s.length ? s[s.length - 1] : e).contentMatch;
  for (let c = r; a && c < o; c++)
    a = a.matchType(n.child(c).type);
  return !a || !a.validEnd ? null : s;
}
function FL(t, e, n) {
  let r = D.empty;
  for (let s = n.length - 1; s >= 0; s--) {
    if (r.size) {
      let l = n[s].type.contentMatch.matchFragment(r);
      if (!l || !l.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = D.from(n[s].type.create(n[s].attrs, r));
  }
  let o = e.start, i = e.end;
  t.step(new Ht(o, i, o, i, new N(r, 0, 0), n.length, !0));
}
function NL(t, e, n, r, o) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let i = t.steps.length;
  t.doc.nodesBetween(e, n, (s, l) => {
    let a = typeof o == "function" ? o(s) : o;
    if (s.isTextblock && !s.hasMarkup(r, a) && zL(t.doc, t.mapping.slice(i).map(l), r)) {
      let c = null;
      if (r.schema.linebreakReplacement) {
        let h = r.whitespace == "pre", p = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        h && !p ? c = !1 : !h && p && (c = !0);
      }
      c === !1 && b1(t, s, l, i), $f(t, t.mapping.slice(i).map(l, 1), r, void 0, c === null);
      let d = t.mapping.slice(i), u = d.map(l, 1), f = d.map(l + s.nodeSize, 1);
      return t.step(new Ht(u, f, u + 1, f - 1, new N(D.from(r.create(a, null, s.marks)), 0, 0), 1, !0)), c === !0 && y1(t, s, l, i), !1;
    }
  });
}
function y1(t, e, n, r) {
  e.forEach((o, i) => {
    if (o.isText) {
      let s, l = /\r?\n|\r/g;
      for (; s = l.exec(o.text); ) {
        let a = t.mapping.slice(r).map(n + 1 + i + s.index);
        t.replaceWith(a, a + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function b1(t, e, n, r) {
  e.forEach((o, i) => {
    if (o.type == o.type.schema.linebreakReplacement) {
      let s = t.mapping.slice(r).map(n + 1 + i);
      t.replaceWith(s, s + 1, e.type.schema.text(`
`));
    }
  });
}
function zL(t, e, n) {
  let r = t.resolve(e), o = r.index();
  return r.parent.canReplaceWith(o, o + 1, n);
}
function HL(t, e, n, r, o) {
  let i = t.doc.nodeAt(e);
  if (!i)
    throw new RangeError("No node at given position");
  n || (n = i.type);
  let s = n.create(r, null, o || i.marks);
  if (i.isLeaf)
    return t.replaceWith(e, e + i.nodeSize, s);
  if (!n.validContent(i.content))
    throw new RangeError("Invalid content for node type " + n.name);
  t.step(new Ht(e, e + i.nodeSize, e + 1, e + i.nodeSize - 1, new N(D.from(s), 0, 0), 1, !0));
}
function Pr(t, e, n = 1, r) {
  let o = t.resolve(e), i = o.depth - n, s = r && r[r.length - 1] || o.parent;
  if (i < 0 || o.parent.type.spec.isolating || !o.parent.canReplace(o.index(), o.parent.childCount) || !s.type.validContent(o.parent.content.cutByIndex(o.index(), o.parent.childCount)))
    return !1;
  for (let c = o.depth - 1, d = n - 2; c > i; c--, d--) {
    let u = o.node(c), f = o.index(c);
    if (u.type.spec.isolating)
      return !1;
    let h = u.content.cutByIndex(f, u.childCount), p = r && r[d + 1];
    p && (h = h.replaceChild(0, p.type.create(p.attrs)));
    let y = r && r[d] || u;
    if (!u.canReplace(f + 1, u.childCount) || !y.type.validContent(h))
      return !1;
  }
  let l = o.indexAfter(i), a = r && r[0];
  return o.node(i).canReplaceWith(l, l, a ? a.type : o.node(i + 1).type);
}
function jL(t, e, n = 1, r) {
  let o = t.doc.resolve(e), i = D.empty, s = D.empty;
  for (let l = o.depth, a = o.depth - n, c = n - 1; l > a; l--, c--) {
    i = D.from(o.node(l).copy(i));
    let d = r && r[c];
    s = D.from(d ? d.type.create(d.attrs, s) : o.node(l).copy(s));
  }
  t.step(new zt(e, e, new N(i.append(s), n, n), !0));
}
function Co(t, e) {
  let n = t.resolve(e), r = n.index();
  return w1(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function WL(t, e) {
  e.content.size || t.type.compatibleContent(e.type);
  let n = t.contentMatchAt(t.childCount), { linebreakReplacement: r } = t.type.schema;
  for (let o = 0; o < e.childCount; o++) {
    let i = e.child(o), s = i.type == r ? t.type.schema.nodes.text : i.type;
    if (n = n.matchType(s), !n || !t.type.allowsMarks(i.marks))
      return !1;
  }
  return n.validEnd;
}
function w1(t, e) {
  return !!(t && e && !t.isLeaf && WL(t, e));
}
function Cc(t, e, n = -1) {
  let r = t.resolve(e);
  for (let o = r.depth; ; o--) {
    let i, s, l = r.index(o);
    if (o == r.depth ? (i = r.nodeBefore, s = r.nodeAfter) : n > 0 ? (i = r.node(o + 1), l++, s = r.node(o).maybeChild(l)) : (i = r.node(o).maybeChild(l - 1), s = r.node(o + 1)), i && !i.isTextblock && w1(i, s) && r.node(o).canReplace(l, l + 1))
      return e;
    if (o == 0)
      break;
    e = n < 0 ? r.before(o) : r.after(o);
  }
}
function GL(t, e, n) {
  let r = null, { linebreakReplacement: o } = t.doc.type.schema, i = t.doc.resolve(e - n), s = i.node().type;
  if (o && s.inlineContent) {
    let d = s.whitespace == "pre", u = !!s.contentMatch.matchType(o);
    d && !u ? r = !1 : !d && u && (r = !0);
  }
  let l = t.steps.length;
  if (r === !1) {
    let d = t.doc.resolve(e + n);
    b1(t, d.node(), d.before(), l);
  }
  s.inlineContent && $f(t, e + n - 1, s, i.node().contentMatchAt(i.index()), r == null);
  let a = t.mapping.slice(l), c = a.map(e - n);
  if (t.step(new zt(c, a.map(e + n, -1), N.empty, !0)), r === !0) {
    let d = t.doc.resolve(c);
    y1(t, d.node(), d.before(), t.steps.length);
  }
  return t;
}
function UL(t, e, n) {
  let r = t.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return e;
  if (r.parentOffset == 0)
    for (let o = r.depth - 1; o >= 0; o--) {
      let i = r.index(o);
      if (r.node(o).canReplaceWith(i, i, n))
        return r.before(o + 1);
      if (i > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let o = r.depth - 1; o >= 0; o--) {
      let i = r.indexAfter(o);
      if (r.node(o).canReplaceWith(i, i, n))
        return r.after(o + 1);
      if (i < r.node(o).childCount)
        return null;
    }
  return null;
}
function S1(t, e, n) {
  let r = t.resolve(e);
  if (!n.content.size)
    return e;
  let o = n.content;
  for (let i = 0; i < n.openStart; i++)
    o = o.firstChild.content;
  for (let i = 1; i <= (n.openStart == 0 && n.size ? 2 : 1); i++)
    for (let s = r.depth; s >= 0; s--) {
      let l = s == r.depth ? 0 : r.pos <= (r.start(s + 1) + r.end(s + 1)) / 2 ? -1 : 1, a = r.index(s) + (l > 0 ? 1 : 0), c = r.node(s), d = !1;
      if (i == 1)
        d = c.canReplace(a, a, o);
      else {
        let u = c.contentMatchAt(a).findWrapping(o.firstChild.type);
        d = u && c.canReplaceWith(a, a, u[0]);
      }
      if (d)
        return l == 0 ? r.pos : l < 0 ? r.before(s + 1) : r.after(s + 1);
    }
  return null;
}
function vc(t, e, n = e, r = N.empty) {
  if (e == n && !r.size)
    return null;
  let o = t.resolve(e), i = t.resolve(n);
  return C1(o, i, r) ? new zt(e, n, r) : new qL(o, i, r).fit();
}
function C1(t, e, n) {
  return !n.openStart && !n.openEnd && t.start() == e.start() && t.parent.canReplace(t.index(), e.index(), n.content);
}
class qL {
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = D.empty;
    for (let o = 0; o <= e.depth; o++) {
      let i = e.node(o);
      this.frontier.push({
        type: i.type,
        match: i.contentMatchAt(e.indexAfter(o))
      });
    }
    for (let o = e.depth; o > 0; o--)
      this.placed = D.from(e.node(o).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, o = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!o)
      return null;
    let i = this.placed, s = r.depth, l = o.depth;
    for (; s && l && i.childCount == 1; )
      i = i.firstChild.content, s--, l--;
    let a = new N(i, s, l);
    return e > -1 ? new Ht(r.pos, e, this.$to.pos, this.$to.end(), a, n) : a.size || r.pos != this.$to.pos ? new zt(r.pos, o.pos, a) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, o = this.unplaced.openEnd; r < e; r++) {
      let i = n.firstChild;
      if (n.childCount > 1 && (o = 0), i.type.spec.isolating && o <= r) {
        e = r;
        break;
      }
      n = i.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let o, i = null;
        r ? (i = sd(this.unplaced.content, r - 1).firstChild, o = i.content) : o = this.unplaced.content;
        let s = o.firstChild;
        for (let l = this.depth; l >= 0; l--) {
          let { type: a, match: c } = this.frontier[l], d, u = null;
          if (n == 1 && (s ? c.matchType(s.type) || (u = c.fillBefore(D.from(s), !1)) : i && a.compatibleContent(i.type)))
            return { sliceDepth: r, frontierDepth: l, parent: i, inject: u };
          if (n == 2 && s && (d = c.findWrapping(s.type)))
            return { sliceDepth: r, frontierDepth: l, parent: i, wrap: d };
          if (i && c.matchType(i.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, o = sd(e, n);
    return !o.childCount || o.firstChild.isLeaf ? !1 : (this.unplaced = new N(e, n + 1, Math.max(r, o.size + n >= e.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, o = sd(e, n);
    if (o.childCount <= 1 && n > 0) {
      let i = e.size - n <= n + o.size;
      this.unplaced = new N(fs(e, n - 1, 1), n - 1, i ? n - 1 : r);
    } else
      this.unplaced = new N(fs(e, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: n, parent: r, inject: o, wrap: i }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (i)
      for (let y = 0; y < i.length; y++)
        this.openFrontierNode(i[y]);
    let s = this.unplaced, l = r ? r.content : s.content, a = s.openStart - e, c = 0, d = [], { match: u, type: f } = this.frontier[n];
    if (o) {
      for (let y = 0; y < o.childCount; y++)
        d.push(o.child(y));
      u = u.matchFragment(o);
    }
    let h = l.size + e - (s.content.size - s.openEnd);
    for (; c < l.childCount; ) {
      let y = l.child(c), b = u.matchType(y.type);
      if (!b)
        break;
      c++, (c > 1 || a == 0 || y.content.size) && (u = b, d.push(v1(y.mark(f.allowedMarks(y.marks)), c == 1 ? a : 0, c == l.childCount ? h : -1)));
    }
    let p = c == l.childCount;
    p || (h = -1), this.placed = hs(this.placed, n, D.from(d)), this.frontier[n].match = u, p && h < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let y = 0, b = l; y < h; y++) {
      let w = b.lastChild;
      this.frontier.push({ type: w.type, match: w.contentMatchAt(w.childCount) }), b = w.content;
    }
    this.unplaced = p ? e == 0 ? N.empty : new N(fs(s.content, e - 1, 1), e - 1, h < 0 ? s.openEnd : e - 1) : new N(fs(s.content, e, c), s.openStart, s.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], n;
    if (!e.type.isTextblock || !ld(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, o = this.$to.after(r);
    for (; r > 1 && o == this.$to.end(--r); )
      ++o;
    return o;
  }
  findCloseLevel(e) {
    e: for (let n = Math.min(this.depth, e.depth); n >= 0; n--) {
      let { match: r, type: o } = this.frontier[n], i = n < e.depth && e.end(n + 1) == e.pos + (e.depth - (n + 1)), s = ld(e, n, o, r, i);
      if (s) {
        for (let l = n - 1; l >= 0; l--) {
          let { match: a, type: c } = this.frontier[l], d = ld(e, l, c, a, !0);
          if (!d || d.childCount)
            continue e;
        }
        return { depth: n, fit: s, move: i ? e.doc.resolve(e.after(n + 1)) : e };
      }
    }
  }
  close(e) {
    let n = this.findCloseLevel(e);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = hs(this.placed, n.depth, n.fit)), e = n.move;
    for (let r = n.depth + 1; r <= e.depth; r++) {
      let o = e.node(r), i = o.type.contentMatch.fillBefore(o.content, !0, e.index(r));
      this.openFrontierNode(o.type, o.attrs, i);
    }
    return e;
  }
  openFrontierNode(e, n = null, r) {
    let o = this.frontier[this.depth];
    o.match = o.match.matchType(e), this.placed = hs(this.placed, this.depth, D.from(e.create(n, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(D.empty, !0);
    n.childCount && (this.placed = hs(this.placed, this.frontier.length, n));
  }
}
function fs(t, e, n) {
  return e == 0 ? t.cutByIndex(n, t.childCount) : t.replaceChild(0, t.firstChild.copy(fs(t.firstChild.content, e - 1, n)));
}
function hs(t, e, n) {
  return e == 0 ? t.append(n) : t.replaceChild(t.childCount - 1, t.lastChild.copy(hs(t.lastChild.content, e - 1, n)));
}
function sd(t, e) {
  for (let n = 0; n < e; n++)
    t = t.firstChild.content;
  return t;
}
function v1(t, e, n) {
  if (e <= 0)
    return t;
  let r = t.content;
  return e > 1 && (r = r.replaceChild(0, v1(r.firstChild, e - 1, r.childCount == 1 ? n - 1 : 0))), e > 0 && (r = t.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(t.type.contentMatch.matchFragment(r).fillBefore(D.empty, !0)))), t.copy(r);
}
function ld(t, e, n, r, o) {
  let i = t.node(e), s = o ? t.indexAfter(e) : t.index(e);
  if (s == i.childCount && !n.compatibleContent(i.type))
    return null;
  let l = r.fillBefore(i.content, !0, s);
  return l && !JL(n, i.content, s) ? l : null;
}
function JL(t, e, n) {
  for (let r = n; r < e.childCount; r++)
    if (!t.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function KL(t) {
  return t.spec.defining || t.spec.definingForContent;
}
function YL(t, e, n, r) {
  if (!r.size)
    return t.deleteRange(e, n);
  let o = t.doc.resolve(e), i = t.doc.resolve(n);
  if (C1(o, i, r))
    return t.step(new zt(e, n, r));
  let s = E1(o, t.doc.resolve(n));
  s[s.length - 1] == 0 && s.pop();
  let l = -(o.depth + 1);
  s.unshift(l);
  for (let f = o.depth, h = o.pos - 1; f > 0; f--, h--) {
    let p = o.node(f).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    s.indexOf(f) > -1 ? l = f : o.before(f) == h && s.splice(1, 0, -f);
  }
  let a = s.indexOf(l), c = [], d = r.openStart;
  for (let f = r.content, h = 0; ; h++) {
    let p = f.firstChild;
    if (c.push(p), h == r.openStart)
      break;
    f = p.content;
  }
  for (let f = d - 1; f >= 0; f--) {
    let h = c[f], p = KL(h.type);
    if (p && !h.sameMarkup(o.node(Math.abs(l) - 1)))
      d = f;
    else if (p || !h.type.isTextblock)
      break;
  }
  for (let f = r.openStart; f >= 0; f--) {
    let h = (f + d + 1) % (r.openStart + 1), p = c[h];
    if (p)
      for (let y = 0; y < s.length; y++) {
        let b = s[(y + a) % s.length], w = !0;
        b < 0 && (w = !1, b = -b);
        let S = o.node(b - 1), x = o.index(b - 1);
        if (S.canReplaceWith(x, x, p.type, p.marks))
          return t.replace(o.before(b), w ? i.after(b) : n, new N(x1(r.content, 0, r.openStart, h), h, r.openEnd));
      }
  }
  let u = t.steps.length;
  for (let f = s.length - 1; f >= 0 && (t.replace(e, n, r), !(t.steps.length > u)); f--) {
    let h = s[f];
    h < 0 || (e = o.before(h), n = i.after(h));
  }
}
function x1(t, e, n, r, o) {
  if (e < n) {
    let i = t.firstChild;
    t = t.replaceChild(0, i.copy(x1(i.content, e + 1, n, r, i)));
  }
  if (e > r) {
    let i = o.contentMatchAt(0), s = i.fillBefore(t).append(t);
    t = s.append(i.matchFragment(s).fillBefore(D.empty, !0));
  }
  return t;
}
function ZL(t, e, n, r) {
  if (!r.isInline && e == n && t.doc.resolve(e).parent.content.size) {
    let o = UL(t.doc, e, r.type);
    o != null && (e = n = o);
  }
  t.replaceRange(e, n, new N(D.from(r), 0, 0));
}
function XL(t, e, n) {
  let r = t.doc.resolve(e), o = t.doc.resolve(n), i = E1(r, o);
  for (let s = 0; s < i.length; s++) {
    let l = i[s], a = s == i.length - 1;
    if (a && l == 0 || r.node(l).type.contentMatch.validEnd)
      return t.delete(r.start(l), o.end(l));
    if (l > 0 && (a || r.node(l - 1).canReplace(r.index(l - 1), o.indexAfter(l - 1))))
      return t.delete(r.before(l), o.after(l));
  }
  for (let s = 1; s <= r.depth && s <= o.depth; s++)
    if (e - r.start(s) == r.depth - s && n > r.end(s) && o.end(s) - n != o.depth - s && r.start(s - 1) == o.start(s - 1) && r.node(s - 1).canReplace(r.index(s - 1), o.index(s - 1)))
      return t.delete(r.before(s), n);
  t.delete(e, n);
}
function E1(t, e) {
  let n = [], r = Math.min(t.depth, e.depth);
  for (let o = r; o >= 0; o--) {
    let i = t.start(o);
    if (i < t.pos - (t.depth - o) || e.end(o) > e.pos + (e.depth - o) || t.node(o).type.spec.isolating || e.node(o).type.spec.isolating)
      break;
    (i == e.start(o) || o == t.depth && o == e.depth && t.parent.inlineContent && e.parent.inlineContent && o && e.start(o - 1) == i - 1) && n.push(o);
  }
  return n;
}
class Si extends dn {
  /**
  Construct an attribute step.
  */
  constructor(e, n, r) {
    super(), this.pos = e, this.attr = n, this.value = r;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return Vt.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in n.attrs)
      r[i] = n.attrs[i];
    r[this.attr] = this.value;
    let o = n.type.create(r, null, n.marks);
    return Vt.fromReplace(e, this.pos, this.pos + 1, new N(D.from(o), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return kn.empty;
  }
  invert(e) {
    return new Si(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Si(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Si(n.pos, n.attr, n.value);
  }
}
dn.jsonID("attr", Si);
class Ns extends dn {
  /**
  Construct an attribute step.
  */
  constructor(e, n) {
    super(), this.attr = e, this.value = n;
  }
  apply(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let o in e.attrs)
      n[o] = e.attrs[o];
    n[this.attr] = this.value;
    let r = e.type.create(n, e.content, e.marks);
    return Vt.ok(r);
  }
  getMap() {
    return kn.empty;
  }
  invert(e) {
    return new Ns(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Ns(n.attr, n.value);
  }
}
dn.jsonID("docAttr", Ns);
let Di = class extends Error {
};
Di = function t(e) {
  let n = Error.call(this, e);
  return n.__proto__ = t.prototype, n;
};
Di.prototype = Object.create(Error.prototype);
Di.prototype.constructor = Di;
Di.prototype.name = "TransformError";
class _f {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new wi();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let n = this.maybeStep(e);
    if (n.failed)
      throw new Di(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let n = e.apply(this.doc);
    return n.failed || this.addStep(e, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, n = e, r = N.empty) {
    let o = vc(this.doc, e, n, r);
    return o && this.step(o), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, n, r) {
    return this.replace(e, n, new N(D.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, n) {
    return this.replace(e, n, N.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, n) {
    return this.replaceWith(e, e, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, n, r) {
    return YL(this, e, n, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, n, r) {
    return ZL(this, e, n, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, n) {
    return XL(this, e, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, n) {
    return _L(this, e, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, n = 1) {
    return GL(this, e, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, n) {
    return FL(this, e, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, n = e, r, o = null) {
    return NL(this, e, n, r, o), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, n, r = null, o) {
    return HL(this, e, n, r, o), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, n, r) {
    return this.step(new Si(e, n, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, n) {
    return this.step(new Ns(e, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, n) {
    return this.step(new so(e, n)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, n) {
    if (!(n instanceof it)) {
      let r = this.doc.nodeAt(e);
      if (!r)
        throw new RangeError("No node at position " + e);
      if (n = n.isInSet(r.marks), !n)
        return this;
    }
    return this.step(new Oi(e, n)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(e, n = 1, r) {
    return jL(this, e, n, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, n, r) {
    return LL(this, e, n, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, n, r) {
    return $L(this, e, n, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, n, r) {
    return $f(this, e, n, r), this;
  }
}
const ad = /* @__PURE__ */ Object.create(null);
class fe {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, n, r) {
    this.$anchor = e, this.$head = n, this.ranges = r || [new k1(e.min(n), e.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let n = 0; n < e.length; n++)
      if (e[n].$from.pos != e[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, n = N.empty) {
    let r = n.content.lastChild, o = null;
    for (let l = 0; l < n.openEnd; l++)
      o = r, r = r.lastChild;
    let i = e.steps.length, s = this.ranges;
    for (let l = 0; l < s.length; l++) {
      let { $from: a, $to: c } = s[l], d = e.mapping.slice(i);
      e.replaceRange(d.map(a.pos), d.map(c.pos), l ? N.empty : n), l == 0 && ng(e, i, (r ? r.isInline : o && o.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, n) {
    let r = e.steps.length, o = this.ranges;
    for (let i = 0; i < o.length; i++) {
      let { $from: s, $to: l } = o[i], a = e.mapping.slice(r), c = a.map(s.pos), d = a.map(l.pos);
      i ? e.deleteRange(c, d) : (e.replaceRangeWith(c, d, n), ng(e, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, n, r = !1) {
    let o = e.parent.inlineContent ? new ce(e) : di(e.node(0), e.parent, e.pos, e.index(), n, r);
    if (o)
      return o;
    for (let i = e.depth - 1; i >= 0; i--) {
      let s = n < 0 ? di(e.node(0), e.node(i), e.before(i + 1), e.index(i), n, r) : di(e.node(0), e.node(i), e.after(i + 1), e.index(i) + 1, n, r);
      if (s)
        return s;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, n = 1) {
    return this.findFrom(e, n) || this.findFrom(e, -n) || new jn(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return di(e, e, 0, 0, 1) || new jn(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return di(e, e, e.content.size, e.childCount, -1) || new jn(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = ad[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, n) {
    if (e in ad)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return ad[e] = n, n.prototype.jsonID = e, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return ce.between(this.$anchor, this.$head).getBookmark();
  }
}
fe.prototype.visible = !0;
class k1 {
  /**
  Create a range.
  */
  constructor(e, n) {
    this.$from = e, this.$to = n;
  }
}
let eg = !1;
function tg(t) {
  !eg && !t.parent.inlineContent && (eg = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + t.parent.type.name + ")"));
}
class ce extends fe {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, n = e) {
    tg(e), tg(n), super(e, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return fe.near(r);
    let o = e.resolve(n.map(this.anchor));
    return new ce(o.parent.inlineContent ? o : r, r);
  }
  replace(e, n = N.empty) {
    if (super.replace(e, n), n == N.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof ce && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new xc(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new ce(e.resolve(n.anchor), e.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, n, r = n) {
    let o = e.resolve(n);
    return new this(o, r == n ? o : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, n, r) {
    let o = e.pos - n.pos;
    if ((!r || o) && (r = o >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let i = fe.findFrom(n, r, !0) || fe.findFrom(n, -r, !0);
      if (i)
        n = i.$head;
      else
        return fe.near(n, r);
    }
    return e.parent.inlineContent || (o == 0 ? e = n : (e = (fe.findFrom(e, -r, !0) || fe.findFrom(e, r, !0)).$anchor, e.pos < n.pos != o < 0 && (e = n))), new ce(e, n);
  }
}
fe.jsonID("text", ce);
class xc {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new xc(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return ce.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class le extends fe {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let n = e.nodeAfter, r = e.node(0).resolve(e.pos + n.nodeSize);
    super(e, r), this.node = n;
  }
  map(e, n) {
    let { deleted: r, pos: o } = n.mapResult(this.anchor), i = e.resolve(o);
    return r ? fe.near(i) : new le(i);
  }
  content() {
    return new N(D.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof le && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new Bf(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new le(e.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, n) {
    return new le(e.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
le.prototype.visible = !1;
fe.jsonID("node", le);
class Bf {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: n, pos: r } = e.mapResult(this.anchor);
    return n ? new xc(r, r) : new Bf(r);
  }
  resolve(e) {
    let n = e.resolve(this.anchor), r = n.nodeAfter;
    return r && le.isSelectable(r) ? new le(n) : fe.near(n);
  }
}
class jn extends fe {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, n = N.empty) {
    if (n == N.empty) {
      e.delete(0, e.doc.content.size);
      let r = fe.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new jn(e);
  }
  map(e) {
    return new jn(e);
  }
  eq(e) {
    return e instanceof jn;
  }
  getBookmark() {
    return QL;
  }
}
fe.jsonID("all", jn);
const QL = {
  map() {
    return this;
  },
  resolve(t) {
    return new jn(t);
  }
};
function di(t, e, n, r, o, i = !1) {
  if (e.inlineContent)
    return ce.create(t, n);
  for (let s = r - (o > 0 ? 0 : 1); o > 0 ? s < e.childCount : s >= 0; s += o) {
    let l = e.child(s);
    if (l.isAtom) {
      if (!i && le.isSelectable(l))
        return le.create(t, n - (o < 0 ? l.nodeSize : 0));
    } else {
      let a = di(t, l, n + o, o < 0 ? l.childCount : 0, o, i);
      if (a)
        return a;
    }
    n += l.nodeSize * o;
  }
  return null;
}
function ng(t, e, n) {
  let r = t.steps.length - 1;
  if (r < e)
    return;
  let o = t.steps[r];
  if (!(o instanceof zt || o instanceof Ht))
    return;
  let i = t.mapping.maps[r], s;
  i.forEach((l, a, c, d) => {
    s == null && (s = d);
  }), t.setSelection(fe.near(t.doc.resolve(s), n));
}
const rg = 1, og = 2, ig = 4;
class e$ extends _f {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | rg) & -3, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & rg) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= og, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return it.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & og) > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    super.addStep(e, n), this.updated = this.updated & -3, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, n = !0) {
    let r = this.selection;
    return n && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || it.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, n, r) {
    let o = this.doc.type.schema;
    if (n == null)
      return e ? this.replaceSelectionWith(o.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = n), r = r ?? n, !e)
        return this.deleteRange(n, r);
      let i = this.storedMarks;
      if (!i) {
        let s = this.doc.resolve(n);
        i = r == n ? s.marks() : s.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(n, r, o.text(e, i)), this.selection.empty || this.setSelection(fe.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, n) {
    return this.meta[typeof e == "string" ? e : e.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= ig, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & ig) > 0;
  }
}
function sg(t, e) {
  return !e || !t ? t : t.bind(e);
}
class ps {
  constructor(e, n, r) {
    this.name = e, this.init = sg(n.init, r), this.apply = sg(n.apply, r);
  }
}
const t$ = [
  new ps("doc", {
    init(t) {
      return t.doc || t.schema.topNodeType.createAndFill();
    },
    apply(t) {
      return t.doc;
    }
  }),
  new ps("selection", {
    init(t, e) {
      return t.selection || fe.atStart(e.doc);
    },
    apply(t) {
      return t.selection;
    }
  }),
  new ps("storedMarks", {
    init(t) {
      return t.storedMarks || null;
    },
    apply(t, e, n, r) {
      return r.selection.$cursor ? t.storedMarks : null;
    }
  }),
  new ps("scrollToSelection", {
    init() {
      return 0;
    },
    apply(t, e) {
      return t.scrolledIntoView ? e + 1 : e;
    }
  })
];
class cd {
  constructor(e, n) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = t$.slice(), n && n.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new ps(r.key, r.spec.state, r));
    });
  }
}
class pi {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, n = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != n) {
        let o = this.config.plugins[r];
        if (o.spec.filterTransaction && !o.spec.filterTransaction.call(o, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let n = [e], r = this.applyInner(e), o = null;
    for (; ; ) {
      let i = !1;
      for (let s = 0; s < this.config.plugins.length; s++) {
        let l = this.config.plugins[s];
        if (l.spec.appendTransaction) {
          let a = o ? o[s].n : 0, c = o ? o[s].state : this, d = a < n.length && l.spec.appendTransaction.call(l, a ? n.slice(a) : n, c, r);
          if (d && r.filterTransaction(d, s)) {
            if (d.setMeta("appendedTransaction", e), !o) {
              o = [];
              for (let u = 0; u < this.config.plugins.length; u++)
                o.push(u < s ? { state: r, n: n.length } : { state: this, n: 0 });
            }
            n.push(d), r = r.applyInner(d), i = !0;
          }
          o && (o[s] = { state: r, n: n.length });
        }
      }
      if (!i)
        return { state: r, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new pi(this.config), r = this.config.fields;
    for (let o = 0; o < r.length; o++) {
      let i = r[o];
      n[i.name] = i.apply(e, this[i.name], this, n);
    }
    return n;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new e$(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let n = new cd(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new pi(n);
    for (let o = 0; o < n.fields.length; o++)
      r[n.fields[o].name] = n.fields[o].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let n = new cd(this.schema, e.plugins), r = n.fields, o = new pi(n);
    for (let i = 0; i < r.length; i++) {
      let s = r[i].name;
      o[s] = this.hasOwnProperty(s) ? this[s] : r[i].init(e, o);
    }
    return o;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let o = e[r], i = o.spec.state;
        i && i.toJSON && (n[r] = i.toJSON.call(o, this[o.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, n, r) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let o = new cd(e.schema, e.plugins), i = new pi(o);
    return o.fields.forEach((s) => {
      if (s.name == "doc")
        i.doc = uo.fromJSON(e.schema, n.doc);
      else if (s.name == "selection")
        i.selection = fe.fromJSON(i.doc, n.selection);
      else if (s.name == "storedMarks")
        n.storedMarks && (i.storedMarks = n.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let l in r) {
            let a = r[l], c = a.spec.state;
            if (a.key == s.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(n, l)) {
              i[s.name] = c.fromJSON.call(a, e, n[l], i);
              return;
            }
          }
        i[s.name] = s.init(e, i);
      }
    }), i;
  }
}
function T1(t, e, n) {
  for (let r in t) {
    let o = t[r];
    o instanceof Function ? o = o.bind(e) : r == "handleDOMEvents" && (o = T1(o, e, {})), n[r] = o;
  }
  return n;
}
class Ft {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && T1(e.props, this, this.props), this.key = e.key ? e.key.key : I1("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const dd = /* @__PURE__ */ Object.create(null);
function I1(t) {
  return t in dd ? t + "$" + ++dd[t] : (dd[t] = 0, t + "$");
}
class tn {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = I1(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Xt = function(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}, zs = function(t) {
  let e = t.assignedSlot || t.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let yu = null;
const Or = function(t, e, n) {
  let r = yu || (yu = document.createRange());
  return r.setEnd(t, n ?? t.nodeValue.length), r.setStart(t, e || 0), r;
}, n$ = function() {
  yu = null;
}, jo = function(t, e, n, r) {
  return n && (lg(t, e, n, r, -1) || lg(t, e, n, r, 1));
}, r$ = /^(img|br|input|textarea|hr)$/i;
function lg(t, e, n, r, o) {
  for (; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (o < 0 ? 0 : Nn(t))) {
      let i = t.parentNode;
      if (!i || i.nodeType != 1 || ll(t) || r$.test(t.nodeName) || t.contentEditable == "false")
        return !1;
      e = Xt(t) + (o < 0 ? 0 : 1), t = i;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (o < 0 ? -1 : 0)], t.contentEditable == "false")
        return !1;
      e = o < 0 ? Nn(t) : 0;
    } else
      return !1;
  }
}
function Nn(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function o$(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e)
      return t;
    if (t.nodeType == 1 && e > 0) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e - 1], e = Nn(t);
    } else if (t.parentNode && !ll(t))
      e = Xt(t), t = t.parentNode;
    else
      return null;
  }
}
function i$(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e < t.nodeValue.length)
      return t;
    if (t.nodeType == 1 && e < t.childNodes.length) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e], e = 0;
    } else if (t.parentNode && !ll(t))
      e = Xt(t) + 1, t = t.parentNode;
    else
      return null;
  }
}
function s$(t, e, n) {
  for (let r = e == 0, o = e == Nn(t); r || o; ) {
    if (t == n)
      return !0;
    let i = Xt(t);
    if (t = t.parentNode, !t)
      return !1;
    r = r && i == 0, o = o && i == Nn(t);
  }
}
function ll(t) {
  let e;
  for (let n = t; n && !(e = n.pmViewDesc); n = n.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == t || e.contentDOM == t);
}
const Ec = function(t) {
  return t.focusNode && jo(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset);
};
function Io(t, e) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = t, n.key = n.code = e, n;
}
function l$(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function a$(t, e, n) {
  if (t.caretPositionFromPoint)
    try {
      let r = t.caretPositionFromPoint(e, n);
      if (r)
        return { node: r.offsetNode, offset: Math.min(Nn(r.offsetNode), r.offset) };
    } catch {
    }
  if (t.caretRangeFromPoint) {
    let r = t.caretRangeFromPoint(e, n);
    if (r)
      return { node: r.startContainer, offset: Math.min(Nn(r.startContainer), r.startOffset) };
  }
}
const yr = typeof navigator < "u" ? navigator : null, ag = typeof document < "u" ? document : null, vo = yr && yr.userAgent || "", bu = /Edge\/(\d+)/.exec(vo), M1 = /MSIE \d/.exec(vo), wu = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(vo), Cn = !!(M1 || wu || bu), ho = M1 ? document.documentMode : wu ? +wu[1] : bu ? +bu[1] : 0, or = !Cn && /gecko\/(\d+)/i.test(vo);
or && +(/Firefox\/(\d+)/.exec(vo) || [0, 0])[1];
const Su = !Cn && /Chrome\/(\d+)/.exec(vo), on = !!Su, R1 = Su ? +Su[1] : 0, gn = !Cn && !!yr && /Apple Computer/.test(yr.vendor), Ai = gn && (/Mobile\/\w+/.test(vo) || !!yr && yr.maxTouchPoints > 2), Bn = Ai || (yr ? /Mac/.test(yr.platform) : !1), c$ = yr ? /Win/.test(yr.platform) : !1, Xn = /Android \d/.test(vo), al = !!ag && "webkitFontSmoothing" in ag.documentElement.style, d$ = al ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function u$(t) {
  let e = t.defaultView && t.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.documentElement.clientWidth,
    top: 0,
    bottom: t.documentElement.clientHeight
  };
}
function Er(t, e) {
  return typeof t == "number" ? t : t[e];
}
function f$(t) {
  let e = t.getBoundingClientRect(), n = e.width / t.offsetWidth || 1, r = e.height / t.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + t.clientWidth * n,
    top: e.top,
    bottom: e.top + t.clientHeight * r
  };
}
function cg(t, e, n) {
  let r = t.someProp("scrollThreshold") || 0, o = t.someProp("scrollMargin") || 5, i = t.dom.ownerDocument;
  for (let s = n || t.dom; s; s = zs(s)) {
    if (s.nodeType != 1)
      continue;
    let l = s, a = l == i.body, c = a ? u$(i) : f$(l), d = 0, u = 0;
    if (e.top < c.top + Er(r, "top") ? u = -(c.top - e.top + Er(o, "top")) : e.bottom > c.bottom - Er(r, "bottom") && (u = e.bottom - e.top > c.bottom - c.top ? e.top + Er(o, "top") - c.top : e.bottom - c.bottom + Er(o, "bottom")), e.left < c.left + Er(r, "left") ? d = -(c.left - e.left + Er(o, "left")) : e.right > c.right - Er(r, "right") && (d = e.right - c.right + Er(o, "right")), d || u)
      if (a)
        i.defaultView.scrollBy(d, u);
      else {
        let f = l.scrollLeft, h = l.scrollTop;
        u && (l.scrollTop += u), d && (l.scrollLeft += d);
        let p = l.scrollLeft - f, y = l.scrollTop - h;
        e = { left: e.left - p, top: e.top - y, right: e.right - p, bottom: e.bottom - y };
      }
    if (a || /^(fixed|sticky)$/.test(getComputedStyle(s).position))
      break;
  }
}
function h$(t) {
  let e = t.dom.getBoundingClientRect(), n = Math.max(0, e.top), r, o;
  for (let i = (e.left + e.right) / 2, s = n + 1; s < Math.min(innerHeight, e.bottom); s += 5) {
    let l = t.root.elementFromPoint(i, s);
    if (!l || l == t.dom || !t.dom.contains(l))
      continue;
    let a = l.getBoundingClientRect();
    if (a.top >= n - 20) {
      r = l, o = a.top;
      break;
    }
  }
  return { refDOM: r, refTop: o, stack: O1(t.dom) };
}
function O1(t) {
  let e = [], n = t.ownerDocument;
  for (let r = t; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), t != n); r = zs(r))
    ;
  return e;
}
function p$({ refDOM: t, refTop: e, stack: n }) {
  let r = t ? t.getBoundingClientRect().top : 0;
  D1(n, r == 0 ? 0 : r - e);
}
function D1(t, e) {
  for (let n = 0; n < t.length; n++) {
    let { dom: r, top: o, left: i } = t[n];
    r.scrollTop != o + e && (r.scrollTop = o + e), r.scrollLeft != i && (r.scrollLeft = i);
  }
}
let li = null;
function g$(t) {
  if (t.setActive)
    return t.setActive();
  if (li)
    return t.focus(li);
  let e = O1(t);
  t.focus(li == null ? {
    get preventScroll() {
      return li = { preventScroll: !0 }, !0;
    }
  } : void 0), li || (li = !1, D1(e, 0));
}
function A1(t, e) {
  let n, r = 2e8, o, i = 0, s = e.top, l = e.top, a, c;
  for (let d = t.firstChild, u = 0; d; d = d.nextSibling, u++) {
    let f;
    if (d.nodeType == 1)
      f = d.getClientRects();
    else if (d.nodeType == 3)
      f = Or(d).getClientRects();
    else
      continue;
    for (let h = 0; h < f.length; h++) {
      let p = f[h];
      if (p.top <= s && p.bottom >= l) {
        s = Math.max(p.bottom, s), l = Math.min(p.top, l);
        let y = p.left > e.left ? p.left - e.left : p.right < e.left ? e.left - p.right : 0;
        if (y < r) {
          n = d, r = y, o = y && n.nodeType == 3 ? {
            left: p.right < e.left ? p.right : p.left,
            top: e.top
          } : e, d.nodeType == 1 && y && (i = u + (e.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > e.top && !a && p.left <= e.left && p.right >= e.left && (a = d, c = { left: Math.max(p.left, Math.min(p.right, e.left)), top: p.top });
      !n && (e.left >= p.right && e.top >= p.top || e.left >= p.left && e.top >= p.bottom) && (i = u + 1);
    }
  }
  return !n && a && (n = a, o = c, r = 0), n && n.nodeType == 3 ? m$(n, o) : !n || r && n.nodeType == 1 ? { node: t, offset: i } : A1(n, o);
}
function m$(t, e) {
  let n = t.nodeValue.length, r = document.createRange();
  for (let o = 0; o < n; o++) {
    r.setEnd(t, o + 1), r.setStart(t, o);
    let i = Jr(r, 1);
    if (i.top != i.bottom && Vf(e, i))
      return { node: t, offset: o + (e.left >= (i.left + i.right) / 2 ? 1 : 0) };
  }
  return { node: t, offset: 0 };
}
function Vf(t, e) {
  return t.left >= e.left - 1 && t.left <= e.right + 1 && t.top >= e.top - 1 && t.top <= e.bottom + 1;
}
function y$(t, e) {
  let n = t.parentNode;
  return n && /^li$/i.test(n.nodeName) && e.left < t.getBoundingClientRect().left ? n : t;
}
function b$(t, e, n) {
  let { node: r, offset: o } = A1(e, n), i = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let s = r.getBoundingClientRect();
    i = s.left != s.right && n.left > (s.left + s.right) / 2 ? 1 : -1;
  }
  return t.docView.posFromDOM(r, o, i);
}
function w$(t, e, n, r) {
  let o = -1;
  for (let i = e, s = !1; i != t.dom; ) {
    let l = t.docView.nearestDesc(i, !0);
    if (!l)
      return null;
    if (l.dom.nodeType == 1 && (l.node.isBlock && l.parent || !l.contentDOM)) {
      let a = l.dom.getBoundingClientRect();
      if (l.node.isBlock && l.parent && (!s && a.left > r.left || a.top > r.top ? o = l.posBefore : (!s && a.right < r.left || a.bottom < r.top) && (o = l.posAfter), s = !0), !l.contentDOM && o < 0 && !l.node.isText)
        return (l.node.isBlock ? r.top < (a.top + a.bottom) / 2 : r.left < (a.left + a.right) / 2) ? l.posBefore : l.posAfter;
    }
    i = l.dom.parentNode;
  }
  return o > -1 ? o : t.docView.posFromDOM(e, n, -1);
}
function L1(t, e, n) {
  let r = t.childNodes.length;
  if (r && n.top < n.bottom)
    for (let o = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - n.top) / (n.bottom - n.top)) - 2)), i = o; ; ) {
      let s = t.childNodes[i];
      if (s.nodeType == 1) {
        let l = s.getClientRects();
        for (let a = 0; a < l.length; a++) {
          let c = l[a];
          if (Vf(e, c))
            return L1(s, e, c);
        }
      }
      if ((i = (i + 1) % r) == o)
        break;
    }
  return t;
}
function S$(t, e) {
  let n = t.dom.ownerDocument, r, o = 0, i = a$(n, e.left, e.top);
  i && ({ node: r, offset: o } = i);
  let s = (t.root.elementFromPoint ? t.root : n).elementFromPoint(e.left, e.top), l;
  if (!s || !t.dom.contains(s.nodeType != 1 ? s.parentNode : s)) {
    let c = t.dom.getBoundingClientRect();
    if (!Vf(e, c) || (s = L1(t.dom, e, c), !s))
      return null;
  }
  if (gn)
    for (let c = s; r && c; c = zs(c))
      c.draggable && (r = void 0);
  if (s = y$(s, e), r) {
    if (or && r.nodeType == 1 && (o = Math.min(o, r.childNodes.length), o < r.childNodes.length)) {
      let d = r.childNodes[o], u;
      d.nodeName == "IMG" && (u = d.getBoundingClientRect()).right <= e.left && u.bottom > e.top && o++;
    }
    let c;
    al && o && r.nodeType == 1 && (c = r.childNodes[o - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && o--, r == t.dom && o == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? l = t.state.doc.content.size : (o == 0 || r.nodeType != 1 || r.childNodes[o - 1].nodeName != "BR") && (l = w$(t, r, o, e));
  }
  l == null && (l = b$(t, s, e));
  let a = t.docView.nearestDesc(s, !0);
  return { pos: l, inside: a ? a.posAtStart - a.border : -1 };
}
function dg(t) {
  return t.top < t.bottom || t.left < t.right;
}
function Jr(t, e) {
  let n = t.getClientRects();
  if (n.length) {
    let r = n[e < 0 ? 0 : n.length - 1];
    if (dg(r))
      return r;
  }
  return Array.prototype.find.call(n, dg) || t.getBoundingClientRect();
}
const C$ = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function $1(t, e, n) {
  let { node: r, offset: o, atom: i } = t.docView.domFromPos(e, n < 0 ? -1 : 1), s = al || or;
  if (r.nodeType == 3)
    if (s && (C$.test(r.nodeValue) || (n < 0 ? !o : o == r.nodeValue.length))) {
      let a = Jr(Or(r, o, o), n);
      if (or && o && /\s/.test(r.nodeValue[o - 1]) && o < r.nodeValue.length) {
        let c = Jr(Or(r, o - 1, o - 1), -1);
        if (c.top == a.top) {
          let d = Jr(Or(r, o, o + 1), -1);
          if (d.top != a.top)
            return ts(d, d.left < c.left);
        }
      }
      return a;
    } else {
      let a = o, c = o, d = n < 0 ? 1 : -1;
      return n < 0 && !o ? (c++, d = -1) : n >= 0 && o == r.nodeValue.length ? (a--, d = 1) : n < 0 ? a-- : c++, ts(Jr(Or(r, a, c), d), d < 0);
    }
  if (!t.state.doc.resolve(e - (i || 0)).parent.inlineContent) {
    if (i == null && o && (n < 0 || o == Nn(r))) {
      let a = r.childNodes[o - 1];
      if (a.nodeType == 1)
        return ud(a.getBoundingClientRect(), !1);
    }
    if (i == null && o < Nn(r)) {
      let a = r.childNodes[o];
      if (a.nodeType == 1)
        return ud(a.getBoundingClientRect(), !0);
    }
    return ud(r.getBoundingClientRect(), n >= 0);
  }
  if (i == null && o && (n < 0 || o == Nn(r))) {
    let a = r.childNodes[o - 1], c = a.nodeType == 3 ? Or(a, Nn(a) - (s ? 0 : 1)) : a.nodeType == 1 && (a.nodeName != "BR" || !a.nextSibling) ? a : null;
    if (c)
      return ts(Jr(c, 1), !1);
  }
  if (i == null && o < Nn(r)) {
    let a = r.childNodes[o];
    for (; a.pmViewDesc && a.pmViewDesc.ignoreForCoords; )
      a = a.nextSibling;
    let c = a ? a.nodeType == 3 ? Or(a, 0, s ? 0 : 1) : a.nodeType == 1 ? a : null : null;
    if (c)
      return ts(Jr(c, -1), !0);
  }
  return ts(Jr(r.nodeType == 3 ? Or(r) : r, -n), n >= 0);
}
function ts(t, e) {
  if (t.width == 0)
    return t;
  let n = e ? t.left : t.right;
  return { top: t.top, bottom: t.bottom, left: n, right: n };
}
function ud(t, e) {
  if (t.height == 0)
    return t;
  let n = e ? t.top : t.bottom;
  return { top: n, bottom: n, left: t.left, right: t.right };
}
function P1(t, e, n) {
  let r = t.state, o = t.root.activeElement;
  r != e && t.updateState(e), o != t.dom && t.focus();
  try {
    return n();
  } finally {
    r != e && t.updateState(r), o != t.dom && o && o.focus();
  }
}
function v$(t, e, n) {
  let r = e.selection, o = n == "up" ? r.$from : r.$to;
  return P1(t, e, () => {
    let { node: i } = t.docView.domFromPos(o.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let l = t.docView.nearestDesc(i, !0);
      if (!l)
        break;
      if (l.node.isBlock) {
        i = l.contentDOM || l.dom;
        break;
      }
      i = l.dom.parentNode;
    }
    let s = $1(t, o.pos, 1);
    for (let l = i.firstChild; l; l = l.nextSibling) {
      let a;
      if (l.nodeType == 1)
        a = l.getClientRects();
      else if (l.nodeType == 3)
        a = Or(l, 0, l.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < a.length; c++) {
        let d = a[c];
        if (d.bottom > d.top + 1 && (n == "up" ? s.top - d.top > (d.bottom - s.top) * 2 : d.bottom - s.bottom > (s.bottom - d.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const x$ = /[\u0590-\u08ac]/;
function E$(t, e, n) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let o = r.parentOffset, i = !o, s = o == r.parent.content.size, l = t.domSelection();
  return l ? !x$.test(r.parent.textContent) || !l.modify ? n == "left" || n == "backward" ? i : s : P1(t, e, () => {
    let { focusNode: a, focusOffset: c, anchorNode: d, anchorOffset: u } = t.domSelectionRange(), f = l.caretBidiLevel;
    l.modify("move", n, "character");
    let h = r.depth ? t.docView.domAfterPos(r.before()) : t.dom, { focusNode: p, focusOffset: y } = t.domSelectionRange(), b = p && !h.contains(p.nodeType == 1 ? p : p.parentNode) || a == p && c == y;
    try {
      l.collapse(d, u), a && (a != d || c != u) && l.extend && l.extend(a, c);
    } catch {
    }
    return f != null && (l.caretBidiLevel = f), b;
  }) : r.pos == r.start() || r.pos == r.end();
}
let ug = null, fg = null, hg = !1;
function k$(t, e, n) {
  return ug == e && fg == n ? hg : (ug = e, fg = n, hg = n == "up" || n == "down" ? v$(t, e, n) : E$(t, e, n));
}
const Wn = 0, pg = 1, Ro = 2, br = 3;
class cl {
  constructor(e, n, r, o) {
    this.parent = e, this.children = n, this.dom = r, this.contentDOM = o, this.dirty = Wn, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, n, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let n = 0; n < this.children.length; n++)
      e += this.children[n].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let n = 0, r = this.posAtStart; ; n++) {
      let o = this.children[n];
      if (o == e)
        return r;
      r += o.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, n, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let i, s;
        if (e == this.contentDOM)
          i = e.childNodes[n - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          i = e.previousSibling;
        }
        for (; i && !((s = i.pmViewDesc) && s.parent == this); )
          i = i.previousSibling;
        return i ? this.posBeforeChild(s) + s.size : this.posAtStart;
      } else {
        let i, s;
        if (e == this.contentDOM)
          i = e.childNodes[n];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          i = e.nextSibling;
        }
        for (; i && !((s = i.pmViewDesc) && s.parent == this); )
          i = i.nextSibling;
        return i ? this.posBeforeChild(s) : this.posAtEnd;
      }
    let o;
    if (e == this.dom && this.contentDOM)
      o = n > Xt(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      o = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let i = e; ; i = i.parentNode) {
          if (i == this.dom) {
            o = !1;
            break;
          }
          if (i.previousSibling)
            break;
        }
      if (o == null && n == e.childNodes.length)
        for (let i = e; ; i = i.parentNode) {
          if (i == this.dom) {
            o = !0;
            break;
          }
          if (i.nextSibling)
            break;
        }
    }
    return o ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, n = !1) {
    for (let r = !0, o = e; o; o = o.parentNode) {
      let i = this.getDesc(o), s;
      if (i && (!n || i.node))
        if (r && (s = i.nodeDOM) && !(s.nodeType == 1 ? s.contains(e.nodeType == 1 ? e : e.parentNode) : s == e))
          r = !1;
        else
          return i;
    }
  }
  getDesc(e) {
    let n = e.pmViewDesc;
    for (let r = n; r; r = r.parent)
      if (r == this)
        return n;
  }
  posFromDOM(e, n, r) {
    for (let o = e; o; o = o.parentNode) {
      let i = this.getDesc(o);
      if (i)
        return i.localPosFromDOM(e, n, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let n = 0, r = 0; n < this.children.length; n++) {
      let o = this.children[n], i = r + o.size;
      if (r == e && i != r) {
        for (; !o.border && o.children.length; )
          o = o.children[0];
        return o;
      }
      if (e < i)
        return o.descAt(e - r - o.border);
      r = i;
    }
  }
  domFromPos(e, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, o = 0;
    for (let i = 0; r < this.children.length; r++) {
      let s = this.children[r], l = i + s.size;
      if (l > e || s instanceof B1) {
        o = e - i;
        break;
      }
      i = l;
    }
    if (o)
      return this.children[r].domFromPos(o - this.children[r].border, n);
    for (let i; r && !(i = this.children[r - 1]).size && i instanceof _1 && i.side >= 0; r--)
      ;
    if (n <= 0) {
      let i, s = !0;
      for (; i = r ? this.children[r - 1] : null, !(!i || i.dom.parentNode == this.contentDOM); r--, s = !1)
        ;
      return i && n && s && !i.border && !i.domAtom ? i.domFromPos(i.size, n) : { node: this.contentDOM, offset: i ? Xt(i.dom) + 1 : 0 };
    } else {
      let i, s = !0;
      for (; i = r < this.children.length ? this.children[r] : null, !(!i || i.dom.parentNode == this.contentDOM); r++, s = !1)
        ;
      return i && s && !i.border && !i.domAtom ? i.domFromPos(0, n) : { node: this.contentDOM, offset: i ? Xt(i.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, n, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let o = -1, i = -1;
    for (let s = r, l = 0; ; l++) {
      let a = this.children[l], c = s + a.size;
      if (o == -1 && e <= c) {
        let d = s + a.border;
        if (e >= d && n <= c - a.border && a.node && a.contentDOM && this.contentDOM.contains(a.contentDOM))
          return a.parseRange(e, n, d);
        e = s;
        for (let u = l; u > 0; u--) {
          let f = this.children[u - 1];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(1)) {
            o = Xt(f.dom) + 1;
            break;
          }
          e -= f.size;
        }
        o == -1 && (o = 0);
      }
      if (o > -1 && (c > n || l == this.children.length - 1)) {
        n = c;
        for (let d = l + 1; d < this.children.length; d++) {
          let u = this.children[d];
          if (u.size && u.dom.parentNode == this.contentDOM && !u.emptyChildAt(-1)) {
            i = Xt(u.dom);
            break;
          }
          n += u.size;
        }
        i == -1 && (i = this.contentDOM.childNodes.length);
        break;
      }
      s = c;
    }
    return { node: this.contentDOM, from: e, to: n, fromOffset: o, toOffset: i };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[e < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: n, offset: r } = this.domFromPos(e, 0);
    if (n.nodeType != 1 || r == n.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return n.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, n, r, o = !1) {
    let i = Math.min(e, n), s = Math.max(e, n);
    for (let h = 0, p = 0; h < this.children.length; h++) {
      let y = this.children[h], b = p + y.size;
      if (i > p && s < b)
        return y.setSelection(e - p - y.border, n - p - y.border, r, o);
      p = b;
    }
    let l = this.domFromPos(e, e ? -1 : 1), a = n == e ? l : this.domFromPos(n, n ? -1 : 1), c = r.root.getSelection(), d = r.domSelectionRange(), u = !1;
    if ((or || gn) && e == n) {
      let { node: h, offset: p } = l;
      if (h.nodeType == 3) {
        if (u = !!(p && h.nodeValue[p - 1] == `
`), u && p == h.nodeValue.length)
          for (let y = h, b; y; y = y.parentNode) {
            if (b = y.nextSibling) {
              b.nodeName == "BR" && (l = a = { node: b.parentNode, offset: Xt(b) + 1 });
              break;
            }
            let w = y.pmViewDesc;
            if (w && w.node && w.node.isBlock)
              break;
          }
      } else {
        let y = h.childNodes[p - 1];
        u = y && (y.nodeName == "BR" || y.contentEditable == "false");
      }
    }
    if (or && d.focusNode && d.focusNode != a.node && d.focusNode.nodeType == 1) {
      let h = d.focusNode.childNodes[d.focusOffset];
      h && h.contentEditable == "false" && (o = !0);
    }
    if (!(o || u && gn) && jo(l.node, l.offset, d.anchorNode, d.anchorOffset) && jo(a.node, a.offset, d.focusNode, d.focusOffset))
      return;
    let f = !1;
    if ((c.extend || e == n) && !u) {
      c.collapse(l.node, l.offset);
      try {
        e != n && c.extend(a.node, a.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (e > n) {
        let p = l;
        l = a, a = p;
      }
      let h = document.createRange();
      h.setEnd(a.node, a.offset), h.setStart(l.node, l.offset), c.removeAllRanges(), c.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, n) {
    for (let r = 0, o = 0; o < this.children.length; o++) {
      let i = this.children[o], s = r + i.size;
      if (r == s ? e <= s && n >= r : e < s && n > r) {
        let l = r + i.border, a = s - i.border;
        if (e >= l && n <= a) {
          this.dirty = e == r || n == s ? Ro : pg, e == l && n == a && (i.contentLost || i.dom.parentNode != this.contentDOM) ? i.dirty = br : i.markDirty(e - l, n - l);
          return;
        } else
          i.dirty = i.dom == i.contentDOM && i.dom.parentNode == this.contentDOM && !i.children.length ? Ro : br;
      }
      r = s;
    }
    this.dirty = Ro;
  }
  markParentsDirty() {
    let e = 1;
    for (let n = this.parent; n; n = n.parent, e++) {
      let r = e == 1 ? Ro : pg;
      n.dirty < r && (n.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class _1 extends cl {
  constructor(e, n, r, o) {
    let i, s = n.type.toDOM;
    if (typeof s == "function" && (s = s(r, () => {
      if (!i)
        return o;
      if (i.parent)
        return i.parent.posBeforeChild(i);
    })), !n.type.spec.raw) {
      if (s.nodeType != 1) {
        let l = document.createElement("span");
        l.appendChild(s), s = l;
      }
      s.contentEditable = "false", s.classList.add("ProseMirror-widget");
    }
    super(e, [], s, null), this.widget = n, this.widget = n, i = this;
  }
  matchesWidget(e) {
    return this.dirty == Wn && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let n = this.widget.spec.stopEvent;
    return n ? n(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class T$ extends cl {
  constructor(e, n, r, o) {
    super(e, [], n, null), this.textDOM = r, this.text = o;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, n) {
    return e != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class Wo extends cl {
  constructor(e, n, r, o, i) {
    super(e, [], r, o), this.mark = n, this.spec = i;
  }
  static create(e, n, r, o) {
    let i = o.nodeViews[n.type.name], s = i && i(n, o, r);
    return (!s || !s.dom) && (s = Qo.renderSpec(document, n.type.spec.toDOM(n, r), null, n.attrs)), new Wo(e, n, s.dom, s.contentDOM || s.dom, s);
  }
  parseRule() {
    return this.dirty & br || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != br && this.mark.eq(e);
  }
  markDirty(e, n) {
    if (super.markDirty(e, n), this.dirty != Wn) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = Wn;
    }
  }
  slice(e, n, r) {
    let o = Wo.create(this.parent, this.mark, !0, r), i = this.children, s = this.size;
    n < s && (i = vu(i, n, s, r)), e > 0 && (i = vu(i, 0, e, r));
    for (let l = 0; l < i.length; l++)
      i[l].parent = o;
    return o.children = i, o;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class po extends cl {
  constructor(e, n, r, o, i, s, l, a, c) {
    super(e, [], i, s), this.node = n, this.outerDeco = r, this.innerDeco = o, this.nodeDOM = l;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, n, r, o, i, s) {
    let l = i.nodeViews[n.type.name], a, c = l && l(n, i, () => {
      if (!a)
        return s;
      if (a.parent)
        return a.parent.posBeforeChild(a);
    }, r, o), d = c && c.dom, u = c && c.contentDOM;
    if (n.isText) {
      if (!d)
        d = document.createTextNode(n.text);
      else if (d.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else d || ({ dom: d, contentDOM: u } = Qo.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs));
    !u && !n.isText && d.nodeName != "BR" && (d.hasAttribute("contenteditable") || (d.contentEditable = "false"), n.type.spec.draggable && (d.draggable = !0));
    let f = d;
    return d = N1(d, r, n), c ? a = new I$(e, n, r, o, d, u || null, f, c, i, s + 1) : n.isText ? new kc(e, n, r, o, d, f, i) : new po(e, n, r, o, d, u || null, f, i, s + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let r = this.children[n];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => D.empty);
    }
    return e;
  }
  matchesNode(e, n, r) {
    return this.dirty == Wn && e.eq(this.node) && ka(n, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, n) {
    let r = this.node.inlineContent, o = n, i = e.composing ? this.localCompositionInfo(e, n) : null, s = i && i.pos > -1 ? i : null, l = i && i.pos < 0, a = new R$(this, s && s.node, e);
    A$(this.node, this.innerDeco, (c, d, u) => {
      c.spec.marks ? a.syncToMarks(c.spec.marks, r, e) : c.type.side >= 0 && !u && a.syncToMarks(d == this.node.childCount ? it.none : this.node.child(d).marks, r, e), a.placeWidget(c, e, o);
    }, (c, d, u, f) => {
      a.syncToMarks(c.marks, r, e);
      let h;
      a.findNodeMatch(c, d, u, f) || l && e.state.selection.from > o && e.state.selection.to < o + c.nodeSize && (h = a.findIndexWithChild(i.node)) > -1 && a.updateNodeAt(c, d, u, h, e) || a.updateNextNode(c, d, u, e, f, o) || a.addNode(c, d, u, e, o), o += c.nodeSize;
    }), a.syncToMarks([], r, e), this.node.isTextblock && a.addTextblockHacks(), a.destroyRest(), (a.changed || this.dirty == Ro) && (s && this.protectLocalComposition(e, s), V1(this.contentDOM, this.children, e), Ai && L$(this.dom));
  }
  localCompositionInfo(e, n) {
    let { from: r, to: o } = e.state.selection;
    if (!(e.state.selection instanceof ce) || r < n || o > n + this.node.content.size)
      return null;
    let i = e.input.compositionNode;
    if (!i || !this.dom.contains(i.parentNode))
      return null;
    if (this.node.inlineContent) {
      let s = i.nodeValue, l = $$(this.node.content, s, r - n, o - n);
      return l < 0 ? null : { node: i, pos: l, text: s };
    } else
      return { node: i, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: n, pos: r, text: o }) {
    if (this.getDesc(n))
      return;
    let i = n;
    for (; i.parentNode != this.contentDOM; i = i.parentNode) {
      for (; i.previousSibling; )
        i.parentNode.removeChild(i.previousSibling);
      for (; i.nextSibling; )
        i.parentNode.removeChild(i.nextSibling);
      i.pmViewDesc && (i.pmViewDesc = void 0);
    }
    let s = new T$(this, i, n, o);
    e.input.compositionNodes.push(s), this.children = vu(this.children, r, r + o.length, e, s);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, n, r, o) {
    return this.dirty == br || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, n, r, o), !0);
  }
  updateInner(e, n, r, o) {
    this.updateOuterDeco(n), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(o, this.posAtStart), this.dirty = Wn;
  }
  updateOuterDeco(e) {
    if (ka(e, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = F1(this.dom, this.nodeDOM, Cu(this.outerDeco, this.node, n), Cu(e, this.node, n)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function gg(t, e, n, r, o) {
  N1(r, e, t);
  let i = new po(void 0, t, e, n, r, r, r, o, 0);
  return i.contentDOM && i.updateChildren(o, 0), i;
}
class kc extends po {
  constructor(e, n, r, o, i, s, l) {
    super(e, n, r, o, i, null, s, l, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, n, r, o) {
    return this.dirty == br || this.dirty != Wn && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != Wn || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, o.trackWrites == this.nodeDOM && (o.trackWrites = null)), this.node = e, this.dirty = Wn, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, n, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(e, n, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, n, r) {
    let o = this.node.cut(e, n), i = document.createTextNode(o.text);
    return new kc(this.parent, o, this.outerDeco, this.innerDeco, i, i, r);
  }
  markDirty(e, n) {
    super.markDirty(e, n), this.dom != this.nodeDOM && (e == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = br);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class B1 extends cl {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == Wn && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class I$ extends po {
  constructor(e, n, r, o, i, s, l, a, c, d) {
    super(e, n, r, o, i, s, l, c, d), this.spec = a;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, n, r, o) {
    if (this.dirty == br)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let i = this.spec.update(e, n, r);
      return i && this.updateInner(e, n, r, o), i;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, n, r, o);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, n, r, o) {
    this.spec.setSelection ? this.spec.setSelection(e, n, r.root) : super.setSelection(e, n, r, o);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function V1(t, e, n) {
  let r = t.firstChild, o = !1;
  for (let i = 0; i < e.length; i++) {
    let s = e[i], l = s.dom;
    if (l.parentNode == t) {
      for (; l != r; )
        r = mg(r), o = !0;
      r = r.nextSibling;
    } else
      o = !0, t.insertBefore(l, r);
    if (s instanceof Wo) {
      let a = r ? r.previousSibling : t.lastChild;
      V1(s.contentDOM, s.children, n), r = a ? a.nextSibling : t.firstChild;
    }
  }
  for (; r; )
    r = mg(r), o = !0;
  o && n.trackWrites == t && (n.trackWrites = null);
}
const vs = function(t) {
  t && (this.nodeName = t);
};
vs.prototype = /* @__PURE__ */ Object.create(null);
const Oo = [new vs()];
function Cu(t, e, n) {
  if (t.length == 0)
    return Oo;
  let r = n ? Oo[0] : new vs(), o = [r];
  for (let i = 0; i < t.length; i++) {
    let s = t[i].type.attrs;
    if (s) {
      s.nodeName && o.push(r = new vs(s.nodeName));
      for (let l in s) {
        let a = s[l];
        a != null && (n && o.length == 1 && o.push(r = new vs(e.isInline ? "span" : "div")), l == "class" ? r.class = (r.class ? r.class + " " : "") + a : l == "style" ? r.style = (r.style ? r.style + ";" : "") + a : l != "nodeName" && (r[l] = a));
      }
    }
  }
  return o;
}
function F1(t, e, n, r) {
  if (n == Oo && r == Oo)
    return e;
  let o = e;
  for (let i = 0; i < r.length; i++) {
    let s = r[i], l = n[i];
    if (i) {
      let a;
      l && l.nodeName == s.nodeName && o != t && (a = o.parentNode) && a.nodeName.toLowerCase() == s.nodeName || (a = document.createElement(s.nodeName), a.pmIsDeco = !0, a.appendChild(o), l = Oo[0]), o = a;
    }
    M$(o, l || Oo[0], s);
  }
  return o;
}
function M$(t, e, n) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && t.removeAttribute(r);
  for (let r in n)
    r != "class" && r != "style" && r != "nodeName" && n[r] != e[r] && t.setAttribute(r, n[r]);
  if (e.class != n.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], o = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let i = 0; i < r.length; i++)
      o.indexOf(r[i]) == -1 && t.classList.remove(r[i]);
    for (let i = 0; i < o.length; i++)
      r.indexOf(o[i]) == -1 && t.classList.add(o[i]);
    t.classList.length == 0 && t.removeAttribute("class");
  }
  if (e.style != n.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, o;
      for (; o = r.exec(e.style); )
        t.style.removeProperty(o[1]);
    }
    n.style && (t.style.cssText += n.style);
  }
}
function N1(t, e, n) {
  return F1(t, t, Oo, Cu(e, n, t.nodeType != 1));
}
function ka(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].type.eq(e[n].type))
      return !1;
  return !0;
}
function mg(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class R$ {
  constructor(e, n, r) {
    this.lock = n, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = O$(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, n) {
    if (e != n) {
      for (let r = e; r < n; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, n - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, n, r) {
    let o = 0, i = this.stack.length >> 1, s = Math.min(i, e.length);
    for (; o < s && (o == i - 1 ? this.top : this.stack[o + 1 << 1]).matchesMark(e[o]) && e[o].type.spec.spanning !== !1; )
      o++;
    for (; o < i; )
      this.destroyRest(), this.top.dirty = Wn, this.index = this.stack.pop(), this.top = this.stack.pop(), i--;
    for (; i < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let l = -1;
      for (let a = this.index; a < Math.min(this.index + 3, this.top.children.length); a++) {
        let c = this.top.children[a];
        if (c.matchesMark(e[i]) && !this.isLocked(c.dom)) {
          l = a;
          break;
        }
      }
      if (l > -1)
        l > this.index && (this.changed = !0, this.destroyBetween(this.index, l)), this.top = this.top.children[this.index];
      else {
        let a = Wo.create(this.top, e[i], n, r);
        this.top.children.splice(this.index, 0, a), this.top = a, this.changed = !0;
      }
      this.index = 0, i++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, n, r, o) {
    let i = -1, s;
    if (o >= this.preMatch.index && (s = this.preMatch.matches[o - this.preMatch.index]).parent == this.top && s.matchesNode(e, n, r))
      i = this.top.children.indexOf(s, this.index);
    else
      for (let l = this.index, a = Math.min(this.top.children.length, l + 5); l < a; l++) {
        let c = this.top.children[l];
        if (c.matchesNode(e, n, r) && !this.preMatch.matched.has(c)) {
          i = l;
          break;
        }
      }
    return i < 0 ? !1 : (this.destroyBetween(this.index, i), this.index++, !0);
  }
  updateNodeAt(e, n, r, o, i) {
    let s = this.top.children[o];
    return s.dirty == br && s.dom == s.contentDOM && (s.dirty = Ro), s.update(e, n, r, i) ? (this.destroyBetween(this.index, o), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let n = e.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let o = this.index; o < this.top.children.length; o++)
            if (this.top.children[o] == r)
              return o;
        }
        return -1;
      }
      e = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, n, r, o, i, s) {
    for (let l = this.index; l < this.top.children.length; l++) {
      let a = this.top.children[l];
      if (a instanceof po) {
        let c = this.preMatch.matched.get(a);
        if (c != null && c != i)
          return !1;
        let d = a.dom, u, f = this.isLocked(d) && !(e.isText && a.node && a.node.isText && a.nodeDOM.nodeValue == e.text && a.dirty != br && ka(n, a.outerDeco));
        if (!f && a.update(e, n, r, o))
          return this.destroyBetween(this.index, l), a.dom != d && (this.changed = !0), this.index++, !0;
        if (!f && (u = this.recreateWrapper(a, e, n, r, o, s)))
          return this.destroyBetween(this.index, l), this.top.children[this.index] = u, u.contentDOM && (u.dirty = Ro, u.updateChildren(o, s + 1), u.dirty = Wn), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, n, r, o, i, s) {
    if (e.dirty || n.isAtom || !e.children.length || !e.node.content.eq(n.content) || !ka(r, e.outerDeco) || !o.eq(e.innerDeco))
      return null;
    let l = po.create(this.top, n, r, o, i, s);
    if (l.contentDOM) {
      l.children = e.children, e.children = [];
      for (let a of l.children)
        a.parent = l;
    }
    return e.destroy(), l;
  }
  // Insert the node as a newly created node desc.
  addNode(e, n, r, o, i) {
    let s = po.create(this.top, e, n, r, o, i);
    s.contentDOM && s.updateChildren(o, i + 1), this.top.children.splice(this.index++, 0, s), this.changed = !0;
  }
  placeWidget(e, n, r) {
    let o = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (o && o.matchesWidget(e) && (e == o.widget || !o.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let i = new _1(this.top, e, n, r);
      this.top.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], n = this.top;
    for (; e instanceof Wo; )
      n = e, e = n.children[n.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof kc) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((gn || on) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(e, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let o = new B1(this.top, [], r, null);
      n != this.top ? n.children.push(o) : n.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function O$(t, e) {
  let n = e, r = n.children.length, o = t.childCount, i = /* @__PURE__ */ new Map(), s = [];
  e: for (; o > 0; ) {
    let l;
    for (; ; )
      if (r) {
        let c = n.children[r - 1];
        if (c instanceof Wo)
          n = c, r = c.children.length;
        else {
          l = c, r--;
          break;
        }
      } else {
        if (n == e)
          break e;
        r = n.parent.children.indexOf(n), n = n.parent;
      }
    let a = l.node;
    if (a) {
      if (a != t.child(o - 1))
        break;
      --o, i.set(l, o), s.push(l);
    }
  }
  return { index: o, matched: i, matches: s.reverse() };
}
function D$(t, e) {
  return t.type.side - e.type.side;
}
function A$(t, e, n, r) {
  let o = e.locals(t), i = 0;
  if (o.length == 0) {
    for (let c = 0; c < t.childCount; c++) {
      let d = t.child(c);
      r(d, o, e.forChild(i, d), c), i += d.nodeSize;
    }
    return;
  }
  let s = 0, l = [], a = null;
  for (let c = 0; ; ) {
    let d, u;
    for (; s < o.length && o[s].to == i; ) {
      let b = o[s++];
      b.widget && (d ? (u || (u = [d])).push(b) : d = b);
    }
    if (d)
      if (u) {
        u.sort(D$);
        for (let b = 0; b < u.length; b++)
          n(u[b], c, !!a);
      } else
        n(d, c, !!a);
    let f, h;
    if (a)
      h = -1, f = a, a = null;
    else if (c < t.childCount)
      h = c, f = t.child(c++);
    else
      break;
    for (let b = 0; b < l.length; b++)
      l[b].to <= i && l.splice(b--, 1);
    for (; s < o.length && o[s].from <= i && o[s].to > i; )
      l.push(o[s++]);
    let p = i + f.nodeSize;
    if (f.isText) {
      let b = p;
      s < o.length && o[s].from < b && (b = o[s].from);
      for (let w = 0; w < l.length; w++)
        l[w].to < b && (b = l[w].to);
      b < p && (a = f.cut(b - i), f = f.cut(0, b - i), p = b, h = -1);
    } else
      for (; s < o.length && o[s].to < p; )
        s++;
    let y = f.isInline && !f.isLeaf ? l.filter((b) => !b.inline) : l.slice();
    r(f, y, e.forChild(i, f), h), i = p;
  }
}
function L$(t) {
  if (t.nodeName == "UL" || t.nodeName == "OL") {
    let e = t.style.cssText;
    t.style.cssText = e + "; list-style: square !important", window.getComputedStyle(t).listStyle, t.style.cssText = e;
  }
}
function $$(t, e, n, r) {
  for (let o = 0, i = 0; o < t.childCount && i <= r; ) {
    let s = t.child(o++), l = i;
    if (i += s.nodeSize, !s.isText)
      continue;
    let a = s.text;
    for (; o < t.childCount; ) {
      let c = t.child(o++);
      if (i += c.nodeSize, !c.isText)
        break;
      a += c.text;
    }
    if (i >= n) {
      if (i >= r && a.slice(r - e.length - l, r - l) == e)
        return r - e.length;
      let c = l < r ? a.lastIndexOf(e, r - l - 1) : -1;
      if (c >= 0 && c + e.length + l >= n)
        return l + c;
      if (n == r && a.length >= r + e.length - l && a.slice(r - l, r - l + e.length) == e)
        return r;
    }
  }
  return -1;
}
function vu(t, e, n, r, o) {
  let i = [];
  for (let s = 0, l = 0; s < t.length; s++) {
    let a = t[s], c = l, d = l += a.size;
    c >= n || d <= e ? i.push(a) : (c < e && i.push(a.slice(0, e - c, r)), o && (i.push(o), o = void 0), d > n && i.push(a.slice(n - c, a.size, r)));
  }
  return i;
}
function Ff(t, e = null) {
  let n = t.domSelectionRange(), r = t.state.doc;
  if (!n.focusNode)
    return null;
  let o = t.docView.nearestDesc(n.focusNode), i = o && o.size == 0, s = t.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (s < 0)
    return null;
  let l = r.resolve(s), a, c;
  if (Ec(n)) {
    for (a = s; o && !o.node; )
      o = o.parent;
    let u = o.node;
    if (o && u.isAtom && le.isSelectable(u) && o.parent && !(u.isInline && s$(n.focusNode, n.focusOffset, o.dom))) {
      let f = o.posBefore;
      c = new le(s == f ? l : r.resolve(f));
    }
  } else {
    if (n instanceof t.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
      let u = s, f = s;
      for (let h = 0; h < n.rangeCount; h++) {
        let p = n.getRangeAt(h);
        u = Math.min(u, t.docView.posFromDOM(p.startContainer, p.startOffset, 1)), f = Math.max(f, t.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (u < 0)
        return null;
      [a, s] = f == t.state.selection.anchor ? [f, u] : [u, f], l = r.resolve(s);
    } else
      a = t.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (a < 0)
      return null;
  }
  let d = r.resolve(a);
  if (!c) {
    let u = e == "pointer" || t.state.selection.head < l.pos && !i ? 1 : -1;
    c = Nf(t, d, l, u);
  }
  return c;
}
function z1(t) {
  return t.editable ? t.hasFocus() : j1(t) && document.activeElement && document.activeElement.contains(t.dom);
}
function _r(t, e = !1) {
  let n = t.state.selection;
  if (H1(t, n), !!z1(t)) {
    if (!e && t.input.mouseDown && t.input.mouseDown.allowDefault && on) {
      let r = t.domSelectionRange(), o = t.domObserver.currentSelection;
      if (r.anchorNode && o.anchorNode && jo(r.anchorNode, r.anchorOffset, o.anchorNode, o.anchorOffset)) {
        t.input.mouseDown.delayedSelectionSync = !0, t.domObserver.setCurSelection();
        return;
      }
    }
    if (t.domObserver.disconnectSelection(), t.cursorWrapper)
      _$(t);
    else {
      let { anchor: r, head: o } = n, i, s;
      yg && !(n instanceof ce) && (n.$from.parent.inlineContent || (i = bg(t, n.from)), !n.empty && !n.$from.parent.inlineContent && (s = bg(t, n.to))), t.docView.setSelection(r, o, t, e), yg && (i && wg(i), s && wg(s)), n.visible ? t.dom.classList.remove("ProseMirror-hideselection") : (t.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && P$(t));
    }
    t.domObserver.setCurSelection(), t.domObserver.connectSelection();
  }
}
const yg = gn || on && R1 < 63;
function bg(t, e) {
  let { node: n, offset: r } = t.docView.domFromPos(e, 0), o = r < n.childNodes.length ? n.childNodes[r] : null, i = r ? n.childNodes[r - 1] : null;
  if (gn && o && o.contentEditable == "false")
    return fd(o);
  if ((!o || o.contentEditable == "false") && (!i || i.contentEditable == "false")) {
    if (o)
      return fd(o);
    if (i)
      return fd(i);
  }
}
function fd(t) {
  return t.contentEditable = "true", gn && t.draggable && (t.draggable = !1, t.wasDraggable = !0), t;
}
function wg(t) {
  t.contentEditable = "false", t.wasDraggable && (t.draggable = !0, t.wasDraggable = null);
}
function P$(t) {
  let e = t.dom.ownerDocument;
  e.removeEventListener("selectionchange", t.input.hideSelectionGuard);
  let n = t.domSelectionRange(), r = n.anchorNode, o = n.anchorOffset;
  e.addEventListener("selectionchange", t.input.hideSelectionGuard = () => {
    (n.anchorNode != r || n.anchorOffset != o) && (e.removeEventListener("selectionchange", t.input.hideSelectionGuard), setTimeout(() => {
      (!z1(t) || t.state.selection.visible) && t.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function _$(t) {
  let e = t.domSelection(), n = document.createRange();
  if (!e)
    return;
  let r = t.cursorWrapper.dom, o = r.nodeName == "IMG";
  o ? n.setStart(r.parentNode, Xt(r) + 1) : n.setStart(r, 0), n.collapse(!0), e.removeAllRanges(), e.addRange(n), !o && !t.state.selection.visible && Cn && ho <= 11 && (r.disabled = !0, r.disabled = !1);
}
function H1(t, e) {
  if (e instanceof le) {
    let n = t.docView.descAt(e.from);
    n != t.lastSelectedViewDesc && (Sg(t), n && n.selectNode(), t.lastSelectedViewDesc = n);
  } else
    Sg(t);
}
function Sg(t) {
  t.lastSelectedViewDesc && (t.lastSelectedViewDesc.parent && t.lastSelectedViewDesc.deselectNode(), t.lastSelectedViewDesc = void 0);
}
function Nf(t, e, n, r) {
  return t.someProp("createSelectionBetween", (o) => o(t, e, n)) || ce.between(e, n, r);
}
function Cg(t) {
  return t.editable && !t.hasFocus() ? !1 : j1(t);
}
function j1(t) {
  let e = t.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return t.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (t.editable || t.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function B$(t) {
  let e = t.docView.domFromPos(t.state.selection.anchor, 0), n = t.domSelectionRange();
  return jo(e.node, e.offset, n.anchorNode, n.anchorOffset);
}
function xu(t, e) {
  let { $anchor: n, $head: r } = t.selection, o = e > 0 ? n.max(r) : n.min(r), i = o.parent.inlineContent ? o.depth ? t.doc.resolve(e > 0 ? o.after() : o.before()) : null : o;
  return i && fe.findFrom(i, e);
}
function Yr(t, e) {
  return t.dispatch(t.state.tr.setSelection(e).scrollIntoView()), !0;
}
function vg(t, e, n) {
  let r = t.state.selection;
  if (r instanceof ce)
    if (n.indexOf("s") > -1) {
      let { $head: o } = r, i = o.textOffset ? null : e < 0 ? o.nodeBefore : o.nodeAfter;
      if (!i || i.isText || !i.isLeaf)
        return !1;
      let s = t.state.doc.resolve(o.pos + i.nodeSize * (e < 0 ? -1 : 1));
      return Yr(t, new ce(r.$anchor, s));
    } else if (r.empty) {
      if (t.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let o = xu(t.state, e);
        return o && o instanceof le ? Yr(t, o) : !1;
      } else if (!(Bn && n.indexOf("m") > -1)) {
        let o = r.$head, i = o.textOffset ? null : e < 0 ? o.nodeBefore : o.nodeAfter, s;
        if (!i || i.isText)
          return !1;
        let l = e < 0 ? o.pos - i.nodeSize : o.pos;
        return i.isAtom || (s = t.docView.descAt(l)) && !s.contentDOM ? le.isSelectable(i) ? Yr(t, new le(e < 0 ? t.state.doc.resolve(o.pos - i.nodeSize) : o)) : al ? Yr(t, new ce(t.state.doc.resolve(e < 0 ? l : l + i.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof le && r.node.isInline)
      return Yr(t, new ce(e > 0 ? r.$to : r.$from));
    {
      let o = xu(t.state, e);
      return o ? Yr(t, o) : !1;
    }
  }
}
function Ta(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function xs(t, e) {
  let n = t.pmViewDesc;
  return n && n.size == 0 && (e < 0 || t.nextSibling || t.nodeName != "BR");
}
function ai(t, e) {
  return e < 0 ? V$(t) : F$(t);
}
function V$(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let o, i, s = !1;
  for (or && n.nodeType == 1 && r < Ta(n) && xs(n.childNodes[r], -1) && (s = !0); ; )
    if (r > 0) {
      if (n.nodeType != 1)
        break;
      {
        let l = n.childNodes[r - 1];
        if (xs(l, -1))
          o = n, i = --r;
        else if (l.nodeType == 3)
          n = l, r = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (W1(n))
        break;
      {
        let l = n.previousSibling;
        for (; l && xs(l, -1); )
          o = n.parentNode, i = Xt(l), l = l.previousSibling;
        if (l)
          n = l, r = Ta(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = 0;
        }
      }
    }
  s ? Eu(t, n, r) : o && Eu(t, o, i);
}
function F$(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let o = Ta(n), i, s;
  for (; ; )
    if (r < o) {
      if (n.nodeType != 1)
        break;
      let l = n.childNodes[r];
      if (xs(l, 1))
        i = n, s = ++r;
      else
        break;
    } else {
      if (W1(n))
        break;
      {
        let l = n.nextSibling;
        for (; l && xs(l, 1); )
          i = l.parentNode, s = Xt(l) + 1, l = l.nextSibling;
        if (l)
          n = l, r = 0, o = Ta(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = o = 0;
        }
      }
    }
  i && Eu(t, i, s);
}
function W1(t) {
  let e = t.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function N$(t, e) {
  for (; t && e == t.childNodes.length && !ll(t); )
    e = Xt(t) + 1, t = t.parentNode;
  for (; t && e < t.childNodes.length; ) {
    let n = t.childNodes[e];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = 0;
  }
}
function z$(t, e) {
  for (; t && !e && !ll(t); )
    e = Xt(t), t = t.parentNode;
  for (; t && e; ) {
    let n = t.childNodes[e - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = t.childNodes.length;
  }
}
function Eu(t, e, n) {
  if (e.nodeType != 3) {
    let i, s;
    (s = N$(e, n)) ? (e = s, n = 0) : (i = z$(e, n)) && (e = i, n = i.nodeValue.length);
  }
  let r = t.domSelection();
  if (!r)
    return;
  if (Ec(r)) {
    let i = document.createRange();
    i.setEnd(e, n), i.setStart(e, n), r.removeAllRanges(), r.addRange(i);
  } else r.extend && r.extend(e, n);
  t.domObserver.setCurSelection();
  let { state: o } = t;
  setTimeout(() => {
    t.state == o && _r(t);
  }, 50);
}
function xg(t, e) {
  let n = t.state.doc.resolve(e);
  if (!(on || c$) && n.parent.inlineContent) {
    let o = t.coordsAtPos(e);
    if (e > n.start()) {
      let i = t.coordsAtPos(e - 1), s = (i.top + i.bottom) / 2;
      if (s > o.top && s < o.bottom && Math.abs(i.left - o.left) > 1)
        return i.left < o.left ? "ltr" : "rtl";
    }
    if (e < n.end()) {
      let i = t.coordsAtPos(e + 1), s = (i.top + i.bottom) / 2;
      if (s > o.top && s < o.bottom && Math.abs(i.left - o.left) > 1)
        return i.left > o.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(t.dom).direction == "rtl" ? "rtl" : "ltr";
}
function Eg(t, e, n) {
  let r = t.state.selection;
  if (r instanceof ce && !r.empty || n.indexOf("s") > -1 || Bn && n.indexOf("m") > -1)
    return !1;
  let { $from: o, $to: i } = r;
  if (!o.parent.inlineContent || t.endOfTextblock(e < 0 ? "up" : "down")) {
    let s = xu(t.state, e);
    if (s && s instanceof le)
      return Yr(t, s);
  }
  if (!o.parent.inlineContent) {
    let s = e < 0 ? o : i, l = r instanceof jn ? fe.near(s, e) : fe.findFrom(s, e);
    return l ? Yr(t, l) : !1;
  }
  return !1;
}
function kg(t, e) {
  if (!(t.state.selection instanceof ce))
    return !0;
  let { $head: n, $anchor: r, empty: o } = t.state.selection;
  if (!n.sameParent(r))
    return !0;
  if (!o)
    return !1;
  if (t.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let i = !n.textOffset && (e < 0 ? n.nodeBefore : n.nodeAfter);
  if (i && !i.isText) {
    let s = t.state.tr;
    return e < 0 ? s.delete(n.pos - i.nodeSize, n.pos) : s.delete(n.pos, n.pos + i.nodeSize), t.dispatch(s), !0;
  }
  return !1;
}
function Tg(t, e, n) {
  t.domObserver.stop(), e.contentEditable = n, t.domObserver.start();
}
function H$(t) {
  if (!gn || t.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: n } = t.domSelectionRange();
  if (e && e.nodeType == 1 && n == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    Tg(t, r, "true"), setTimeout(() => Tg(t, r, "false"), 20);
  }
  return !1;
}
function j$(t) {
  let e = "";
  return t.ctrlKey && (e += "c"), t.metaKey && (e += "m"), t.altKey && (e += "a"), t.shiftKey && (e += "s"), e;
}
function W$(t, e) {
  let n = e.keyCode, r = j$(e);
  if (n == 8 || Bn && n == 72 && r == "c")
    return kg(t, -1) || ai(t, -1);
  if (n == 46 && !e.shiftKey || Bn && n == 68 && r == "c")
    return kg(t, 1) || ai(t, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || Bn && n == 66 && r == "c") {
    let o = n == 37 ? xg(t, t.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return vg(t, o, r) || ai(t, o);
  } else if (n == 39 || Bn && n == 70 && r == "c") {
    let o = n == 39 ? xg(t, t.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return vg(t, o, r) || ai(t, o);
  } else {
    if (n == 38 || Bn && n == 80 && r == "c")
      return Eg(t, -1, r) || ai(t, -1);
    if (n == 40 || Bn && n == 78 && r == "c")
      return H$(t) || Eg(t, 1, r) || ai(t, 1);
    if (r == (Bn ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function G1(t, e) {
  t.someProp("transformCopied", (h) => {
    e = h(e, t);
  });
  let n = [], { content: r, openStart: o, openEnd: i } = e;
  for (; o > 1 && i > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    o--, i--;
    let h = r.firstChild;
    n.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), r = h.content;
  }
  let s = t.someProp("clipboardSerializer") || Qo.fromSchema(t.state.schema), l = Z1(), a = l.createElement("div");
  a.appendChild(s.serializeFragment(r, { document: l }));
  let c = a.firstChild, d, u = 0;
  for (; c && c.nodeType == 1 && (d = Y1[c.nodeName.toLowerCase()]); ) {
    for (let h = d.length - 1; h >= 0; h--) {
      let p = l.createElement(d[h]);
      for (; a.firstChild; )
        p.appendChild(a.firstChild);
      a.appendChild(p), u++;
    }
    c = a.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${o} ${i}${u ? ` -${u}` : ""} ${JSON.stringify(n)}`);
  let f = t.someProp("clipboardTextSerializer", (h) => h(e, t)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: a, text: f, slice: e };
}
function U1(t, e, n, r, o) {
  let i = o.parent.type.spec.code, s, l;
  if (!n && !e)
    return null;
  let a = e && (r || i || !n);
  if (a) {
    if (t.someProp("transformPastedText", (f) => {
      e = f(e, i || r, t);
    }), i)
      return e ? new N(D.from(t.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : N.empty;
    let u = t.someProp("clipboardTextParser", (f) => f(e, o, r, t));
    if (u)
      l = u;
    else {
      let f = o.marks(), { schema: h } = t.state, p = Qo.fromSchema(h);
      s = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((y) => {
        let b = s.appendChild(document.createElement("p"));
        y && b.appendChild(p.serializeNode(h.text(y, f)));
      });
    }
  } else
    t.someProp("transformPastedHTML", (u) => {
      n = u(n, t);
    }), s = J$(n), al && K$(s);
  let c = s && s.querySelector("[data-pm-slice]"), d = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (d && d[3])
    for (let u = +d[3]; u > 0; u--) {
      let f = s.firstChild;
      for (; f && f.nodeType != 1; )
        f = f.nextSibling;
      if (!f)
        break;
      s = f;
    }
  if (l || (l = (t.someProp("clipboardParser") || t.someProp("domParser") || fo.fromSchema(t.state.schema)).parseSlice(s, {
    preserveWhitespace: !!(a || d),
    context: o,
    ruleFromNode(f) {
      return f.nodeName == "BR" && !f.nextSibling && f.parentNode && !G$.test(f.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), d)
    l = Y$(Ig(l, +d[1], +d[2]), d[4]);
  else if (l = N.maxOpen(U$(l.content, o), !0), l.openStart || l.openEnd) {
    let u = 0, f = 0;
    for (let h = l.content.firstChild; u < l.openStart && !h.type.spec.isolating; u++, h = h.firstChild)
      ;
    for (let h = l.content.lastChild; f < l.openEnd && !h.type.spec.isolating; f++, h = h.lastChild)
      ;
    l = Ig(l, u, f);
  }
  return t.someProp("transformPasted", (u) => {
    l = u(l, t);
  }), l;
}
const G$ = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function U$(t, e) {
  if (t.childCount < 2)
    return t;
  for (let n = e.depth; n >= 0; n--) {
    let o = e.node(n).contentMatchAt(e.index(n)), i, s = [];
    if (t.forEach((l) => {
      if (!s)
        return;
      let a = o.findWrapping(l.type), c;
      if (!a)
        return s = null;
      if (c = s.length && i.length && J1(a, i, l, s[s.length - 1], 0))
        s[s.length - 1] = c;
      else {
        s.length && (s[s.length - 1] = K1(s[s.length - 1], i.length));
        let d = q1(l, a);
        s.push(d), o = o.matchType(d.type), i = a;
      }
    }), s)
      return D.from(s);
  }
  return t;
}
function q1(t, e, n = 0) {
  for (let r = e.length - 1; r >= n; r--)
    t = e[r].create(null, D.from(t));
  return t;
}
function J1(t, e, n, r, o) {
  if (o < t.length && o < e.length && t[o] == e[o]) {
    let i = J1(t, e, n, r.lastChild, o + 1);
    if (i)
      return r.copy(r.content.replaceChild(r.childCount - 1, i));
    if (r.contentMatchAt(r.childCount).matchType(o == t.length - 1 ? n.type : t[o + 1]))
      return r.copy(r.content.append(D.from(q1(n, t, o + 1))));
  }
}
function K1(t, e) {
  if (e == 0)
    return t;
  let n = t.content.replaceChild(t.childCount - 1, K1(t.lastChild, e - 1)), r = t.contentMatchAt(t.childCount).fillBefore(D.empty, !0);
  return t.copy(n.append(r));
}
function ku(t, e, n, r, o, i) {
  let s = e < 0 ? t.firstChild : t.lastChild, l = s.content;
  return t.childCount > 1 && (i = 0), o < r - 1 && (l = ku(l, e, n, r, o + 1, i)), o >= n && (l = e < 0 ? s.contentMatchAt(0).fillBefore(l, i <= o).append(l) : l.append(s.contentMatchAt(s.childCount).fillBefore(D.empty, !0))), t.replaceChild(e < 0 ? 0 : t.childCount - 1, s.copy(l));
}
function Ig(t, e, n) {
  return e < t.openStart && (t = new N(ku(t.content, -1, e, t.openStart, 0, t.openEnd), e, t.openEnd)), n < t.openEnd && (t = new N(ku(t.content, 1, n, t.openEnd, 0, 0), t.openStart, n)), t;
}
const Y1 = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let Mg = null;
function Z1() {
  return Mg || (Mg = document.implementation.createHTMLDocument("title"));
}
let hd = null;
function q$(t) {
  let e = window.trustedTypes;
  return e ? (hd || (hd = e.createPolicy("ProseMirrorClipboard", { createHTML: (n) => n })), hd.createHTML(t)) : t;
}
function J$(t) {
  let e = /^(\s*<meta [^>]*>)*/.exec(t);
  e && (t = t.slice(e[0].length));
  let n = Z1().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(t), o;
  if ((o = r && Y1[r[1].toLowerCase()]) && (t = o.map((i) => "<" + i + ">").join("") + t + o.map((i) => "</" + i + ">").reverse().join("")), n.innerHTML = q$(t), o)
    for (let i = 0; i < o.length; i++)
      n = n.querySelector(o[i]) || n;
  return n;
}
function K$(t) {
  let e = t.querySelectorAll(on ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(t.ownerDocument.createTextNode(" "), r);
  }
}
function Y$(t, e) {
  if (!t.size)
    return t;
  let n = t.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return t;
  }
  let { content: o, openStart: i, openEnd: s } = t;
  for (let l = r.length - 2; l >= 0; l -= 2) {
    let a = n.nodes[r[l]];
    if (!a || a.hasRequiredAttrs())
      break;
    o = D.from(a.create(r[l + 1], o)), i++, s++;
  }
  return new N(o, i, s);
}
const mn = {}, yn = {}, Z$ = { touchstart: !0, touchmove: !0 };
class X$ {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastAndroidDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function Q$(t) {
  for (let e in mn) {
    let n = mn[e];
    t.dom.addEventListener(e, t.input.eventHandlers[e] = (r) => {
      tP(t, r) && !zf(t, r) && (t.editable || !(r.type in yn)) && n(t, r);
    }, Z$[e] ? { passive: !0 } : void 0);
  }
  gn && t.dom.addEventListener("input", () => null), Tu(t);
}
function lo(t, e) {
  t.input.lastSelectionOrigin = e, t.input.lastSelectionTime = Date.now();
}
function eP(t) {
  t.domObserver.stop();
  for (let e in t.input.eventHandlers)
    t.dom.removeEventListener(e, t.input.eventHandlers[e]);
  clearTimeout(t.input.composingTimeout), clearTimeout(t.input.lastIOSEnterFallbackTimeout);
}
function Tu(t) {
  t.someProp("handleDOMEvents", (e) => {
    for (let n in e)
      t.input.eventHandlers[n] || t.dom.addEventListener(n, t.input.eventHandlers[n] = (r) => zf(t, r));
  });
}
function zf(t, e) {
  return t.someProp("handleDOMEvents", (n) => {
    let r = n[e.type];
    return r ? r(t, e) || e.defaultPrevented : !1;
  });
}
function tP(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target; n != t.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function nP(t, e) {
  !zf(t, e) && mn[e.type] && (t.editable || !(e.type in yn)) && mn[e.type](t, e);
}
yn.keydown = (t, e) => {
  let n = e;
  if (t.input.shiftKey = n.keyCode == 16 || n.shiftKey, !Q1(t, n) && (t.input.lastKeyCode = n.keyCode, t.input.lastKeyCodeTime = Date.now(), !(Xn && on && n.keyCode == 13)))
    if (n.keyCode != 229 && t.domObserver.forceFlush(), Ai && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let r = Date.now();
      t.input.lastIOSEnter = r, t.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        t.input.lastIOSEnter == r && (t.someProp("handleKeyDown", (o) => o(t, Io(13, "Enter"))), t.input.lastIOSEnter = 0);
      }, 200);
    } else t.someProp("handleKeyDown", (r) => r(t, n)) || W$(t, n) ? n.preventDefault() : lo(t, "key");
};
yn.keyup = (t, e) => {
  e.keyCode == 16 && (t.input.shiftKey = !1);
};
yn.keypress = (t, e) => {
  let n = e;
  if (Q1(t, n) || !n.charCode || n.ctrlKey && !n.altKey || Bn && n.metaKey)
    return;
  if (t.someProp("handleKeyPress", (o) => o(t, n))) {
    n.preventDefault();
    return;
  }
  let r = t.state.selection;
  if (!(r instanceof ce) || !r.$from.sameParent(r.$to)) {
    let o = String.fromCharCode(n.charCode);
    !/[\r\n]/.test(o) && !t.someProp("handleTextInput", (i) => i(t, r.$from.pos, r.$to.pos, o)) && t.dispatch(t.state.tr.insertText(o).scrollIntoView()), n.preventDefault();
  }
};
function Tc(t) {
  return { left: t.clientX, top: t.clientY };
}
function rP(t, e) {
  let n = e.x - t.clientX, r = e.y - t.clientY;
  return n * n + r * r < 100;
}
function Hf(t, e, n, r, o) {
  if (r == -1)
    return !1;
  let i = t.state.doc.resolve(r);
  for (let s = i.depth + 1; s > 0; s--)
    if (t.someProp(e, (l) => s > i.depth ? l(t, n, i.nodeAfter, i.before(s), o, !0) : l(t, n, i.node(s), i.before(s), o, !1)))
      return !0;
  return !1;
}
function Ci(t, e, n) {
  if (t.focused || t.focus(), t.state.selection.eq(e))
    return;
  let r = t.state.tr.setSelection(e);
  r.setMeta("pointer", !0), t.dispatch(r);
}
function oP(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.doc.resolve(e), r = n.nodeAfter;
  return r && r.isAtom && le.isSelectable(r) ? (Ci(t, new le(n)), !0) : !1;
}
function iP(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.selection, r, o;
  n instanceof le && (r = n.node);
  let i = t.state.doc.resolve(e);
  for (let s = i.depth + 1; s > 0; s--) {
    let l = s > i.depth ? i.nodeAfter : i.node(s);
    if (le.isSelectable(l)) {
      r && n.$from.depth > 0 && s >= n.$from.depth && i.before(n.$from.depth + 1) == n.$from.pos ? o = i.before(n.$from.depth) : o = i.before(s);
      break;
    }
  }
  return o != null ? (Ci(t, le.create(t.state.doc, o)), !0) : !1;
}
function sP(t, e, n, r, o) {
  return Hf(t, "handleClickOn", e, n, r) || t.someProp("handleClick", (i) => i(t, e, r)) || (o ? iP(t, n) : oP(t, n));
}
function lP(t, e, n, r) {
  return Hf(t, "handleDoubleClickOn", e, n, r) || t.someProp("handleDoubleClick", (o) => o(t, e, r));
}
function aP(t, e, n, r) {
  return Hf(t, "handleTripleClickOn", e, n, r) || t.someProp("handleTripleClick", (o) => o(t, e, r)) || cP(t, n, r);
}
function cP(t, e, n) {
  if (n.button != 0)
    return !1;
  let r = t.state.doc;
  if (e == -1)
    return r.inlineContent ? (Ci(t, ce.create(r, 0, r.content.size)), !0) : !1;
  let o = r.resolve(e);
  for (let i = o.depth + 1; i > 0; i--) {
    let s = i > o.depth ? o.nodeAfter : o.node(i), l = o.before(i);
    if (s.inlineContent)
      Ci(t, ce.create(r, l + 1, l + 1 + s.content.size));
    else if (le.isSelectable(s))
      Ci(t, le.create(r, l));
    else
      continue;
    return !0;
  }
}
function jf(t) {
  return Ia(t);
}
const X1 = Bn ? "metaKey" : "ctrlKey";
mn.mousedown = (t, e) => {
  let n = e;
  t.input.shiftKey = n.shiftKey;
  let r = jf(t), o = Date.now(), i = "singleClick";
  o - t.input.lastClick.time < 500 && rP(n, t.input.lastClick) && !n[X1] && (t.input.lastClick.type == "singleClick" ? i = "doubleClick" : t.input.lastClick.type == "doubleClick" && (i = "tripleClick")), t.input.lastClick = { time: o, x: n.clientX, y: n.clientY, type: i };
  let s = t.posAtCoords(Tc(n));
  s && (i == "singleClick" ? (t.input.mouseDown && t.input.mouseDown.done(), t.input.mouseDown = new dP(t, s, n, !!r)) : (i == "doubleClick" ? lP : aP)(t, s.pos, s.inside, n) ? n.preventDefault() : lo(t, "pointer"));
};
class dP {
  constructor(e, n, r, o) {
    this.view = e, this.pos = n, this.event = r, this.flushed = o, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[X1], this.allowDefault = r.shiftKey;
    let i, s;
    if (n.inside > -1)
      i = e.state.doc.nodeAt(n.inside), s = n.inside;
    else {
      let d = e.state.doc.resolve(n.pos);
      i = d.parent, s = d.depth ? d.before() : 0;
    }
    const l = o ? null : r.target, a = l ? e.docView.nearestDesc(l, !0) : null;
    this.target = a && a.dom.nodeType == 1 ? a.dom : null;
    let { selection: c } = e.state;
    (r.button == 0 && i.type.spec.draggable && i.type.spec.selectable !== !1 || c instanceof le && c.from <= s && c.to > s) && (this.mightDrag = {
      node: i,
      pos: s,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && or && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), lo(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => _r(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(Tc(e))), this.updateAllowDefault(e), this.allowDefault || !n ? lo(this.view, "pointer") : sP(this.view, n.pos, n.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    gn && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    on && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (Ci(this.view, fe.near(this.view.state.doc.resolve(n.pos))), e.preventDefault()) : lo(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), lo(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
mn.touchstart = (t) => {
  t.input.lastTouch = Date.now(), jf(t), lo(t, "pointer");
};
mn.touchmove = (t) => {
  t.input.lastTouch = Date.now(), lo(t, "pointer");
};
mn.contextmenu = (t) => jf(t);
function Q1(t, e) {
  return t.composing ? !0 : gn && Math.abs(e.timeStamp - t.input.compositionEndedAt) < 500 ? (t.input.compositionEndedAt = -2e8, !0) : !1;
}
const uP = Xn ? 5e3 : -1;
yn.compositionstart = yn.compositionupdate = (t) => {
  if (!t.composing) {
    t.domObserver.flush();
    let { state: e } = t, n = e.selection.$to;
    if (e.selection instanceof ce && (e.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      t.markCursor = t.state.storedMarks || n.marks(), Ia(t, !0), t.markCursor = null;
    else if (Ia(t, !e.selection.empty), or && e.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let r = t.domSelectionRange();
      for (let o = r.focusNode, i = r.focusOffset; o && o.nodeType == 1 && i != 0; ) {
        let s = i < 0 ? o.lastChild : o.childNodes[i - 1];
        if (!s)
          break;
        if (s.nodeType == 3) {
          let l = t.domSelection();
          l && l.collapse(s, s.nodeValue.length);
          break;
        } else
          o = s, i = -1;
      }
    }
    t.input.composing = !0;
  }
  ew(t, uP);
};
yn.compositionend = (t, e) => {
  t.composing && (t.input.composing = !1, t.input.compositionEndedAt = e.timeStamp, t.input.compositionPendingChanges = t.domObserver.pendingRecords().length ? t.input.compositionID : 0, t.input.compositionNode = null, t.input.compositionPendingChanges && Promise.resolve().then(() => t.domObserver.flush()), t.input.compositionID++, ew(t, 20));
};
function ew(t, e) {
  clearTimeout(t.input.composingTimeout), e > -1 && (t.input.composingTimeout = setTimeout(() => Ia(t), e));
}
function tw(t) {
  for (t.composing && (t.input.composing = !1, t.input.compositionEndedAt = hP()); t.input.compositionNodes.length > 0; )
    t.input.compositionNodes.pop().markParentsDirty();
}
function fP(t) {
  let e = t.domSelectionRange();
  if (!e.focusNode)
    return null;
  let n = o$(e.focusNode, e.focusOffset), r = i$(e.focusNode, e.focusOffset);
  if (n && r && n != r) {
    let o = r.pmViewDesc, i = t.domObserver.lastChangedTextNode;
    if (n == i || r == i)
      return i;
    if (!o || !o.isText(r.nodeValue))
      return r;
    if (t.input.compositionNode == r) {
      let s = n.pmViewDesc;
      if (!(!s || !s.isText(n.nodeValue)))
        return r;
    }
  }
  return n || r;
}
function hP() {
  let t = document.createEvent("Event");
  return t.initEvent("event", !0, !0), t.timeStamp;
}
function Ia(t, e = !1) {
  if (!(Xn && t.domObserver.flushingSoon >= 0)) {
    if (t.domObserver.forceFlush(), tw(t), e || t.docView && t.docView.dirty) {
      let n = Ff(t);
      return n && !n.eq(t.state.selection) ? t.dispatch(t.state.tr.setSelection(n)) : (t.markCursor || e) && !t.state.selection.empty ? t.dispatch(t.state.tr.deleteSelection()) : t.updateState(t.state), !0;
    }
    return !1;
  }
}
function pP(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(e), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), o = document.createRange();
  o.selectNodeContents(e), t.dom.blur(), r.removeAllRanges(), r.addRange(o), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), t.focus();
  }, 50);
}
const Hs = Cn && ho < 15 || Ai && d$ < 604;
mn.copy = yn.cut = (t, e) => {
  let n = e, r = t.state.selection, o = n.type == "cut";
  if (r.empty)
    return;
  let i = Hs ? null : n.clipboardData, s = r.content(), { dom: l, text: a } = G1(t, s);
  i ? (n.preventDefault(), i.clearData(), i.setData("text/html", l.innerHTML), i.setData("text/plain", a)) : pP(t, l), o && t.dispatch(t.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function gP(t) {
  return t.openStart == 0 && t.openEnd == 0 && t.content.childCount == 1 ? t.content.firstChild : null;
}
function mP(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.input.shiftKey || t.state.selection.$from.parent.type.spec.code, r = t.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let o = t.input.shiftKey && t.input.lastKeyCode != 45;
  setTimeout(() => {
    t.focus(), r.parentNode && r.parentNode.removeChild(r), n ? js(t, r.value, null, o, e) : js(t, r.textContent, r.innerHTML, o, e);
  }, 50);
}
function js(t, e, n, r, o) {
  let i = U1(t, e, n, r, t.state.selection.$from);
  if (t.someProp("handlePaste", (a) => a(t, o, i || N.empty)))
    return !0;
  if (!i)
    return !1;
  let s = gP(i), l = s ? t.state.tr.replaceSelectionWith(s, r) : t.state.tr.replaceSelection(i);
  return t.dispatch(l.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function nw(t) {
  let e = t.getData("text/plain") || t.getData("Text");
  if (e)
    return e;
  let n = t.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
yn.paste = (t, e) => {
  let n = e;
  if (t.composing && !Xn)
    return;
  let r = Hs ? null : n.clipboardData, o = t.input.shiftKey && t.input.lastKeyCode != 45;
  r && js(t, nw(r), r.getData("text/html"), o, n) ? n.preventDefault() : mP(t, n);
};
class rw {
  constructor(e, n, r) {
    this.slice = e, this.move = n, this.node = r;
  }
}
const ow = Bn ? "altKey" : "ctrlKey";
mn.dragstart = (t, e) => {
  let n = e, r = t.input.mouseDown;
  if (r && r.done(), !n.dataTransfer)
    return;
  let o = t.state.selection, i = o.empty ? null : t.posAtCoords(Tc(n)), s;
  if (!(i && i.pos >= o.from && i.pos <= (o instanceof le ? o.to - 1 : o.to))) {
    if (r && r.mightDrag)
      s = le.create(t.state.doc, r.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let u = t.docView.nearestDesc(n.target, !0);
      u && u.node.type.spec.draggable && u != t.docView && (s = le.create(t.state.doc, u.posBefore));
    }
  }
  let l = (s || t.state.selection).content(), { dom: a, text: c, slice: d } = G1(t, l);
  (!n.dataTransfer.files.length || !on || R1 > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData(Hs ? "Text" : "text/html", a.innerHTML), n.dataTransfer.effectAllowed = "copyMove", Hs || n.dataTransfer.setData("text/plain", c), t.dragging = new rw(d, !n[ow], s);
};
mn.dragend = (t) => {
  let e = t.dragging;
  window.setTimeout(() => {
    t.dragging == e && (t.dragging = null);
  }, 50);
};
yn.dragover = yn.dragenter = (t, e) => e.preventDefault();
yn.drop = (t, e) => {
  let n = e, r = t.dragging;
  if (t.dragging = null, !n.dataTransfer)
    return;
  let o = t.posAtCoords(Tc(n));
  if (!o)
    return;
  let i = t.state.doc.resolve(o.pos), s = r && r.slice;
  s ? t.someProp("transformPasted", (p) => {
    s = p(s, t);
  }) : s = U1(t, nw(n.dataTransfer), Hs ? null : n.dataTransfer.getData("text/html"), !1, i);
  let l = !!(r && !n[ow]);
  if (t.someProp("handleDrop", (p) => p(t, n, s || N.empty, l))) {
    n.preventDefault();
    return;
  }
  if (!s)
    return;
  n.preventDefault();
  let a = s ? S1(t.state.doc, i.pos, s) : i.pos;
  a == null && (a = i.pos);
  let c = t.state.tr;
  if (l) {
    let { node: p } = r;
    p ? p.replace(c) : c.deleteSelection();
  }
  let d = c.mapping.map(a), u = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, f = c.doc;
  if (u ? c.replaceRangeWith(d, d, s.content.firstChild) : c.replaceRange(d, d, s), c.doc.eq(f))
    return;
  let h = c.doc.resolve(d);
  if (u && le.isSelectable(s.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(s.content.firstChild))
    c.setSelection(new le(h));
  else {
    let p = c.mapping.map(a);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((y, b, w, S) => p = S), c.setSelection(Nf(t, h, c.doc.resolve(p)));
  }
  t.focus(), t.dispatch(c.setMeta("uiEvent", "drop"));
};
mn.focus = (t) => {
  t.input.lastFocus = Date.now(), t.focused || (t.domObserver.stop(), t.dom.classList.add("ProseMirror-focused"), t.domObserver.start(), t.focused = !0, setTimeout(() => {
    t.docView && t.hasFocus() && !t.domObserver.currentSelection.eq(t.domSelectionRange()) && _r(t);
  }, 20));
};
mn.blur = (t, e) => {
  let n = e;
  t.focused && (t.domObserver.stop(), t.dom.classList.remove("ProseMirror-focused"), t.domObserver.start(), n.relatedTarget && t.dom.contains(n.relatedTarget) && t.domObserver.currentSelection.clear(), t.focused = !1);
};
mn.beforeinput = (t, e) => {
  if (on && Xn && e.inputType == "deleteContentBackward") {
    t.domObserver.flushSoon();
    let { domChangeCount: r } = t.input;
    setTimeout(() => {
      if (t.input.domChangeCount != r || (t.dom.blur(), t.focus(), t.someProp("handleKeyDown", (i) => i(t, Io(8, "Backspace")))))
        return;
      let { $cursor: o } = t.state.selection;
      o && o.pos > 0 && t.dispatch(t.state.tr.delete(o.pos - 1, o.pos).scrollIntoView());
    }, 50);
  }
};
for (let t in yn)
  mn[t] = yn[t];
function Ws(t, e) {
  if (t == e)
    return !0;
  for (let n in t)
    if (t[n] !== e[n])
      return !1;
  for (let n in e)
    if (!(n in t))
      return !1;
  return !0;
}
class Ma {
  constructor(e, n) {
    this.toDOM = e, this.spec = n || Bo, this.side = this.spec.side || 0;
  }
  map(e, n, r, o) {
    let { pos: i, deleted: s } = e.mapResult(n.from + o, this.side < 0 ? -1 : 1);
    return s ? null : new sn(i - r, i - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof Ma && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && Ws(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class go {
  constructor(e, n) {
    this.attrs = e, this.spec = n || Bo;
  }
  map(e, n, r, o) {
    let i = e.map(n.from + o, this.spec.inclusiveStart ? -1 : 1) - r, s = e.map(n.to + o, this.spec.inclusiveEnd ? 1 : -1) - r;
    return i >= s ? null : new sn(i, s, this);
  }
  valid(e, n) {
    return n.from < n.to;
  }
  eq(e) {
    return this == e || e instanceof go && Ws(this.attrs, e.attrs) && Ws(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof go;
  }
  destroy() {
  }
}
class Wf {
  constructor(e, n) {
    this.attrs = e, this.spec = n || Bo;
  }
  map(e, n, r, o) {
    let i = e.mapResult(n.from + o, 1);
    if (i.deleted)
      return null;
    let s = e.mapResult(n.to + o, -1);
    return s.deleted || s.pos <= i.pos ? null : new sn(i.pos - r, s.pos - r, this);
  }
  valid(e, n) {
    let { index: r, offset: o } = e.content.findIndex(n.from), i;
    return o == n.from && !(i = e.child(r)).isText && o + i.nodeSize == n.to;
  }
  eq(e) {
    return this == e || e instanceof Wf && Ws(this.attrs, e.attrs) && Ws(this.spec, e.spec);
  }
  destroy() {
  }
}
class sn {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.from = e, this.to = n, this.type = r;
  }
  /**
  @internal
  */
  copy(e, n) {
    return new sn(e, n, this.type);
  }
  /**
  @internal
  */
  eq(e, n = 0) {
    return this.type.eq(e.type) && this.from + n == e.from && this.to + n == e.to;
  }
  /**
  @internal
  */
  map(e, n, r) {
    return this.type.map(e, this, n, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, n, r) {
    return new sn(e, e, new Ma(n, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, n, r, o) {
    return new sn(e, n, new go(r, o));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, n, r, o) {
    return new sn(e, n, new Wf(r, o));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof go;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Ma;
  }
}
const ui = [], Bo = {};
class bt {
  /**
  @internal
  */
  constructor(e, n) {
    this.local = e.length ? e : ui, this.children = n.length ? n : ui;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, n) {
    return n.length ? Ra(n, e, 0, Bo) : nn;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, n, r) {
    let o = [];
    return this.findInner(e ?? 0, n ?? 1e9, o, 0, r), o;
  }
  findInner(e, n, r, o, i) {
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      l.from <= n && l.to >= e && (!i || i(l.spec)) && r.push(l.copy(l.from + o, l.to + o));
    }
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] < n && this.children[s + 1] > e) {
        let l = this.children[s] + 1;
        this.children[s + 2].findInner(e - l, n - l, r, o + l, i);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, n, r) {
    return this == nn || e.maps.length == 0 ? this : this.mapInner(e, n, 0, 0, r || Bo);
  }
  /**
  @internal
  */
  mapInner(e, n, r, o, i) {
    let s;
    for (let l = 0; l < this.local.length; l++) {
      let a = this.local[l].map(e, r, o);
      a && a.type.valid(n, a) ? (s || (s = [])).push(a) : i.onRemove && i.onRemove(this.local[l].spec);
    }
    return this.children.length ? yP(this.children, s || [], e, n, r, o, i) : s ? new bt(s.sort(Vo), ui) : nn;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, n) {
    return n.length ? this == nn ? bt.create(e, n) : this.addInner(e, n, 0) : this;
  }
  addInner(e, n, r) {
    let o, i = 0;
    e.forEach((l, a) => {
      let c = a + r, d;
      if (d = sw(n, l, c)) {
        for (o || (o = this.children.slice()); i < o.length && o[i] < a; )
          i += 3;
        o[i] == a ? o[i + 2] = o[i + 2].addInner(l, d, c + 1) : o.splice(i, 0, a, a + l.nodeSize, Ra(d, l, c + 1, Bo)), i += 3;
      }
    });
    let s = iw(i ? lw(n) : n, -r);
    for (let l = 0; l < s.length; l++)
      s[l].type.valid(e, s[l]) || s.splice(l--, 1);
    return new bt(s.length ? this.local.concat(s).sort(Vo) : this.local, o || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == nn ? this : this.removeInner(e, 0);
  }
  removeInner(e, n) {
    let r = this.children, o = this.local;
    for (let i = 0; i < r.length; i += 3) {
      let s, l = r[i] + n, a = r[i + 1] + n;
      for (let d = 0, u; d < e.length; d++)
        (u = e[d]) && u.from > l && u.to < a && (e[d] = null, (s || (s = [])).push(u));
      if (!s)
        continue;
      r == this.children && (r = this.children.slice());
      let c = r[i + 2].removeInner(s, l + 1);
      c != nn ? r[i + 2] = c : (r.splice(i, 3), i -= 3);
    }
    if (o.length) {
      for (let i = 0, s; i < e.length; i++)
        if (s = e[i])
          for (let l = 0; l < o.length; l++)
            o[l].eq(s, n) && (o == this.local && (o = this.local.slice()), o.splice(l--, 1));
    }
    return r == this.children && o == this.local ? this : o.length || r.length ? new bt(o, r) : nn;
  }
  forChild(e, n) {
    if (this == nn)
      return this;
    if (n.isLeaf)
      return bt.empty;
    let r, o;
    for (let l = 0; l < this.children.length; l += 3)
      if (this.children[l] >= e) {
        this.children[l] == e && (r = this.children[l + 2]);
        break;
      }
    let i = e + 1, s = i + n.content.size;
    for (let l = 0; l < this.local.length; l++) {
      let a = this.local[l];
      if (a.from < s && a.to > i && a.type instanceof go) {
        let c = Math.max(i, a.from) - i, d = Math.min(s, a.to) - i;
        c < d && (o || (o = [])).push(a.copy(c, d));
      }
    }
    if (o) {
      let l = new bt(o.sort(Vo), ui);
      return r ? new to([l, r]) : l;
    }
    return r || nn;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof bt) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(e.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != e.children[n] || this.children[n + 1] != e.children[n + 1] || !this.children[n + 2].eq(e.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return Gf(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == nn)
      return ui;
    if (e.inlineContent || !this.local.some(go.is))
      return this.local;
    let n = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof go || n.push(this.local[r]);
    return n;
  }
  forEachSet(e) {
    e(this);
  }
}
bt.empty = new bt([], []);
bt.removeOverlap = Gf;
const nn = bt.empty;
class to {
  constructor(e) {
    this.members = e;
  }
  map(e, n) {
    const r = this.members.map((o) => o.map(e, n, Bo));
    return to.from(r);
  }
  forChild(e, n) {
    if (n.isLeaf)
      return bt.empty;
    let r = [];
    for (let o = 0; o < this.members.length; o++) {
      let i = this.members[o].forChild(e, n);
      i != nn && (i instanceof to ? r = r.concat(i.members) : r.push(i));
    }
    return to.from(r);
  }
  eq(e) {
    if (!(e instanceof to) || e.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(e.members[n]))
        return !1;
    return !0;
  }
  locals(e) {
    let n, r = !0;
    for (let o = 0; o < this.members.length; o++) {
      let i = this.members[o].localsInner(e);
      if (i.length)
        if (!n)
          n = i;
        else {
          r && (n = n.slice(), r = !1);
          for (let s = 0; s < i.length; s++)
            n.push(i[s]);
        }
    }
    return n ? Gf(r ? n : n.sort(Vo)) : ui;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return nn;
      case 1:
        return e[0];
      default:
        return new to(e.every((n) => n instanceof bt) ? e : e.reduce((n, r) => n.concat(r instanceof bt ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let n = 0; n < this.members.length; n++)
      this.members[n].forEachSet(e);
  }
}
function yP(t, e, n, r, o, i, s) {
  let l = t.slice();
  for (let c = 0, d = i; c < n.maps.length; c++) {
    let u = 0;
    n.maps[c].forEach((f, h, p, y) => {
      let b = y - p - (h - f);
      for (let w = 0; w < l.length; w += 3) {
        let S = l[w + 1];
        if (S < 0 || f > S + d - u)
          continue;
        let x = l[w] + d - u;
        h >= x ? l[w + 1] = f <= x ? -2 : -1 : f >= d && b && (l[w] += b, l[w + 1] += b);
      }
      u += b;
    }), d = n.maps[c].map(d, -1);
  }
  let a = !1;
  for (let c = 0; c < l.length; c += 3)
    if (l[c + 1] < 0) {
      if (l[c + 1] == -2) {
        a = !0, l[c + 1] = -1;
        continue;
      }
      let d = n.map(t[c] + i), u = d - o;
      if (u < 0 || u >= r.content.size) {
        a = !0;
        continue;
      }
      let f = n.map(t[c + 1] + i, -1), h = f - o, { index: p, offset: y } = r.content.findIndex(u), b = r.maybeChild(p);
      if (b && y == u && y + b.nodeSize == h) {
        let w = l[c + 2].mapInner(n, b, d + 1, t[c] + i + 1, s);
        w != nn ? (l[c] = u, l[c + 1] = h, l[c + 2] = w) : (l[c + 1] = -2, a = !0);
      } else
        a = !0;
    }
  if (a) {
    let c = bP(l, t, e, n, o, i, s), d = Ra(c, r, 0, s);
    e = d.local;
    for (let u = 0; u < l.length; u += 3)
      l[u + 1] < 0 && (l.splice(u, 3), u -= 3);
    for (let u = 0, f = 0; u < d.children.length; u += 3) {
      let h = d.children[u];
      for (; f < l.length && l[f] < h; )
        f += 3;
      l.splice(f, 0, d.children[u], d.children[u + 1], d.children[u + 2]);
    }
  }
  return new bt(e.sort(Vo), l);
}
function iw(t, e) {
  if (!e || !t.length)
    return t;
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let o = t[r];
    n.push(new sn(o.from + e, o.to + e, o.type));
  }
  return n;
}
function bP(t, e, n, r, o, i, s) {
  function l(a, c) {
    for (let d = 0; d < a.local.length; d++) {
      let u = a.local[d].map(r, o, c);
      u ? n.push(u) : s.onRemove && s.onRemove(a.local[d].spec);
    }
    for (let d = 0; d < a.children.length; d += 3)
      l(a.children[d + 2], a.children[d] + c + 1);
  }
  for (let a = 0; a < t.length; a += 3)
    t[a + 1] == -1 && l(t[a + 2], e[a] + i + 1);
  return n;
}
function sw(t, e, n) {
  if (e.isLeaf)
    return null;
  let r = n + e.nodeSize, o = null;
  for (let i = 0, s; i < t.length; i++)
    (s = t[i]) && s.from > n && s.to < r && ((o || (o = [])).push(s), t[i] = null);
  return o;
}
function lw(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    t[n] != null && e.push(t[n]);
  return e;
}
function Ra(t, e, n, r) {
  let o = [], i = !1;
  e.forEach((l, a) => {
    let c = sw(t, l, a + n);
    if (c) {
      i = !0;
      let d = Ra(c, l, n + a + 1, r);
      d != nn && o.push(a, a + l.nodeSize, d);
    }
  });
  let s = iw(i ? lw(t) : t, -n).sort(Vo);
  for (let l = 0; l < s.length; l++)
    s[l].type.valid(e, s[l]) || (r.onRemove && r.onRemove(s[l].spec), s.splice(l--, 1));
  return s.length || o.length ? new bt(s, o) : nn;
}
function Vo(t, e) {
  return t.from - e.from || t.to - e.to;
}
function Gf(t) {
  let e = t;
  for (let n = 0; n < e.length - 1; n++) {
    let r = e[n];
    if (r.from != r.to)
      for (let o = n + 1; o < e.length; o++) {
        let i = e[o];
        if (i.from == r.from) {
          i.to != r.to && (e == t && (e = t.slice()), e[o] = i.copy(i.from, r.to), Rg(e, o + 1, i.copy(r.to, i.to)));
          continue;
        } else {
          i.from < r.to && (e == t && (e = t.slice()), e[n] = r.copy(r.from, i.from), Rg(e, o, r.copy(i.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function Rg(t, e, n) {
  for (; e < t.length && Vo(n, t[e]) > 0; )
    e++;
  t.splice(e, 0, n);
}
function pd(t) {
  let e = [];
  return t.someProp("decorations", (n) => {
    let r = n(t.state);
    r && r != nn && e.push(r);
  }), t.cursorWrapper && e.push(bt.create(t.state.doc, [t.cursorWrapper.deco])), to.from(e);
}
const wP = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, SP = Cn && ho <= 11;
class CP {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class vP {
  constructor(e, n) {
    this.view = e, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new CP(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let o = 0; o < r.length; o++)
        this.queue.push(r[o]);
      Cn && ho <= 11 && r.some((o) => o.type == "childList" && o.removedNodes.length || o.type == "characterData" && o.oldValue.length > o.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), SP && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, wP)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let n = 0; n < e.length; n++)
          this.queue.push(e[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (Cg(this.view)) {
      if (this.suppressingSelectionUpdates)
        return _r(this.view);
      if (Cn && ho <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && jo(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), r;
    for (let i = e.focusNode; i; i = zs(i))
      n.add(i);
    for (let i = e.anchorNode; i; i = zs(i))
      if (n.has(i)) {
        r = i;
        break;
      }
    let o = r && this.view.docView.nearestDesc(r);
    if (o && o.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let r = e.domSelectionRange(), o = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && Cg(e) && !this.ignoreSelectionChange(r), i = -1, s = -1, l = !1, a = [];
    if (e.editable)
      for (let d = 0; d < n.length; d++) {
        let u = this.registerMutation(n[d], a);
        u && (i = i < 0 ? u.from : Math.min(u.from, i), s = s < 0 ? u.to : Math.max(u.to, s), u.typeOver && (l = !0));
      }
    if (or && a.length) {
      let d = a.filter((u) => u.nodeName == "BR");
      if (d.length == 2) {
        let [u, f] = d;
        u.parentNode && u.parentNode.parentNode == f.parentNode ? f.remove() : u.remove();
      } else {
        let { focusNode: u } = this.currentSelection;
        for (let f of d) {
          let h = f.parentNode;
          h && h.nodeName == "LI" && (!u || kP(e, u) != h) && f.remove();
        }
      }
    }
    let c = null;
    i < 0 && o && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && Ec(r) && (c = Ff(e)) && c.eq(fe.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, _r(e), this.currentSelection.set(r), e.scrollToSelection()) : (i > -1 || o) && (i > -1 && (e.docView.markDirty(i, s), xP(e)), this.handleDOMChange(i, s, l, a), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || _r(e), this.currentSelection.set(r));
  }
  registerMutation(e, n) {
    if (n.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let d = 0; d < e.addedNodes.length; d++) {
        let u = e.addedNodes[d];
        n.push(u), u.nodeType == 3 && (this.lastChangedTextNode = u);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let o = e.previousSibling, i = e.nextSibling;
      if (Cn && ho <= 11 && e.addedNodes.length)
        for (let d = 0; d < e.addedNodes.length; d++) {
          let { previousSibling: u, nextSibling: f } = e.addedNodes[d];
          (!u || Array.prototype.indexOf.call(e.addedNodes, u) < 0) && (o = u), (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (i = f);
        }
      let s = o && o.parentNode == e.target ? Xt(o) + 1 : 0, l = r.localPosFromDOM(e.target, s, -1), a = i && i.parentNode == e.target ? Xt(i) : e.target.childNodes.length, c = r.localPosFromDOM(e.target, a, 1);
      return { from: l, to: c };
    } else return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let Og = /* @__PURE__ */ new WeakMap(), Dg = !1;
function xP(t) {
  if (!Og.has(t) && (Og.set(t, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(t.dom).whiteSpace) !== -1)) {
    if (t.requiresGeckoHackNode = or, Dg)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Dg = !0;
  }
}
function Ag(t, e) {
  let n = e.startContainer, r = e.startOffset, o = e.endContainer, i = e.endOffset, s = t.domAtPos(t.state.selection.anchor);
  return jo(s.node, s.offset, o, i) && ([n, r, o, i] = [o, i, n, r]), { anchorNode: n, anchorOffset: r, focusNode: o, focusOffset: i };
}
function EP(t, e) {
  if (e.getComposedRanges) {
    let o = e.getComposedRanges(t.root)[0];
    if (o)
      return Ag(t, o);
  }
  let n;
  function r(o) {
    o.preventDefault(), o.stopImmediatePropagation(), n = o.getTargetRanges()[0];
  }
  return t.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), t.dom.removeEventListener("beforeinput", r, !0), n ? Ag(t, n) : null;
}
function kP(t, e) {
  for (let n = e.parentNode; n && n != t.dom; n = n.parentNode) {
    let r = t.docView.nearestDesc(n, !0);
    if (r && r.node.isBlock)
      return n;
  }
  return null;
}
function TP(t, e, n) {
  let { node: r, fromOffset: o, toOffset: i, from: s, to: l } = t.docView.parseRange(e, n), a = t.domSelectionRange(), c, d = a.anchorNode;
  if (d && t.dom.contains(d.nodeType == 1 ? d : d.parentNode) && (c = [{ node: d, offset: a.anchorOffset }], Ec(a) || c.push({ node: a.focusNode, offset: a.focusOffset })), on && t.input.lastKeyCode === 8)
    for (let b = i; b > o; b--) {
      let w = r.childNodes[b - 1], S = w.pmViewDesc;
      if (w.nodeName == "BR" && !S) {
        i = b;
        break;
      }
      if (!S || S.size)
        break;
    }
  let u = t.state.doc, f = t.someProp("domParser") || fo.fromSchema(t.state.schema), h = u.resolve(s), p = null, y = f.parse(r, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: o,
    to: i,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: IP,
    context: h
  });
  if (c && c[0].pos != null) {
    let b = c[0].pos, w = c[1] && c[1].pos;
    w == null && (w = b), p = { anchor: b + s, head: w + s };
  }
  return { doc: y, sel: p, from: s, to: l };
}
function IP(t) {
  let e = t.pmViewDesc;
  if (e)
    return e.parseRule();
  if (t.nodeName == "BR" && t.parentNode) {
    if (gn && /^(ul|ol)$/i.test(t.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (t.parentNode.lastChild == t || gn && /^(tr|table)$/i.test(t.parentNode.nodeName))
      return { ignore: !0 };
  } else if (t.nodeName == "IMG" && t.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const MP = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function RP(t, e, n, r, o) {
  let i = t.input.compositionPendingChanges || (t.composing ? t.input.compositionID : 0);
  if (t.input.compositionPendingChanges = 0, e < 0) {
    let R = t.input.lastSelectionTime > Date.now() - 50 ? t.input.lastSelectionOrigin : null, A = Ff(t, R);
    if (A && !t.state.selection.eq(A)) {
      if (on && Xn && t.input.lastKeyCode === 13 && Date.now() - 100 < t.input.lastKeyCodeTime && t.someProp("handleKeyDown", (V) => V(t, Io(13, "Enter"))))
        return;
      let F = t.state.tr.setSelection(A);
      R == "pointer" ? F.setMeta("pointer", !0) : R == "key" && F.scrollIntoView(), i && F.setMeta("composition", i), t.dispatch(F);
    }
    return;
  }
  let s = t.state.doc.resolve(e), l = s.sharedDepth(n);
  e = s.before(l + 1), n = t.state.doc.resolve(n).after(l + 1);
  let a = t.state.selection, c = TP(t, e, n), d = t.state.doc, u = d.slice(c.from, c.to), f, h;
  t.input.lastKeyCode === 8 && Date.now() - 100 < t.input.lastKeyCodeTime ? (f = t.state.selection.to, h = "end") : (f = t.state.selection.from, h = "start"), t.input.lastKeyCode = null;
  let p = AP(u.content, c.doc.content, c.from, f, h);
  if (p && t.input.domChangeCount++, (Ai && t.input.lastIOSEnter > Date.now() - 225 || Xn) && o.some((R) => R.nodeType == 1 && !MP.test(R.nodeName)) && (!p || p.endA >= p.endB) && t.someProp("handleKeyDown", (R) => R(t, Io(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (r && a instanceof ce && !a.empty && a.$head.sameParent(a.$anchor) && !t.composing && !(c.sel && c.sel.anchor != c.sel.head))
      p = { start: a.from, endA: a.to, endB: a.to };
    else {
      if (c.sel) {
        let R = Lg(t, t.state.doc, c.sel);
        if (R && !R.eq(t.state.selection)) {
          let A = t.state.tr.setSelection(R);
          i && A.setMeta("composition", i), t.dispatch(A);
        }
      }
      return;
    }
  t.state.selection.from < t.state.selection.to && p.start == p.endB && t.state.selection instanceof ce && (p.start > t.state.selection.from && p.start <= t.state.selection.from + 2 && t.state.selection.from >= c.from ? p.start = t.state.selection.from : p.endA < t.state.selection.to && p.endA >= t.state.selection.to - 2 && t.state.selection.to <= c.to && (p.endB += t.state.selection.to - p.endA, p.endA = t.state.selection.to)), Cn && ho <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > c.from && c.doc.textBetween(p.start - c.from - 1, p.start - c.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let y = c.doc.resolveNoCache(p.start - c.from), b = c.doc.resolveNoCache(p.endB - c.from), w = d.resolve(p.start), S = y.sameParent(b) && y.parent.inlineContent && w.end() >= p.endA, x;
  if ((Ai && t.input.lastIOSEnter > Date.now() - 225 && (!S || o.some((R) => R.nodeName == "DIV" || R.nodeName == "P")) || !S && y.pos < c.doc.content.size && !y.sameParent(b) && (x = fe.findFrom(c.doc.resolve(y.pos + 1), 1, !0)) && x.head == b.pos) && t.someProp("handleKeyDown", (R) => R(t, Io(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (t.state.selection.anchor > p.start && DP(d, p.start, p.endA, y, b) && t.someProp("handleKeyDown", (R) => R(t, Io(8, "Backspace")))) {
    Xn && on && t.domObserver.suppressSelectionUpdates();
    return;
  }
  on && Xn && p.endB == p.start && (t.input.lastAndroidDelete = Date.now()), Xn && !S && y.start() != b.start() && b.parentOffset == 0 && y.depth == b.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == p.endA && (p.endB -= 2, b = c.doc.resolveNoCache(p.endB - c.from), setTimeout(() => {
    t.someProp("handleKeyDown", function(R) {
      return R(t, Io(13, "Enter"));
    });
  }, 20));
  let E = p.start, v = p.endA, T, I, M;
  if (S) {
    if (y.pos == b.pos)
      Cn && ho <= 11 && y.parentOffset == 0 && (t.domObserver.suppressSelectionUpdates(), setTimeout(() => _r(t), 20)), T = t.state.tr.delete(E, v), I = d.resolve(p.start).marksAcross(d.resolve(p.endA));
    else if (
      // Adding or removing a mark
      p.endA == p.endB && (M = OP(y.parent.content.cut(y.parentOffset, b.parentOffset), w.parent.content.cut(w.parentOffset, p.endA - w.start())))
    )
      T = t.state.tr, M.type == "add" ? T.addMark(E, v, M.mark) : T.removeMark(E, v, M.mark);
    else if (y.parent.child(y.index()).isText && y.index() == b.index() - (b.textOffset ? 0 : 1)) {
      let R = y.parent.textBetween(y.parentOffset, b.parentOffset);
      if (t.someProp("handleTextInput", (A) => A(t, E, v, R)))
        return;
      T = t.state.tr.insertText(R, E, v);
    }
  }
  if (T || (T = t.state.tr.replace(E, v, c.doc.slice(p.start - c.from, p.endB - c.from))), c.sel) {
    let R = Lg(t, T.doc, c.sel);
    R && !(on && Xn && t.composing && R.empty && (p.start != p.endB || t.input.lastAndroidDelete < Date.now() - 100) && (R.head == E || R.head == T.mapping.map(v) - 1) || Cn && R.empty && R.head == E) && T.setSelection(R);
  }
  I && T.ensureMarks(I), i && T.setMeta("composition", i), t.dispatch(T.scrollIntoView());
}
function Lg(t, e, n) {
  return Math.max(n.anchor, n.head) > e.content.size ? null : Nf(t, e.resolve(n.anchor), e.resolve(n.head));
}
function OP(t, e) {
  let n = t.firstChild.marks, r = e.firstChild.marks, o = n, i = r, s, l, a;
  for (let d = 0; d < r.length; d++)
    o = r[d].removeFromSet(o);
  for (let d = 0; d < n.length; d++)
    i = n[d].removeFromSet(i);
  if (o.length == 1 && i.length == 0)
    l = o[0], s = "add", a = (d) => d.mark(l.addToSet(d.marks));
  else if (o.length == 0 && i.length == 1)
    l = i[0], s = "remove", a = (d) => d.mark(l.removeFromSet(d.marks));
  else
    return null;
  let c = [];
  for (let d = 0; d < e.childCount; d++)
    c.push(a(e.child(d)));
  if (D.from(c).eq(t))
    return { mark: l, type: s };
}
function DP(t, e, n, r, o) {
  if (
    // The content must have shrunk
    n - e <= o.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    gd(r, !0, !1) < o.pos
  )
    return !1;
  let i = t.resolve(e);
  if (!r.parent.isTextblock) {
    let l = i.nodeAfter;
    return l != null && n == e + l.nodeSize;
  }
  if (i.parentOffset < i.parent.content.size || !i.parent.isTextblock)
    return !1;
  let s = t.resolve(gd(i, !0, !0));
  return !s.parent.isTextblock || s.pos > n || gd(s, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(s.parent.content);
}
function gd(t, e, n) {
  let r = t.depth, o = e ? t.end() : t.pos;
  for (; r > 0 && (e || t.indexAfter(r) == t.node(r).childCount); )
    r--, o++, e = !1;
  if (n) {
    let i = t.node(r).maybeChild(t.indexAfter(r));
    for (; i && !i.isLeaf; )
      i = i.firstChild, o++;
  }
  return o;
}
function AP(t, e, n, r, o) {
  let i = t.findDiffStart(e, n);
  if (i == null)
    return null;
  let { a: s, b: l } = t.findDiffEnd(e, n + t.size, n + e.size);
  if (o == "end") {
    let a = Math.max(0, i - Math.min(s, l));
    r -= s + a - i;
  }
  if (s < i && t.size < e.size) {
    let a = r <= i && r >= s ? i - r : 0;
    i -= a, i && i < e.size && $g(e.textBetween(i - 1, i + 1)) && (i += a ? 1 : -1), l = i + (l - s), s = i;
  } else if (l < i) {
    let a = r <= i && r >= l ? i - r : 0;
    i -= a, i && i < t.size && $g(t.textBetween(i - 1, i + 1)) && (i += a ? 1 : -1), s = i + (s - l), l = i;
  }
  return { start: i, endA: s, endB: l };
}
function $g(t) {
  if (t.length != 2)
    return !1;
  let e = t.charCodeAt(0), n = t.charCodeAt(1);
  return e >= 56320 && e <= 57343 && n >= 55296 && n <= 56319;
}
class LP {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new X$(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(Fg), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = Bg(this), _g(this), this.nodeViews = Vg(this), this.docView = gg(this.state.doc, Pg(this), pd(this), this.dom, this), this.domObserver = new vP(this, (r, o, i, s) => RP(this, r, o, i, s)), this.domObserver.start(), Q$(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let n in e)
        this._props[n] = e[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Tu(this);
    let n = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(Fg), this.directPlugins = e.plugins), this.updateStateInner(e.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let n = {};
    for (let r in this._props)
      n[r] = this._props[r];
    n.state = this.state;
    for (let r in e)
      n[r] = e[r];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, n) {
    var r;
    let o = this.state, i = !1, s = !1;
    e.storedMarks && this.composing && (tw(this), s = !0), this.state = e;
    let l = o.plugins != e.plugins || this._props.plugins != n.plugins;
    if (l || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let h = Vg(this);
      PP(h, this.nodeViews) && (this.nodeViews = h, i = !0);
    }
    (l || n.handleDOMEvents != this._props.handleDOMEvents) && Tu(this), this.editable = Bg(this), _g(this);
    let a = pd(this), c = Pg(this), d = o.plugins != e.plugins && !o.doc.eq(e.doc) ? "reset" : e.scrollToSelection > o.scrollToSelection ? "to selection" : "preserve", u = i || !this.docView.matchesNode(e.doc, c, a);
    (u || !e.selection.eq(o.selection)) && (s = !0);
    let f = d == "preserve" && s && this.dom.style.overflowAnchor == null && h$(this);
    if (s) {
      this.domObserver.stop();
      let h = u && (Cn || on) && !this.composing && !o.selection.empty && !e.selection.empty && $P(o.selection, e.selection);
      if (u) {
        let p = on ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = fP(this)), (i || !this.docView.update(e.doc, c, a, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = gg(e.doc, c, a, this.dom, this)), p && !this.trackWrites && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && B$(this)) ? _r(this, h) : (H1(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(o), !((r = this.dragging) === null || r === void 0) && r.node && !o.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, o), d == "reset" ? this.dom.scrollTop = 0 : d == "to selection" ? this.scrollToSelection() : f && p$(f);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!this.someProp("handleScrollToSelection", (n) => n(this))) if (this.state.selection instanceof le) {
      let n = this.docView.domAfterPos(this.state.selection.from);
      n.nodeType == 1 && cg(this, n.getBoundingClientRect(), e);
    } else
      cg(this, this.coordsAtPos(this.state.selection.head, 1), e);
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let r = this.directPlugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let r = this.state.plugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let r = this.pluginViews[n];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, n) {
    let r = e.node, o = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      o = r.from;
    else {
      let i = r.from + (this.state.doc.content.size - n.doc.content.size);
      (i > 0 && this.state.doc.nodeAt(i)) == r.node && (o = i);
    }
    this.dragging = new rw(e.slice, e.move, o < 0 ? void 0 : le.create(this.state.doc, o));
  }
  someProp(e, n) {
    let r = this._props && this._props[e], o;
    if (r != null && (o = n ? n(r) : r))
      return o;
    for (let s = 0; s < this.directPlugins.length; s++) {
      let l = this.directPlugins[s].props[e];
      if (l != null && (o = n ? n(l) : l))
        return o;
    }
    let i = this.state.plugins;
    if (i)
      for (let s = 0; s < i.length; s++) {
        let l = i[s].props[e];
        if (l != null && (o = n ? n(l) : l))
          return o;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Cn) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && g$(this.dom), _r(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return S$(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, n = 1) {
    return $1(this, e, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, n = 0) {
    return this.docView.domFromPos(e, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let n = this.docView.descAt(e);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, n, r = -1) {
    let o = this.docView.posFromDOM(e, n, r);
    if (o == null)
      throw new RangeError("DOM position not inside the editor");
    return o;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, n) {
    return k$(this, n || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, n) {
    return js(this, "", e, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, n) {
    return js(this, e, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (eP(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], pd(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, n$());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return nP(this, e);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(e) {
    let n = this._props.dispatchTransaction;
    n ? n.call(this, e) : this.updateState(this.state.apply(e));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? gn && this.root.nodeType === 11 && l$(this.dom.ownerDocument) == this.dom && EP(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function Pg(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(t.editable), t.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(t.state)), n)
      for (let r in n)
        r == "class" ? e.class += " " + n[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + n[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(n[r]));
  }), e.translate || (e.translate = "no"), [sn.node(0, t.state.doc.content.size, e)];
}
function _g(t) {
  if (t.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), t.cursorWrapper = { dom: e, deco: sn.widget(t.state.selection.from, e, { raw: !0, marks: t.markCursor }) };
  } else
    t.cursorWrapper = null;
}
function Bg(t) {
  return !t.someProp("editable", (e) => e(t.state) === !1);
}
function $P(t, e) {
  let n = Math.min(t.$anchor.sharedDepth(t.head), e.$anchor.sharedDepth(e.head));
  return t.$anchor.start(n) != e.$anchor.start(n);
}
function Vg(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(r) {
    for (let o in r)
      Object.prototype.hasOwnProperty.call(e, o) || (e[o] = r[o]);
  }
  return t.someProp("nodeViews", n), t.someProp("markViews", n), e;
}
function PP(t, e) {
  let n = 0, r = 0;
  for (let o in t) {
    if (t[o] != e[o])
      return !0;
    n++;
  }
  for (let o in e)
    r++;
  return n != r;
}
function Fg(t) {
  if (t.spec.state || t.spec.filterTransaction || t.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var bo = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Oa = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, _P = typeof navigator < "u" && /Mac/.test(navigator.platform), BP = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Qt = 0; Qt < 10; Qt++) bo[48 + Qt] = bo[96 + Qt] = String(Qt);
for (var Qt = 1; Qt <= 24; Qt++) bo[Qt + 111] = "F" + Qt;
for (var Qt = 65; Qt <= 90; Qt++)
  bo[Qt] = String.fromCharCode(Qt + 32), Oa[Qt] = String.fromCharCode(Qt);
for (var md in bo) Oa.hasOwnProperty(md) || (Oa[md] = bo[md]);
function VP(t) {
  var e = _P && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || BP && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? Oa : bo)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const FP = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function NP(t) {
  let e = t.split(/-(?!$)/), n = e[e.length - 1];
  n == "Space" && (n = " ");
  let r, o, i, s;
  for (let l = 0; l < e.length - 1; l++) {
    let a = e[l];
    if (/^(cmd|meta|m)$/i.test(a))
      s = !0;
    else if (/^a(lt)?$/i.test(a))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(a))
      o = !0;
    else if (/^s(hift)?$/i.test(a))
      i = !0;
    else if (/^mod$/i.test(a))
      FP ? s = !0 : o = !0;
    else
      throw new Error("Unrecognized modifier name: " + a);
  }
  return r && (n = "Alt-" + n), o && (n = "Ctrl-" + n), s && (n = "Meta-" + n), i && (n = "Shift-" + n), n;
}
function zP(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t)
    e[NP(n)] = t[n];
  return e;
}
function yd(t, e, n = !0) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n && e.shiftKey && (t = "Shift-" + t), t;
}
function HP(t) {
  return new Ft({ props: { handleKeyDown: Uf(t) } });
}
function Uf(t) {
  let e = zP(t);
  return function(n, r) {
    let o = VP(r), i, s = e[yd(o, r)];
    if (s && s(n.state, n.dispatch, n))
      return !0;
    if (o.length == 1 && o != " ") {
      if (r.shiftKey) {
        let l = e[yd(o, r, !1)];
        if (l && l(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.shiftKey || r.altKey || r.metaKey || o.charCodeAt(0) > 127) && (i = bo[r.keyCode]) && i != o) {
        let l = e[yd(i, r)];
        if (l && l(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
const qf = (t, e) => t.selection.empty ? !1 : (e && e(t.tr.deleteSelection().scrollIntoView()), !0);
function aw(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("backward", t) : n.parentOffset > 0) ? null : n;
}
const cw = (t, e, n) => {
  let r = aw(t, n);
  if (!r)
    return !1;
  let o = Jf(r);
  if (!o) {
    let s = r.blockRange(), l = s && Wi(s);
    return l == null ? !1 : (e && e(t.tr.lift(s, l).scrollIntoView()), !0);
  }
  let i = o.nodeBefore;
  if (bw(t, o, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (Li(i, "end") || le.isSelectable(i)))
    for (let s = r.depth; ; s--) {
      let l = vc(t.doc, r.before(s), r.after(s), N.empty);
      if (l && l.slice.size < l.to - l.from) {
        if (e) {
          let a = t.tr.step(l);
          a.setSelection(Li(i, "end") ? fe.findFrom(a.doc.resolve(a.mapping.map(o.pos, -1)), -1) : le.create(a.doc, o.pos - i.nodeSize)), e(a.scrollIntoView());
        }
        return !0;
      }
      if (s == 1 || r.node(s - 1).childCount > 1)
        break;
    }
  return i.isAtom && o.depth == r.depth - 1 ? (e && e(t.tr.delete(o.pos - i.nodeSize, o.pos).scrollIntoView()), !0) : !1;
}, jP = (t, e, n) => {
  let r = aw(t, n);
  if (!r)
    return !1;
  let o = Jf(r);
  return o ? dw(t, o, e) : !1;
}, WP = (t, e, n) => {
  let r = fw(t, n);
  if (!r)
    return !1;
  let o = Kf(r);
  return o ? dw(t, o, e) : !1;
};
function dw(t, e, n) {
  let r = e.nodeBefore, o = r, i = e.pos - 1;
  for (; !o.isTextblock; i--) {
    if (o.type.spec.isolating)
      return !1;
    let d = o.lastChild;
    if (!d)
      return !1;
    o = d;
  }
  let s = e.nodeAfter, l = s, a = e.pos + 1;
  for (; !l.isTextblock; a++) {
    if (l.type.spec.isolating)
      return !1;
    let d = l.firstChild;
    if (!d)
      return !1;
    l = d;
  }
  let c = vc(t.doc, i, a, N.empty);
  if (!c || c.from != i || c instanceof zt && c.slice.size >= a - i)
    return !1;
  if (n) {
    let d = t.tr.step(c);
    d.setSelection(ce.create(d.doc, i)), n(d.scrollIntoView());
  }
  return !0;
}
function Li(t, e, n = !1) {
  for (let r = t; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const uw = (t, e, n) => {
  let { $head: r, empty: o } = t.selection, i = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", t) : r.parentOffset > 0)
      return !1;
    i = Jf(r);
  }
  let s = i && i.nodeBefore;
  return !s || !le.isSelectable(s) ? !1 : (e && e(t.tr.setSelection(le.create(t.doc, i.pos - s.nodeSize)).scrollIntoView()), !0);
};
function Jf(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      if (t.index(e) > 0)
        return t.doc.resolve(t.before(e + 1));
      if (t.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function fw(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("forward", t) : n.parentOffset < n.parent.content.size) ? null : n;
}
const hw = (t, e, n) => {
  let r = fw(t, n);
  if (!r)
    return !1;
  let o = Kf(r);
  if (!o)
    return !1;
  let i = o.nodeAfter;
  if (bw(t, o, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (Li(i, "start") || le.isSelectable(i))) {
    let s = vc(t.doc, r.before(), r.after(), N.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (e) {
        let l = t.tr.step(s);
        l.setSelection(Li(i, "start") ? fe.findFrom(l.doc.resolve(l.mapping.map(o.pos)), 1) : le.create(l.doc, l.mapping.map(o.pos))), e(l.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && o.depth == r.depth - 1 ? (e && e(t.tr.delete(o.pos, o.pos + i.nodeSize).scrollIntoView()), !0) : !1;
}, pw = (t, e, n) => {
  let { $head: r, empty: o } = t.selection, i = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", t) : r.parentOffset < r.parent.content.size)
      return !1;
    i = Kf(r);
  }
  let s = i && i.nodeAfter;
  return !s || !le.isSelectable(s) ? !1 : (e && e(t.tr.setSelection(le.create(t.doc, i.pos)).scrollIntoView()), !0);
};
function Kf(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      let n = t.node(e);
      if (t.index(e) + 1 < n.childCount)
        return t.doc.resolve(t.after(e + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const GP = (t, e) => {
  let n = t.selection, r = n instanceof le, o;
  if (r) {
    if (n.node.isTextblock || !Co(t.doc, n.from))
      return !1;
    o = n.from;
  } else if (o = Cc(t.doc, n.from, -1), o == null)
    return !1;
  if (e) {
    let i = t.tr.join(o);
    r && i.setSelection(le.create(i.doc, o - t.doc.resolve(o).nodeBefore.nodeSize)), e(i.scrollIntoView());
  }
  return !0;
}, UP = (t, e) => {
  let n = t.selection, r;
  if (n instanceof le) {
    if (n.node.isTextblock || !Co(t.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = Cc(t.doc, n.to, 1), r == null)
    return !1;
  return e && e(t.tr.join(r).scrollIntoView()), !0;
}, qP = (t, e) => {
  let { $from: n, $to: r } = t.selection, o = n.blockRange(r), i = o && Wi(o);
  return i == null ? !1 : (e && e(t.tr.lift(o, i).scrollIntoView()), !0);
}, gw = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (e && e(t.tr.insertText(`
`).scrollIntoView()), !0);
};
function Yf(t) {
  for (let e = 0; e < t.edgeCount; e++) {
    let { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const JP = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let o = n.node(-1), i = n.indexAfter(-1), s = Yf(o.contentMatchAt(i));
  if (!s || !o.canReplaceWith(i, i, s))
    return !1;
  if (e) {
    let l = n.after(), a = t.tr.replaceWith(l, l, s.createAndFill());
    a.setSelection(fe.near(a.doc.resolve(l), 1)), e(a.scrollIntoView());
  }
  return !0;
}, mw = (t, e) => {
  let n = t.selection, { $from: r, $to: o } = n;
  if (n instanceof jn || r.parent.inlineContent || o.parent.inlineContent)
    return !1;
  let i = Yf(o.parent.contentMatchAt(o.indexAfter()));
  if (!i || !i.isTextblock)
    return !1;
  if (e) {
    let s = (!r.parentOffset && o.index() < o.parent.childCount ? r : o).pos, l = t.tr.insert(s, i.createAndFill());
    l.setSelection(ce.create(l.doc, s + 1)), e(l.scrollIntoView());
  }
  return !0;
}, yw = (t, e) => {
  let { $cursor: n } = t.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let i = n.before();
    if (Pr(t.doc, i))
      return e && e(t.tr.split(i).scrollIntoView()), !0;
  }
  let r = n.blockRange(), o = r && Wi(r);
  return o == null ? !1 : (e && e(t.tr.lift(r, o).scrollIntoView()), !0);
};
function KP(t) {
  return (e, n) => {
    let { $from: r, $to: o } = e.selection;
    if (e.selection instanceof le && e.selection.node.isBlock)
      return !r.parentOffset || !Pr(e.doc, r.pos) ? !1 : (n && n(e.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let i = [], s, l, a = !1, c = !1;
    for (let h = r.depth; ; h--)
      if (r.node(h).isBlock) {
        a = r.end(h) == r.pos + (r.depth - h), c = r.start(h) == r.pos - (r.depth - h), l = Yf(r.node(h - 1).contentMatchAt(r.indexAfter(h - 1))), i.unshift(a && l ? { type: l } : null), s = h;
        break;
      } else {
        if (h == 1)
          return !1;
        i.unshift(null);
      }
    let d = e.tr;
    (e.selection instanceof ce || e.selection instanceof jn) && d.deleteSelection();
    let u = d.mapping.map(r.pos), f = Pr(d.doc, u, i.length, i);
    if (f || (i[0] = l ? { type: l } : null, f = Pr(d.doc, u, i.length, i)), d.split(u, i.length, i), !a && c && r.node(s).type != l) {
      let h = d.mapping.map(r.before(s)), p = d.doc.resolve(h);
      l && r.node(s - 1).canReplaceWith(p.index(), p.index() + 1, l) && d.setNodeMarkup(d.mapping.map(r.before(s)), l);
    }
    return n && n(d.scrollIntoView()), !0;
  };
}
const YP = KP(), ZP = (t, e) => {
  let { $from: n, to: r } = t.selection, o, i = n.sharedDepth(r);
  return i == 0 ? !1 : (o = n.before(i), e && e(t.tr.setSelection(le.create(t.doc, o))), !0);
};
function XP(t, e, n) {
  let r = e.nodeBefore, o = e.nodeAfter, i = e.index();
  return !r || !o || !r.type.compatibleContent(o.type) ? !1 : !r.content.size && e.parent.canReplace(i - 1, i) ? (n && n(t.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(i, i + 1) || !(o.isTextblock || Co(t.doc, e.pos)) ? !1 : (n && n(t.tr.join(e.pos).scrollIntoView()), !0);
}
function bw(t, e, n, r) {
  let o = e.nodeBefore, i = e.nodeAfter, s, l, a = o.type.spec.isolating || i.type.spec.isolating;
  if (!a && XP(t, e, n))
    return !0;
  let c = !a && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (s = (l = o.contentMatchAt(o.childCount)).findWrapping(i.type)) && l.matchType(s[0] || i.type).validEnd) {
    if (n) {
      let h = e.pos + i.nodeSize, p = D.empty;
      for (let w = s.length - 1; w >= 0; w--)
        p = D.from(s[w].create(null, p));
      p = D.from(o.copy(p));
      let y = t.tr.step(new Ht(e.pos - 1, h, e.pos, h, new N(p, 1, 0), s.length, !0)), b = y.doc.resolve(h + 2 * s.length);
      b.nodeAfter && b.nodeAfter.type == o.type && Co(y.doc, b.pos) && y.join(b.pos), n(y.scrollIntoView());
    }
    return !0;
  }
  let d = i.type.spec.isolating || r > 0 && a ? null : fe.findFrom(e, 1), u = d && d.$from.blockRange(d.$to), f = u && Wi(u);
  if (f != null && f >= e.depth)
    return n && n(t.tr.lift(u, f).scrollIntoView()), !0;
  if (c && Li(i, "start", !0) && Li(o, "end")) {
    let h = o, p = [];
    for (; p.push(h), !h.isTextblock; )
      h = h.lastChild;
    let y = i, b = 1;
    for (; !y.isTextblock; y = y.firstChild)
      b++;
    if (h.canReplace(h.childCount, h.childCount, y.content)) {
      if (n) {
        let w = D.empty;
        for (let x = p.length - 1; x >= 0; x--)
          w = D.from(p[x].copy(w));
        let S = t.tr.step(new Ht(e.pos - p.length, e.pos + i.nodeSize, e.pos + b, e.pos + i.nodeSize - b, new N(w, p.length, 0), 0, !0));
        n(S.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function ww(t) {
  return function(e, n) {
    let r = e.selection, o = t < 0 ? r.$from : r.$to, i = o.depth;
    for (; o.node(i).isInline; ) {
      if (!i)
        return !1;
      i--;
    }
    return o.node(i).isTextblock ? (n && n(e.tr.setSelection(ce.create(e.doc, t < 0 ? o.start(i) : o.end(i)))), !0) : !1;
  };
}
const QP = ww(-1), e_ = ww(1);
function t_(t, e = null) {
  return function(n, r) {
    let { $from: o, $to: i } = n.selection, s = o.blockRange(i), l = s && Pf(s, t, e);
    return l ? (r && r(n.tr.wrap(s, l).scrollIntoView()), !0) : !1;
  };
}
function Ng(t, e = null) {
  return function(n, r) {
    let o = !1;
    for (let i = 0; i < n.selection.ranges.length && !o; i++) {
      let { $from: { pos: s }, $to: { pos: l } } = n.selection.ranges[i];
      n.doc.nodesBetween(s, l, (a, c) => {
        if (o)
          return !1;
        if (!(!a.isTextblock || a.hasMarkup(t, e)))
          if (a.type == t)
            o = !0;
          else {
            let d = n.doc.resolve(c), u = d.index();
            o = d.parent.canReplaceWith(u, u + 1, t);
          }
      });
    }
    if (!o)
      return !1;
    if (r) {
      let i = n.tr;
      for (let s = 0; s < n.selection.ranges.length; s++) {
        let { $from: { pos: l }, $to: { pos: a } } = n.selection.ranges[s];
        i.setBlockType(l, a, t, e);
      }
      r(i.scrollIntoView());
    }
    return !0;
  };
}
function Zf(...t) {
  return function(e, n, r) {
    for (let o = 0; o < t.length; o++)
      if (t[o](e, n, r))
        return !0;
    return !1;
  };
}
Zf(qf, cw, uw);
Zf(qf, hw, pw);
Zf(gw, mw, yw, YP);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function n_(t, e = null) {
  return function(n, r) {
    let { $from: o, $to: i } = n.selection, s = o.blockRange(i);
    if (!s)
      return !1;
    let l = r ? n.tr : null;
    return r_(l, s, t, e) ? (r && r(l.scrollIntoView()), !0) : !1;
  };
}
function r_(t, e, n, r = null) {
  let o = !1, i = e, s = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(n) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let a = s.resolve(e.start - 2);
    i = new Ca(a, a, e.depth), e.endIndex < e.parent.childCount && (e = new Ca(e.$from, s.resolve(e.$to.end(e.depth)), e.depth)), o = !0;
  }
  let l = Pf(i, n, r, e);
  return l ? (t && o_(t, e, l, o, n), !0) : !1;
}
function o_(t, e, n, r, o) {
  let i = D.empty;
  for (let d = n.length - 1; d >= 0; d--)
    i = D.from(n[d].type.create(n[d].attrs, i));
  t.step(new Ht(e.start - (r ? 2 : 0), e.end, e.start, e.end, new N(i, 0, 0), n.length, !0));
  let s = 0;
  for (let d = 0; d < n.length; d++)
    n[d].type == o && (s = d + 1);
  let l = n.length - s, a = e.start + n.length - (r ? 2 : 0), c = e.parent;
  for (let d = e.startIndex, u = e.endIndex, f = !0; d < u; d++, f = !1)
    !f && Pr(t.doc, a, l) && (t.split(a, l), a += 2 * l), a += c.child(d).nodeSize;
  return t;
}
function i_(t) {
  return function(e, n) {
    let { $from: r, $to: o } = e.selection, i = r.blockRange(o, (s) => s.childCount > 0 && s.firstChild.type == t);
    return i ? n ? r.node(i.depth - 1).type == t ? s_(e, n, t, i) : l_(e, n, i) : !0 : !1;
  };
}
function s_(t, e, n, r) {
  let o = t.tr, i = r.end, s = r.$to.end(r.depth);
  i < s && (o.step(new Ht(i - 1, s, i, s, new N(D.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new Ca(o.doc.resolve(r.$from.pos), o.doc.resolve(s), r.depth));
  const l = Wi(r);
  if (l == null)
    return !1;
  o.lift(r, l);
  let a = o.mapping.map(i, -1) - 1;
  return Co(o.doc, a) && o.join(a), e(o.scrollIntoView()), !0;
}
function l_(t, e, n) {
  let r = t.tr, o = n.parent;
  for (let h = n.end, p = n.endIndex - 1, y = n.startIndex; p > y; p--)
    h -= o.child(p).nodeSize, r.delete(h - 1, h + 1);
  let i = r.doc.resolve(n.start), s = i.nodeAfter;
  if (r.mapping.map(n.end) != n.start + i.nodeAfter.nodeSize)
    return !1;
  let l = n.startIndex == 0, a = n.endIndex == o.childCount, c = i.node(-1), d = i.index(-1);
  if (!c.canReplace(d + (l ? 0 : 1), d + 1, s.content.append(a ? D.empty : D.from(o))))
    return !1;
  let u = i.pos, f = u + s.nodeSize;
  return r.step(new Ht(u - (l ? 1 : 0), f + (a ? 1 : 0), u + 1, f - 1, new N((l ? D.empty : D.from(o.copy(D.empty))).append(a ? D.empty : D.from(o.copy(D.empty))), l ? 0 : 1, a ? 0 : 1), l ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function a_(t) {
  return function(e, n) {
    let { $from: r, $to: o } = e.selection, i = r.blockRange(o, (c) => c.childCount > 0 && c.firstChild.type == t);
    if (!i)
      return !1;
    let s = i.startIndex;
    if (s == 0)
      return !1;
    let l = i.parent, a = l.child(s - 1);
    if (a.type != t)
      return !1;
    if (n) {
      let c = a.lastChild && a.lastChild.type == l.type, d = D.from(c ? t.create() : null), u = new N(D.from(t.create(null, D.from(l.type.create(null, d)))), c ? 3 : 1, 0), f = i.start, h = i.end;
      n(e.tr.step(new Ht(f - (c ? 3 : 1), h, f, h, u, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Ic(t) {
  const { state: e, transaction: n } = t;
  let { selection: r } = n, { doc: o } = n, { storedMarks: i } = n;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return i;
    },
    get selection() {
      return r;
    },
    get doc() {
      return o;
    },
    get tr() {
      return r = n.selection, o = n.doc, i = n.storedMarks, n;
    }
  };
}
class Mc {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: r } = this, { view: o } = n, { tr: i } = r, s = this.buildProps(i);
    return Object.fromEntries(Object.entries(e).map(([l, a]) => [l, (...d) => {
      const u = a(...d)(s);
      return !i.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(i), u;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: r, editor: o, state: i } = this, { view: s } = o, l = [], a = !!e, c = e || i.tr, d = () => (!a && n && !c.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(c), l.every((f) => f === !0)), u = {
      ...Object.fromEntries(Object.entries(r).map(([f, h]) => [f, (...y) => {
        const b = this.buildProps(c, n), w = h(...y)(b);
        return l.push(w), u;
      }])),
      run: d
    };
    return u;
  }
  createCan(e) {
    const { rawCommands: n, state: r } = this, o = !1, i = e || r.tr, s = this.buildProps(i, o);
    return {
      ...Object.fromEntries(Object.entries(n).map(([a, c]) => [a, (...d) => c(...d)({ ...s, dispatch: void 0 })])),
      chain: () => this.createChain(i, o)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: r, editor: o, state: i } = this, { view: s } = o, l = {
      tr: e,
      editor: o,
      view: s,
      state: Ic({
        state: i,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([a, c]) => [a, (...d) => c(...d)(l)]));
      }
    };
    return l;
  }
}
class c_ {
  constructor() {
    this.callbacks = {};
  }
  on(e, n) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(n), this;
  }
  emit(e, ...n) {
    const r = this.callbacks[e];
    return r && r.forEach((o) => o.apply(this, n)), this;
  }
  off(e, n) {
    const r = this.callbacks[e];
    return r && (n ? this.callbacks[e] = r.filter((o) => o !== n) : delete this.callbacks[e]), this;
  }
  once(e, n) {
    const r = (...o) => {
      this.off(e, r), n.apply(this, o);
    };
    return this.on(e, r);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function K(t, e, n) {
  return t.config[e] === void 0 && t.parent ? K(t.parent, e, n) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...n,
    parent: t.parent ? K(t.parent, e, n) : null
  }) : t.config[e];
}
function Rc(t) {
  const e = t.filter((o) => o.type === "extension"), n = t.filter((o) => o.type === "node"), r = t.filter((o) => o.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: n,
    markExtensions: r
  };
}
function Sw(t) {
  const e = [], { nodeExtensions: n, markExtensions: r } = Rc(t), o = [...n, ...r], i = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return t.forEach((s) => {
    const l = {
      name: s.name,
      options: s.options,
      storage: s.storage,
      extensions: o
    }, a = K(s, "addGlobalAttributes", l);
    if (!a)
      return;
    a().forEach((d) => {
      d.types.forEach((u) => {
        Object.entries(d.attributes).forEach(([f, h]) => {
          e.push({
            type: u,
            name: f,
            attribute: {
              ...i,
              ...h
            }
          });
        });
      });
    });
  }), o.forEach((s) => {
    const l = {
      name: s.name,
      options: s.options,
      storage: s.storage
    }, a = K(s, "addAttributes", l);
    if (!a)
      return;
    const c = a();
    Object.entries(c).forEach(([d, u]) => {
      const f = {
        ...i,
        ...u
      };
      typeof (f == null ? void 0 : f.default) == "function" && (f.default = f.default()), f != null && f.isRequired && (f == null ? void 0 : f.default) === void 0 && delete f.default, e.push({
        type: s.name,
        name: d,
        attribute: f
      });
    });
  }), e;
}
function Wt(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
function wt(...t) {
  return t.filter((e) => !!e).reduce((e, n) => {
    const r = { ...e };
    return Object.entries(n).forEach(([o, i]) => {
      if (!r[o]) {
        r[o] = i;
        return;
      }
      if (o === "class") {
        const l = i ? i.split(" ") : [], a = r[o] ? r[o].split(" ") : [], c = l.filter((d) => !a.includes(d));
        r[o] = [...a, ...c].join(" ");
      } else if (o === "style") {
        const l = i ? i.split(";").map((d) => d.trim()).filter(Boolean) : [], a = r[o] ? r[o].split(";").map((d) => d.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        a.forEach((d) => {
          const [u, f] = d.split(":").map((h) => h.trim());
          c.set(u, f);
        }), l.forEach((d) => {
          const [u, f] = d.split(":").map((h) => h.trim());
          c.set(u, f);
        }), r[o] = Array.from(c.entries()).map(([d, u]) => `${d}: ${u}`).join("; ");
      } else
        r[o] = i;
    }), r;
  }, {});
}
function Iu(t, e) {
  return e.filter((n) => n.type === t.type.name).filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(t.attrs) || {} : {
    [n.name]: t.attrs[n.name]
  }).reduce((n, r) => wt(n, r), {});
}
function Cw(t) {
  return typeof t == "function";
}
function Re(t, e = void 0, ...n) {
  return Cw(t) ? e ? t.bind(e)(...n) : t(...n) : t;
}
function d_(t = {}) {
  return Object.keys(t).length === 0 && t.constructor === Object;
}
function u_(t) {
  return typeof t != "string" ? t : t.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(t) : t === "true" ? !0 : t === "false" ? !1 : t;
}
function zg(t, e) {
  return "style" in t ? t : {
    ...t,
    getAttrs: (n) => {
      const r = t.getAttrs ? t.getAttrs(n) : t.attrs;
      if (r === !1)
        return !1;
      const o = e.reduce((i, s) => {
        const l = s.attribute.parseHTML ? s.attribute.parseHTML(n) : u_(n.getAttribute(s.name));
        return l == null ? i : {
          ...i,
          [s.name]: l
        };
      }, {});
      return { ...r, ...o };
    }
  };
}
function Hg(t) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(t).filter(([e, n]) => e === "attrs" && d_(n) ? !1 : n != null)
  );
}
function f_(t, e) {
  var n;
  const r = Sw(t), { nodeExtensions: o, markExtensions: i } = Rc(t), s = (n = o.find((c) => K(c, "topNode"))) === null || n === void 0 ? void 0 : n.name, l = Object.fromEntries(o.map((c) => {
    const d = r.filter((w) => w.type === c.name), u = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, f = t.reduce((w, S) => {
      const x = K(S, "extendNodeSchema", u);
      return {
        ...w,
        ...x ? x(c) : {}
      };
    }, {}), h = Hg({
      ...f,
      content: Re(K(c, "content", u)),
      marks: Re(K(c, "marks", u)),
      group: Re(K(c, "group", u)),
      inline: Re(K(c, "inline", u)),
      atom: Re(K(c, "atom", u)),
      selectable: Re(K(c, "selectable", u)),
      draggable: Re(K(c, "draggable", u)),
      code: Re(K(c, "code", u)),
      whitespace: Re(K(c, "whitespace", u)),
      linebreakReplacement: Re(K(c, "linebreakReplacement", u)),
      defining: Re(K(c, "defining", u)),
      isolating: Re(K(c, "isolating", u)),
      attrs: Object.fromEntries(d.map((w) => {
        var S;
        return [w.name, { default: (S = w == null ? void 0 : w.attribute) === null || S === void 0 ? void 0 : S.default }];
      }))
    }), p = Re(K(c, "parseHTML", u));
    p && (h.parseDOM = p.map((w) => zg(w, d)));
    const y = K(c, "renderHTML", u);
    y && (h.toDOM = (w) => y({
      node: w,
      HTMLAttributes: Iu(w, d)
    }));
    const b = K(c, "renderText", u);
    return b && (h.toText = b), [c.name, h];
  })), a = Object.fromEntries(i.map((c) => {
    const d = r.filter((b) => b.type === c.name), u = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, f = t.reduce((b, w) => {
      const S = K(w, "extendMarkSchema", u);
      return {
        ...b,
        ...S ? S(c) : {}
      };
    }, {}), h = Hg({
      ...f,
      inclusive: Re(K(c, "inclusive", u)),
      excludes: Re(K(c, "excludes", u)),
      group: Re(K(c, "group", u)),
      spanning: Re(K(c, "spanning", u)),
      code: Re(K(c, "code", u)),
      attrs: Object.fromEntries(d.map((b) => {
        var w;
        return [b.name, { default: (w = b == null ? void 0 : b.attribute) === null || w === void 0 ? void 0 : w.default }];
      }))
    }), p = Re(K(c, "parseHTML", u));
    p && (h.parseDOM = p.map((b) => zg(b, d)));
    const y = K(c, "renderHTML", u);
    return y && (h.toDOM = (b) => y({
      mark: b,
      HTMLAttributes: Iu(b, d)
    })), [c.name, h];
  }));
  return new c1({
    topNode: s,
    nodes: l,
    marks: a
  });
}
function bd(t, e) {
  return e.nodes[t] || e.marks[t] || null;
}
function jg(t, e) {
  return Array.isArray(e) ? e.some((n) => (typeof n == "string" ? n : n.name) === t.name) : e;
}
function Xf(t, e) {
  const n = Qo.fromSchema(e).serializeFragment(t), o = document.implementation.createHTMLDocument().createElement("div");
  return o.appendChild(n), o.innerHTML;
}
const h_ = (t, e = 500) => {
  let n = "";
  const r = t.parentOffset;
  return t.parent.nodesBetween(Math.max(0, r - e), r, (o, i, s, l) => {
    var a, c;
    const d = ((c = (a = o.type.spec).toText) === null || c === void 0 ? void 0 : c.call(a, {
      node: o,
      pos: i,
      parent: s,
      index: l
    })) || o.textContent || "%leaf%";
    n += o.isAtom && !o.isText ? d : d.slice(0, Math.max(0, r - i));
  }), n;
};
function Qf(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
class Oc {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const p_ = (t, e) => {
  if (Qf(e))
    return e.exec(t);
  const n = e(t);
  if (!n)
    return null;
  const r = [n.text];
  return r.index = n.index, r.input = t, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
};
function El(t) {
  var e;
  const { editor: n, from: r, to: o, text: i, rules: s, plugin: l } = t, { view: a } = n;
  if (a.composing)
    return !1;
  const c = a.state.doc.resolve(r);
  if (
    // check for code node
    c.parent.type.spec.code || !((e = c.nodeBefore || c.nodeAfter) === null || e === void 0) && e.marks.find((f) => f.type.spec.code)
  )
    return !1;
  let d = !1;
  const u = h_(c) + i;
  return s.forEach((f) => {
    if (d)
      return;
    const h = p_(u, f.find);
    if (!h)
      return;
    const p = a.state.tr, y = Ic({
      state: a.state,
      transaction: p
    }), b = {
      from: r - (h[0].length - i.length),
      to: o
    }, { commands: w, chain: S, can: x } = new Mc({
      editor: n,
      state: y
    });
    f.handler({
      state: y,
      range: b,
      match: h,
      commands: w,
      chain: S,
      can: x
    }) === null || !p.steps.length || (p.setMeta(l, {
      transform: p,
      from: r,
      to: o,
      text: i
    }), a.dispatch(p), d = !0);
  }), d;
}
function g_(t) {
  const { editor: e, rules: n } = t, r = new Ft({
    state: {
      init() {
        return null;
      },
      apply(o, i, s) {
        const l = o.getMeta(r);
        if (l)
          return l;
        const a = o.getMeta("applyInputRules");
        return !!a && setTimeout(() => {
          let { text: d } = a;
          typeof d == "string" ? d = d : d = Xf(D.from(d), s.schema);
          const { from: u } = a, f = u + d.length;
          El({
            editor: e,
            from: u,
            to: f,
            text: d,
            rules: n,
            plugin: r
          });
        }), o.selectionSet || o.docChanged ? null : i;
      }
    },
    props: {
      handleTextInput(o, i, s, l) {
        return El({
          editor: e,
          from: i,
          to: s,
          text: l,
          rules: n,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (o) => (setTimeout(() => {
          const { $cursor: i } = o.state.selection;
          i && El({
            editor: e,
            from: i.pos,
            to: i.pos,
            text: "",
            rules: n,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(o, i) {
        if (i.key !== "Enter")
          return !1;
        const { $cursor: s } = o.state.selection;
        return s ? El({
          editor: e,
          from: s.pos,
          to: s.pos,
          text: `
`,
          rules: n,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function m_(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function kl(t) {
  return m_(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function Dc(t, e) {
  const n = { ...t };
  return kl(t) && kl(e) && Object.keys(e).forEach((r) => {
    kl(e[r]) && kl(t[r]) ? n[r] = Dc(t[r], e[r]) : n[r] = e[r];
  }), n;
}
class ir {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Re(K(this, "addOptions", {
      name: this.name
    }))), this.storage = Re(K(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new ir(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Dc(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new ir(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Re(K(n, "addOptions", {
      name: n.name
    })), n.storage = Re(K(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  static handleExit({ editor: e, mark: n }) {
    const { tr: r } = e.state, o = e.state.selection.$from;
    if (o.pos === o.end()) {
      const s = o.marks();
      if (!!!s.find((c) => (c == null ? void 0 : c.type.name) === n.name))
        return !1;
      const a = s.find((c) => (c == null ? void 0 : c.type.name) === n.name);
      return a && r.removeStoredMark(a), r.insertText(" ", o.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
}
function y_(t) {
  return typeof t == "number";
}
class b_ {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const w_ = (t, e, n) => {
  if (Qf(e))
    return [...t.matchAll(e)];
  const r = e(t, n);
  return r ? r.map((o) => {
    const i = [o.text];
    return i.index = o.index, i.input = t, i.data = o.data, o.replaceWith && (o.text.includes(o.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), i.push(o.replaceWith)), i;
  }) : [];
};
function S_(t) {
  const { editor: e, state: n, from: r, to: o, rule: i, pasteEvent: s, dropEvent: l } = t, { commands: a, chain: c, can: d } = new Mc({
    editor: e,
    state: n
  }), u = [];
  return n.doc.nodesBetween(r, o, (h, p) => {
    if (!h.isTextblock || h.type.spec.code)
      return;
    const y = Math.max(r, p), b = Math.min(o, p + h.content.size), w = h.textBetween(y - p, b - p, void 0, "￼");
    w_(w, i.find, s).forEach((x) => {
      if (x.index === void 0)
        return;
      const E = y + x.index + 1, v = E + x[0].length, T = {
        from: n.tr.mapping.map(E),
        to: n.tr.mapping.map(v)
      }, I = i.handler({
        state: n,
        range: T,
        match: x,
        commands: a,
        chain: c,
        can: d,
        pasteEvent: s,
        dropEvent: l
      });
      u.push(I);
    });
  }), u.every((h) => h !== null);
}
const C_ = (t) => {
  var e;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = n.clipboardData) === null || e === void 0 || e.setData("text/html", t), n;
};
function v_(t) {
  const { editor: e, rules: n } = t;
  let r = null, o = !1, i = !1, s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, l;
  try {
    l = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    l = null;
  }
  const a = ({ state: d, from: u, to: f, rule: h, pasteEvt: p }) => {
    const y = d.tr, b = Ic({
      state: d,
      transaction: y
    });
    if (!(!S_({
      editor: e,
      state: b,
      from: Math.max(u - 1, 0),
      to: f.b - 1,
      rule: h,
      pasteEvent: p,
      dropEvent: l
    }) || !y.steps.length)) {
      try {
        l = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        l = null;
      }
      return s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, y;
    }
  };
  return n.map((d) => new Ft({
    // we register a global drag handler to track the current drag source element
    view(u) {
      const f = (h) => {
        var p;
        r = !((p = u.dom.parentElement) === null || p === void 0) && p.contains(h.target) ? u.dom.parentElement : null;
      };
      return window.addEventListener("dragstart", f), {
        destroy() {
          window.removeEventListener("dragstart", f);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (u, f) => (i = r === u.dom.parentElement, l = f, !1),
        paste: (u, f) => {
          var h;
          const p = (h = f.clipboardData) === null || h === void 0 ? void 0 : h.getData("text/html");
          return s = f, o = !!(p != null && p.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (u, f, h) => {
      const p = u[0], y = p.getMeta("uiEvent") === "paste" && !o, b = p.getMeta("uiEvent") === "drop" && !i, w = p.getMeta("applyPasteRules"), S = !!w;
      if (!y && !b && !S)
        return;
      if (S) {
        let { text: v } = w;
        typeof v == "string" ? v = v : v = Xf(D.from(v), h.schema);
        const { from: T } = w, I = T + v.length, M = C_(v);
        return a({
          rule: d,
          state: h,
          from: T,
          to: { b: I },
          pasteEvt: M
        });
      }
      const x = f.doc.content.findDiffStart(h.doc.content), E = f.doc.content.findDiffEnd(h.doc.content);
      if (!(!y_(x) || !E || x === E.b))
        return a({
          rule: d,
          state: h,
          from: x,
          to: E,
          pasteEvt: s
        });
    }
  }));
}
function x_(t) {
  const e = t.filter((n, r) => t.indexOf(n) !== r);
  return Array.from(new Set(e));
}
class gi {
  constructor(e, n) {
    this.splittableMarks = [], this.editor = n, this.extensions = gi.resolve(e), this.schema = f_(this.extensions, n), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const n = gi.sort(gi.flatten(e)), r = x_(n.map((o) => o.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((o) => `'${o}'`).join(", ")}]. This can lead to issues.`), n;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage
      }, o = K(n, "addExtensions", r);
      return o ? [n, ...this.flatten(o())] : n;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((r, o) => {
      const i = K(r, "priority") || 100, s = K(o, "priority") || 100;
      return i > s ? -1 : i < s ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: this.editor,
        type: bd(n.name, this.schema)
      }, o = K(n, "addCommands", r);
      return o ? {
        ...e,
        ...o()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, n = gi.sort([...this.extensions].reverse()), r = [], o = [], i = n.map((s) => {
      const l = {
        name: s.name,
        options: s.options,
        storage: s.storage,
        editor: e,
        type: bd(s.name, this.schema)
      }, a = [], c = K(s, "addKeyboardShortcuts", l);
      let d = {};
      if (s.type === "mark" && K(s, "exitable", l) && (d.ArrowRight = () => ir.handleExit({ editor: e, mark: s })), c) {
        const y = Object.fromEntries(Object.entries(c()).map(([b, w]) => [b, () => w({ editor: e })]));
        d = { ...d, ...y };
      }
      const u = HP(d);
      a.push(u);
      const f = K(s, "addInputRules", l);
      jg(s, e.options.enableInputRules) && f && r.push(...f());
      const h = K(s, "addPasteRules", l);
      jg(s, e.options.enablePasteRules) && h && o.push(...h());
      const p = K(s, "addProseMirrorPlugins", l);
      if (p) {
        const y = p();
        a.push(...y);
      }
      return a;
    }).flat();
    return [
      g_({
        editor: e,
        rules: r
      }),
      ...v_({
        editor: e,
        rules: o
      }),
      ...i
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Sw(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: n } = Rc(this.extensions);
    return Object.fromEntries(n.filter((r) => !!K(r, "addNodeView")).map((r) => {
      const o = this.attributes.filter((a) => a.type === r.name), i = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: e,
        type: Wt(r.name, this.schema)
      }, s = K(r, "addNodeView", i);
      if (!s)
        return [];
      const l = (a, c, d, u, f) => {
        const h = Iu(a, o);
        return s()({
          // pass-through
          node: a,
          view: c,
          getPos: d,
          decorations: u,
          innerDecorations: f,
          // tiptap-specific
          editor: e,
          extension: r,
          HTMLAttributes: h
        });
      };
      return [r.name, l];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var n;
      this.editor.extensionStorage[e.name] = e.storage;
      const r = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: bd(e.name, this.schema)
      };
      e.type === "mark" && (!((n = Re(K(e, "keepOnSplit", r))) !== null && n !== void 0) || n) && this.splittableMarks.push(e.name);
      const o = K(e, "onBeforeCreate", r), i = K(e, "onCreate", r), s = K(e, "onUpdate", r), l = K(e, "onSelectionUpdate", r), a = K(e, "onTransaction", r), c = K(e, "onFocus", r), d = K(e, "onBlur", r), u = K(e, "onDestroy", r);
      o && this.editor.on("beforeCreate", o), i && this.editor.on("create", i), s && this.editor.on("update", s), l && this.editor.on("selectionUpdate", l), a && this.editor.on("transaction", a), c && this.editor.on("focus", c), d && this.editor.on("blur", d), u && this.editor.on("destroy", u);
    });
  }
}
class en {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Re(K(this, "addOptions", {
      name: this.name
    }))), this.storage = Re(K(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new en(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Dc(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new en({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Re(K(n, "addOptions", {
      name: n.name
    })), n.storage = Re(K(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function vw(t, e, n) {
  const { from: r, to: o } = e, { blockSeparator: i = `

`, textSerializers: s = {} } = n || {};
  let l = "";
  return t.nodesBetween(r, o, (a, c, d, u) => {
    var f;
    a.isBlock && c > r && (l += i);
    const h = s == null ? void 0 : s[a.type.name];
    if (h)
      return d && (l += h({
        node: a,
        pos: c,
        parent: d,
        index: u,
        range: e
      })), !1;
    a.isText && (l += (f = a == null ? void 0 : a.text) === null || f === void 0 ? void 0 : f.slice(Math.max(r, c) - c, o - c));
  }), l;
}
function xw(t) {
  return Object.fromEntries(Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, n]) => [e, n.spec.toText]));
}
const E_ = en.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Ft({
        key: new tn("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: n } = t, { doc: r, selection: o } = e, { ranges: i } = o, s = Math.min(...i.map((d) => d.$from.pos)), l = Math.max(...i.map((d) => d.$to.pos)), a = xw(n);
            return vw(r, { from: s, to: l }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: a
            });
          }
        }
      })
    ];
  }
}), k_ = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var n;
  t.isDestroyed || (e.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), T_ = (t = !1) => ({ commands: e }) => e.setContent("", t), I_ = () => ({ state: t, tr: e, dispatch: n }) => {
  const { selection: r } = e, { ranges: o } = r;
  return n && o.forEach(({ $from: i, $to: s }) => {
    t.doc.nodesBetween(i.pos, s.pos, (l, a) => {
      if (l.type.isText)
        return;
      const { doc: c, mapping: d } = e, u = c.resolve(d.map(a)), f = c.resolve(d.map(a + l.nodeSize)), h = u.blockRange(f);
      if (!h)
        return;
      const p = Wi(h);
      if (l.type.isTextblock) {
        const { defaultType: y } = u.parent.contentMatchAt(u.index());
        e.setNodeMarkup(h.start, y);
      }
      (p || p === 0) && e.lift(h, p);
    });
  }), !0;
}, M_ = (t) => (e) => t(e), R_ = () => ({ state: t, dispatch: e }) => mw(t, e), O_ = (t, e) => ({ editor: n, tr: r }) => {
  const { state: o } = n, i = o.doc.slice(t.from, t.to);
  r.deleteRange(t.from, t.to);
  const s = r.mapping.map(e);
  return r.insert(s, i.content), r.setSelection(new ce(r.doc.resolve(s - 1))), !0;
}, D_ = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const o = t.selection.$anchor;
  for (let i = o.depth; i > 0; i -= 1)
    if (o.node(i).type === r.type) {
      if (e) {
        const l = o.before(i), a = o.after(i);
        t.delete(l, a).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, A_ = (t) => ({ tr: e, state: n, dispatch: r }) => {
  const o = Wt(t, n.schema), i = e.selection.$anchor;
  for (let s = i.depth; s > 0; s -= 1)
    if (i.node(s).type === o) {
      if (r) {
        const a = i.before(s), c = i.after(s);
        e.delete(a, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, L_ = (t) => ({ tr: e, dispatch: n }) => {
  const { from: r, to: o } = t;
  return n && e.delete(r, o), !0;
}, $_ = () => ({ state: t, dispatch: e }) => qf(t, e), P_ = () => ({ commands: t }) => t.keyboardShortcut("Enter"), __ = () => ({ state: t, dispatch: e }) => JP(t, e);
function Da(t, e, n = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((o) => n.strict ? e[o] === t[o] : Qf(e[o]) ? e[o].test(t[o]) : e[o] === t[o]) : !0;
}
function Ew(t, e, n = {}) {
  return t.find((r) => r.type === e && Da(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((o) => [o, r.attrs[o]])),
    n
  ));
}
function Wg(t, e, n = {}) {
  return !!Ew(t, e, n);
}
function eh(t, e, n) {
  var r;
  if (!t || !e)
    return;
  let o = t.parent.childAfter(t.parentOffset);
  if ((!o.node || !o.node.marks.some((d) => d.type === e)) && (o = t.parent.childBefore(t.parentOffset)), !o.node || !o.node.marks.some((d) => d.type === e) || (n = n || ((r = o.node.marks[0]) === null || r === void 0 ? void 0 : r.attrs), !Ew([...o.node.marks], e, n)))
    return;
  let s = o.index, l = t.start() + o.offset, a = s + 1, c = l + o.node.nodeSize;
  for (; s > 0 && Wg([...t.parent.child(s - 1).marks], e, n); )
    s -= 1, l -= t.parent.child(s).nodeSize;
  for (; a < t.parent.childCount && Wg([...t.parent.child(a).marks], e, n); )
    c += t.parent.child(a).nodeSize, a += 1;
  return {
    from: l,
    to: c
  };
}
function xo(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
const B_ = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  const i = xo(t, r.schema), { doc: s, selection: l } = n, { $from: a, from: c, to: d } = l;
  if (o) {
    const u = eh(a, i, e);
    if (u && u.from <= c && u.to >= d) {
      const f = ce.create(s, u.from, u.to);
      n.setSelection(f);
    }
  }
  return !0;
}, V_ = (t) => (e) => {
  const n = typeof t == "function" ? t(e) : t;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](e))
      return !0;
  return !1;
};
function kw(t) {
  return t instanceof ce;
}
function Do(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(t, e), n);
}
function Tw(t, e = null) {
  if (!e)
    return null;
  const n = fe.atStart(t), r = fe.atEnd(t);
  if (e === "start" || e === !0)
    return n;
  if (e === "end")
    return r;
  const o = n.from, i = r.to;
  return e === "all" ? ce.create(t, Do(0, o, i), Do(t.content.size, o, i)) : ce.create(t, Do(e, o, i), Do(e, o, i));
}
function th() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const F_ = (t = null, e = {}) => ({ editor: n, view: r, tr: o, dispatch: i }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const s = () => {
    th() && r.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), e != null && e.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && t === null || t === !1)
    return !0;
  if (i && t === null && !kw(n.state.selection))
    return s(), !0;
  const l = Tw(o.doc, t) || n.state.selection, a = n.state.selection.eq(l);
  return i && (a || o.setSelection(l), a && o.storedMarks && o.setStoredMarks(o.storedMarks), s()), !0;
}, N_ = (t, e) => (n) => t.every((r, o) => e(r, { ...n, index: o })), z_ = (t, e) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, t, e), Iw = (t) => {
  const e = t.childNodes;
  for (let n = e.length - 1; n >= 0; n -= 1) {
    const r = e[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? t.removeChild(r) : r.nodeType === 1 && Iw(r);
  }
  return t;
};
function Tl(t) {
  const e = `<body>${t}</body>`, n = new window.DOMParser().parseFromString(e, "text/html").body;
  return Iw(n);
}
function Aa(t, e, n) {
  if (t instanceof uo || t instanceof D)
    return t;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof t == "object" && t !== null, o = typeof t == "string";
  if (r)
    try {
      if (Array.isArray(t) && t.length > 0)
        return D.fromArray(t.map((l) => e.nodeFromJSON(l)));
      const s = e.nodeFromJSON(t);
      return n.errorOnInvalidContent && s.check(), s;
    } catch (i) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: i });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", i), Aa("", e, n);
    }
  if (o) {
    if (n.errorOnInvalidContent) {
      let s = !1, l = "";
      const a = new c1({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (s = !0, l = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? fo.fromSchema(a).parseSlice(Tl(t), n.parseOptions) : fo.fromSchema(a).parse(Tl(t), n.parseOptions), n.errorOnInvalidContent && s)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${l}`) });
    }
    const i = fo.fromSchema(e);
    return n.slice ? i.parseSlice(Tl(t), n.parseOptions).content : i.parse(Tl(t), n.parseOptions);
  }
  return Aa("", e, n);
}
function H_(t, e, n) {
  const r = t.steps.length - 1;
  if (r < e)
    return;
  const o = t.steps[r];
  if (!(o instanceof zt || o instanceof Ht))
    return;
  const i = t.mapping.maps[r];
  let s = 0;
  i.forEach((l, a, c, d) => {
    s === 0 && (s = d);
  }), t.setSelection(fe.near(t.doc.resolve(s), n));
}
const j_ = (t) => !("type" in t), W_ = (t, e, n) => ({ tr: r, dispatch: o, editor: i }) => {
  var s;
  if (o) {
    n = {
      parseOptions: i.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let l;
    try {
      l = Aa(e, i.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...n.parseOptions
        },
        errorOnInvalidContent: (s = n.errorOnInvalidContent) !== null && s !== void 0 ? s : i.options.enableContentCheck
      });
    } catch (p) {
      return i.emit("contentError", {
        editor: i,
        error: p,
        disableCollaboration: () => {
          i.storage.collaboration && (i.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: a, to: c } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, d = !0, u = !0;
    if ((j_(l) ? l : [l]).forEach((p) => {
      p.check(), d = d ? p.isText && p.marks.length === 0 : !1, u = u ? p.isBlock : !1;
    }), a === c && u) {
      const { parent: p } = r.doc.resolve(a);
      p.isTextblock && !p.type.spec.code && !p.childCount && (a -= 1, c += 1);
    }
    let h;
    if (d) {
      if (Array.isArray(e))
        h = e.map((p) => p.text || "").join("");
      else if (e instanceof D) {
        let p = "";
        e.forEach((y) => {
          y.text && (p += y.text);
        }), h = p;
      } else typeof e == "object" && e && e.text ? h = e.text : h = e;
      r.insertText(h, a, c);
    } else
      h = l, r.replaceWith(a, c, h);
    n.updateSelection && H_(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: a, text: h }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: a, text: h });
  }
  return !0;
}, G_ = () => ({ state: t, dispatch: e }) => GP(t, e), U_ = () => ({ state: t, dispatch: e }) => UP(t, e), q_ = () => ({ state: t, dispatch: e }) => cw(t, e), J_ = () => ({ state: t, dispatch: e }) => hw(t, e), K_ = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = Cc(t.doc, t.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, Y_ = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = Cc(t.doc, t.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, Z_ = () => ({ state: t, dispatch: e }) => jP(t, e), X_ = () => ({ state: t, dispatch: e }) => WP(t, e);
function Mw() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function Q_(t) {
  const e = t.split(/-(?!$)/);
  let n = e[e.length - 1];
  n === "Space" && (n = " ");
  let r, o, i, s;
  for (let l = 0; l < e.length - 1; l += 1) {
    const a = e[l];
    if (/^(cmd|meta|m)$/i.test(a))
      s = !0;
    else if (/^a(lt)?$/i.test(a))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(a))
      o = !0;
    else if (/^s(hift)?$/i.test(a))
      i = !0;
    else if (/^mod$/i.test(a))
      th() || Mw() ? s = !0 : o = !0;
    else
      throw new Error(`Unrecognized modifier name: ${a}`);
  }
  return r && (n = `Alt-${n}`), o && (n = `Ctrl-${n}`), s && (n = `Meta-${n}`), i && (n = `Shift-${n}`), n;
}
const e4 = (t) => ({ editor: e, view: n, tr: r, dispatch: o }) => {
  const i = Q_(t).split(/-(?!$)/), s = i.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), l = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: i.includes("Alt"),
    ctrlKey: i.includes("Ctrl"),
    metaKey: i.includes("Meta"),
    shiftKey: i.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), a = e.captureTransaction(() => {
    n.someProp("handleKeyDown", (c) => c(n, l));
  });
  return a == null || a.steps.forEach((c) => {
    const d = c.map(r.mapping);
    d && o && r.maybeStep(d);
  }), !0;
};
function Gs(t, e, n = {}) {
  const { from: r, to: o, empty: i } = t.selection, s = e ? Wt(e, t.schema) : null, l = [];
  t.doc.nodesBetween(r, o, (u, f) => {
    if (u.isText)
      return;
    const h = Math.max(r, f), p = Math.min(o, f + u.nodeSize);
    l.push({
      node: u,
      from: h,
      to: p
    });
  });
  const a = o - r, c = l.filter((u) => s ? s.name === u.node.type.name : !0).filter((u) => Da(u.node.attrs, n, { strict: !1 }));
  return i ? !!c.length : c.reduce((u, f) => u + f.to - f.from, 0) >= a;
}
const t4 = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = Wt(t, n.schema);
  return Gs(n, o, e) ? qP(n, r) : !1;
}, n4 = () => ({ state: t, dispatch: e }) => yw(t, e), r4 = (t) => ({ state: e, dispatch: n }) => {
  const r = Wt(t, e.schema);
  return i_(r)(e, n);
}, o4 = () => ({ state: t, dispatch: e }) => gw(t, e);
function Ac(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function Gg(t, e) {
  const n = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((r, o) => (n.includes(o) || (r[o] = t[o]), r), {});
}
const i4 = (t, e) => ({ tr: n, state: r, dispatch: o }) => {
  let i = null, s = null;
  const l = Ac(typeof t == "string" ? t : t.name, r.schema);
  return l ? (l === "node" && (i = Wt(t, r.schema)), l === "mark" && (s = xo(t, r.schema)), o && n.selection.ranges.forEach((a) => {
    r.doc.nodesBetween(a.$from.pos, a.$to.pos, (c, d) => {
      i && i === c.type && n.setNodeMarkup(d, void 0, Gg(c.attrs, e)), s && c.marks.length && c.marks.forEach((u) => {
        s === u.type && n.addMark(d, d + c.nodeSize, s.create(Gg(u.attrs, e)));
      });
    });
  }), !0) : !1;
}, s4 = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), l4 = () => ({ tr: t, commands: e }) => e.setTextSelection({
  from: 0,
  to: t.doc.content.size
}), a4 = () => ({ state: t, dispatch: e }) => uw(t, e), c4 = () => ({ state: t, dispatch: e }) => pw(t, e), d4 = () => ({ state: t, dispatch: e }) => ZP(t, e), u4 = () => ({ state: t, dispatch: e }) => e_(t, e), f4 = () => ({ state: t, dispatch: e }) => QP(t, e);
function Mu(t, e, n = {}, r = {}) {
  return Aa(t, e, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const h4 = (t, e = !1, n = {}, r = {}) => ({ editor: o, tr: i, dispatch: s, commands: l }) => {
  var a, c;
  const { doc: d } = i;
  if (n.preserveWhitespace !== "full") {
    const u = Mu(t, o.schema, n, {
      errorOnInvalidContent: (a = r.errorOnInvalidContent) !== null && a !== void 0 ? a : o.options.enableContentCheck
    });
    return s && i.replaceWith(0, d.content.size, u).setMeta("preventUpdate", !e), !0;
  }
  return s && i.setMeta("preventUpdate", !e), l.insertContentAt({ from: 0, to: d.content.size }, t, {
    parseOptions: n,
    errorOnInvalidContent: (c = r.errorOnInvalidContent) !== null && c !== void 0 ? c : o.options.enableContentCheck
  });
};
function Rw(t, e) {
  const n = xo(e, t.schema), { from: r, to: o, empty: i } = t.selection, s = [];
  i ? (t.storedMarks && s.push(...t.storedMarks), s.push(...t.selection.$head.marks())) : t.doc.nodesBetween(r, o, (a) => {
    s.push(...a.marks);
  });
  const l = s.find((a) => a.type.name === n.name);
  return l ? { ...l.attrs } : {};
}
function p4(t, e) {
  const n = new _f(t);
  return e.forEach((r) => {
    r.steps.forEach((o) => {
      n.step(o);
    });
  }), n;
}
function g4(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function m4(t, e, n) {
  const r = [];
  return t.nodesBetween(e.from, e.to, (o, i) => {
    n(o) && r.push({
      node: o,
      pos: i
    });
  }), r;
}
function Ow(t, e) {
  for (let n = t.depth; n > 0; n -= 1) {
    const r = t.node(n);
    if (e(r))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: r
      };
  }
}
function nh(t) {
  return (e) => Ow(e.$from, t);
}
function y4(t, e) {
  const n = {
    from: 0,
    to: t.content.size
  };
  return vw(t, n, e);
}
function b4(t, e) {
  const n = Wt(e, t.schema), { from: r, to: o } = t.selection, i = [];
  t.doc.nodesBetween(r, o, (l) => {
    i.push(l);
  });
  const s = i.reverse().find((l) => l.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function Dw(t, e) {
  const n = Ac(typeof e == "string" ? e : e.name, t.schema);
  return n === "node" ? b4(t, e) : n === "mark" ? Rw(t, e) : {};
}
function w4(t, e = JSON.stringify) {
  const n = {};
  return t.filter((r) => {
    const o = e(r);
    return Object.prototype.hasOwnProperty.call(n, o) ? !1 : n[o] = !0;
  });
}
function S4(t) {
  const e = w4(t);
  return e.length === 1 ? e : e.filter((n, r) => !e.filter((i, s) => s !== r).some((i) => n.oldRange.from >= i.oldRange.from && n.oldRange.to <= i.oldRange.to && n.newRange.from >= i.newRange.from && n.newRange.to <= i.newRange.to));
}
function C4(t) {
  const { mapping: e, steps: n } = t, r = [];
  return e.maps.forEach((o, i) => {
    const s = [];
    if (o.ranges.length)
      o.forEach((l, a) => {
        s.push({ from: l, to: a });
      });
    else {
      const { from: l, to: a } = n[i];
      if (l === void 0 || a === void 0)
        return;
      s.push({ from: l, to: a });
    }
    s.forEach(({ from: l, to: a }) => {
      const c = e.slice(i).map(l, -1), d = e.slice(i).map(a), u = e.invert().map(c, -1), f = e.invert().map(d);
      r.push({
        oldRange: {
          from: u,
          to: f
        },
        newRange: {
          from: c,
          to: d
        }
      });
    });
  }), S4(r);
}
function rh(t, e, n) {
  const r = [];
  return t === e ? n.resolve(t).marks().forEach((o) => {
    const i = n.resolve(t), s = eh(i, o.type);
    s && r.push({
      mark: o,
      ...s
    });
  }) : n.nodesBetween(t, e, (o, i) => {
    !o || (o == null ? void 0 : o.nodeSize) === void 0 || r.push(...o.marks.map((s) => ({
      from: i,
      to: i + o.nodeSize,
      mark: s
    })));
  }), r;
}
function Xl(t, e, n) {
  return Object.fromEntries(Object.entries(n).filter(([r]) => {
    const o = t.find((i) => i.type === e && i.name === r);
    return o ? o.attribute.keepOnSplit : !1;
  }));
}
function Ru(t, e, n = {}) {
  const { empty: r, ranges: o } = t.selection, i = e ? xo(e, t.schema) : null;
  if (r)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((u) => i ? i.name === u.type.name : !0).find((u) => Da(u.attrs, n, { strict: !1 }));
  let s = 0;
  const l = [];
  if (o.forEach(({ $from: u, $to: f }) => {
    const h = u.pos, p = f.pos;
    t.doc.nodesBetween(h, p, (y, b) => {
      if (!y.isText && !y.marks.length)
        return;
      const w = Math.max(h, b), S = Math.min(p, b + y.nodeSize), x = S - w;
      s += x, l.push(...y.marks.map((E) => ({
        mark: E,
        from: w,
        to: S
      })));
    });
  }), s === 0)
    return !1;
  const a = l.filter((u) => i ? i.name === u.mark.type.name : !0).filter((u) => Da(u.mark.attrs, n, { strict: !1 })).reduce((u, f) => u + f.to - f.from, 0), c = l.filter((u) => i ? u.mark.type !== i && u.mark.type.excludes(i) : !0).reduce((u, f) => u + f.to - f.from, 0);
  return (a > 0 ? a + c : a) >= s;
}
function v4(t, e, n = {}) {
  if (!e)
    return Gs(t, null, n) || Ru(t, null, n);
  const r = Ac(e, t.schema);
  return r === "node" ? Gs(t, e, n) : r === "mark" ? Ru(t, e, n) : !1;
}
function Ug(t, e) {
  const { nodeExtensions: n } = Rc(e), r = n.find((s) => s.name === t);
  if (!r)
    return !1;
  const o = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, i = Re(K(r, "group", o));
  return typeof i != "string" ? !1 : i.split(" ").includes("list");
}
function Lc(t, { checkChildren: e = !0, ignoreWhitespace: n = !1 } = {}) {
  var r;
  if (n) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return /^\s*$/m.test((r = t.text) !== null && r !== void 0 ? r : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let o = !0;
    return t.content.forEach((i) => {
      o !== !1 && (Lc(i, { ignoreWhitespace: n, checkChildren: e }) || (o = !1));
    }), o;
  }
  return !1;
}
function x4(t) {
  return t instanceof le;
}
function E4(t, e, n) {
  var r;
  const { selection: o } = e;
  let i = null;
  if (kw(o) && (i = o.$cursor), i) {
    const l = (r = t.storedMarks) !== null && r !== void 0 ? r : i.marks();
    return !!n.isInSet(l) || !l.some((a) => a.type.excludes(n));
  }
  const { ranges: s } = o;
  return s.some(({ $from: l, $to: a }) => {
    let c = l.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(n) : !1;
    return t.doc.nodesBetween(l.pos, a.pos, (d, u, f) => {
      if (c)
        return !1;
      if (d.isInline) {
        const h = !f || f.type.allowsMarkType(n), p = !!n.isInSet(d.marks) || !d.marks.some((y) => y.type.excludes(n));
        c = h && p;
      }
      return !c;
    }), c;
  });
}
const k4 = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  const { selection: i } = n, { empty: s, ranges: l } = i, a = xo(t, r.schema);
  if (o)
    if (s) {
      const c = Rw(r, a);
      n.addStoredMark(a.create({
        ...c,
        ...e
      }));
    } else
      l.forEach((c) => {
        const d = c.$from.pos, u = c.$to.pos;
        r.doc.nodesBetween(d, u, (f, h) => {
          const p = Math.max(h, d), y = Math.min(h + f.nodeSize, u);
          f.marks.find((w) => w.type === a) ? f.marks.forEach((w) => {
            a === w.type && n.addMark(p, y, a.create({
              ...w.attrs,
              ...e
            }));
          }) : n.addMark(p, y, a.create(e));
        });
      });
  return E4(r, n, a);
}, T4 = (t, e) => ({ tr: n }) => (n.setMeta(t, e), !0), I4 = (t, e = {}) => ({ state: n, dispatch: r, chain: o }) => {
  const i = Wt(t, n.schema);
  let s;
  return n.selection.$anchor.sameParent(n.selection.$head) && (s = n.selection.$anchor.parent.attrs), i.isTextblock ? o().command(({ commands: l }) => Ng(i, { ...s, ...e })(n) ? !0 : l.clearNodes()).command(({ state: l }) => Ng(i, { ...s, ...e })(l, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, M4 = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, o = Do(t, 0, r.content.size), i = le.create(r, o);
    e.setSelection(i);
  }
  return !0;
}, R4 = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, { from: o, to: i } = typeof t == "number" ? { from: t, to: t } : t, s = ce.atStart(r).from, l = ce.atEnd(r).to, a = Do(o, s, l), c = Do(i, s, l), d = ce.create(r, a, c);
    e.setSelection(d);
  }
  return !0;
}, O4 = (t) => ({ state: e, dispatch: n }) => {
  const r = Wt(t, e.schema);
  return a_(r)(e, n);
};
function qg(t, e) {
  const n = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (n) {
    const r = n.filter((o) => e == null ? void 0 : e.includes(o.type.name));
    t.tr.ensureMarks(r);
  }
}
const D4 = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: n, dispatch: r, editor: o }) => {
  const { selection: i, doc: s } = e, { $from: l, $to: a } = i, c = o.extensionManager.attributes, d = Xl(c, l.node().type.name, l.node().attrs);
  if (i instanceof le && i.node.isBlock)
    return !l.parentOffset || !Pr(s, l.pos) ? !1 : (r && (t && qg(n, o.extensionManager.splittableMarks), e.split(l.pos).scrollIntoView()), !0);
  if (!l.parent.isBlock)
    return !1;
  const u = a.parentOffset === a.parent.content.size, f = l.depth === 0 ? void 0 : g4(l.node(-1).contentMatchAt(l.indexAfter(-1)));
  let h = u && f ? [
    {
      type: f,
      attrs: d
    }
  ] : void 0, p = Pr(e.doc, e.mapping.map(l.pos), 1, h);
  if (!h && !p && Pr(e.doc, e.mapping.map(l.pos), 1, f ? [{ type: f }] : void 0) && (p = !0, h = f ? [
    {
      type: f,
      attrs: d
    }
  ] : void 0), r) {
    if (p && (i instanceof ce && e.deleteSelection(), e.split(e.mapping.map(l.pos), 1, h), f && !u && !l.parentOffset && l.parent.type !== f)) {
      const y = e.mapping.map(l.before()), b = e.doc.resolve(y);
      l.node(-1).canReplaceWith(b.index(), b.index() + 1, f) && e.setNodeMarkup(e.mapping.map(l.before()), f);
    }
    t && qg(n, o.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, A4 = (t, e = {}) => ({ tr: n, state: r, dispatch: o, editor: i }) => {
  var s;
  const l = Wt(t, r.schema), { $from: a, $to: c } = r.selection, d = r.selection.node;
  if (d && d.isBlock || a.depth < 2 || !a.sameParent(c))
    return !1;
  const u = a.node(-1);
  if (u.type !== l)
    return !1;
  const f = i.extensionManager.attributes;
  if (a.parent.content.size === 0 && a.node(-1).childCount === a.indexAfter(-1)) {
    if (a.depth === 2 || a.node(-3).type !== l || a.index(-2) !== a.node(-2).childCount - 1)
      return !1;
    if (o) {
      let w = D.empty;
      const S = a.index(-1) ? 1 : a.index(-2) ? 2 : 3;
      for (let M = a.depth - S; M >= a.depth - 3; M -= 1)
        w = D.from(a.node(M).copy(w));
      const x = a.indexAfter(-1) < a.node(-2).childCount ? 1 : a.indexAfter(-2) < a.node(-3).childCount ? 2 : 3, E = {
        ...Xl(f, a.node().type.name, a.node().attrs),
        ...e
      }, v = ((s = l.contentMatch.defaultType) === null || s === void 0 ? void 0 : s.createAndFill(E)) || void 0;
      w = w.append(D.from(l.createAndFill(null, v) || void 0));
      const T = a.before(a.depth - (S - 1));
      n.replace(T, a.after(-x), new N(w, 4 - S, 0));
      let I = -1;
      n.doc.nodesBetween(T, n.doc.content.size, (M, R) => {
        if (I > -1)
          return !1;
        M.isTextblock && M.content.size === 0 && (I = R + 1);
      }), I > -1 && n.setSelection(ce.near(n.doc.resolve(I))), n.scrollIntoView();
    }
    return !0;
  }
  const h = c.pos === a.end() ? u.contentMatchAt(0).defaultType : null, p = {
    ...Xl(f, u.type.name, u.attrs),
    ...e
  }, y = {
    ...Xl(f, a.node().type.name, a.node().attrs),
    ...e
  };
  n.delete(a.pos, c.pos);
  const b = h ? [
    { type: l, attrs: p },
    { type: h, attrs: y }
  ] : [{ type: l, attrs: p }];
  if (!Pr(n.doc, a.pos, 2))
    return !1;
  if (o) {
    const { selection: w, storedMarks: S } = r, { splittableMarks: x } = i.extensionManager, E = S || w.$to.parentOffset && w.$from.marks();
    if (n.split(a.pos, 2, b).scrollIntoView(), !E || !o)
      return !0;
    const v = E.filter((T) => x.includes(T.type.name));
    n.ensureMarks(v);
  }
  return !0;
}, wd = (t, e) => {
  const n = nh((s) => s.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const o = t.doc.nodeAt(r);
  return n.node.type === (o == null ? void 0 : o.type) && Co(t.doc, n.pos) && t.join(n.pos), !0;
}, Sd = (t, e) => {
  const n = nh((s) => s.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const o = t.doc.nodeAt(r);
  return n.node.type === (o == null ? void 0 : o.type) && Co(t.doc, r) && t.join(r), !0;
}, L4 = (t, e, n, r = {}) => ({ editor: o, tr: i, state: s, dispatch: l, chain: a, commands: c, can: d }) => {
  const { extensions: u, splittableMarks: f } = o.extensionManager, h = Wt(t, s.schema), p = Wt(e, s.schema), { selection: y, storedMarks: b } = s, { $from: w, $to: S } = y, x = w.blockRange(S), E = b || y.$to.parentOffset && y.$from.marks();
  if (!x)
    return !1;
  const v = nh((T) => Ug(T.type.name, u))(y);
  if (x.depth >= 1 && v && x.depth - v.depth <= 1) {
    if (v.node.type === h)
      return c.liftListItem(p);
    if (Ug(v.node.type.name, u) && h.validContent(v.node.content) && l)
      return a().command(() => (i.setNodeMarkup(v.pos, h), !0)).command(() => wd(i, h)).command(() => Sd(i, h)).run();
  }
  return !n || !E || !l ? a().command(() => d().wrapInList(h, r) ? !0 : c.clearNodes()).wrapInList(h, r).command(() => wd(i, h)).command(() => Sd(i, h)).run() : a().command(() => {
    const T = d().wrapInList(h, r), I = E.filter((M) => f.includes(M.type.name));
    return i.ensureMarks(I), T ? !0 : c.clearNodes();
  }).wrapInList(h, r).command(() => wd(i, h)).command(() => Sd(i, h)).run();
}, $4 = (t, e = {}, n = {}) => ({ state: r, commands: o }) => {
  const { extendEmptyMarkRange: i = !1 } = n, s = xo(t, r.schema);
  return Ru(r, s, e) ? o.unsetMark(s, { extendEmptyMarkRange: i }) : o.setMark(s, e);
}, P4 = (t, e, n = {}) => ({ state: r, commands: o }) => {
  const i = Wt(t, r.schema), s = Wt(e, r.schema), l = Gs(r, i, n);
  let a;
  return r.selection.$anchor.sameParent(r.selection.$head) && (a = r.selection.$anchor.parent.attrs), l ? o.setNode(s, a) : o.setNode(i, { ...a, ...n });
}, _4 = (t, e = {}) => ({ state: n, commands: r }) => {
  const o = Wt(t, n.schema);
  return Gs(n, o, e) ? r.lift(o) : r.wrapIn(o, e);
}, B4 = () => ({ state: t, dispatch: e }) => {
  const n = t.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const o = n[r];
    let i;
    if (o.spec.isInputRules && (i = o.getState(t))) {
      if (e) {
        const s = t.tr, l = i.transform;
        for (let a = l.steps.length - 1; a >= 0; a -= 1)
          s.step(l.steps[a].invert(l.docs[a]));
        if (i.text) {
          const a = s.doc.resolve(i.from).marks();
          s.replaceWith(i.from, i.to, t.schema.text(i.text, a));
        } else
          s.delete(i.from, i.to);
      }
      return !0;
    }
  }
  return !1;
}, V4 = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, { empty: r, ranges: o } = n;
  return r || e && o.forEach((i) => {
    t.removeMark(i.$from.pos, i.$to.pos);
  }), !0;
}, F4 = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  var i;
  const { extendEmptyMarkRange: s = !1 } = e, { selection: l } = n, a = xo(t, r.schema), { $from: c, empty: d, ranges: u } = l;
  if (!o)
    return !0;
  if (d && s) {
    let { from: f, to: h } = l;
    const p = (i = c.marks().find((b) => b.type === a)) === null || i === void 0 ? void 0 : i.attrs, y = eh(c, a, p);
    y && (f = y.from, h = y.to), n.removeMark(f, h, a);
  } else
    u.forEach((f) => {
      n.removeMark(f.$from.pos, f.$to.pos, a);
    });
  return n.removeStoredMark(a), !0;
}, N4 = (t, e = {}) => ({ tr: n, state: r, dispatch: o }) => {
  let i = null, s = null;
  const l = Ac(typeof t == "string" ? t : t.name, r.schema);
  return l ? (l === "node" && (i = Wt(t, r.schema)), l === "mark" && (s = xo(t, r.schema)), o && n.selection.ranges.forEach((a) => {
    const c = a.$from.pos, d = a.$to.pos;
    let u, f, h, p;
    n.selection.empty ? r.doc.nodesBetween(c, d, (y, b) => {
      i && i === y.type && (h = Math.max(b, c), p = Math.min(b + y.nodeSize, d), u = b, f = y);
    }) : r.doc.nodesBetween(c, d, (y, b) => {
      b < c && i && i === y.type && (h = Math.max(b, c), p = Math.min(b + y.nodeSize, d), u = b, f = y), b >= c && b <= d && (i && i === y.type && n.setNodeMarkup(b, void 0, {
        ...y.attrs,
        ...e
      }), s && y.marks.length && y.marks.forEach((w) => {
        if (s === w.type) {
          const S = Math.max(b, c), x = Math.min(b + y.nodeSize, d);
          n.addMark(S, x, s.create({
            ...w.attrs,
            ...e
          }));
        }
      }));
    }), f && (u !== void 0 && n.setNodeMarkup(u, void 0, {
      ...f.attrs,
      ...e
    }), s && f.marks.length && f.marks.forEach((y) => {
      s === y.type && n.addMark(h, p, s.create({
        ...y.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, z4 = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = Wt(t, n.schema);
  return t_(o, e)(n, r);
}, H4 = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const o = Wt(t, n.schema);
  return n_(o, e)(n, r);
};
var j4 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: k_,
  clearContent: T_,
  clearNodes: I_,
  command: M_,
  createParagraphNear: R_,
  cut: O_,
  deleteCurrentNode: D_,
  deleteNode: A_,
  deleteRange: L_,
  deleteSelection: $_,
  enter: P_,
  exitCode: __,
  extendMarkRange: B_,
  first: V_,
  focus: F_,
  forEach: N_,
  insertContent: z_,
  insertContentAt: W_,
  joinBackward: q_,
  joinDown: U_,
  joinForward: J_,
  joinItemBackward: K_,
  joinItemForward: Y_,
  joinTextblockBackward: Z_,
  joinTextblockForward: X_,
  joinUp: G_,
  keyboardShortcut: e4,
  lift: t4,
  liftEmptyBlock: n4,
  liftListItem: r4,
  newlineInCode: o4,
  resetAttributes: i4,
  scrollIntoView: s4,
  selectAll: l4,
  selectNodeBackward: a4,
  selectNodeForward: c4,
  selectParentNode: d4,
  selectTextblockEnd: u4,
  selectTextblockStart: f4,
  setContent: h4,
  setMark: k4,
  setMeta: T4,
  setNode: I4,
  setNodeSelection: M4,
  setTextSelection: R4,
  sinkListItem: O4,
  splitBlock: D4,
  splitListItem: A4,
  toggleList: L4,
  toggleMark: $4,
  toggleNode: P4,
  toggleWrap: _4,
  undoInputRule: B4,
  unsetAllMarks: V4,
  unsetMark: F4,
  updateAttributes: N4,
  wrapIn: z4,
  wrapInList: H4
});
const W4 = en.create({
  name: "commands",
  addCommands() {
    return {
      ...j4
    };
  }
}), G4 = en.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Ft({
        key: new tn("tiptapDrop"),
        props: {
          handleDrop: (t, e, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
}), U4 = en.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Ft({
        key: new tn("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), q4 = en.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new Ft({
        key: new tn("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (e, n) => {
              t.isFocused = !0;
              const r = t.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, n) => {
              t.isFocused = !1;
              const r = t.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), J4 = en.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: l }) => {
        const { selection: a, doc: c } = l, { empty: d, $anchor: u } = a, { pos: f, parent: h } = u, p = u.parent.isTextblock && f > 0 ? l.doc.resolve(f - 1) : u, y = p.parent.type.spec.isolating, b = u.pos - u.parentOffset, w = y && p.parent.childCount === 1 ? b === u.pos : fe.atStart(c).from === f;
        return !d || !h.type.isTextblock || h.textContent.length || !w || w && u.parent.type.name === "paragraph" ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, o = {
      ...r
    }, i = {
      ...r,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return th() || Mw() ? i : o;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Ft({
        key: new tn("clearDocument"),
        appendTransaction: (t, e, n) => {
          const r = t.some((y) => y.docChanged) && !e.doc.eq(n.doc), o = t.some((y) => y.getMeta("preventClearDocument"));
          if (!r || o)
            return;
          const { empty: i, from: s, to: l } = e.selection, a = fe.atStart(e.doc).from, c = fe.atEnd(e.doc).to;
          if (i || !(s === a && l === c) || !Lc(n.doc))
            return;
          const f = n.tr, h = Ic({
            state: n,
            transaction: f
          }), { commands: p } = new Mc({
            editor: this.editor,
            state: h
          });
          if (p.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
}), K4 = en.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Ft({
        key: new tn("tiptapPaste"),
        props: {
          handlePaste: (t, e, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: n
            });
          }
        }
      })
    ];
  }
}), Y4 = en.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Ft({
        key: new tn("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class Mo {
  get name() {
    return this.node.type.name;
  }
  constructor(e, n, r = !1, o = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = n, this.currentNode = o;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let n = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(e);
    return new Mo(n, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new Mo(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new Mo(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((n, r) => {
      const o = n.isBlock && !n.isTextblock, i = n.isAtom && !n.isText, s = this.pos + r + (i ? 0 : 1), l = this.resolvedPos.doc.resolve(s);
      if (!o && l.depth <= this.depth)
        return;
      const a = new Mo(l, this.editor, o, o ? n : null);
      o && (a.actualDepth = this.depth + 1), e.push(new Mo(l, this.editor, o, o ? n : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, n = {}) {
    let r = null, o = this.parent;
    for (; o && !r; ) {
      if (o.node.type.name === e)
        if (Object.keys(n).length > 0) {
          const i = o.node.attrs, s = Object.keys(n);
          for (let l = 0; l < s.length; l += 1) {
            const a = s[l];
            if (i[a] !== n[a])
              break;
          }
        } else
          r = o;
      o = o.parent;
    }
    return r;
  }
  querySelector(e, n = {}) {
    return this.querySelectorAll(e, n, !0)[0] || null;
  }
  querySelectorAll(e, n = {}, r = !1) {
    let o = [];
    if (!this.children || this.children.length === 0)
      return o;
    const i = Object.keys(n);
    return this.children.forEach((s) => {
      r && o.length > 0 || (s.node.type.name === e && i.every((a) => n[a] === s.node.attrs[a]) && o.push(s), !(r && o.length > 0) && (o = o.concat(s.querySelectorAll(e, n, r))));
    }), o;
  }
  setAttribute(e) {
    const { tr: n } = this.editor.state;
    n.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(n);
  }
}
const Z4 = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function X4(t, e, n) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const o = document.createElement("style");
  return e && o.setAttribute("nonce", e), o.setAttribute("data-tiptap-style", ""), o.innerHTML = t, document.getElementsByTagName("head")[0].appendChild(o), o;
}
class Q4 extends c_ {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: n }) => {
        throw n;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: n, slice: r, moved: o }) => this.options.onDrop(n, r, o)), this.on("paste", ({ event: n, slice: r }) => this.options.onPaste(n, r)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = X4(Z4, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, n = !0) {
    this.setOptions({ editable: e }), n && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, n) {
    const r = Cw(n) ? n(e, [...this.state.plugins]) : [...this.state.plugins, e], o = this.state.reconfigure({ plugins: r });
    return this.view.updateState(o), o;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const n = this.state.plugins;
    let r = n;
    if ([].concat(e).forEach((i) => {
      const s = typeof i == "string" ? `${i}$` : i.key;
      r = n.filter((l) => !l.key.startsWith(s));
    }), n.length === r.length)
      return;
    const o = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(o), o;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, n;
    const o = [...this.options.enableCoreExtensions ? [
      U4,
      E_.configure({
        blockSeparator: (n = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || n === void 0 ? void 0 : n.blockSeparator
      }),
      W4,
      q4,
      J4,
      Y4,
      G4,
      K4
    ].filter((i) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[i.name] !== !1 : !0) : [], ...this.options.extensions].filter((i) => ["extension", "node", "mark"].includes(i == null ? void 0 : i.type));
    this.extensionManager = new gi(o, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Mc({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let n;
    try {
      n = Mu(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (s) {
      if (!(s instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(s.message))
        throw s;
      this.emit("contentError", {
        editor: this,
        error: s,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((l) => l.name !== "collaboration"), this.createExtensionManager();
        }
      }), n = Mu(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const r = Tw(n, this.options.autofocus);
    this.view = new LP(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: pi.create({
        doc: n,
        selection: r || void 0
      })
    });
    const o = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(o), this.createNodeViews(), this.prependClass();
    const i = this.view.dom;
    i.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((s) => {
        var l;
        return (l = this.capturedTransaction) === null || l === void 0 ? void 0 : l.step(s);
      });
      return;
    }
    const n = this.state.apply(e), r = !this.state.selection.eq(n.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: n
    }), this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: e
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const o = e.getMeta("focus"), i = e.getMeta("blur");
    o && this.emit("focus", {
      editor: this,
      event: o.event,
      transaction: e
    }), i && this.emit("blur", {
      editor: this,
      event: i.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return Dw(this.state, e);
  }
  isActive(e, n) {
    const r = typeof e == "string" ? e : null, o = typeof e == "string" ? n : e;
    return v4(this.state, r, o);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return Xf(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: n = `

`, textSerializers: r = {} } = e || {};
    return y4(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...xw(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Lc(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(e, n)) || null;
  }
  $nodes(e, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(e, n)) || null;
  }
  $pos(e) {
    const n = this.state.doc.resolve(e);
    return new Mo(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function Go(t) {
  return new Oc({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const o = Re(t.getAttributes, void 0, r);
      if (o === !1 || o === null)
        return null;
      const { tr: i } = e, s = r[r.length - 1], l = r[0];
      if (s) {
        const a = l.search(/\S/), c = n.from + l.indexOf(s), d = c + s.length;
        if (rh(n.from, n.to, e.doc).filter((h) => h.mark.type.excluded.find((y) => y === t.type && y !== h.mark.type)).filter((h) => h.to > c).length)
          return null;
        d < n.to && i.delete(d, n.to), c > n.from && i.delete(n.from + a, c);
        const f = n.from + a + s.length;
        i.addMark(n.from + a, f, t.type.create(o || {})), i.removeStoredMark(t.type);
      }
    }
  });
}
function e3(t) {
  return new Oc({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const o = Re(t.getAttributes, void 0, r) || {}, { tr: i } = e, s = n.from;
      let l = n.to;
      const a = t.type.create(o);
      if (r[1]) {
        const c = r[0].lastIndexOf(r[1]);
        let d = s + c;
        d > l ? d = l : l = d + r[1].length;
        const u = r[0][r[0].length - 1];
        i.insertText(u, s + r[0].length - 1), i.replaceWith(d, l, a);
      } else if (r[0]) {
        const c = t.type.isInline ? s : s - 1;
        i.insert(c, t.type.create(o)).delete(i.mapping.map(s), i.mapping.map(l));
      }
      i.scrollIntoView();
    }
  });
}
function Ou(t) {
  return new Oc({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const o = e.doc.resolve(n.from), i = Re(t.getAttributes, void 0, r) || {};
      if (!o.node(-1).canReplaceWith(o.index(-1), o.indexAfter(-1), t.type))
        return null;
      e.tr.delete(n.from, n.to).setBlockType(n.from, n.from, t.type, i);
    }
  });
}
function Us(t) {
  return new Oc({
    find: t.find,
    handler: ({ state: e, range: n, match: r, chain: o }) => {
      const i = Re(t.getAttributes, void 0, r) || {}, s = e.tr.delete(n.from, n.to), a = s.doc.resolve(n.from).blockRange(), c = a && Pf(a, t.type, i);
      if (!c)
        return null;
      if (s.wrap(a, c), t.keepMarks && t.editor) {
        const { selection: u, storedMarks: f } = e, { splittableMarks: h } = t.editor.extensionManager, p = f || u.$to.parentOffset && u.$from.marks();
        if (p) {
          const y = p.filter((b) => h.includes(b.type.name));
          s.ensureMarks(y);
        }
      }
      if (t.keepAttributes) {
        const u = t.type.name === "bulletList" || t.type.name === "orderedList" ? "listItem" : "taskList";
        o().updateAttributes(u, i).run();
      }
      const d = s.doc.resolve(n.from - 1).nodeBefore;
      d && d.type === t.type && Co(s.doc, n.from - 1) && (!t.joinPredicate || t.joinPredicate(r, d)) && s.join(n.from - 1);
    }
  });
}
class Gt {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Re(K(this, "addOptions", {
      name: this.name
    }))), this.storage = Re(K(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Gt(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Dc(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new Gt(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Re(K(n, "addOptions", {
      name: n.name
    })), n.storage = Re(K(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function wo(t) {
  return new b_({
    find: t.find,
    handler: ({ state: e, range: n, match: r, pasteEvent: o }) => {
      const i = Re(t.getAttributes, void 0, r, o);
      if (i === !1 || i === null)
        return null;
      const { tr: s } = e, l = r[r.length - 1], a = r[0];
      let c = n.to;
      if (l) {
        const d = a.search(/\S/), u = n.from + a.indexOf(l), f = u + l.length;
        if (rh(n.from, n.to, e.doc).filter((p) => p.mark.type.excluded.find((b) => b === t.type && b !== p.mark.type)).filter((p) => p.to > u).length)
          return null;
        f < n.to && s.delete(f, n.to), u > n.from && s.delete(n.from + d, u), c = n.from + d + l.length, s.addMark(n.from + d, c, t.type.create(i || {})), s.removeStoredMark(t.type);
      }
    }
  });
}
const t3 = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", n3 = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", $i = (t, e) => {
  for (const n in e)
    t[n] = e[n];
  return t;
}, Du = "numeric", Au = "ascii", Lu = "alpha", Es = "asciinumeric", gs = "alphanumeric", $u = "domain", Aw = "emoji", r3 = "scheme", o3 = "slashscheme", Cd = "whitespace";
function i3(t, e) {
  return t in e || (e[t] = []), e[t];
}
function Ao(t, e, n) {
  e[Du] && (e[Es] = !0, e[gs] = !0), e[Au] && (e[Es] = !0, e[Lu] = !0), e[Es] && (e[gs] = !0), e[Lu] && (e[gs] = !0), e[gs] && (e[$u] = !0), e[Aw] && (e[$u] = !0);
  for (const r in e) {
    const o = i3(r, n);
    o.indexOf(t) < 0 && o.push(t);
  }
}
function s3(t, e) {
  const n = {};
  for (const r in e)
    e[r].indexOf(t) >= 0 && (n[r] = !0);
  return n;
}
function Sn(t = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = t;
}
Sn.groups = {};
Sn.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(t) {
    const e = this, n = e.j[t];
    if (n)
      return n;
    for (let r = 0; r < e.jr.length; r++) {
      const o = e.jr[r][0], i = e.jr[r][1];
      if (i && o.test(t))
        return i;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(t, e = !1) {
    return e ? t in this.j : !!this.go(t);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(t, e, n, r) {
    for (let o = 0; o < t.length; o++)
      this.tt(t[o], e, n, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(t, e, n, r) {
    r = r || Sn.groups;
    let o;
    return e && e.j ? o = e : (o = new Sn(e), n && r && Ao(e, n, r)), this.jr.push([t, o]), o;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(t, e, n, r) {
    let o = this;
    const i = t.length;
    if (!i)
      return o;
    for (let s = 0; s < i - 1; s++)
      o = o.tt(t[s]);
    return o.tt(t[i - 1], e, n, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(t, e, n, r) {
    r = r || Sn.groups;
    const o = this;
    if (e && e.j)
      return o.j[t] = e, e;
    const i = e;
    let s, l = o.go(t);
    if (l ? (s = new Sn(), $i(s.j, l.j), s.jr.push.apply(s.jr, l.jr), s.jd = l.jd, s.t = l.t) : s = new Sn(), i) {
      if (r)
        if (s.t && typeof s.t == "string") {
          const a = $i(s3(s.t, r), n);
          Ao(i, a, r);
        } else n && Ao(i, n, r);
      s.t = i;
    }
    return o.j[t] = s, s;
  }
};
const Me = (t, e, n, r, o) => t.ta(e, n, r, o), vt = (t, e, n, r, o) => t.tr(e, n, r, o), Jg = (t, e, n, r, o) => t.ts(e, n, r, o), B = (t, e, n, r, o) => t.tt(e, n, r, o), Mr = "WORD", Pu = "UWORD", Lw = "ASCIINUMERICAL", $w = "ALPHANUMERICAL", qs = "LOCALHOST", _u = "TLD", Bu = "UTLD", Ql = "SCHEME", fi = "SLASH_SCHEME", oh = "NUM", Vu = "WS", ih = "NL", ks = "OPENBRACE", Ts = "CLOSEBRACE", La = "OPENBRACKET", $a = "CLOSEBRACKET", Pa = "OPENPAREN", _a = "CLOSEPAREN", Ba = "OPENANGLEBRACKET", Va = "CLOSEANGLEBRACKET", Fa = "FULLWIDTHLEFTPAREN", Na = "FULLWIDTHRIGHTPAREN", za = "LEFTCORNERBRACKET", Ha = "RIGHTCORNERBRACKET", ja = "LEFTWHITECORNERBRACKET", Wa = "RIGHTWHITECORNERBRACKET", Ga = "FULLWIDTHLESSTHAN", Ua = "FULLWIDTHGREATERTHAN", qa = "AMPERSAND", sh = "APOSTROPHE", Ja = "ASTERISK", Zr = "AT", Ka = "BACKSLASH", Ya = "BACKTICK", Za = "CARET", no = "COLON", lh = "COMMA", Xa = "DOLLAR", dr = "DOT", Qa = "EQUALS", ah = "EXCLAMATION", _n = "HYPHEN", Is = "PERCENT", ec = "PIPE", tc = "PLUS", nc = "POUND", Ms = "QUERY", ch = "QUOTE", Pw = "FULLWIDTHMIDDLEDOT", dh = "SEMI", ur = "SLASH", Rs = "TILDE", rc = "UNDERSCORE", _w = "EMOJI", oc = "SYM";
var Bw = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: Mr,
  UWORD: Pu,
  ASCIINUMERICAL: Lw,
  ALPHANUMERICAL: $w,
  LOCALHOST: qs,
  TLD: _u,
  UTLD: Bu,
  SCHEME: Ql,
  SLASH_SCHEME: fi,
  NUM: oh,
  WS: Vu,
  NL: ih,
  OPENBRACE: ks,
  CLOSEBRACE: Ts,
  OPENBRACKET: La,
  CLOSEBRACKET: $a,
  OPENPAREN: Pa,
  CLOSEPAREN: _a,
  OPENANGLEBRACKET: Ba,
  CLOSEANGLEBRACKET: Va,
  FULLWIDTHLEFTPAREN: Fa,
  FULLWIDTHRIGHTPAREN: Na,
  LEFTCORNERBRACKET: za,
  RIGHTCORNERBRACKET: Ha,
  LEFTWHITECORNERBRACKET: ja,
  RIGHTWHITECORNERBRACKET: Wa,
  FULLWIDTHLESSTHAN: Ga,
  FULLWIDTHGREATERTHAN: Ua,
  AMPERSAND: qa,
  APOSTROPHE: sh,
  ASTERISK: Ja,
  AT: Zr,
  BACKSLASH: Ka,
  BACKTICK: Ya,
  CARET: Za,
  COLON: no,
  COMMA: lh,
  DOLLAR: Xa,
  DOT: dr,
  EQUALS: Qa,
  EXCLAMATION: ah,
  HYPHEN: _n,
  PERCENT: Is,
  PIPE: ec,
  PLUS: tc,
  POUND: nc,
  QUERY: Ms,
  QUOTE: ch,
  FULLWIDTHMIDDLEDOT: Pw,
  SEMI: dh,
  SLASH: ur,
  TILDE: Rs,
  UNDERSCORE: rc,
  EMOJI: _w,
  SYM: oc
});
const kr = /[a-z]/, ns = new RegExp("\\p{L}", "u"), vd = new RegExp("\\p{Emoji}", "u"), Tr = /\d/, xd = /\s/, Kg = "\r", Ed = `
`, l3 = "️", a3 = "‍", kd = "￼";
let Il = null, Ml = null;
function c3(t = []) {
  const e = {};
  Sn.groups = e;
  const n = new Sn();
  Il == null && (Il = Yg(t3)), Ml == null && (Ml = Yg(n3)), B(n, "'", sh), B(n, "{", ks), B(n, "}", Ts), B(n, "[", La), B(n, "]", $a), B(n, "(", Pa), B(n, ")", _a), B(n, "<", Ba), B(n, ">", Va), B(n, "（", Fa), B(n, "）", Na), B(n, "「", za), B(n, "」", Ha), B(n, "『", ja), B(n, "』", Wa), B(n, "＜", Ga), B(n, "＞", Ua), B(n, "&", qa), B(n, "*", Ja), B(n, "@", Zr), B(n, "`", Ya), B(n, "^", Za), B(n, ":", no), B(n, ",", lh), B(n, "$", Xa), B(n, ".", dr), B(n, "=", Qa), B(n, "!", ah), B(n, "-", _n), B(n, "%", Is), B(n, "|", ec), B(n, "+", tc), B(n, "#", nc), B(n, "?", Ms), B(n, '"', ch), B(n, "/", ur), B(n, ";", dh), B(n, "~", Rs), B(n, "_", rc), B(n, "\\", Ka), B(n, "・", Pw);
  const r = vt(n, Tr, oh, {
    [Du]: !0
  });
  vt(r, Tr, r);
  const o = vt(r, kr, Lw, {
    [Es]: !0
  }), i = vt(r, ns, $w, {
    [gs]: !0
  }), s = vt(n, kr, Mr, {
    [Au]: !0
  });
  vt(s, Tr, o), vt(s, kr, s), vt(o, Tr, o), vt(o, kr, o);
  const l = vt(n, ns, Pu, {
    [Lu]: !0
  });
  vt(l, kr), vt(l, Tr, i), vt(l, ns, l), vt(i, Tr, i), vt(i, kr), vt(i, ns, i);
  const a = B(n, Ed, ih, {
    [Cd]: !0
  }), c = B(n, Kg, Vu, {
    [Cd]: !0
  }), d = vt(n, xd, Vu, {
    [Cd]: !0
  });
  B(n, kd, d), B(c, Ed, a), B(c, kd, d), vt(c, xd, d), B(d, Kg), B(d, Ed), vt(d, xd, d), B(d, kd, d);
  const u = vt(n, vd, _w, {
    [Aw]: !0
  });
  B(u, "#"), vt(u, vd, u), B(u, l3, u);
  const f = B(u, a3);
  B(f, "#"), vt(f, vd, u);
  const h = [[kr, s], [Tr, o]], p = [[kr, null], [ns, l], [Tr, i]];
  for (let y = 0; y < Il.length; y++)
    qr(n, Il[y], _u, Mr, h);
  for (let y = 0; y < Ml.length; y++)
    qr(n, Ml[y], Bu, Pu, p);
  Ao(_u, {
    tld: !0,
    ascii: !0
  }, e), Ao(Bu, {
    utld: !0,
    alpha: !0
  }, e), qr(n, "file", Ql, Mr, h), qr(n, "mailto", Ql, Mr, h), qr(n, "http", fi, Mr, h), qr(n, "https", fi, Mr, h), qr(n, "ftp", fi, Mr, h), qr(n, "ftps", fi, Mr, h), Ao(Ql, {
    scheme: !0,
    ascii: !0
  }, e), Ao(fi, {
    slashscheme: !0,
    ascii: !0
  }, e), t = t.sort((y, b) => y[0] > b[0] ? 1 : -1);
  for (let y = 0; y < t.length; y++) {
    const b = t[y][0], S = t[y][1] ? {
      [r3]: !0
    } : {
      [o3]: !0
    };
    b.indexOf("-") >= 0 ? S[$u] = !0 : kr.test(b) ? Tr.test(b) ? S[Es] = !0 : S[Au] = !0 : S[Du] = !0, Jg(n, b, b, S);
  }
  return Jg(n, "localhost", qs, {
    ascii: !0
  }), n.jd = new Sn(oc), {
    start: n,
    tokens: $i({
      groups: e
    }, Bw)
  };
}
function Vw(t, e) {
  const n = d3(e.replace(/[A-Z]/g, (l) => l.toLowerCase())), r = n.length, o = [];
  let i = 0, s = 0;
  for (; s < r; ) {
    let l = t, a = null, c = 0, d = null, u = -1, f = -1;
    for (; s < r && (a = l.go(n[s])); )
      l = a, l.accepts() ? (u = 0, f = 0, d = l) : u >= 0 && (u += n[s].length, f++), c += n[s].length, i += n[s].length, s++;
    i -= u, s -= f, c -= u, o.push({
      t: d.t,
      // token type/name
      v: e.slice(i - c, i),
      // string value
      s: i - c,
      // start index
      e: i
      // end index (excluding)
    });
  }
  return o;
}
function d3(t) {
  const e = [], n = t.length;
  let r = 0;
  for (; r < n; ) {
    let o = t.charCodeAt(r), i, s = o < 55296 || o > 56319 || r + 1 === n || (i = t.charCodeAt(r + 1)) < 56320 || i > 57343 ? t[r] : t.slice(r, r + 2);
    e.push(s), r += s.length;
  }
  return e;
}
function qr(t, e, n, r, o) {
  let i;
  const s = e.length;
  for (let l = 0; l < s - 1; l++) {
    const a = e[l];
    t.j[a] ? i = t.j[a] : (i = new Sn(r), i.jr = o.slice(), t.j[a] = i), t = i;
  }
  return i = new Sn(n), i.jr = o.slice(), t.j[e[s - 1]] = i, i;
}
function Yg(t) {
  const e = [], n = [];
  let r = 0, o = "0123456789";
  for (; r < t.length; ) {
    let i = 0;
    for (; o.indexOf(t[r + i]) >= 0; )
      i++;
    if (i > 0) {
      e.push(n.join(""));
      for (let s = parseInt(t.substring(r, r + i), 10); s > 0; s--)
        n.pop();
      r += i;
    } else
      n.push(t[r]), r++;
  }
  return e;
}
const Js = {
  defaultProtocol: "http",
  events: null,
  format: Zg,
  formatHref: Zg,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function uh(t, e = null) {
  let n = $i({}, Js);
  t && (n = $i(n, t instanceof uh ? t.o : t));
  const r = n.ignoreTags, o = [];
  for (let i = 0; i < r.length; i++)
    o.push(r[i].toUpperCase());
  this.o = n, e && (this.defaultRender = e), this.ignoreTags = o;
}
uh.prototype = {
  o: Js,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(t) {
    return t;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(t) {
    return this.get("validate", t.toString(), t);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(t, e, n) {
    const r = e != null;
    let o = this.o[t];
    return o && (typeof o == "object" ? (o = n.t in o ? o[n.t] : Js[t], typeof o == "function" && r && (o = o(e, n))) : typeof o == "function" && r && (o = o(e, n.t, n)), o);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(t, e, n) {
    let r = this.o[t];
    return typeof r == "function" && e != null && (r = r(e, n.t, n)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(t) {
    const e = t.render(this);
    return (this.get("render", null, t) || this.defaultRender)(e, t.t, t);
  }
};
function Zg(t) {
  return t;
}
function Fw(t, e) {
  this.t = "token", this.v = t, this.tk = e;
}
Fw.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(t) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(t) {
    const e = this.toString(), n = t.get("truncate", e, this), r = t.get("format", e, this);
    return n && r.length > n ? r.substring(0, n) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(t) {
    return t.get("formatHref", this.toHref(t.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(t = Js.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(t) {
    return {
      type: this.t,
      value: this.toFormattedString(t),
      isLink: this.isLink,
      href: this.toFormattedHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(t) {
    return t.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(t) {
    const e = this, n = this.toHref(t.get("defaultProtocol")), r = t.get("formatHref", n, this), o = t.get("tagName", n, e), i = this.toFormattedString(t), s = {}, l = t.get("className", n, e), a = t.get("target", n, e), c = t.get("rel", n, e), d = t.getObj("attributes", n, e), u = t.getObj("events", n, e);
    return s.href = r, l && (s.class = l), a && (s.target = a), c && (s.rel = c), d && $i(s, d), {
      tagName: o,
      attributes: s,
      content: i,
      eventListeners: u
    };
  }
};
function $c(t, e) {
  class n extends Fw {
    constructor(o, i) {
      super(o, i), this.t = t;
    }
  }
  for (const r in e)
    n.prototype[r] = e[r];
  return n.t = t, n;
}
const Xg = $c("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Qg = $c("text"), u3 = $c("nl"), Rl = $c("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(t = Js.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${t}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const t = this.tk;
    return t.length >= 2 && t[0].t !== qs && t[1].t === no;
  }
}), Pn = (t) => new Sn(t);
function f3({
  groups: t
}) {
  const e = t.domain.concat([qa, Ja, Zr, Ka, Ya, Za, Xa, Qa, _n, oh, Is, ec, tc, nc, ur, oc, Rs, rc]), n = [no, lh, dr, ah, Is, Ms, ch, dh, Ba, Va, ks, Ts, $a, La, Pa, _a, Fa, Na, za, Ha, ja, Wa, Ga, Ua], r = [qa, sh, Ja, Ka, Ya, Za, Xa, Qa, _n, ks, Ts, Is, ec, tc, nc, Ms, ur, oc, Rs, rc], o = Pn(), i = B(o, Rs);
  Me(i, r, i), Me(i, t.domain, i);
  const s = Pn(), l = Pn(), a = Pn();
  Me(o, t.domain, s), Me(o, t.scheme, l), Me(o, t.slashscheme, a), Me(s, r, i), Me(s, t.domain, s);
  const c = B(s, Zr);
  B(i, Zr, c), B(l, Zr, c), B(a, Zr, c);
  const d = B(i, dr);
  Me(d, r, i), Me(d, t.domain, i);
  const u = Pn();
  Me(c, t.domain, u), Me(u, t.domain, u);
  const f = B(u, dr);
  Me(f, t.domain, u);
  const h = Pn(Xg);
  Me(f, t.tld, h), Me(f, t.utld, h), B(c, qs, h);
  const p = B(u, _n);
  B(p, _n, p), Me(p, t.domain, u), Me(h, t.domain, u), B(h, dr, f), B(h, _n, p);
  const y = B(h, no);
  Me(y, t.numeric, Xg);
  const b = B(s, _n), w = B(s, dr);
  B(b, _n, b), Me(b, t.domain, s), Me(w, r, i), Me(w, t.domain, s);
  const S = Pn(Rl);
  Me(w, t.tld, S), Me(w, t.utld, S), Me(S, t.domain, s), Me(S, r, i), B(S, dr, w), B(S, _n, b), B(S, Zr, c);
  const x = B(S, no), E = Pn(Rl);
  Me(x, t.numeric, E);
  const v = Pn(Rl), T = Pn();
  Me(v, e, v), Me(v, n, T), Me(T, e, v), Me(T, n, T), B(S, ur, v), B(E, ur, v);
  const I = B(l, no), M = B(a, no), R = B(M, ur), A = B(R, ur);
  Me(l, t.domain, s), B(l, dr, w), B(l, _n, b), Me(a, t.domain, s), B(a, dr, w), B(a, _n, b), Me(I, t.domain, v), B(I, ur, v), B(I, Ms, v), Me(A, t.domain, v), Me(A, e, v), B(A, ur, v);
  const F = [
    [ks, Ts],
    // {}
    [La, $a],
    // []
    [Pa, _a],
    // ()
    [Ba, Va],
    // <>
    [Fa, Na],
    // （）
    [za, Ha],
    // 「」
    [ja, Wa],
    // 『』
    [Ga, Ua]
    // ＜＞
  ];
  for (let V = 0; V < F.length; V++) {
    const [P, J] = F[V], ne = B(v, P);
    B(T, P, ne), B(ne, J, v);
    const G = Pn(Rl);
    Me(ne, e, G);
    const H = Pn();
    Me(ne, n), Me(G, e, G), Me(G, n, H), Me(H, e, G), Me(H, n, H), B(G, J, v), B(H, J, v);
  }
  return B(o, qs, S), B(o, ih, u3), {
    start: o,
    tokens: Bw
  };
}
function h3(t, e, n) {
  let r = n.length, o = 0, i = [], s = [];
  for (; o < r; ) {
    let l = t, a = null, c = null, d = 0, u = null, f = -1;
    for (; o < r && !(a = l.go(n[o].t)); )
      s.push(n[o++]);
    for (; o < r && (c = a || l.go(n[o].t)); )
      a = null, l = c, l.accepts() ? (f = 0, u = l) : f >= 0 && f++, o++, d++;
    if (f < 0)
      o -= d, o < r && (s.push(n[o]), o++);
    else {
      s.length > 0 && (i.push(Td(Qg, e, s)), s = []), o -= f, d -= f;
      const h = u.t, p = n.slice(o - d, o);
      i.push(Td(h, e, p));
    }
  }
  return s.length > 0 && i.push(Td(Qg, e, s)), i;
}
function Td(t, e, n) {
  const r = n[0].s, o = n[n.length - 1].e, i = e.slice(r, o);
  return new t(i, n);
}
const p3 = typeof console < "u" && console && console.warn || (() => {
}), g3 = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", ut = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function m3() {
  return Sn.groups = {}, ut.scanner = null, ut.parser = null, ut.tokenQueue = [], ut.pluginQueue = [], ut.customSchemes = [], ut.initialized = !1, ut;
}
function em(t, e = !1) {
  if (ut.initialized && p3(`linkifyjs: already initialized - will not register custom scheme "${t}" ${g3}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(t))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  ut.customSchemes.push([t, e]);
}
function y3() {
  ut.scanner = c3(ut.customSchemes);
  for (let t = 0; t < ut.tokenQueue.length; t++)
    ut.tokenQueue[t][1]({
      scanner: ut.scanner
    });
  ut.parser = f3(ut.scanner.tokens);
  for (let t = 0; t < ut.pluginQueue.length; t++)
    ut.pluginQueue[t][1]({
      scanner: ut.scanner,
      parser: ut.parser
    });
  return ut.initialized = !0, ut;
}
function fh(t) {
  return ut.initialized || y3(), h3(ut.parser.start, t, Vw(ut.scanner.start, t));
}
fh.scan = Vw;
function Nw(t, e = null, n = null) {
  if (e && typeof e == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    n = e, e = null;
  }
  const r = new uh(n), o = fh(t), i = [];
  for (let s = 0; s < o.length; s++) {
    const l = o[s];
    l.isLink && (!e || l.t === e) && r.check(l) && i.push(l.toFormattedObject(r));
  }
  return i;
}
function b3(t) {
  return t.length === 1 ? t[0].isLink : t.length === 3 && t[1].isLink ? ["()", "[]"].includes(t[0].value + t[2].value) : !1;
}
function w3(t) {
  return new Ft({
    key: new tn("autolink"),
    appendTransaction: (e, n, r) => {
      const o = e.some((c) => c.docChanged) && !n.doc.eq(r.doc), i = e.some((c) => c.getMeta("preventAutolink"));
      if (!o || i)
        return;
      const { tr: s } = r, l = p4(n.doc, [...e]);
      if (C4(l).forEach(({ newRange: c }) => {
        const d = m4(r.doc, c, (h) => h.isTextblock);
        let u, f;
        if (d.length > 1 ? (u = d[0], f = r.doc.textBetween(u.pos, u.pos + u.node.nodeSize, void 0, " ")) : d.length && r.doc.textBetween(c.from, c.to, " ", " ").endsWith(" ") && (u = d[0], f = r.doc.textBetween(u.pos, c.to, void 0, " ")), u && f) {
          const h = f.split(" ").filter((w) => w !== "");
          if (h.length <= 0)
            return !1;
          const p = h[h.length - 1], y = u.pos + f.lastIndexOf(p);
          if (!p)
            return !1;
          const b = fh(p).map((w) => w.toObject(t.defaultProtocol));
          if (!b3(b))
            return !1;
          b.filter((w) => w.isLink).map((w) => ({
            ...w,
            from: y + w.start + 1,
            to: y + w.end + 1
          })).filter((w) => r.schema.marks.code ? !r.doc.rangeHasMark(w.from, w.to, r.schema.marks.code) : !0).filter((w) => t.validate(w.value)).filter((w) => t.shouldAutoLink(w.value)).forEach((w) => {
            rh(w.from, w.to, r.doc).some((S) => S.mark.type === t.type) || s.addMark(w.from, w.to, t.type.create({
              href: w.href
            }));
          });
        }
      }), !!s.steps.length)
        return s;
    }
  });
}
function S3(t) {
  return new Ft({
    key: new tn("handleClickLink"),
    props: {
      handleClick: (e, n, r) => {
        var o, i;
        if (r.button !== 0 || !e.editable)
          return !1;
        let s = r.target;
        const l = [];
        for (; s.nodeName !== "DIV"; )
          l.push(s), s = s.parentNode;
        if (!l.find((f) => f.nodeName === "A"))
          return !1;
        const a = Dw(e.state, t.type.name), c = r.target, d = (o = c == null ? void 0 : c.href) !== null && o !== void 0 ? o : a.href, u = (i = c == null ? void 0 : c.target) !== null && i !== void 0 ? i : a.target;
        return c && d ? (window.open(d, u), !0) : !1;
      }
    }
  });
}
function C3(t) {
  return new Ft({
    key: new tn("handlePasteLink"),
    props: {
      handlePaste: (e, n, r) => {
        const { state: o } = e, { selection: i } = o, { empty: s } = i;
        if (s)
          return !1;
        let l = "";
        r.content.forEach((c) => {
          l += c.textContent;
        });
        const a = Nw(l, { defaultProtocol: t.defaultProtocol }).find((c) => c.isLink && c.value === l);
        return !l || !a ? !1 : (t.editor.commands.setMark(t.type, {
          href: a.href
        }), !0);
      }
    }
  });
}
const v3 = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g;
function rs(t, e) {
  const n = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  return e && e.forEach((r) => {
    const o = typeof r == "string" ? r : r.scheme;
    o && n.push(o);
  }), !t || t.replace(v3, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${n.join("|")}):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const x3 = ir.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((t) => {
      if (typeof t == "string") {
        em(t);
        return;
      }
      em(t.scheme, t.optionalSlashes);
    });
  },
  onDestroy() {
    m3();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (t, e) => !!rs(t, e.protocols),
      validate: (t) => !!t,
      shouldAutoLink: (t) => !!t
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(t) {
          return t.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (t) => {
          const e = t.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (n) => !!rs(n, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return this.options.isAllowedUri(t.href, {
      defaultValidate: (e) => !!rs(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", wt(this.options.HTMLAttributes, t), 0] : [
      "a",
      wt(this.options.HTMLAttributes, { ...t, href: "" }),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (t) => ({ chain: e }) => e().setMark(this.name, t).setMeta("preventAutolink", !0).run(),
      toggleLink: (t) => ({ chain: e }) => e().toggleMark(this.name, t, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run(),
      unsetLink: () => ({ chain: t }) => t().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      wo({
        find: (t) => {
          const e = [];
          if (t) {
            const { protocols: n, defaultProtocol: r } = this.options, o = Nw(t).filter((i) => i.isLink && this.options.isAllowedUri(i.value, {
              defaultValidate: (s) => !!rs(s, n),
              protocols: n,
              defaultProtocol: r
            }));
            o.length && o.forEach((i) => e.push({
              text: i.value,
              data: {
                href: i.href
              },
              index: i.start
            }));
          }
          return e;
        },
        type: this.type,
        getAttributes: (t) => {
          var e;
          return {
            href: (e = t.data) === null || e === void 0 ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const t = [], { protocols: e, defaultProtocol: n } = this.options;
    return this.options.autolink && t.push(w3({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: (r) => this.options.isAllowedUri(r, {
        defaultValidate: (o) => !!rs(o, e),
        protocols: e,
        defaultProtocol: n
      }),
      shouldAutoLink: this.options.shouldAutoLink
    })), this.options.openOnClick === !0 && t.push(S3({
      type: this.type
    })), this.options.linkOnPaste && t.push(C3({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), t;
  }
}), E3 = x3.extend({
  addKeyboardShortcuts: () => ({
    "Mod-k": () => (window.dispatchEvent(new Event("edit-link")), !0)
  })
}).configure({ openOnClick: !1 });
var ei = { root: "m_dd3f7539", typographyStylesProvider: "m_d37966d9", content: "m_c2204cc2", linkEditorDropdown: "m_8a991b4f", control: "m_c2207da6", controlIcon: "m_9cdfeb3f", controlsGroup: "m_2ab47ef2", linkEditor: "m_b67b711e", linkEditorInput: "m_296cf94c", linkEditorExternalControl: "m_cfef614", linkEditorSave: "m_3b28e7bb", toolbar: "m_4574a3c4", taskList: "m_8b44009a" }, Ol = { exports: {} }, is = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tm;
function k3() {
  if (tm) return is;
  tm = 1;
  var t = g, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, a, c) {
    var d, u = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), a.key !== void 0 && (f = "" + a.key), a.ref !== void 0 && (h = a.ref);
    for (d in a) r.call(a, d) && !i.hasOwnProperty(d) && (u[d] = a[d]);
    if (l && l.defaultProps) for (d in a = l.defaultProps, a) u[d] === void 0 && (u[d] = a[d]);
    return { $$typeof: e, type: l, key: f, ref: h, props: u, _owner: o.current };
  }
  return is.Fragment = n, is.jsx = s, is.jsxs = s, is;
}
var ss = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nm;
function T3() {
  return nm || (nm = 1, process.env.NODE_ENV !== "production" && function() {
    var t = g, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), a = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, y = "@@iterator";
    function b(k) {
      if (k === null || typeof k != "object")
        return null;
      var $ = p && k[p] || k[y];
      return typeof $ == "function" ? $ : null;
    }
    var w = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(k) {
      {
        for (var $ = arguments.length, j = new Array($ > 1 ? $ - 1 : 0), pe = 1; pe < $; pe++)
          j[pe - 1] = arguments[pe];
        x("error", k, j);
      }
    }
    function x(k, $, j) {
      {
        var pe = w.ReactDebugCurrentFrame, qe = pe.getStackAddendum();
        qe !== "" && ($ += "%s", j = j.concat([qe]));
        var rt = j.map(function(ze) {
          return String(ze);
        });
        rt.unshift("Warning: " + $), Function.prototype.apply.call(console[k], console, rt);
      }
    }
    var E = !1, v = !1, T = !1, I = !1, M = !1, R;
    R = Symbol.for("react.module.reference");
    function A(k) {
      return !!(typeof k == "string" || typeof k == "function" || k === r || k === i || M || k === o || k === c || k === d || I || k === h || E || v || T || typeof k == "object" && k !== null && (k.$$typeof === f || k.$$typeof === u || k.$$typeof === s || k.$$typeof === l || k.$$typeof === a || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      k.$$typeof === R || k.getModuleId !== void 0));
    }
    function F(k, $, j) {
      var pe = k.displayName;
      if (pe)
        return pe;
      var qe = $.displayName || $.name || "";
      return qe !== "" ? j + "(" + qe + ")" : j;
    }
    function V(k) {
      return k.displayName || "Context";
    }
    function P(k) {
      if (k == null)
        return null;
      if (typeof k.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof k == "function")
        return k.displayName || k.name || null;
      if (typeof k == "string")
        return k;
      switch (k) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof k == "object")
        switch (k.$$typeof) {
          case l:
            var $ = k;
            return V($) + ".Consumer";
          case s:
            var j = k;
            return V(j._context) + ".Provider";
          case a:
            return F(k, k.render, "ForwardRef");
          case u:
            var pe = k.displayName || null;
            return pe !== null ? pe : P(k.type) || "Memo";
          case f: {
            var qe = k, rt = qe._payload, ze = qe._init;
            try {
              return P(ze(rt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var J = Object.assign, ne = 0, G, H, W, se, U, re, ke;
    function Te() {
    }
    Te.__reactDisabledLog = !0;
    function Se() {
      {
        if (ne === 0) {
          G = console.log, H = console.info, W = console.warn, se = console.error, U = console.group, re = console.groupCollapsed, ke = console.groupEnd;
          var k = {
            configurable: !0,
            enumerable: !0,
            value: Te,
            writable: !0
          };
          Object.defineProperties(console, {
            info: k,
            log: k,
            warn: k,
            error: k,
            group: k,
            groupCollapsed: k,
            groupEnd: k
          });
        }
        ne++;
      }
    }
    function Le() {
      {
        if (ne--, ne === 0) {
          var k = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: J({}, k, {
              value: G
            }),
            info: J({}, k, {
              value: H
            }),
            warn: J({}, k, {
              value: W
            }),
            error: J({}, k, {
              value: se
            }),
            group: J({}, k, {
              value: U
            }),
            groupCollapsed: J({}, k, {
              value: re
            }),
            groupEnd: J({}, k, {
              value: ke
            })
          });
        }
        ne < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ce = w.ReactCurrentDispatcher, et;
    function Oe(k, $, j) {
      {
        if (et === void 0)
          try {
            throw Error();
          } catch (qe) {
            var pe = qe.stack.trim().match(/\n( *(at )?)/);
            et = pe && pe[1] || "";
          }
        return `
` + et + k;
      }
    }
    var $e = !1, Ie;
    {
      var ee = typeof WeakMap == "function" ? WeakMap : Map;
      Ie = new ee();
    }
    function de(k, $) {
      if (!k || $e)
        return "";
      {
        var j = Ie.get(k);
        if (j !== void 0)
          return j;
      }
      var pe;
      $e = !0;
      var qe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var rt;
      rt = Ce.current, Ce.current = null, Se();
      try {
        if ($) {
          var ze = function() {
            throw Error();
          };
          if (Object.defineProperty(ze.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ze, []);
            } catch (xr) {
              pe = xr;
            }
            Reflect.construct(k, [], ze);
          } else {
            try {
              ze.call();
            } catch (xr) {
              pe = xr;
            }
            k.call(ze.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (xr) {
            pe = xr;
          }
          k();
        }
      } catch (xr) {
        if (xr && pe && typeof xr.stack == "string") {
          for (var Ve = xr.stack.split(`
`), fn = pe.stack.split(`
`), Rt = Ve.length - 1, $t = fn.length - 1; Rt >= 1 && $t >= 0 && Ve[Rt] !== fn[$t]; )
            $t--;
          for (; Rt >= 1 && $t >= 0; Rt--, $t--)
            if (Ve[Rt] !== fn[$t]) {
              if (Rt !== 1 || $t !== 1)
                do
                  if (Rt--, $t--, $t < 0 || Ve[Rt] !== fn[$t]) {
                    var Ln = `
` + Ve[Rt].replace(" at new ", " at ");
                    return k.displayName && Ln.includes("<anonymous>") && (Ln = Ln.replace("<anonymous>", k.displayName)), typeof k == "function" && Ie.set(k, Ln), Ln;
                  }
                while (Rt >= 1 && $t >= 0);
              break;
            }
        }
      } finally {
        $e = !1, Ce.current = rt, Le(), Error.prepareStackTrace = qe;
      }
      var ti = k ? k.displayName || k.name : "", Th = ti ? Oe(ti) : "";
      return typeof k == "function" && Ie.set(k, Th), Th;
    }
    function ae(k, $, j) {
      return de(k, !1);
    }
    function Y(k) {
      var $ = k.prototype;
      return !!($ && $.isReactComponent);
    }
    function we(k, $, j) {
      if (k == null)
        return "";
      if (typeof k == "function")
        return de(k, Y(k));
      if (typeof k == "string")
        return Oe(k);
      switch (k) {
        case c:
          return Oe("Suspense");
        case d:
          return Oe("SuspenseList");
      }
      if (typeof k == "object")
        switch (k.$$typeof) {
          case a:
            return ae(k.render);
          case u:
            return we(k.type, $, j);
          case f: {
            var pe = k, qe = pe._payload, rt = pe._init;
            try {
              return we(rt(qe), $, j);
            } catch {
            }
          }
        }
      return "";
    }
    var Ze = Object.prototype.hasOwnProperty, Je = {}, ht = w.ReactDebugCurrentFrame;
    function Xe(k) {
      if (k) {
        var $ = k._owner, j = we(k.type, k._source, $ ? $.type : null);
        ht.setExtraStackFrame(j);
      } else
        ht.setExtraStackFrame(null);
    }
    function Lt(k, $, j, pe, qe) {
      {
        var rt = Function.call.bind(Ze);
        for (var ze in k)
          if (rt(k, ze)) {
            var Ve = void 0;
            try {
              if (typeof k[ze] != "function") {
                var fn = Error((pe || "React class") + ": " + j + " type `" + ze + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof k[ze] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw fn.name = "Invariant Violation", fn;
              }
              Ve = k[ze]($, ze, pe, j, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Rt) {
              Ve = Rt;
            }
            Ve && !(Ve instanceof Error) && (Xe(qe), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", pe || "React class", j, ze, typeof Ve), Xe(null)), Ve instanceof Error && !(Ve.message in Je) && (Je[Ve.message] = !0, Xe(qe), S("Failed %s type: %s", j, Ve.message), Xe(null));
          }
      }
    }
    var Be = Array.isArray;
    function tt(k) {
      return Be(k);
    }
    function St(k) {
      {
        var $ = typeof Symbol == "function" && Symbol.toStringTag, j = $ && k[Symbol.toStringTag] || k.constructor.name || "Object";
        return j;
      }
    }
    function Mt(k) {
      try {
        return nt(k), !1;
      } catch {
        return !0;
      }
    }
    function nt(k) {
      return "" + k;
    }
    function je(k) {
      if (Mt(k))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", St(k)), nt(k);
    }
    var Qe = w.ReactCurrentOwner, L = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, q, ve;
    function De(k) {
      if (Ze.call(k, "ref")) {
        var $ = Object.getOwnPropertyDescriptor(k, "ref").get;
        if ($ && $.isReactWarning)
          return !1;
      }
      return k.ref !== void 0;
    }
    function pt(k) {
      if (Ze.call(k, "key")) {
        var $ = Object.getOwnPropertyDescriptor(k, "key").get;
        if ($ && $.isReactWarning)
          return !1;
      }
      return k.key !== void 0;
    }
    function un(k, $) {
      typeof k.ref == "string" && Qe.current;
    }
    function bn(k, $) {
      {
        var j = function() {
          q || (q = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $));
        };
        j.isReactWarning = !0, Object.defineProperty(k, "key", {
          get: j,
          configurable: !0
        });
      }
    }
    function Ut(k, $) {
      {
        var j = function() {
          ve || (ve = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $));
        };
        j.isReactWarning = !0, Object.defineProperty(k, "ref", {
          get: j,
          configurable: !0
        });
      }
    }
    var Dn = function(k, $, j, pe, qe, rt, ze) {
      var Ve = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: k,
        key: $,
        ref: j,
        props: ze,
        // Record the component responsible for creating this element.
        _owner: rt
      };
      return Ve._store = {}, Object.defineProperty(Ve._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ve, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: pe
      }), Object.defineProperty(Ve, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: qe
      }), Object.freeze && (Object.freeze(Ve.props), Object.freeze(Ve)), Ve;
    };
    function qt(k, $, j, pe, qe) {
      {
        var rt, ze = {}, Ve = null, fn = null;
        j !== void 0 && (je(j), Ve = "" + j), pt($) && (je($.key), Ve = "" + $.key), De($) && (fn = $.ref, un($, qe));
        for (rt in $)
          Ze.call($, rt) && !L.hasOwnProperty(rt) && (ze[rt] = $[rt]);
        if (k && k.defaultProps) {
          var Rt = k.defaultProps;
          for (rt in Rt)
            ze[rt] === void 0 && (ze[rt] = Rt[rt]);
        }
        if (Ve || fn) {
          var $t = typeof k == "function" ? k.displayName || k.name || "Unknown" : k;
          Ve && bn(ze, $t), fn && Ut(ze, $t);
        }
        return Dn(k, Ve, fn, qe, pe, Qe.current, ze);
      }
    }
    var ct = w.ReactCurrentOwner, vn = w.ReactDebugCurrentFrame;
    function Jt(k) {
      if (k) {
        var $ = k._owner, j = we(k.type, k._source, $ ? $.type : null);
        vn.setExtraStackFrame(j);
      } else
        vn.setExtraStackFrame(null);
    }
    var Un;
    Un = !1;
    function Ct(k) {
      return typeof k == "object" && k !== null && k.$$typeof === e;
    }
    function An() {
      {
        if (ct.current) {
          var k = P(ct.current.type);
          if (k)
            return `

Check the render method of \`` + k + "`.";
        }
        return "";
      }
    }
    function jr(k) {
      return "";
    }
    var qn = {};
    function Eo(k) {
      {
        var $ = An();
        if (!$) {
          var j = typeof k == "string" ? k : k.displayName || k.name;
          j && ($ = `

Check the top-level render call using <` + j + ">.");
        }
        return $;
      }
    }
    function gt(k, $) {
      {
        if (!k._store || k._store.validated || k.key != null)
          return;
        k._store.validated = !0;
        var j = Eo($);
        if (qn[j])
          return;
        qn[j] = !0;
        var pe = "";
        k && k._owner && k._owner !== ct.current && (pe = " It was passed a child from " + P(k._owner.type) + "."), Jt(k), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', j, pe), Jt(null);
      }
    }
    function Jn(k, $) {
      {
        if (typeof k != "object")
          return;
        if (tt(k))
          for (var j = 0; j < k.length; j++) {
            var pe = k[j];
            Ct(pe) && gt(pe, $);
          }
        else if (Ct(k))
          k._store && (k._store.validated = !0);
        else if (k) {
          var qe = b(k);
          if (typeof qe == "function" && qe !== k.entries)
            for (var rt = qe.call(k), ze; !(ze = rt.next()).done; )
              Ct(ze.value) && gt(ze.value, $);
        }
      }
    }
    function Pe(k) {
      {
        var $ = k.type;
        if ($ == null || typeof $ == "string")
          return;
        var j;
        if (typeof $ == "function")
          j = $.propTypes;
        else if (typeof $ == "object" && ($.$$typeof === a || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        $.$$typeof === u))
          j = $.propTypes;
        else
          return;
        if (j) {
          var pe = P($);
          Lt(j, k.props, "prop", pe, k);
        } else if ($.PropTypes !== void 0 && !Un) {
          Un = !0;
          var qe = P($);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", qe || "Unknown");
        }
        typeof $.getDefaultProps == "function" && !$.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function xn(k) {
      {
        for (var $ = Object.keys(k.props), j = 0; j < $.length; j++) {
          var pe = $[j];
          if (pe !== "children" && pe !== "key") {
            Jt(k), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", pe), Jt(null);
            break;
          }
        }
        k.ref !== null && (Jt(k), S("Invalid attribute `ref` supplied to `React.Fragment`."), Jt(null));
      }
    }
    function qi(k, $, j, pe, qe, rt) {
      {
        var ze = A(k);
        if (!ze) {
          var Ve = "";
          (k === void 0 || typeof k == "object" && k !== null && Object.keys(k).length === 0) && (Ve += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var fn = jr();
          fn ? Ve += fn : Ve += An();
          var Rt;
          k === null ? Rt = "null" : tt(k) ? Rt = "array" : k !== void 0 && k.$$typeof === e ? (Rt = "<" + (P(k.type) || "Unknown") + " />", Ve = " Did you accidentally export a JSX literal instead of a component?") : Rt = typeof k, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Rt, Ve);
        }
        var $t = qt(k, $, j, qe, rt);
        if ($t == null)
          return $t;
        if (ze) {
          var Ln = $.children;
          if (Ln !== void 0)
            if (pe)
              if (tt(Ln)) {
                for (var ti = 0; ti < Ln.length; ti++)
                  Jn(Ln[ti], k);
                Object.freeze && Object.freeze(Ln);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Jn(Ln, k);
        }
        return k === r ? xn($t) : Pe($t), $t;
      }
    }
    function Ne(k, $, j) {
      return qi(k, $, j, !0);
    }
    function ue(k, $, j) {
      return qi(k, $, j, !1);
    }
    var yt = ue, cr = Ne;
    ss.Fragment = r, ss.jsx = yt, ss.jsxs = cr;
  }()), ss;
}
var rm;
function I3() {
  return rm || (rm = 1, process.env.NODE_ENV === "production" ? Ol.exports = k3() : Ol.exports = T3()), Ol.exports;
}
var C = I3();
const M3 = {
  // Controls labels
  linkControlLabel: "Link",
  colorPickerControlLabel: "Text color",
  highlightControlLabel: "Highlight text",
  colorControlLabel: (t) => `Set text color ${t}`,
  boldControlLabel: "Bold",
  italicControlLabel: "Italic",
  underlineControlLabel: "Underline",
  strikeControlLabel: "Strikethrough",
  clearFormattingControlLabel: "Clear formatting",
  unlinkControlLabel: "Remove link",
  bulletListControlLabel: "Bullet list",
  orderedListControlLabel: "Ordered list",
  h1ControlLabel: "Heading 1",
  h2ControlLabel: "Heading 2",
  h3ControlLabel: "Heading 3",
  h4ControlLabel: "Heading 4",
  h5ControlLabel: "Heading 5",
  h6ControlLabel: "Heading 6",
  blockquoteControlLabel: "Blockquote",
  alignLeftControlLabel: "Align text: left",
  alignCenterControlLabel: "Align text: center",
  alignRightControlLabel: "Align text: right",
  alignJustifyControlLabel: "Align text: justify",
  codeControlLabel: "Code",
  codeBlockControlLabel: "Code block",
  subscriptControlLabel: "Subscript",
  superscriptControlLabel: "Superscript",
  unsetColorControlLabel: "Unset color",
  hrControlLabel: "Horizontal line",
  undoControlLabel: "Undo",
  redoControlLabel: "Redo",
  // Task list
  tasksControlLabel: "Task list",
  tasksSinkLabel: "Decrease task level",
  tasksLiftLabel: "Increase task level",
  // Link editor
  linkEditorInputLabel: "Enter URL",
  linkEditorInputPlaceholder: "https://example.com/",
  linkEditorExternalLink: "Open link in a new tab",
  linkEditorInternalLink: "Open link in the same tab",
  linkEditorSave: "Save",
  // Color picker control
  colorPickerCancel: "Cancel",
  colorPickerClear: "Clear color",
  colorPickerColorPicker: "Color picker",
  colorPickerPalette: "Color palette",
  colorPickerSave: "Save",
  colorPickerColorLabel: (t) => `Set text color ${t}`
}, [R3, lr] = ZS("RichTextEditor component was not found in tree");
function O3(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Fu = { exports: {} }, Id = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var om;
function D3() {
  if (om) return Id;
  om = 1;
  var t = g;
  function e(u, f) {
    return u === f && (u !== 0 || 1 / u === 1 / f) || u !== u && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, o = t.useEffect, i = t.useLayoutEffect, s = t.useDebugValue;
  function l(u, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), y = p[0].inst, b = p[1];
    return i(function() {
      y.value = h, y.getSnapshot = f, a(y) && b({ inst: y });
    }, [u, h, f]), o(function() {
      return a(y) && b({ inst: y }), u(function() {
        a(y) && b({ inst: y });
      });
    }, [u]), s(h), h;
  }
  function a(u) {
    var f = u.getSnapshot;
    u = u.value;
    try {
      var h = f();
      return !n(u, h);
    } catch {
      return !0;
    }
  }
  function c(u, f) {
    return f();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : l;
  return Id.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : d, Id;
}
var Md = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var im;
function A3() {
  return im || (im = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = g, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(x) {
      {
        for (var E = arguments.length, v = new Array(E > 1 ? E - 1 : 0), T = 1; T < E; T++)
          v[T - 1] = arguments[T];
        r("error", x, v);
      }
    }
    function r(x, E, v) {
      {
        var T = e.ReactDebugCurrentFrame, I = T.getStackAddendum();
        I !== "" && (E += "%s", v = v.concat([I]));
        var M = v.map(function(R) {
          return String(R);
        });
        M.unshift("Warning: " + E), Function.prototype.apply.call(console[x], console, M);
      }
    }
    function o(x, E) {
      return x === E && (x !== 0 || 1 / x === 1 / E) || x !== x && E !== E;
    }
    var i = typeof Object.is == "function" ? Object.is : o, s = t.useState, l = t.useEffect, a = t.useLayoutEffect, c = t.useDebugValue, d = !1, u = !1;
    function f(x, E, v) {
      d || t.startTransition !== void 0 && (d = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var T = E();
      if (!u) {
        var I = E();
        i(T, I) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), u = !0);
      }
      var M = s({
        inst: {
          value: T,
          getSnapshot: E
        }
      }), R = M[0].inst, A = M[1];
      return a(function() {
        R.value = T, R.getSnapshot = E, h(R) && A({
          inst: R
        });
      }, [x, T, E]), l(function() {
        h(R) && A({
          inst: R
        });
        var F = function() {
          h(R) && A({
            inst: R
          });
        };
        return x(F);
      }, [x]), c(T), T;
    }
    function h(x) {
      var E = x.getSnapshot, v = x.value;
      try {
        var T = E();
        return !i(v, T);
      } catch {
        return !0;
      }
    }
    function p(x, E, v) {
      return E();
    }
    var y = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", b = !y, w = b ? p : f, S = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : w;
    Md.useSyncExternalStore = S, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Md;
}
process.env.NODE_ENV === "production" ? Fu.exports = D3() : Fu.exports = A3();
var Pc = Fu.exports;
const L3 = (...t) => (e) => {
  t.forEach((n) => {
    typeof n == "function" ? n(e) : n && (n.current = e);
  });
}, $3 = ({ contentComponent: t }) => {
  const e = Pc.useSyncExternalStore(t.subscribe, t.getSnapshot, t.getServerSnapshot);
  return g.createElement(g.Fragment, null, Object.values(e));
};
function P3() {
  const t = /* @__PURE__ */ new Set();
  let e = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(n) {
      return t.add(n), () => {
        t.delete(n);
      };
    },
    getSnapshot() {
      return e;
    },
    getServerSnapshot() {
      return e;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(n, r) {
      e = {
        ...e,
        [n]: Cv.createPortal(r.reactElement, r.element, n)
      }, t.forEach((o) => o());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(n) {
      const r = { ...e };
      delete r[n], e = r, t.forEach((o) => o());
    }
  };
}
class _3 extends g.Component {
  constructor(e) {
    var n;
    super(e), this.editorContentRef = g.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((n = e.editor) === null || n === void 0) && n.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const e = this.props.editor;
    if (e && !e.isDestroyed && e.options.element) {
      if (e.contentComponent)
        return;
      const n = this.editorContentRef.current;
      n.append(...e.options.element.childNodes), e.setOptions({
        element: n
      }), e.contentComponent = P3(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = e.contentComponent.subscribe(() => {
        this.setState((r) => r.hasContentComponentInitialized ? r : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), e.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const e = this.props.editor;
    if (!e || (this.initialized = !1, e.isDestroyed || e.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), e.contentComponent = null, !e.options.element.firstChild))
      return;
    const n = document.createElement("div");
    n.append(...e.options.element.childNodes), e.setOptions({
      element: n
    });
  }
  render() {
    const { editor: e, innerRef: n, ...r } = this.props;
    return g.createElement(
      g.Fragment,
      null,
      g.createElement("div", { ref: L3(n, this.editorContentRef), ...r }),
      (e == null ? void 0 : e.contentComponent) && g.createElement($3, { contentComponent: e.contentComponent })
    );
  }
}
const B3 = ge((t, e) => {
  const n = g.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [t.editor]);
  return g.createElement(_3, {
    key: n,
    innerRef: e,
    ...t
  });
}), sm = g.memo(B3);
var V3 = function t(e, n) {
  if (e === n) return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor) return !1;
    var r, o, i;
    if (Array.isArray(e)) {
      if (r = e.length, r != n.length) return !1;
      for (o = r; o-- !== 0; )
        if (!t(e[o], n[o])) return !1;
      return !0;
    }
    if (e instanceof Map && n instanceof Map) {
      if (e.size !== n.size) return !1;
      for (o of e.entries())
        if (!n.has(o[0])) return !1;
      for (o of e.entries())
        if (!t(o[1], n.get(o[0]))) return !1;
      return !0;
    }
    if (e instanceof Set && n instanceof Set) {
      if (e.size !== n.size) return !1;
      for (o of e.entries())
        if (!n.has(o[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(n)) {
      if (r = e.length, r != n.length) return !1;
      for (o = r; o-- !== 0; )
        if (e[o] !== n[o]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
    if (i = Object.keys(e), r = i.length, r !== Object.keys(n).length) return !1;
    for (o = r; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, i[o])) return !1;
    for (o = r; o-- !== 0; ) {
      var s = i[o];
      if (!(s === "_owner" && e.$$typeof) && !t(e[s], n[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}, F3 = /* @__PURE__ */ O3(V3), Nu = { exports: {} }, Rd = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lm;
function N3() {
  if (lm) return Rd;
  lm = 1;
  var t = g, e = Pc;
  function n(c, d) {
    return c === d && (c !== 0 || 1 / c === 1 / d) || c !== c && d !== d;
  }
  var r = typeof Object.is == "function" ? Object.is : n, o = e.useSyncExternalStore, i = t.useRef, s = t.useEffect, l = t.useMemo, a = t.useDebugValue;
  return Rd.useSyncExternalStoreWithSelector = function(c, d, u, f, h) {
    var p = i(null);
    if (p.current === null) {
      var y = { hasValue: !1, value: null };
      p.current = y;
    } else y = p.current;
    p = l(function() {
      function w(T) {
        if (!S) {
          if (S = !0, x = T, T = f(T), h !== void 0 && y.hasValue) {
            var I = y.value;
            if (h(I, T)) return E = I;
          }
          return E = T;
        }
        if (I = E, r(x, T)) return I;
        var M = f(T);
        return h !== void 0 && h(I, M) ? I : (x = T, E = M);
      }
      var S = !1, x, E, v = u === void 0 ? null : u;
      return [function() {
        return w(d());
      }, v === null ? void 0 : function() {
        return w(v());
      }];
    }, [d, u, f, h]);
    var b = o(c, p[0], p[1]);
    return s(function() {
      y.hasValue = !0, y.value = b;
    }, [b]), a(b), b;
  }, Rd;
}
var Od = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var am;
function z3() {
  return am || (am = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = g, e = Pc;
    function n(d, u) {
      return d === u && (d !== 0 || 1 / d === 1 / u) || d !== d && u !== u;
    }
    var r = typeof Object.is == "function" ? Object.is : n, o = e.useSyncExternalStore, i = t.useRef, s = t.useEffect, l = t.useMemo, a = t.useDebugValue;
    function c(d, u, f, h, p) {
      var y = i(null), b;
      y.current === null ? (b = {
        hasValue: !1,
        value: null
      }, y.current = b) : b = y.current;
      var w = l(function() {
        var v = !1, T, I, M = function(V) {
          if (!v) {
            v = !0, T = V;
            var P = h(V);
            if (p !== void 0 && b.hasValue) {
              var J = b.value;
              if (p(J, P))
                return I = J, J;
            }
            return I = P, P;
          }
          var ne = T, G = I;
          if (r(ne, V))
            return G;
          var H = h(V);
          return p !== void 0 && p(G, H) ? G : (T = V, I = H, H);
        }, R = f === void 0 ? null : f, A = function() {
          return M(u());
        }, F = R === null ? void 0 : function() {
          return M(R());
        };
        return [A, F];
      }, [u, f, h, p]), S = w[0], x = w[1], E = o(d, S, x);
      return s(function() {
        b.hasValue = !0, b.value = E;
      }, [E]), a(E), E;
    }
    Od.useSyncExternalStoreWithSelector = c, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Od;
}
process.env.NODE_ENV === "production" ? Nu.exports = N3() : Nu.exports = z3();
var H3 = Nu.exports;
const j3 = typeof window < "u" ? _m : It;
class W3 {
  constructor(e) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = e, this.lastSnapshot = { editor: e, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscribers.add(e), () => {
      this.subscribers.delete(e);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(e) {
    if (this.editor = e, this.editor) {
      const n = () => {
        this.transactionNumber += 1, this.subscribers.forEach((o) => o());
      }, r = this.editor;
      return r.on("transaction", n), () => {
        r.off("transaction", n);
      };
    }
  }
}
function G3(t) {
  var e;
  const [n] = ie(() => new W3(t.editor)), r = H3.useSyncExternalStoreWithSelector(n.subscribe, n.getSnapshot, n.getServerSnapshot, t.selector, (e = t.equalityFn) !== null && e !== void 0 ? e : F3);
  return j3(() => n.watch(t.editor), [t.editor, n]), Bm(r), r;
}
const cm = process.env.NODE_ENV !== "production", zu = typeof window > "u", U3 = zu || !!(typeof window < "u" && window.next);
class q3 {
  constructor(e) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = e, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(e) {
    this.editor = e, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((n) => n());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return zu || U3 ? (cm && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && zu && cm)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const e = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...r) => {
        var o, i;
        return (i = (o = this.options.current).onBeforeCreate) === null || i === void 0 ? void 0 : i.call(o, ...r);
      },
      onBlur: (...r) => {
        var o, i;
        return (i = (o = this.options.current).onBlur) === null || i === void 0 ? void 0 : i.call(o, ...r);
      },
      onCreate: (...r) => {
        var o, i;
        return (i = (o = this.options.current).onCreate) === null || i === void 0 ? void 0 : i.call(o, ...r);
      },
      onDestroy: (...r) => {
        var o, i;
        return (i = (o = this.options.current).onDestroy) === null || i === void 0 ? void 0 : i.call(o, ...r);
      },
      onFocus: (...r) => {
        var o, i;
        return (i = (o = this.options.current).onFocus) === null || i === void 0 ? void 0 : i.call(o, ...r);
      },
      onSelectionUpdate: (...r) => {
        var o, i;
        return (i = (o = this.options.current).onSelectionUpdate) === null || i === void 0 ? void 0 : i.call(o, ...r);
      },
      onTransaction: (...r) => {
        var o, i;
        return (i = (o = this.options.current).onTransaction) === null || i === void 0 ? void 0 : i.call(o, ...r);
      },
      onUpdate: (...r) => {
        var o, i;
        return (i = (o = this.options.current).onUpdate) === null || i === void 0 ? void 0 : i.call(o, ...r);
      },
      onContentError: (...r) => {
        var o, i;
        return (i = (o = this.options.current).onContentError) === null || i === void 0 ? void 0 : i.call(o, ...r);
      },
      onDrop: (...r) => {
        var o, i;
        return (i = (o = this.options.current).onDrop) === null || i === void 0 ? void 0 : i.call(o, ...r);
      },
      onPaste: (...r) => {
        var o, i;
        return (i = (o = this.options.current).onPaste) === null || i === void 0 ? void 0 : i.call(o, ...r);
      }
    };
    return new Q4(e);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscriptions.add(e), () => {
      this.subscriptions.delete(e);
    };
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(e) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && e.length === 0 ? this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(e), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(e) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = e;
        return;
      }
      if (this.previousDeps.length === e.length && this.previousDeps.every((r, o) => r === e[o]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = e;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const e = this.instanceId, n = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === e) {
        n && n.setOptions(this.options.current);
        return;
      }
      n && !n.isDestroyed && (n.destroy(), this.instanceId === e && this.setEditor(null));
    }, 1);
  }
}
function J3(t = {}, e = []) {
  const n = Nt(t);
  n.current = t;
  const [r] = ie(() => new q3(n)), o = Pc.useSyncExternalStore(r.subscribe, r.getEditor, r.getServerSnapshot);
  return Bm(o), It(r.onRender(e)), G3({
    editor: o,
    selector: ({ transactionNumber: i }) => t.shouldRerenderOnTransaction === !1 ? null : t.immediatelyRender && i === 0 ? 0 : i + 1
  }), o;
}
const K3 = qo({
  editor: null
});
K3.Consumer;
const Y3 = qo({
  onDragStart: void 0
}), Z3 = () => Pi(Y3);
g.forwardRef((t, e) => {
  const { onDragStart: n } = Z3(), r = t.as || "div";
  return (
    // @ts-ignore
    g.createElement(r, { ...t, ref: e, "data-node-view-wrapper": "", onDragStart: n, style: {
      whiteSpace: "normal",
      ...t.style
    } })
  );
});
const X3 = {}, hh = Bi((t, e) => {
  const n = he("RichTextEditorContent", X3, t), { classNames: r, className: o, style: i, styles: s, vars: l, ...a } = n, c = lr();
  return c.withTypographyStyles ? /* @__PURE__ */ C.jsx(
    XS,
    {
      ...c.getStyles("typographyStylesProvider", { className: o, style: i, styles: s, classNames: r }),
      unstyled: c.unstyled,
      ref: e,
      children: /* @__PURE__ */ C.jsx(
        oe,
        {
          component: sm,
          editor: c.editor,
          ...c.getStyles("content", { classNames: r, styles: s }),
          ...a
        }
      )
    }
  ) : /* @__PURE__ */ C.jsx(
    oe,
    {
      component: sm,
      editor: c.editor,
      ...c.getStyles("content", { classNames: r, styles: s, className: o, style: i }),
      ...a
    }
  );
});
hh.classes = ei;
hh.displayName = "@mantine/tiptap/RichTextEditorContent";
function Fe(t) {
  return /* @__PURE__ */ C.jsx(
    "svg",
    {
      ...t,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      strokeWidth: "1.5",
      stroke: "currentColor",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  );
}
function Q3(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M7 5h6a3.5 3.5 0 0 1 0 7h-6z" }),
    /* @__PURE__ */ C.jsx("path", { d: "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7" })
  ] });
}
function eB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 5l6 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M7 19l6 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M14 5l-4 14" })
  ] });
}
function tB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M7 5v5a5 5 0 0 0 10 0v-5" }),
    /* @__PURE__ */ C.jsx("path", { d: "M5 19h14" })
  ] });
}
function nB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M5 12l14 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M16 6.5a4 2 0 0 0 -4 -1.5h-1a3.5 3.5 0 0 0 0 7h2a3.5 3.5 0 0 1 0 7h-1.5a4 2 0 0 1 -4 -1.5" })
  ] });
}
function rB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M17 15l4 4m0 -4l-4 4" }),
    /* @__PURE__ */ C.jsx("path", { d: "M7 6v-1h11v1" }),
    /* @__PURE__ */ C.jsx("path", { d: "M7 19l4 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M13 5l-4 14" })
  ] });
}
function oB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M19 18v-8l-2 2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M12 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 12h8" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 6h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 6h2" })
  ] });
}
function iB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M12 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 12h8" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 6h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 6h2" })
  ] });
}
function sB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M19 14a2 2 0 1 0 -2 -2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M17 16a2 2 0 1 0 2 -2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M12 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 12h8" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 6h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 6h2" })
  ] });
}
function lB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M20 18v-8l-4 6h5" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M12 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 12h8" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 6h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 6h2" })
  ] });
}
function aB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M17 18h2a2 2 0 1 0 0 -4h-2v-4h4" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M12 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 12h8" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 6h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 6h2" })
  ] });
}
function cB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M19 14a2 2 0 1 0 0 4a2 2 0 0 0 0 -4z" }),
    /* @__PURE__ */ C.jsx("path", { d: "M21 12a2 2 0 1 0 -4 0v4" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M12 6v12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 18h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 12h8" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 6h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 6h2" })
  ] });
}
function dB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M9 6l11 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M9 12l11 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M9 18l11 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M5 6l0 .01" }),
    /* @__PURE__ */ C.jsx("path", { d: "M5 12l0 .01" }),
    /* @__PURE__ */ C.jsx("path", { d: "M5 18l0 .01" })
  ] });
}
function uB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 6h9" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 12h9" }),
    /* @__PURE__ */ C.jsx("path", { d: "M12 18h8" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4" }),
    /* @__PURE__ */ C.jsx("path", { d: "M6 10v-6l-2 2" })
  ] });
}
function fB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M17 22v-2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M9 15l6 -6" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" }),
    /* @__PURE__ */ C.jsx("path", { d: "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" }),
    /* @__PURE__ */ C.jsx("path", { d: "M20 17h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M2 7h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M7 2v2" })
  ] });
}
function hB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M6 15h15" }),
    /* @__PURE__ */ C.jsx("path", { d: "M21 19h-15" }),
    /* @__PURE__ */ C.jsx("path", { d: "M15 11h6" }),
    /* @__PURE__ */ C.jsx("path", { d: "M21 7h-6" }),
    /* @__PURE__ */ C.jsx("path", { d: "M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2" })
  ] });
}
function pB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 6l16 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 12l10 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 18l14 0" })
  ] });
}
function gB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 6l16 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M10 12l10 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M6 18l14 0" })
  ] });
}
function mB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 6l16 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M8 12l8 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M6 18l12 0" })
  ] });
}
function yB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 6l16 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 12l16 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 18l12 0" })
  ] });
}
function bB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M5 7l8 10m-8 0l8 -10" }),
    /* @__PURE__ */ C.jsx("path", { d: "M21 20h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2" })
  ] });
}
function wB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M5 7l8 10m-8 0l8 -10" }),
    /* @__PURE__ */ C.jsx("path", { d: "M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2" })
  ] });
}
function zw(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M7 8l-4 4l4 4" }),
    /* @__PURE__ */ C.jsx("path", { d: "M17 8l4 4l-4 4" }),
    /* @__PURE__ */ C.jsx("path", { d: "M14 4l-4 16" })
  ] });
}
function SB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 19h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" }),
    /* @__PURE__ */ C.jsx("path", { d: "M12.5 5.5l4 4" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4.5 13.5l4 4" }),
    /* @__PURE__ */ C.jsx("path", { d: "M21 15v4h-8l4 -4z" })
  ] });
}
function CB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M5 12h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M17 12h2" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 12h2" })
  ] });
}
function Hw(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3 3l18 18" })
  ] });
}
function vB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 7l6 6" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z" })
  ] });
}
function xB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M18 6l-12 12" }),
    /* @__PURE__ */ C.jsx("path", { d: "M6 6l12 12" })
  ] });
}
function EB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25" }),
    /* @__PURE__ */ C.jsx("path", { d: "M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" })
  ] });
}
function kB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M5 12l5 5l10 -10" })
  ] });
}
function TB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M9 15l6 -6" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" }),
    /* @__PURE__ */ C.jsx("path", { d: "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" })
  ] });
}
function IB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 13l9 -9" }),
    /* @__PURE__ */ C.jsx("path", { d: "M15 4h5v5" })
  ] });
}
function MB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M9 14l-4 -4l4 -4" }),
    /* @__PURE__ */ C.jsx("path", { d: "M5 10h11a4 4 0 1 1 0 8h-1" })
  ] });
}
function RB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M15 14l4 -4l-4 -4" }),
    /* @__PURE__ */ C.jsx("path", { d: "M19 10h-11a4 4 0 1 0 0 8h1" })
  ] });
}
function OB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3.5 5.5l1.5 1.5l2.5 -2.5" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3.5 11.5l1.5 1.5l2.5 -2.5" }),
    /* @__PURE__ */ C.jsx("path", { d: "M3.5 17.5l1.5 1.5l2.5 -2.5" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 6l9 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 12l9 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M11 18l9 0" })
  ] });
}
function DB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M20 6l-11 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M20 12l-7 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M20 18l-11 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M4 8l4 4l-4 4" })
  ] });
}
function AB(t) {
  return /* @__PURE__ */ C.jsxs(Fe, { ...t, children: [
    /* @__PURE__ */ C.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ C.jsx("path", { d: "M20 6l-7 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M20 12l-9 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M20 18l-7 0" }),
    /* @__PURE__ */ C.jsx("path", { d: "M8 8l-4 4l4 4" })
  ] });
}
const LB = {
  interactive: !0
}, Gi = Bi((t, e) => {
  const n = he("RichTextEditorControl", LB, t), {
    classNames: r,
    className: o,
    style: i,
    styles: s,
    vars: l,
    interactive: a,
    active: c,
    onMouseDown: d,
    disabled: u,
    ...f
  } = n, h = lr();
  return /* @__PURE__ */ C.jsx(
    Qs,
    {
      ...f,
      ...h.getStyles("control", { className: o, style: i, classNames: r, styles: s }),
      disabled: u,
      "data-rich-text-editor-control": !0,
      tabIndex: a ? 0 : -1,
      "data-interactive": a || void 0,
      "data-disabled": u || void 0,
      "data-active": c || void 0,
      "aria-pressed": c && a || void 0,
      "aria-hidden": !a || void 0,
      ref: e,
      unstyled: h.unstyled,
      variant: h.variant || "default",
      onMouseDown: (p) => {
        p.preventDefault(), d == null || d(p);
      }
    }
  );
});
Gi.classes = ei;
Gi.displayName = "@mantine/tiptap/RichTextEditorControl";
const ph = ge(({ className: t, icon: e, ...n }, r) => {
  const o = lr();
  return /* @__PURE__ */ C.jsx(Gi, { ref: r, ...n, children: /* @__PURE__ */ C.jsx(e, { ...o.getStyles("controlIcon") }) });
});
ph.displayName = "@mantine/tiptap/RichTextEditorControlBase";
function Ye({
  label: t,
  isActive: e,
  operation: n,
  icon: r,
  isDisabled: o
}) {
  const i = ge((s, l) => {
    const { editor: a, labels: c } = lr(), d = c[t];
    return /* @__PURE__ */ C.jsx(
      ph,
      {
        ...s,
        "aria-label": d,
        title: d,
        active: e != null && e.name ? a == null ? void 0 : a.isActive(e.name, e.attributes) : !1,
        ref: l,
        onClick: () => a == null ? void 0 : a.chain().focus()[n.name](n.attributes).run(),
        icon: s.icon || r,
        disabled: (o == null ? void 0 : o(a)) || !1
      }
    );
  });
  return i.displayName = `@mantine/tiptap/${t}`, i;
}
const $B = Ye({
  label: "boldControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(Q3, { ...t }),
  isActive: { name: "bold" },
  operation: { name: "toggleBold" }
}), PB = Ye({
  label: "italicControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(eB, { ...t }),
  isActive: { name: "italic" },
  operation: { name: "toggleItalic" }
}), _B = Ye({
  label: "underlineControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(tB, { ...t }),
  isActive: { name: "underline" },
  operation: { name: "toggleUnderline" }
}), BB = Ye({
  label: "strikeControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(nB, { ...t }),
  isActive: { name: "strike" },
  operation: { name: "toggleStrike" }
}), VB = Ye({
  label: "clearFormattingControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(rB, { ...t }),
  operation: { name: "unsetAllMarks" }
}), FB = Ye({
  label: "unlinkControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(fB, { ...t }),
  operation: { name: "unsetLink" }
}), NB = Ye({
  label: "bulletListControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(dB, { ...t }),
  isActive: { name: "bulletList" },
  operation: { name: "toggleBulletList" }
}), zB = Ye({
  label: "orderedListControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(uB, { ...t }),
  isActive: { name: "orderedList" },
  operation: { name: "toggleOrderedList" }
}), HB = Ye({
  label: "h1ControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(oB, { ...t }),
  isActive: { name: "heading", attributes: { level: 1 } },
  operation: { name: "toggleHeading", attributes: { level: 1 } }
}), jB = Ye({
  label: "h2ControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(iB, { ...t }),
  isActive: { name: "heading", attributes: { level: 2 } },
  operation: { name: "toggleHeading", attributes: { level: 2 } }
}), WB = Ye({
  label: "h3ControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(sB, { ...t }),
  isActive: { name: "heading", attributes: { level: 3 } },
  operation: { name: "toggleHeading", attributes: { level: 3 } }
}), GB = Ye({
  label: "h4ControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(lB, { ...t }),
  isActive: { name: "heading", attributes: { level: 4 } },
  operation: { name: "toggleHeading", attributes: { level: 4 } }
}), UB = Ye({
  label: "h5ControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(aB, { ...t }),
  isActive: { name: "heading", attributes: { level: 5 } },
  operation: { name: "toggleHeading", attributes: { level: 5 } }
}), qB = Ye({
  label: "h6ControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(cB, { ...t }),
  isActive: { name: "heading", attributes: { level: 6 } },
  operation: { name: "toggleHeading", attributes: { level: 6 } }
}), JB = Ye({
  label: "blockquoteControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(hB, { ...t }),
  isActive: { name: "blockquote" },
  operation: { name: "toggleBlockquote" }
}), KB = Ye({
  label: "alignLeftControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(pB, { ...t }),
  operation: { name: "setTextAlign", attributes: "left" }
}), YB = Ye({
  label: "alignRightControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(gB, { ...t }),
  operation: { name: "setTextAlign", attributes: "right" }
}), ZB = Ye({
  label: "alignCenterControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(mB, { ...t }),
  operation: { name: "setTextAlign", attributes: "center" }
}), XB = Ye({
  label: "alignJustifyControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(yB, { ...t }),
  operation: { name: "setTextAlign", attributes: "justify" }
}), QB = Ye({
  label: "subscriptControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(bB, { ...t }),
  isActive: { name: "subscript" },
  operation: { name: "toggleSubscript" }
}), eV = Ye({
  label: "superscriptControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(wB, { ...t }),
  isActive: { name: "superscript" },
  operation: { name: "toggleSuperscript" }
}), tV = Ye({
  label: "codeControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(zw, { ...t }),
  isActive: { name: "code" },
  operation: { name: "toggleCode" }
}), nV = Ye({
  label: "codeBlockControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(zw, { ...t }),
  isActive: { name: "codeBlock" },
  operation: { name: "toggleCodeBlock" }
}), rV = Ye({
  label: "highlightControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(SB, { ...t }),
  isActive: { name: "highlight" },
  operation: { name: "toggleHighlight" }
}), oV = Ye({
  label: "hrControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(CB, { ...t }),
  operation: { name: "setHorizontalRule" }
}), iV = Ye({
  label: "unsetColorControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(Hw, { ...t }),
  operation: { name: "unsetColor" }
}), sV = Ye({
  label: "undoControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(MB, { ...t }),
  isDisabled: (t) => !(t != null && t.can().undo()),
  operation: { name: "undo" }
}), lV = Ye({
  label: "redoControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(RB, { ...t }),
  isDisabled: (t) => !(t != null && t.can().redo()),
  operation: { name: "redo" }
}), aV = Ye({
  label: "tasksControlLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(OB, { ...t }),
  isActive: { name: "taskList" },
  operation: { name: "toggleTaskList" }
}), cV = Ye({
  label: "tasksSinkLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(DB, { ...t }),
  operation: { name: "sinkListItem", attributes: "taskItem" },
  isDisabled: (t) => !(t != null && t.can().sinkListItem("taskItem"))
}), dV = Ye({
  label: "tasksLiftLabel",
  icon: (t) => /* @__PURE__ */ C.jsx(AB, { ...t }),
  operation: { name: "liftListItem", attributes: "taskItem" },
  isDisabled: (t) => !(t != null && t.can().liftListItem("taskItem"))
}), uV = (t) => /* @__PURE__ */ C.jsx(TB, { ...t }), fV = {}, gh = Bi(
  (t, e) => {
    var V;
    const n = he("RichTextEditorLinkControl", fV, t), {
      classNames: r,
      className: o,
      style: i,
      styles: s,
      vars: l,
      icon: a,
      popoverProps: c,
      disableTooltips: d,
      initialExternal: u,
      ...f
    } = n, h = lr(), p = { classNames: r, styles: s }, [y, b] = fv(""), [w, S] = ie(u), [x, { open: E, close: v }] = ty(!1), T = () => {
      var J;
      E();
      const P = (J = h.editor) == null ? void 0 : J.getAttributes("link");
      b((P == null ? void 0 : P.href) || ""), S(P != null && P.href ? (P == null ? void 0 : P.target) === "_blank" : u);
    }, I = () => {
      v(), b(""), S(u);
    }, M = () => {
      var P, J;
      I(), y === "" ? (P = h.editor) == null || P.chain().focus().extendMarkRange("link").unsetLink().run() : (J = h.editor) == null || J.chain().focus().extendMarkRange("link").setLink({ href: y, target: w ? "_blank" : null }).run();
    }, R = (P) => {
      P.key === "Enter" && (P.preventDefault(), M());
    };
    hv("edit-link", T, !1);
    const { resolvedClassNames: A, resolvedStyles: F } = QS({ classNames: r, styles: s, props: n });
    return /* @__PURE__ */ C.jsxs(
      Hn,
      {
        trapFocus: !0,
        shadow: "md",
        withinPortal: !0,
        opened: x,
        onChange: (P) => !P && I(),
        offset: -44,
        zIndex: 1e4,
        ...c,
        children: [
          /* @__PURE__ */ C.jsx(Hn.Target, { children: /* @__PURE__ */ C.jsx(
            ph,
            {
              icon: a || uV,
              ...f,
              "aria-label": h.labels.linkControlLabel,
              title: h.labels.linkControlLabel,
              onClick: T,
              active: (V = h.editor) == null ? void 0 : V.isActive("link"),
              ref: e,
              classNames: A,
              styles: F,
              className: o,
              style: i,
              variant: h.variant
            }
          ) }),
          /* @__PURE__ */ C.jsx(Hn.Dropdown, { ...h.getStyles("linkEditorDropdown", p), children: /* @__PURE__ */ C.jsxs("div", { ...h.getStyles("linkEditor", p), children: [
            /* @__PURE__ */ C.jsx(
              jm,
              {
                placeholder: h.labels.linkEditorInputPlaceholder,
                "aria-label": h.labels.linkEditorInputLabel,
                type: "url",
                value: y,
                onChange: b,
                classNames: { input: h.getStyles("linkEditorInput", p).className },
                onKeyDown: R,
                rightSection: /* @__PURE__ */ C.jsx(
                  Xs,
                  {
                    label: w ? h.labels.linkEditorExternalLink : h.labels.linkEditorInternalLink,
                    events: { hover: !0, focus: !0, touch: !0 },
                    withinPortal: !0,
                    withArrow: !0,
                    disabled: d,
                    zIndex: 1e4,
                    children: /* @__PURE__ */ C.jsx(
                      Qs,
                      {
                        onClick: () => S((P) => !P),
                        "data-active": w || void 0,
                        ...h.getStyles("linkEditorExternalControl", p),
                        children: /* @__PURE__ */ C.jsx(IB, { style: { width: m(14), height: m(14) } })
                      }
                    )
                  }
                )
              }
            ),
            /* @__PURE__ */ C.jsx(
              ra,
              {
                variant: "default",
                onClick: M,
                ...h.getStyles("linkEditorSave", p),
                children: h.labels.linkEditorSave
              }
            )
          ] }) })
        ]
      }
    );
  }
);
gh.classes = ei;
gh.displayName = "@mantine/tiptap/RichTextEditorLinkControl";
const hV = {}, jw = ge((t, e) => {
  const { popoverProps: n, colors: r, colorPickerProps: o, ...i } = he(
    "RichTextEditorColorPickerControl",
    hV,
    t
  ), { editor: s, labels: l, getStyles: a, variant: c } = lr(), [d, { toggle: u, close: f }] = ty(!1), [h, p] = ie("palette"), y = (s == null ? void 0 : s.getAttributes("textStyle").color) || "var(--mantine-color-text)", b = (x, E = !0) => {
    (s == null ? void 0 : s.chain()).focus().setColor(x).run(), E && f();
  }, w = () => {
    (s == null ? void 0 : s.chain()).focus().unsetColor().run(), f();
  }, S = r.map((x, E) => /* @__PURE__ */ C.jsx(
    Gd,
    {
      component: "button",
      color: x,
      onClick: () => b(x),
      size: 26,
      radius: "xs",
      style: { cursor: "pointer" },
      title: l.colorPickerColorLabel(x),
      "aria-label": l.colorPickerColorLabel(x)
    },
    E
  ));
  return /* @__PURE__ */ C.jsxs(
    Hn,
    {
      opened: d,
      withinPortal: !0,
      trapFocus: !0,
      onChange: (x) => !x && f(),
      ...n,
      children: [
        /* @__PURE__ */ C.jsx(Hn.Target, { children: /* @__PURE__ */ C.jsx(
          Gi,
          {
            ...i,
            variant: c,
            "aria-label": l.colorPickerControlLabel,
            title: l.colorPickerControlLabel,
            ref: e,
            onClick: u,
            children: /* @__PURE__ */ C.jsx(Gd, { color: y, size: 14 })
          }
        ) }),
        /* @__PURE__ */ C.jsxs(Hn.Dropdown, { ...a("linkEditorDropdown"), children: [
          h === "palette" && /* @__PURE__ */ C.jsx(Wd, { cols: 7, spacing: 2, children: S }),
          h === "colorPicker" && /* @__PURE__ */ C.jsx(
            eC,
            {
              defaultValue: y,
              onChange: (x) => b(x, !1),
              ...o
            }
          ),
          /* @__PURE__ */ C.jsx(Xs.Group, { closeDelay: 200, children: /* @__PURE__ */ C.jsxs(X, { justify: "flex-end", gap: "xs", mt: "sm", children: [
            h === "palette" && /* @__PURE__ */ C.jsx(
              Ji,
              {
                variant: "default",
                onClick: f,
                title: l.colorPickerCancel,
                "aria-label": l.colorPickerCancel,
                children: /* @__PURE__ */ C.jsx(xB, { style: { width: m(16), height: m(16) } })
              }
            ),
            /* @__PURE__ */ C.jsx(
              Ji,
              {
                variant: "default",
                onClick: w,
                title: l.colorPickerClear,
                "aria-label": l.colorPickerClear,
                children: /* @__PURE__ */ C.jsx(Hw, { style: { width: m(16), height: m(16) } })
              }
            ),
            h === "palette" ? /* @__PURE__ */ C.jsx(
              Ji,
              {
                variant: "default",
                onClick: () => p("colorPicker"),
                title: l.colorPickerColorPicker,
                "aria-label": l.colorPickerColorPicker,
                children: /* @__PURE__ */ C.jsx(vB, { style: { width: m(16), height: m(16) } })
              }
            ) : /* @__PURE__ */ C.jsx(
              Ji,
              {
                variant: "default",
                onClick: () => p("palette"),
                "aria-label": l.colorPickerPalette,
                title: l.colorPickerPalette,
                children: /* @__PURE__ */ C.jsx(EB, { style: { width: m(16), height: m(16) } })
              }
            ),
            h === "colorPicker" && /* @__PURE__ */ C.jsx(
              Ji,
              {
                variant: "default",
                onClick: f,
                title: l.colorPickerSave,
                "aria-label": l.colorPickerSave,
                children: /* @__PURE__ */ C.jsx(kB, { style: { width: m(16), height: m(16) } })
              }
            )
          ] }) })
        ] })
      ]
    }
  );
});
jw.displayName = "@mantine/tiptap/ColorPickerControl";
const pV = {}, Ww = ge((t, e) => {
  const { color: n, ...r } = he("RichTextEditorColorControl", pV, t), { editor: o, labels: i, variant: s } = lr(), l = (o == null ? void 0 : o.getAttributes("textStyle").color) || null, a = i.colorControlLabel(n);
  return /* @__PURE__ */ C.jsx(
    Gi,
    {
      ...r,
      variant: s,
      active: l === n,
      "aria-label": a,
      title: a,
      onClick: () => (o == null ? void 0 : o.chain()).focus().setColor(n).run(),
      ref: e,
      children: /* @__PURE__ */ C.jsx(Gd, { color: n, size: 14 })
    }
  );
});
Ww.displayName = "@mantine/tiptap/RichTextEditorColorControl";
const gV = {}, mh = Bi(
  (t, e) => {
    const n = he("RichTextEditorControlsGroup", gV, t), { classNames: r, className: o, style: i, styles: s, vars: l, variant: a, ...c } = n, d = lr();
    return /* @__PURE__ */ C.jsx(
      oe,
      {
        ref: e,
        variant: a || d.variant,
        ...d.getStyles("controlsGroup", { className: o, style: i, styles: s, classNames: r }),
        ...c
      }
    );
  }
);
mh.classes = ei;
mh.displayName = "@mantine/tiptap/RichTextEditorControlsGroup";
const mV = {}, yh = Bi((t, e) => {
  const n = he("RichTextEditorToolbar", mV, t), {
    classNames: r,
    className: o,
    style: i,
    styles: s,
    vars: l,
    sticky: a,
    stickyOffset: c,
    mod: d,
    variant: u,
    ...f
  } = n, h = lr();
  return /* @__PURE__ */ C.jsx(
    oe,
    {
      ref: e,
      mod: [{ sticky: a }, d],
      variant: u || h.variant,
      ...h.getStyles("toolbar", { className: o, style: i, styles: s, classNames: r }),
      ...f,
      __vars: { "--rte-sticky-offset": m(c) }
    }
  );
});
yh.classes = ei;
yh.displayName = "@mantine/tiptap/RichTextEditorToolbar";
const yV = {
  withCodeHighlightStyles: !0,
  withTypographyStyles: !0,
  variant: "default"
}, Z = Bi((t, e) => {
  const n = he("RichTextEditor", yV, t), {
    classNames: r,
    className: o,
    style: i,
    styles: s,
    unstyled: l,
    vars: a,
    editor: c,
    withCodeHighlightStyles: d,
    withTypographyStyles: u,
    labels: f,
    children: h,
    variant: p,
    ...y
  } = n, b = tC({
    name: "RichTextEditor",
    classes: ei,
    props: n,
    className: o,
    style: i,
    classNames: r,
    styles: s,
    unstyled: l,
    vars: a
  }), w = me(() => ({ ...M3, ...f }), [f]);
  return /* @__PURE__ */ C.jsx(
    R3,
    {
      value: {
        editor: c,
        getStyles: b,
        labels: w,
        withCodeHighlightStyles: d,
        withTypographyStyles: u,
        unstyled: l,
        variant: p
      },
      children: /* @__PURE__ */ C.jsx(oe, { ...b("root"), ...y, ref: e, children: h })
    }
  );
});
Z.classes = ei;
Z.displayName = "@mantine/tiptap/RichTextEditor";
Z.Content = hh;
Z.Control = Gi;
Z.Toolbar = yh;
Z.ControlsGroup = mh;
Z.Bold = $B;
Z.Italic = PB;
Z.Strikethrough = BB;
Z.Underline = _B;
Z.ClearFormatting = VB;
Z.H1 = HB;
Z.H2 = jB;
Z.H3 = WB;
Z.H4 = GB;
Z.H5 = UB;
Z.H6 = qB;
Z.BulletList = NB;
Z.OrderedList = zB;
Z.Link = gh;
Z.Unlink = FB;
Z.Blockquote = JB;
Z.AlignLeft = KB;
Z.AlignRight = YB;
Z.AlignCenter = ZB;
Z.AlignJustify = XB;
Z.Superscript = eV;
Z.Subscript = QB;
Z.Code = tV;
Z.CodeBlock = nV;
Z.ColorPicker = jw;
Z.Color = Ww;
Z.Highlight = rV;
Z.Hr = oV;
Z.UnsetColor = iV;
Z.Undo = sV;
Z.Redo = lV;
Z.TaskList = aV;
Z.TaskListSink = cV;
Z.TaskListLift = dV;
const Xr = {
  text: "text",
  source: "source"
}, bV = [1, 2, 3, 4, 5], ms = {
  default: "default",
  preview: "preview"
}, Dt = (t) => `toolbar-button-${t}`, wV = (t, e) => {
  const n = () => t.chain().focus();
  return [
    {
      name: e.createTable,
      onClick: () => n().insertTable({ rows: 3, cols: 3, withHeaderRow: !0 }).run(),
      disabled: !1
    },
    {
      name: e.addColumnBefore,
      onClick: () => n().addColumnBefore().run(),
      disabled: !t.can().addColumnBefore()
    },
    {
      name: e.addColumnAfter,
      onClick: () => n().addColumnAfter().run(),
      disabled: !t.can().addColumnAfter()
    },
    {
      name: e.deleteColumn,
      onClick: () => n().deleteColumn().run(),
      disabled: !t.can().deleteColumn()
    },
    {
      name: e.addRowAfter,
      onClick: () => n().addRowAfter().run(),
      disabled: !t.can().addRowAfter()
    },
    {
      name: e.deleteTable,
      onClick: () => n().deleteTable().run(),
      disabled: !t.can().deleteTable()
    },
    {
      name: e.mergeCells,
      onClick: () => n().mergeCells().run(),
      disabled: !t.can().mergeCells()
    },
    {
      name: e.toggleHeaderColumn,
      onClick: () => n().toggleHeaderColumn().run(),
      disabled: !t.can().toggleHeaderColumn()
    }
  ];
}, Ks = "0 !important", SV = {
  borderTopRightRadius: Ks,
  borderBottomRightRadius: Ks
}, CV = {
  borderTopLeftRadius: Ks,
  borderBottomLeftRadius: Ks
}, Dl = {
  borderRadius: Ks
}, Gw = O((t) => ({
  active: {
    backgroundColor: t.colors.green[13],
    svg: {
      color: t.colors.green[13]
    }
  },
  toolbarControls: {
    width: "100%",
    backgroundColor: "transparent",
    "& > *": {
      ...Dl,
      border: 0
    }
  },
  dropDown: {
    ...Dl,
    "&:hover": {
      backgroundColor: t.other.colors.greyIron[2]
    }
  },
  controlWrapper: {
    height: "100%",
    "& > *": {
      ...Dl,
      border: 0
    }
  },
  textDropdown: {
    borderTop: 0,
    borderLeft: 0,
    borderBottom: 0,
    "& > span": {
      justifyContent: "space-between"
    }
  },
  tableDropdown: {
    borderTop: 0,
    borderRight: 0,
    borderBottom: 0,
    "& > span": {
      justifyContent: "space-between"
    }
  },
  tableDropdownWrapper: {},
  controls: {
    "& > *:not(:first-of-type):not(:last-of-type)": {
      ...Dl,
      borderLeft: "none",
      borderRight: "none"
    },
    "& > *:first-of-type": {
      ...SV
    },
    "& > *:last-of-type": {
      ...CV
    },
    "& > button:first-of-type": {
      borderRight: "none"
    },
    "& > button:last-of-type": {
      borderLeft: "none"
    }
  },
  hideToolBar: {
    display: "none"
  },
  borderLeft: {
    borderLeft: `1px solid ${t.other.colors.greyIron[4]} !important`
  },
  borderRight: {
    borderRight: `1px solid ${t.other.colors.greyIron[4]} !important`
  },
  disabledControl: {
    '&[data-rich-text-editor-control="true"]': {
      cursor: "not-allowed",
      pointerEvents: "none",
      svg: {
        color: t.other.colors.greyIron[12],
        "& path": {
          stroke: t.other.colors.greyIron[12]
        }
      },
      backgroundColor: t.other.colors.greyIron[2]
    },
    '&:not([data-loading="true"]):disabled': {
      cursor: "not-allowed",
      pointerEvents: "none",
      color: `${t.other.colors.greyIron[12]} !important`,
      svg: {
        color: t.other.colors.greyIron[12],
        "& path": {
          stroke: t.other.colors.greyIron[12]
        }
      },
      backgroundColor: `${t.other.colors.greyIron[2]} !important`
    }
  },
  activeDisabledControl: {
    '&[data-rich-text-editor-control="true"]': {
      backgroundColor: t.other.colors.brand[4]
    }
  }
})), Uw = wr(({ handleActive: t, active: e, disabled: n }) => {
  const { editor: r } = lr(), { cx: o, classes: i } = Gw(), s = te(() => {
    r && (t(Xr.source), r.commands.setContent(`<textarea>${r.getHTML()}</textarea>`));
  }, [r, t]), l = te(() => {
    r && (t(Xr.text), r.commands.setContent(r.getText(), !0));
  }, [r, t]);
  return /* @__PURE__ */ g.createElement(X, { gap: 0, wrap: "nowrap", className: i.controlWrapper }, /* @__PURE__ */ g.createElement(
    Z.Control,
    {
      active: e === Xr.text,
      onClick: l,
      "aria-label": "Text mode",
      title: "Text mode",
      "data-testid": Dt("text-mode"),
      classNames: {
        control: o({ [i.disabledControl]: n, [i.activeDisabledControl]: e === Xr.text && n })
      }
    },
    /* @__PURE__ */ g.createElement(IC, { width: 16, height: 16 })
  ), /* @__PURE__ */ g.createElement(
    Z.Control,
    {
      active: e === Xr.source,
      onClick: s,
      "aria-label": "Source code",
      title: "Source code",
      "data-testid": Dt("source-code"),
      classNames: {
        control: o({ [i.disabledControl]: n, [i.activeDisabledControl]: e === Xr.source && n })
      }
    },
    /* @__PURE__ */ g.createElement(MC, { width: 16, height: 16 })
  ));
});
Uw.displayName = "EditorModeControl";
const vV = ({ translations: t, onChangeControlsMode: e, disabled: n }) => {
  const { editor: r } = lr(), { classes: o, cx: i } = Gw(), [s, l] = ie(Xr.text), a = me(() => s === Xr.source, [s]), c = te(
    (f) => {
      r == null || r.chain().focus().toggleHeading({ level: f + 1 }).run();
    },
    [r]
  ), d = te(
    (f) => {
      l(f), e == null || e(f);
    },
    [e]
  ), u = me(() => r ? wV(r, t) : [], [r, t]);
  return r ? /* @__PURE__ */ g.createElement(Z.Toolbar, { sticky: !0, "aria-disabled": n }, /* @__PURE__ */ g.createElement(Z.ControlsGroup, { className: i(o.toolbarControls) }, /* @__PURE__ */ g.createElement(Uw, { handleActive: d, active: s, disabled: n }), !a && /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(
    Zt,
    {
      classNames: {
        wrapper: i(o.borderLeft, o.tableDropdownWrapper),
        targetElement: i(o.dropDown, o.textDropdown)
      },
      elementSize: ln.S,
      targetElementProps: {
        elementVariant: Q.SecondaryMainLine,
        leftSection: /* @__PURE__ */ g.createElement(RC, null),
        px: 10,
        disabled: n,
        classNames: { root: i({ [o.disabledControl]: n }) }
      },
      "data-testid": Dt("heading"),
      width: 103
    },
    /* @__PURE__ */ g.createElement(Zt.Items, null, bV.map((f) => /* @__PURE__ */ g.createElement(
      Zt.Item,
      {
        "data-testid": Dt(`heading-${f}`),
        key: f,
        onClick: () => c(f),
        "data-value": f,
        disabled: n
      },
      `${t.heading}${f}`
    )))
  ), /* @__PURE__ */ g.createElement(
    Z.Bold,
    {
      icon: OC,
      "data-testid": Dt("bold"),
      classNames: { control: i({ [o.disabledControl]: n }, o.borderLeft) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.Italic,
    {
      icon: DC,
      "data-testid": Dt("italic"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.Underline,
    {
      icon: AC,
      "data-testid": Dt("underline"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.Strikethrough,
    {
      icon: LC,
      "data-testid": Dt("strike"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.ClearFormatting,
    {
      icon: $C,
      "data-testid": Dt("clear"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.Highlight,
    {
      icon: PC,
      "data-testid": Dt("highlight"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.AlignLeft,
    {
      icon: _C,
      "data-testid": Dt("align-left"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.AlignCenter,
    {
      icon: BC,
      "data-testid": Dt("align-center"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.AlignJustify,
    {
      icon: VC,
      "data-testid": Dt("align-justify"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.AlignRight,
    {
      icon: FC,
      "data-testid": Dt("align-right"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.Blockquote,
    {
      icon: NC,
      "data-testid": Dt("quote"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.Link,
    {
      icon: zC,
      "data-testid": Dt("link"),
      classNames: { control: i(o.borderLeft, { [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.Hr,
    {
      interactive: !a && !n,
      icon: HC,
      "data-testid": Dt("hr"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.BulletList,
    {
      icon: jC,
      "data-testid": Dt("bullet-list"),
      classNames: { control: i({ [o.disabledControl]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Z.OrderedList,
    {
      icon: WC,
      "data-testid": Dt("order-list"),
      classNames: { control: i({ [o.disabledControl]: n, [o.borderRight]: n }) }
    }
  ), /* @__PURE__ */ g.createElement(
    Zt,
    {
      classNames: {
        wrapper: i(o.tableDropdownWrapper, o.borderLeft),
        targetElement: i(o.dropDown, o.tableDropdown)
      },
      elementSize: ln.S,
      targetElementProps: {
        elementVariant: Q.SecondaryMainLine,
        leftSection: /* @__PURE__ */ g.createElement(GC, null),
        disabled: n,
        px: 10,
        classNames: { root: i({ [o.disabledControl]: n }) }
      },
      "data-testid": Dt("table"),
      "data-interactive": !a,
      disabled: a,
      width: "fit-content"
    },
    /* @__PURE__ */ g.createElement(Zt.Items, null, u.map(({ onClick: f, name: h, disabled: p }, y) => /* @__PURE__ */ g.createElement(Zt.Item, { "data-testid": Dt(`table-${y}`), key: h, onClick: f, disabled: p }, h)))
  )))) : null;
}, xV = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, EV = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, kV = ir.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-color") || t.style.backgroundColor,
        renderHTML: (t) => t.color ? {
          "data-color": t.color,
          style: `background-color: ${t.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["mark", wt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setHighlight: (t) => ({ commands: e }) => e.setMark(this.name, t),
      toggleHighlight: (t) => ({ commands: e }) => e.toggleMark(this.name, t),
      unsetHighlight: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      Go({
        find: xV,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      wo({
        find: EV,
        type: this.type
      })
    ];
  }
}), TV = en.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new Ft({
        key: new tn("placeholder"),
        props: {
          decorations: ({ doc: t, selection: e }) => {
            const n = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: r } = e, o = [];
            if (!n)
              return null;
            const i = this.editor.isEmpty;
            return t.descendants((s, l) => {
              const a = r >= l && r <= l + s.nodeSize, c = !s.isLeaf && Lc(s);
              if ((a || !this.options.showOnlyCurrent) && c) {
                const d = [this.options.emptyNodeClass];
                i && d.push(this.options.emptyEditorClass);
                const u = sn.node(l, l + s.nodeSize, {
                  class: d.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: s,
                    pos: l,
                    hasAnchor: a
                  }) : this.options.placeholder
                });
                o.push(u);
              }
              return this.options.includeChildren;
            }), bt.create(t, o);
          }
        }
      })
    ];
  }
});
var Hu, ju;
if (typeof WeakMap < "u") {
  let t = /* @__PURE__ */ new WeakMap();
  Hu = (e) => t.get(e), ju = (e, n) => (t.set(e, n), n);
} else {
  const t = [];
  let n = 0;
  Hu = (r) => {
    for (let o = 0; o < t.length; o += 2)
      if (t[o] == r)
        return t[o + 1];
  }, ju = (r, o) => (n == 10 && (n = 0), t[n++] = r, t[n++] = o);
}
var Tt = class {
  constructor(t, e, n, r) {
    this.width = t, this.height = e, this.map = n, this.problems = r;
  }
  // Find the dimensions of the cell at the given position.
  findCell(t) {
    for (let e = 0; e < this.map.length; e++) {
      const n = this.map[e];
      if (n != t)
        continue;
      const r = e % this.width, o = e / this.width | 0;
      let i = r + 1, s = o + 1;
      for (let l = 1; i < this.width && this.map[e + l] == n; l++)
        i++;
      for (let l = 1; s < this.height && this.map[e + this.width * l] == n; l++)
        s++;
      return { left: r, top: o, right: i, bottom: s };
    }
    throw new RangeError(`No cell with offset ${t} found`);
  }
  // Find the left side of the cell at the given position.
  colCount(t) {
    for (let e = 0; e < this.map.length; e++)
      if (this.map[e] == t)
        return e % this.width;
    throw new RangeError(`No cell with offset ${t} found`);
  }
  // Find the next cell in the given direction, starting from the cell
  // at `pos`, if any.
  nextCell(t, e, n) {
    const { left: r, right: o, top: i, bottom: s } = this.findCell(t);
    return e == "horiz" ? (n < 0 ? r == 0 : o == this.width) ? null : this.map[i * this.width + (n < 0 ? r - 1 : o)] : (n < 0 ? i == 0 : s == this.height) ? null : this.map[r + this.width * (n < 0 ? i - 1 : s)];
  }
  // Get the rectangle spanning the two given cells.
  rectBetween(t, e) {
    const {
      left: n,
      right: r,
      top: o,
      bottom: i
    } = this.findCell(t), {
      left: s,
      right: l,
      top: a,
      bottom: c
    } = this.findCell(e);
    return {
      left: Math.min(n, s),
      top: Math.min(o, a),
      right: Math.max(r, l),
      bottom: Math.max(i, c)
    };
  }
  // Return the position of all cells that have the top left corner in
  // the given rectangle.
  cellsInRect(t) {
    const e = [], n = {};
    for (let r = t.top; r < t.bottom; r++)
      for (let o = t.left; o < t.right; o++) {
        const i = r * this.width + o, s = this.map[i];
        n[s] || (n[s] = !0, !(o == t.left && o && this.map[i - 1] == s || r == t.top && r && this.map[i - this.width] == s) && e.push(s));
      }
    return e;
  }
  // Return the position at which the cell at the given row and column
  // starts, or would start, if a cell started there.
  positionAt(t, e, n) {
    for (let r = 0, o = 0; ; r++) {
      const i = o + n.child(r).nodeSize;
      if (r == t) {
        let s = e + t * this.width;
        const l = (t + 1) * this.width;
        for (; s < l && this.map[s] < o; )
          s++;
        return s == l ? i - 1 : this.map[s];
      }
      o = i;
    }
  }
  // Find the table map for the given table node.
  static get(t) {
    return Hu(t) || ju(t, IV(t));
  }
};
function IV(t) {
  if (t.type.spec.tableRole != "table")
    throw new RangeError("Not a table node: " + t.type.name);
  const e = MV(t), n = t.childCount, r = [];
  let o = 0, i = null;
  const s = [];
  for (let c = 0, d = e * n; c < d; c++)
    r[c] = 0;
  for (let c = 0, d = 0; c < n; c++) {
    const u = t.child(c);
    d++;
    for (let p = 0; ; p++) {
      for (; o < r.length && r[o] != 0; )
        o++;
      if (p == u.childCount)
        break;
      const y = u.child(p), { colspan: b, rowspan: w, colwidth: S } = y.attrs;
      for (let x = 0; x < w; x++) {
        if (x + c >= n) {
          (i || (i = [])).push({
            type: "overlong_rowspan",
            pos: d,
            n: w - x
          });
          break;
        }
        const E = o + x * e;
        for (let v = 0; v < b; v++) {
          r[E + v] == 0 ? r[E + v] = d : (i || (i = [])).push({
            type: "collision",
            row: c,
            pos: d,
            n: b - v
          });
          const T = S && S[v];
          if (T) {
            const I = (E + v) % e * 2, M = s[I];
            M == null || M != T && s[I + 1] == 1 ? (s[I] = T, s[I + 1] = 1) : M == T && s[I + 1]++;
          }
        }
      }
      o += b, d += y.nodeSize;
    }
    const f = (c + 1) * e;
    let h = 0;
    for (; o < f; )
      r[o++] == 0 && h++;
    h && (i || (i = [])).push({ type: "missing", row: c, n: h }), d++;
  }
  const l = new Tt(e, n, r, i);
  let a = !1;
  for (let c = 0; !a && c < s.length; c += 2)
    s[c] != null && s[c + 1] < n && (a = !0);
  return a && RV(l, s, t), l;
}
function MV(t) {
  let e = -1, n = !1;
  for (let r = 0; r < t.childCount; r++) {
    const o = t.child(r);
    let i = 0;
    if (n)
      for (let s = 0; s < r; s++) {
        const l = t.child(s);
        for (let a = 0; a < l.childCount; a++) {
          const c = l.child(a);
          s + c.attrs.rowspan > r && (i += c.attrs.colspan);
        }
      }
    for (let s = 0; s < o.childCount; s++) {
      const l = o.child(s);
      i += l.attrs.colspan, l.attrs.rowspan > 1 && (n = !0);
    }
    e == -1 ? e = i : e != i && (e = Math.max(e, i));
  }
  return e;
}
function RV(t, e, n) {
  t.problems || (t.problems = []);
  const r = {};
  for (let o = 0; o < t.map.length; o++) {
    const i = t.map[o];
    if (r[i])
      continue;
    r[i] = !0;
    const s = n.nodeAt(i);
    if (!s)
      throw new RangeError(`No cell with offset ${i} found`);
    let l = null;
    const a = s.attrs;
    for (let c = 0; c < a.colspan; c++) {
      const d = (o + c) % t.width, u = e[d * 2];
      u != null && (!a.colwidth || a.colwidth[c] != u) && ((l || (l = OV(a)))[c] = u);
    }
    l && t.problems.unshift({
      type: "colwidth mismatch",
      pos: i,
      colwidth: l
    });
  }
}
function OV(t) {
  if (t.colwidth)
    return t.colwidth.slice();
  const e = [];
  for (let n = 0; n < t.colspan; n++)
    e.push(0);
  return e;
}
function cn(t) {
  let e = t.cached.tableNodeTypes;
  if (!e) {
    e = t.cached.tableNodeTypes = {};
    for (const n in t.nodes) {
      const r = t.nodes[n], o = r.spec.tableRole;
      o && (e[o] = r);
    }
  }
  return e;
}
var ro = new tn("selectingCells");
function Ui(t) {
  for (let e = t.depth - 1; e > 0; e--)
    if (t.node(e).type.spec.tableRole == "row")
      return t.node(0).resolve(t.before(e + 1));
  return null;
}
function DV(t) {
  for (let e = t.depth; e > 0; e--) {
    const n = t.node(e).type.spec.tableRole;
    if (n === "cell" || n === "header_cell")
      return t.node(e);
  }
  return null;
}
function ar(t) {
  const e = t.selection.$head;
  for (let n = e.depth; n > 0; n--)
    if (e.node(n).type.spec.tableRole == "row")
      return !0;
  return !1;
}
function _c(t) {
  const e = t.selection;
  if ("$anchorCell" in e && e.$anchorCell)
    return e.$anchorCell.pos > e.$headCell.pos ? e.$anchorCell : e.$headCell;
  if ("node" in e && e.node && e.node.type.spec.tableRole == "cell")
    return e.$anchor;
  const n = Ui(e.$head) || AV(e.$head);
  if (n)
    return n;
  throw new RangeError(`No cell found around position ${e.head}`);
}
function AV(t) {
  for (let e = t.nodeAfter, n = t.pos; e; e = e.firstChild, n++) {
    const r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell")
      return t.doc.resolve(n);
  }
  for (let e = t.nodeBefore, n = t.pos; e; e = e.lastChild, n--) {
    const r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell")
      return t.doc.resolve(n - e.nodeSize);
  }
}
function Wu(t) {
  return t.parent.type.spec.tableRole == "row" && !!t.nodeAfter;
}
function LV(t) {
  return t.node(0).resolve(t.pos + t.nodeAfter.nodeSize);
}
function bh(t, e) {
  return t.depth == e.depth && t.pos >= e.start(-1) && t.pos <= e.end(-1);
}
function qw(t, e, n) {
  const r = t.node(-1), o = Tt.get(r), i = t.start(-1), s = o.nextCell(t.pos - i, e, n);
  return s == null ? null : t.node(0).resolve(i + s);
}
function Uo(t, e, n = 1) {
  const r = { ...t, colspan: t.colspan - n };
  return r.colwidth && (r.colwidth = r.colwidth.slice(), r.colwidth.splice(e, n), r.colwidth.some((o) => o > 0) || (r.colwidth = null)), r;
}
function Jw(t, e, n = 1) {
  const r = { ...t, colspan: t.colspan + n };
  if (r.colwidth) {
    r.colwidth = r.colwidth.slice();
    for (let o = 0; o < n; o++)
      r.colwidth.splice(e, 0, 0);
  }
  return r;
}
function $V(t, e, n) {
  const r = cn(e.type.schema).header_cell;
  for (let o = 0; o < t.height; o++)
    if (e.nodeAt(t.map[n + o * t.width]).type != r)
      return !1;
  return !0;
}
var lt = class Rr extends fe {
  // A table selection is identified by its anchor and head cells. The
  // positions given to this constructor should point _before_ two
  // cells in the same table. They may be the same, to select a single
  // cell.
  constructor(e, n = e) {
    const r = e.node(-1), o = Tt.get(r), i = e.start(-1), s = o.rectBetween(
      e.pos - i,
      n.pos - i
    ), l = e.node(0), a = o.cellsInRect(s).filter((d) => d != n.pos - i);
    a.unshift(n.pos - i);
    const c = a.map((d) => {
      const u = r.nodeAt(d);
      if (!u)
        throw RangeError(`No cell with offset ${d} found`);
      const f = i + d + 1;
      return new k1(
        l.resolve(f),
        l.resolve(f + u.content.size)
      );
    });
    super(c[0].$from, c[0].$to, c), this.$anchorCell = e, this.$headCell = n;
  }
  map(e, n) {
    const r = e.resolve(n.map(this.$anchorCell.pos)), o = e.resolve(n.map(this.$headCell.pos));
    if (Wu(r) && Wu(o) && bh(r, o)) {
      const i = this.$anchorCell.node(-1) != r.node(-1);
      return i && this.isRowSelection() ? Rr.rowSelection(r, o) : i && this.isColSelection() ? Rr.colSelection(r, o) : new Rr(r, o);
    }
    return ce.between(r, o);
  }
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  content() {
    const e = this.$anchorCell.node(-1), n = Tt.get(e), r = this.$anchorCell.start(-1), o = n.rectBetween(
      this.$anchorCell.pos - r,
      this.$headCell.pos - r
    ), i = {}, s = [];
    for (let a = o.top; a < o.bottom; a++) {
      const c = [];
      for (let d = a * n.width + o.left, u = o.left; u < o.right; u++, d++) {
        const f = n.map[d];
        if (i[f])
          continue;
        i[f] = !0;
        const h = n.findCell(f);
        let p = e.nodeAt(f);
        if (!p)
          throw RangeError(`No cell with offset ${f} found`);
        const y = o.left - h.left, b = h.right - o.right;
        if (y > 0 || b > 0) {
          let w = p.attrs;
          if (y > 0 && (w = Uo(w, 0, y)), b > 0 && (w = Uo(
            w,
            w.colspan - b,
            b
          )), h.left < o.left) {
            if (p = p.type.createAndFill(w), !p)
              throw RangeError(
                `Could not create cell with attrs ${JSON.stringify(w)}`
              );
          } else
            p = p.type.create(w, p.content);
        }
        if (h.top < o.top || h.bottom > o.bottom) {
          const w = {
            ...p.attrs,
            rowspan: Math.min(h.bottom, o.bottom) - Math.max(h.top, o.top)
          };
          h.top < o.top ? p = p.type.createAndFill(w) : p = p.type.create(w, p.content);
        }
        c.push(p);
      }
      s.push(e.child(a).copy(D.from(c)));
    }
    const l = this.isColSelection() && this.isRowSelection() ? e : s;
    return new N(D.from(l), 1, 1);
  }
  replace(e, n = N.empty) {
    const r = e.steps.length, o = this.ranges;
    for (let s = 0; s < o.length; s++) {
      const { $from: l, $to: a } = o[s], c = e.mapping.slice(r);
      e.replace(
        c.map(l.pos),
        c.map(a.pos),
        s ? N.empty : n
      );
    }
    const i = fe.findFrom(
      e.doc.resolve(e.mapping.slice(r).map(this.to)),
      -1
    );
    i && e.setSelection(i);
  }
  replaceWith(e, n) {
    this.replace(e, new N(D.from(n), 0, 0));
  }
  forEachCell(e) {
    const n = this.$anchorCell.node(-1), r = Tt.get(n), o = this.$anchorCell.start(-1), i = r.cellsInRect(
      r.rectBetween(
        this.$anchorCell.pos - o,
        this.$headCell.pos - o
      )
    );
    for (let s = 0; s < i.length; s++)
      e(n.nodeAt(i[s]), o + i[s]);
  }
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  isColSelection() {
    const e = this.$anchorCell.index(-1), n = this.$headCell.index(-1);
    if (Math.min(e, n) > 0)
      return !1;
    const r = e + this.$anchorCell.nodeAfter.attrs.rowspan, o = n + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(r, o) == this.$headCell.node(-1).childCount;
  }
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  static colSelection(e, n = e) {
    const r = e.node(-1), o = Tt.get(r), i = e.start(-1), s = o.findCell(e.pos - i), l = o.findCell(n.pos - i), a = e.node(0);
    return s.top <= l.top ? (s.top > 0 && (e = a.resolve(i + o.map[s.left])), l.bottom < o.height && (n = a.resolve(
      i + o.map[o.width * (o.height - 1) + l.right - 1]
    ))) : (l.top > 0 && (n = a.resolve(i + o.map[l.left])), s.bottom < o.height && (e = a.resolve(
      i + o.map[o.width * (o.height - 1) + s.right - 1]
    ))), new Rr(e, n);
  }
  // True if this selection goes all the way from the left to the
  // right of the table.
  isRowSelection() {
    const e = this.$anchorCell.node(-1), n = Tt.get(e), r = this.$anchorCell.start(-1), o = n.colCount(this.$anchorCell.pos - r), i = n.colCount(this.$headCell.pos - r);
    if (Math.min(o, i) > 0)
      return !1;
    const s = o + this.$anchorCell.nodeAfter.attrs.colspan, l = i + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(s, l) == n.width;
  }
  eq(e) {
    return e instanceof Rr && e.$anchorCell.pos == this.$anchorCell.pos && e.$headCell.pos == this.$headCell.pos;
  }
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  static rowSelection(e, n = e) {
    const r = e.node(-1), o = Tt.get(r), i = e.start(-1), s = o.findCell(e.pos - i), l = o.findCell(n.pos - i), a = e.node(0);
    return s.left <= l.left ? (s.left > 0 && (e = a.resolve(
      i + o.map[s.top * o.width]
    )), l.right < o.width && (n = a.resolve(
      i + o.map[o.width * (l.top + 1) - 1]
    ))) : (l.left > 0 && (n = a.resolve(i + o.map[l.top * o.width])), s.right < o.width && (e = a.resolve(
      i + o.map[o.width * (s.top + 1) - 1]
    ))), new Rr(e, n);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(e, n) {
    return new Rr(e.resolve(n.anchor), e.resolve(n.head));
  }
  static create(e, n, r = n) {
    return new Rr(e.resolve(n), e.resolve(r));
  }
  getBookmark() {
    return new PV(this.$anchorCell.pos, this.$headCell.pos);
  }
};
lt.prototype.visible = !1;
fe.jsonID("cell", lt);
var PV = class Kw {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new Kw(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    const n = e.resolve(this.anchor), r = e.resolve(this.head);
    return n.parent.type.spec.tableRole == "row" && r.parent.type.spec.tableRole == "row" && n.index() < n.parent.childCount && r.index() < r.parent.childCount && bh(n, r) ? new lt(n, r) : fe.near(r, 1);
  }
};
function _V(t) {
  if (!(t.selection instanceof lt))
    return null;
  const e = [];
  return t.selection.forEachCell((n, r) => {
    e.push(
      sn.node(r, r + n.nodeSize, { class: "selectedCell" })
    );
  }), bt.create(t.doc, e);
}
function BV({ $from: t, $to: e }) {
  if (t.pos == e.pos || t.pos < e.pos - 6)
    return !1;
  let n = t.pos, r = e.pos, o = t.depth;
  for (; o >= 0 && !(t.after(o + 1) < t.end(o)); o--, n++)
    ;
  for (let i = e.depth; i >= 0 && !(e.before(i + 1) > e.start(i)); i--, r--)
    ;
  return n == r && /row|table/.test(t.node(o).type.spec.tableRole);
}
function VV({ $from: t, $to: e }) {
  let n, r;
  for (let o = t.depth; o > 0; o--) {
    const i = t.node(o);
    if (i.type.spec.tableRole === "cell" || i.type.spec.tableRole === "header_cell") {
      n = i;
      break;
    }
  }
  for (let o = e.depth; o > 0; o--) {
    const i = e.node(o);
    if (i.type.spec.tableRole === "cell" || i.type.spec.tableRole === "header_cell") {
      r = i;
      break;
    }
  }
  return n !== r && e.parentOffset === 0;
}
function FV(t, e, n) {
  const r = (e || t).selection, o = (e || t).doc;
  let i, s;
  if (r instanceof le && (s = r.node.type.spec.tableRole)) {
    if (s == "cell" || s == "header_cell")
      i = lt.create(o, r.from);
    else if (s == "row") {
      const l = o.resolve(r.from + 1);
      i = lt.rowSelection(l, l);
    } else if (!n) {
      const l = Tt.get(r.node), a = r.from + 1, c = a + l.map[l.width * l.height - 1];
      i = lt.create(o, a + 1, c);
    }
  } else r instanceof ce && BV(r) ? i = ce.create(o, r.from) : r instanceof ce && VV(r) && (i = ce.create(o, r.$from.start(), r.$from.end()));
  return i && (e || (e = t.tr)).setSelection(i), e;
}
var NV = new tn("fix-tables");
function Yw(t, e, n, r) {
  const o = t.childCount, i = e.childCount;
  e:
    for (let s = 0, l = 0; s < i; s++) {
      const a = e.child(s);
      for (let c = l, d = Math.min(o, s + 3); c < d; c++)
        if (t.child(c) == a) {
          l = c + 1, n += a.nodeSize;
          continue e;
        }
      r(a, n), l < o && t.child(l).sameMarkup(a) ? Yw(t.child(l), a, n + 1, r) : a.nodesBetween(0, a.content.size, r, n + 1), n += a.nodeSize;
    }
}
function Zw(t, e) {
  let n;
  const r = (o, i) => {
    o.type.spec.tableRole == "table" && (n = zV(t, o, i, n));
  };
  return e ? e.doc != t.doc && Yw(e.doc, t.doc, 0, r) : t.doc.descendants(r), n;
}
function zV(t, e, n, r) {
  const o = Tt.get(e);
  if (!o.problems)
    return r;
  r || (r = t.tr);
  const i = [];
  for (let a = 0; a < o.height; a++)
    i.push(0);
  for (let a = 0; a < o.problems.length; a++) {
    const c = o.problems[a];
    if (c.type == "collision") {
      const d = e.nodeAt(c.pos);
      if (!d)
        continue;
      const u = d.attrs;
      for (let f = 0; f < u.rowspan; f++)
        i[c.row + f] += c.n;
      r.setNodeMarkup(
        r.mapping.map(n + 1 + c.pos),
        null,
        Uo(u, u.colspan - c.n, c.n)
      );
    } else if (c.type == "missing")
      i[c.row] += c.n;
    else if (c.type == "overlong_rowspan") {
      const d = e.nodeAt(c.pos);
      if (!d)
        continue;
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, {
        ...d.attrs,
        rowspan: d.attrs.rowspan - c.n
      });
    } else if (c.type == "colwidth mismatch") {
      const d = e.nodeAt(c.pos);
      if (!d)
        continue;
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, {
        ...d.attrs,
        colwidth: c.colwidth
      });
    }
  }
  let s, l;
  for (let a = 0; a < i.length; a++)
    i[a] && (s == null && (s = a), l = a);
  for (let a = 0, c = n + 1; a < o.height; a++) {
    const d = e.child(a), u = c + d.nodeSize, f = i[a];
    if (f > 0) {
      let h = "cell";
      d.firstChild && (h = d.firstChild.type.spec.tableRole);
      const p = [];
      for (let b = 0; b < f; b++) {
        const w = cn(t.schema)[h].createAndFill();
        w && p.push(w);
      }
      const y = (a == 0 || s == a - 1) && l == a ? c + 1 : u - 1;
      r.insert(r.mapping.map(y), p);
    }
    c = u;
  }
  return r.setMeta(NV, { fixTables: !0 });
}
function vr(t) {
  const e = t.selection, n = _c(t), r = n.node(-1), o = n.start(-1), i = Tt.get(r);
  return { ...e instanceof lt ? i.rectBetween(
    e.$anchorCell.pos - o,
    e.$headCell.pos - o
  ) : i.findCell(n.pos - o), tableStart: o, map: i, table: r };
}
function Xw(t, { map: e, tableStart: n, table: r }, o) {
  let i = o > 0 ? -1 : 0;
  $V(e, r, o + i) && (i = o == 0 || o == e.width ? null : 0);
  for (let s = 0; s < e.height; s++) {
    const l = s * e.width + o;
    if (o > 0 && o < e.width && e.map[l - 1] == e.map[l]) {
      const a = e.map[l], c = r.nodeAt(a);
      t.setNodeMarkup(
        t.mapping.map(n + a),
        null,
        Jw(c.attrs, o - e.colCount(a))
      ), s += c.attrs.rowspan - 1;
    } else {
      const a = i == null ? cn(r.type.schema).cell : r.nodeAt(e.map[l + i]).type, c = e.positionAt(s, o, r);
      t.insert(t.mapping.map(n + c), a.createAndFill());
    }
  }
  return t;
}
function HV(t, e) {
  if (!ar(t))
    return !1;
  if (e) {
    const n = vr(t);
    e(Xw(t.tr, n, n.left));
  }
  return !0;
}
function jV(t, e) {
  if (!ar(t))
    return !1;
  if (e) {
    const n = vr(t);
    e(Xw(t.tr, n, n.right));
  }
  return !0;
}
function WV(t, { map: e, table: n, tableStart: r }, o) {
  const i = t.mapping.maps.length;
  for (let s = 0; s < e.height; ) {
    const l = s * e.width + o, a = e.map[l], c = n.nodeAt(a), d = c.attrs;
    if (o > 0 && e.map[l - 1] == a || o < e.width - 1 && e.map[l + 1] == a)
      t.setNodeMarkup(
        t.mapping.slice(i).map(r + a),
        null,
        Uo(d, o - e.colCount(a))
      );
    else {
      const u = t.mapping.slice(i).map(r + a);
      t.delete(u, u + c.nodeSize);
    }
    s += d.rowspan;
  }
}
function GV(t, e) {
  if (!ar(t))
    return !1;
  if (e) {
    const n = vr(t), r = t.tr;
    if (n.left == 0 && n.right == n.map.width)
      return !1;
    for (let o = n.right - 1; WV(r, n, o), o != n.left; o--) {
      const i = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc;
      if (!i)
        throw RangeError("No table found");
      n.table = i, n.map = Tt.get(i);
    }
    e(r);
  }
  return !0;
}
function UV(t, e, n) {
  var r;
  const o = cn(e.type.schema).header_cell;
  for (let i = 0; i < t.width; i++)
    if (((r = e.nodeAt(t.map[i + n * t.width])) == null ? void 0 : r.type) != o)
      return !1;
  return !0;
}
function Qw(t, { map: e, tableStart: n, table: r }, o) {
  var i;
  let s = n;
  for (let c = 0; c < o; c++)
    s += r.child(c).nodeSize;
  const l = [];
  let a = o > 0 ? -1 : 0;
  UV(e, r, o + a) && (a = o == 0 || o == e.height ? null : 0);
  for (let c = 0, d = e.width * o; c < e.width; c++, d++)
    if (o > 0 && o < e.height && e.map[d] == e.map[d - e.width]) {
      const u = e.map[d], f = r.nodeAt(u).attrs;
      t.setNodeMarkup(n + u, null, {
        ...f,
        rowspan: f.rowspan + 1
      }), c += f.colspan - 1;
    } else {
      const u = a == null ? cn(r.type.schema).cell : (i = r.nodeAt(e.map[d + a * e.width])) == null ? void 0 : i.type, f = u == null ? void 0 : u.createAndFill();
      f && l.push(f);
    }
  return t.insert(s, cn(r.type.schema).row.create(null, l)), t;
}
function qV(t, e) {
  if (!ar(t))
    return !1;
  if (e) {
    const n = vr(t);
    e(Qw(t.tr, n, n.top));
  }
  return !0;
}
function JV(t, e) {
  if (!ar(t))
    return !1;
  if (e) {
    const n = vr(t);
    e(Qw(t.tr, n, n.bottom));
  }
  return !0;
}
function KV(t, { map: e, table: n, tableStart: r }, o) {
  let i = 0;
  for (let c = 0; c < o; c++)
    i += n.child(c).nodeSize;
  const s = i + n.child(o).nodeSize, l = t.mapping.maps.length;
  t.delete(i + r, s + r);
  const a = /* @__PURE__ */ new Set();
  for (let c = 0, d = o * e.width; c < e.width; c++, d++) {
    const u = e.map[d];
    if (!a.has(u)) {
      if (a.add(u), o > 0 && u == e.map[d - e.width]) {
        const f = n.nodeAt(u).attrs;
        t.setNodeMarkup(t.mapping.slice(l).map(u + r), null, {
          ...f,
          rowspan: f.rowspan - 1
        }), c += f.colspan - 1;
      } else if (o < e.height && u == e.map[d + e.width]) {
        const f = n.nodeAt(u), h = f.attrs, p = f.type.create(
          { ...h, rowspan: f.attrs.rowspan - 1 },
          f.content
        ), y = e.positionAt(o + 1, c, n);
        t.insert(t.mapping.slice(l).map(r + y), p), c += h.colspan - 1;
      }
    }
  }
}
function YV(t, e) {
  if (!ar(t))
    return !1;
  if (e) {
    const n = vr(t), r = t.tr;
    if (n.top == 0 && n.bottom == n.map.height)
      return !1;
    for (let o = n.bottom - 1; KV(r, n, o), o != n.top; o--) {
      const i = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc;
      if (!i)
        throw RangeError("No table found");
      n.table = i, n.map = Tt.get(n.table);
    }
    e(r);
  }
  return !0;
}
function dm(t) {
  const e = t.content;
  return e.childCount == 1 && e.child(0).isTextblock && e.child(0).childCount == 0;
}
function ZV({ width: t, height: e, map: n }, r) {
  let o = r.top * t + r.left, i = o, s = (r.bottom - 1) * t + r.left, l = o + (r.right - r.left - 1);
  for (let a = r.top; a < r.bottom; a++) {
    if (r.left > 0 && n[i] == n[i - 1] || r.right < t && n[l] == n[l + 1])
      return !0;
    i += t, l += t;
  }
  for (let a = r.left; a < r.right; a++) {
    if (r.top > 0 && n[o] == n[o - t] || r.bottom < e && n[s] == n[s + t])
      return !0;
    o++, s++;
  }
  return !1;
}
function um(t, e) {
  const n = t.selection;
  if (!(n instanceof lt) || n.$anchorCell.pos == n.$headCell.pos)
    return !1;
  const r = vr(t), { map: o } = r;
  if (ZV(o, r))
    return !1;
  if (e) {
    const i = t.tr, s = {};
    let l = D.empty, a, c;
    for (let d = r.top; d < r.bottom; d++)
      for (let u = r.left; u < r.right; u++) {
        const f = o.map[d * o.width + u], h = r.table.nodeAt(f);
        if (!(s[f] || !h))
          if (s[f] = !0, a == null)
            a = f, c = h;
          else {
            dm(h) || (l = l.append(h.content));
            const p = i.mapping.map(f + r.tableStart);
            i.delete(p, p + h.nodeSize);
          }
      }
    if (a == null || c == null)
      return !0;
    if (i.setNodeMarkup(a + r.tableStart, null, {
      ...Jw(
        c.attrs,
        c.attrs.colspan,
        r.right - r.left - c.attrs.colspan
      ),
      rowspan: r.bottom - r.top
    }), l.size) {
      const d = a + 1 + c.content.size, u = dm(c) ? a + 1 : d;
      i.replaceWith(u + r.tableStart, d + r.tableStart, l);
    }
    i.setSelection(
      new lt(i.doc.resolve(a + r.tableStart))
    ), e(i);
  }
  return !0;
}
function fm(t, e) {
  const n = cn(t.schema);
  return XV(({ node: r }) => n[r.type.spec.tableRole])(t, e);
}
function XV(t) {
  return (e, n) => {
    var r;
    const o = e.selection;
    let i, s;
    if (o instanceof lt) {
      if (o.$anchorCell.pos != o.$headCell.pos)
        return !1;
      i = o.$anchorCell.nodeAfter, s = o.$anchorCell.pos;
    } else {
      if (i = DV(o.$from), !i)
        return !1;
      s = (r = Ui(o.$from)) == null ? void 0 : r.pos;
    }
    if (i == null || s == null || i.attrs.colspan == 1 && i.attrs.rowspan == 1)
      return !1;
    if (n) {
      let l = i.attrs;
      const a = [], c = l.colwidth;
      l.rowspan > 1 && (l = { ...l, rowspan: 1 }), l.colspan > 1 && (l = { ...l, colspan: 1 });
      const d = vr(e), u = e.tr;
      for (let h = 0; h < d.right - d.left; h++)
        a.push(
          c ? {
            ...l,
            colwidth: c && c[h] ? [c[h]] : null
          } : l
        );
      let f;
      for (let h = d.top; h < d.bottom; h++) {
        let p = d.map.positionAt(h, d.left, d.table);
        h == d.top && (p += i.nodeSize);
        for (let y = d.left, b = 0; y < d.right; y++, b++)
          y == d.left && h == d.top || u.insert(
            f = u.mapping.map(p + d.tableStart, 1),
            t({ node: i, row: h, col: y }).createAndFill(a[b])
          );
      }
      u.setNodeMarkup(
        s,
        t({ node: i, row: d.top, col: d.left }),
        a[0]
      ), o instanceof lt && u.setSelection(
        new lt(
          u.doc.resolve(o.$anchorCell.pos),
          f ? u.doc.resolve(f) : void 0
        )
      ), n(u);
    }
    return !0;
  };
}
function QV(t, e) {
  return function(n, r) {
    if (!ar(n))
      return !1;
    const o = _c(n);
    if (o.nodeAfter.attrs[t] === e)
      return !1;
    if (r) {
      const i = n.tr;
      n.selection instanceof lt ? n.selection.forEachCell((s, l) => {
        s.attrs[t] !== e && i.setNodeMarkup(l, null, {
          ...s.attrs,
          [t]: e
        });
      }) : i.setNodeMarkup(o.pos, null, {
        ...o.nodeAfter.attrs,
        [t]: e
      }), r(i);
    }
    return !0;
  };
}
function eF(t) {
  return function(e, n) {
    if (!ar(e))
      return !1;
    if (n) {
      const r = cn(e.schema), o = vr(e), i = e.tr, s = o.map.cellsInRect(
        t == "column" ? {
          left: o.left,
          top: 0,
          right: o.right,
          bottom: o.map.height
        } : t == "row" ? {
          left: 0,
          top: o.top,
          right: o.map.width,
          bottom: o.bottom
        } : o
      ), l = s.map((a) => o.table.nodeAt(a));
      for (let a = 0; a < s.length; a++)
        l[a].type == r.header_cell && i.setNodeMarkup(
          o.tableStart + s[a],
          r.cell,
          l[a].attrs
        );
      if (i.steps.length == 0)
        for (let a = 0; a < s.length; a++)
          i.setNodeMarkup(
            o.tableStart + s[a],
            r.header_cell,
            l[a].attrs
          );
      n(i);
    }
    return !0;
  };
}
function hm(t, e, n) {
  const r = e.map.cellsInRect({
    left: 0,
    top: 0,
    right: t == "row" ? e.map.width : 1,
    bottom: t == "column" ? e.map.height : 1
  });
  for (let o = 0; o < r.length; o++) {
    const i = e.table.nodeAt(r[o]);
    if (i && i.type !== n.header_cell)
      return !1;
  }
  return !0;
}
function Ys(t, e) {
  return e = e || { useDeprecatedLogic: !1 }, e.useDeprecatedLogic ? eF(t) : function(n, r) {
    if (!ar(n))
      return !1;
    if (r) {
      const o = cn(n.schema), i = vr(n), s = n.tr, l = hm("row", i, o), a = hm(
        "column",
        i,
        o
      ), d = (t === "column" ? l : t === "row" ? a : !1) ? 1 : 0, u = t == "column" ? {
        left: 0,
        top: d,
        right: 1,
        bottom: i.map.height
      } : t == "row" ? {
        left: d,
        top: 0,
        right: i.map.width,
        bottom: 1
      } : i, f = t == "column" ? a ? o.cell : o.header_cell : t == "row" ? l ? o.cell : o.header_cell : o.cell;
      i.map.cellsInRect(u).forEach((h) => {
        const p = h + i.tableStart, y = s.doc.nodeAt(p);
        y && s.setNodeMarkup(p, f, y.attrs);
      }), r(s);
    }
    return !0;
  };
}
Ys("row", {
  useDeprecatedLogic: !0
});
Ys("column", {
  useDeprecatedLogic: !0
});
var tF = Ys("cell", {
  useDeprecatedLogic: !0
});
function nF(t, e) {
  if (e < 0) {
    const n = t.nodeBefore;
    if (n)
      return t.pos - n.nodeSize;
    for (let r = t.index(-1) - 1, o = t.before(); r >= 0; r--) {
      const i = t.node(-1).child(r), s = i.lastChild;
      if (s)
        return o - 1 - s.nodeSize;
      o -= i.nodeSize;
    }
  } else {
    if (t.index() < t.parent.childCount - 1)
      return t.pos + t.nodeAfter.nodeSize;
    const n = t.node(-1);
    for (let r = t.indexAfter(-1), o = t.after(); r < n.childCount; r++) {
      const i = n.child(r);
      if (i.childCount)
        return o + 1;
      o += i.nodeSize;
    }
  }
  return null;
}
function pm(t) {
  return function(e, n) {
    if (!ar(e))
      return !1;
    const r = nF(_c(e), t);
    if (r == null)
      return !1;
    if (n) {
      const o = e.doc.resolve(r);
      n(
        e.tr.setSelection(ce.between(o, LV(o))).scrollIntoView()
      );
    }
    return !0;
  };
}
function rF(t, e) {
  const n = t.selection.$anchor;
  for (let r = n.depth; r > 0; r--)
    if (n.node(r).type.spec.tableRole == "table")
      return e && e(
        t.tr.delete(n.before(r), n.after(r)).scrollIntoView()
      ), !0;
  return !1;
}
function Al(t, e) {
  const n = t.selection;
  if (!(n instanceof lt))
    return !1;
  if (e) {
    const r = t.tr, o = cn(t.schema).cell.createAndFill().content;
    n.forEachCell((i, s) => {
      i.content.eq(o) || r.replace(
        r.mapping.map(s + 1),
        r.mapping.map(s + i.nodeSize - 1),
        new N(o, 0, 0)
      );
    }), r.docChanged && e(r);
  }
  return !0;
}
function oF(t) {
  if (!t.size)
    return null;
  let { content: e, openStart: n, openEnd: r } = t;
  for (; e.childCount == 1 && (n > 0 && r > 0 || e.child(0).type.spec.tableRole == "table"); )
    n--, r--, e = e.child(0).content;
  const o = e.child(0), i = o.type.spec.tableRole, s = o.type.schema, l = [];
  if (i == "row")
    for (let a = 0; a < e.childCount; a++) {
      let c = e.child(a).content;
      const d = a ? 0 : Math.max(0, n - 1), u = a < e.childCount - 1 ? 0 : Math.max(0, r - 1);
      (d || u) && (c = Gu(
        cn(s).row,
        new N(c, d, u)
      ).content), l.push(c);
    }
  else if (i == "cell" || i == "header_cell")
    l.push(
      n || r ? Gu(
        cn(s).row,
        new N(e, n, r)
      ).content : e
    );
  else
    return null;
  return iF(s, l);
}
function iF(t, e) {
  const n = [];
  for (let o = 0; o < e.length; o++) {
    const i = e[o];
    for (let s = i.childCount - 1; s >= 0; s--) {
      const { rowspan: l, colspan: a } = i.child(s).attrs;
      for (let c = o; c < o + l; c++)
        n[c] = (n[c] || 0) + a;
    }
  }
  let r = 0;
  for (let o = 0; o < n.length; o++)
    r = Math.max(r, n[o]);
  for (let o = 0; o < n.length; o++)
    if (o >= e.length && e.push(D.empty), n[o] < r) {
      const i = cn(t).cell.createAndFill(), s = [];
      for (let l = n[o]; l < r; l++)
        s.push(i);
      e[o] = e[o].append(D.from(s));
    }
  return { height: e.length, width: r, rows: e };
}
function Gu(t, e) {
  const n = t.createAndFill();
  return new _f(n).replace(0, n.content.size, e).doc;
}
function sF({ width: t, height: e, rows: n }, r, o) {
  if (t != r) {
    const i = [], s = [];
    for (let l = 0; l < n.length; l++) {
      const a = n[l], c = [];
      for (let d = i[l] || 0, u = 0; d < r; u++) {
        let f = a.child(u % a.childCount);
        d + f.attrs.colspan > r && (f = f.type.createChecked(
          Uo(
            f.attrs,
            f.attrs.colspan,
            d + f.attrs.colspan - r
          ),
          f.content
        )), c.push(f), d += f.attrs.colspan;
        for (let h = 1; h < f.attrs.rowspan; h++)
          i[l + h] = (i[l + h] || 0) + f.attrs.colspan;
      }
      s.push(D.from(c));
    }
    n = s, t = r;
  }
  if (e != o) {
    const i = [];
    for (let s = 0, l = 0; s < o; s++, l++) {
      const a = [], c = n[l % e];
      for (let d = 0; d < c.childCount; d++) {
        let u = c.child(d);
        s + u.attrs.rowspan > o && (u = u.type.create(
          {
            ...u.attrs,
            rowspan: Math.max(1, o - u.attrs.rowspan)
          },
          u.content
        )), a.push(u);
      }
      i.push(D.from(a));
    }
    n = i, e = o;
  }
  return { width: t, height: e, rows: n };
}
function lF(t, e, n, r, o, i, s) {
  const l = t.doc.type.schema, a = cn(l);
  let c, d;
  if (o > e.width)
    for (let u = 0, f = 0; u < e.height; u++) {
      const h = n.child(u);
      f += h.nodeSize;
      const p = [];
      let y;
      h.lastChild == null || h.lastChild.type == a.cell ? y = c || (c = a.cell.createAndFill()) : y = d || (d = a.header_cell.createAndFill());
      for (let b = e.width; b < o; b++)
        p.push(y);
      t.insert(t.mapping.slice(s).map(f - 1 + r), p);
    }
  if (i > e.height) {
    const u = [];
    for (let p = 0, y = (e.height - 1) * e.width; p < Math.max(e.width, o); p++) {
      const b = p >= e.width ? !1 : n.nodeAt(e.map[y + p]).type == a.header_cell;
      u.push(
        b ? d || (d = a.header_cell.createAndFill()) : c || (c = a.cell.createAndFill())
      );
    }
    const f = a.row.create(null, D.from(u)), h = [];
    for (let p = e.height; p < i; p++)
      h.push(f);
    t.insert(t.mapping.slice(s).map(r + n.nodeSize - 2), h);
  }
  return !!(c || d);
}
function gm(t, e, n, r, o, i, s, l) {
  if (s == 0 || s == e.height)
    return !1;
  let a = !1;
  for (let c = o; c < i; c++) {
    const d = s * e.width + c, u = e.map[d];
    if (e.map[d - e.width] == u) {
      a = !0;
      const f = n.nodeAt(u), { top: h, left: p } = e.findCell(u);
      t.setNodeMarkup(t.mapping.slice(l).map(u + r), null, {
        ...f.attrs,
        rowspan: s - h
      }), t.insert(
        t.mapping.slice(l).map(e.positionAt(s, p, n)),
        f.type.createAndFill({
          ...f.attrs,
          rowspan: h + f.attrs.rowspan - s
        })
      ), c += f.attrs.colspan - 1;
    }
  }
  return a;
}
function mm(t, e, n, r, o, i, s, l) {
  if (s == 0 || s == e.width)
    return !1;
  let a = !1;
  for (let c = o; c < i; c++) {
    const d = c * e.width + s, u = e.map[d];
    if (e.map[d - 1] == u) {
      a = !0;
      const f = n.nodeAt(u), h = e.colCount(u), p = t.mapping.slice(l).map(u + r);
      t.setNodeMarkup(
        p,
        null,
        Uo(
          f.attrs,
          s - h,
          f.attrs.colspan - (s - h)
        )
      ), t.insert(
        p + f.nodeSize,
        f.type.createAndFill(
          Uo(f.attrs, 0, s - h)
        )
      ), c += f.attrs.rowspan - 1;
    }
  }
  return a;
}
function ym(t, e, n, r, o) {
  let i = n ? t.doc.nodeAt(n - 1) : t.doc;
  if (!i)
    throw new Error("No table found");
  let s = Tt.get(i);
  const { top: l, left: a } = r, c = a + o.width, d = l + o.height, u = t.tr;
  let f = 0;
  function h() {
    if (i = n ? u.doc.nodeAt(n - 1) : u.doc, !i)
      throw new Error("No table found");
    s = Tt.get(i), f = u.mapping.maps.length;
  }
  lF(u, s, i, n, c, d, f) && h(), gm(u, s, i, n, a, c, l, f) && h(), gm(u, s, i, n, a, c, d, f) && h(), mm(u, s, i, n, l, d, a, f) && h(), mm(u, s, i, n, l, d, c, f) && h();
  for (let p = l; p < d; p++) {
    const y = s.positionAt(p, a, i), b = s.positionAt(p, c, i);
    u.replace(
      u.mapping.slice(f).map(y + n),
      u.mapping.slice(f).map(b + n),
      new N(o.rows[p - l], 0, 0)
    );
  }
  h(), u.setSelection(
    new lt(
      u.doc.resolve(n + s.positionAt(l, a, i)),
      u.doc.resolve(n + s.positionAt(d - 1, c - 1, i))
    )
  ), e(u);
}
var aF = Uf({
  ArrowLeft: Ll("horiz", -1),
  ArrowRight: Ll("horiz", 1),
  ArrowUp: Ll("vert", -1),
  ArrowDown: Ll("vert", 1),
  "Shift-ArrowLeft": $l("horiz", -1),
  "Shift-ArrowRight": $l("horiz", 1),
  "Shift-ArrowUp": $l("vert", -1),
  "Shift-ArrowDown": $l("vert", 1),
  Backspace: Al,
  "Mod-Backspace": Al,
  Delete: Al,
  "Mod-Delete": Al
});
function ea(t, e, n) {
  return n.eq(t.selection) ? !1 : (e && e(t.tr.setSelection(n).scrollIntoView()), !0);
}
function Ll(t, e) {
  return (n, r, o) => {
    if (!o)
      return !1;
    const i = n.selection;
    if (i instanceof lt)
      return ea(
        n,
        r,
        fe.near(i.$headCell, e)
      );
    if (t != "horiz" && !i.empty)
      return !1;
    const s = eS(o, t, e);
    if (s == null)
      return !1;
    if (t == "horiz")
      return ea(
        n,
        r,
        fe.near(n.doc.resolve(i.head + e), e)
      );
    {
      const l = n.doc.resolve(s), a = qw(l, t, e);
      let c;
      return a ? c = fe.near(a, 1) : e < 0 ? c = fe.near(n.doc.resolve(l.before(-1)), -1) : c = fe.near(n.doc.resolve(l.after(-1)), 1), ea(n, r, c);
    }
  };
}
function $l(t, e) {
  return (n, r, o) => {
    if (!o)
      return !1;
    const i = n.selection;
    let s;
    if (i instanceof lt)
      s = i;
    else {
      const a = eS(o, t, e);
      if (a == null)
        return !1;
      s = new lt(n.doc.resolve(a));
    }
    const l = qw(s.$headCell, t, e);
    return l ? ea(
      n,
      r,
      new lt(s.$anchorCell, l)
    ) : !1;
  };
}
function cF(t, e) {
  const n = t.state.doc, r = Ui(n.resolve(e));
  return r ? (t.dispatch(t.state.tr.setSelection(new lt(r))), !0) : !1;
}
function dF(t, e, n) {
  if (!ar(t.state))
    return !1;
  let r = oF(n);
  const o = t.state.selection;
  if (o instanceof lt) {
    r || (r = {
      width: 1,
      height: 1,
      rows: [
        D.from(
          Gu(cn(t.state.schema).cell, n)
        )
      ]
    });
    const i = o.$anchorCell.node(-1), s = o.$anchorCell.start(-1), l = Tt.get(i).rectBetween(
      o.$anchorCell.pos - s,
      o.$headCell.pos - s
    );
    return r = sF(r, l.right - l.left, l.bottom - l.top), ym(t.state, t.dispatch, s, l, r), !0;
  } else if (r) {
    const i = _c(t.state), s = i.start(-1);
    return ym(
      t.state,
      t.dispatch,
      s,
      Tt.get(i.node(-1)).findCell(i.pos - s),
      r
    ), !0;
  } else
    return !1;
}
function uF(t, e) {
  var n;
  if (e.ctrlKey || e.metaKey)
    return;
  const r = bm(t, e.target);
  let o;
  if (e.shiftKey && t.state.selection instanceof lt)
    i(t.state.selection.$anchorCell, e), e.preventDefault();
  else if (e.shiftKey && r && (o = Ui(t.state.selection.$anchor)) != null && ((n = Dd(t, e)) == null ? void 0 : n.pos) != o.pos)
    i(o, e), e.preventDefault();
  else if (!r)
    return;
  function i(a, c) {
    let d = Dd(t, c);
    const u = ro.getState(t.state) == null;
    if (!d || !bh(a, d))
      if (u)
        d = a;
      else
        return;
    const f = new lt(a, d);
    if (u || !t.state.selection.eq(f)) {
      const h = t.state.tr.setSelection(f);
      u && h.setMeta(ro, a.pos), t.dispatch(h);
    }
  }
  function s() {
    t.root.removeEventListener("mouseup", s), t.root.removeEventListener("dragstart", s), t.root.removeEventListener("mousemove", l), ro.getState(t.state) != null && t.dispatch(t.state.tr.setMeta(ro, -1));
  }
  function l(a) {
    const c = a, d = ro.getState(t.state);
    let u;
    if (d != null)
      u = t.state.doc.resolve(d);
    else if (bm(t, c.target) != r && (u = Dd(t, e), !u))
      return s();
    u && i(u, c);
  }
  t.root.addEventListener("mouseup", s), t.root.addEventListener("dragstart", s), t.root.addEventListener("mousemove", l);
}
function eS(t, e, n) {
  if (!(t.state.selection instanceof ce))
    return null;
  const { $head: r } = t.state.selection;
  for (let o = r.depth - 1; o >= 0; o--) {
    const i = r.node(o);
    if ((n < 0 ? r.index(o) : r.indexAfter(o)) != (n < 0 ? 0 : i.childCount))
      return null;
    if (i.type.spec.tableRole == "cell" || i.type.spec.tableRole == "header_cell") {
      const l = r.before(o), a = e == "vert" ? n > 0 ? "down" : "up" : n > 0 ? "right" : "left";
      return t.endOfTextblock(a) ? l : null;
    }
  }
  return null;
}
function bm(t, e) {
  for (; e && e != t.dom; e = e.parentNode)
    if (e.nodeName == "TD" || e.nodeName == "TH")
      return e;
  return null;
}
function Dd(t, e) {
  const n = t.posAtCoords({
    left: e.clientX,
    top: e.clientY
  });
  return n && n ? Ui(t.state.doc.resolve(n.pos)) : null;
}
var fF = class {
  constructor(e, n) {
    this.node = e, this.defaultCellMinWidth = n, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.table.style.setProperty(
      "--default-cell-min-width",
      `${n}px`
    ), this.colgroup = this.table.appendChild(document.createElement("colgroup")), Uu(e, this.colgroup, this.table, n), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type != this.node.type ? !1 : (this.node = e, Uu(
      e,
      this.colgroup,
      this.table,
      this.defaultCellMinWidth
    ), !0);
  }
  ignoreMutation(e) {
    return e.type == "attributes" && (e.target == this.table || this.colgroup.contains(e.target));
  }
};
function Uu(t, e, n, r, o, i) {
  var s;
  let l = 0, a = !0, c = e.firstChild;
  const d = t.firstChild;
  if (d) {
    for (let u = 0, f = 0; u < d.childCount; u++) {
      const { colspan: h, colwidth: p } = d.child(u).attrs;
      for (let y = 0; y < h; y++, f++) {
        const b = o == f ? i : p && p[y], w = b ? b + "px" : "";
        if (l += b || r, b || (a = !1), c)
          c.style.width != w && (c.style.width = w), c = c.nextSibling;
        else {
          const S = document.createElement("col");
          S.style.width = w, e.appendChild(S);
        }
      }
    }
    for (; c; ) {
      const u = c.nextSibling;
      (s = c.parentNode) == null || s.removeChild(c), c = u;
    }
    a ? (n.style.width = l + "px", n.style.minWidth = "") : (n.style.width = "", n.style.minWidth = l + "px");
  }
}
var Tn = new tn(
  "tableColumnResizing"
);
function hF({
  handleWidth: t = 5,
  cellMinWidth: e = 25,
  defaultCellMinWidth: n = 100,
  View: r = fF,
  lastColumnResizable: o = !0
} = {}) {
  const i = new Ft({
    key: Tn,
    state: {
      init(s, l) {
        var a, c;
        const d = (c = (a = i.spec) == null ? void 0 : a.props) == null ? void 0 : c.nodeViews, u = cn(l.schema).table.name;
        return r && d && (d[u] = (f, h) => new r(f, n, h)), new pF(-1, !1);
      },
      apply(s, l) {
        return l.apply(s);
      }
    },
    props: {
      attributes: (s) => {
        const l = Tn.getState(s);
        return l && l.activeHandle > -1 ? { class: "resize-cursor" } : {};
      },
      handleDOMEvents: {
        mousemove: (s, l) => {
          gF(s, l, t, o);
        },
        mouseleave: (s) => {
          mF(s);
        },
        mousedown: (s, l) => {
          yF(s, l, e, n);
        }
      },
      decorations: (s) => {
        const l = Tn.getState(s);
        if (l && l.activeHandle > -1)
          return vF(s, l.activeHandle);
      },
      nodeViews: {}
    }
  });
  return i;
}
var pF = class ta {
  constructor(e, n) {
    this.activeHandle = e, this.dragging = n;
  }
  apply(e) {
    const n = this, r = e.getMeta(Tn);
    if (r && r.setHandle != null)
      return new ta(r.setHandle, !1);
    if (r && r.setDragging !== void 0)
      return new ta(n.activeHandle, r.setDragging);
    if (n.activeHandle > -1 && e.docChanged) {
      let o = e.mapping.map(n.activeHandle, -1);
      return Wu(e.doc.resolve(o)) || (o = -1), new ta(o, n.dragging);
    }
    return n;
  }
};
function gF(t, e, n, r) {
  const o = Tn.getState(t.state);
  if (o && !o.dragging) {
    const i = wF(e.target);
    let s = -1;
    if (i) {
      const { left: l, right: a } = i.getBoundingClientRect();
      e.clientX - l <= n ? s = wm(t, e, "left", n) : a - e.clientX <= n && (s = wm(t, e, "right", n));
    }
    if (s != o.activeHandle) {
      if (!r && s !== -1) {
        const l = t.state.doc.resolve(s), a = l.node(-1), c = Tt.get(a), d = l.start(-1);
        if (c.colCount(l.pos - d) + l.nodeAfter.attrs.colspan - 1 == c.width - 1)
          return;
      }
      tS(t, s);
    }
  }
}
function mF(t) {
  const e = Tn.getState(t.state);
  e && e.activeHandle > -1 && !e.dragging && tS(t, -1);
}
function yF(t, e, n, r) {
  var o;
  const i = (o = t.dom.ownerDocument.defaultView) != null ? o : window, s = Tn.getState(t.state);
  if (!s || s.activeHandle == -1 || s.dragging)
    return !1;
  const l = t.state.doc.nodeAt(s.activeHandle), a = bF(t, s.activeHandle, l.attrs);
  t.dispatch(
    t.state.tr.setMeta(Tn, {
      setDragging: { startX: e.clientX, startWidth: a }
    })
  );
  function c(u) {
    i.removeEventListener("mouseup", c), i.removeEventListener("mousemove", d);
    const f = Tn.getState(t.state);
    f != null && f.dragging && (SF(
      t,
      f.activeHandle,
      Sm(f.dragging, u, n)
    ), t.dispatch(
      t.state.tr.setMeta(Tn, { setDragging: null })
    ));
  }
  function d(u) {
    if (!u.which)
      return c(u);
    const f = Tn.getState(t.state);
    if (f && f.dragging) {
      const h = Sm(f.dragging, u, n);
      Cm(
        t,
        f.activeHandle,
        h,
        r
      );
    }
  }
  return Cm(
    t,
    s.activeHandle,
    a,
    r
  ), i.addEventListener("mouseup", c), i.addEventListener("mousemove", d), e.preventDefault(), !0;
}
function bF(t, e, { colspan: n, colwidth: r }) {
  const o = r && r[r.length - 1];
  if (o)
    return o;
  const i = t.domAtPos(e);
  let l = i.node.childNodes[i.offset].offsetWidth, a = n;
  if (r)
    for (let c = 0; c < n; c++)
      r[c] && (l -= r[c], a--);
  return l / a;
}
function wF(t) {
  for (; t && t.nodeName != "TD" && t.nodeName != "TH"; )
    t = t.classList && t.classList.contains("ProseMirror") ? null : t.parentNode;
  return t;
}
function wm(t, e, n, r) {
  const o = n == "right" ? -r : r, i = t.posAtCoords({
    left: e.clientX + o,
    top: e.clientY
  });
  if (!i)
    return -1;
  const { pos: s } = i, l = Ui(t.state.doc.resolve(s));
  if (!l)
    return -1;
  if (n == "right")
    return l.pos;
  const a = Tt.get(l.node(-1)), c = l.start(-1), d = a.map.indexOf(l.pos - c);
  return d % a.width == 0 ? -1 : c + a.map[d - 1];
}
function Sm(t, e, n) {
  const r = e.clientX - t.startX;
  return Math.max(n, t.startWidth + r);
}
function tS(t, e) {
  t.dispatch(
    t.state.tr.setMeta(Tn, { setHandle: e })
  );
}
function SF(t, e, n) {
  const r = t.state.doc.resolve(e), o = r.node(-1), i = Tt.get(o), s = r.start(-1), l = i.colCount(r.pos - s) + r.nodeAfter.attrs.colspan - 1, a = t.state.tr;
  for (let c = 0; c < i.height; c++) {
    const d = c * i.width + l;
    if (c && i.map[d] == i.map[d - i.width])
      continue;
    const u = i.map[d], f = o.nodeAt(u).attrs, h = f.colspan == 1 ? 0 : l - i.colCount(u);
    if (f.colwidth && f.colwidth[h] == n)
      continue;
    const p = f.colwidth ? f.colwidth.slice() : CF(f.colspan);
    p[h] = n, a.setNodeMarkup(s + u, null, { ...f, colwidth: p });
  }
  a.docChanged && t.dispatch(a);
}
function Cm(t, e, n, r) {
  const o = t.state.doc.resolve(e), i = o.node(-1), s = o.start(-1), l = Tt.get(i).colCount(o.pos - s) + o.nodeAfter.attrs.colspan - 1;
  let a = t.domAtPos(o.start(-1)).node;
  for (; a && a.nodeName != "TABLE"; )
    a = a.parentNode;
  a && Uu(
    i,
    a.firstChild,
    a,
    r,
    l,
    n
  );
}
function CF(t) {
  return Array(t).fill(0);
}
function vF(t, e) {
  var n;
  const r = [], o = t.doc.resolve(e), i = o.node(-1);
  if (!i)
    return bt.empty;
  const s = Tt.get(i), l = o.start(-1), a = s.colCount(o.pos - l) + o.nodeAfter.attrs.colspan - 1;
  for (let c = 0; c < s.height; c++) {
    const d = a + c * s.width;
    if ((a == s.width - 1 || s.map[d] != s.map[d + 1]) && (c == 0 || s.map[d] != s.map[d - s.width])) {
      const u = s.map[d], f = l + u + i.nodeAt(u).nodeSize - 1, h = document.createElement("div");
      h.className = "column-resize-handle", (n = Tn.getState(t)) != null && n.dragging && r.push(
        sn.node(
          l + u,
          l + u + i.nodeAt(u).nodeSize,
          {
            class: "column-resize-dragging"
          }
        )
      ), r.push(sn.widget(f, h));
    }
  }
  return bt.create(t.doc, r);
}
function xF({
  allowTableNodeSelection: t = !1
} = {}) {
  return new Ft({
    key: ro,
    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init() {
        return null;
      },
      apply(e, n) {
        const r = e.getMeta(ro);
        if (r != null)
          return r == -1 ? null : r;
        if (n == null || !e.docChanged)
          return n;
        const { deleted: o, pos: i } = e.mapping.mapResult(n);
        return o ? null : i;
      }
    },
    props: {
      decorations: _V,
      handleDOMEvents: {
        mousedown: uF
      },
      createSelectionBetween(e) {
        return ro.getState(e.state) != null ? e.state.selection : null;
      },
      handleTripleClick: cF,
      handleKeyDown: aF,
      handlePaste: dF
    },
    appendTransaction(e, n, r) {
      return FV(
        r,
        Zw(r, n),
        t
      );
    }
  });
}
function qu(t, e) {
  return e ? ["width", `${Math.max(e, t)}px`] : ["min-width", `${t}px`];
}
function vm(t, e, n, r, o, i) {
  var s;
  let l = 0, a = !0, c = e.firstChild;
  const d = t.firstChild;
  if (d !== null)
    for (let u = 0, f = 0; u < d.childCount; u += 1) {
      const { colspan: h, colwidth: p } = d.child(u).attrs;
      for (let y = 0; y < h; y += 1, f += 1) {
        const b = o === f ? i : p && p[y], w = b ? `${b}px` : "";
        if (l += b || r, b || (a = !1), c) {
          if (c.style.width !== w) {
            const [S, x] = qu(r, b);
            c.style.setProperty(S, x);
          }
          c = c.nextSibling;
        } else {
          const S = document.createElement("col"), [x, E] = qu(r, b);
          S.style.setProperty(x, E), e.appendChild(S);
        }
      }
    }
  for (; c; ) {
    const u = c.nextSibling;
    (s = c.parentNode) === null || s === void 0 || s.removeChild(c), c = u;
  }
  a ? (n.style.width = `${l}px`, n.style.minWidth = "") : (n.style.width = "", n.style.minWidth = `${l}px`);
}
class EF {
  constructor(e, n) {
    this.node = e, this.cellMinWidth = n, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.colgroup = this.table.appendChild(document.createElement("colgroup")), vm(e, this.colgroup, this.table, n), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type !== this.node.type ? !1 : (this.node = e, vm(e, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(e) {
    return e.type === "attributes" && (e.target === this.table || this.colgroup.contains(e.target));
  }
}
function kF(t, e, n, r) {
  let o = 0, i = !0;
  const s = [], l = t.firstChild;
  if (!l)
    return {};
  for (let u = 0, f = 0; u < l.childCount; u += 1) {
    const { colspan: h, colwidth: p } = l.child(u).attrs;
    for (let y = 0; y < h; y += 1, f += 1) {
      const b = n === f ? r : p && p[y];
      o += b || e, b || (i = !1);
      const [w, S] = qu(e, b);
      s.push([
        "col",
        { style: `${w}: ${S}` }
      ]);
    }
  }
  const a = i ? `${o}px` : "", c = i ? "" : `${o}px`;
  return { colgroup: ["colgroup", {}, ...s], tableWidth: a, tableMinWidth: c };
}
function xm(t, e) {
  return t.createAndFill();
}
function TF(t) {
  if (t.cached.tableNodeTypes)
    return t.cached.tableNodeTypes;
  const e = {};
  return Object.keys(t.nodes).forEach((n) => {
    const r = t.nodes[n];
    r.spec.tableRole && (e[r.spec.tableRole] = r);
  }), t.cached.tableNodeTypes = e, e;
}
function IF(t, e, n, r, o) {
  const i = TF(t), s = [], l = [];
  for (let c = 0; c < n; c += 1) {
    const d = xm(i.cell);
    if (d && l.push(d), r) {
      const u = xm(i.header_cell);
      u && s.push(u);
    }
  }
  const a = [];
  for (let c = 0; c < e; c += 1)
    a.push(i.row.createChecked(null, r && c === 0 ? s : l));
  return i.table.createChecked(null, a);
}
function MF(t) {
  return t instanceof lt;
}
const Pl = ({ editor: t }) => {
  const { selection: e } = t.state;
  if (!MF(e))
    return !1;
  let n = 0;
  const r = Ow(e.ranges[0].$from, (i) => i.type.name === "table");
  return r == null || r.node.descendants((i) => {
    if (i.type.name === "table")
      return !1;
    ["tableCell", "tableHeader"].includes(i.type.name) && (n += 1);
  }), n === e.ranges.length ? (t.commands.deleteTable(), !0) : !1;
}, RF = Gt.create({
  name: "table",
  // @ts-ignore
  addOptions() {
    return {
      HTMLAttributes: {},
      resizable: !1,
      handleWidth: 5,
      cellMinWidth: 25,
      // TODO: fix
      View: EF,
      lastColumnResizable: !0,
      allowTableNodeSelection: !1
    };
  },
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  group: "block",
  parseHTML() {
    return [{ tag: "table" }];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    const { colgroup: n, tableWidth: r, tableMinWidth: o } = kF(t, this.options.cellMinWidth);
    return [
      "table",
      wt(this.options.HTMLAttributes, e, {
        style: r ? `width: ${r}` : `min-width: ${o}`
      }),
      n,
      ["tbody", 0]
    ];
  },
  addCommands() {
    return {
      insertTable: ({ rows: t = 3, cols: e = 3, withHeaderRow: n = !0 } = {}) => ({ tr: r, dispatch: o, editor: i }) => {
        const s = IF(i.schema, t, e, n);
        if (o) {
          const l = r.selection.from + 1;
          r.replaceSelectionWith(s).scrollIntoView().setSelection(ce.near(r.doc.resolve(l)));
        }
        return !0;
      },
      addColumnBefore: () => ({ state: t, dispatch: e }) => HV(t, e),
      addColumnAfter: () => ({ state: t, dispatch: e }) => jV(t, e),
      deleteColumn: () => ({ state: t, dispatch: e }) => GV(t, e),
      addRowBefore: () => ({ state: t, dispatch: e }) => qV(t, e),
      addRowAfter: () => ({ state: t, dispatch: e }) => JV(t, e),
      deleteRow: () => ({ state: t, dispatch: e }) => YV(t, e),
      deleteTable: () => ({ state: t, dispatch: e }) => rF(t, e),
      mergeCells: () => ({ state: t, dispatch: e }) => um(t, e),
      splitCell: () => ({ state: t, dispatch: e }) => fm(t, e),
      toggleHeaderColumn: () => ({ state: t, dispatch: e }) => Ys("column")(t, e),
      toggleHeaderRow: () => ({ state: t, dispatch: e }) => Ys("row")(t, e),
      toggleHeaderCell: () => ({ state: t, dispatch: e }) => tF(t, e),
      mergeOrSplit: () => ({ state: t, dispatch: e }) => um(t, e) ? !0 : fm(t, e),
      setCellAttribute: (t, e) => ({ state: n, dispatch: r }) => QV(t, e)(n, r),
      goToNextCell: () => ({ state: t, dispatch: e }) => pm(1)(t, e),
      goToPreviousCell: () => ({ state: t, dispatch: e }) => pm(-1)(t, e),
      fixTables: () => ({ state: t, dispatch: e }) => (e && Zw(t), !0),
      setCellSelection: (t) => ({ tr: e, dispatch: n }) => {
        if (n) {
          const r = lt.create(e.doc, t.anchorCell, t.headCell);
          e.setSelection(r);
        }
        return !0;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Tab: () => this.editor.commands.goToNextCell() ? !0 : this.editor.can().addRowAfter() ? this.editor.chain().addRowAfter().goToNextCell().run() : !1,
      "Shift-Tab": () => this.editor.commands.goToPreviousCell(),
      Backspace: Pl,
      "Mod-Backspace": Pl,
      Delete: Pl,
      "Mod-Delete": Pl
    };
  },
  addProseMirrorPlugins() {
    return [
      ...this.options.resizable && this.editor.isEditable ? [
        hF({
          handleWidth: this.options.handleWidth,
          cellMinWidth: this.options.cellMinWidth,
          defaultCellMinWidth: this.options.cellMinWidth,
          View: this.options.View,
          lastColumnResizable: this.options.lastColumnResizable
        })
      ] : [],
      xF({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  },
  extendNodeSchema(t) {
    const e = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      tableRole: Re(K(t, "tableRole", e))
    };
  }
}), OF = Gt.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("colwidth");
          return e ? e.split(",").map((r) => parseInt(r, 10)) : null;
        }
      }
    };
  },
  tableRole: "cell",
  isolating: !0,
  parseHTML() {
    return [
      { tag: "td" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["td", wt(this.options.HTMLAttributes, t), 0];
  }
}), DF = Gt.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("colwidth");
          return e ? e.split(",").map((r) => parseInt(r, 10)) : null;
        }
      }
    };
  },
  tableRole: "header_cell",
  isolating: !0,
  parseHTML() {
    return [
      { tag: "th" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["th", wt(this.options.HTMLAttributes, t), 0];
  }
}), AF = Gt.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "(tableCell | tableHeader)*",
  tableRole: "row",
  parseHTML() {
    return [
      { tag: "tr" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["tr", wt(this.options.HTMLAttributes, t), 0];
  }
}), LF = en.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: "left"
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (t) => {
              const e = t.style.textAlign || this.options.defaultAlignment;
              return this.options.alignments.includes(e) ? e : this.options.defaultAlignment;
            },
            renderHTML: (t) => t.textAlign === this.options.defaultAlignment ? {} : { style: `text-align: ${t.textAlign}` }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (t) => ({ commands: e }) => this.options.alignments.includes(t) ? this.options.types.map((n) => e.updateAttributes(n, { textAlign: t })).every((n) => n) : !1,
      unsetTextAlign: () => ({ commands: t }) => this.options.types.map((e) => t.resetAttributes(e, "textAlign")).every((e) => e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), $F = ir.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["u", wt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: t }) => t.setMark(this.name),
      toggleUnderline: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetUnderline: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), PF = /^\s*>\s$/, _F = Gt.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["blockquote", wt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: t }) => t.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: t }) => t.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: t }) => t.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Us({
        find: PF,
        type: this.type
      })
    ];
  }
}), BF = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, VF = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, FF = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, NF = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, zF = ir.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (t) => t.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (t) => /^(bold(er)?|[5-9]\d{2,})$/.test(t) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["strong", wt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: t }) => t.setMark(this.name),
      toggleBold: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetBold: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      Go({
        find: BF,
        type: this.type
      }),
      Go({
        find: FF,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      wo({
        find: VF,
        type: this.type
      }),
      wo({
        find: NF,
        type: this.type
      })
    ];
  }
}), HF = "listItem", Em = "textStyle", km = /^\s*([-+*])\s$/, jF = Gt.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", wt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(HF, this.editor.getAttributes(Em)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let t = Us({
      find: km,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = Us({
      find: km,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Em),
      editor: this.editor
    })), [
      t
    ];
  }
}), WF = new RegExp("(?<!`)`([^`]+)`(?!`)"), GF = new RegExp("(?<!`)`([^`]+)`(?!`)", "g"), UF = ir.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["code", wt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: t }) => t.setMark(this.name),
      toggleCode: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetCode: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      Go({
        find: WF,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      wo({
        find: GF,
        type: this.type
      })
    ];
  }
}), qF = /^```([a-z]+)?[\s\n]$/, JF = /^~~~([a-z]+)?[\s\n]$/, KF = Gt.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (t) => {
          var e;
          const { languageClassPrefix: n } = this.options, i = [...((e = t.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((s) => s.startsWith(n)).map((s) => s.replace(n, ""))[0];
          return i || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "pre",
      wt(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: t.attrs.language ? this.options.languageClassPrefix + t.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (t) => ({ commands: e }) => e.setNode(this.name, t),
      toggleCodeBlock: (t) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: t, $anchor: e } = this.editor.state.selection, n = e.pos === 1;
        return !t || e.parent.type.name !== this.name ? !1 : n || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: t }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = t, { selection: n } = e, { $from: r, empty: o } = n;
        if (!o || r.parent.type !== this.type)
          return !1;
        const i = r.parentOffset === r.parent.nodeSize - 2, s = r.parent.textContent.endsWith(`

`);
        return !i || !s ? !1 : t.chain().command(({ tr: l }) => (l.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: t }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = t, { selection: n, doc: r } = e, { $from: o, empty: i } = n;
        if (!i || o.parent.type !== this.type || !(o.parentOffset === o.parent.nodeSize - 2))
          return !1;
        const l = o.after();
        return l === void 0 ? !1 : r.nodeAt(l) ? t.commands.command(({ tr: c }) => (c.setSelection(fe.near(r.resolve(l))), !0)) : t.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Ou({
        find: qF,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      }),
      Ou({
        find: JF,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Ft({
        key: new tn("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (t, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), o = r ? JSON.parse(r) : void 0, i = o == null ? void 0 : o.mode;
            if (!n || !i)
              return !1;
            const { tr: s, schema: l } = t.state, a = l.text(n.replace(/\r\n?/g, `
`));
            return s.replaceSelectionWith(this.type.create({ language: i }, a)), s.selection.$from.parent.type !== this.type && s.setSelection(ce.near(s.doc.resolve(Math.max(0, s.selection.from - 2)))), s.setMeta("paste", !0), t.dispatch(s), !0;
          }
        }
      })
    ];
  }
}), YF = Gt.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function ZF(t = {}) {
  return new Ft({
    view(e) {
      return new XF(e, t);
    }
  });
}
class XF {
  constructor(e, n) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = n.width) !== null && r !== void 0 ? r : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((o) => {
      let i = (s) => {
        this[o](s);
      };
      return e.dom.addEventListener(o, i), { name: o, handler: i };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: n }) => this.editorView.dom.removeEventListener(e, n));
  }
  update(e, n) {
    this.cursorPos != null && n.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), n = !e.parent.inlineContent, r;
    if (n) {
      let l = e.nodeBefore, a = e.nodeAfter;
      if (l || a) {
        let c = this.editorView.nodeDOM(this.cursorPos - (l ? l.nodeSize : 0));
        if (c) {
          let d = c.getBoundingClientRect(), u = l ? d.bottom : d.top;
          l && a && (u = (u + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), r = { left: d.left, right: d.right, top: u - this.width / 2, bottom: u + this.width / 2 };
        }
      }
    }
    if (!r) {
      let l = this.editorView.coordsAtPos(this.cursorPos);
      r = { left: l.left - this.width / 2, right: l.left + this.width / 2, top: l.top, bottom: l.bottom };
    }
    let o = this.editorView.dom.offsetParent;
    this.element || (this.element = o.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let i, s;
    if (!o || o == document.body && getComputedStyle(o).position == "static")
      i = -pageXOffset, s = -pageYOffset;
    else {
      let l = o.getBoundingClientRect();
      i = l.left - o.scrollLeft, s = l.top - o.scrollTop;
    }
    this.element.style.left = r.left - i + "px", this.element.style.top = r.top - s + "px", this.element.style.width = r.right - r.left + "px", this.element.style.height = r.bottom - r.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), o = r && r.type.spec.disableDropCursor, i = typeof o == "function" ? o(this.editorView, n, e) : o;
    if (n && !i) {
      let s = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let l = S1(this.editorView.state.doc, s, this.editorView.dragging.slice);
        l != null && (s = l);
      }
      this.setCursor(s), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    (e.target == this.editorView.dom || !this.editorView.dom.contains(e.relatedTarget)) && this.setCursor(null);
  }
}
const QF = en.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      ZF(this.options)
    ];
  }
});
class Et extends fe {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    return Et.valid(r) ? new Et(r) : fe.near(r);
  }
  content() {
    return N.empty;
  }
  eq(e) {
    return e instanceof Et && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Et(e.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new wh(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let n = e.parent;
    if (n.isTextblock || !eN(e) || !tN(e))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let o = n.contentMatchAt(e.index()).defaultType;
    return o && o.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, n, r = !1) {
    e: for (; ; ) {
      if (!r && Et.valid(e))
        return e;
      let o = e.pos, i = null;
      for (let s = e.depth; ; s--) {
        let l = e.node(s);
        if (n > 0 ? e.indexAfter(s) < l.childCount : e.index(s) > 0) {
          i = l.child(n > 0 ? e.indexAfter(s) : e.index(s) - 1);
          break;
        } else if (s == 0)
          return null;
        o += n;
        let a = e.doc.resolve(o);
        if (Et.valid(a))
          return a;
      }
      for (; ; ) {
        let s = n > 0 ? i.firstChild : i.lastChild;
        if (!s) {
          if (i.isAtom && !i.isText && !le.isSelectable(i)) {
            e = e.doc.resolve(o + i.nodeSize * n), r = !1;
            continue e;
          }
          break;
        }
        i = s, o += n;
        let l = e.doc.resolve(o);
        if (Et.valid(l))
          return l;
      }
      return null;
    }
  }
}
Et.prototype.visible = !1;
Et.findFrom = Et.findGapCursorFrom;
fe.jsonID("gapcursor", Et);
class wh {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new wh(e.map(this.pos));
  }
  resolve(e) {
    let n = e.resolve(this.pos);
    return Et.valid(n) ? new Et(n) : fe.near(n);
  }
}
function eN(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.index(e), r = t.node(e);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(n - 1); ; o = o.lastChild) {
      if (o.childCount == 0 && !o.inlineContent || o.isAtom || o.type.spec.isolating)
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function tN(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.indexAfter(e), r = t.node(e);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(n); ; o = o.firstChild) {
      if (o.childCount == 0 && !o.inlineContent || o.isAtom || o.type.spec.isolating)
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function nN() {
  return new Ft({
    props: {
      decorations: sN,
      createSelectionBetween(t, e, n) {
        return e.pos == n.pos && Et.valid(n) ? new Et(n) : null;
      },
      handleClick: oN,
      handleKeyDown: rN,
      handleDOMEvents: { beforeinput: iN }
    }
  });
}
const rN = Uf({
  ArrowLeft: _l("horiz", -1),
  ArrowRight: _l("horiz", 1),
  ArrowUp: _l("vert", -1),
  ArrowDown: _l("vert", 1)
});
function _l(t, e) {
  const n = t == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, o, i) {
    let s = r.selection, l = e > 0 ? s.$to : s.$from, a = s.empty;
    if (s instanceof ce) {
      if (!i.endOfTextblock(n) || l.depth == 0)
        return !1;
      a = !1, l = r.doc.resolve(e > 0 ? l.after() : l.before());
    }
    let c = Et.findGapCursorFrom(l, e, a);
    return c ? (o && o(r.tr.setSelection(new Et(c))), !0) : !1;
  };
}
function oN(t, e, n) {
  if (!t || !t.editable)
    return !1;
  let r = t.state.doc.resolve(e);
  if (!Et.valid(r))
    return !1;
  let o = t.posAtCoords({ left: n.clientX, top: n.clientY });
  return o && o.inside > -1 && le.isSelectable(t.state.doc.nodeAt(o.inside)) ? !1 : (t.dispatch(t.state.tr.setSelection(new Et(r))), !0);
}
function iN(t, e) {
  if (e.inputType != "insertCompositionText" || !(t.state.selection instanceof Et))
    return !1;
  let { $from: n } = t.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(t.state.schema.nodes.text);
  if (!r)
    return !1;
  let o = D.empty;
  for (let s = r.length - 1; s >= 0; s--)
    o = D.from(r[s].createAndFill(null, o));
  let i = t.state.tr.replace(n.pos, n.pos, new N(o, 0, 0));
  return i.setSelection(ce.near(i.doc.resolve(n.pos + 1))), t.dispatch(i), !1;
}
function sN(t) {
  if (!(t.selection instanceof Et))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", bt.create(t.doc, [sn.widget(t.selection.head, e, { key: "gapcursor" })]);
}
const lN = en.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      nN()
    ];
  },
  extendNodeSchema(t) {
    var e;
    const n = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      allowGapCursor: (e = Re(K(t, "allowGapCursor", n))) !== null && e !== void 0 ? e : null
    };
  }
}), aN = Gt.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["br", wt(this.options.HTMLAttributes, t)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: t, chain: e, state: n, editor: r }) => t.first([
        () => t.exitCode(),
        () => t.command(() => {
          const { selection: o, storedMarks: i } = n;
          if (o.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: s } = this.options, { splittableMarks: l } = r.extensionManager, a = i || o.$to.parentOffset && o.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: d }) => {
            if (d && a && s) {
              const u = a.filter((f) => l.includes(f.type.name));
              c.ensureMarks(u);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), cN = Gt.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((t) => ({
      tag: `h${t}`,
      attrs: { level: t }
    }));
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(t.attrs.level) ? t.attrs.level : this.options.levels[0]}`, wt(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.setNode(this.name, t) : !1,
      toggleHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.toggleNode(this.name, "paragraph", t) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((t, e) => ({
      ...t,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((t) => Ou({
      find: new RegExp(`^(#{1,${t}})\\s$`),
      type: this.type,
      getAttributes: {
        level: t
      }
    }));
  }
});
var ic = 200, jt = function() {
};
jt.prototype.append = function(e) {
  return e.length ? (e = jt.from(e), !this.length && e || e.length < ic && this.leafAppend(e) || this.length < ic && e.leafPrepend(this) || this.appendInner(e)) : this;
};
jt.prototype.prepend = function(e) {
  return e.length ? jt.from(e).append(this) : this;
};
jt.prototype.appendInner = function(e) {
  return new dN(this, e);
};
jt.prototype.slice = function(e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = this.length), e >= n ? jt.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, n));
};
jt.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
jt.prototype.forEach = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length), n <= r ? this.forEachInner(e, n, r, 0) : this.forEachInvertedInner(e, n, r, 0);
};
jt.prototype.map = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length);
  var o = [];
  return this.forEach(function(i, s) {
    return o.push(e(i, s));
  }, n, r), o;
};
jt.from = function(e) {
  return e instanceof jt ? e : e && e.length ? new nS(e) : jt.empty;
};
var nS = /* @__PURE__ */ function(t) {
  function e(r) {
    t.call(this), this.values = r;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(o, i) {
    return o == 0 && i == this.length ? this : new e(this.values.slice(o, i));
  }, e.prototype.getInner = function(o) {
    return this.values[o];
  }, e.prototype.forEachInner = function(o, i, s, l) {
    for (var a = i; a < s; a++)
      if (o(this.values[a], l + a) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(o, i, s, l) {
    for (var a = i - 1; a >= s; a--)
      if (o(this.values[a], l + a) === !1)
        return !1;
  }, e.prototype.leafAppend = function(o) {
    if (this.length + o.length <= ic)
      return new e(this.values.concat(o.flatten()));
  }, e.prototype.leafPrepend = function(o) {
    if (this.length + o.length <= ic)
      return new e(o.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, n), e;
}(jt);
jt.empty = new nS([]);
var dN = /* @__PURE__ */ function(t) {
  function e(n, r) {
    t.call(this), this.left = n, this.right = r, this.length = n.length + r.length, this.depth = Math.max(n.depth, r.depth) + 1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, o, i, s) {
    var l = this.left.length;
    if (o < l && this.left.forEachInner(r, o, Math.min(i, l), s) === !1 || i > l && this.right.forEachInner(r, Math.max(o - l, 0), Math.min(this.length, i) - l, s + l) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, o, i, s) {
    var l = this.left.length;
    if (o > l && this.right.forEachInvertedInner(r, o - l, Math.max(i, l) - l, s + l) === !1 || i < l && this.left.forEachInvertedInner(r, Math.min(o, l), i, s) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, o) {
    if (r == 0 && o == this.length)
      return this;
    var i = this.left.length;
    return o <= i ? this.left.slice(r, o) : r >= i ? this.right.slice(r - i, o - i) : this.left.slice(r, i).append(this.right.slice(0, o - i));
  }, e.prototype.leafAppend = function(r) {
    var o = this.right.leafAppend(r);
    if (o)
      return new e(this.left, o);
  }, e.prototype.leafPrepend = function(r) {
    var o = this.left.leafPrepend(r);
    if (o)
      return new e(o, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(jt);
const uN = 500;
class Qn {
  constructor(e, n) {
    this.items = e, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, n) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let o, i;
    n && (o = this.remapping(r, this.items.length), i = o.maps.length);
    let s = e.tr, l, a, c = [], d = [];
    return this.items.forEach((u, f) => {
      if (!u.step) {
        o || (o = this.remapping(r, f + 1), i = o.maps.length), i--, d.push(u);
        return;
      }
      if (o) {
        d.push(new fr(u.map));
        let h = u.step.map(o.slice(i)), p;
        h && s.maybeStep(h).doc && (p = s.mapping.maps[s.mapping.maps.length - 1], c.push(new fr(p, void 0, void 0, c.length + d.length))), i--, p && o.appendMap(p, i);
      } else
        s.maybeStep(u.step);
      if (u.selection)
        return l = o ? u.selection.map(o.slice(i)) : u.selection, a = new Qn(this.items.slice(0, r).append(d.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: a, transform: s, selection: l };
  }
  // Create a new branch with the given transform added.
  addTransform(e, n, r, o) {
    let i = [], s = this.eventCount, l = this.items, a = !o && l.length ? l.get(l.length - 1) : null;
    for (let d = 0; d < e.steps.length; d++) {
      let u = e.steps[d].invert(e.docs[d]), f = new fr(e.mapping.maps[d], u, n), h;
      (h = a && a.merge(f)) && (f = h, d ? i.pop() : l = l.slice(0, l.length - 1)), i.push(f), n && (s++, n = void 0), o || (a = f);
    }
    let c = s - r.depth;
    return c > hN && (l = fN(l, c), s -= c), new Qn(l.append(i), s);
  }
  remapping(e, n) {
    let r = new wi();
    return this.items.forEach((o, i) => {
      let s = o.mirrorOffset != null && i - o.mirrorOffset >= e ? r.maps.length - o.mirrorOffset : void 0;
      r.appendMap(o.map, s);
    }, e, n), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Qn(this.items.append(e.map((n) => new fr(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, n) {
    if (!this.eventCount)
      return this;
    let r = [], o = Math.max(0, this.items.length - n), i = e.mapping, s = e.steps.length, l = this.eventCount;
    this.items.forEach((f) => {
      f.selection && l--;
    }, o);
    let a = n;
    this.items.forEach((f) => {
      let h = i.getMirror(--a);
      if (h == null)
        return;
      s = Math.min(s, h);
      let p = i.maps[h];
      if (f.step) {
        let y = e.steps[h].invert(e.docs[h]), b = f.selection && f.selection.map(i.slice(a + 1, h));
        b && l++, r.push(new fr(p, y, b));
      } else
        r.push(new fr(p));
    }, o);
    let c = [];
    for (let f = n; f < s; f++)
      c.push(new fr(i.maps[f]));
    let d = this.items.slice(0, o).append(c).append(r), u = new Qn(d, l);
    return u.emptyItemCount() > uN && (u = u.compress(this.items.length - r.length)), u;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((n) => {
      n.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let n = this.remapping(0, e), r = n.maps.length, o = [], i = 0;
    return this.items.forEach((s, l) => {
      if (l >= e)
        o.push(s), s.selection && i++;
      else if (s.step) {
        let a = s.step.map(n.slice(r)), c = a && a.getMap();
        if (r--, c && n.appendMap(c, r), a) {
          let d = s.selection && s.selection.map(n.slice(r));
          d && i++;
          let u = new fr(c.invert(), a, d), f, h = o.length - 1;
          (f = o.length && o[h].merge(u)) ? o[h] = f : o.push(u);
        }
      } else s.map && r--;
    }, this.items.length, 0), new Qn(jt.from(o.reverse()), i);
  }
}
Qn.empty = new Qn(jt.empty, 0);
function fN(t, e) {
  let n;
  return t.forEach((r, o) => {
    if (r.selection && e-- == 0)
      return n = o, !1;
  }), t.slice(n);
}
class fr {
  constructor(e, n, r, o) {
    this.map = e, this.step = n, this.selection = r, this.mirrorOffset = o;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let n = e.step.merge(this.step);
      if (n)
        return new fr(n.getMap().invert(), n, this.selection);
    }
  }
}
class Qr {
  constructor(e, n, r, o, i) {
    this.done = e, this.undone = n, this.prevRanges = r, this.prevTime = o, this.prevComposition = i;
  }
}
const hN = 20;
function pN(t, e, n, r) {
  let o = n.getMeta(Fo), i;
  if (o)
    return o.historyState;
  n.getMeta(yN) && (t = new Qr(t.done, t.undone, null, 0, -1));
  let s = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return t;
  if (s && s.getMeta(Fo))
    return s.getMeta(Fo).redo ? new Qr(t.done.addTransform(n, void 0, r, na(e)), t.undone, Tm(n.mapping.maps), t.prevTime, t.prevComposition) : new Qr(t.done, t.undone.addTransform(n, void 0, r, na(e)), null, t.prevTime, t.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(s && s.getMeta("addToHistory") === !1)) {
    let l = n.getMeta("composition"), a = t.prevTime == 0 || !s && t.prevComposition != l && (t.prevTime < (n.time || 0) - r.newGroupDelay || !gN(n, t.prevRanges)), c = s ? Ad(t.prevRanges, n.mapping) : Tm(n.mapping.maps);
    return new Qr(t.done.addTransform(n, a ? e.selection.getBookmark() : void 0, r, na(e)), Qn.empty, c, n.time, l ?? t.prevComposition);
  } else return (i = n.getMeta("rebased")) ? new Qr(t.done.rebased(n, i), t.undone.rebased(n, i), Ad(t.prevRanges, n.mapping), t.prevTime, t.prevComposition) : new Qr(t.done.addMaps(n.mapping.maps), t.undone.addMaps(n.mapping.maps), Ad(t.prevRanges, n.mapping), t.prevTime, t.prevComposition);
}
function gN(t, e) {
  if (!e)
    return !1;
  if (!t.docChanged)
    return !0;
  let n = !1;
  return t.mapping.maps[0].forEach((r, o) => {
    for (let i = 0; i < e.length; i += 2)
      r <= e[i + 1] && o >= e[i] && (n = !0);
  }), n;
}
function Tm(t) {
  let e = [];
  for (let n = t.length - 1; n >= 0 && e.length == 0; n--)
    t[n].forEach((r, o, i, s) => e.push(i, s));
  return e;
}
function Ad(t, e) {
  if (!t)
    return null;
  let n = [];
  for (let r = 0; r < t.length; r += 2) {
    let o = e.map(t[r], 1), i = e.map(t[r + 1], -1);
    o <= i && n.push(o, i);
  }
  return n;
}
function mN(t, e, n) {
  let r = na(e), o = Fo.get(e).spec.config, i = (n ? t.undone : t.done).popEvent(e, r);
  if (!i)
    return null;
  let s = i.selection.resolve(i.transform.doc), l = (n ? t.done : t.undone).addTransform(i.transform, e.selection.getBookmark(), o, r), a = new Qr(n ? l : i.remaining, n ? i.remaining : l, null, 0, -1);
  return i.transform.setSelection(s).setMeta(Fo, { redo: n, historyState: a });
}
let Ld = !1, Im = null;
function na(t) {
  let e = t.plugins;
  if (Im != e) {
    Ld = !1, Im = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].spec.historyPreserveItems) {
        Ld = !0;
        break;
      }
  }
  return Ld;
}
const Fo = new tn("history"), yN = new tn("closeHistory");
function bN(t = {}) {
  return t = {
    depth: t.depth || 100,
    newGroupDelay: t.newGroupDelay || 500
  }, new Ft({
    key: Fo,
    state: {
      init() {
        return new Qr(Qn.empty, Qn.empty, null, 0, -1);
      },
      apply(e, n, r) {
        return pN(n, r, e, t);
      }
    },
    config: t,
    props: {
      handleDOMEvents: {
        beforeinput(e, n) {
          let r = n.inputType, o = r == "historyUndo" ? oS : r == "historyRedo" ? iS : null;
          return o ? (n.preventDefault(), o(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function rS(t, e) {
  return (n, r) => {
    let o = Fo.getState(n);
    if (!o || (t ? o.undone : o.done).eventCount == 0)
      return !1;
    if (r) {
      let i = mN(o, n, t);
      i && r(e ? i.scrollIntoView() : i);
    }
    return !0;
  };
}
const oS = rS(!1, !0), iS = rS(!0, !0), wN = en.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: t, dispatch: e }) => oS(t, e),
      redo: () => ({ state: t, dispatch: e }) => iS(t, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      bN(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), SN = Gt.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["hr", wt(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: t, state: e }) => {
        const { selection: n } = e, { $from: r, $to: o } = n, i = t();
        return r.parentOffset === 0 ? i.insertContentAt({
          from: Math.max(r.pos - 1, 0),
          to: o.pos
        }, {
          type: this.name
        }) : x4(n) ? i.insertContentAt(o.pos, {
          type: this.name
        }) : i.insertContent({ type: this.name }), i.command(({ tr: s, dispatch: l }) => {
          var a;
          if (l) {
            const { $to: c } = s.selection, d = c.end();
            if (c.nodeAfter)
              c.nodeAfter.isTextblock ? s.setSelection(ce.create(s.doc, c.pos + 1)) : c.nodeAfter.isBlock ? s.setSelection(le.create(s.doc, c.pos)) : s.setSelection(ce.create(s.doc, c.pos));
            else {
              const u = (a = c.parent.type.contentMatch.defaultType) === null || a === void 0 ? void 0 : a.create();
              u && (s.insert(d, u), s.setSelection(ce.create(s.doc, d + 1)));
            }
            s.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      e3({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), CN = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, vN = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, xN = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, EN = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, kN = ir.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (t) => t.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["em", wt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: t }) => t.setMark(this.name),
      toggleItalic: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetItalic: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      Go({
        find: CN,
        type: this.type
      }),
      Go({
        find: xN,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      wo({
        find: vN,
        type: this.type
      }),
      wo({
        find: EN,
        type: this.type
      })
    ];
  }
}), TN = Gt.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["li", wt(this.options.HTMLAttributes, t), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), IN = "listItem", Mm = "textStyle", Rm = /^(\d+)\.\s$/, MN = Gt.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (t) => t.hasAttribute("start") ? parseInt(t.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: void 0,
        parseHTML: (t) => t.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    const { start: e, ...n } = t;
    return e === 1 ? ["ol", wt(this.options.HTMLAttributes, n), 0] : ["ol", wt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(IN, this.editor.getAttributes(Mm)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let t = Us({
      find: Rm,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = Us({
      find: Rm,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(Mm) }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1],
      editor: this.editor
    })), [
      t
    ];
  }
}), RN = Gt.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["p", wt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: t }) => t.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), ON = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, DN = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, AN = ir.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["s", wt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: t }) => t.setMark(this.name),
      toggleStrike: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetStrike: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      Go({
        find: ON,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      wo({
        find: DN,
        type: this.type
      })
    ];
  }
}), LN = Gt.create({
  name: "text",
  group: "inline"
}), $N = en.create({
  name: "starterKit",
  addExtensions() {
    var t, e, n, r, o, i, s, l, a, c, d, u, f, h, p, y, b, w;
    const S = [];
    return this.options.bold !== !1 && S.push(zF.configure((t = this.options) === null || t === void 0 ? void 0 : t.bold)), this.options.blockquote !== !1 && S.push(_F.configure((e = this.options) === null || e === void 0 ? void 0 : e.blockquote)), this.options.bulletList !== !1 && S.push(jF.configure((n = this.options) === null || n === void 0 ? void 0 : n.bulletList)), this.options.code !== !1 && S.push(UF.configure((r = this.options) === null || r === void 0 ? void 0 : r.code)), this.options.codeBlock !== !1 && S.push(KF.configure((o = this.options) === null || o === void 0 ? void 0 : o.codeBlock)), this.options.document !== !1 && S.push(YF.configure((i = this.options) === null || i === void 0 ? void 0 : i.document)), this.options.dropcursor !== !1 && S.push(QF.configure((s = this.options) === null || s === void 0 ? void 0 : s.dropcursor)), this.options.gapcursor !== !1 && S.push(lN.configure((l = this.options) === null || l === void 0 ? void 0 : l.gapcursor)), this.options.hardBreak !== !1 && S.push(aN.configure((a = this.options) === null || a === void 0 ? void 0 : a.hardBreak)), this.options.heading !== !1 && S.push(cN.configure((c = this.options) === null || c === void 0 ? void 0 : c.heading)), this.options.history !== !1 && S.push(wN.configure((d = this.options) === null || d === void 0 ? void 0 : d.history)), this.options.horizontalRule !== !1 && S.push(SN.configure((u = this.options) === null || u === void 0 ? void 0 : u.horizontalRule)), this.options.italic !== !1 && S.push(kN.configure((f = this.options) === null || f === void 0 ? void 0 : f.italic)), this.options.listItem !== !1 && S.push(TN.configure((h = this.options) === null || h === void 0 ? void 0 : h.listItem)), this.options.orderedList !== !1 && S.push(MN.configure((p = this.options) === null || p === void 0 ? void 0 : p.orderedList)), this.options.paragraph !== !1 && S.push(RN.configure((y = this.options) === null || y === void 0 ? void 0 : y.paragraph)), this.options.strike !== !1 && S.push(AN.configure((b = this.options) === null || b === void 0 ? void 0 : b.strike)), this.options.text !== !1 && S.push(LN.configure((w = this.options) === null || w === void 0 ? void 0 : w.text)), S;
  }
}), PN = (t) => [
  $N.configure({
    paragraph: {
      HTMLAttributes: {
        class: "editor-paragraph"
      }
    }
  }),
  TV.configure({
    placeholder: t
  }),
  kV,
  LF.configure({
    types: ["heading", "paragraph"]
  }),
  $F,
  E3,
  RF.configure({
    resizable: !0,
    allowTableNodeSelection: !0
  }),
  AF,
  DF,
  OF
], _N = {
  heading: "H",
  createTable: "Create table",
  addColumnBefore: "Add column before",
  addColumnAfter: "Add column after",
  deleteColumn: "Delete column",
  addRowAfter: "Add row after",
  deleteTable: "Delete table",
  mergeCells: "Merge cells",
  toggleHeaderColumn: "Toggle header column",
  table: "Table",
  placeholder: "Enter a text..."
}, BN = O((t, { mode: e, disabled: n }) => {
  const r = e === ms.preview ? "unset" : void 0, o = e === ms.preview ? "unset" : t.other.colors.white[0], i = n ? t.other.colors.greyIron[2] : o, s = n ? t.other.colors.greyIron[2] : r;
  return {
    root: {
      height: "100%",
      backgroundColor: i,
      borderColor: t.other.colors.greyIron[4],
      border: e === ms.preview ? "none" : void 0,
      cursor: n ? "not-allowed" : void 0
    },
    control: {
      padding: `${m(12)} ${m(9)}`,
      height: "100%",
      borderColor: t.other.colors.greyIron[4],
      borderRadius: t.other.borderRadius[8],
      "--mantine-primary-color-light-color": t.other.colors.brand[13],
      "--mantine-primary-color-light": t.other.colors.brand[3],
      "--mantine-primary-color-light-hover": t.other.colors.brand[5]
    },
    content: {
      minHeight: m(60),
      font: t.other.fonts.desktop.s.s.default,
      color: t.other.colors.greyIron[16],
      backgroundColor: s,
      "& h2": {
        font: t.other.fonts.desktop.s.xxl.header,
        letterSpacing: "-0.01em"
      },
      "& h3": {
        font: t.other.fonts.desktop.s.xl.header
      },
      "& h4": {
        font: t.other.fonts.desktop.s.l.header
      },
      "& h5": {
        font: t.other.fonts.desktop.s.m.header
      },
      "& h6": {
        font: t.other.fonts.desktop.s.s.header
      },
      "& strong": {
        fontWeight: 600
      },
      "& mark": {
        padding: 0,
        backgroundColor: t.other.colors.brand[6]
      },
      "& a": {
        color: t.other.colors.blue[13],
        textDecoration: "underline",
        textUnderlineOffset: 4,
        textDecorationColor: t.other.colors.blue[9],
        transition: Ae(["color", "text-decoration-color"]),
        "&::selection": {
          backgroundColor: t.other.colors.blue[2]
        },
        "&:hover": {
          textDecorationColor: t.other.colors.blue[13],
          color: t.other.colors.blue[13]
        },
        "&:active": {
          color: t.other.colors.blue[15],
          textDecorationColor: t.other.colors.blue[15]
        },
        "&:visited": {
          color: t.other.colors.blue[15],
          textDecorationColor: t.other.colors.blue[15],
          "&:hover": {
            textDecorationColor: t.other.colors.blue[15]
          },
          "&:active": {
            color: t.other.colors.blue[17],
            textDecorationColor: t.other.colors.blue[17]
          }
        }
      },
      "& table": {
        borderCollapse: "collapse",
        margin: 0,
        overflow: "hidden",
        tableLayout: "fixed",
        width: "100%",
        "& td, & th": {
          border: `1px solid ${t.colors.gray[3]}`,
          boxSizing: "border-box",
          minWidth: m(16),
          padding: `${m(8)} ${m(12)}`,
          position: "relative",
          verticalAlign: "top",
          "& > *": {
            marginBottom: 0
          }
        },
        "& th": {
          backgroundColor: `${t.colors.gray[1]}`,
          font: t.other.fonts.desktop.s.s.important,
          textAlign: "left"
        },
        "& .selectedCell:after": {
          backgroundColor: `${t.colors.gray[1]}`,
          content: '""',
          opacity: 0.5,
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          pointerEvents: "none",
          position: "absolute",
          zIndex: 2
        },
        "& .column-resize-handle": {
          backgroundColor: `${t.colors.gray[1]}`,
          bottom: m(-2),
          pointerEvents: "none",
          position: "absolute",
          right: m(-2),
          top: 0,
          width: m(2)
        }
      },
      "& .resize-cursor": {
        cursor: "col-resize"
      },
      "& ul, & ol": {
        paddingLeft: m(30),
        "& li": {
          marginTop: m(4),
          paddingLeft: m(8),
          wordBreak: "break-word",
          wordWrap: "break-word",
          "& > p": {
            display: "unset"
          },
          "&:first-of-type": {
            marginTop: 0
          },
          listStylePosition: "outside"
        }
      },
      ".ProseMirror": {
        padding: e === ms.preview ? 0 : void 0,
        margin: 0
      }
    },
    toolbar: {
      backgroundColor: i,
      padding: 0,
      borderColor: t.other.colors.greyIron[4]
    },
    typographyStylesProvider: {},
    controlsGroup: {},
    linkEditor: {},
    linkEditorSave: {},
    linkEditorExternalControl: {
      display: "none"
    },
    linkEditorInput: {
      paddingRight: m(8),
      "&:focus, &:focus-within": {
        borderColor: t.other.colors.brand[10]
      }
    },
    linkEditorDropdown: {
      marginTop: m(44)
    }
  };
}), VN = ge(
  ({ withToolbar: t = !0, classNames: e, translations: n = {}, mode: r = ms.default, onChangeControlsMode: o, editable: i, disabled: s, ...l }, a) => {
    const { rest: c, styleProps: d } = el(l), u = me(
      () => ({
        ..._N,
        ...n
      }),
      [n]
    ), f = J3({
      extensions: PN(u.placeholder),
      editable: !s && i,
      ...c
    }), { classes: h, cx: p } = BN({ mode: r, disabled: s });
    return MS(a, () => ({ editor: f }), [f]), /* @__PURE__ */ g.createElement(
      Z,
      {
        editor: f,
        classNames: {
          root: p(h.root, e == null ? void 0 : e.root),
          control: p(h.control, e == null ? void 0 : e.control),
          content: p(h.content, e == null ? void 0 : e.content),
          toolbar: p(h.toolbar, e == null ? void 0 : e.toolbar),
          typographyStylesProvider: p(h.typographyStylesProvider, e == null ? void 0 : e.typographyStylesProvider),
          controlsGroup: p(h.controlsGroup, e == null ? void 0 : e.controlsGroup),
          linkEditor: p(h.linkEditor, e == null ? void 0 : e.linkEditor),
          linkEditorDropdown: p(h.linkEditorDropdown, e == null ? void 0 : e.linkEditorDropdown),
          linkEditorExternalControl: p(h.linkEditorExternalControl, e == null ? void 0 : e.linkEditorExternalControl),
          linkEditorSave: p(h.linkEditorSave, e == null ? void 0 : e.linkEditorSave),
          linkEditorInput: p(h.linkEditorInput, e == null ? void 0 : e.linkEditorInput)
        },
        ...d
      },
      t && /* @__PURE__ */ g.createElement(vV, { onChangeControlsMode: o, translations: u, disabled: s }),
      /* @__PURE__ */ g.createElement(Z.Content, null)
    );
  }
);
VN.displayName = "RichEditor";
const FN = O((t, { opened: e }) => ({
  root: {
    gap: m(16)
  },
  header: {
    gap: m(8)
  },
  divider: {
    width: "100%",
    flex: 1
  },
  title: {},
  buttons: {
    gap: m(8)
  },
  button: {
    [`& .${No}`]: {
      svg: {
        transition: Ae(["transform", "rotate"]),
        transform: `rotate(${e ? "180deg" : 0})`
      }
    }
  },
  content: {}
})), bz = ({
  title: t,
  defaultValue: e = !0,
  value: n,
  onChange: r,
  children: o,
  extraButtons: i = [],
  className: s,
  titlePosition: l = "left",
  ...a
}) => {
  const [c, d] = an({
    defaultValue: e,
    value: n,
    onChange: r
  }), { classes: u, cx: f } = FN({ opened: c }), h = te(() => {
    d(!c);
  }, [c, d]);
  return /* @__PURE__ */ g.createElement(Ee, { className: f(u.root, s), ...a }, /* @__PURE__ */ g.createElement(X, { className: u.header }, /* @__PURE__ */ g.createElement(
    il,
    {
      className: u.divider,
      labelPosition: l,
      label: /* @__PURE__ */ g.createElement(xe, { elementVariant: "default", elementSize: "m", colorVariant: "greyIron.13", className: u.title }, t)
    }
  ), /* @__PURE__ */ g.createElement(X, { className: u.buttons }, i, /* @__PURE__ */ g.createElement(
    ye,
    {
      isIconOnly: !0,
      isRound: !0,
      elementVariant: Q.TertiaryMain,
      rightSection: /* @__PURE__ */ g.createElement(Sr, null),
      onClick: h,
      className: u.button,
      "data-testid": "sector-click-button"
    }
  ))), /* @__PURE__ */ g.createElement(jd, { in: c, transitionDuration: 300, transitionTimingFunction: "linear", className: u.content }, o));
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function ao(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function On(t, e) {
  return (n) => {
    e.setState((r) => ({
      ...r,
      [t]: ao(n, r[t])
    }));
  };
}
function sc(t) {
  return t instanceof Function;
}
function NN(t) {
  return Array.isArray(t) && t.every((e) => typeof e == "number");
}
function zN(t, e) {
  const n = [], r = (o) => {
    o.forEach((i) => {
      n.push(i);
      const s = e(i);
      s != null && s.length && r(s);
    });
  };
  return r(t), n;
}
function be(t, e, n) {
  let r = [], o;
  return () => {
    let i;
    n.key && n.debug && (i = Date.now());
    const s = t();
    if (!(s.length !== r.length || s.some((c, d) => r[d] !== c)))
      return o;
    r = s;
    let a;
    if (n.key && n.debug && (a = Date.now()), o = e(...s), n == null || n.onChange == null || n.onChange(o), n.key && n.debug && n != null && n.debug()) {
      const c = Math.round((Date.now() - i) * 100) / 100, d = Math.round((Date.now() - a) * 100) / 100, u = d / 16, f = (h, p) => {
        for (h = String(h); h.length < p; )
          h = " " + h;
        return h;
      };
      console.info(`%c⏱ ${f(d, 5)} /${f(c, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * u, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return o;
  };
}
function HN(t, e, n, r) {
  var o, i;
  const l = {
    ...t._getDefaultColumnDef(),
    ...e
  }, a = l.accessorKey;
  let c = (o = (i = l.id) != null ? i : a ? a.replace(".", "_") : void 0) != null ? o : typeof l.header == "string" ? l.header : void 0, d;
  if (l.accessorFn ? d = l.accessorFn : a && (a.includes(".") ? d = (f) => {
    let h = f;
    for (const y of a.split(".")) {
      var p;
      h = (p = h) == null ? void 0 : p[y], process.env.NODE_ENV !== "production" && h === void 0 && console.warn(`"${y}" in deeply nested key "${a}" returned undefined.`);
    }
    return h;
  } : d = (f) => f[l.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(l.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let u = {
    id: `${String(c)}`,
    accessorFn: d,
    parent: r,
    depth: n,
    columnDef: l,
    columns: [],
    getFlatColumns: be(() => [!0], () => {
      var f;
      return [u, ...(f = u.columns) == null ? void 0 : f.flatMap((h) => h.getFlatColumns())];
    }, {
      key: process.env.NODE_ENV === "production" && "column.getFlatColumns",
      debug: () => {
        var f;
        return (f = t.options.debugAll) != null ? f : t.options.debugColumns;
      }
    }),
    getLeafColumns: be(() => [t._getOrderColumnsFn()], (f) => {
      var h;
      if ((h = u.columns) != null && h.length) {
        let p = u.columns.flatMap((y) => y.getLeafColumns());
        return f(p);
      }
      return [u];
    }, {
      key: process.env.NODE_ENV === "production" && "column.getLeafColumns",
      debug: () => {
        var f;
        return (f = t.options.debugAll) != null ? f : t.options.debugColumns;
      }
    })
  };
  for (const f of t._features)
    f.createColumn == null || f.createColumn(u, t);
  return u;
}
function Om(t, e, n) {
  var r;
  let i = {
    id: (r = n.id) != null ? r : e.id,
    column: e,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const s = [], l = (a) => {
        a.subHeaders && a.subHeaders.length && a.subHeaders.map(l), s.push(a);
      };
      return l(i), s;
    },
    getContext: () => ({
      table: t,
      header: i,
      column: e
    })
  };
  return t._features.forEach((s) => {
    s.createHeader == null || s.createHeader(i, t);
  }), i;
}
const jN = {
  createTable: (t) => {
    t.getHeaderGroups = be(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, r, o) => {
      var i, s;
      const l = (i = r == null ? void 0 : r.map((u) => n.find((f) => f.id === u)).filter(Boolean)) != null ? i : [], a = (s = o == null ? void 0 : o.map((u) => n.find((f) => f.id === u)).filter(Boolean)) != null ? s : [], c = n.filter((u) => !(r != null && r.includes(u.id)) && !(o != null && o.includes(u.id)));
      return Bl(e, [...l, ...c, ...a], t);
    }, {
      key: process.env.NODE_ENV === "development" && "getHeaderGroups",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getCenterHeaderGroups = be(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, r, o) => (n = n.filter((i) => !(r != null && r.includes(i.id)) && !(o != null && o.includes(i.id))), Bl(e, n, t, "center")), {
      key: process.env.NODE_ENV === "development" && "getCenterHeaderGroups",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getLeftHeaderGroups = be(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left], (e, n, r) => {
      var o;
      const i = (o = r == null ? void 0 : r.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? o : [];
      return Bl(e, i, t, "left");
    }, {
      key: process.env.NODE_ENV === "development" && "getLeftHeaderGroups",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getRightHeaderGroups = be(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.right], (e, n, r) => {
      var o;
      const i = (o = r == null ? void 0 : r.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? o : [];
      return Bl(e, i, t, "right");
    }, {
      key: process.env.NODE_ENV === "development" && "getRightHeaderGroups",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getFooterGroups = be(() => [t.getHeaderGroups()], (e) => [...e].reverse(), {
      key: process.env.NODE_ENV === "development" && "getFooterGroups",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getLeftFooterGroups = be(() => [t.getLeftHeaderGroups()], (e) => [...e].reverse(), {
      key: process.env.NODE_ENV === "development" && "getLeftFooterGroups",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getCenterFooterGroups = be(() => [t.getCenterHeaderGroups()], (e) => [...e].reverse(), {
      key: process.env.NODE_ENV === "development" && "getCenterFooterGroups",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getRightFooterGroups = be(() => [t.getRightHeaderGroups()], (e) => [...e].reverse(), {
      key: process.env.NODE_ENV === "development" && "getRightFooterGroups",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getFlatHeaders = be(() => [t.getHeaderGroups()], (e) => e.map((n) => n.headers).flat(), {
      key: process.env.NODE_ENV === "development" && "getFlatHeaders",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getLeftFlatHeaders = be(() => [t.getLeftHeaderGroups()], (e) => e.map((n) => n.headers).flat(), {
      key: process.env.NODE_ENV === "development" && "getLeftFlatHeaders",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getCenterFlatHeaders = be(() => [t.getCenterHeaderGroups()], (e) => e.map((n) => n.headers).flat(), {
      key: process.env.NODE_ENV === "development" && "getCenterFlatHeaders",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getRightFlatHeaders = be(() => [t.getRightHeaderGroups()], (e) => e.map((n) => n.headers).flat(), {
      key: process.env.NODE_ENV === "development" && "getRightFlatHeaders",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getCenterLeafHeaders = be(() => [t.getCenterFlatHeaders()], (e) => e.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), {
      key: process.env.NODE_ENV === "development" && "getCenterLeafHeaders",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getLeftLeafHeaders = be(() => [t.getLeftFlatHeaders()], (e) => e.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), {
      key: process.env.NODE_ENV === "development" && "getLeftLeafHeaders",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getRightLeafHeaders = be(() => [t.getRightFlatHeaders()], (e) => e.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), {
      key: process.env.NODE_ENV === "development" && "getRightLeafHeaders",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    }), t.getLeafHeaders = be(() => [t.getLeftHeaderGroups(), t.getCenterHeaderGroups(), t.getRightHeaderGroups()], (e, n, r) => {
      var o, i, s, l, a, c;
      return [...(o = (i = e[0]) == null ? void 0 : i.headers) != null ? o : [], ...(s = (l = n[0]) == null ? void 0 : l.headers) != null ? s : [], ...(a = (c = r[0]) == null ? void 0 : c.headers) != null ? a : []].map((d) => d.getLeafHeaders()).flat();
    }, {
      key: process.env.NODE_ENV === "development" && "getLeafHeaders",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugHeaders;
      }
    });
  }
};
function Bl(t, e, n, r) {
  var o, i;
  let s = 0;
  const l = function(f, h) {
    h === void 0 && (h = 1), s = Math.max(s, h), f.filter((p) => p.getIsVisible()).forEach((p) => {
      var y;
      (y = p.columns) != null && y.length && l(p.columns, h + 1);
    }, 0);
  };
  l(t);
  let a = [];
  const c = (f, h) => {
    const p = {
      depth: h,
      id: [r, `${h}`].filter(Boolean).join("_"),
      headers: []
    }, y = [];
    f.forEach((b) => {
      const w = [...y].reverse()[0], S = b.column.depth === p.depth;
      let x, E = !1;
      if (S && b.column.parent ? x = b.column.parent : (x = b.column, E = !0), w && (w == null ? void 0 : w.column) === x)
        w.subHeaders.push(b);
      else {
        const v = Om(n, x, {
          id: [r, h, x.id, b == null ? void 0 : b.id].filter(Boolean).join("_"),
          isPlaceholder: E,
          placeholderId: E ? `${y.filter((T) => T.column === x).length}` : void 0,
          depth: h,
          index: y.length
        });
        v.subHeaders.push(b), y.push(v);
      }
      p.headers.push(b), b.headerGroup = p;
    }), a.push(p), h > 0 && c(y, h - 1);
  }, d = e.map((f, h) => Om(n, f, {
    depth: s,
    index: h
  }));
  c(d, s - 1), a.reverse();
  const u = (f) => f.filter((p) => p.column.getIsVisible()).map((p) => {
    let y = 0, b = 0, w = [0];
    p.subHeaders && p.subHeaders.length ? (w = [], u(p.subHeaders).forEach((x) => {
      let {
        colSpan: E,
        rowSpan: v
      } = x;
      y += E, w.push(v);
    })) : y = 1;
    const S = Math.min(...w);
    return b = b + S, p.colSpan = y, p.rowSpan = b, {
      colSpan: y,
      rowSpan: b
    };
  });
  return u((o = (i = a[0]) == null ? void 0 : i.headers) != null ? o : []), a;
}
const Vl = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, $d = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), WN = {
  getDefaultColumnDef: () => Vl,
  getInitialState: (t) => ({
    columnSizing: {},
    columnSizingInfo: $d(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: On("columnSizing", t),
    onColumnSizingInfoChange: On("columnSizingInfo", t)
  }),
  createColumn: (t, e) => {
    t.getSize = () => {
      var n, r, o;
      const i = e.getState().columnSizing[t.id];
      return Math.min(Math.max((n = t.columnDef.minSize) != null ? n : Vl.minSize, (r = i ?? t.columnDef.size) != null ? r : Vl.size), (o = t.columnDef.maxSize) != null ? o : Vl.maxSize);
    }, t.getStart = (n) => {
      const r = n ? n === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns(), o = r.findIndex((i) => i.id === t.id);
      if (o > 0) {
        const i = r[o - 1];
        return i.getStart(n) + i.getSize();
      }
      return 0;
    }, t.resetSize = () => {
      e.setColumnSizing((n) => {
        let {
          [t.id]: r,
          ...o
        } = n;
        return o;
      });
    }, t.getCanResize = () => {
      var n, r;
      return ((n = t.columnDef.enableResizing) != null ? n : !0) && ((r = e.options.enableColumnResizing) != null ? r : !0);
    }, t.getIsResizing = () => e.getState().columnSizingInfo.isResizingColumn === t.id;
  },
  createHeader: (t, e) => {
    t.getSize = () => {
      let n = 0;
      const r = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(r);
        else {
          var i;
          n += (i = o.column.getSize()) != null ? i : 0;
        }
      };
      return r(t), n;
    }, t.getStart = () => {
      if (t.index > 0) {
        const n = t.headerGroup.headers[t.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, t.getResizeHandler = () => {
      const n = e.getColumn(t.column.id), r = n == null ? void 0 : n.getCanResize();
      return (o) => {
        if (!n || !r || (o.persist == null || o.persist(), Pd(o) && o.touches && o.touches.length > 1))
          return;
        const i = t.getSize(), s = t ? t.getLeafHeaders().map((y) => [y.column.id, y.column.getSize()]) : [[n.id, n.getSize()]], l = Pd(o) ? Math.round(o.touches[0].clientX) : o.clientX, a = {}, c = (y, b) => {
          typeof b == "number" && (e.setColumnSizingInfo((w) => {
            var S, x;
            const E = e.options.columnResizeDirection === "rtl" ? -1 : 1, v = (b - ((S = w == null ? void 0 : w.startOffset) != null ? S : 0)) * E, T = Math.max(v / ((x = w == null ? void 0 : w.startSize) != null ? x : 0), -0.999999);
            return w.columnSizingStart.forEach((I) => {
              let [M, R] = I;
              a[M] = Math.round(Math.max(R + R * T, 0) * 100) / 100;
            }), {
              ...w,
              deltaOffset: v,
              deltaPercentage: T
            };
          }), (e.options.columnResizeMode === "onChange" || y === "end") && e.setColumnSizing((w) => ({
            ...w,
            ...a
          })));
        }, d = (y) => c("move", y), u = (y) => {
          c("end", y), e.setColumnSizingInfo((b) => ({
            ...b,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, f = {
          moveHandler: (y) => d(y.clientX),
          upHandler: (y) => {
            document.removeEventListener("mousemove", f.moveHandler), document.removeEventListener("mouseup", f.upHandler), u(y.clientX);
          }
        }, h = {
          moveHandler: (y) => (y.cancelable && (y.preventDefault(), y.stopPropagation()), d(y.touches[0].clientX), !1),
          upHandler: (y) => {
            var b;
            document.removeEventListener("touchmove", h.moveHandler), document.removeEventListener("touchend", h.upHandler), y.cancelable && (y.preventDefault(), y.stopPropagation()), u((b = y.touches[0]) == null ? void 0 : b.clientX);
          }
        }, p = GN() ? {
          passive: !1
        } : !1;
        Pd(o) ? (document.addEventListener("touchmove", h.moveHandler, p), document.addEventListener("touchend", h.upHandler, p)) : (document.addEventListener("mousemove", f.moveHandler, p), document.addEventListener("mouseup", f.upHandler, p)), e.setColumnSizingInfo((y) => ({
          ...y,
          startOffset: l,
          startSize: i,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: s,
          isResizingColumn: n.id
        }));
      };
    };
  },
  createTable: (t) => {
    t.setColumnSizing = (e) => t.options.onColumnSizingChange == null ? void 0 : t.options.onColumnSizingChange(e), t.setColumnSizingInfo = (e) => t.options.onColumnSizingInfoChange == null ? void 0 : t.options.onColumnSizingInfoChange(e), t.resetColumnSizing = (e) => {
      var n;
      t.setColumnSizing(e ? {} : (n = t.initialState.columnSizing) != null ? n : {});
    }, t.resetHeaderSizeInfo = (e) => {
      var n;
      t.setColumnSizingInfo(e ? $d() : (n = t.initialState.columnSizingInfo) != null ? n : $d());
    }, t.getTotalSize = () => {
      var e, n;
      return (e = (n = t.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? e : 0;
    }, t.getLeftTotalSize = () => {
      var e, n;
      return (e = (n = t.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? e : 0;
    }, t.getCenterTotalSize = () => {
      var e, n;
      return (e = (n = t.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? e : 0;
    }, t.getRightTotalSize = () => {
      var e, n;
      return (e = (n = t.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? e : 0;
    };
  }
};
let Fl = null;
function GN() {
  if (typeof Fl == "boolean") return Fl;
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, e), window.removeEventListener("test", n);
  } catch {
    t = !1;
  }
  return Fl = t, Fl;
}
function Pd(t) {
  return t.type === "touchstart";
}
const UN = {
  getInitialState: (t) => ({
    expanded: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onExpandedChange: On("expanded", t),
    paginateExpandedRows: !0
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetExpanded = () => {
      var r, o;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((r = (o = t.options.autoResetAll) != null ? o : t.options.autoResetExpanded) != null ? r : !t.options.manualExpanding) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetExpanded(), n = !1;
        });
      }
    }, t.setExpanded = (r) => t.options.onExpandedChange == null ? void 0 : t.options.onExpandedChange(r), t.toggleAllRowsExpanded = (r) => {
      r ?? !t.getIsAllRowsExpanded() ? t.setExpanded(!0) : t.setExpanded({});
    }, t.resetExpanded = (r) => {
      var o, i;
      t.setExpanded(r ? {} : (o = (i = t.initialState) == null ? void 0 : i.expanded) != null ? o : {});
    }, t.getCanSomeRowsExpand = () => t.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), t.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), t.toggleAllRowsExpanded();
    }, t.getIsSomeRowsExpanded = () => {
      const r = t.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, t.getIsAllRowsExpanded = () => {
      const r = t.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || t.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, t.getExpandedDepth = () => {
      let r = 0;
      return (t.getState().expanded === !0 ? Object.keys(t.getRowModel().rowsById) : Object.keys(t.getState().expanded)).forEach((i) => {
        const s = i.split(".");
        r = Math.max(r, s.length);
      }), r;
    }, t.getPreExpandedRowModel = () => t.getSortedRowModel(), t.getExpandedRowModel = () => (!t._getExpandedRowModel && t.options.getExpandedRowModel && (t._getExpandedRowModel = t.options.getExpandedRowModel(t)), t.options.manualExpanding || !t._getExpandedRowModel ? t.getPreExpandedRowModel() : t._getExpandedRowModel());
  },
  createRow: (t, e) => {
    t.toggleExpanded = (n) => {
      e.setExpanded((r) => {
        var o;
        const i = r === !0 ? !0 : !!(r != null && r[t.id]);
        let s = {};
        if (r === !0 ? Object.keys(e.getRowModel().rowsById).forEach((l) => {
          s[l] = !0;
        }) : s = r, n = (o = n) != null ? o : !i, !i && n)
          return {
            ...s,
            [t.id]: !0
          };
        if (i && !n) {
          const {
            [t.id]: l,
            ...a
          } = s;
          return a;
        }
        return r;
      });
    }, t.getIsExpanded = () => {
      var n;
      const r = e.getState().expanded;
      return !!((n = e.options.getIsRowExpanded == null ? void 0 : e.options.getIsRowExpanded(t)) != null ? n : r === !0 || r != null && r[t.id]);
    }, t.getCanExpand = () => {
      var n, r, o;
      return (n = e.options.getRowCanExpand == null ? void 0 : e.options.getRowCanExpand(t)) != null ? n : ((r = e.options.enableExpanding) != null ? r : !0) && !!((o = t.subRows) != null && o.length);
    }, t.getIsAllParentsExpanded = () => {
      let n = !0, r = t;
      for (; n && r.parentId; )
        r = e.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, t.getToggleExpandedHandler = () => {
      const n = t.getCanExpand();
      return () => {
        n && t.toggleExpanded();
      };
    };
  }
}, sS = (t, e, n) => {
  var r;
  const o = n.toLowerCase();
  return !!(!((r = t.getValue(e)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(o));
};
sS.autoRemove = (t) => tr(t);
const lS = (t, e, n) => {
  var r;
  return !!(!((r = t.getValue(e)) == null || (r = r.toString()) == null) && r.includes(n));
};
lS.autoRemove = (t) => tr(t);
const aS = (t, e, n) => {
  var r;
  return ((r = t.getValue(e)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
aS.autoRemove = (t) => tr(t);
const cS = (t, e, n) => {
  var r;
  return (r = t.getValue(e)) == null ? void 0 : r.includes(n);
};
cS.autoRemove = (t) => tr(t) || !(t != null && t.length);
const dS = (t, e, n) => !n.some((r) => {
  var o;
  return !((o = t.getValue(e)) != null && o.includes(r));
});
dS.autoRemove = (t) => tr(t) || !(t != null && t.length);
const uS = (t, e, n) => n.some((r) => {
  var o;
  return (o = t.getValue(e)) == null ? void 0 : o.includes(r);
});
uS.autoRemove = (t) => tr(t) || !(t != null && t.length);
const fS = (t, e, n) => t.getValue(e) === n;
fS.autoRemove = (t) => tr(t);
const hS = (t, e, n) => t.getValue(e) == n;
hS.autoRemove = (t) => tr(t);
const Sh = (t, e, n) => {
  let [r, o] = n;
  const i = t.getValue(e);
  return i >= r && i <= o;
};
Sh.resolveFilterValue = (t) => {
  let [e, n] = t, r = typeof e != "number" ? parseFloat(e) : e, o = typeof n != "number" ? parseFloat(n) : n, i = e === null || Number.isNaN(r) ? -1 / 0 : r, s = n === null || Number.isNaN(o) ? 1 / 0 : o;
  if (i > s) {
    const l = i;
    i = s, s = l;
  }
  return [i, s];
};
Sh.autoRemove = (t) => tr(t) || tr(t[0]) && tr(t[1]);
const Ir = {
  includesString: sS,
  includesStringSensitive: lS,
  equalsString: aS,
  arrIncludes: cS,
  arrIncludesAll: dS,
  arrIncludesSome: uS,
  equals: fS,
  weakEquals: hS,
  inNumberRange: Sh
};
function tr(t) {
  return t == null || t === "";
}
const qN = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (t) => ({
    columnFilters: [],
    globalFilter: void 0,
    // filtersProgress: 1,
    // facetProgress: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnFiltersChange: On("columnFilters", t),
    onGlobalFilterChange: On("globalFilter", t),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100,
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (e) => {
      var n;
      const r = (n = t.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[e.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (t, e) => {
    t.getAutoFilterFn = () => {
      const n = e.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(t.id);
      return typeof r == "string" ? Ir.includesString : typeof r == "number" ? Ir.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? Ir.equals : Array.isArray(r) ? Ir.arrIncludes : Ir.weakEquals;
    }, t.getFilterFn = () => {
      var n, r;
      return sc(t.columnDef.filterFn) ? t.columnDef.filterFn : t.columnDef.filterFn === "auto" ? t.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = e.options.filterFns) == null ? void 0 : r[t.columnDef.filterFn]) != null ? n : Ir[t.columnDef.filterFn]
      );
    }, t.getCanFilter = () => {
      var n, r, o;
      return ((n = t.columnDef.enableColumnFilter) != null ? n : !0) && ((r = e.options.enableColumnFilters) != null ? r : !0) && ((o = e.options.enableFilters) != null ? o : !0) && !!t.accessorFn;
    }, t.getCanGlobalFilter = () => {
      var n, r, o, i;
      return ((n = t.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = e.options.enableGlobalFilter) != null ? r : !0) && ((o = e.options.enableFilters) != null ? o : !0) && ((i = e.options.getColumnCanGlobalFilter == null ? void 0 : e.options.getColumnCanGlobalFilter(t)) != null ? i : !0) && !!t.accessorFn;
    }, t.getIsFiltered = () => t.getFilterIndex() > -1, t.getFilterValue = () => {
      var n;
      return (n = e.getState().columnFilters) == null || (n = n.find((r) => r.id === t.id)) == null ? void 0 : n.value;
    }, t.getFilterIndex = () => {
      var n, r;
      return (n = (r = e.getState().columnFilters) == null ? void 0 : r.findIndex((o) => o.id === t.id)) != null ? n : -1;
    }, t.setFilterValue = (n) => {
      e.setColumnFilters((r) => {
        const o = t.getFilterFn(), i = r == null ? void 0 : r.find((d) => d.id === t.id), s = ao(n, i ? i.value : void 0);
        if (Dm(o, s, t)) {
          var l;
          return (l = r == null ? void 0 : r.filter((d) => d.id !== t.id)) != null ? l : [];
        }
        const a = {
          id: t.id,
          value: s
        };
        if (i) {
          var c;
          return (c = r == null ? void 0 : r.map((d) => d.id === t.id ? a : d)) != null ? c : [];
        }
        return r != null && r.length ? [...r, a] : [a];
      });
    }, t._getFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, t.id), t.getFacetedRowModel = () => t._getFacetedRowModel ? t._getFacetedRowModel() : e.getPreFilteredRowModel(), t._getFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, t.id), t.getFacetedUniqueValues = () => t._getFacetedUniqueValues ? t._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, t.id), t.getFacetedMinMaxValues = () => {
      if (t._getFacetedMinMaxValues)
        return t._getFacetedMinMaxValues();
    };
  },
  createRow: (t, e) => {
    t.columnFilters = {}, t.columnFiltersMeta = {};
  },
  createTable: (t) => {
    t.getGlobalAutoFilterFn = () => Ir.includesString, t.getGlobalFilterFn = () => {
      var e, n;
      const {
        globalFilterFn: r
      } = t.options;
      return sc(r) ? r : r === "auto" ? t.getGlobalAutoFilterFn() : (
        // @ts-ignore
        (e = (n = t.options.filterFns) == null ? void 0 : n[r]) != null ? e : Ir[r]
      );
    }, t.setColumnFilters = (e) => {
      const n = t.getAllLeafColumns(), r = (o) => {
        var i;
        return (i = ao(e, o)) == null ? void 0 : i.filter((s) => {
          const l = n.find((a) => a.id === s.id);
          if (l) {
            const a = l.getFilterFn();
            if (Dm(a, s.value, l))
              return !1;
          }
          return !0;
        });
      };
      t.options.onColumnFiltersChange == null || t.options.onColumnFiltersChange(r);
    }, t.setGlobalFilter = (e) => {
      t.options.onGlobalFilterChange == null || t.options.onGlobalFilterChange(e);
    }, t.resetGlobalFilter = (e) => {
      t.setGlobalFilter(e ? void 0 : t.initialState.globalFilter);
    }, t.resetColumnFilters = (e) => {
      var n, r;
      t.setColumnFilters(e ? [] : (n = (r = t.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, t.getPreFilteredRowModel = () => t.getCoreRowModel(), t.getFilteredRowModel = () => (!t._getFilteredRowModel && t.options.getFilteredRowModel && (t._getFilteredRowModel = t.options.getFilteredRowModel(t)), t.options.manualFiltering || !t._getFilteredRowModel ? t.getPreFilteredRowModel() : t._getFilteredRowModel()), t._getGlobalFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, "__global__"), t.getGlobalFacetedRowModel = () => t.options.manualFiltering || !t._getGlobalFacetedRowModel ? t.getPreFilteredRowModel() : t._getGlobalFacetedRowModel(), t._getGlobalFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, "__global__"), t.getGlobalFacetedUniqueValues = () => t._getGlobalFacetedUniqueValues ? t._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getGlobalFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, "__global__"), t.getGlobalFacetedMinMaxValues = () => {
      if (t._getGlobalFacetedMinMaxValues)
        return t._getGlobalFacetedMinMaxValues();
    };
  }
};
function Dm(t, e, n) {
  return (t && t.autoRemove ? t.autoRemove(e, n) : !1) || typeof e > "u" || typeof e == "string" && !e;
}
const JN = (t, e, n) => n.reduce((r, o) => {
  const i = o.getValue(t);
  return r + (typeof i == "number" ? i : 0);
}, 0), KN = (t, e, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(t);
    i != null && (r > i || r === void 0 && i >= i) && (r = i);
  }), r;
}, YN = (t, e, n) => {
  let r;
  return n.forEach((o) => {
    const i = o.getValue(t);
    i != null && (r < i || r === void 0 && i >= i) && (r = i);
  }), r;
}, ZN = (t, e, n) => {
  let r, o;
  return n.forEach((i) => {
    const s = i.getValue(t);
    s != null && (r === void 0 ? s >= s && (r = o = s) : (r > s && (r = s), o < s && (o = s)));
  }), [r, o];
}, XN = (t, e) => {
  let n = 0, r = 0;
  if (e.forEach((o) => {
    let i = o.getValue(t);
    i != null && (i = +i) >= i && (++n, r += i);
  }), n) return r / n;
}, QN = (t, e) => {
  if (!e.length)
    return;
  const n = e.map((i) => i.getValue(t));
  if (!NN(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), o = n.sort((i, s) => i - s);
  return n.length % 2 !== 0 ? o[r] : (o[r - 1] + o[r]) / 2;
}, e6 = (t, e) => Array.from(new Set(e.map((n) => n.getValue(t))).values()), t6 = (t, e) => new Set(e.map((n) => n.getValue(t))).size, n6 = (t, e) => e.length, _d = {
  sum: JN,
  min: KN,
  max: YN,
  extent: ZN,
  mean: XN,
  median: QN,
  unique: e6,
  uniqueCount: t6,
  count: n6
}, r6 = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (t) => {
      var e, n;
      return (e = (n = t.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? e : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (t) => ({
    grouping: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGroupingChange: On("grouping", t),
    groupedColumnMode: "reorder"
  }),
  createColumn: (t, e) => {
    t.toggleGrouping = () => {
      e.setGrouping((n) => n != null && n.includes(t.id) ? n.filter((r) => r !== t.id) : [...n ?? [], t.id]);
    }, t.getCanGroup = () => {
      var n, r, o, i;
      return (n = (r = (o = (i = t.columnDef.enableGrouping) != null ? i : !0) != null ? o : e.options.enableGrouping) != null ? r : !0) != null ? n : !!t.accessorFn;
    }, t.getIsGrouped = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.includes(t.id);
    }, t.getGroupedIndex = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.indexOf(t.id);
    }, t.getToggleGroupingHandler = () => {
      const n = t.getCanGroup();
      return () => {
        n && t.toggleGrouping();
      };
    }, t.getAutoAggregationFn = () => {
      const n = e.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(t.id);
      if (typeof r == "number")
        return _d.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return _d.extent;
    }, t.getAggregationFn = () => {
      var n, r;
      if (!t)
        throw new Error();
      return sc(t.columnDef.aggregationFn) ? t.columnDef.aggregationFn : t.columnDef.aggregationFn === "auto" ? t.getAutoAggregationFn() : (n = (r = e.options.aggregationFns) == null ? void 0 : r[t.columnDef.aggregationFn]) != null ? n : _d[t.columnDef.aggregationFn];
    };
  },
  createTable: (t) => {
    t.setGrouping = (e) => t.options.onGroupingChange == null ? void 0 : t.options.onGroupingChange(e), t.resetGrouping = (e) => {
      var n, r;
      t.setGrouping(e ? [] : (n = (r = t.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, t.getPreGroupedRowModel = () => t.getFilteredRowModel(), t.getGroupedRowModel = () => (!t._getGroupedRowModel && t.options.getGroupedRowModel && (t._getGroupedRowModel = t.options.getGroupedRowModel(t)), t.options.manualGrouping || !t._getGroupedRowModel ? t.getPreGroupedRowModel() : t._getGroupedRowModel());
  },
  createRow: (t, e) => {
    t.getIsGrouped = () => !!t.groupingColumnId, t.getGroupingValue = (n) => {
      if (t._groupingValuesCache.hasOwnProperty(n))
        return t._groupingValuesCache[n];
      const r = e.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (t._groupingValuesCache[n] = r.columnDef.getGroupingValue(t.original), t._groupingValuesCache[n]) : t.getValue(n);
    }, t._groupingValuesCache = {};
  },
  createCell: (t, e, n, r) => {
    t.getIsGrouped = () => e.getIsGrouped() && e.id === n.groupingColumnId, t.getIsPlaceholder = () => !t.getIsGrouped() && e.getIsGrouped(), t.getIsAggregated = () => {
      var o;
      return !t.getIsGrouped() && !t.getIsPlaceholder() && !!((o = n.subRows) != null && o.length);
    };
  }
};
function o6(t, e, n) {
  if (!(e != null && e.length) || !n)
    return t;
  const r = t.filter((i) => !e.includes(i.id));
  return n === "remove" ? r : [...e.map((i) => t.find((s) => s.id === i)).filter(Boolean), ...r];
}
const i6 = {
  getInitialState: (t) => ({
    columnOrder: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnOrderChange: On("columnOrder", t)
  }),
  createTable: (t) => {
    t.setColumnOrder = (e) => t.options.onColumnOrderChange == null ? void 0 : t.options.onColumnOrderChange(e), t.resetColumnOrder = (e) => {
      var n;
      t.setColumnOrder(e ? [] : (n = t.initialState.columnOrder) != null ? n : []);
    }, t._getOrderColumnsFn = be(() => [t.getState().columnOrder, t.getState().grouping, t.options.groupedColumnMode], (e, n, r) => (o) => {
      let i = [];
      if (!(e != null && e.length))
        i = o;
      else {
        const s = [...e], l = [...o];
        for (; l.length && s.length; ) {
          const a = s.shift(), c = l.findIndex((d) => d.id === a);
          c > -1 && i.push(l.splice(c, 1)[0]);
        }
        i = [...i, ...l];
      }
      return o6(i, n, r);
    }, {
      key: process.env.NODE_ENV === "development" && "getOrderColumnsFn"
      // debug: () => table.options.debugAll ?? table.options.debugTable,
    });
  }
}, Ju = 0, Ku = 10, Bd = () => ({
  pageIndex: Ju,
  pageSize: Ku
}), s6 = {
  getInitialState: (t) => ({
    ...t,
    pagination: {
      ...Bd(),
      ...t == null ? void 0 : t.pagination
    }
  }),
  getDefaultOptions: (t) => ({
    onPaginationChange: On("pagination", t)
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetPageIndex = () => {
      var r, o;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((r = (o = t.options.autoResetAll) != null ? o : t.options.autoResetPageIndex) != null ? r : !t.options.manualPagination) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetPageIndex(), n = !1;
        });
      }
    }, t.setPagination = (r) => {
      const o = (i) => ao(r, i);
      return t.options.onPaginationChange == null ? void 0 : t.options.onPaginationChange(o);
    }, t.resetPagination = (r) => {
      var o;
      t.setPagination(r ? Bd() : (o = t.initialState.pagination) != null ? o : Bd());
    }, t.setPageIndex = (r) => {
      t.setPagination((o) => {
        let i = ao(r, o.pageIndex);
        const s = typeof t.options.pageCount > "u" || t.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : t.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, s)), {
          ...o,
          pageIndex: i
        };
      });
    }, t.resetPageIndex = (r) => {
      var o, i;
      t.setPageIndex(r ? Ju : (o = (i = t.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? o : Ju);
    }, t.resetPageSize = (r) => {
      var o, i;
      t.setPageSize(r ? Ku : (o = (i = t.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? o : Ku);
    }, t.setPageSize = (r) => {
      t.setPagination((o) => {
        const i = Math.max(1, ao(r, o.pageSize)), s = o.pageSize * o.pageIndex, l = Math.floor(s / i);
        return {
          ...o,
          pageIndex: l,
          pageSize: i
        };
      });
    }, t.setPageCount = (r) => t.setPagination((o) => {
      var i;
      let s = ao(r, (i = t.options.pageCount) != null ? i : -1);
      return typeof s == "number" && (s = Math.max(-1, s)), {
        ...o,
        pageCount: s
      };
    }), t.getPageOptions = be(() => [t.getPageCount()], (r) => {
      let o = [];
      return r && r > 0 && (o = [...new Array(r)].fill(null).map((i, s) => s)), o;
    }, {
      key: process.env.NODE_ENV === "development" && "getPageOptions",
      debug: () => {
        var r;
        return (r = t.options.debugAll) != null ? r : t.options.debugTable;
      }
    }), t.getCanPreviousPage = () => t.getState().pagination.pageIndex > 0, t.getCanNextPage = () => {
      const {
        pageIndex: r
      } = t.getState().pagination, o = t.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : r < o - 1;
    }, t.previousPage = () => t.setPageIndex((r) => r - 1), t.nextPage = () => t.setPageIndex((r) => r + 1), t.getPrePaginationRowModel = () => t.getExpandedRowModel(), t.getPaginationRowModel = () => (!t._getPaginationRowModel && t.options.getPaginationRowModel && (t._getPaginationRowModel = t.options.getPaginationRowModel(t)), t.options.manualPagination || !t._getPaginationRowModel ? t.getPrePaginationRowModel() : t._getPaginationRowModel()), t.getPageCount = () => {
      var r;
      return (r = t.options.pageCount) != null ? r : Math.ceil(t.getPrePaginationRowModel().rows.length / t.getState().pagination.pageSize);
    };
  }
}, Vd = () => ({
  left: [],
  right: []
}), Fd = () => ({
  top: [],
  bottom: []
}), l6 = {
  getInitialState: (t) => ({
    columnPinning: Vd(),
    rowPinning: Fd(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnPinningChange: On("columnPinning", t),
    onRowPinningChange: On("rowPinning", t)
  }),
  createColumn: (t, e) => {
    t.pin = (n) => {
      const r = t.getLeafColumns().map((o) => o.id).filter(Boolean);
      e.setColumnPinning((o) => {
        var i, s;
        if (n === "right") {
          var l, a;
          return {
            left: ((l = o == null ? void 0 : o.left) != null ? l : []).filter((u) => !(r != null && r.includes(u))),
            right: [...((a = o == null ? void 0 : o.right) != null ? a : []).filter((u) => !(r != null && r.includes(u))), ...r]
          };
        }
        if (n === "left") {
          var c, d;
          return {
            left: [...((c = o == null ? void 0 : o.left) != null ? c : []).filter((u) => !(r != null && r.includes(u))), ...r],
            right: ((d = o == null ? void 0 : o.right) != null ? d : []).filter((u) => !(r != null && r.includes(u)))
          };
        }
        return {
          left: ((i = o == null ? void 0 : o.left) != null ? i : []).filter((u) => !(r != null && r.includes(u))),
          right: ((s = o == null ? void 0 : o.right) != null ? s : []).filter((u) => !(r != null && r.includes(u)))
        };
      });
    }, t.getCanPin = () => t.getLeafColumns().some((r) => {
      var o, i, s;
      return ((o = r.columnDef.enablePinning) != null ? o : !0) && ((i = (s = e.options.enableColumnPinning) != null ? s : e.options.enablePinning) != null ? i : !0);
    }), t.getIsPinned = () => {
      const n = t.getLeafColumns().map((l) => l.id), {
        left: r,
        right: o
      } = e.getState().columnPinning, i = n.some((l) => r == null ? void 0 : r.includes(l)), s = n.some((l) => o == null ? void 0 : o.includes(l));
      return i ? "left" : s ? "right" : !1;
    }, t.getPinnedIndex = () => {
      var n, r;
      const o = t.getIsPinned();
      return o ? (n = (r = e.getState().columnPinning) == null || (r = r[o]) == null ? void 0 : r.indexOf(t.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (t, e) => {
    t.pin = (n, r, o) => {
      const i = r ? t.getLeafRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], s = o ? t.getParentRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], l = /* @__PURE__ */ new Set([...s, t.id, ...i]);
      e.setRowPinning((a) => {
        var c, d;
        if (n === "bottom") {
          var u, f;
          return {
            top: ((u = a == null ? void 0 : a.top) != null ? u : []).filter((y) => !(l != null && l.has(y))),
            bottom: [...((f = a == null ? void 0 : a.bottom) != null ? f : []).filter((y) => !(l != null && l.has(y))), ...Array.from(l)]
          };
        }
        if (n === "top") {
          var h, p;
          return {
            top: [...((h = a == null ? void 0 : a.top) != null ? h : []).filter((y) => !(l != null && l.has(y))), ...Array.from(l)],
            bottom: ((p = a == null ? void 0 : a.bottom) != null ? p : []).filter((y) => !(l != null && l.has(y)))
          };
        }
        return {
          top: ((c = a == null ? void 0 : a.top) != null ? c : []).filter((y) => !(l != null && l.has(y))),
          bottom: ((d = a == null ? void 0 : a.bottom) != null ? d : []).filter((y) => !(l != null && l.has(y)))
        };
      });
    }, t.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: o
      } = e.options;
      return typeof r == "function" ? r(t) : (n = r ?? o) != null ? n : !0;
    }, t.getIsPinned = () => {
      const n = [t.id], {
        top: r,
        bottom: o
      } = e.getState().rowPinning, i = n.some((l) => r == null ? void 0 : r.includes(l)), s = n.some((l) => o == null ? void 0 : o.includes(l));
      return i ? "top" : s ? "bottom" : !1;
    }, t.getPinnedIndex = () => {
      var n, r;
      const o = t.getIsPinned();
      if (!o) return -1;
      const i = (n = e._getPinnedRows(o)) == null ? void 0 : n.map((s) => {
        let {
          id: l
        } = s;
        return l;
      });
      return (r = i == null ? void 0 : i.indexOf(t.id)) != null ? r : -1;
    }, t.getCenterVisibleCells = be(() => [t._getAllVisibleCells(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, r, o) => {
      const i = [...r ?? [], ...o ?? []];
      return n.filter((s) => !i.includes(s.column.id));
    }, {
      key: process.env.NODE_ENV === "development" && "row.getCenterVisibleCells",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugRows;
      }
    }), t.getLeftVisibleCells = be(() => [t._getAllVisibleCells(), e.getState().columnPinning.left, ,], (n, r) => (r ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), {
      key: process.env.NODE_ENV === "development" && "row.getLeftVisibleCells",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugRows;
      }
    }), t.getRightVisibleCells = be(() => [t._getAllVisibleCells(), e.getState().columnPinning.right], (n, r) => (r ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), {
      key: process.env.NODE_ENV === "development" && "row.getRightVisibleCells",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugRows;
      }
    });
  },
  createTable: (t) => {
    t.setColumnPinning = (e) => t.options.onColumnPinningChange == null ? void 0 : t.options.onColumnPinningChange(e), t.resetColumnPinning = (e) => {
      var n, r;
      return t.setColumnPinning(e ? Vd() : (n = (r = t.initialState) == null ? void 0 : r.columnPinning) != null ? n : Vd());
    }, t.getIsSomeColumnsPinned = (e) => {
      var n;
      const r = t.getState().columnPinning;
      if (!e) {
        var o, i;
        return !!((o = r.left) != null && o.length || (i = r.right) != null && i.length);
      }
      return !!((n = r[e]) != null && n.length);
    }, t.getLeftLeafColumns = be(() => [t.getAllLeafColumns(), t.getState().columnPinning.left], (e, n) => (n ?? []).map((r) => e.find((o) => o.id === r)).filter(Boolean), {
      key: process.env.NODE_ENV === "development" && "getLeftLeafColumns",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugColumns;
      }
    }), t.getRightLeafColumns = be(() => [t.getAllLeafColumns(), t.getState().columnPinning.right], (e, n) => (n ?? []).map((r) => e.find((o) => o.id === r)).filter(Boolean), {
      key: process.env.NODE_ENV === "development" && "getRightLeafColumns",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugColumns;
      }
    }), t.getCenterLeafColumns = be(() => [t.getAllLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, r) => {
      const o = [...n ?? [], ...r ?? []];
      return e.filter((i) => !o.includes(i.id));
    }, {
      key: process.env.NODE_ENV === "development" && "getCenterLeafColumns",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugColumns;
      }
    }), t.setRowPinning = (e) => t.options.onRowPinningChange == null ? void 0 : t.options.onRowPinningChange(e), t.resetRowPinning = (e) => {
      var n, r;
      return t.setRowPinning(e ? Fd() : (n = (r = t.initialState) == null ? void 0 : r.rowPinning) != null ? n : Fd());
    }, t.getIsSomeRowsPinned = (e) => {
      var n;
      const r = t.getState().rowPinning;
      if (!e) {
        var o, i;
        return !!((o = r.top) != null && o.length || (i = r.bottom) != null && i.length);
      }
      return !!((n = r[e]) != null && n.length);
    }, t._getPinnedRows = (e) => be(() => [t.getRowModel().rows, t.getState().rowPinning[e]], (n, r) => {
      var o;
      return ((o = t.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (r ?? []).map((s) => {
          const l = t.getRow(s, !0);
          return l.getIsAllParentsExpanded() ? l : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (r ?? []).map((s) => n.find((l) => l.id === s))
      )).filter(Boolean).map((s) => ({
        ...s,
        position: e
      }));
    }, {
      key: process.env.NODE_ENV === "development" && `row.get${e === "top" ? "Top" : "Bottom"}Rows`,
      debug: () => {
        var n;
        return (n = t.options.debugAll) != null ? n : t.options.debugRows;
      }
    })(), t.getTopRows = () => t._getPinnedRows("top"), t.getBottomRows = () => t._getPinnedRows("bottom"), t.getCenterRows = be(() => [t.getRowModel().rows, t.getState().rowPinning.top, t.getState().rowPinning.bottom], (e, n, r) => {
      const o = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return e.filter((i) => !o.has(i.id));
    }, {
      key: process.env.NODE_ENV === "development" && "row.getCenterRows",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugRows;
      }
    });
  }
}, a6 = {
  getInitialState: (t) => ({
    rowSelection: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowSelectionChange: On("rowSelection", t),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (t) => {
    t.setRowSelection = (e) => t.options.onRowSelectionChange == null ? void 0 : t.options.onRowSelectionChange(e), t.resetRowSelection = (e) => {
      var n;
      return t.setRowSelection(e ? {} : (n = t.initialState.rowSelection) != null ? n : {});
    }, t.toggleAllRowsSelected = (e) => {
      t.setRowSelection((n) => {
        e = typeof e < "u" ? e : !t.getIsAllRowsSelected();
        const r = {
          ...n
        }, o = t.getPreGroupedRowModel().flatRows;
        return e ? o.forEach((i) => {
          i.getCanSelect() && (r[i.id] = !0);
        }) : o.forEach((i) => {
          delete r[i.id];
        }), r;
      });
    }, t.toggleAllPageRowsSelected = (e) => t.setRowSelection((n) => {
      const r = typeof e < "u" ? e : !t.getIsAllPageRowsSelected(), o = {
        ...n
      };
      return t.getRowModel().rows.forEach((i) => {
        Yu(o, i.id, r, !0, t);
      }), o;
    }), t.getPreSelectedRowModel = () => t.getCoreRowModel(), t.getSelectedRowModel = be(() => [t.getState().rowSelection, t.getCoreRowModel()], (e, n) => Object.keys(e).length ? Nd(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, {
      key: process.env.NODE_ENV === "development" && "getSelectedRowModel",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugTable;
      }
    }), t.getFilteredSelectedRowModel = be(() => [t.getState().rowSelection, t.getFilteredRowModel()], (e, n) => Object.keys(e).length ? Nd(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, {
      key: process.env.NODE_ENV === "production" && "getFilteredSelectedRowModel",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugTable;
      }
    }), t.getGroupedSelectedRowModel = be(() => [t.getState().rowSelection, t.getSortedRowModel()], (e, n) => Object.keys(e).length ? Nd(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, {
      key: process.env.NODE_ENV === "production" && "getGroupedSelectedRowModel",
      debug: () => {
        var e;
        return (e = t.options.debugAll) != null ? e : t.options.debugTable;
      }
    }), t.getIsAllRowsSelected = () => {
      const e = t.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = t.getState();
      let r = !!(e.length && Object.keys(n).length);
      return r && e.some((o) => o.getCanSelect() && !n[o.id]) && (r = !1), r;
    }, t.getIsAllPageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: n
      } = t.getState();
      let r = !!e.length;
      return r && e.some((o) => !n[o.id]) && (r = !1), r;
    }, t.getIsSomeRowsSelected = () => {
      var e;
      const n = Object.keys((e = t.getState().rowSelection) != null ? e : {}).length;
      return n > 0 && n < t.getFilteredRowModel().flatRows.length;
    }, t.getIsSomePageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows;
      return t.getIsAllPageRowsSelected() ? !1 : e.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, t.getToggleAllRowsSelectedHandler = () => (e) => {
      t.toggleAllRowsSelected(e.target.checked);
    }, t.getToggleAllPageRowsSelectedHandler = () => (e) => {
      t.toggleAllPageRowsSelected(e.target.checked);
    };
  },
  createRow: (t, e) => {
    t.toggleSelected = (n, r) => {
      const o = t.getIsSelected();
      e.setRowSelection((i) => {
        var s;
        if (n = typeof n < "u" ? n : !o, t.getCanSelect() && o === n)
          return i;
        const l = {
          ...i
        };
        return Yu(l, t.id, n, (s = r == null ? void 0 : r.selectChildren) != null ? s : !0, e), l;
      });
    }, t.getIsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return Ch(t, n);
    }, t.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return Zu(t, n) === "some";
    }, t.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return Zu(t, n) === "all";
    }, t.getCanSelect = () => {
      var n;
      return typeof e.options.enableRowSelection == "function" ? e.options.enableRowSelection(t) : (n = e.options.enableRowSelection) != null ? n : !0;
    }, t.getCanSelectSubRows = () => {
      var n;
      return typeof e.options.enableSubRowSelection == "function" ? e.options.enableSubRowSelection(t) : (n = e.options.enableSubRowSelection) != null ? n : !0;
    }, t.getCanMultiSelect = () => {
      var n;
      return typeof e.options.enableMultiRowSelection == "function" ? e.options.enableMultiRowSelection(t) : (n = e.options.enableMultiRowSelection) != null ? n : !0;
    }, t.getToggleSelectedHandler = () => {
      const n = t.getCanSelect();
      return (r) => {
        var o;
        n && t.toggleSelected((o = r.target) == null ? void 0 : o.checked);
      };
    };
  }
}, Yu = (t, e, n, r, o) => {
  var i;
  const s = o.getRow(e, !0);
  n ? (s.getCanMultiSelect() || Object.keys(t).forEach((l) => delete t[l]), s.getCanSelect() && (t[e] = !0)) : delete t[e], r && (i = s.subRows) != null && i.length && s.getCanSelectSubRows() && s.subRows.forEach((l) => Yu(t, l.id, n, r, o));
};
function Nd(t, e) {
  const n = t.getState().rowSelection, r = [], o = {}, i = function(s, l) {
    return s.map((a) => {
      var c;
      const d = Ch(a, n);
      if (d && (r.push(a), o[a.id] = a), (c = a.subRows) != null && c.length && (a = {
        ...a,
        subRows: i(a.subRows)
      }), d)
        return a;
    }).filter(Boolean);
  };
  return {
    rows: i(e.rows),
    flatRows: r,
    rowsById: o
  };
}
function Ch(t, e) {
  var n;
  return (n = e[t.id]) != null ? n : !1;
}
function Zu(t, e, n) {
  var r;
  if (!((r = t.subRows) != null && r.length)) return !1;
  let o = !0, i = !1;
  return t.subRows.forEach((s) => {
    if (!(i && !o) && (s.getCanSelect() && (Ch(s, e) ? i = !0 : o = !1), s.subRows && s.subRows.length)) {
      const l = Zu(s, e);
      l === "all" ? i = !0 : (l === "some" && (i = !0), o = !1);
    }
  }), o ? "all" : i ? "some" : !1;
}
const Xu = /([0-9]+)/gm, c6 = (t, e, n) => pS(So(t.getValue(n)).toLowerCase(), So(e.getValue(n)).toLowerCase()), d6 = (t, e, n) => pS(So(t.getValue(n)), So(e.getValue(n))), u6 = (t, e, n) => vh(So(t.getValue(n)).toLowerCase(), So(e.getValue(n)).toLowerCase()), f6 = (t, e, n) => vh(So(t.getValue(n)), So(e.getValue(n))), h6 = (t, e, n) => {
  const r = t.getValue(n), o = e.getValue(n);
  return r > o ? 1 : r < o ? -1 : 0;
}, p6 = (t, e, n) => vh(t.getValue(n), e.getValue(n));
function vh(t, e) {
  return t === e ? 0 : t > e ? 1 : -1;
}
function So(t) {
  return typeof t == "number" ? isNaN(t) || t === 1 / 0 || t === -1 / 0 ? "" : String(t) : typeof t == "string" ? t : "";
}
function pS(t, e) {
  const n = t.split(Xu).filter(Boolean), r = e.split(Xu).filter(Boolean);
  for (; n.length && r.length; ) {
    const o = n.shift(), i = r.shift(), s = parseInt(o, 10), l = parseInt(i, 10), a = [s, l].sort();
    if (isNaN(a[0])) {
      if (o > i)
        return 1;
      if (i > o)
        return -1;
      continue;
    }
    if (isNaN(a[1]))
      return isNaN(s) ? -1 : 1;
    if (s > l)
      return 1;
    if (l > s)
      return -1;
  }
  return n.length - r.length;
}
const ls = {
  alphanumeric: c6,
  alphanumericCaseSensitive: d6,
  text: u6,
  textCaseSensitive: f6,
  datetime: h6,
  basic: p6
}, g6 = {
  getInitialState: (t) => ({
    sorting: [],
    ...t
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (t) => ({
    onSortingChange: On("sorting", t),
    isMultiSortEvent: (e) => e.shiftKey
  }),
  createColumn: (t, e) => {
    t.getAutoSortingFn = () => {
      const n = e.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const o of n) {
        const i = o == null ? void 0 : o.getValue(t.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return ls.datetime;
        if (typeof i == "string" && (r = !0, i.split(Xu).length > 1))
          return ls.alphanumeric;
      }
      return r ? ls.text : ls.basic;
    }, t.getAutoSortDir = () => {
      const n = e.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(t.id)) == "string" ? "asc" : "desc";
    }, t.getSortingFn = () => {
      var n, r;
      if (!t)
        throw new Error();
      return sc(t.columnDef.sortingFn) ? t.columnDef.sortingFn : t.columnDef.sortingFn === "auto" ? t.getAutoSortingFn() : (n = (r = e.options.sortingFns) == null ? void 0 : r[t.columnDef.sortingFn]) != null ? n : ls[t.columnDef.sortingFn];
    }, t.toggleSorting = (n, r) => {
      const o = t.getNextSortingOrder(), i = typeof n < "u" && n !== null;
      e.setSorting((s) => {
        const l = s == null ? void 0 : s.find((h) => h.id === t.id), a = s == null ? void 0 : s.findIndex((h) => h.id === t.id);
        let c = [], d, u = i ? n : o === "desc";
        if (s != null && s.length && t.getCanMultiSort() && r ? l ? d = "toggle" : d = "add" : s != null && s.length && a !== s.length - 1 ? d = "replace" : l ? d = "toggle" : d = "replace", d === "toggle" && (i || o || (d = "remove")), d === "add") {
          var f;
          c = [...s, {
            id: t.id,
            desc: u
          }], c.splice(0, c.length - ((f = e.options.maxMultiSortColCount) != null ? f : Number.MAX_SAFE_INTEGER));
        } else d === "toggle" ? c = s.map((h) => h.id === t.id ? {
          ...h,
          desc: u
        } : h) : d === "remove" ? c = s.filter((h) => h.id !== t.id) : c = [{
          id: t.id,
          desc: u
        }];
        return c;
      });
    }, t.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = t.columnDef.sortDescFirst) != null ? r : e.options.sortDescFirst) != null ? n : t.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, t.getNextSortingOrder = (n) => {
      var r, o;
      const i = t.getFirstSortDir(), s = t.getIsSorted();
      return s ? s !== i && ((r = e.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (o = e.options.enableMultiRemove) != null) || o) ? !1 : s === "desc" ? "asc" : "desc" : i;
    }, t.getCanSort = () => {
      var n, r;
      return ((n = t.columnDef.enableSorting) != null ? n : !0) && ((r = e.options.enableSorting) != null ? r : !0) && !!t.accessorFn;
    }, t.getCanMultiSort = () => {
      var n, r;
      return (n = (r = t.columnDef.enableMultiSort) != null ? r : e.options.enableMultiSort) != null ? n : !!t.accessorFn;
    }, t.getIsSorted = () => {
      var n;
      const r = (n = e.getState().sorting) == null ? void 0 : n.find((o) => o.id === t.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, t.getSortIndex = () => {
      var n, r;
      return (n = (r = e.getState().sorting) == null ? void 0 : r.findIndex((o) => o.id === t.id)) != null ? n : -1;
    }, t.clearSorting = () => {
      e.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== t.id) : []);
    }, t.getToggleSortingHandler = () => {
      const n = t.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), t.toggleSorting == null || t.toggleSorting(void 0, t.getCanMultiSort() ? e.options.isMultiSortEvent == null ? void 0 : e.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (t) => {
    t.setSorting = (e) => t.options.onSortingChange == null ? void 0 : t.options.onSortingChange(e), t.resetSorting = (e) => {
      var n, r;
      t.setSorting(e ? [] : (n = (r = t.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, t.getPreSortedRowModel = () => t.getGroupedRowModel(), t.getSortedRowModel = () => (!t._getSortedRowModel && t.options.getSortedRowModel && (t._getSortedRowModel = t.options.getSortedRowModel(t)), t.options.manualSorting || !t._getSortedRowModel ? t.getPreSortedRowModel() : t._getSortedRowModel());
  }
}, m6 = {
  getInitialState: (t) => ({
    columnVisibility: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnVisibilityChange: On("columnVisibility", t)
  }),
  createColumn: (t, e) => {
    t.toggleVisibility = (n) => {
      t.getCanHide() && e.setColumnVisibility((r) => ({
        ...r,
        [t.id]: n ?? !t.getIsVisible()
      }));
    }, t.getIsVisible = () => {
      var n, r;
      return (n = (r = e.getState().columnVisibility) == null ? void 0 : r[t.id]) != null ? n : !0;
    }, t.getCanHide = () => {
      var n, r;
      return ((n = t.columnDef.enableHiding) != null ? n : !0) && ((r = e.options.enableHiding) != null ? r : !0);
    }, t.getToggleVisibilityHandler = () => (n) => {
      t.toggleVisibility == null || t.toggleVisibility(n.target.checked);
    };
  },
  createRow: (t, e) => {
    t._getAllVisibleCells = be(() => [t.getAllCells(), e.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), {
      key: process.env.NODE_ENV === "production" && "row._getAllVisibleCells",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugRows;
      }
    }), t.getVisibleCells = be(() => [t.getLeftVisibleCells(), t.getCenterVisibleCells(), t.getRightVisibleCells()], (n, r, o) => [...n, ...r, ...o], {
      key: process.env.NODE_ENV === "development" && "row.getVisibleCells",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugRows;
      }
    });
  },
  createTable: (t) => {
    const e = (n, r) => be(() => [r(), r().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), {
      key: n,
      debug: () => {
        var o;
        return (o = t.options.debugAll) != null ? o : t.options.debugColumns;
      }
    });
    t.getVisibleFlatColumns = e("getVisibleFlatColumns", () => t.getAllFlatColumns()), t.getVisibleLeafColumns = e("getVisibleLeafColumns", () => t.getAllLeafColumns()), t.getLeftVisibleLeafColumns = e("getLeftVisibleLeafColumns", () => t.getLeftLeafColumns()), t.getRightVisibleLeafColumns = e("getRightVisibleLeafColumns", () => t.getRightLeafColumns()), t.getCenterVisibleLeafColumns = e("getCenterVisibleLeafColumns", () => t.getCenterLeafColumns()), t.setColumnVisibility = (n) => t.options.onColumnVisibilityChange == null ? void 0 : t.options.onColumnVisibilityChange(n), t.resetColumnVisibility = (n) => {
      var r;
      t.setColumnVisibility(n ? {} : (r = t.initialState.columnVisibility) != null ? r : {});
    }, t.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !t.getIsAllColumnsVisible(), t.setColumnVisibility(t.getAllLeafColumns().reduce((o, i) => ({
        ...o,
        [i.id]: n || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, t.getIsAllColumnsVisible = () => !t.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), t.getIsSomeColumnsVisible = () => t.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), t.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      t.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
}, Am = [jN, m6, i6, l6, qN, g6, r6, UN, s6, a6, WN];
function y6(t) {
  var e;
  (t.debugAll || t.debugTable) && console.info("Creating Table Instance...");
  let n = {
    _features: Am
  };
  const r = n._features.reduce((d, u) => Object.assign(d, u.getDefaultOptions == null ? void 0 : u.getDefaultOptions(n)), {}), o = (d) => n.options.mergeOptions ? n.options.mergeOptions(r, d) : {
    ...r,
    ...d
  };
  let s = {
    ...{},
    ...(e = t.initialState) != null ? e : {}
  };
  n._features.forEach((d) => {
    var u;
    s = (u = d.getInitialState == null ? void 0 : d.getInitialState(s)) != null ? u : s;
  });
  const l = [];
  let a = !1;
  const c = {
    _features: Am,
    options: {
      ...r,
      ...t
    },
    initialState: s,
    _queue: (d) => {
      l.push(d), a || (a = !0, Promise.resolve().then(() => {
        for (; l.length; )
          l.shift()();
        a = !1;
      }).catch((u) => setTimeout(() => {
        throw u;
      })));
    },
    reset: () => {
      n.setState(n.initialState);
    },
    setOptions: (d) => {
      const u = ao(d, n.options);
      n.options = o(u);
    },
    getState: () => n.options.state,
    setState: (d) => {
      n.options.onStateChange == null || n.options.onStateChange(d);
    },
    _getRowId: (d, u, f) => {
      var h;
      return (h = n.options.getRowId == null ? void 0 : n.options.getRowId(d, u, f)) != null ? h : `${f ? [f.id, u].join(".") : u}`;
    },
    getCoreRowModel: () => (n._getCoreRowModel || (n._getCoreRowModel = n.options.getCoreRowModel(n)), n._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => n.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (d, u) => {
      let f = (u ? n.getPrePaginationRowModel() : n.getRowModel()).rowsById[d];
      if (!f && (f = n.getCoreRowModel().rowsById[d], !f))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${d}`) : new Error();
      return f;
    },
    _getDefaultColumnDef: be(() => [n.options.defaultColumn], (d) => {
      var u;
      return d = (u = d) != null ? u : {}, {
        header: (f) => {
          const h = f.header.column.columnDef;
          return h.accessorKey ? h.accessorKey : h.accessorFn ? h.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (f) => {
          var h, p;
          return (h = (p = f.renderValue()) == null || p.toString == null ? void 0 : p.toString()) != null ? h : null;
        },
        ...n._features.reduce((f, h) => Object.assign(f, h.getDefaultColumnDef == null ? void 0 : h.getDefaultColumnDef()), {}),
        ...d
      };
    }, {
      debug: () => {
        var d;
        return (d = n.options.debugAll) != null ? d : n.options.debugColumns;
      },
      key: process.env.NODE_ENV === "development" && "getDefaultColumnDef"
    }),
    _getColumnDefs: () => n.options.columns,
    getAllColumns: be(() => [n._getColumnDefs()], (d) => {
      const u = function(f, h, p) {
        return p === void 0 && (p = 0), f.map((y) => {
          const b = HN(n, y, p, h), w = y;
          return b.columns = w.columns ? u(w.columns, b, p + 1) : [], b;
        });
      };
      return u(d);
    }, {
      key: process.env.NODE_ENV === "development" && "getAllColumns",
      debug: () => {
        var d;
        return (d = n.options.debugAll) != null ? d : n.options.debugColumns;
      }
    }),
    getAllFlatColumns: be(() => [n.getAllColumns()], (d) => d.flatMap((u) => u.getFlatColumns()), {
      key: process.env.NODE_ENV === "development" && "getAllFlatColumns",
      debug: () => {
        var d;
        return (d = n.options.debugAll) != null ? d : n.options.debugColumns;
      }
    }),
    _getAllFlatColumnsById: be(() => [n.getAllFlatColumns()], (d) => d.reduce((u, f) => (u[f.id] = f, u), {}), {
      key: process.env.NODE_ENV === "development" && "getAllFlatColumnsById",
      debug: () => {
        var d;
        return (d = n.options.debugAll) != null ? d : n.options.debugColumns;
      }
    }),
    getAllLeafColumns: be(() => [n.getAllColumns(), n._getOrderColumnsFn()], (d, u) => {
      let f = d.flatMap((h) => h.getLeafColumns());
      return u(f);
    }, {
      key: process.env.NODE_ENV === "development" && "getAllLeafColumns",
      debug: () => {
        var d;
        return (d = n.options.debugAll) != null ? d : n.options.debugColumns;
      }
    }),
    getColumn: (d) => {
      const u = n._getAllFlatColumnsById()[d];
      return process.env.NODE_ENV !== "production" && !u && console.error(`[Table] Column with id '${d}' does not exist.`), u;
    }
  };
  Object.assign(n, c);
  for (let d = 0; d < n._features.length; d++) {
    const u = n._features[d];
    u == null || u.createTable == null || u.createTable(n);
  }
  return n;
}
function b6(t, e, n, r) {
  const o = () => {
    var s;
    return (s = i.getValue()) != null ? s : t.options.renderFallbackValue;
  }, i = {
    id: `${e.id}_${n.id}`,
    row: e,
    column: n,
    getValue: () => e.getValue(r),
    renderValue: o,
    getContext: be(() => [t, n, e, i], (s, l, a, c) => ({
      table: s,
      column: l,
      row: a,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), {
      key: process.env.NODE_ENV === "development" && "cell.getContext",
      debug: () => t.options.debugAll
    })
  };
  return t._features.forEach((s) => {
    s.createCell == null || s.createCell(i, n, e, t);
  }, {}), i;
}
const xh = (t, e, n, r, o, i, s) => {
  let l = {
    id: e,
    index: r,
    original: n,
    depth: o,
    parentId: s,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (a) => {
      if (l._valuesCache.hasOwnProperty(a))
        return l._valuesCache[a];
      const c = t.getColumn(a);
      if (c != null && c.accessorFn)
        return l._valuesCache[a] = c.accessorFn(l.original, r), l._valuesCache[a];
    },
    getUniqueValues: (a) => {
      if (l._uniqueValuesCache.hasOwnProperty(a))
        return l._uniqueValuesCache[a];
      const c = t.getColumn(a);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (l._uniqueValuesCache[a] = c.columnDef.getUniqueValues(l.original, r), l._uniqueValuesCache[a]) : (l._uniqueValuesCache[a] = [l.getValue(a)], l._uniqueValuesCache[a]);
    },
    renderValue: (a) => {
      var c;
      return (c = l.getValue(a)) != null ? c : t.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => zN(l.subRows, (a) => a.subRows),
    getParentRow: () => l.parentId ? t.getRow(l.parentId, !0) : void 0,
    getParentRows: () => {
      let a = [], c = l;
      for (; ; ) {
        const d = c.getParentRow();
        if (!d) break;
        a.push(d), c = d;
      }
      return a.reverse();
    },
    getAllCells: be(() => [t.getAllLeafColumns()], (a) => a.map((c) => b6(t, l, c, c.id)), {
      key: process.env.NODE_ENV === "development" && "row.getAllCells",
      debug: () => {
        var a;
        return (a = t.options.debugAll) != null ? a : t.options.debugRows;
      }
    }),
    _getAllCellsByColumnId: be(() => [l.getAllCells()], (a) => a.reduce((c, d) => (c[d.column.id] = d, c), {}), {
      key: process.env.NODE_ENV === "production" && "row.getAllCellsByColumnId",
      debug: () => {
        var a;
        return (a = t.options.debugAll) != null ? a : t.options.debugRows;
      }
    })
  };
  for (let a = 0; a < t._features.length; a++) {
    const c = t._features[a];
    c == null || c.createRow == null || c.createRow(l, t);
  }
  return l;
};
function w6() {
  return {
    accessor: (t, e) => typeof t == "function" ? {
      ...e,
      accessorFn: t
    } : {
      ...e,
      accessorKey: t
    },
    display: (t) => t,
    group: (t) => t
  };
}
function gS() {
  return (t) => be(() => [t.options.data], (e) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(o, i, s) {
      i === void 0 && (i = 0);
      const l = [];
      for (let c = 0; c < o.length; c++) {
        const d = xh(t, t._getRowId(o[c], c, s), o[c], c, i, void 0, s == null ? void 0 : s.id);
        if (n.flatRows.push(d), n.rowsById[d.id] = d, l.push(d), t.options.getSubRows) {
          var a;
          d.originalSubRows = t.options.getSubRows(o[c], c), (a = d.originalSubRows) != null && a.length && (d.subRows = r(d.originalSubRows, i + 1, d));
        }
      }
      return l;
    };
    return n.rows = r(e), n;
  }, {
    key: process.env.NODE_ENV === "development" && "getRowModel",
    debug: () => {
      var e;
      return (e = t.options.debugAll) != null ? e : t.options.debugTable;
    },
    onChange: () => {
      t._autoResetPageIndex();
    }
  });
}
function S6(t, e, n) {
  return n.options.filterFromLeafRows ? C6(t, e, n) : v6(t, e, n);
}
function C6(t, e, n) {
  var r;
  const o = [], i = {}, s = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, l = function(a, c) {
    c === void 0 && (c = 0);
    const d = [];
    for (let f = 0; f < a.length; f++) {
      var u;
      let h = a[f];
      const p = xh(n, h.id, h.original, h.index, h.depth, void 0, h.parentId);
      if (p.columnFilters = h.columnFilters, (u = h.subRows) != null && u.length && c < s) {
        if (p.subRows = l(h.subRows, c + 1), h = p, e(h) && !p.subRows.length) {
          d.push(h), i[h.id] = h, o.push(h);
          continue;
        }
        if (e(h) || p.subRows.length) {
          d.push(h), i[h.id] = h, o.push(h);
          continue;
        }
      } else
        h = p, e(h) && (d.push(h), i[h.id] = h, o.push(h));
    }
    return d;
  };
  return {
    rows: l(t),
    flatRows: o,
    rowsById: i
  };
}
function v6(t, e, n) {
  var r;
  const o = [], i = {}, s = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, l = function(a, c) {
    c === void 0 && (c = 0);
    const d = [];
    for (let f = 0; f < a.length; f++) {
      let h = a[f];
      if (e(h)) {
        var u;
        if ((u = h.subRows) != null && u.length && c < s) {
          const y = xh(n, h.id, h.original, h.index, h.depth, void 0, h.parentId);
          y.subRows = l(h.subRows, c + 1), h = y;
        }
        d.push(h), o.push(h), i[h.id] = h;
      }
    }
    return d;
  };
  return {
    rows: l(t),
    flatRows: o,
    rowsById: i
  };
}
function x6() {
  return (t) => be(() => [t.getPreFilteredRowModel(), t.getState().columnFilters, t.getState().globalFilter], (e, n, r) => {
    if (!e.rows.length || !(n != null && n.length) && !r) {
      for (let f = 0; f < e.flatRows.length; f++)
        e.flatRows[f].columnFilters = {}, e.flatRows[f].columnFiltersMeta = {};
      return e;
    }
    const o = [], i = [];
    (n ?? []).forEach((f) => {
      var h;
      const p = t.getColumn(f.id);
      if (!p)
        return;
      const y = p.getFilterFn();
      if (!y) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${p.id}.`);
        return;
      }
      o.push({
        id: f.id,
        filterFn: y,
        resolvedValue: (h = y.resolveFilterValue == null ? void 0 : y.resolveFilterValue(f.value)) != null ? h : f.value
      });
    });
    const s = n.map((f) => f.id), l = t.getGlobalFilterFn(), a = t.getAllLeafColumns().filter((f) => f.getCanGlobalFilter());
    r && l && a.length && (s.push("__global__"), a.forEach((f) => {
      var h;
      i.push({
        id: f.id,
        filterFn: l,
        resolvedValue: (h = l.resolveFilterValue == null ? void 0 : l.resolveFilterValue(r)) != null ? h : r
      });
    }));
    let c, d;
    for (let f = 0; f < e.flatRows.length; f++) {
      const h = e.flatRows[f];
      if (h.columnFilters = {}, o.length)
        for (let p = 0; p < o.length; p++) {
          c = o[p];
          const y = c.id;
          h.columnFilters[y] = c.filterFn(h, y, c.resolvedValue, (b) => {
            h.columnFiltersMeta[y] = b;
          });
        }
      if (i.length) {
        for (let p = 0; p < i.length; p++) {
          d = i[p];
          const y = d.id;
          if (d.filterFn(h, y, d.resolvedValue, (b) => {
            h.columnFiltersMeta[y] = b;
          })) {
            h.columnFilters.__global__ = !0;
            break;
          }
        }
        h.columnFilters.__global__ !== !0 && (h.columnFilters.__global__ = !1);
      }
    }
    const u = (f) => {
      for (let h = 0; h < s.length; h++)
        if (f.columnFilters[s[h]] === !1)
          return !1;
      return !0;
    };
    return S6(e.rows, u, t);
  }, {
    key: process.env.NODE_ENV === "development" && "getFilteredRowModel",
    debug: () => {
      var e;
      return (e = t.options.debugAll) != null ? e : t.options.debugTable;
    },
    onChange: () => {
      t._autoResetPageIndex();
    }
  });
}
function E6() {
  return (t) => be(() => [t.getState().sorting, t.getPreSortedRowModel()], (e, n) => {
    if (!n.rows.length || !(e != null && e.length))
      return n;
    const r = t.getState().sorting, o = [], i = r.filter((a) => {
      var c;
      return (c = t.getColumn(a.id)) == null ? void 0 : c.getCanSort();
    }), s = {};
    i.forEach((a) => {
      const c = t.getColumn(a.id);
      c && (s[a.id] = {
        sortUndefined: c.columnDef.sortUndefined,
        invertSorting: c.columnDef.invertSorting,
        sortingFn: c.getSortingFn()
      });
    });
    const l = (a) => {
      const c = a.map((d) => ({
        ...d
      }));
      return c.sort((d, u) => {
        for (let h = 0; h < i.length; h += 1) {
          var f;
          const p = i[h], y = s[p.id], b = (f = p == null ? void 0 : p.desc) != null ? f : !1;
          let w = 0;
          if (y.sortUndefined) {
            const S = d.getValue(p.id), x = u.getValue(p.id), E = S === void 0, v = x === void 0;
            (E || v) && (w = E && v ? 0 : E ? y.sortUndefined : -y.sortUndefined);
          }
          if (w === 0 && (w = y.sortingFn(d, u, p.id)), w !== 0)
            return b && (w *= -1), y.invertSorting && (w *= -1), w;
        }
        return d.index - u.index;
      }), c.forEach((d) => {
        var u;
        o.push(d), (u = d.subRows) != null && u.length && (d.subRows = l(d.subRows));
      }), c;
    };
    return {
      rows: l(n.rows),
      flatRows: o,
      rowsById: n.rowsById
    };
  }, {
    key: process.env.NODE_ENV === "development" && "getSortedRowModel",
    debug: () => {
      var e;
      return (e = t.options.debugAll) != null ? e : t.options.debugTable;
    },
    onChange: () => {
      t._autoResetPageIndex();
    }
  });
}
function k6(t) {
  const e = [], n = (r) => {
    var o;
    e.push(r), (o = r.subRows) != null && o.length && r.getIsExpanded() && r.subRows.forEach(n);
  };
  return t.rows.forEach(n), {
    rows: e,
    flatRows: t.flatRows,
    rowsById: t.rowsById
  };
}
function T6(t) {
  return (e) => be(() => [e.getState().pagination, e.getPrePaginationRowModel(), e.options.paginateExpandedRows ? void 0 : e.getState().expanded], (n, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: o,
      pageIndex: i
    } = n;
    let {
      rows: s,
      flatRows: l,
      rowsById: a
    } = r;
    const c = o * i, d = c + o;
    s = s.slice(c, d);
    let u;
    e.options.paginateExpandedRows ? u = {
      rows: s,
      flatRows: l,
      rowsById: a
    } : u = k6({
      rows: s,
      flatRows: l,
      rowsById: a
    }), u.flatRows = [];
    const f = (h) => {
      u.flatRows.push(h), h.subRows.length && h.subRows.forEach(f);
    };
    return u.rows.forEach(f), u;
  }, {
    key: process.env.NODE_ENV === "development" && "getPaginationRowModel",
    debug: () => {
      var n;
      return (n = e.options.debugAll) != null ? n : e.options.debugTable;
    }
  });
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Zs(t, e) {
  return t ? I6(t) ? /* @__PURE__ */ Lr.createElement(t, e) : t : null;
}
function I6(t) {
  return M6(t) || typeof t == "function" || R6(t);
}
function M6(t) {
  return typeof t == "function" && (() => {
    const e = Object.getPrototypeOf(t);
    return e.prototype && e.prototype.isReactComponent;
  })();
}
function R6(t) {
  return typeof t == "object" && typeof t.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(t.$$typeof.description);
}
function mS(t) {
  const e = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...t
  }, [n] = Lr.useState(() => ({
    current: y6(e)
  })), [r, o] = Lr.useState(() => n.current.initialState);
  return n.current.setOptions((i) => ({
    ...i,
    ...t,
    state: {
      ...r,
      ...t.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (s) => {
      o(s), t.onStateChange == null || t.onStateChange(s);
    }
  })), n.current;
}
const O6 = () => {
  const t = Nt(null), [e, n] = ie(!0), r = te(
    ({ x: o }) => {
      const i = t.current;
      if (!i) {
        n(!0);
        return;
      }
      const { scrollWidth: s, clientWidth: l } = i, a = o + l >= s;
      n(a);
    },
    [t]
  );
  return It(() => {
    const o = new ResizeObserver(() => {
      var i, s;
      r({ x: ((i = t.current) == null ? void 0 : i.scrollLeft) || 0, y: ((s = t.current) == null ? void 0 : s.scrollTop) || 0 });
    });
    return t.current && o.observe(t.current), () => {
      o.disconnect();
    };
  }, [r]), {
    scrollReference: t,
    handleScrollPositionChange: r,
    isLastScrollableVisible: e
  };
}, zd = (t, e) => t === e - 1, D6 = O(
  (t, {
    withRowHandler: e,
    withBorders: n,
    withStickyLastColumn: r,
    rowGaps: o
  }) => {
    const i = Ae(["background-color"]), s = n ? 0 : m(t.other.borderRadius[8]), l = "linear-gradient(270deg, rgba(78, 74, 81, 0.1) 0%, rgba(255, 255, 255, 0) 100%)", a = 7;
    return {
      root: {
        width: "100%",
        borderTopLeftRadius: s,
        borderTopRightRadius: s,
        borderBottomLeftRadius: s,
        borderBottomRightRadius: s
      },
      container: {
        height: "auto",
        borderTopLeftRadius: s,
        borderTopRightRadius: s,
        borderBottomLeftRadius: t.other.borderRadius[8],
        borderBottomRightRadius: t.other.borderRadius[8]
      },
      viewport: {
        "& > div": {
          display: "table"
        }
      },
      table: {
        width: "100%"
      },
      thead: {
        margin: 0,
        backgroundColor: t.other.colors.greyIron[0]
      },
      theadTr: {
        display: "flex",
        position: "relative",
        "&:after": {
          position: "absolute",
          content: '""',
          width: "100%",
          left: 0,
          right: 0,
          bottom: 0
        }
      },
      theadTh: {
        textAlign: "left",
        wordBreak: "break-all",
        padding: `${m(a)} ${m(16)}`,
        flexWrap: "nowrap",
        whiteSpace: "nowrap",
        font: t.other.fonts.desktop.s.s.important,
        backgroundColor: t.other.colors.greyIron[0],
        color: t.other.colors.greyIron[12],
        "&:first-of-type": {
          borderTopLeftRadius: s,
          borderBottomLeftRadius: s
        },
        "&:last-of-type": {
          borderTopRightRadius: s,
          borderBottomRightRadius: s,
          position: r ? "sticky" : "relative",
          zIndex: r ? 10 : "auto",
          right: r ? -1 : 0
        }
      },
      tBody: {},
      tr: {
        display: "flex",
        transition: i,
        position: "relative",
        borderTop: n ? `${m(1)} solid ${t.other.colors.greyIron[4]}` : "none",
        [`&&:hover .${Dr}`]: {
          ...e ? {
            backgroundColor: t.other.colors.brand[0],
            cursor: "pointer"
          } : {}
        }
      },
      td: {
        display: "flex",
        transition: i,
        boxSizing: "border-box",
        padding: `${m(8)} ${m(16)}`,
        wordBreak: "break-word",
        alignItems: "center",
        font: t.other.fonts.desktop.s.s.default,
        color: t.other.colors.greyIron[21],
        backgroundColor: t.other.colors.white,
        borderWidth: 0,
        alignSelf: "stretch",
        "&:first-of-type": {
          borderTopLeftRadius: s,
          borderBottomLeftRadius: s
        },
        "&:last-of-type": {
          borderTopRightRadius: s,
          borderBottomRightRadius: s,
          position: r ? "sticky" : "relative",
          zIndex: r ? 10 : "auto",
          right: r ? -1 : 0
        }
      },
      alignRight: {
        textAlign: "right",
        justifyContent: "flex-end"
      },
      alignLeft: {
        textAlign: "left",
        justifyContent: "flex-start"
      },
      alignCenter: {
        textAlign: "center",
        justifyContent: "center"
      },
      stickyShadowCell: {
        "&::after": {
          background: l,
          content: '""',
          width: m(40),
          height: `calc(100% + ${m(o + 1)})`,
          top: -o,
          left: m(-40),
          bottom: 0,
          position: "absolute"
        }
      },
      stickyShadowHeader: {
        "&::after": {
          content: '""',
          background: l,
          width: m(40),
          height: `calc(100% + ${m((a + 3) * 2)})`,
          top: -10,
          left: m(-40),
          bottom: 0,
          position: "absolute"
        }
      },
      lastRowStickyShadow: {
        "&::after": {
          content: '""',
          background: l,
          width: m(40),
          height: "100%",
          top: -o,
          left: m(-40),
          position: "absolute"
        }
      }
    };
  }
), wz = (t) => {
  const {
    data: e,
    columns: n,
    rowGaps: r = 8,
    withBorders: o,
    onRowClick: i,
    withStickyLastColumn: s,
    classNames: l,
    className: a,
    ...c
  } = t, { classes: d, cx: u } = D6({
    withRowHandler: i !== void 0,
    withBorders: o,
    withStickyLastColumn: s,
    rowGaps: r
  }), f = mS({
    data: e,
    getRowId: (b, w, S) => (S == null ? void 0 : S.id) || (b == null ? void 0 : b.id) || w,
    columns: n.filter(Boolean),
    getCoreRowModel: gS()
  }), { scrollReference: h, handleScrollPositionChange: p, isLastScrollableVisible: y } = O6();
  return /* @__PURE__ */ g.createElement(oe, { component: "div", className: u(d.root, l == null ? void 0 : l.root, a), ...c }, /* @__PURE__ */ g.createElement(
    Fr,
    {
      className: u(d.container, l == null ? void 0 : l.container),
      classNames: {
        viewport: u(d.viewport, l == null ? void 0 : l.viewport)
      },
      type: "auto",
      viewportRef: h,
      onScrollPositionChange: p
    },
    /* @__PURE__ */ g.createElement(Ee, { gap: r, role: "table", className: u(d.table, l == null ? void 0 : l.table) }, /* @__PURE__ */ g.createElement(oe, { component: "div", role: "rowgroup", className: u(d.thead, l == null ? void 0 : l.thead) }, f.getHeaderGroups().map((b) => /* @__PURE__ */ g.createElement(X, { gap: 0, role: "row", key: b.id, className: u(d.theadTr, l == null ? void 0 : l.theadTr), wrap: "nowrap" }, b.headers.map((w, S) => {
      var x, E, v, T;
      return /* @__PURE__ */ g.createElement(at, { key: w.id, label: (x = w.column.columnDef.meta) == null ? void 0 : x.tooltipText }, /* @__PURE__ */ g.createElement(
        oe,
        {
          component: "div",
          role: "columnheader",
          className: u(d.theadTh, l == null ? void 0 : l.theadTh, {
            [u(d.stickyShadowHeader, l == null ? void 0 : l.stickyShadowHeader)]: s && !y,
            [u(d.alignLeft, l == null ? void 0 : l.alignLeft)]: ((E = w.column.columnDef.meta) == null ? void 0 : E.align) === "left",
            [u(d.alignRight, l == null ? void 0 : l.alignRight)]: ((v = w.column.columnDef.meta) == null ? void 0 : v.align) === "right",
            [u(d.alignCenter, l == null ? void 0 : l.alignCenter)]: ((T = w.column.columnDef.meta) == null ? void 0 : T.align) === "center"
          }),
          style: {
            flexGrow: zd(S, b.headers.length) ? 0 : 1
          },
          w: w.getSize() || void 0
        },
        Zs(w.column.columnDef.header, w.getContext())
      ));
    })))), /* @__PURE__ */ g.createElement(Ee, { gap: r, role: "rowgroup", className: u(d.tBody, l == null ? void 0 : l.tBody) }, f.getRowModel().rows.map((b, w) => /* @__PURE__ */ g.createElement(
      X,
      {
        role: "row",
        key: b.id,
        gap: 0,
        justify: "space-between",
        wrap: "nowrap",
        className: u(d.tr, l == null ? void 0 : l.tr),
        onClick: () => {
          i == null || i(b.original);
        }
      },
      b.getVisibleCells().map((S, x) => {
        var E, v, T;
        return /* @__PURE__ */ g.createElement(
          oe,
          {
            role: "cell",
            key: S.id,
            className: u(d.td, l == null ? void 0 : l.td, Dr, {
              [u(d.stickyShadowCell, l == null ? void 0 : l.stickyShadowCell)]: s && !y,
              [u(d.lastRowStickyShadow, l == null ? void 0 : l.lastRowStickyShadow)]: zd(w, f.getRowModel().rows.length) && s && !y,
              [u(d.alignLeft, l == null ? void 0 : l.alignLeft)]: ((E = S.column.columnDef.meta) == null ? void 0 : E.align) === "left",
              [u(d.alignRight, l == null ? void 0 : l.alignRight)]: ((v = S.column.columnDef.meta) == null ? void 0 : v.align) === "right",
              [u(d.alignCenter, l == null ? void 0 : l.alignCenter)]: ((T = S.column.columnDef.meta) == null ? void 0 : T.align) === "center"
            }),
            style: {
              flexGrow: zd(x, b.getVisibleCells().length) ? 0 : 1
            },
            w: S.column.getSize() || void 0
          },
          Zs(S.column.columnDef.cell, S.getContext())
        );
      })
    ))))
  ));
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var mo = function() {
  return mo = Object.assign || function(e) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, mo.apply(this, arguments);
};
function A6(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(t); o < r.length; o++)
      e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  return n;
}
var L6 = function() {
  return Math.random().toString(36).substring(6);
}, $6 = function(t) {
  var e = t.animate, n = e === void 0 ? !0 : e, r = t.animateBegin, o = t.backgroundColor, i = o === void 0 ? "#f5f6f7" : o, s = t.backgroundOpacity, l = s === void 0 ? 1 : s, a = t.baseUrl, c = a === void 0 ? "" : a, d = t.children, u = t.foregroundColor, f = u === void 0 ? "#eee" : u, h = t.foregroundOpacity, p = h === void 0 ? 1 : h, y = t.gradientRatio, b = y === void 0 ? 2 : y, w = t.gradientDirection, S = w === void 0 ? "left-right" : w, x = t.uniqueKey, E = t.interval, v = E === void 0 ? 0.25 : E, T = t.rtl, I = T === void 0 ? !1 : T, M = t.speed, R = M === void 0 ? 1.2 : M, A = t.style, F = A === void 0 ? {} : A, V = t.title, P = V === void 0 ? "Loading..." : V, J = t.beforeMask, ne = J === void 0 ? null : J, G = A6(t, ["animate", "animateBegin", "backgroundColor", "backgroundOpacity", "baseUrl", "children", "foregroundColor", "foregroundOpacity", "gradientRatio", "gradientDirection", "uniqueKey", "interval", "rtl", "speed", "style", "title", "beforeMask"]), H = x || L6(), W = H + "-diff", se = H + "-animated-diff", U = H + "-aria", re = I ? { transform: "scaleX(-1)" } : null, ke = "0; " + v + "; 1", Te = R + "s", Se = S === "top-bottom" ? "rotate(90)" : void 0;
  return At(
    "svg",
    mo({ "aria-labelledby": U, role: "img", style: mo(mo({}, F), re) }, G),
    P ? At("title", { id: U }, P) : null,
    ne && RS(ne) ? ne : null,
    At("rect", { role: "presentation", x: "0", y: "0", width: "100%", height: "100%", clipPath: "url(" + c + "#" + W + ")", style: { fill: "url(" + c + "#" + se + ")" } }),
    At(
      "defs",
      null,
      At("clipPath", { id: W }, d),
      At(
        "linearGradient",
        { id: se, gradientTransform: Se },
        At("stop", { offset: "0%", stopColor: i, stopOpacity: l }, n && At("animate", { attributeName: "offset", values: -b + "; " + -b + "; 1", keyTimes: ke, dur: Te, repeatCount: "indefinite", begin: r })),
        At("stop", { offset: "50%", stopColor: f, stopOpacity: p }, n && At("animate", { attributeName: "offset", values: -b / 2 + "; " + -b / 2 + "; " + (1 + b / 2), keyTimes: ke, dur: Te, repeatCount: "indefinite", begin: r })),
        At("stop", { offset: "100%", stopColor: i, stopOpacity: l }, n && At("animate", { attributeName: "offset", values: "0; 0; " + (1 + b), keyTimes: ke, dur: Te, repeatCount: "indefinite", begin: r }))
      )
    )
  );
}, yS = function(t) {
  return t.children ? At($6, mo({}, t)) : At(P6, mo({}, t));
}, P6 = function(t) {
  return At(
    yS,
    mo({ viewBox: "0 0 476 124" }, t),
    At("rect", { x: "48", y: "8", width: "88", height: "6", rx: "3" }),
    At("rect", { x: "48", y: "26", width: "52", height: "6", rx: "3" }),
    At("rect", { x: "0", y: "56", width: "410", height: "6", rx: "3" }),
    At("rect", { x: "0", y: "72", width: "380", height: "6", rx: "3" }),
    At("rect", { x: "0", y: "88", width: "178", height: "6", rx: "3" }),
    At("circle", { cx: "20", cy: "20", r: "20" })
  );
};
const _6 = O((t) => ({
  skeletonItem: {
    background: `linear-gradient(90deg, ${t.other.colors.greyIron[1]} 2.27%, ${t.other.colors.greyIron[3]} 100%)`
  }
})), bS = ({
  width: t = "100%",
  height: e = 16,
  borderRadius: n = 8,
  uniqueKey: r,
  className: o,
  rounded: i = !1,
  centered: s = !1,
  ...l
}) => {
  const { classes: a, cx: c } = _6(), d = _i();
  return /* @__PURE__ */ g.createElement(
    oe,
    {
      uniqueKey: r,
      component: yS,
      className: c(a.skeletonItem, o),
      speed: 2,
      width: "100",
      height: 12,
      backgroundColor: d.other.colors.greyIron[3],
      foregroundColor: d.other.colors.greyIron[5],
      style: { width: t, height: e, borderRadius: i ? "50%" : n, margin: s ? "0 auto" : void 0 },
      ...l
    },
    /* @__PURE__ */ g.createElement("rect", { x: "0", y: "0", rx: "6", ry: "6", width: t, height: e })
  );
}, B6 = O((t, { transitionDuration: e }) => ({
  control: {},
  root: {
    position: "relative",
    marginBottom: m(20)
    // It's liked with font size on button
  },
  content: {
    overflow: "hidden",
    transitionProperty: "max-height",
    // TODO: (V7 changes)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // transitionTimingFunction: theme.transitionTimingFunction,
    transitionDuration: `${e}ms`,
    font: t.other.fonts.desktop.s.s.default,
    "@media (prefers-reduced-motion)": {
      transitionDuration: t.respectReducedMotion ? "0ms" : void 0
    }
  }
})), wS = 200, V6 = {
  transitionDuration: wS,
  maxHeight: 100,
  initialState: !1,
  hideLabel: "Hide",
  showLabel: "Show all"
}, F6 = ge((t, e) => {
  const { className: n, children: r, maxHeight: o, hideLabel: i, showLabel: s, transitionDuration: l, controlRef: a, initialState: c, classNames: d, ...u } = he(
    "Spoiler",
    V6,
    t
  ), { classes: f, cx: h } = B6({ transitionDuration: l || wS }), [p, y] = ie(c), [b, w] = ie(c), { ref: S, height: x } = pv(), E = p ? i : s, v = te(() => {
    y(!p);
  }, [p]);
  return It(() => {
    w(o < x);
  }, [x, o, r]), /* @__PURE__ */ g.createElement(
    oe,
    {
      className: h(f.root, d == null ? void 0 : d.root, n),
      mod: {
        opened: p
      },
      ref: e,
      ...u
    },
    b && /* @__PURE__ */ g.createElement(
      ye,
      {
        pos: "absolute",
        top: "100%",
        elementSize: Ue.M,
        elementVariant: Q.PrimaryMainLine,
        ref: a,
        onClick: v,
        className: h(f.control, d == null ? void 0 : d.control),
        "data-testid": "spoiler-button"
      },
      E
    ),
    /* @__PURE__ */ g.createElement(
      Ee,
      {
        gap: 0,
        className: h(f.content, d == null ? void 0 : d.content),
        "data-reduce-motion": !0,
        style: { maxHeight: p ? x || void 0 : o }
      },
      /* @__PURE__ */ g.createElement("div", { ref: S }, r)
    )
  );
});
F6.displayName = "Spoiler";
const N6 = O((t) => ({
  root: {},
  title: {},
  description: {},
  leftIconWrapper: {
    padding: m(13),
    width: m(42),
    height: m(42),
    backgroundColor: t.other.colors.greyIron[2],
    borderRadius: m(8)
  },
  leftIcon: {
    width: m(16),
    height: m(16),
    color: t.other.colors.greyIron[13]
  }
})), z6 = {}, Sz = (t) => {
  const { title: e, titleProperties: n, description: r, descriptionProperties: o, leftIcon: i, className: s, ...l } = he("Info", z6, t), { classes: a, cx: c } = N6();
  return /* @__PURE__ */ g.createElement(X, { className: c(a.root, s), ...l, gap: 8 }, !!i && /* @__PURE__ */ g.createElement(oe, { className: a.leftIconWrapper }, /* @__PURE__ */ g.createElement(Ee, { align: "center", className: a.leftIcon }, i)), /* @__PURE__ */ g.createElement(Ee, { gap: 4, align: "flex-start", className: c(a.root, s) }, /* @__PURE__ */ g.createElement(
    xe,
    {
      elementVariant: "default",
      elementSize: "s",
      colorVariant: "greyIron.12",
      ...n,
      className: c(a.title, n == null ? void 0 : n.className)
    },
    e
  ), /* @__PURE__ */ g.createElement(
    xe,
    {
      elementVariant: "default",
      elementSize: "s",
      colorVariant: "greyIron.20",
      ...o,
      className: c(a.description, o == null ? void 0 : o.className)
    },
    r
  )));
}, H6 = O((t) => ({
  root: {
    backgroundColor: t.other.colors.white[0],
    padding: m(16),
    border: `${m(1)} solid`,
    borderColor: t.other.colors.greyIron[4],
    borderRadius: t.other.borderRadius[8],
    boxSizing: "border-box"
  },
  wrapper: {
    justifyContent: "space-between",
    height: "100%"
  },
  topSection: {},
  header: {},
  headerTitleWrapper: {},
  headerTitle: {
    font: t.other.fonts.desktop.s.xs.extraImportant,
    color: t.other.colors.greyIron[12],
    textTransform: "uppercase"
  },
  headerTooltip: {
    maxWidth: m(200)
  },
  headerTooltipButton: {
    cursor: "unset"
  },
  headerRightTopIcon: {
    width: m(20),
    height: m(20),
    color: t.other.colors.greyIron[7],
    svg: {
      width: m(20),
      height: m(20)
    }
  },
  descriptionWrapper: {},
  description: {
    font: t.other.fonts.desktop.s.l.extraImportant,
    color: t.other.colors.greyIron[20]
  },
  descriptionSub: {
    font: t.other.fonts.desktop.s.xs.default,
    color: t.other.colors.greyIron[12]
  }
})), j6 = {
  isLoading: !1
}, W6 = wr((t) => {
  const {
    topSection: e,
    headerTitle: n,
    headerTooltipText: r,
    HeaderRightTopIconComponent: o,
    description: i,
    descriptionSub: s,
    isLoading: l,
    className: a,
    classNames: c,
    ...d
  } = he("Stats", j6, t), { classes: u, cx: f } = H6();
  return /* @__PURE__ */ g.createElement(Gm, { className: f(u.root, c == null ? void 0 : c.root, a), ...d }, /* @__PURE__ */ g.createElement(Ee, { className: f(u.wrapper, c == null ? void 0 : c.wrapper), gap: 16 }, e && /* @__PURE__ */ g.createElement(X, { className: f(u.topSection, c == null ? void 0 : c.topSection), "data-testid": "Stats-top-section", grow: !0 }, e), /* @__PURE__ */ g.createElement(X, { className: f(u.header, c == null ? void 0 : c.header), justify: "space-between", wrap: "nowrap" }, /* @__PURE__ */ g.createElement(X, { className: f(u.headerTitleWrapper, c == null ? void 0 : c.headerTitleWrapper), gap: 4, wrap: "nowrap" }, /* @__PURE__ */ g.createElement(Ti, { className: f(u.headerTitle, c == null ? void 0 : c.headerTitle), order: 3, elementSize: "xs" }, n), r && /* @__PURE__ */ g.createElement(at, { className: f(u.headerTooltip, c == null ? void 0 : c.headerTooltip), label: r, multiline: !0 }, /* @__PURE__ */ g.createElement(
    ye,
    {
      isIconOnly: !0,
      elementVariant: Q.SecondaryMainLine,
      elementSize: Ue.XS,
      rightSection: /* @__PURE__ */ g.createElement(Nr, null),
      "data-testid": "Stats-tooltip-button",
      className: f(u.headerTooltipButton, c == null ? void 0 : c.headerTooltipButton)
    }
  ))), o && /* @__PURE__ */ g.createElement("div", { className: f(u.headerRightTopIcon, c == null ? void 0 : c.headerRightTopIcon), "data-testid": "Stats-header-right-top-icon" }, o)), (i || s) && /* @__PURE__ */ g.createElement(Ee, { className: u.descriptionWrapper, gap: 2 }, i && /* @__PURE__ */ g.createElement(xe, { className: u.description, elementSize: "l", elementVariant: "extraImportant" }, l ? /* @__PURE__ */ g.createElement(bS, { uniqueKey: "sk-stats-description-loader", width: 61, height: 12 }) : i), s && /* @__PURE__ */ g.createElement(xe, { className: u.descriptionSub, elementSize: "xs", elementVariant: "default" }, s))));
});
W6.displayName = "Stats";
const G6 = O((t) => ({
  root: {},
  step: {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    width: m(40),
    height: m(40),
    borderRadius: "50%",
    backgroundColor: t.other.colors.brand[6]
  },
  label: {},
  description: {}
})), Cz = ({ step: t, label: e, description: n, className: r, classNames: o, ...i }) => {
  const { classes: s, cx: l } = G6();
  return /* @__PURE__ */ g.createElement(X, { gap: 12, className: l(s.root, o == null ? void 0 : o.root, r), ...i }, /* @__PURE__ */ g.createElement(xe, { elementSize: "m", elementVariant: "important", colorVariant: "greyIron.18", className: l(s.step, o == null ? void 0 : o.step) }, t), /* @__PURE__ */ g.createElement(
    BA,
    {
      classNames: { title: l(s.label, o == null ? void 0 : o.label), subtitle: l(s.description, o == null ? void 0 : o.description) },
      elementSize: "s",
      title: e,
      subtitle: n
    }
  ));
}, SS = qo({
  openModal: () => {
    throw new Error("Not implemented openModal method");
  },
  closeModal: () => {
    throw new Error("Not implemented closeModal method");
  }
}), U6 = SS.Provider, CS = () => Pi(SS), q6 = () => {
  const [t, e] = ie(!1), [n, r] = ie(null), o = te(
    (s) => {
      e(!0), r(s);
    },
    [e, r]
  ), i = te(() => {
    e(!1), r(null);
  }, [e, r]);
  return {
    isOpen: t,
    openModal: o,
    closeModal: i,
    action: n
  };
}, J6 = ({ children: t }) => {
  const { action: e, openModal: n, closeModal: r, isOpen: o } = q6(), i = te(() => {
    e == null || e.onClick(e.rowData), r();
  }, [e, r]);
  return /* @__PURE__ */ g.createElement(U6, { value: { openModal: n, closeModal: r } }, /* @__PURE__ */ g.createElement(
    Df.Confirm,
    {
      opened: o,
      elementVariant: "warning",
      title: e == null ? void 0 : e.confirmModalTitle,
      description: e == null ? void 0 : e.confirmModalDescription,
      hideOpenButton: !0,
      buttonCancelProperties: { children: e == null ? void 0 : e.confirmModalCancelButtonText },
      buttonAcceptProperties: { children: e == null ? void 0 : e.confirmModalAcceptButtonText },
      centered: !0,
      onAccept: i,
      onCancel: r
    }
  ), t);
}, K6 = O(() => ({
  container: {
    visibility: "hidden",
    opacity: 0,
    transition: Ae(["opacity"])
  },
  button: {
    display: "inline-flex"
  }
})), Y6 = ({ items: t, classNames: e, ...n }) => {
  const { classes: r, cx: o } = K6(), { openModal: i } = CS();
  return /* @__PURE__ */ g.createElement(X, { justify: "right", gap: 10, className: o(r.container, e == null ? void 0 : e.container, rf), ...n }, t.map((s, l) => /* @__PURE__ */ g.createElement(at, { label: s.tooltip, key: l, withinPortal: !0, ...s.tooltipProps }, /* @__PURE__ */ g.createElement(
    ye,
    {
      className: o(r.button, e == null ? void 0 : e.button),
      key: l,
      elementVariant: Q.PrimaryMainLine,
      leftSection: s.icon,
      isIconOnly: !0,
      isRound: !0,
      onClick: () => {
        if (s.withConfirmModal)
          return i(s);
        s.onClick(s.rowData);
      },
      "data-testid": s["data-testid"]
    }
  ))));
}, Z6 = O((t) => ({
  trActionsWrapper: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: m(4),
    display: "flex",
    alignItems: "center"
  },
  trActionsDropdownWrapper: {
    width: m(204),
    display: "flex"
  },
  trActionsDropdown: {
    width: `${m(204)} !important`,
    padding: t.other.spacings[8]
  },
  trActionsDropdownTarget: {
    marginLeft: "auto"
  },
  trActionsDropdownItem: {
    padding: t.other.spacings[8]
  }
})), X6 = (t) => {
  const { items: e, classNames: n } = t, { classes: r, cx: o } = Z6(), { openModal: i } = CS();
  return e.length === 0 ? null : /* @__PURE__ */ g.createElement("div", { className: r.trActionsWrapper }, /* @__PURE__ */ g.createElement(
    Zt,
    {
      classNames: {
        wrapper: o(r.trActionsDropdownWrapper, n == null ? void 0 : n.trActionsDropdownWrapper),
        dropdown: o(r.trActionsDropdown, n == null ? void 0 : n.trActionsDropdown),
        targetElement: o(r.trActionsDropdownTarget, n == null ? void 0 : n.trActionsDropdownTarget),
        item: o(r.trActionsDropdownItem, n == null ? void 0 : n.trActionsDropdownItem)
      },
      targetElementProps: {
        elementVariant: Q.SecondaryMainLine,
        leftSection: /* @__PURE__ */ g.createElement(UC, null)
      },
      hideTargetElementRightIcon: !0,
      elementSize: ln.M,
      withinPortal: !0,
      position: "bottom-end"
    },
    /* @__PURE__ */ g.createElement(Zt.Items, null, e == null ? void 0 : e.map((s) => /* @__PURE__ */ g.createElement(g.Fragment, { key: s.name }, s.tooltip ? /* @__PURE__ */ g.createElement(at, { label: s.tooltip, ...s.tooltipProps }, /* @__PURE__ */ g.createElement("div", null, /* @__PURE__ */ g.createElement(
      Zt.Item,
      {
        "data-testid": `table-row-actions-item-${s.name.toLowerCase()}`,
        key: s.name,
        disabled: s.disabled,
        onClick: () => {
          if (s.withConfirmModal)
            return i(s);
          s.onClick(s.rowData);
        }
      },
      /* @__PURE__ */ g.createElement(X, { gap: 4, wrap: "nowrap", align: "center" }, s.icon || null, /* @__PURE__ */ g.createElement(oe, { component: "span", flex: 1 }, s.name))
    ))) : /* @__PURE__ */ g.createElement(
      Zt.Item,
      {
        "data-testid": `table-row-actions-item-${s.name.toLowerCase()}`,
        key: s.name,
        disabled: s.disabled,
        onClick: () => {
          if (s.withConfirmModal)
            return i(s);
          s.onClick(s.rowData);
        }
      },
      /* @__PURE__ */ g.createElement(X, { gap: 4, wrap: "nowrap", align: "center" }, s.icon || null, /* @__PURE__ */ g.createElement(oe, { component: "span", flex: 1 }, s.name))
    ))))
  ));
}, Os = "_actions", Q6 = "select", Ds = 205, e5 = 0, t5 = 0, n5 = 10, r5 = {
  minSize: 0,
  size: Number.MAX_SAFE_INTEGER
}, o5 = ({
  rowActions: t,
  rowActionsType: e,
  rowActionsWidth: n,
  rowActionsMinWidth: r,
  rowActionsMaxWidth: o,
  data: i
}) => {
  const s = me(() => e === "buttons" ? Y6 : X6, [e]), l = me(() => {
    const c = w6();
    return t != null && t.length ? c.accessor(Os, {
      header: "",
      cell: ({ row: d }) => {
        const u = typeof t == "function" ? t(d.original) : t;
        return /* @__PURE__ */ g.createElement(
          s,
          {
            items: u == null ? void 0 : u.map((f) => ({
              ...f,
              rowData: d.original
            }))
          }
        );
      },
      size: e === "buttons" ? n : 20,
      minSize: e === "buttons" ? r : 20,
      maxSize: e === "buttons" ? o : 20,
      meta: {
        align: "right"
      }
    }) : void 0;
  }, [s, t, o, r, e, n]);
  return {
    selectionColumn: me(
      () => ({
        id: Q6,
        header: ({ table: c }) => /* @__PURE__ */ g.createElement(
          la,
          {
            checked: c.getIsAllRowsSelected(),
            indeterminate: c.getIsSomeRowsSelected() || void 0,
            onChange: c.getToggleAllRowsSelectedHandler(),
            "data-testid": "table-select-all"
          }
        ),
        cell: ({ row: c }) => /* @__PURE__ */ g.createElement(
          la,
          {
            checked: c.getIsSelected(),
            disabled: !c.getCanSelect(),
            indeterminate: c.getIsSomeSelected() || void 0,
            onChange: c.getToggleSelectedHandler(),
            "data-testid": "table-select-row"
          }
        ),
        maxSize: 44
      }),
      []
    ),
    actionColumn: l
  };
}, i5 = (t, e) => {
  const n = Nt(!1), r = te(
    (i) => {
      const s = {};
      for (const l of t.getAllLeafColumns())
        s[l.id] = i.includes(l.id) || l.id === Os;
      t.setColumnVisibility(s);
    },
    [t]
  ), o = me(() => {
    const i = [], s = t.getAllLeafColumns().filter((l) => l.id !== Os).map((l) => {
      var a, c;
      return l.getIsVisible() && e.columnVisibility[l.id] && i.push(l.id), {
        value: l.id,
        label: ((a = e.columnVisibilityFilterLabels) == null ? void 0 : a[l.id]) || l.id,
        disabled: (c = e.columnVisibilityFilterDisabledColumns) == null ? void 0 : c[l.id]
      };
    });
    return {
      multiSelectDataChecked: i,
      multiSelectData: s
    };
  }, [t, e]);
  return It(() => {
    n.current || (n.current = !0, e.withColumnVisibilityFilter && r(o.multiSelectDataChecked));
  }, [o.multiSelectDataChecked, r, e.withColumnVisibilityFilter]), It(() => {
    if (e.withColumnVisibilityFilter) {
      const i = {
        ...e.columnVisibilityState,
        ...e.columnVisibility
      };
      for (const s of t.getAllLeafColumns())
        typeof i[s.id] != "boolean" && (i[s.id] = !1), s.id === Os && (i[s.id] = !0);
      t.setColumnVisibility(i);
    }
  }, [e.columnVisibilityState, e.withColumnVisibilityFilter]), {
    handleChangeColumnsFilter: r,
    columnsFilterData: o
  };
}, s5 = O((t) => ({
  rowGroupElement: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "stretch"
  },
  rowGroupElementHeaderPadding: {
    visibility: "hidden",
    height: 0,
    display: "flex",
    flexDirection: "column"
  },
  tdRowGroup: {
    boxSizing: "border-box",
    padding: `0 ${m(16)}`,
    borderBottom: `${m(1)} solid ${t.other.colors.greyIron[4]}`,
    borderRight: `${m(1)} solid ${t.other.colors.greyIron[4]}`,
    wordBreak: "break-word",
    font: t.other.fonts.desktop.s.xs.important,
    color: t.other.colors.greyIron[18],
    "&:last-of-type": {
      borderBottom: "none"
    }
  }
})), l5 = ({ table: t, rowGroupName: e }) => {
  const { classes: n, cx: r } = s5(), o = me(() => {
    if (!e)
      return null;
    const l = /* @__PURE__ */ new Map();
    for (const a of t.getRowModel().rows) {
      const c = a.original[e];
      if (!c)
        continue;
      const d = 1;
      l.has(c) ? l.set(c, l.get(c) + d) : l.set(c, d);
    }
    return l;
  }, [t, e]), i = me(() => {
    if (!o || o.size === 0)
      return null;
    const l = Object.fromEntries(o.entries());
    return /* @__PURE__ */ g.createElement("div", { className: n.rowGroupElement }, Object.entries(l).map(([a, c]) => /* @__PURE__ */ g.createElement(
      "div",
      {
        key: a,
        className: n.tdRowGroup,
        style: { flexBasis: 0, flexGrow: c, display: "flex", alignItems: "center" }
      },
      a
    )));
  }, [o, n]), s = me(() => {
    if (!o || o.size === 0)
      return null;
    const l = Object.fromEntries(o.entries());
    return /* @__PURE__ */ g.createElement("div", { className: r(n.tdRowGroup, n.rowGroupElementHeaderPadding) }, Object.entries(l).map(([a]) => /* @__PURE__ */ g.createElement("div", { key: a }, a)));
  }, [o, n, r]);
  return {
    rowGroupElement: i,
    rowGroupElementHeaderPadding: s
  };
}, a5 = () => {
  const [t, e] = ie(!1), n = te(
    ({ x: r }) => {
      r > 0 && !t && e(!0), r === 0 && t && e(!1);
    },
    [t]
  );
  return {
    isShowFirstColumnShadow: t,
    onScrollPositionChange: n
  };
}, c5 = ({
  id: t,
  columnWidth: e,
  tableWidth: n,
  columnSizingType: r
}) => r === "old" ? `${Number(e) / n * 100}%` : !e || e === Number.MAX_SAFE_INTEGER ? `${Ds}px` : r === "px" ? `${e}px` : r === "percent" ? (e > 100 && console.warn(`Column width is more than 100%. Please review column width for ${t}`), `${e}%`) : `${Ds}px`, d5 = O(() => ({
  label: {
    margin: 0,
    "& > div": {
      margin: 0
    }
  },
  root: {
    display: "flex",
    flexDirection: "column"
  },
  wrapper: {
    height: 0,
    width: m(230)
  }
})), u5 = ({ columnVisibilityFilterButtonText: t, targetButtonProps: e, disabled: n, ...r }) => {
  const { classes: o } = d5(), i = mr(Ge.greaterThen("md", !1));
  return /* @__PURE__ */ g.createElement(
    Fb,
    {
      targetButtonText: t,
      targetButtonProps: {
        role: "button",
        elementVariant: Q.TertiaryMain,
        rightSection: /* @__PURE__ */ g.createElement(qC, null),
        disabled: n,
        "data-testid": "columns-filter-button",
        isIconOnly: !i,
        ...e
      },
      width: i ? "target" : 230,
      classNames: o,
      maxDropdownHeight: 300,
      disabled: n,
      searchable: !1,
      zIndex: Rn("app") - 1,
      ...r
    }
  );
}, f5 = O((t) => ({
  row: {
    padding: `${m(13)} ${m(24)}`,
    borderBottom: `${m(1)} solid ${t.other.colors.greyIron[4]}`
  },
  rowColor: {
    "&:nth-of-type(odd)": {
      backgroundColor: t.other.colors.greyIron[1]
    },
    "&:nth-of-type(even) ": {
      backgroundColor: t.other.colors.white[0]
    }
  },
  rowBorderBottom: {
    "&:last-of-type": {
      border: "none"
    }
  }
})), Hd = {
  rowsCount: 10,
  pattern: [
    { width: 67, marginLeft: 0 },
    { flex: 3, marginLeft: 36 },
    { flex: 1, marginLeft: 24 },
    { flex: 1, marginLeft: 24 },
    { flex: 1, marginLeft: 30 },
    { flex: 1, marginLeft: 24 }
  ],
  lastBorderBottom: !1
}, Eh = ({
  rowsCount: t = Hd.rowsCount,
  pattern: e = Hd.pattern,
  lastBorderBottom: n = Hd.lastBorderBottom
}) => {
  const { classes: r, cx: o } = f5(), i = me(() => Array.from({ length: t }), [t]);
  return /* @__PURE__ */ g.createElement(Ee, { gap: 0 }, i.map((s, l) => /* @__PURE__ */ g.createElement(
    X,
    {
      gap: 0,
      key: l,
      className: o(r.row, { [o(r.rowColor, Sy)]: t > 1, [r.rowBorderBottom]: !n }),
      align: "center",
      justify: "space-between",
      style: { flex: 1 },
      wrap: "nowrap"
    },
    e.map((a, c) => /* @__PURE__ */ g.createElement(bS, { key: c, style: a, height: 12, borderRadius: 8 }))
  )));
}, h5 = ({ loading: t }) => t ? /* @__PURE__ */ g.createElement(
  Eh,
  {
    rowsCount: 1,
    pattern: [
      { width: 67, marginLeft: 0 },
      { width: 67, marginLeft: "auto" }
    ],
    lastBorderBottom: !0
  }
) : null, p5 = O((t) => ({
  footer: {
    borderTop: `${m(1)} solid`,
    borderColor: t.other.colors.greyIron[4]
  },
  displayNone: {
    display: "none"
  }
})), vS = wr(({ footer: t, loading: e }) => {
  const { classes: n, cx: r } = p5();
  return t && /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(h5, { loading: e }), /* @__PURE__ */ g.createElement(X, { justify: "left", px: 24, py: 20, className: r(n.footer, { [n.displayNone]: e }) }, t));
});
vS.displayName = "Footer";
const g5 = O((t) => ({
  wrapper: {
    maxWidth: `calc(100% - ${m(20)})`
  },
  label: {
    display: "inline-block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  iconWrapper: {
    width: m(16),
    height: m(16)
  },
  iconColor: {
    color: t.other.colors.greyIron[10],
    cursor: "unset"
  },
  tooltip: {
    cursor: "unset"
  }
})), xS = wr(({ classNames: t, label: e, tooltip: n, ...r }) => {
  const { classes: o, cx: i } = g5();
  return /* @__PURE__ */ g.createElement(X, { gap: 4, align: "baseline", justify: "flex-start", wrap: "nowrap", ...r }, /* @__PURE__ */ g.createElement(X, { className: i(o.wrapper, t == null ? void 0 : t.wrapper) }, /* @__PURE__ */ g.createElement("span", { className: i(o.label, t == null ? void 0 : t.label) }, e)), /* @__PURE__ */ g.createElement("span", { className: i(o.iconWrapper, t == null ? void 0 : t.iconWrapper) }, /* @__PURE__ */ g.createElement(at, { label: n, className: i(o.tooltip, t == null ? void 0 : t.tooltip), multiline: !0, withinPortal: !0 }, /* @__PURE__ */ g.createElement(
    ye,
    {
      elementVariant: Q.SecondaryMainLine,
      elementSize: Ue.XS,
      leftSection: /* @__PURE__ */ g.createElement(Nr, { width: 16, height: 16 }),
      className: i(o.iconColor, t == null ? void 0 : t.iconColor),
      isIconOnly: !0
    }
  ))));
});
xS.displayName = "HeaderWithTooltip";
const m5 = ({ loading: t }) => t ? /* @__PURE__ */ g.createElement(
  Eh,
  {
    rowsCount: 1,
    pattern: [
      { width: 67, marginLeft: 0 },
      { width: "50%", marginLeft: "auto" },
      { width: 67, marginLeft: "auto" }
    ],
    lastBorderBottom: !0
  }
) : null, y5 = {
  asc: /* @__PURE__ */ g.createElement(KC, { width: 14, height: 14 }),
  desc: /* @__PURE__ */ g.createElement(JC, { width: 14, height: 14 })
}, b5 = ({ sortDirection: t }) => {
  const { other: e } = _i();
  return t ? /* @__PURE__ */ g.createElement(
    ye,
    {
      isIconOnly: !0,
      elementVariant: Q.PrimaryMainLine,
      elementSize: Ue.XS,
      rightSection: y5[t || "desc"],
      style: { width: 16, height: 16, color: t ? void 0 : e.colors.greyIron[10] }
    }
  ) : null;
}, ES = wr(({ isShow: t, table: e, classNames: n, getTotalRowTdClasses: r, generateCellStyle: o }) => t ? e.getFooterGroups().map((i) => /* @__PURE__ */ g.createElement("div", { role: "row", key: i.id, className: n }, i.headers.map((s) => /* @__PURE__ */ g.createElement(
  "div",
  {
    role: "cell",
    key: s.id,
    className: r(s),
    style: o({
      cell: s,
      id: s.column.id,
      size: s.column.columnDef.size,
      minSize: s.column.columnDef.minSize,
      maxSize: s.column.columnDef.maxSize
    })
  },
  s.isPlaceholder ? null : Zs(s.column.columnDef.footer, s.getContext())
)))) : null);
ES.displayName = "TotalRow";
const w5 = O((t, { withPagination: e }) => {
  const n = Ae(["background-color"]);
  return {
    root: {
      width: "100%",
      borderRadius: t.other.borderRadius[8],
      border: `${m(1)} solid`,
      borderColor: t.other.colors.greyIron[4],
      backgroundColor: t.other.colors.white[0]
    },
    container: {
      height: "auto",
      borderRadius: e ? 0 : t.other.borderRadius[8],
      borderTopLeftRadius: t.other.borderRadius[8],
      borderTopRightRadius: t.other.borderRadius[8]
    },
    viewport: {
      "& > div": {
        display: "table"
      }
    },
    header: {},
    table: {
      width: "100%"
    },
    tableBorderTop: {
      borderTop: `${m(1)} solid`,
      borderColor: t.other.colors.greyIron[4]
    },
    thead: {
      margin: 0,
      position: "sticky",
      top: 0,
      backgroundColor: t.other.colors.white[0],
      borderBottom: `${m(1)} solid`,
      borderColor: t.other.colors.greyIron[4]
    },
    theadTh: {
      textAlign: "left",
      wordBreak: "break-all",
      backgroundColor: t.other.colors.white[0],
      padding: `${m(13)} ${m(16)}`,
      "&:first-of-type": {
        position: "sticky",
        left: 0,
        paddingLeft: m(16),
        [Ge.greaterThen("md")]: {
          paddingLeft: m(24)
        }
      },
      "&:last-of-type": {
        paddingRight: m(16),
        [Ge.greaterThen("md")]: {
          paddingRight: m(24)
        }
      },
      flexWrap: "nowrap",
      whiteSpace: "nowrap",
      transition: n,
      font: t.other.fonts.desktop.s.xs.important,
      color: t.other.colors.greyIron[12]
    },
    theadThSorted: {
      color: t.other.colors.brand[13],
      flexWrap: "nowrap"
    },
    theadSorted: {
      backgroundColor: t.other.colors.greyIron[1]
    },
    theadTr: {
      display: "flex",
      position: "relative",
      "&:after": {
        position: "absolute",
        content: '""',
        width: "100%",
        left: 0,
        right: 0,
        bottom: 0
      }
    },
    tr: {
      display: "flex",
      borderBottom: `${m(1)} solid ${t.other.colors.greyIron[4]}`,
      transition: n,
      position: "relative",
      "&:last-of-type": {
        borderBottom: "none"
      },
      [`&&:hover .${Dr}`]: {
        backgroundColor: t.other.colors.brand[2]
      },
      "&:hover": {
        [`& .${rf}`]: {
          visibility: "visible",
          opacity: 1
        }
      }
    },
    trBg: {
      [`& .${Dr}`]: {
        backgroundColor: t.other.colors.white[0]
      }
    },
    trEvenOddBg: {
      [`&:nth-of-type(odd) .${Dr}`]: {
        backgroundColor: t.other.colors.greyIron[1]
      }
    },
    trCursorPointer: {
      cursor: "pointer"
    },
    trTotal: {
      [`&& .${Dr}`]: {
        backgroundColor: t.other.colors.brand[2]
      }
    },
    th: {
      textAlign: "left",
      padding: `${m(13)} ${m(16)}`,
      wordBreak: "break-all",
      font: t.other.fonts.desktop.s.xs.important,
      color: t.other.colors.greyIron[12],
      "&:first-of-type": {
        paddingLeft: m(16),
        [Ge.greaterThen("md")]: {
          paddingLeft: m(24)
        }
      },
      "&:last-of-type": {
        paddingRight: m(16),
        [Ge.greaterThen("md")]: {
          paddingRight: m(24)
        }
      }
    },
    td: {
      display: "flex",
      transition: n,
      boxSizing: "border-box",
      padding: `${m(17)} ${m(16)}`,
      wordBreak: "break-word",
      font: t.other.fonts.desktop.s.xs.default,
      color: t.other.colors.greyIron[18],
      "&:first-of-type": {
        position: "sticky",
        left: 0,
        font: t.other.fonts.desktop.s.xs.important,
        color: t.other.colors.greyIron[20],
        paddingLeft: m(16),
        [Ge.greaterThen("md")]: {
          paddingLeft: m(24)
        }
      },
      "&:last-of-type": {
        paddingRight: m(16),
        [Ge.greaterThen("md")]: {
          paddingRight: m(24)
        }
      }
    },
    tBody: {
      display: "flex",
      flexDirection: "row",
      alignItems: "stretch"
    },
    tRows: {
      flexGrow: 2
    },
    pagination: {
      borderTop: `${m(1)} solid`,
      borderColor: t.other.colors.greyIron[4]
    },
    sticky: {
      "&:first-of-type": {
        zIndex: Rn("app") - 2,
        "&::after": {
          content: '""',
          background: "linear-gradient(90deg, rgba(78, 74, 81, 0.1) 0%, rgba(255, 255, 255, 0) 100%)",
          width: m(40),
          top: 0,
          right: m(-40),
          bottom: 0,
          position: "absolute"
        }
      }
    },
    canSort: {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: t.other.colors.greyIron[1]
      }
    },
    loaderWrapper: {},
    loaderLine: {},
    displayNone: {
      display: "none"
    },
    alignRight: {
      textAlign: "right",
      justifyContent: "flex-end"
    },
    alignLeft: {
      textAlign: "left",
      justifyContent: "flex-start"
    },
    alignCenter: {
      textAlign: "center",
      justifyContent: "center"
    }
  };
}), S5 = {
  paginationComponentProps: {
    withControls: !0,
    withPerPage: !0,
    withGoToPage: !0
  },
  withPagination: !0,
  withSelectionColumn: !1,
  withColumnVisibilityFilter: !1,
  columnVisibilityFilterButtonText: "Customize columns",
  enableSorting: !1,
  manualSorting: !1,
  enableSortingRemoval: !0,
  useTableRowEvenOddBackground: !0,
  rowActions: void 0,
  rowActionsType: "dropdown",
  autoResetPageIndex: !1,
  columnSizingType: "old"
}, C5 = (t) => {
  var qi;
  const {
    data: e,
    columns: n,
    toolbar: r,
    footer: o,
    rowGroupName: i,
    withSelectionColumn: s,
    withPagination: l,
    paginationComponentProps: a,
    rowActions: c,
    rowActionsType: d,
    rowActionsWidth: u,
    rowActionsMinWidth: f,
    rowActionsMaxWidth: h,
    classNames: p,
    pagination: y,
    onChange: b,
    onChangeSorting: w,
    manualPagination: S,
    total: x,
    debugAll: E,
    debugTable: v,
    debugHeaders: T,
    debugColumns: I,
    debugRows: M,
    columnVisibilityState: R,
    withColumnVisibilityFilter: A,
    columnVisibilityFilterLabels: F,
    columnVisibilityFilterButtonText: V,
    columnVisibilityFilterMultiSelectProps: P,
    columnVisibilityFilterDisabledColumns: J,
    manualSorting: ne,
    enableSorting: G,
    sortingState: H,
    loading: W,
    isError: se,
    emptyDataComponent: U,
    errorDataComponent: re,
    withTotalRow: ke,
    columnVisibilityLocalStorageKey: Te,
    enableSortingRemoval: Se,
    onRowClick: Le,
    className: Ce,
    useTableRowEvenOddBackground: et,
    autoResetPageIndex: Oe,
    rowHighlightClassName: $e,
    applyRowHighlightClassName: Ie,
    getRowId: ee,
    columnSizingType: de,
    ...ae
  } = he("Table", S5, t), { isShowFirstColumnShadow: Y, onScrollPositionChange: we } = a5(), [Ze, Je] = ie(H || []), [ht, Xe] = ie({}), Lt = Nt(null), Be = `${Te}-columnVisibility`, tt = () => {
    if (!Te)
      return R || {};
    try {
      return JSON.parse(window.localStorage.getItem(Be) || JSON.stringify(R || {}));
    } catch {
      return R || {};
    }
  }, [St, Mt] = ey({
    key: Be,
    defaultValue: tt(),
    serialize: (Ne) => Ne && JSON.stringify(Ne),
    deserialize: (Ne) => Ne && JSON.parse(Ne)
  }), [{ pageIndex: nt, pageSize: je }, Qe] = ie({
    pageIndex: (y == null ? void 0 : y.pageIndex) || t5,
    pageSize: (y == null ? void 0 : y.pageSize) || n5
  }), { classes: L, cx: q } = w5({ withPagination: l }), { className: ve, ...De } = a || {}, { selectionColumn: pt, actionColumn: un } = o5({
    data: e,
    rowActions: c,
    rowActionsType: d,
    rowActionsWidth: u,
    rowActionsMinWidth: f,
    rowActionsMaxWidth: h
  }), Ut = [...s ? [pt, ...n] : n, un].filter(Boolean), Dn = te(
    (Ne) => {
      Je((ue) => {
        const yt = Ne(ue);
        return w == null || w(yt), yt;
      });
    },
    [w]
  ), qt = te(
    (Ne) => {
      Mt(Ne), we({ x: 0, y: 0 });
    },
    [we, Mt]
  ), ct = mS({
    data: e,
    debugAll: E,
    debugTable: v,
    debugHeaders: T,
    debugColumns: I,
    debugRows: M,
    manualPagination: S,
    manualSorting: ne,
    enableSorting: G,
    enableSortingRemoval: Se,
    enableRowSelection: s,
    state: {
      sorting: G ? Ze : void 0,
      columnVisibility: St,
      pagination: {
        pageIndex: nt,
        pageSize: je
      },
      rowSelection: s ? ht : void 0
    },
    autoResetPageIndex: Oe,
    getRowId: (Ne, ue, yt) => (ee == null ? void 0 : ee(Ne, ue, yt)) || (yt == null ? void 0 : yt.id) || (Ne == null ? void 0 : Ne.id) || ue,
    columns: Ut,
    pageCount: Math.ceil(e.length / je),
    getCoreRowModel: gS(),
    getFilteredRowModel: x6(),
    getPaginationRowModel: T6(),
    getSortedRowModel: G ? E6() : void 0,
    onPaginationChange: Qe,
    onColumnVisibilityChange: qt,
    onSortingChange: G ? Dn : void 0,
    onRowSelectionChange: s ? Xe : void 0,
    // FIXME: workaround to add flexibility for columns width: https://github.com/TanStack/table/discussions/3192#discussioncomment-6458134
    defaultColumn: r5
  }), { handleChangeColumnsFilter: vn, columnsFilterData: Jt } = i5(ct, {
    columnVisibilityFilterLabels: F,
    columnVisibilityFilterDisabledColumns: J,
    columnVisibilityState: R,
    columnVisibility: St,
    withColumnVisibilityFilter: A
  }), { rowGroupElement: Un, rowGroupElementHeaderPadding: Ct } = l5({ table: ct, rowGroupName: i }), An = (Ne, ue) => {
    const yt = { pageIndex: Ne > 0 ? Ne - 1 : Ne, pageSize: ue };
    b == null || b(yt), ct.setPagination(yt);
  };
  It(() => {
    H && ne && JSON.stringify(H) !== JSON.stringify(Ze) && Je(H);
  }, [ne, Je, H]);
  const jr = ((qi = Lt.current) == null ? void 0 : qi.scrollWidth) || e5, qn = ({
    cell: Ne,
    id: ue,
    size: yt,
    minSize: cr,
    maxSize: k
  }) => {
    const $ = de === "old" ? Ne.getSize() === Number.MAX_SAFE_INTEGER ? Ds : Ne.getSize() : yt, j = c5({
      id: ue,
      columnWidth: $,
      tableWidth: jr,
      columnSizingType: de
    }), pe = cr === Number.MAX_SAFE_INTEGER ? Ds : cr || Ds, qe = k !== Number.MAX_SAFE_INTEGER && k !== void 0 && pe > k ? k : pe;
    return {
      width: j,
      minWidth: qe,
      maxWidth: k === Number.MAX_SAFE_INTEGER ? void 0 : k,
      flexGrow: de === "old" && ![Os].includes(ue) ? 1 : void 0
    };
  }, Eo = me(() => r || A ? /* @__PURE__ */ g.createElement(X, { justify: "space-between", px: { base: 16, md: 24 }, py: { base: 16, md: 20 }, className: q(L.header, p == null ? void 0 : p.header) }, A && /* @__PURE__ */ g.createElement(
    u5,
    {
      ...P,
      onChange: vn,
      value: Jt.multiSelectDataChecked,
      data: Jt.multiSelectData,
      columnVisibilityFilterButtonText: V,
      disabled: W
    }
  ), r, " ") : null, [
    r,
    A,
    P,
    vn,
    Jt,
    V,
    W,
    L.header,
    p == null ? void 0 : p.header,
    q
  ]), gt = te(
    (Ne) => {
      var ue, yt;
      return q(L.td, p == null ? void 0 : p.td, Dr, {
        [q(L.sticky, p == null ? void 0 : p.sticky)]: Y,
        [q(L.alignLeft, p == null ? void 0 : p.alignLeft)]: ((ue = Ne.column.columnDef.meta) == null ? void 0 : ue.align) === "left",
        [q(L.alignRight, p == null ? void 0 : p.alignRight)]: ((yt = Ne.column.columnDef.meta) == null ? void 0 : yt.align) === "right"
      });
    },
    [L.td, L.sticky, L.alignLeft, L.alignRight, Y, q, p]
  ), Jn = me(() => se && !W, [se, W]), Pe = me(() => x === 0 && !W && !se, [x, W, se]), xn = me(() => !Jn && !Pe, [Jn, Pe]);
  return /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(J6, null, /* @__PURE__ */ g.createElement(oe, { component: "div", className: q(L.root, p == null ? void 0 : p.root, Ce), ...ae }, Eo, /* @__PURE__ */ g.createElement(
    Fr,
    {
      ref: Lt,
      className: q(L.container, p == null ? void 0 : p.container),
      classNames: {
        viewport: q(L.viewport, p == null ? void 0 : p.viewport)
      },
      type: "auto",
      onScrollPositionChange: we
    },
    /* @__PURE__ */ g.createElement(
      "div",
      {
        role: "table",
        className: q(L.table, p == null ? void 0 : p.table, {
          [q(L.tableBorderTop, p == null ? void 0 : p.tableBorderTop)]: r || A
        })
      },
      xn && /* @__PURE__ */ g.createElement("div", { role: "rowgroup", className: q(L.thead, p == null ? void 0 : p.thead) }, ct.getHeaderGroups().map((Ne) => /* @__PURE__ */ g.createElement("div", { role: "row", key: Ne.id, className: q(L.theadTr, p == null ? void 0 : p.theadTr) }, Ct, Ne.headers.filter((ue) => i ? ue.column.id !== i : !0).map((ue) => {
        var cr, k, $, j;
        const yt = G && (ue.column.columnDef.enableSorting !== !1 && ue.column.columnDef.enableSorting === void 0 || ue.column.columnDef.enableSorting);
        return /* @__PURE__ */ g.createElement(at, { key: ue.id, label: (cr = ue.column.columnDef.meta) == null ? void 0 : cr.tooltipText, withinPortal: !0 }, /* @__PURE__ */ g.createElement(
          "div",
          {
            role: "columnheader",
            className: q(L.theadTh, p == null ? void 0 : p.theadTh, {
              [q(L.sticky, p == null ? void 0 : p.sticky)]: Y,
              [q(L.canSort, p == null ? void 0 : p.canSort)]: ue.column.getCanSort(),
              [q(L.theadSorted, p == null ? void 0 : p.theadSorted)]: ue.column.getIsSorted()
            }),
            style: qn({
              cell: ue,
              id: ue.column.id,
              size: ue.column.columnDef.size,
              minSize: ue.column.columnDef.minSize,
              maxSize: ue.column.columnDef.maxSize
            })
          },
          ue.isPlaceholder ? null : /* @__PURE__ */ g.createElement(
            X,
            {
              gap: 4,
              align: "center",
              className: q({
                [q(L.theadThSorted, p == null ? void 0 : p.theadThSorted)]: ue.column.getIsSorted(),
                [q(L.alignLeft, p == null ? void 0 : p.alignLeft)]: ((k = ue.column.columnDef.meta) == null ? void 0 : k.align) === "left",
                [q(L.alignRight, p == null ? void 0 : p.alignRight)]: (($ = ue.column.columnDef.meta) == null ? void 0 : $.align) === "right",
                [q(L.alignCenter, p == null ? void 0 : p.alignCenter)]: ((j = ue.column.columnDef.meta) == null ? void 0 : j.align) === "center"
              }),
              onClick: yt ? ue.column.getToggleSortingHandler() : void 0
            },
            Zs(ue.column.columnDef.header, ue.getContext()),
            yt && /* @__PURE__ */ g.createElement(b5, { sortDirection: ue.column.getIsSorted() }),
            " "
          )
        ));
      })))),
      /* @__PURE__ */ g.createElement(A2, { classNames: L, loading: W }),
      W && /* @__PURE__ */ g.createElement(Eh, { lastBorderBottom: !!o }),
      xn && /* @__PURE__ */ g.createElement(Ee, { role: "rowgroup", gap: 0, className: q({ [L.displayNone]: W }) }, /* @__PURE__ */ g.createElement("div", { className: q(L.tBody, p == null ? void 0 : p.tBody) }, Un, /* @__PURE__ */ g.createElement("div", { className: L.tRows }, /* @__PURE__ */ g.createElement(g.Fragment, null, ct.getRowModel().rows.map((Ne) => (
        // TODO: TASK-https://mbt.tpondemand.com/entity/394726-fe-fix-interactive-state-for-clickable
        // eslint-disable-next-line jsx-a11y/interactive-supports-focus, jsx-a11y/click-events-have-key-events
        /* @__PURE__ */ g.createElement(
          "div",
          {
            role: "row",
            key: Ne.id,
            className: q(
              L.tr,
              p == null ? void 0 : p.tr,
              L.trBg,
              {
                [L.trEvenOddBg]: et,
                [L.trCursorPointer]: !!Le
              },
              $e ? { [$e]: Ie == null ? void 0 : Ie(Ne) } : {}
            ),
            onClick: () => Le == null ? void 0 : Le(Ne.id)
          },
          Ne.getVisibleCells().filter((ue) => i ? ue.column.id !== i : !0).map((ue) => {
            var yt, cr, k;
            return /* @__PURE__ */ g.createElement(
              "div",
              {
                role: "cell",
                key: ue.id,
                className: q(L.td, p == null ? void 0 : p.td, Dr, {
                  [L.sticky]: Y,
                  [L.alignLeft]: ((yt = ue.column.columnDef.meta) == null ? void 0 : yt.align) === "left",
                  [L.alignRight]: ((cr = ue.column.columnDef.meta) == null ? void 0 : cr.align) === "right",
                  [L.alignCenter]: ((k = ue.column.columnDef.meta) == null ? void 0 : k.align) === "center"
                }),
                style: qn({
                  cell: ue.column,
                  id: ue.column.id,
                  size: ue.column.columnDef.size,
                  minSize: ue.column.columnDef.minSize,
                  maxSize: ue.column.columnDef.maxSize
                }),
                "data-table-body-td": "true"
              },
              Zs(ue.column.columnDef.cell, ue.getContext())
            );
          })
        )
      )), xn && /* @__PURE__ */ g.createElement(
        ES,
        {
          isShow: !!(ke && x !== 0),
          table: ct,
          getTotalRowTdClasses: gt,
          classNames: q(L.tr, L.trTotal, p == null ? void 0 : p.tr, p == null ? void 0 : p.trTotal),
          generateCellStyle: qn
        }
      ))))),
      Jn && (re || "Error"),
      Pe && (U || "No data")
    )
  ), !se && x !== 0 && /* @__PURE__ */ g.createElement(vS, { footer: o, loading: W }), l && !se && /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(m5, { loading: W }), /* @__PURE__ */ g.createElement(
    Nb,
    {
      total: x,
      pageSize: ct.getState().pagination.pageSize,
      page: ct.getState().pagination.pageIndex + 1,
      onChange: An,
      style: { width: "100%", display: W || x === 0 ? "none" : void 0 },
      px: 24,
      py: 20,
      className: q(L.pagination, p == null ? void 0 : p.pagination, ve, { [L.displayNone]: W }),
      ...De
    }
  )))));
};
C5.HeaderWithTooltip = xS;
const kS = "--tabs-list-underline-width", v5 = `var(${kS})`, x5 = () => {
  const t = Nt(null);
  return It(() => {
    const e = new MutationObserver(() => {
      var r;
      const n = (r = t.current) == null ? void 0 : r.querySelector('[aria-selected="true"]');
      n && n.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    });
    if (t.current) {
      e.observe(t.current, { attributes: !0, subtree: !0 });
      const n = t.current.scrollWidth;
      document.documentElement.style.setProperty(kS, `${n}px`);
    }
    return () => e.disconnect();
  }, []), {
    tabListReference: t
  };
}, TS = ge(
  ({ children: t, ...e }, n) => {
    const { tabListReference: r } = x5(), o = dc(r, n);
    return /* @__PURE__ */ g.createElement(ac.List, { ref: o, ...e }, t);
  }
);
TS.displayName = "TabsList";
const Lm = (t, e) => {
  switch (t) {
    case "l":
      return e[0];
    case "m":
      return e[1];
    default:
      return e[0];
  }
}, E5 = O((t, { elementSize: e, withScrollableTabs: n }) => ({
  root: {},
  list: {
    "--tabs-list-border-size": m(0.5),
    "--tab-border-color": t.other.colors.greyIron[4],
    display: "flex",
    ...n ? {
      overflowX: "auto",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none"
      },
      flexWrap: "nowrap",
      "&::before": {
        width: v5
      }
    } : {}
  },
  tab: {
    padding: 0,
    marginRight: m(16),
    color: t.other.colors.greyIron[13],
    font: Lm(e, [t.other.fonts.desktop.s.m.header, t.other.fonts.desktop.s.s.header]),
    height: m(Lm(e, [46, 42])),
    borderBottom: `${m(1)} solid ${t.other.colors.greyIron[4]}`,
    "&:last-of-type": {
      marginRight: 0
    },
    "&:hover": {
      color: t.other.colors.brand[13],
      borderColor: t.other.colors.greyIron[4],
      backgroundColor: "unset"
    },
    "&:active": {
      color: t.other.colors.brand[16]
    },
    "&:focus-visible": {
      outline: "none",
      [`> .${Cy}`]: {
        borderColor: t.other.colors.brand[3]
      }
    },
    "&:disabled": {
      color: t.other.colors.greyIron[9]
    },
    "&[data-active]": {
      color: t.other.colors.brand[13],
      borderBottom: `${m(2)} solid ${t.other.colors.brand[13]}`,
      "&:hover, &:focus-visible": {
        color: t.other.colors.brand[16],
        borderColor: t.other.colors.brand[16]
      },
      "&:active": {
        color: t.other.colors.brand[20],
        borderColor: t.other.colors.brand[16]
      }
    }
  },
  tabSection: {
    "&:not(:only-child)": {
      marginLeft: m(2),
      marginTop: m(-14)
    }
  },
  tabLabel: {
    alignSelf: "flex-start",
    border: `${m(4)} solid transparent`,
    borderRadius: m(8)
  },
  tabIcon: {},
  panel: {
    font: t.other.fonts.desktop.s.s.default,
    color: t.other.colors.greyIron[16]
  }
})), k5 = {
  elementSize: "l",
  withScrollableTabs: !1
}, Bc = ge((t, e) => {
  const { onChange: n, children: r, classNames: o, defaultValue: i, elementSize: s, value: l, withScrollableTabs: a, ...c } = he("Tabs", k5, t), [d, u] = ie(i || null), { classes: f } = E5({ elementSize: s, withScrollableTabs: a }), h = (p) => {
    u(p), n == null || n(p);
  };
  return /* @__PURE__ */ g.createElement(
    ac,
    {
      defaultValue: d,
      value: l || d,
      classNames: { ...f, ...o },
      "data-testid": "tabs",
      ...c,
      onChange: h,
      ref: e
    },
    r
  );
});
Bc.displayName = "Tabs";
Bc.Tab = ac.Tab;
Bc.List = TS;
Bc.Panel = ac.Panel;
const T5 = O((t) => ({
  root: {
    lineHeight: 1,
    display: "flex",
    flexDirection: "column",
    gap: m(6)
  },
  wrapper: {
    marginBottom: 0
  },
  input: {
    width: "100%",
    borderRadius: t.other.borderRadius[8],
    borderColor: t.other.colors.greyIron[7],
    font: t.other.fonts.desktop.s.s.default,
    color: t.other.colors.greyIron[18],
    padding: `${m(10)} ${m(12)}`,
    backgroundColor: t.other.colors.white[0],
    transition: Ae(["background-color", "border-color", "color"]),
    "&::placeholder": {
      color: t.other.colors.greyIron[10]
    },
    "&::selection": {
      backgroundColor: t.other.colors.brand[3]
    },
    "&:hover:not(&:disabled)": {
      borderColor: t.other.colors.brand[10]
    },
    "&:focus, &:focus-within": {
      borderColor: t.other.colors.brand[13],
      backgroundColor: t.other.colors.white[0]
    },
    "&:disabled": {
      borderColor: "transparent",
      backgroundColor: t.other.colors.greyIron[2],
      color: t.other.colors.greyIron[12],
      pointerEvents: "none",
      "::placeholder": {
        color: t.other.colors.greyIron[9]
      }
    },
    "&:-internal-autofill-selected": {
      borderColor: t.other.colors.brand[13],
      boxShadow: `0 0 0 ${m(40)} ${t.other.colors.brand[0]} inset`
    },
    "&:read-only": {
      color: t.other.colors.greyIron[15]
    },
    '&[data-error="true"]': {
      borderColor: t.other.colors.raspberry[12],
      backgroundColor: t.other.colors.white[0],
      color: t.other.colors.greyIron[18],
      "&::placeholder": {
        color: t.other.colors.raspberry[12]
      },
      "&:hover:not(&:disabled)": {
        borderColor: t.other.colors.raspberry[12],
        backgroundColor: t.other.colors.raspberry[0]
      },
      "&:hover:not(&:placeholder-shown)": {
        backgroundColor: t.other.colors.white[0]
      },
      "&:active:not(&:disabled)": {
        backgroundColor: t.other.colors.white[0]
      },
      "&:focus": {
        borderColor: t.other.colors.raspberry[12]
      },
      "&:-internal-autofill-selected": {
        borderColor: t.other.colors.raspberry[12],
        backgroundColor: t.other.colors.white[0],
        color: t.other.colors.greyIron[18]
      }
    }
  },
  inputContainer: {
    position: "relative"
  },
  required: {
    color: t.other.colors.brand[13]
  },
  labelWrapper: {
    display: "inline-flex",
    alignItems: "center"
  },
  labelWrapperWithIcon: {
    [`& + .${Ps}`]: {
      marginLeft: m(-2)
    }
  },
  label: {
    font: t.other.fonts.desktop.s.s.label,
    color: t.other.colors.greyIron[15]
  },
  labelDisabled: {
    color: t.other.colors.greyIron[9]
  },
  labelIcon: {
    marginLeft: t.other.spacings[4],
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    svg: {
      width: m(16),
      height: m(16)
    }
  },
  description: {
    marginTop: m(-2),
    font: t.other.fonts.desktop.s.s.default,
    color: t.other.colors.greyIron[10]
  },
  section: {
    marginLeft: m(3),
    svg: {
      width: m(16),
      height: m(16),
      color: t.other.colors.greyIron[10]
    }
  },
  iconDisabled: {
    svg: {
      stroke: t.other.colors.greyIron[9]
    }
  },
  svgIcon: {
    svg: {
      width: m(16),
      height: m(16),
      color: t.other.colors.greyIron[10]
    }
  },
  error: {
    marginTop: m(-2),
    font: t.other.fonts.desktop.s.s.default,
    color: t.other.colors.raspberry[12]
  },
  toggle: {
    position: "absolute",
    top: m(-36),
    right: 0
  }
})), I5 = ge((t, e) => {
  const { classNames: n, label: r, labelIcon: o, disabled: i, error: s, labelIconTooltipText: l, className: a, tooltipProps: c, ...d } = he(
    "Textarea",
    {},
    t
  ), { classes: u, cx: f } = T5();
  return /* @__PURE__ */ g.createElement(
    nC,
    {
      ref: e,
      classNames: {
        ...u,
        root: f(u.root, n == null ? void 0 : n.root),
        wrapper: f(u.wrapper, n == null ? void 0 : n.wrapper),
        input: f(u.input, n == null ? void 0 : n.input),
        required: f(u.required, n == null ? void 0 : n.required),
        section: f(u.section, n == null ? void 0 : n.section),
        label: f(u.label, n == null ? void 0 : n.label, { [u.labelDisabled]: i }),
        description: f(u.description, n == null ? void 0 : n.description, { [u.labelDisabled]: i })
      },
      className: a,
      disabled: i,
      label: (r || o) && /* @__PURE__ */ g.createElement("div", { className: f(u.labelWrapper, { [u.labelWrapperWithIcon]: o }) }, r && /* @__PURE__ */ g.createElement("span", null, r), (o || l) && /* @__PURE__ */ g.createElement(at, { label: l, style: { maxWidth: m(200) }, multiline: !0, ...c }, /* @__PURE__ */ g.createElement("span", { className: f(u.svgIcon, u.labelIcon, { [u.iconDisabled]: i }) }, o || /* @__PURE__ */ g.createElement(Nr, null)))),
      inputWrapperOrder: ["label", "input", "description", "error"],
      error: s,
      ...d
    }
  );
});
I5.displayName = "Textarea";
const M5 = O((t, { width: e }) => ({
  text: {
    width: m(e) || "auto",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }
})), R5 = ({ children: t, width: e, tooltip: n, textProps: r, boxProps: o, ...i }) => {
  const { classes: s } = M5({ width: e });
  return /* @__PURE__ */ g.createElement(oe, { className: s.text, ...o }, /* @__PURE__ */ g.createElement(at, { label: n, ...i }, /* @__PURE__ */ g.createElement(xe, { inherit: !0, truncate: "end", ...r }, t)));
};
R5.displayName = "TextSingleLine";
const O5 = O((t) => ({
  root: {
    padding: "0.75rem",
    width: "100%",
    backgroundColor: t.other.colors.white,
    border: `1px solid ${t.other.colors.greyIron[4]}`,
    borderRadius: "0.5rem",
    "&:hover": {
      borderColor: t.other.colors.brand[13]
    }
  },
  textWrapper: {
    maxWidth: "15.2rem",
    width: "15.2rem"
  },
  title: {
    color: t.other.colors.greyIron[20]
  },
  subtitle: {
    color: t.other.colors.greyIron[15]
  },
  icon: {
    color: t.other.colors.greyIron[20],
    width: 18,
    height: 18
  },
  error: {
    borderColor: t.other.colors.raspberry[13],
    color: t.other.colors.raspberry[13],
    "&:hover": {
      borderColor: t.other.colors.raspberry[13]
    }
  },
  disabled: {
    backgroundColor: t.other.colors.greyIron[2],
    color: t.other.colors.greyIron[10],
    borderColor: t.other.colors.greyIron[4],
    cursor: "not-allowed",
    "&:hover": {
      borderColor: t.other.colors.greyIron[4]
    }
  },
  progressRoot: {
    backgroundColor: t.other.colors.greyIron[2]
  },
  progressBar: {
    backgroundColor: t.other.colors.brand[5]
  }
})), D5 = {
  loadingProgressValue: 0,
  errors: []
}, vz = (t) => {
  const { className: e, classNames: n, file: r, errors: o, disabled: i, loadingProgressValue: s, resetLoading: l, onDelete: a, onRefresh: c, src: d, name: u, ...f } = he(
    "UploadCard",
    D5,
    t
  ), { classes: h, cx: p } = O5(), y = (r == null ? void 0 : r.type.includes("image/")) || !!d, b = r instanceof Blob, w = y && b ? URL.createObjectURL(r) : d, S = b ? `${Cb(r)}Mb` : "", x = s && s > 0 && s < 100, E = au(o) ? "idle" : "error", v = x ? "loading" : E, [T] = o || [], I = (T == null ? void 0 : T.type) === "file" ? "file" : "upload";
  return /* @__PURE__ */ g.createElement(
    Gm,
    {
      className: p(h.root, n == null ? void 0 : n.root, { [h.error]: v === "error", [h.disabled]: i }, e),
      classNames: n,
      "data-testid": "upload-card-container",
      ...f
    },
    /* @__PURE__ */ g.createElement(Ee, { gap: 8 }, /* @__PURE__ */ g.createElement(X, { align: "flex-start", justify: "space-between", gap: 8, wrap: "nowrap" }, /* @__PURE__ */ g.createElement(X, { align: "flex-start", gap: 8 }, y && /* @__PURE__ */ g.createElement(jD, { elementVariant: "default", src: w, imageProps: { onLoad: () => URL.revokeObjectURL(w || "") } }), !y && v !== "error" && /* @__PURE__ */ g.createElement(YC, { className: p(h.icon, { [h.disabled]: i }) }), !y && v === "error" && I === "upload" && /* @__PURE__ */ g.createElement(ZC, { className: p(h.icon, { [h.disabled]: i }) }), !y && v === "error" && I === "file" && /* @__PURE__ */ g.createElement(XC, { className: p(h.icon, { [h.disabled]: i }) }), /* @__PURE__ */ g.createElement(Ee, { gap: 0, className: h.textWrapper, justify: "flex-start", align: "flex-start" }, /* @__PURE__ */ g.createElement(xe, { elementSize: "s", elementVariant: "buttons", className: p(h.title, { [h.disabled]: i }) }, u), /* @__PURE__ */ g.createElement(
      xe,
      {
        elementSize: "xs",
        elementVariant: "default",
        className: p(h.subtitle, { [h.error]: v === "error", [h.disabled]: i })
      },
      (T == null ? void 0 : T.message) || S
    ))), /* @__PURE__ */ g.createElement(X, { gap: 8 }, v === "loading" && /* @__PURE__ */ g.createElement(
      ye,
      {
        elementVariant: Q.PrimaryMainLine,
        elementSize: Ue.XS,
        isIconOnly: !0,
        disabled: i,
        leftSection: /* @__PURE__ */ g.createElement(cc, null),
        onClick: l
      }
    ), v !== "loading" && /* @__PURE__ */ g.createElement(
      ye,
      {
        elementVariant: Q.PrimaryMainLine,
        elementSize: Ue.XS,
        isIconOnly: !0,
        disabled: i,
        leftSection: /* @__PURE__ */ g.createElement(QC, null),
        onClick: a
      }
    ), v === "error" && T.type === "upload" && /* @__PURE__ */ g.createElement(
      ye,
      {
        elementVariant: Q.PrimaryMainLine,
        elementSize: Ue.XS,
        isIconOnly: !0,
        disabled: i,
        leftSection: /* @__PURE__ */ g.createElement(ev, null),
        onClick: c
      }
    ))), v === "loading" && s && !i && /* @__PURE__ */ g.createElement(rC, { value: s, classNames: { root: h.progressRoot, section: h.progressBar } }))
  );
}, $m = 0, A5 = Number.POSITIVE_INFINITY, L5 = Number.POSITIVE_INFINITY, $5 = Number.POSITIVE_INFINITY, xz = ({
  fileMaxSize: t = $5,
  imageMaxWidth: e = A5,
  imageMaxHeight: n = L5,
  imageSizeErrorMessage: r = `Image is too big, max width: ${e}, max height: ${n}`,
  fileSizeErrorMessage: o = `File is too big, max size: ${t}Mb`,
  uploadErrorMessage: i = "Upload error"
}) => {
  const [s, l] = ie([]), [a, c] = ie($m);
  return {
    errors: s,
    resetErrors: () => l([]),
    progress: a,
    handleProgress: (y) => {
      const b = Math.round(y.loaded / y.total * 100);
      c(b);
    },
    handleLoad: () => {
      c($m);
    },
    handleUploadError: () => {
      l([...s, { type: "upload", message: i }]);
    },
    checkFileAndImageSizes: async (y) => {
      if ((t ? Cb(y) > t : !1) && l([{ type: "file", message: o }, ...s]), !y.type.includes("image"))
        return;
      const w = await xD(y);
      (w.width > e || w.height > n) && l([{ type: "file", message: r }, ...s]);
    }
  };
}, kh = qo(null);
kh.displayName = "@mantine/modals/ModalsContext";
function P5() {
  const t = Pi(kh);
  if (!t)
    throw new Error(
      "[@mantine/modals] useModals hook was called outside of context, wrap your app with ModalsProvider component"
    );
  return t;
}
function _5({
  id: t,
  cancelProps: e,
  confirmProps: n,
  labels: r = { cancel: "", confirm: "" },
  closeOnConfirm: o = !0,
  closeOnCancel: i = !0,
  groupProps: s,
  onCancel: l,
  onConfirm: a,
  children: c
}) {
  const { cancel: d, confirm: u } = r, f = P5(), h = (y) => {
    typeof (e == null ? void 0 : e.onClick) == "function" && (e == null || e.onClick(y)), typeof l == "function" && l(), i && f.closeModal(t);
  }, p = (y) => {
    typeof (n == null ? void 0 : n.onClick) == "function" && (n == null || n.onClick(y)), typeof a == "function" && a(), o && f.closeModal(t);
  };
  return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
    c && /* @__PURE__ */ C.jsx(oe, { mb: "md", children: c }),
    /* @__PURE__ */ C.jsxs(X, { mt: c ? 0 : "md", justify: "flex-end", ...s, children: [
      /* @__PURE__ */ C.jsx(ra, { variant: "default", ...e, onClick: h, children: (e == null ? void 0 : e.children) || d }),
      /* @__PURE__ */ C.jsx(ra, { ...n, onClick: p, children: (n == null ? void 0 : n.children) || u })
    ] })
  ] });
}
const [B5, dl] = oC("mantine-modals"), Ez = (t) => {
  const e = t.modalId || mi();
  return dl("openModal")({ ...t, modalId: e }), e;
}, kz = (t) => {
  const e = t.modalId || mi();
  return dl("openConfirmModal")({ ...t, modalId: e }), e;
}, Tz = (t) => {
  const e = t.modalId || mi();
  return dl("openContextModal")({ ...t, modalId: e }), e;
}, Iz = dl("closeModal"), Mz = dl("closeAllModals");
function Pm(t, e) {
  var n, r, o, i;
  e && t.type === "confirm" && ((r = (n = t.props).onCancel) == null || r.call(n)), (i = (o = t.props).onClose) == null || i.call(o);
}
function V5(t, e) {
  var n;
  switch (e.type) {
    case "OPEN":
      return {
        current: e.modal,
        modals: [...t.modals, e.modal]
      };
    case "CLOSE": {
      const r = t.modals.find((i) => i.id === e.modalId);
      if (!r)
        return t;
      Pm(r, e.canceled);
      const o = t.modals.filter((i) => i.id !== e.modalId);
      return {
        current: o[o.length - 1] || t.current,
        modals: o
      };
    }
    case "CLOSE_ALL":
      return t.modals.length ? (t.modals.concat().reverse().forEach((r) => {
        Pm(r, e.canceled);
      }), {
        current: t.current,
        modals: []
      }) : t;
    case "UPDATE": {
      const { modalId: r, newProps: o } = e, i = t.modals.map((l) => l.id !== r ? l : l.type === "content" || l.type === "confirm" ? {
        ...l,
        props: {
          ...l.props,
          ...o
        }
      } : l.type === "context" ? {
        ...l,
        props: {
          ...l.props,
          ...o,
          innerProps: {
            ...l.props.innerProps,
            ...o.innerProps
          }
        }
      } : l), s = ((n = t.current) == null ? void 0 : n.id) === r && i.find((l) => l.id === r) || t.current;
      return {
        ...t,
        modals: i,
        current: s
      };
    }
    default:
      return t;
  }
}
function F5(t) {
  if (!t)
    return { confirmProps: {}, modalProps: {} };
  const {
    id: e,
    children: n,
    onCancel: r,
    onConfirm: o,
    closeOnConfirm: i,
    closeOnCancel: s,
    cancelProps: l,
    confirmProps: a,
    groupProps: c,
    labels: d,
    ...u
  } = t;
  return {
    confirmProps: {
      id: e,
      children: n,
      onCancel: r,
      onConfirm: o,
      closeOnConfirm: i,
      closeOnCancel: s,
      cancelProps: l,
      confirmProps: a,
      groupProps: c,
      labels: d
    },
    modalProps: {
      id: e,
      ...u
    }
  };
}
function Rz({ children: t, modalProps: e, labels: n, modals: r }) {
  const [o, i] = OS(V5, { modals: [], current: null }), s = Nt(o);
  s.current = o;
  const l = te(
    (S) => {
      i({ type: "CLOSE_ALL", canceled: S });
    },
    [s, i]
  ), a = te(
    ({ modalId: S, ...x }) => {
      const E = S || mi();
      return i({
        type: "OPEN",
        modal: {
          id: E,
          type: "content",
          props: x
        }
      }), E;
    },
    [i]
  ), c = te(
    ({ modalId: S, ...x }) => {
      const E = S || mi();
      return i({
        type: "OPEN",
        modal: {
          id: E,
          type: "confirm",
          props: x
        }
      }), E;
    },
    [i]
  ), d = te(
    (S, { modalId: x, ...E }) => {
      const v = x || mi();
      return i({
        type: "OPEN",
        modal: {
          id: v,
          type: "context",
          props: E,
          ctx: S
        }
      }), v;
    },
    [i]
  ), u = te(
    (S, x) => {
      i({ type: "CLOSE", modalId: S, canceled: x });
    },
    [s, i]
  ), f = te(
    ({ modalId: S, ...x }) => {
      i({
        type: "UPDATE",
        modalId: S,
        newProps: x
      });
    },
    [i]
  ), h = te(
    ({ modalId: S, ...x }) => {
      i({ type: "UPDATE", modalId: S, newProps: x });
    },
    [i]
  );
  B5({
    openModal: a,
    openConfirmModal: c,
    openContextModal: ({ modal: S, ...x }) => d(S, x),
    closeModal: u,
    closeContextModal: u,
    closeAllModals: l,
    updateModal: f,
    updateContextModal: h
  });
  const p = {
    modalProps: e || {},
    modals: o.modals,
    openModal: a,
    openConfirmModal: c,
    openContextModal: d,
    closeModal: u,
    closeContextModal: u,
    closeAll: l,
    updateModal: f,
    updateContextModal: h
  }, y = () => {
    const S = s.current.current;
    switch (S == null ? void 0 : S.type) {
      case "context": {
        const { innerProps: x, ...E } = S.props, v = r[S.ctx];
        return {
          modalProps: E,
          content: /* @__PURE__ */ C.jsx(v, { innerProps: x, context: p, id: S.id })
        };
      }
      case "confirm": {
        const { modalProps: x, confirmProps: E } = F5(S.props);
        return {
          modalProps: x,
          content: /* @__PURE__ */ C.jsx(
            _5,
            {
              ...E,
              id: S.id,
              labels: S.props.labels || n
            }
          )
        };
      }
      case "content": {
        const { children: x, ...E } = S.props;
        return {
          modalProps: E,
          content: x
        };
      }
      default:
        return {
          modalProps: {},
          content: null
        };
    }
  }, { modalProps: b, content: w } = y();
  return /* @__PURE__ */ C.jsxs(kh.Provider, { value: p, children: [
    /* @__PURE__ */ C.jsx(
      ef,
      {
        zIndex: Rn("modal") + 1,
        ...e,
        ...b,
        opened: o.modals.length > 0,
        onClose: () => {
          var S;
          return u((S = o.current) == null ? void 0 : S.id);
        },
        children: w
      }
    ),
    t
  ] });
}
export {
  Qv as Accordion,
  Az as AppShell,
  Jo as Avatar,
  Lz as BackgroundImage,
  Ty as Badge,
  $z as Box,
  Pz as Burger,
  ye as Button,
  Ue as ButtonSizeEnum,
  Q as ButtonVariantEnum,
  Sx as Card,
  _z as Center,
  la as Checkbox,
  Lo as CircleWithIcon,
  Ix as CodeBlock,
  fz as CodeInput,
  Bz as Collapse,
  G0 as ColorSchemeProvider,
  ez as Condition,
  Vz as Container,
  Lx as Copy,
  Fz as CopyButton,
  Px as Counter,
  tz as Country,
  nz as CropPreview,
  PD as DESKTOP_COLUMNS,
  q2 as DESKTOP_HEADER_HEIGHT,
  bT as DatePicker,
  IT as DateRangePicker,
  il as Divider,
  OT as Drawer,
  ln as DropDownSizeEnum,
  Zt as Dropdown,
  az as Dropzone,
  cz as ErrorBlock,
  _e as FastRangePanelEnum,
  BT as Favourite,
  dz as FilterButtons,
  AD as FiltersPanel,
  uz as FixedLayout,
  Nz as Flex,
  Rf as Grid,
  zz as Group,
  Hz as HoverCard,
  Pt as Image,
  rz as ImageCrop,
  jD as ImagePreview,
  jz as ImageV2,
  Sz as Info,
  Wz as Input,
  ki as Link,
  k2 as LinkText,
  Lb as List,
  sf as Loader,
  O2 as LoaderApp,
  A2 as LoaderProgress,
  VD as MAXIMUM_GRID_CONTAINER_WIDTH,
  Pb as MOBILE_HEADER_HEIGHT,
  gz as MainLayout,
  Gz as Menu,
  Df as Modal,
  Rz as ModalsProvider,
  aA as Money,
  Fb as MultiSelect,
  Mi as NavLink,
  U2 as NavMenu,
  sz as NotificationsProvider,
  YD as NumberInput,
  Uz as Overlay,
  BA as PageHeading,
  Nb as Pagination,
  qz as Paper,
  XD as PasswordInput,
  hz as PhoneNumber,
  Jz as Popover,
  YA as ProgressBar,
  sl as ProgressSteps,
  Af as Radio,
  VN as RichEditor,
  Kz as ScrollArea,
  bz as Sector,
  Ob as Select,
  Yz as SimpleGrid,
  wz as SimpleTable,
  bS as Skeleton,
  Zz as Space,
  F6 as Spoiler,
  Xz as Stack,
  W6 as Stats,
  Cz as StepHeader,
  xx as SuccessIcon,
  C5 as Table,
  Bc as Tabs,
  xe as Text,
  Ab as TextInput,
  R5 as TextSingleLine,
  I5 as Textarea,
  lz as ThemeProvider,
  Ti as Title,
  Of as Toggle,
  at as Tooltip,
  Qz as Transition,
  eH as UnstyledButton,
  vz as UploadCard,
  Ex as WarningIcon,
  Ae as addTransitionForCssProperties,
  Mz as closeAllModals,
  Iz as closeModal,
  w6 as createColumnHelper,
  yH as createFormContext,
  tH as createSafeContext,
  uH as createStyles,
  _D as defaultGutter,
  BD as defaultHorizontalMargins,
  hi as defaultTheme,
  nH as em,
  N2 as getContactAvatar,
  rH as getDefaultZIndex,
  CT as getFastPanelRangeValues,
  oH as getSortedBreakpoints,
  bH as hasLength,
  wH as isEmail,
  SH as isInRange,
  CH as isNotEmpty,
  vH as joiResolver,
  yo as mapColorNameAndIndexToValue,
  xH as matches,
  Ge as mediaHelper,
  Q5 as mutateMediaHelperBreakpoints,
  mz as notificationsManagers,
  kz as openConfirmModal,
  Tz as openContextModal,
  Ez as openModal,
  iH as px,
  X5 as referenceConstants,
  sH as rem,
  lH as rgba,
  EH as superstructResolver,
  iz as useColorScheme,
  kH as useForm,
  hH as useIntersection,
  pH as useInterval,
  pz as useMainLayoutState,
  aH as useMantineTheme,
  gH as useMediaQuery,
  P5 as useModals,
  cH as useProps,
  x5 as useScrollableTabs,
  Ox as useTooltipState,
  xz as useUploader,
  TH as yupResolver,
  IH as zodResolver
};
//# sourceMappingURL=affstore-ds-ui-kit.js.map
